webpackJsonp([1],{

/***/ "+8rZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+igM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzIxNjhGMzt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTczLjYsMjguN2MtNi4xLTYuMS0xNC41LTkuOS0yMy44LTkuOVMzMi4xLDIyLjYsMjYsMjguN3MtOS45LDE0LjUtOS45LDIzLjhjMCwxOC42LDE1LjEsMzMuNywzMy43LDMzLjcKCQljOS4zLDAsMTcuNy0zLjgsMjMuOC05LjljNi4xLTYuMSw5LjktMTQuNSw5LjktMjMuOFM3OS43LDM0LjgsNzMuNiwyOC43eiBNNDMuOCwzNi45YzAtMy4yLDIuNi01LjgsNS44LTUuOGMxLjYsMCwzLjEsMC43LDQuMSwxLjcKCQljMS4xLDEuMSwxLjcsMi41LDEuNyw0LjF2MTYuN2MwLDMuMi0yLjYsNS44LTUuOCw1LjhzLTUuOC0yLjYtNS44LTUuOFYzNi45TDQzLjgsMzYuOXogTTU5LjksNTQuMWMwLDUtMy42LDkuMi04LjMsMTB2NC41aDQuNwoJCWMxLjIsMCwyLjIsMSwyLjIsMi4ycy0xLDIuMi0yLjIsMi4yaC0xM2MtMS4yLDAtMi4yLTEtMi4yLTIuMnMxLTIuMiwyLjItMi4ySDQ4di00LjVjLTQuOC0wLjgtOC41LTUtOC41LTEwLjF2LTUuNAoJCWMwLTAuOCwwLjctMS40LDEuNC0xLjRjMC44LDAsMS40LDAuNywxLjQsMS40VjU0YzAsNCwzLjMsNy4zLDcuMyw3LjNzNy4zLTMuMyw3LjMtNy4zdi01LjRjMC0wLjgsMC43LTEuNCwxLjQtMS40CgkJYzAuOCwwLDEuNCwwLjcsMS40LDEuNEw1OS45LDU0LjFMNTkuOSw1NC4xeiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "/41y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeReloadOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"380px","height":"440px","left":"calc((108vw - 500px)/2)","top":"100px","z-index":"99"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2"},[_c('img',{staticStyle:{"width":"300px","position":"absolute","top":"0","left":"42px"},attrs:{"src":__webpack_require__("pax8")}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('label',{staticClass:"align-center text-grey-darker font-light text-xs mx-8",staticStyle:{"position":"absolute","bottom":"74px","left":"10px","text-align":"center"}},[_c('img',{staticClass:"w-4 h-5",staticStyle:{"position":"relative","bottom":"-4px"},attrs:{"src":__webpack_require__("hoQL")}}),_vm._v(" \n          "+_vm._s(this.getTips())+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-5 justify-start",staticStyle:{"position":"absolute","bottom":"0px","left":"31%","margin-left":"38px"}},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 font-semibold justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeReloadOverlay()}}},[_vm._v("Okay")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row mb-2 justify-between items-center",staticStyle:{"position":"absolute","bottom":"94px","left":"31%"}},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v("You are back online!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Jfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_consultation__ = __webpack_require__("57jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_customer_summary__ = __webpack_require__("FyQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_customer_profile__ = __webpack_require__("h6cF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_customer_document__ = __webpack_require__("eX/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_customer_health_parameters__ = __webpack_require__("O4OI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__ = __webpack_require__("II+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_customer_medication__ = __webpack_require__("kmHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_snackbar_helpers__ = __webpack_require__("tjrC");









// State
var state = {
  initiated: false,
  pastConsults: [],
  activePastConsultId: null,
  activePastConsultationRequestId: null,
  currentPage: 1,
  totalPastConsults: 0

  // Getters
};var getters = {
  isPastChatPresent: function isPastChatPresent() {
    if (state.activePastConsultationRequestId !== null) {
      return true;
    } else {
      return false;
    }
  },
  getActivePastCustomer: function getActivePastCustomer() {
    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    var index = state.pastConsults.indexOf(patient);
    if (index > -1) {
      return state.pastConsults[index];
    } else {
      return {};
    }
  },
  getPastConsults: function getPastConsults() {
    return state.pastConsults;
  },
  showLoadMore: function showLoadMore() {
    if (state.pastConsults.length < state.totalPastConsults) {
      return true;
    } else {
      return false;
    }
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__["a" /* default */].fetchPastConsultationsDetails().then(function (response) {
      if (response.status === 200) {
        dispatch('setUpPastConsults', { details: response.body.past_consults, total: response.body.total });
      }
    });
  },
  setUpPastConsults: function setUpPastConsults(_ref2, _ref3) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    var details = _ref3.details,
        total = _ref3.total;

    commit('setUpPastConsults', { details: details, total: total });
  },
  fetchMoreConsults: function fetchMoreConsults(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var newPage = state.currentPage + 1;
    __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__["a" /* default */].fetchPastConsultationsDetails(newPage).then(function (response) {
      if (response.status === 200) {
        commit('loadMoreConsults', { pastConsults: response.body.past_consults });
      }
    });
  },
  loadMoreConsultsAdmin: function loadMoreConsultsAdmin(_ref5, _ref6) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    var pastConsults = _ref6.pastConsults;

    commit('loadMoreConsults', { pastConsults: pastConsults });
  },
  switchTo: function switchTo(_ref7, _ref8) {
    var state = _ref7.state,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    var id = _ref8.id,
        consultationRequestId = _ref8.consultationRequestId;

    commit('switchTo', { id: id, consultationRequestId: consultationRequestId });
    if (consultationRequestId !== null) {
      dispatch('fetchMessages', { consultationRequestId: consultationRequestId });
      dispatch('fetchCustomerProfile', { consultationRequestId: consultationRequestId });
    }
  },
  fetchCustomerProfile: function fetchCustomerProfile(_ref9, _ref10) {
    var commit = _ref9.commit,
        state = _ref9.state;
    var consultationRequestId = _ref10.consultationRequestId;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === consultationRequestId;
    });
    __WEBPACK_IMPORTED_MODULE_3__api_customer_profile__["a" /* default */].getCustomerDetails(patient.customerId).then(function (response) {
      if (response.status === 200) {
        commit('updateCustomerDetails', { consultationRequestId: patient.consultationRequest.consultationRequestId, customerDetails: response.body.customer });
      }
    });
  },
  fetchMessages: function fetchMessages(_ref11, _ref12) {
    var commit = _ref11.commit;
    var consultationRequestId = _ref12.consultationRequestId;

    __WEBPACK_IMPORTED_MODULE_1__api_consultation__["a" /* default */].getMessages(consultationRequestId).then(function (response) {
      if (response.status === 200) {
        var messages = response.body.messages;
        commit('fetchChat', { consultationRequestId: consultationRequestId, messages: messages });
      }
    });
  },
  addToPastConsultation: function addToPastConsultation(_ref13, _ref14) {
    var commit = _ref13.commit,
        state = _ref13.state;
    var consult = _ref14.consult;

    commit('addToPastConsultation', consult);
  },
  updateSummary: function updateSummary(_ref15, _ref16) {
    var commit = _ref15.commit,
        state = _ref15.state;
    var summary = _ref16.summary;

    __WEBPACK_IMPORTED_MODULE_1__api_consultation__["a" /* default */].updateSummary(summary).then(function (response) {
      if (response.status === 200) {}
    });
  },
  reviewSummary: function reviewSummary(_ref17) {
    var commit = _ref17.commit,
        state = _ref17.state;
  },
  updateConsultation: function updateConsultation(_ref18, data) {
    var commit = _ref18.commit,
        state = _ref18.state,
        dispatch = _ref18.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    __WEBPACK_IMPORTED_MODULE_2__api_customer_summary__["a" /* default */].saveSummaryDetails(data, patient.consultation.consultationId).then(function (response) {
      if (response.status === 200) {
        commit('updateConsultation', { consultation: response.body.consultation });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  sendSummary: function sendSummary(_ref19, data) {
    var commit = _ref19.commit,
        state = _ref19.state,
        dispatch = _ref19.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    var summaryNotes = patient.consultation.summaryNotes;
    if (!summaryNotes) {
      dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Please add summary' }, { root: true });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__api_customer_summary__["a" /* default */].sendSummary(patient.consultation.consultationId, data.componentKey).then(function (response) {
        if (response.status === 200) {
          commit('updateConsultation', { consultation: response.body.consultation });
          dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    }
  },
  updateCurrentMedication: function updateCurrentMedication(_ref20, medications) {
    var commit = _ref20.commit,
        state = _ref20.state,
        dispatch = _ref20.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    __WEBPACK_IMPORTED_MODULE_7__api_customer_medication__["a" /* default */].update(patient.customerId, medications).then(function (resp) {
      if (resp.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('updateCurrentMedication', { activePastConsultationRequestId: state.activePastConsultationRequestId, medications: resp.body.medications });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  summaryNotNeeded: function summaryNotNeeded(_ref21, data) {
    var commit = _ref21.commit,
        state = _ref21.state,
        dispatch = _ref21.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    __WEBPACK_IMPORTED_MODULE_2__api_customer_summary__["a" /* default */].summaryNotNeeded(patient.consultation.consultationId, data.componentKey).then(function (response) {
      if (response.status === 200) {
        commit('updateConsultation', { consultation: response.body.consultation });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  uploadDocuments: function uploadDocuments(_ref22, formData) {
    var commit = _ref22.commit,
        state = _ref22.state,
        dispatch = _ref22.dispatch;

    __WEBPACK_IMPORTED_MODULE_4__api_customer_document__["a" /* default */].uploadDocuments(formData).then(function (response) {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', { consultationRequestId: state.activePastConsultationRequestId, data: response.body });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', { consultationRequestId: state.activePastConsultationRequestId, data: response.body.prescriptions })
        // }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateHealthParameters: function updateHealthParameters(_ref23, data) {
    var commit = _ref23.commit,
        state = _ref23.state,
        dispatch = _ref23.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    __WEBPACK_IMPORTED_MODULE_5__api_customer_health_parameters__["a" /* default */].updateHealthParameters(data, patient.customerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { consultationRequestId: patient.consultationRequest.consultationRequestId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateGeneralParameters: function updateGeneralParameters(_ref24, data) {
    var commit = _ref24.commit,
        state = _ref24.state,
        dispatch = _ref24.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });

    __WEBPACK_IMPORTED_MODULE_5__api_customer_health_parameters__["a" /* default */].updateGeneralParameters({ gender: data.gender, date_of_birth: data.date_of_birth }, patient.customerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.body).length > 0) {
          commit('updateCustomerDetails', { consultationRequestId: patient.consultationRequest.consultationRequestId, customerDetails: { gender: response.body.gender, date_of_birth: response.body.date_of_birth } });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
    __WEBPACK_IMPORTED_MODULE_5__api_customer_health_parameters__["a" /* default */].updateHealthParameters({ blood_group: data.blood_group }, patient.customerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { consultationRequestId: patient.consultationRequest.consultationRequestId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  setFollowUp: function setFollowUp(_ref25, followUps) {
    var commit = _ref25.commit,
        state = _ref25.state,
        dispatch = _ref25.dispatch;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    __WEBPACK_IMPORTED_MODULE_1__api_consultation__["a" /* default */].createFollowUp({ consultation_id: patient.consultation.consultationId, consultation_followup_reminders: followUps }).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('setFollowUp', { followUps: response.body.followup_reminders });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  reset: function reset(_ref26) {
    var commit = _ref26.commit;

    commit('reset');
  }
};

// Mutations
var mutations = {
  setUpPastConsults: function setUpPastConsults(state, _ref27) {
    var details = _ref27.details,
        total = _ref27.total;

    state.pastConsults = [];
    state.activePastConsultId = null;
    state.totalPastConsults = total;
    for (var i = 0; i < details.length; i++) {
      var pc = {
        channelId: details[i].channel_id,
        customerId: details[i].customer_id,
        name: details[i].customer_name,
        isFamilyDoctor: details[i].is_family_doctor,
        familyDoctor: { id: details[i].family_doctor.id, name: details[i].family_doctor.name },
        consultationRequest: {
          consultationRequestId: details[i].consultation_request.consultation_request_id,
          chiefComplaint: details[i].consultation_request.chief_complaint,
          duration: details[i].consultation_request.duration,
          date: details[i].consultation_request.date
        },
        consultation: {
          chiefComplaint: details[i].consultation.chief_complaint,
          consultationId: details[i].consultation.consultation_id,
          provisionalDiagnosis: details[i].consultation.provisional_diagnois,
          summaryNotes: details[i].consultation.summary,
          date: details[i].consultation.date,
          summary_status: details[i].consultation.summary_status,
          prescribedDrugs: details[i].consultation.prescribed_drugs,
          followupReminders: details[i].consultation.followup_reminders,
          recommendedTests: details[i].consultation.recommended_tests
        },
        details: {},
        messages: []
      };
      state.pastConsults.push(pc);
    }
    state.initiated = true;
  },
  switchTo: function switchTo(state, _ref28) {
    var id = _ref28.id,
        consultationRequestId = _ref28.consultationRequestId;

    state.activePastConsultId = id;
    state.activePastConsultationRequestId = consultationRequestId;
  },
  fetchChat: function fetchChat(state, _ref29) {
    var consultationRequestId = _ref29.consultationRequestId,
        messages = _ref29.messages;

    var consult = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === consultationRequestId;
    });
    var index = state.pastConsults.indexOf(consult);
    if (index > -1) {
      var timeInMilliSeconds = new Date().getTime();
      if (messages.length > 0) {
        timeInMilliSeconds = messages[0].uniqueId;
      }
      var chiefComp = consult.consultationRequest.chiefComplaint;
      var duration = consult.consultationRequest.duration;
      if (!chiefComp) {
        chiefComp = 'Patient did not answer this.';
      }
      if (!duration) {
        duration = 'Patient did not answer this.';
      }
      var topMsgs = [{ payload: { text: 'please let us know your health issue' }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'doctor' } }, { payload: { text: chiefComp }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'customer' }
        // { payload: { text: 'How long have you been having this issue?' }, status: 'read', uniqueId: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'doctor' } },
        // { payload: { text: duration }, status: 'read', uniqueId: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'customer' } }
      }];
      var msgs = topMsgs.concat(messages);
      state.pastConsults[index].messages = msgs;
    }
  },
  updateCustomerDetails: function updateCustomerDetails(state, _ref30) {
    var consultationRequestId = _ref30.consultationRequestId,
        customerDetails = _ref30.customerDetails;

    var consult = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === consultationRequestId;
    });
    var index = state.pastConsults.indexOf(consult);
    if (index > -1) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customerDetails).length === 2) {
        state.pastConsults[index].details.date_of_birth = customerDetails.date_of_birth;
        state.pastConsults[index].details.gender = customerDetails.gender;
      } else {
        state.pastConsults[index].details = customerDetails;
      }
    }
  },
  updateCurrentMedication: function updateCurrentMedication(state, _ref31) {
    var activePastConsultationRequestId = _ref31.activePastConsultationRequestId,
        medications = _ref31.medications;

    var consult = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    var index = state.pastConsults.indexOf(consult);
    if (index > -1) {
      state.pastConsults[index].details.medications = medications;
    }
  },
  addToPastConsultation: function addToPastConsultation(state, consult) {
    var pc = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === consult.consultationRequest.consultationRequestId;
    });
    var index = state.pastConsults.indexOf(pc);
    if (index < 0) {
      var latestPc = {
        channelId: consult.channelId,
        customerId: consult.customerId,
        name: consult.name,
        isFamilyDoctor: consult.isFamilyDoctor,
        consultationRequest: consult.consultationRequest,
        consultation: consult.consultation,
        messages: consult.messages
      };
      if (!consult.isFamilyDoctor && consult.familyDoctor) {
        latestPc.familyDoctor = { id: consult.familyDoctor.id, name: consult.familyDoctor.name };
      }
      state.pastConsults.unshift(latestPc);
      state.totalPastConsults++;
    }
  },
  updateConsultation: function updateConsultation(state, _ref32) {
    var consultation = _ref32.consultation;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    var index = state.pastConsults.indexOf(patient);
    if (index > -1) {
      state.pastConsults[index].consultation.chiefComplaint = consultation.chief_compliant;
      state.pastConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois;
      state.pastConsults[index].consultation.summaryNotes = consultation.summary_notes;
      state.pastConsults[index].consultation.summary_status = consultation.summary_status;
    }
  },
  updateDocuments: function updateDocuments(state, _ref33) {
    var consultationRequestId = _ref33.consultationRequestId,
        data = _ref33.data;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === consultationRequestId;
    });
    var index = state.pastConsults.indexOf(patient);
    if (index > -1) {
      state.pastConsults[index].details.documents.push(data);
    }
  },


  // updatePrescriptions (state, { consultationRequestId, data }) {
  //   let patient = state.pastConsults.find(function (ele) {
  //     return (ele.consultationRequest.consultationRequestId === consultationRequestId)
  //   })
  //   let index = state.pastConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.pastConsults[index].details.prescriptions = state.pastConsults[index].details.prescriptions.concat(data)
  //   }
  // },

  updateHealthParameter: function updateHealthParameter(state, _ref34) {
    var consultationRequestId = _ref34.consultationRequestId,
        healthParameters = _ref34.healthParameters;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === consultationRequestId;
    });
    var index = state.pastConsults.indexOf(patient);
    if (index > -1) {
      healthParameters.map(function (param) {
        state.pastConsults[index].details.health_parameters[param.question_tag] = param.result;
        if (param.question_tag === 'height') {
          var answer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__components_common_snackbar_helpers__["b" /* convertHeightToFeetInches */])(param.result);
          state.pastConsults[index].details.health_parameters['feet'] = answer[0];
          state.pastConsults[index].details.health_parameters['inches'] = answer[1];
        }
      });
    }
  },
  setFollowUp: function setFollowUp(state, _ref35) {
    var followUps = _ref35.followUps;

    var patient = state.pastConsults.find(function (ele) {
      return ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId;
    });
    if (patient) {
      var i = state.pastConsults.indexOf(patient);
      state.pastConsults[i].consultation.followupReminders = followUps;
    }
  },
  reset: function reset(state) {
    state.pastConsults = [];
    state.activePastConsultId = null;
    state.activePastConsultationRequestId = null;
  },
  loadMoreConsults: function loadMoreConsults(state, _ref36) {
    var pastConsults = _ref36.pastConsults;

    if (pastConsults.length > 0) {
      state.currentPage += 1;
    }
    for (var i = 0; i < pastConsults.length; i++) {
      var pc = {
        channelId: pastConsults[i].channel_id,
        customerId: pastConsults[i].customer_id,
        name: pastConsults[i].customer_name,
        isFamilyDoctor: pastConsults[i].is_family_doctor,
        familyDoctor: { id: pastConsults[i].family_doctor.id, name: pastConsults[i].family_doctor.name },
        consultationRequest: {
          consultationRequestId: pastConsults[i].consultation_request.consultation_request_id,
          chiefComplaint: pastConsults[i].consultation_request.chief_complaint,
          duration: pastConsults[i].consultation_request.duration,
          date: pastConsults[i].consultation_request.date
        },
        consultation: {
          chiefComplaint: pastConsults[i].consultation.chief_complaint,
          consultationId: pastConsults[i].consultation.consultation_id,
          provisionalDiagnosis: pastConsults[i].consultation.provisional_diagnois,
          summaryNotes: pastConsults[i].consultation.summary,
          date: pastConsults[i].consultation.date,
          summary_status: pastConsults[i].consultation.summary_status,
          prescribedDrugs: pastConsults[i].consultation.prescribed_drugs,
          followupReminders: pastConsults[i].consultation.followup_reminders,
          recommendedTests: pastConsults[i].consultation.recommended_tests
        },
        details: {},
        messages: []
      };
      state.pastConsults.push(pc);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "/Mpz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/VGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorChatAvailability_vue__ = __webpack_require__("0EMX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c93cf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorChatAvailability_vue__ = __webpack_require__("Nw0W");
function injectStyle (ssrContext) {
  __webpack_require__("z5iz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43c93cf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorChatAvailability_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c93cf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorChatAvailability_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/eMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_COVID19_vue__ = __webpack_require__("Dsin");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a57094_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_COVID19_vue__ = __webpack_require__("1b+e");
function injectStyle (ssrContext) {
  __webpack_require__("3Yb5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_COVID19_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a57094_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_COVID19_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/oPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pt-6 px-4 bg-white",staticStyle:{"height":"calc(100vh - 3rem)"}},[_c('div',{staticClass:"flex flex-row items-center justify-between"},[_c('div',{staticClass:"flex flex-col leading-normal"},[_c('p',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.uploadedBy))]),_vm._v(" "),_c('p',{staticClass:"text-grey-darker font-semibold"},[_vm._v(_vm._s(_vm.uploadedOn))])])]),_vm._v(" "),_c('div',{staticClass:"bg-grey-extralight rounded mt-4 test"},[_c('div',{staticClass:"flex flex-row items-center justify-between border-b pt-2 pb-1"},[_c('div',{staticClass:"flex flex-row items-center"},[_c('p',{staticClass:"font-semibold text-sm tracking-wide cursor-pointer text-center px-4 py-2",class:_vm.showTab === 'results' ? 'text-blue border-solid border-b border-blue' : 'text-grey hover:text-blue',on:{"click":function($event){_vm.showTab = 'results'}}},[_vm._v("RESULTS")]),_vm._v(" "),_c('p',{staticClass:"font-semibold text-sm tracking-wide cursor-pointer text-center px-4 py-2",class:_vm.showTab === 'notes' ? 'text-blue border-solid border-b border-blue' : 'text-grey hover:text-blue',on:{"click":function($event){_vm.showTab = 'notes'}}},[_vm._v("NOTES")]),_vm._v(" "),_c('p',{staticClass:"font-semibold text-sm tracking-wide cursor-pointer text-center px-4 py-2",class:_vm.showTab === 'reports' ? 'text-blue border-solid border-b border-blue' : 'text-grey hover:text-blue',on:{"click":function($event){_vm.showTab = 'reports'}}},[_vm._v("REPORTS")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTab == 'results'),expression:"showTab == 'results'"}]},[(_vm.data.digitized_reports && _vm.data.digitized_reports.length)?_c('div',[_c('div',{staticClass:"overflow-y-scroll reports-scroll"},_vm._l((_vm.data.digitized_reports),function(report){return _c('div',{key:report.lab_test_id,staticClass:"flex flex-col px-4  text-grey-darker"},[_c('p',{staticClass:"font-semibold text-base pt-2"},[_vm._v(_vm._s(report.name ? report.name : 'No reports'))]),_vm._v(" "),_vm._l((report.results),function(result){return _c('div',{key:result.id,staticClass:"text-grey flex flex-row justify-between overflow-y-auto",staticStyle:{"color":"#324467"}},[_c('p',{staticClass:"pb-3 px-2 text-sm pt-2"},[_vm._v(_vm._s(result.test_component_name))]),_vm._v(" "),_c('div',{staticClass:"pb-3 px-2 text-sm",class:result.color},[_vm._v(_vm._s(result.result))])])})],2)}),0)]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTab == 'notes'),expression:"showTab == 'notes'"}]},[(_vm.data.notes && _vm.data.notes.length)?_c('div',[_c('div',{staticClass:"max-h-48 overflow-y-scroll reports-scroll"},_vm._l((_vm.data.notes),function(note){return _c('div',{key:note.id,staticClass:"flex flex-col py-3 px-4 text-sm text-grey-darker"},[_c('p',{staticClass:"text-grey-darker font-semibold"},[_vm._v(_vm._s(note.title))]),_vm._v(" "),_c('p',{staticClass:"pt-2 text-sm pl-2"},[_vm._v(_vm._s(note.description))])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTab == 'reports'),expression:"showTab == 'reports'"}]},[(_vm.data.reports && _vm.data.reports.length)?_c('div',[_c('div',{staticClass:"max-h-48 overflow-y-scroll reports-scroll"},_vm._l((_vm.data.reports),function(report){return _c('div',{key:report.id,staticClass:"p-2 font-semibold text-sm text-blue cursor-pointer",on:{"click":function($event){return _vm.openReport(report.url)}}},[_vm._v("\n              "+_vm._s(report.name)+"\n            ")])}),0)]):_vm._e()])])]),_vm._v(" "),(!_vm.data.digitized_reports.length && !_vm.data.notes.length && !_vm.data.reports.length)?_c('div',{staticClass:"text-center text-grey-darker font-semibold text-lg pt-2"},[_vm._v("\n    No Reports\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = VueApexCharts;

/***/ }),

/***/ "0/tJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.timerColor},[_vm._v(_vm._s(_vm.minutes)+"m "+_vm._s(_vm.seconds)+"s")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0D7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  loader: {
    loading: false,
    componentKey: null // null for loader at global/window level else for loader at components pass component key
  }
};

var getters = {
  getLoaderData: function getLoaderData() {
    return state.loader;
  }
};

var actions = {
  setLoader: function setLoader(_ref, data) {
    var commit = _ref.commit;

    commit('setLoader', data);
  }
};

var mutations = {
  setLoader: function setLoader(state, data) {
    state.loader = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "0EMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__ = __webpack_require__("Ph2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var today = __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date());
    return {
      checkedMohanDr: false,
      checkedMaheshDr: false,
      checkedVarunDr: false,
      checkedArmanDr: false,
      showModal: false,
      openReplaceDr: false,
      selectedDoctor: {},
      isLoading: false,
      addDoctors: false,
      addSelectedDoctor: {},
      timeSlots: ['07:00-15:00', '15:00-23:00', '11:00-19:00'],
      doctors: [],
      years: [2022, 2023, 2024],
      months: [{ text: 'January', value: '01' }, { text: 'Feburary', value: '02' }, { text: 'March', value: '03' }, { text: 'April', value: '04' }, { text: 'May', value: '05' }, { text: 'June', value: '06' }, { text: 'July', value: '07' }, { text: 'August', value: '08' }, { text: 'September', value: '09' }, { text: 'October', value: 10 }, { text: 'November', value: 11 }, { text: 'December', value: 12 }],
      selectedMonth: { value: today.format('MM'), text: today.format('MMMM') },
      selectedYear: today.format('YYYY'),
      response: [],
      slotDoctors: []
    };
  },

  mounted: function mounted() {
    this.getDoctorsList();
    this.getDoctorChatSlots();
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    role: 'configuration/getRole'
  }), {
    dates: function dates() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response);
    },
    autoSelectAllDoc: function autoSelectAllDoc() {
      var noDocSelected = true;
      this.doctors.map(function (doc) {
        if (doc.selected) {
          noDocSelected = false;
        }
        return;
      });
      return noDocSelected;
    },
    dropdownDoctorList: function dropdownDoctorList() {
      var _this = this;

      var doctorList = {};
      doctorList = this.doctors.filter(function (doctor) {
        return !_this.slotDoctors.find(function (doc) {
          return doctor.id === doc.id;
        });
      });
      return doctorList;
    }
  }),
  methods: {
    getDocInitials: function getDocInitials(name) {
      name = name.toLocaleLowerCase();
      if (name.includes('dr.')) {
        var nameArr = name.split('dr.');
        return nameArr[1].trim().charAt(0).toUpperCase();
      } else if (name.includes('dr')) {
        var _nameArr = name.split('dr');
        return _nameArr[1].trim().charAt(0).toUpperCase();
      } else {
        return name.charAt(0).toUpperCase();
      }
    },
    onMonthYearChange: function onMonthYearChange() {
      this.getDoctorChatSlots();
    },
    getDoctorChatSlots: function getDoctorChatSlots() {
      var _this2 = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__["a" /* default */].getDoctorChatSlots(this.selectedMonth.value, this.selectedYear).then(function (response) {
        if (response.status === 200) {
          if (!response.body.slots) {
            _this2.$toast.open({
              message: 'Slots not available',
              type: 'warning',
              position: 'top',
              queue: false
            });
            var date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(that.response)[0];
            if (date) {
              that.selectedMonth = { value: parseInt(__WEBPACK_IMPORTED_MODULE_4_moment___default()(date, 'DD/MM/YYYY').format('MM')) };
              that.selectedYear = parseInt(__WEBPACK_IMPORTED_MODULE_4_moment___default()(date, 'DD/MM/YYYY').format('YYYY'));
            }
            return;
          }
          _this2.response = response.body.slots;
        }
      }).catch(function (error) {
        console.log('error is ', error);
      });
    },
    getDoctorsList: function getDoctorsList() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__["a" /* default */].getDoctorsList().then(function (response) {
        if (response.status === 200) {
          that.doctors = response.body.doctors.map(function (doc) {
            doc.selected = false;
            return doc;
          });
        }
      }).catch(function (error) {
        console.log('error is ', error);
      });
    },
    openModal: function openModal(showModal, slot, date) {
      if (this.role !== 'admin') {
        return;
      }
      this.showModal = !this.showModal;
      this.selectedSlot = slot;
      this.selectedDate = date;
      this.slotDoctors = this.getDocsForASlot(slot, date);
    },
    closeModal: function closeModal() {
      this.slotDoctors = [];
      this.selectedDate = '';
      this.selectedSlot = '';
      this.selectedDoctor = {};
      this.showModal = false;
      this.addDoctors = false;
      this.openReplaceDr = false;
      this.getDoctorChatSlots();
    },
    deleteDoctor: function deleteDoctor(i) {
      this.slotDoctors.splice(i, 1);
    },
    replaceDoctor: function replaceDoctor(i, doctor) {
      this.addDoctors = false;
      this.openReplaceDr = !this.openReplaceDr;
      this.selectedDoctor = doctor;
    },
    replaceHandler: function replaceHandler(i) {
      var replaceDoctorId = parseInt(event.target.value);
      var dropdownSelectedDoctor = {};
      var removeDuplicateDoctor = {};
      dropdownSelectedDoctor = this.dropdownDoctorList.find(function (doctor) {
        if (replaceDoctorId === doctor.id) {
          return doctor;
        }
      });
      removeDuplicateDoctor = this.slotDoctors.find(function (duplicateDoc) {
        if (replaceDoctorId === duplicateDoc.id) {
          return duplicateDoc;
        }
      });
      if (dropdownSelectedDoctor === removeDuplicateDoctor) {
        this.$toast.open({
          message: 'Doctor is already present in the slot',
          type: 'warning',
          position: 'top',
          queue: false
        });
      } else {
        this.slotDoctors.splice(i, 1, dropdownSelectedDoctor);
      }
    },
    undoReplace: function undoReplace(i) {
      this.openReplaceDr = false;
    },
    addDoctor: function addDoctor(addDoctors) {
      this.openReplaceDr = false;
      this.addDoctors = !this.addDoctors;
    },
    addHandler: function addHandler() {
      var addDoctorId = parseInt(event.target.value);
      var addSelectedDoctor = this.dropdownDoctorList.find(function (doctor) {
        if (addDoctorId === doctor.id) {
          return doctor;
        }
      });
      var removeDuplicateSelectedDoc = this.slotDoctors.find(function (duplicateSelectDoc) {
        if (addDoctorId === duplicateSelectDoc.id) {
          return duplicateSelectDoc;
        }
      });
      if (addSelectedDoctor === removeDuplicateSelectedDoc) {
        this.$toast.open({
          message: 'Doctor is already present in the slot',
          type: 'warning',
          position: 'top',
          queue: false
        });
      } else {
        this.slotDoctors.push(addSelectedDoctor);
      }
      this.addDoctors = false;
    },
    dateObject: function dateObject(date) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response[date]).length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response[date]);
      }
      return [];
    },
    getDocsForASlot: function getDocsForASlot(slot, date) {
      if (this.response[date][slot].length > 0) {
        if (this.autoSelectAllDoc) {
          return this.response[date][slot];
        } else {
          var resp = [];
          var that = this;
          this.response[date][slot].map(function (doc) {
            that.doctors.filter(function (doc) {
              return doc.selected;
            }).map(function (selectedDoc) {
              if (doc.id === selectedDoc.id) {
                resp.push(doc);
              }
            });
          });
          return resp;
        }
      }
      return [];
    },

    selectDoctors: function selectDoctors(i, doc) {
      this.doctors[i].selected = !this.doctors[i].selected;
    },
    showAllDoctors: function showAllDoctors() {
      this.doctors.map(function (doctor) {
        doctor.selected = false;
      });
    },
    updateChatSlot: function updateChatSlot() {
      var _this3 = this;

      if (this.role !== 'admin') {
        this.$toast.open({
          message: 'Not Authorised',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      var doctorIds = this.slotDoctors.map(function (a) {
        return a.id;
      });
      var res = this.selectedSlot.split('-');
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__["a" /* default */].updateChatSlot({
        doctor_ids: doctorIds,
        date: this.selectedDate,
        start_time: res[0],
        end_time: res[1]
      }).then(function (response) {
        if (response.status === 200) {
          _this3.showModal = false;
          _this3.$toast.open({
            message: 'Chat Availability updated successfully',
            type: 'success',
            position: 'top',
            queue: false
          });
          that.getDoctorChatSlots();
        }
      }).catch(function (error) {
        console.log('error is ', error);
        _this3.$toast.open({
          message: 'Chat Availability updated failed',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    }
  }
});

/***/ }),

/***/ "0Kyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("7q3b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a65b14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("MswO");
function injectStyle (ssrContext) {
  __webpack_require__("HnX8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a65b14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a65b14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0OM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['doctor'],
  data: function data() {
    return {
      consultations: [],
      search: '',
      page: 1
    };
  },

  created: function created() {},
  mounted: function mounted() {
    this.getDoctorConsults();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    pastConsults: function pastConsults(state) {
      this.consultations = state.pastConsultation.pastConsults;
      return state.pastConsultation.pastConsults;
    },

    activePastConsultationRequestId: function activePastConsultationRequestId(state) {
      return state.pastConsultation.activePastConsultationRequestId;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    showLoadMore: 'pastConsultation/showLoadMore'
  })),
  watch: {
    pastConsults: function pastConsults(value) {
      this.consultations = value;
    }
  },
  methods: {
    selectFromPastList: function selectFromPastList(id, consultationRequestId) {
      this.$store.dispatch('pastConsultation/switchTo', { id: id, consultationRequestId: consultationRequestId });
    },
    consultStatus: function consultStatus(cp) {
      if (cp.consultation.summary_status === 'done' || cp.consultation.summary_status === 'not_needed') {
        return true;
      } else {
        return false;
      }
    },
    getDoctorConsults: function getDoctorConsults() {
      this.selectedDoctor = this.doctor.id;
      this.isLoading = true;
      var that = this;
      if (this.doctor.doctor_id === null) {} else {
        this.getDoctorConsultsApi().then(function (response) {
          if (response.status === 200) {
            that.$store.dispatch('pastConsultation/setUpPastConsults', { details: response.body.consultations, total: response.body.total });
          } else {}
        }, function (response) {});
      }
    },
    fetchConsults: function fetchConsults() {
      var that = this;
      if (this.search !== '' && this.doctor.doctor_id) {
        this.getDoctorConsultsApi().then(function (response) {
          if (response.status === 200) {
            that.$store.dispatch('pastConsultation/setUpPastConsults', { details: response.body.consultations, total: response.body.total });
          } else {}
        }, function (response) {});
      }
    },
    fetchMoreConsults: function fetchMoreConsults() {
      var that = this;
      this.page = this.page + 1;
      this.getDoctorConsultsApi().then(function (response) {
        if (response.status === 200) {
          that.$store.dispatch('pastConsultation/loadMoreConsultsAdmin', { pastConsults: response.body.consultations });
        }
      });
    },

    getDoctorConsultsApi: function getDoctorConsultsApi() {
      var query = 'page=' + this.page + '&type=text&doctor_id=' + this.doctor.doctor_id;
      if (this.search && this.search !== '') query = query + '&term=' + this.search;
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(window.API_URL + 'doctors/doctor_consults?' + query);
    }
  }
});

/***/ }),

/***/ "0Olh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0qeJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ekincare_logo.25c97c9.png";

/***/ }),

/***/ "0xqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"w-full"},[_c('section',{staticClass:"bg-white flex flex-row rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"flex flex-col px-5"},[_c('div',[_c('div',{staticClass:"flex flex-row flex-no-shrink flex-no-grow py-2"},[_c('h3',{staticClass:"text-md"},[_vm._v(" Profile Picture ")]),_vm._v(" "),_c('div',{staticClass:"db-file-upload ml-auto"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"myFiles",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.changeProfileImage($event.target.files)}}}),_vm._v(" "),_c('span',{staticClass:"py-2 px-2 mr-1 justify-center cursor-pointer rounded-sm text-blue text-xs",attrs:{"alt":"attach_file"}},[_vm._v("Upload")])])])])]),_vm._v(" "),(_vm.doctor.photo)?_c('div',[_c('img',{staticClass:"w-64 h-64",attrs:{"src":_vm.doctor.photo.url}})]):_c('div',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"250px"}},[_vm._v("person")])])]),_vm._v(" "),_c('div',{staticClass:"border border-b border-grey-lightest my-5"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"flex flex-row flex-no-shrink flex-no-grow py-2"},[_c('h3',{staticClass:"text-md"},[_vm._v(" Signature ")]),_vm._v(" "),_c('div',{staticClass:"db-file-upload ml-auto"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"myFiles",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".pdf, .png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.changeSignatureImage($event.target.files)}}}),_vm._v(" "),_c('span',{staticClass:"py-2 px-2 mr-1 justify-center cursor-pointer rounded-sm text-blue text-xs",attrs:{"alt":"attach_file"}},[_vm._v("Upload")])])])])]),_vm._v(" "),(_vm.doctor.signature)?_c('div',[_c('img',{staticClass:"w-64 h-64",attrs:{"src":_vm.doctor.signature.url}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"w-1/2"},[_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("Name")]),_vm._v(" "),_c('input',{staticClass:"shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",domProps:{"value":_vm.doctor.name},on:{"change":_vm.onName}})]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("Qualification")]),_vm._v(" "),_c('input',{staticClass:"shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",domProps:{"value":_vm.doctor.qualification},on:{"change":_vm.onQualification}})]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("Summary")]),_vm._v(" "),_c('input',{staticClass:"shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",domProps:{"value":_vm.doctor.description},on:{"change":_vm.onDescription}})]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("Mobile Number")]),_vm._v(" "),_c('input',{staticClass:"shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",domProps:{"value":_vm.doctor.mobile_number},on:{"change":_vm.onMobileNumber}})]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("Registration Number")]),_vm._v(" "),_c('input',{staticClass:"shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",domProps:{"value":_vm.doctor.registration_number},on:{"change":_vm.onRegistrationNumber}})]),_vm._v(" "),_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",on:{"click":_vm.saveProfile}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:" mt-4 mx-12"},[_c('div',{staticClass:"bg-white shadow-md rounded p-6"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"text-grey-darker font-semibold text-base"},[_vm._v("\n            Multi Factor Authentication\n            ")]),_vm._v(" "),(_vm.mfa.enabled)?_c('span',{staticClass:"text-sm ml-12 bg-green-light rounded-full text-grey-dark py-2 font-semibold h-6 px-3 flex justify-center items-center gap-1"},[_c('span',{staticClass:"rounded-full mr-2 p-1 bg-green-dark"}),_vm._v("\n            enabled\n          ")]):_c('span',{staticClass:"text-sm ml-12 bg-grey-lightest rounded-full text-grey-dark py-1.5 font-semibold px-3 h-6 flex justify-center items-center gap-1"},[_c('span',{staticClass:"rounded-full mr-1 p-1 bg-grey-dark"}),_vm._v("\n            disabled\n          ")])]),_vm._v(" "),(_vm.mfa.enabled)?_c('p',{staticClass:"text-sm mt-1 mb-3 text-grey-dark"},[_vm._v("Enabled for your account")]):_c('p',{staticClass:"text-sm mt-1 mb-3 text-grey-dark"},[_vm._v("Enable multi factor authentication")]),_vm._v(" "),(!_vm.mfa.enabled)?_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold mt-4 py-2 px-4 rounded focus:outline-none focus:shadow-outline",on:{"click":_vm.moveToMfaSettings}},[_vm._v("Enable MFA")]):_vm._e()])])])]),_vm._v(" "),_c('div',[(_vm.isPopupVisible)?_c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"text-lg font-semibold text-grey-dark my-3 ml-6"},[_vm._v("Are you sure you want to disable MFA?")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-xl ml-16 italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.showOrClosePopup}},[_c('i',{staticClass:"fa fa-window-close",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4 mx-8"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.disableMfaSettings}},[_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-base italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.showOrClosePopup}},[_c('a',{attrs:{"href":"#"}},[_vm._v("No")])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"toaster"},[_c('toaster')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0zGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "10ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mer_vue__ = __webpack_require__("DIK+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51884bdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mer_vue__ = __webpack_require__("kf5T");
function injectStyle (ssrContext) {
  __webpack_require__("2Xwv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51884bdd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51884bdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "15t0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "1Faf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1JxI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiNDNEYxRDgiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMUI3MDQyIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMy4xNCAxNy4zODdjLjM5Mi0uMzczLjkxNC0uNzQ2IDEuMzA1LTEuMjQ0IDEuOTU4LTEuODY2IDMuOTE1LTMuODU3IDUuODczLTUuNzIzLjM5MS0uMzczLjc4My0uNDk4IDEuMTc0LS4zNzMuNzgzLjI0OCAxLjA0NCAxLjI0NC41MjIgMS44NjZsLS41MjIuNDk4Yy0yLjQ4IDIuMzYzLTQuOTU5IDQuODUyLTcuNDM4IDcuMjE2LS41MjIuNDk3LTEuMTc0LjQ5Ny0xLjgyNyAwLTEuMzA1LTEuMjQ0LTIuNjEtMi42MTMtMy45MTUtMy44NTctLjI2LS4zNzMtLjM5MS0uNzQ3LS4yNi0xLjEyLjEzLS4zNzMuMzktLjYyMi45MTMtLjc0Ni4zOTEtLjEyNS43ODMgMCAxLjA0NC4zNzMuOTEzLjg3IDEuODI3IDEuODY2IDIuNzQgMi43MzdsLjM5MS4zNzN6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "1PhP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNyAxOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTcgMTg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMzI0NDY3O30KPC9zdHlsZT4KPGcgaWQ9Ik5ldy1JY29ucyI+Cgk8ZyBpZD0iTG9nb3V0Ij4KCQk8ZyBpZD0iUGF0aCI+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNi45LDkuNWMwLDQuNy0zLjcsOC40LTguNSw4LjRDMy44LDE4LDAsMTQuMiwwLDkuNWMwLTIuOSwxLjYtNS43LDQuMi03LjJjMC4yLTAuMSwwLjUtMC4yLDAuNy0wLjEKCQkJCWMwLjMsMC4xLDAuNSwwLjIsMC42LDAuNEM1LjgsMyw1LjcsMy43LDUuMiw0QzMuMiw1LjEsMiw3LjIsMiw5LjVDMiwxMyw1LDE2LDguNSwxNkMxMiwxNiwxNSwxMywxNSw5LjVDMTUsNy4yLDEzLjcsNSwxMS43LDQKCQkJCWMtMC41LTAuMy0wLjYtMC45LTAuMy0xLjRjMC4xLTAuMiwwLjQtMC40LDAuNi0wLjRjMC4yLTAuMSwwLjUsMCwwLjcsMC4xQzE1LjMsMy44LDE2LjksNi42LDE2LjksOS41eiIvPgoJCTwvZz4KCQk8ZyBpZD0iUGF0aF8xXyI+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik05LjQsMS4ydjguNGMwLDAuNS0wLjUsMC45LTAuOSwwLjlDOCwxMC41LDcuNSwxMCw3LjUsOS41VjEuMmMwLTAuNSwwLjUtMC45LDAuOS0wLjlDOSwwLjIsOS40LDAuNyw5LjQsMS4yCgkJCQl6Ii8+CgkJPC9nPgoJPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "1R19":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "1b+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('left-pane',{attrs:{"data":_vm.responseData,"selectedPatient":_vm.selectedPatient},on:{"tabChange":_vm.tabChange,"selectFromList":_vm.selectFromList}}),_vm._v(" "),(_vm.responseData.length>0 || _vm.status === 'new')?_c('div',{staticClass:"flex flex-col overflow-y-auto w-full",staticStyle:{"height":"calc(100vh - 3rem)"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-white flex-no-shrink flex-no-grow border-solid border-b border-grey-lighest"},[_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow px-8 pt-4 pb-8 mr-auto border-r border-solid border-grey-lighest",staticStyle:{"width":"400px"}},[_c('div',{staticClass:"my-4 flex flex-col"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.name),expression:"selectedPatient.name"}],staticClass:"h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"type":"text"},domProps:{"value":(_vm.selectedPatient.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.email),expression:"selectedPatient.email"}],staticClass:"h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"type":"text"},domProps:{"value":(_vm.selectedPatient.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Mobile Number "),(_vm.status === 'new')?_c('span',{staticClass:"text-red text-m"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.mobile_number),expression:"selectedPatient.mobile_number"}],staticClass:"h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status !== 'new' ? true : false,"type":"number"},domProps:{"value":(_vm.selectedPatient.mobile_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient, "mobile_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Age")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.response.age),expression:"selectedPatient.response.age"}],staticClass:"h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"min":"0","type":"number"},domProps:{"value":(_vm.selectedPatient.response.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient.response, "age", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"flex flex-row items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.response.gender),expression:"selectedPatient.response.gender"}],staticClass:"h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"value":"male","type":"radio"},domProps:{"checked":_vm._q(_vm.selectedPatient.response.gender,"male")},on:{"change":function($event){return _vm.$set(_vm.selectedPatient.response, "gender", "male")}}}),_vm._v(" "),_c('label',{staticClass:"text-sm font-semibold text-grey-dark ml-2 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Male")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center ml-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.response.gender),expression:"selectedPatient.response.gender"}],staticClass:"h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"value":"female","type":"radio"},domProps:{"checked":_vm._q(_vm.selectedPatient.response.gender,"female")},on:{"change":function($event){return _vm.$set(_vm.selectedPatient.response, "gender", "female")}}}),_vm._v(" "),_c('label',{staticClass:"text-sm font-semibold text-grey-dark ml-2 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Female")])])])]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_vm._m(3),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.address),expression:"selectedPatient.address"}],staticClass:"h-24 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"type":"text"},domProps:{"value":(_vm.selectedPatient.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_vm._m(4),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.summary),expression:"selectedPatient.summary"}],staticClass:"h-24 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"type":"text"},domProps:{"value":(_vm.selectedPatient.summary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient, "summary", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-4 flex flex-col"},[_vm._m(5),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.provisional_diagnosis),expression:"selectedPatient.provisional_diagnosis"}],staticClass:"h-24 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"type":"text"},domProps:{"value":(_vm.selectedPatient.provisional_diagnosis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPatient, "provisional_diagnosis", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mt-4 flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPatient.sendPrescription),expression:"selectedPatient.sendPrescription"}],staticClass:"h-8 p-2 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"disabled":_vm.status==='done' ? true : false,"type":"checkbox","name":"drug_duration"},domProps:{"checked":Array.isArray(_vm.selectedPatient.sendPrescription)?_vm._i(_vm.selectedPatient.sendPrescription,null)>-1:(_vm.selectedPatient.sendPrescription)},on:{"change":function($event){var $$a=_vm.selectedPatient.sendPrescription,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedPatient, "sendPrescription", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedPatient, "sendPrescription", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedPatient, "sendPrescription", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"p-2 mr-2 text-sm font-semibold text-grey-dark",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Recommend Covid-19 test")])]),_vm._v(" "),_c('div',{staticClass:"mt-4 flex flex-row"},[(_vm.status==='done')?_c('span',{staticClass:"w-full cursor-not-allowed border border-solid border-green bg-green py-2 px-5 text-white font-semibold text-center rounded self-center flex-no-shrink items-end"},[_vm._v("Marked as done")]):_c('span',{staticClass:"w-full hover:shadow-md cursor-pointer border border-solid border-blue bg-blue py-2 px-5 text-white font-semibold text-center rounded self-center flex-no-shrink items-end",on:{"click":function($event){return _vm.markAsDone('done')}}},[_vm._v("Mark as done")])]),_vm._v(" "),(_vm.status!=='done' && _vm.status!== 'new')?_c('div',{staticClass:"mt-4 flex flex-row"},[_c('span',{staticClass:"w-full hover:shadow-md cursor-pointer border border-solid border-grey-lightest bg-white py-2 px-auto text-blue font-semibold text-center rounded self-center flex-no-shrink items-end",on:{"click":function($event){return _vm.openPopup()}}},[_vm._v("Customer didn't answer the call")])]):_vm._e()]),_vm._v(" "),(_vm.selectedPatient.response['0'] || _vm.selectedPatient.response['1'] || _vm.answer3 || _vm.answer4 || _vm.answer5)?_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"my-4 flex flex-col"},[(_vm.selectedPatient.response['0'])?_c('div',{staticClass:"flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest"},[_c('div',{staticClass:"felx text-lg font-semibold text-grey mr-2 mt-1"},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"text-base font-semibold text-grey"},[_vm._v("Have you travelled to any of the high-risk COVID-19 affected countries in the last 14 days?")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-darker font-semibold my-2"},[_vm._v(_vm._s(_vm.selectedPatient.response['0']))])])]):_vm._e(),_vm._v(" "),(_vm.selectedPatient.response['1'])?_c('div',{staticClass:"flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest"},[_c('div',{staticClass:"felx text-lg font-semibold text-grey mr-2 mt-1"},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"text-base font-semibold text-grey"},[_vm._v("Did you come in contact with a laboratory tested positive case or suspected person in the last 14 days?")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-darker font-semibold my-2"},[_vm._v(_vm._s(_vm.selectedPatient.response['1']))])])]):_vm._e(),_vm._v(" "),(_vm.answer3)?_c('div',{staticClass:"flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest"},[_c('div',{staticClass:"felx text-lg font-semibold text-grey mr-2 mt-1"},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"text-base font-semibold text-grey"},[_vm._v("Have you developed any new symptoms recently? Please select an option from below. ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-darker font-semibold my-2"},[_vm._v(_vm._s(_vm.answer3))])])]):_vm._e(),_vm._v(" "),(_vm.answer4)?_c('div',{staticClass:"flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest"},[_c('div',{staticClass:"felx text-lg font-semibold text-grey mr-2 mt-1"},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"text-base font-semibold text-grey"},[_vm._v("Any of these signs could also be an indication of infection. Please select an option from below ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-darker font-semibold my-2"},[_vm._v(_vm._s(_vm.answer4))])])]):_vm._e(),_vm._v(" "),(_vm.answer5)?_c('div',{staticClass:"flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest"},[_c('div',{staticClass:"felx text-lg font-semibold text-grey mr-2 mt-1"},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"text-base font-semibold text-grey"},[_vm._v("Do you have a pre-existing condition or medical history? ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-darker font-semibold my-2"},[_vm._v(_vm._s(_vm.answer5))])])]):_vm._e()])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showPopup)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20 py-4 px-2",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v("Confirm")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker my-2 text-base"},[_vm._v("Please click 'YES' if you have called the customer twice, otherwise click 'NO'. Clicking 'YES' will remove the customer request.")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-4 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.popupStatus()}}},[_vm._v("Yes")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-blue text-sm hover:shadow-md ml-4 border border-solid border-grey-lightest",on:{"click":function($event){return _vm.closeOverlay()}}},[_vm._v("No")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("COVID-19")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Name "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Email "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Address "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Summary "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Provisional Diagnosis "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1bhZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiMzNjM2MzYiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMTUgOS41djExLjMzN005LjUgMTVoMTEuMzM3TTE1IDkuNXYxMS4zMzdNOS41IDE0LjVoMTEuMzM3Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "1dtu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1h9A":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAD/klEQVR4nO3cQWxURRgH8P/3dtfFRBNNTYFS3aeYeDaAvRASSLAHoyHhQNLAjTQa9YrdhWAP3XoACUdMuEBAEw0XotEDkkBSjcLBi1wU2wrd7WIIiZFE6O77PBRCXXZpV2bet+P+f7fOe9v5Mv/Mvpl5TQEiIiKiXiTWBfgSlyrayf0zkwMmYxFZdEoPMABjDMAYAzDGAIwFvwrqdLXTKd+rI84AYwzAGAMwxgCMMQBjWesCfOl09eJ7NdUOZ4AxBmCMARhjAMYYgDEGYIwBGGMAxhiAMQZgjAEY64qzoA2jmrvVVxtOkGyHyCaorofgWQA569p8Mw3g5fd/yS88/dR7N7W6D4L+xVb9H7woXTmzAOJiZUddcFSghV4a8GYGzwCVuDT3AQRnABTS77+7pDwDVAr7qyegsifdfrtXqjMgLlU+FAUHf4nUZkBcrOwAcHCZ276G6hcRdOr2QnaudnjN7WV/r9GbLFdSCSAen16FuziK9uubK6rJ3tmPBr9Po55ukkoAenfVuwJt+cBVxblcPr/z1/G+P9Oopdt4fwZsGNWcqO5rc/lKLw8+kEIAt/pqww82Wf+iqsneXh58IIUAGqKvt7n0TS9+5zfzHoAAG9tc+dx33yHwvw9QXd+y46g+5b3vAPgPQPBMq+Yns/mq974DkMZO+IlWjT+P9/+VQt9djy9kjDEAY13xRsyHUM6IOAOMMQBjDMAYAzDGAIwFvwqy+j8/rnAGGGMAxhiAMQZgjAEY8xpAXJwfanetMDb3qs++Q+FlCRePVWNEegzA8CNuUwBnsZB9e+ZQ/7yPOkLgPIC4OD+kknwpwHMruV+B64LkzZnJwZ9c1xICpwG8MFZ7SaLGDysd/PsUuB4hs3F6cnXNZT0hcPgMUImixvFOBx8ABBhUND5xV0s4nM2AwoH5bZIk3z7O74gEm34rD1x2VVMInJ0FieruNpfuqKAEzX22+GN9RKBlAPnmGxPFpbhUcVWSE77PmtwdxqlubtkM2T9bXntkSdPHLxaroqKHnPUdMJf7gMFWjbKQOd3cpvXMKYf9Bs1lAPVWjZqTh6ZwQ/7mDvwelwPR5su7PtLcks3kHmrrVS5fyFwA8Epzo0DLhVIVQPbTxZb6iEInHPYbtK5ahorI0HR57Y+uagqBs6+g2Yk156F6/r9+XoCvem3wAcenoY1MdhTAzY4/qLgRib7jspZQOA3g2sTqqyr6FjoL4Y8owhtXy+uuuawlFM6Xg7Pldd8lSeY1gSz7PFDFOY2ioV47fljK6za7UKpuFeguAFsUeF4WA/9dBFMATk6XBy767D8EzgII5a+RXXF1RsQdqTEGYIwBGGMAxhgAERERERERERFRSv4BWAj+tuZYdt4AAAAASUVORK5CYII="

/***/ }),

/***/ "1id9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1pBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__["a" /* default */]
  },
  data: function data() {
    return {
      search: '',
      viewProfile: false,
      showSaveReminder: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activePastConsult: function activePastConsult(state) {
      return state.pastConsultation.activePastConsultId;
    },
    activePastConsultationRequestId: function activePastConsultationRequestId(state) {
      return state.pastConsultation.activePastConsultationRequestId;
    },
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    consultations: 'pastConsultation/getPastConsults',
    showLoadMore: 'pastConsultation/showLoadMore'
  })),
  watch: {
    consultations: function consultations(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.consultations = newVal;
      }
    }
  },
  methods: {
    selectFromPastList: function selectFromPastList(id, consultationRequestId) {
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      this.$store.dispatch('pastConsultation/switchTo', { id: id, consultationRequestId: consultationRequestId });
    },
    consultStatus: function consultStatus(cp) {
      if (cp.consultation.consultationId === null || cp.consultation.consultationId === undefined) {
        return true;
      } else {
        if (cp.consultation.summary_status === 'done' || cp.consultation.summary_status === 'not_needed') {
          return true;
        } else {
          return false;
        }
      }
    },
    viewCustomerProfile: function viewCustomerProfile(e) {
      e.stopPropagation();
      this.viewProfile = !this.viewProfile;
    },
    fetchMoreConsults: function fetchMoreConsults() {
      this.$store.dispatch('pastConsultation/fetchMoreConsults');
    },
    closeModal: function closeModal(params) {
      this.showSaveReminder = false;
    }
  }
});

/***/ }),

/***/ "22C3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    loadDetails: function loadDetails(state) {
      return state.consultationRequest.loadDetails;
    }
  })),
  methods: {
    closePopup: function closePopup() {
      this.$emit('closePopup', false);
    }
  }
});

/***/ }),

/***/ "2HGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveOfflineConsultations_vue__ = __webpack_require__("pU0Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de6e982_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveOfflineConsultations_vue__ = __webpack_require__("5e3d");
function injectStyle (ssrContext) {
  __webpack_require__("LLFE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveOfflineConsultations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de6e982_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveOfflineConsultations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2IkP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY29weSIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDJhMiAyIDAgMCAxIDItMmg4YTIgMiAwIDAgMSAyIDJ2OGEyIDIgMCAwIDEtMiAySDZhMiAyIDAgMCAxLTItMnptMi0xYTEgMSAwIDAgMC0xIDF2OGExIDEgMCAwIDAgMSAxaDhhMSAxIDAgMCAwIDEtMVYyYTEgMSAwIDAgMC0xLTF6TTIgNWExIDEgMCAwIDAtMSAxdjhhMSAxIDAgMCAwIDEgMWg4YTEgMSAwIDAgMCAxLTF2LTFoMXYxYTIgMiAwIDAgMS0yIDJIMmEyIDIgMCAwIDEtMi0yVjZhMiAyIDAgMCAxIDItMmgxdjF6Ii8+Cjwvc3ZnPg=="

/***/ }),

/***/ "2JCH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");

/* harmony default export */ __webpack_exports__["a"] = ({
  parseMessage: function parseMessage(channelId, msg) {
    // if (channelId === 'doctors_channel') {
    var message = JSON.parse(msg.data);
    if (message.intent_name === 'join_channel') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('consultationRequest/addConsultationRequest', message); // save message in queue for display
    } else if (message.intent_name === 'reject') {
      console.log('One of the doctors has rejected this request');
    } else if (message.intent_name === 'already_assigned' && message.doctor_id !== __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.configuration.doctorId) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('consultationRequest/removeRequest', { message: message, status: 'already_assigned' });
    } else if (message.intent_name === 'request_cancelled') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('consultationRequest/removeRequest', { message: message, status: 'cancelled' });
    } else if (message.intent_name === 'request_missed') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('consultationRequest/missedConsultationRequest', message);
    } else if (message.intent_name === 'request_queried') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('consultationRequest/queriedConsultationRequest', message);
    } else if (message.intent_name === 'notification') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('notification/addNotification', { notification: message.payload });
    } else {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('message/receive', { channelId: channelId, message: message });
    }
  },
  buildWelcomeTextMessage: function buildWelcomeTextMessage(data) {
    var timeInMilliSeconds = new Date().getTime();
    var name = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.configuration.name;
    var text = 'Hi, This is ' + name + '. I am here to help you with your health query.';
    if (data.patient.isFamilyDoctor) text = 'Hi ' + data.patient.name + ', good to connect with you today.';
    return {
      intentName: 'incoming_text',
      uniqueId: timeInMilliSeconds,
      payload: { text: text },
      user: { 'type': 'doctor' },
      timestamp: timeInMilliSeconds,
      transient: false,
      consultation_request_id: data.patient.consultationRequest.consultationRequestId,
      customer_id: data.activeCustomerId
    };
  },
  buildMessage: function buildMessage(payload, options) {
    if (options.patient) {
      var timeInMilliSeconds = new Date().getTime();
      return {
        intentName: options.intentName,
        uniqueId: timeInMilliSeconds,
        payload: payload,
        timestamp: timeInMilliSeconds,
        user: { 'type': 'doctor' },
        transient: false,
        consultation_request_id: options.patient.consultationRequest.consultationRequestId,
        // since cuatomer side we are not sending consultation id so not send it from here either
        // consultation_id: patient.consultation.consultationId, // need to figure it out
        customer_id: options.activeCustomerId
      };
    }
  },
  buildFileData: function buildFileData(fileList, options) {
    if (options.patient) {
      var formData = new FormData();
      formData.append('customer_id', options.activeCustomerId);
      formData.append('consultation_id', options.consultationId);
      formData.append('files[]', fileList[0], fileList[0].name);
      return formData;
    }
  },
  buildTempFileData: function buildTempFileData(file) {
    file.progress = 0;
    file.state = 'preparing'; // has 4 states : preparing, uploading, uploaded, reload
    file.intentName = 'file_attachment';
    file.payload = { file_url: '', file_name: file.name };
    file.user = { type: 'doctor' };
    return file;
  },
  buildDocumentMessage: function buildDocumentMessage(data) {
    if (data.patient) {
      // create send data based on conditions like documents or presciption etc
      var sendData = {
        url: data.url,
        type: data.type,
        fileIntent: data.intentName,
        fileName: data.fileName,
        channelId: data.activeChannelId,
        customer_id: data.activeCustomerId,
        consultation_request_id: data.activeConsultationRequestId
      };
      var timeInMilliSeconds = new Date().getTime();
      var msg = {
        uniqueId: timeInMilliSeconds,
        intentName: data.intentName,
        payload: { id: data.id, file_url: sendData.url, file_name: sendData.fileName, unique: sendData.channelId + timeInMilliSeconds },
        user: { type: 'doctor' },
        transient: false,
        consultation_id: data.activeConsultationId,
        consultation_request_id: sendData.consultation_request_id,
        customer_id: sendData.customer_id
      };
      if (sendData.type === 'prescription') {
        msg.payload.medications = data.medications;
        // msg.payload.prescription_id = data.prescriptionId
        // msg.payload.labtests = (sendData.labtests !== undefined) ? sendData.labtests : null
      }
      return msg;
    }
  },
  buildPresenceUpdate: function buildPresenceUpdate(data) {
    if (data.isTyping !== undefined) {
      if (data.isTyping === true) {
        data.typing = true;
      } else {
        data.typing = false;
      }
      delete data.isTyping;
    } else if (data.isDelivered !== undefined && data.isDelivered === true) {
      delete data.isDelivered;
      data.typing = false;
    } else if (data.isRead !== undefined && data.isRead === true) {
      delete data.isRead;
      data.typing = false;
    }
    data.transient = false;
    data.user = { 'type': 'doctor' };
    return data;
  }
});

/***/ }),

/***/ "2T23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beforeRequestSuccess; });
/* unused harmony export beforeRequestError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



var onSuccess = function onSuccess(response) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('loader/setLoader', { loading: false, componentKey: null });
  return response;
};

var onError = function onError() {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('loader/setLoader', { loading: false, componentKey: null });
  // return Promise.reject(error)
};

var beforeRequestSuccess = function beforeRequestSuccess(request) {
  var key = null;
  if (request && request.componentKey) {
    key = request.componentKey;
  }
  !request.params.calledOnce && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('loader/setLoader', { loading: true, componentKey: key });
  return;
};

var beforeRequestError = function beforeRequestError(error) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('loader/setLoader', { loading: false, componentKey: null });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};



/***/ }),

/***/ "2Xwv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2f92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RightPane_vue__ = __webpack_require__("lGU3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa12103a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RightPane_vue__ = __webpack_require__("s4wO");
function injectStyle (ssrContext) {
  __webpack_require__("t2QX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RightPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa12103a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RightPane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3+8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col rounded-m bg-grey-extralight m-3"},[_c('div',{staticClass:"bg-grey-lightest rounded-t-m font-semibold p-4 text-grey-darkest"},[_vm._v("Prescribed Medicines")]),_vm._v(" "),_c('div',{staticClass:"px-4 pt-3 pb-2"},_vm._l((_vm.data.medications),function(med,index){return _c('div',{key:index},[_c('div',{staticClass:"flex flex-col pt-1 pb-2"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"text-sm text-grey-darkest font-semibold"},[_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(("" + (med.name))))]),_vm._v(_vm._s((", " + (med.dose_quantity) + " " + (med.dose_unit))))]),_vm._v(" "),(med.duration && med.duration_unit)?_c('div',{staticClass:"text-sm text-grey-darkest ml-4"},[_vm._v(" for "),_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(med.duration)+" "+_vm._s(med.duration_unit))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex py-1"},[_c('div',{staticClass:"flex text-xs text-grey-dark capitalize"},[_vm._v(_vm._s(med.frequency))])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "318Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setOptions */
var config = {
  defaultContainerElement: null,
  defaultIconPack: 'mdi',
  defaultDialogConfirmText: null,
  defaultDialogCancelText: null,
  defaultSnackbarDuration: 3500,
  defaultToastDuration: 2000,
  defaultTooltipType: 'is-primary',
  defaultTooltipAnimated: false,
  defaultInputAutocomplete: 'on',
  defaultDateFormatter: null,
  defaultDateParser: null,
  defaultDayNames: null,
  defaultMonthNames: null,
  defaultFirstDayOfWeek: null,
  defaultUnselectableDaysOfWeek: null,
  defaultTimeFormatter: null,
  defaultTimeParser: null,
  defaultModalScroll: null,
  defaultDatepickerMobileNative: true,
  defaultTimepickerMobileNative: true,
  defaultNoticeQueue: true,
  defaultInputHasCounter: true
};

/* harmony default export */ __webpack_exports__["a"] = (config);

var setOptions = function setOptions(options) {
  config = options;
};

/***/ }),

/***/ "32Py":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "35nw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewUpdateAvailable_vue__ = __webpack_require__("ce3u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d3a1d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewUpdateAvailable_vue__ = __webpack_require__("vwaR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewUpdateAvailable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d3a1d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewUpdateAvailable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3DOc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col p-2 flex-no-shrink flex-no-grow rounded-sm bg-white",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"flex justify-between w-full mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex mr-auto"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mr-1 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])]),_vm._v(" "),(!_vm.inEdit && _vm.canEdit)?_c('div',{staticClass:"flex ml-auto mr-1",on:{"click":function($event){return _vm.edit()}}},[_c('span',{staticClass:"justify-center cursor-pointer text-blue text-sm font-semibold"},[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.inEdit)?_c('div',{staticClass:"flex ml-auto"},[(!_vm.editMode || _vm.editMode === 'false')?_c('span',{staticClass:"justify-center cursor-pointer text-blue text-sm font-semibold",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!_vm.editMode || _vm.editMode === 'false')?_c('span',{staticClass:"pl-2 justify-center cursor-pointer text-grey-light text-sm font-semibold",on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel")]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.inEdit)?_c('div',[_c('p',{staticClass:"flex flex-col text-grey-darker text-m",domProps:{"innerHTML":_vm._s(_vm.selectedItem.join(','))}})]):_c('div',{staticClass:"flex-no-shrink flex-no-grow relative auto-complete-container"},[_c('multiselect',{attrs:{"id":'editor_'+_vm.fieldId,"options":_vm.itemList,"placeholder":"Type to search","value":_vm.selectedItem,"searchable":true,"multiple":true},on:{"search-change":function($event){return _vm.onDivInput($event)}},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3MlZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  inEdit: false,
  field: null
};

var getters = {};

var actions = {
  updateTextFieldState: function updateTextFieldState(_ref, data) {
    var commit = _ref.commit;

    commit('updateTextFieldState', data);
  }
};

var mutations = {
  updateTextFieldState: function updateTextFieldState(state, data) {
    state.inEdit = data.inEdit;
    state.field = data.inEdit ? data.field : null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "3Qx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  props: ['value', 'label', 'fieldId', 'editMode', 'list', 'error'],
  data: function data() {
    var editing = false;
    if (this.editMode && this.editMode === 'true') {
      editing = true;
    }
    return {
      inEdit: editing,
      itemList: this.list,
      isLoading: false,
      selectedItem: this.value ? this.value.split(';') : []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  }), {
    canEdit: function canEdit() {
      if (this.customer) {
        if (this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') {
          return false;
        } else {
          return true;
        }
      }
    }
  }),
  watch: {
    value: function value(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.selectedItem = newVal.split(';');
        } else {
          this.selectedItem = [];
        }
      }
    },
    list: function list(val) {
      this.itemList = val;
    },
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!this.value) {
          this.selectedItem = [];
          return;
        }
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    edit: function edit() {
      this.inEdit = true;
    },
    save: function save() {
      if (this.error && this.error.hasError) {
        this.$toast.open({ message: this.error.message ? this.error.message : 'Something went wrong', type: 'error', position: 'top', queue: false });
        return;
      }
      if (this.selectedItem.length > 0) {
        this.inEdit = false;
        this.$emit('saveChange', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.fieldId, this.selectedItem.join(';')));
        this.$store.dispatch('textField/updateTextFieldState', { inEdit: false, field: this.fieldId });
      }
      if (this.selectedItem.length === 0) {
        this.$toast.open({
          message: 'Please choose any option to save',
          type: 'error',
          position: 'top',
          queue: false
        });
        return;
      }
    },
    cancel: function cancel() {
      this.inEdit = false;
      this.$store.dispatch('textField/updateTextFieldState', { inEdit: false, field: this.fieldId });
    },
    onDivInput: function onDivInput(value) {
      if (value.length > 0) {
        this.$emit('input', value);
        this.$emit('searchInput', value);
        this.$store.dispatch('textField/updateTextFieldState', { inEdit: true, field: this.fieldId });
      }
    }
  }
});

/***/ }),

/***/ "3X5m":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImVkaXQiPgo8cGF0aCBpZD0iUGF0aCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4xNzE2IDIuMzA3OUMxMi43MzA5IDIuODY2ODUgMTIuNzMwOSAzLjc3MzM1IDEyLjE3MTYgNC4zMzIzMUwxMS40NDg0IDUuMDU1NTJMOC45NDM2MyAyLjU1MDc5TDkuNjY2ODUgMS44Mjc1N0MxMC4yMjYxIDEuMjY4NDYgMTEuMTMyNiAxLjI2ODQ2IDExLjY5MTcgMS44Mjc1N0wxMi4xNzE2IDIuMzA3OVoiIGZpbGw9IiNCN0NGRkYiLz4KPHBhdGggaWQ9IlBhdGhfMiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjM5MTk4IDkuMTAyNDJMNC44OTY3MiAxMS42MDcyTDQuODczMzkgMTEuNjMwNUwxLjQwOTEgMTIuNTkwMkwyLjM2ODY1IDkuMTI1NzVMMi4zOTE5OCA5LjEwMjQyWiIgZmlsbD0iI0I3Q0ZGRiIvPgo8ZyBpZD0iR3JvdXAiPgo8ZyBpZD0iU2hhcGUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjk4MTEgMS41MzgzNEMxMS4yNjE2IDAuODIwNTU0IDEwLjA5NyAwLjgyMDU1NCA5LjM3NzY0IDEuNTM4MzRMMi4wNzk0NiA4LjgzNjUxQzIuMDI5NjEgOC44ODY1MyAxLjk5MzMzIDguOTQ4NTMgMS45NzQ0OCA5LjAxNjQ0TDEuMDE0OTMgMTIuNDgwOUMwLjk3NTQ1OSAxMi42MjI5IDEuMDE1NTcgMTIuNzc1MSAxLjExOTc1IDEyLjg3OTRDMS4yMjQwOSAxMi45ODM2IDEuMzc2MjIgMTMuMDIzNyAxLjUxODI3IDEyLjk4NDRMNC45ODI3MiAxMi4wMjQ3QzUuMDUwNzkgMTIuMDA1OCA1LjExMjk1IDExLjk2OTYgNS4xNjI5NyAxMS45MTk1TDUuMTg2MTQgMTEuODk2MkwxMi40NjA4IDQuNjIxNTJDMTMuMTc5NyAzLjkwMjc4IDEzLjE3OTcgMi43Mzc0MiAxMi40NjA4IDIuMDE4NjdMMTEuOTgxMSAxLjUzODM0Wk0yLjU4NTc4IDkuODc0NjlMNC4xMjQ0MiAxMS40MTM1TDEuOTk1OTkgMTIuMDAzMUwyLjU4NTc4IDkuODc0NjlaTTQuODk3MDEgMTEuNjA3VjExLjYwNzNMNS4xNjM3IDExLjg3MzdMNC44OTcwMSAxMS42MDdaTTQuODk3MDggMTEuMDI4OUwyLjk3MDYzIDkuMTAyNDFMOC45NDM2NSAzLjEyOTM5TDEwLjg2OTkgNS4wNTU1Mkw0Ljg5NzA4IDExLjAyODlaTTExLjQ0ODQgNC40NzcwN0wxMS44ODI0IDQuMDQzMDhDMTIuMjgxOSAzLjY0MzkyIDEyLjI4MTkgMi45OTY0NCAxMS44ODI0IDIuNTk3MjhMMTEuNDAyNCAyLjExNjc5QzExLjAwMjcgMS43MTgxMSAxMC4zNTU3IDEuNzE4MTEgOS45NTYyNSAyLjExNjc5TDkuNTIyMjUgMi41NTA3OEwxMS40NDg0IDQuNDc3MDdaIiBmaWxsPSIjMjE2OEYzIi8+CjxwYXRoIGQ9Ik05LjM3NzY0IDEuNTM4MzRMOS4yNzE2OSAxLjQzMjE2TDkuMjcxNTcgMS40MzIyN0w5LjM3NzY0IDEuNTM4MzRaTTExLjk4MTEgMS41MzgzNEwxMi4wODczIDEuNDMyMzRMMTIuMDg3MSAxLjQzMjE0TDExLjk4MTEgMS41MzgzNFpNMi4wNzk0NiA4LjgzNjUxTDEuOTczMzkgOC43MzA0NUwxLjk3MzIzIDguNzMwNjJMMi4wNzk0NiA4LjgzNjUxWk0xLjk3NDQ4IDkuMDE2NDRMMS44Mjk5NSA4Ljk3NjMxTDEuODI5OTIgOC45NzY0TDEuOTc0NDggOS4wMTY0NFpNMS4wMTQ5MyAxMi40ODA5TDEuMTU5NDUgMTIuNTIxTDEuMTU5NDggMTIuNTIwOUwxLjAxNDkzIDEyLjQ4MDlaTTEuMTE5NzUgMTIuODc5NEwxLjAxMzYgMTIuOTg1NEwxLjAxMzc3IDEyLjk4NTZMMS4xMTk3NSAxMi44Nzk0Wk0xLjUxODI3IDEyLjk4NDRMMS41NTgyOCAxMy4xMjlMMS41NTgzMiAxMy4xMjg5TDEuNTE4MjcgMTIuOTg0NFpNNC45ODI3MiAxMi4wMjQ3TDQuOTQyNjggMTEuODgwMUg0Ljk0MjY4TDQuOTgyNzIgMTIuMDI0N1pNNS4xNjI5NyAxMS45MTk1TDUuMjY5MDMgMTIuMDI1Nkw1LjI2OTQgMTIuMDI1Mkw1LjE2Mjk3IDExLjkxOTVaTTUuMTg2MTQgMTEuODk2Mkw1LjA4MDA3IDExLjc5MDFMNS4wNzk3IDExLjc5MDVMNS4xODYxNCAxMS44OTYyWk0xMi40NjA4IDQuNjIxNTJMMTIuMzU0OCA0LjUxNTQ1TDEyLjM1NDggNC41MTU0NkwxMi40NjA4IDQuNjIxNTJaTTEyLjQ2MDggMi4wMTg2N0wxMi4zNTQ3IDIuMTI0NjdMMTIuMzU0OCAyLjEyNDc1TDEyLjQ2MDggMi4wMTg2N1pNNC4xMjQ0MiAxMS40MTM1TDQuMTY0NDYgMTEuNTU4TDQuNDEyNCAxMS40ODk0TDQuMjMwNDkgMTEuMzA3NEw0LjEyNDQyIDExLjQxMzVaTTIuNTg1NzggOS44NzQ2OUwyLjY5MTg1IDkuNzY4NjNMMi41MDk5MyA5LjU4NjY5TDIuNDQxMjMgOS44MzQ2M0wyLjU4NTc4IDkuODc0NjlaTTEuOTk1OTkgMTIuMDAzMUwxLjg1MTQ0IDExLjk2MzFMMS43ODA2OCAxMi4yMTg0TDIuMDM2MDMgMTIuMTQ3N0wxLjk5NTk5IDEyLjAwMzFaTTQuODk3MDEgMTEuNjA3M0g0Ljc0NzAxVjExLjY2OTVMNC43OTEgMTEuNzEzNEw0Ljg5NzAxIDExLjYwNzNaTTQuODk3MDEgMTEuNjA3TDUuMDAzMDcgMTEuNTAwOUw0Ljc0NzAxIDExLjI0NDlWMTEuNjA3SDQuODk3MDFaTTUuMTYzNyAxMS44NzM3TDUuMDU3NyAxMS45Nzk4TDUuMjY5NzcgMTEuNzY3Nkw1LjE2MzcgMTEuODczN1pNMi45NzA2MyA5LjEwMjQxTDIuODY0NTcgOC45OTYzNEwyLjc1ODUgOS4xMDI0MUwyLjg2NDU3IDkuMjA4NDdMMi45NzA2MyA5LjEwMjQxWk00Ljg5NzA4IDExLjAyODlMNC43OTEwMiAxMS4xMzQ5TDQuODk3MDkgMTEuMjQxTDUuMDAzMTUgMTEuMTM0OUw0Ljg5NzA4IDExLjAyODlaTTguOTQzNjUgMy4xMjkzOUw5LjA0OTcyIDMuMDIzMzJMOC45NDM2NSAyLjkxNzI2TDguODM3NTkgMy4wMjMzMkw4Ljk0MzY1IDMuMTI5MzlaTTEwLjg2OTkgNS4wNTU1MkwxMC45NzYgNS4xNjE1OEwxMS4wODIxIDUuMDU1NTFMMTAuOTc2IDQuOTQ5NDVMMTAuODY5OSA1LjA1NTUyWk0xMS44ODI0IDQuMDQzMDhMMTEuNzc2NCAzLjkzNjk3TDExLjc3NjMgMy45MzcwMUwxMS44ODI0IDQuMDQzMDhaTTExLjQ0ODQgNC40NzcwN0wxMS4zNDIzIDQuNTgzMTNMMTEuNDQ4NCA0LjY4OTIxTDExLjU1NDQgNC41ODMxNEwxMS40NDg0IDQuNDc3MDdaTTExLjg4MjQgMi41OTcyOEwxMS43NzYzIDIuNzAzMjlMMTEuNzc2NCAyLjcwMzM5TDExLjg4MjQgMi41OTcyOFpNMTEuNDAyNCAyLjExNjc5TDExLjUwODUgMi4wMTA3N0wxMS41MDgzIDIuMDEwNTlMMTEuNDAyNCAyLjExNjc5Wk05Ljk1NjI1IDIuMTE2NzlMOS44NTAyOSAyLjAxMDYxTDkuODUwMTggMi4wMTA3Mkw5Ljk1NjI1IDIuMTE2NzlaTTkuNTIyMjUgMi41NTA3OEw5LjQxNjE5IDIuNDQ0NzFMOS4zMTAxMiAyLjU1MDc4TDkuNDE2MTggMi42NTY4NEw5LjUyMjI1IDIuNTUwNzhaTTkuNDgzNTkgMS42NDQ1MkMxMC4xNDQ0IDAuOTg1MTY2IDExLjIxNDIgMC45ODUxNDkgMTEuODc1MiAxLjY0NDUzTDEyLjA4NzEgMS40MzIxNEMxMS4zMDkgMC42NTU5NTkgMTAuMDQ5NiAwLjY1NTk0MiA5LjI3MTY5IDEuNDMyMTZMOS40ODM1OSAxLjY0NDUyWk0yLjE4NTUzIDguOTQyNThMOS40ODM3IDEuNjQ0NDFMOS4yNzE1NyAxLjQzMjI3TDEuOTczMzkgOC43MzA0NUwyLjE4NTUzIDguOTQyNThaTTIuMTE5MDEgOS4wNTY1N0MyLjEzMDkgOS4wMTM3NCAyLjE1Mzg4IDguOTc0MzMgMi4xODU3IDguOTQyNDFMMS45NzMyMyA4LjczMDYyQzEuOTA1MzMgOC43OTg3MyAxLjg1NTc2IDguODgzMzIgMS44Mjk5NSA4Ljk3NjMxTDIuMTE5MDEgOS4wNTY1N1pNMS4xNTk0OCAxMi41MjA5TDIuMTE5MDQgOS4wNTY0OEwxLjgyOTkyIDguOTc2NEwwLjg3MDM3IDEyLjQ0MDlMMS4xNTk0OCAxMi41MjA5Wk0xLjIyNTkgMTIuNzczNEMxLjE1OTgxIDEyLjcwNzIgMS4xMzQ0OSAxMi42MTA5IDEuMTU5NDUgMTIuNTIxTDAuODcwNDAyIDEyLjQ0MDdDMC44MTY0MzIgMTIuNjM1IDAuODcxMzI1IDEyLjg0MjkgMS4wMTM2IDEyLjk4NTRMMS4yMjU5IDEyLjc3MzRaTTEuNDc4MjcgMTIuODM5OEMxLjM4ODMxIDEyLjg2NDcgMS4yOTE5MyAxMi44Mzk0IDEuMjI1NzQgMTIuNzczM0wxLjAxMzc3IDEyLjk4NTZDMS4xNTYyNiAxMy4xMjc4IDEuMzY0MTIgMTMuMTgyNyAxLjU1ODI4IDEzLjEyOUwxLjQ3ODI3IDEyLjgzOThaTTQuOTQyNjggMTEuODgwMUwxLjQ3ODIzIDEyLjgzOThMMS41NTgzMiAxMy4xMjg5TDUuMDIyNzYgMTIuMTY5Mkw0Ljk0MjY4IDExLjg4MDFaTTUuMDU2OSAxMS44MTM1QzUuMDI1MTYgMTEuODQ1MiA0Ljk4NTczIDExLjg2ODIgNC45NDI2OCAxMS44ODAxTDUuMDIyNzYgMTIuMTY5MkM1LjExNTg2IDEyLjE0MzUgNS4yMDA3NSAxMi4wOTM5IDUuMjY5MDMgMTIuMDI1Nkw1LjA1NjkgMTEuODEzNVpNNS4wNzk3IDExLjc5MDVMNS4wNTY1MyAxMS44MTM4TDUuMjY5NCAxMi4wMjUyTDUuMjkyNTcgMTIuMDAxOUw1LjA3OTcgMTEuNzkwNVpNMTIuMzU0OCA0LjUxNTQ2TDUuMDgwMDcgMTEuNzkwMUw1LjI5MjIgMTIuMDAyM0wxMi41NjY5IDQuNzI3NTlMMTIuMzU0OCA0LjUxNTQ2Wk0xMi4zNTQ4IDIuMTI0NzVDMTMuMDE1MSAyLjc4NDkxIDEzLjAxNTEgMy44NTUyOCAxMi4zNTQ4IDQuNTE1NDVMMTIuNTY2OSA0LjcyNzZDMTMuMzQ0NCAzLjk1MDI4IDEzLjM0NDQgMi42ODk5MiAxMi41NjY5IDEuOTEyNkwxMi4zNTQ4IDIuMTI0NzVaTTExLjg3NSAxLjY0NDMzTDEyLjM1NDcgMi4xMjQ2N0wxMi41NjcgMS45MTI2OEwxMi4wODczIDEuNDMyMzRMMTEuODc1IDEuNjQ0MzNaTTQuMjMwNDkgMTEuMzA3NEwyLjY5MTg1IDkuNzY4NjNMMi40Nzk3MSA5Ljk4MDc1TDQuMDE4MzUgMTEuNTE5NUw0LjIzMDQ5IDExLjMwNzRaTTIuMDM2MDMgMTIuMTQ3N0w0LjE2NDQ2IDExLjU1OEw0LjA4NDM3IDExLjI2ODlMMS45NTU5NCAxMS44NTg2TDIuMDM2MDMgMTIuMTQ3N1pNMi40NDEyMyA5LjgzNDYzTDEuODUxNDQgMTEuOTYzMUwyLjE0MDU0IDEyLjA0MzJMMi43MzAzMyA5LjkxNDc1TDIuNDQxMjMgOS44MzQ2M1pNNS4wNDcwMSAxMS42MDczVjExLjYwN0g0Ljc0NzAxVjExLjYwNzNINS4wNDcwMVpNNS4yNjk3IDExLjc2NzVMNS4wMDMwMSAxMS41MDEyTDQuNzkxIDExLjcxMzRMNS4wNTc3IDExLjk3OThMNS4yNjk3IDExLjc2NzVaTTQuNzkwOTQgMTEuNzEzMUw1LjA1NzYzIDExLjk3OTdMNS4yNjk3NyAxMS43Njc2TDUuMDAzMDcgMTEuNTAwOUw0Ljc5MDk0IDExLjcxMzFaTTIuODY0NTcgOS4yMDg0N0w0Ljc5MTAyIDExLjEzNDlMNS4wMDMxNSAxMC45MjI4TDMuMDc2NyA4Ljk5NjM0TDIuODY0NTcgOS4yMDg0N1pNOC44Mzc1OSAzLjAyMzMyTDIuODY0NTcgOC45OTYzNEwzLjA3NjcgOS4yMDg0N0w5LjA0OTcyIDMuMjM1NDVMOC44Mzc1OSAzLjAyMzMyWk0xMC45NzYgNC45NDk0NUw5LjA0OTcyIDMuMDIzMzJMOC44Mzc1OSAzLjIzNTQ2TDEwLjc2MzkgNS4xNjE1OUwxMC45NzYgNC45NDk0NVpNNS4wMDMxNSAxMS4xMzQ5TDEwLjk3NiA1LjE2MTU4TDEwLjc2MzkgNC45NDk0Nkw0Ljc5MTAxIDEwLjkyMjhMNS4wMDMxNSAxMS4xMzQ5Wk0xMS43NzYzIDMuOTM3MDFMMTEuMzQyMyA0LjM3MTAxTDExLjU1NDQgNC41ODMxNEwxMS45ODg0IDQuMTQ5MTRMMTEuNzc2MyAzLjkzNzAxWk0xMS43NzY0IDIuNzAzMzlDMTIuMTE3MiAzLjA0Mzk2IDEyLjExNzIgMy41OTY0IDExLjc3NjQgMy45MzY5N0wxMS45ODg0IDQuMTQ5MTlDMTIuNDQ2NSAzLjY5MTQ0IDEyLjQ0NjUgMi45NDg5MiAxMS45ODg0IDIuNDkxMTdMMTEuNzc2NCAyLjcwMzM5Wk0xMS4yOTYyIDIuMjIyOEwxMS43NzYzIDIuNzAzMjlMMTEuOTg4NSAyLjQ5MTI3TDExLjUwODUgMi4wMTA3N0wxMS4yOTYyIDIuMjIyOFpNMTAuMDYyMiAyLjIyMjk2QzEwLjQwMzEgMS44ODI3MyAxMC45NTUzIDEuODgyNyAxMS4yOTY0IDIuMjIyOThMMTEuNTA4MyAyLjAxMDU5QzExLjA1MDEgMS41NTM1MSAxMC4zMDgzIDEuNTUzNDggOS44NTAyOSAyLjAxMDYxTDEwLjA2MjIgMi4yMjI5NlpNOS42MjgzMiAyLjY1Njg1TDEwLjA2MjMgMi4yMjI4NUw5Ljg1MDE4IDIuMDEwNzJMOS40MTYxOSAyLjQ0NDcxTDkuNjI4MzIgMi42NTY4NVpNMTEuNTU0NSA0LjM3MTAxTDkuNjI4MzIgMi40NDQ3Mkw5LjQxNjE4IDIuNjU2ODRMMTEuMzQyMyA0LjU4MzEzTDExLjU1NDUgNC4zNzEwMVoiIGZpbGw9IiMyMTY4RjMiLz4KPC9nPgo8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "3X9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":_vm.transition.enter,"leave-active-class":_vm.transition.leave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"snackbar",class:[_vm.type,_vm.position, _vm.request.isFamilyDoctor ? 'family-doctor' : ''],attrs:{"id":_vm.elementId}},[(_vm.request.isFamilyDoctor && _vm.request.status === 'unicasted')?_c('span',{staticClass:"pl-2 w-8"},[_c('img',{attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})]):_vm._e(),_vm._v(" "),(_vm.request.isFamilyDoctor && _vm.request.status === 'queried')?_c('span',{staticClass:"pl-2 w-8"},[_c('img',{attrs:{"src":__webpack_require__("xf//"),"alt":"Personal Patient"}})]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text text-sm"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.actionText)?_c('div',{staticClass:"action flex flex-row",class:_vm.type},[_c('div',[(_vm.request.isFamilyDoctor && _vm.request.status === 'unicasted')?_c('button',{staticClass:"button is-green",on:{"click":_vm.action}},[_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.actionText))])]):(_vm.request.isFamilyDoctor && _vm.request.status === 'queried')?_c('button',{staticClass:"button is-red",on:{"click":_vm.action}},[_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.actionText))])]):(!_vm.request.isFamilyDoctor)?_c('button',{staticClass:"button is-dark",on:{"click":_vm.action}},[_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.actionText))])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button is-dark",on:{"click":this.close}},[_c('img',{staticClass:"w-3",attrs:{"src":__webpack_require__("TpOy")}})])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Yb5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Zfj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSI0NSIgdmlld0JveD0iMCAwIDQ1IDQ1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIuNSIgY3k9IjIyLjUiIHI9IjIyLjUiIGZpbGw9IiNFNUY4RUUiLz4KICAgICAgICA8ZyBmaWxsPSIjMUI3MDQyIiBzdHJva2U9IiMxQjcwNDIiIHN0cm9rZS13aWR0aD0iMS4yIj4KICAgICAgICAgICAgPHBhdGggZD0iTTIzLjUgMTAuOGMyLjEgMCAzLjggMS43IDMuOCAzLjggMCAyLjEtMS43IDMuOC0zLjggMy44LTIuMSAwLTMuOC0xLjctMy44LTMuOC4xLTIuMiAxLjctMy44IDMuOC0zLjh6TTE5IDIwLjhjLTIuMyAwLTQuMiAxLjktNC4yIDQuMnY0YzAgLjcuNSAxLjIgMS4yIDEuMmgxNGMuNyAwIDEuMi0uNSAxLjItMS4ydi00YzAtMi4zLTEuOS00LjItNC4yLTQuMmgtOHoiLz4KICAgICAgICA8L2c+CiAgICAgICAgPHBhdGggZmlsbD0iI0U1RjhFRSIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMjUuNjQ3IDI3LjU1OGgxLjk4M2MxLjU2NyAwIDIuNTczLjg5IDIuNTczIDIuMjg4IDAgMS40MzMtMS4wMjEgMi41OTYtMi41NzMgMi41OTZoLTEuOTgzdjIuMDJjMCAxLjM5Ny0xLjAwNiAyLjI4OC0yLjU3MiAyLjI4OC0xLjMyOCAwLTIuMjctLjk1My0yLjI3LTIuMjg4di0yLjAyaC0xLjk4M2MtMS40MjIgMC0yLjU3Mi0xLjAzNS0yLjU3Mi0yLjU5NiAwLTEuNjIuODgtMi4yODggMi41NzItMi4yODhoMS45ODR2LTIuMDJjMC0xLjMzNS45NDEtMi4yODggMi4yNjktMi4yODggMS4zNTYgMCAyLjU3Mi45NTggMi41NzIgMi4yODh2Mi4wMnoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMUI3MDQyIiBkPSJNMjguNDUzIDI5Ljg3MmMwIC43NjktLjUxIDEuNTM4LTEuNTMgMS41MzhIMjQuNjN2Mi4zMDhjMCAuNzctLjUxIDEuMjgyLTEuNTMgMS4yODItLjc2NSAwLTEuMjc1LS41MTMtMS4yNzUtMS4yODJWMzEuNDFIMTkuNTNjLS43NjUgMC0xLjUzLS41MTMtMS41My0xLjUzOCAwLTEuMDI2LjUxLTEuMjgyIDEuNTMtMS4yODJoMi4yOTR2LTIuMzA4YzAtLjc3LjUxLTEuMjgyIDEuMjc1LTEuMjgyLjc2NSAwIDEuNTMuNTEzIDEuNTMgMS4yODJ2Mi4zMDhoMi4yOTRjMS4wMiAwIDEuNTMuNTEzIDEuNTMgMS4yODJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "3f2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      summary: true
    };
  },

  props: {
    activity: Object,
    showHraAndTests: Boolean,
    week: String,
    itemPosition: String,
    startDate: String,
    currentWeek: String
  },
  computed: {
    overdueDays: function overdueDays() {
      var startDate = new Date(this.startDate);
      var date = new Date();
      var diffTime = date.getTime() - startDate.getTime();
      var diffDays = diffTime / (1000 * 3600 * 24);
      return Math.floor(diffDays);
    },
    statusIcon: function statusIcon() {
      if (this.activity.status === 'overdue') return __webpack_require__("Br3c");
      if (this.activity.status === 'pending' || this.activity.status === 'scheduled') return __webpack_require__("MCWQ");
      if (this.activity.status === 'completed') return __webpack_require__("j/3f");
      if (this.activity.status === 'new') return __webpack_require__("lXhI");
    },
    showArrowIcon: function showArrowIcon() {
      if (['Consultation', 'Challenge'].includes(this.activity.type)) return false;
      if (['completed', 'pending'].includes(this.activity.status)) return true;
    }
  },
  methods: {
    statusText: function statusText() {
      var _activity = this.activity,
          status = _activity.status,
          type = _activity.type;

      if (status === 'new') return this.activity.type === 'Challenge' ? 'Not yet started' : 'Not yet taken';
      if (status === 'scheduled') return this.activity.type + ' has been scheduled';
      if (type === 'Appointment') {
        var datePresent = this.activity.documents[0];
        return status === 'completed' && datePresent ? 'Reports Generated on ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.activity.documents[0].date).format('Do, MMM YYYY') : 'Test completed, reports pending';
      }
      if (status === 'overdue') return this.activity.type + ' is overdue';
      if (type === 'HRA') {
        return 'Taken on ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.activity.hra_date).format('Do, MMM YYYY');
      }
      if (type === 'Consultation') return this.activity.summary;
    },
    toggleView: function toggleView() {
      if (['HRA', 'Appointment'].includes(this.activity.type)) {
        this.$emit('toggleView', this.activity.type, this.week);
      }
    }
  }
});

/***/ }),

/***/ "3fn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_OfflineConsultations_ActiveOfflineConsultations__ = __webpack_require__("2HGq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_OfflineConsultations_PastOfflineConsultations_vue__ = __webpack_require__("lY5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_OfflineConsultations_SearchModal__ = __webpack_require__("ywm7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ActiveConsultations: __WEBPACK_IMPORTED_MODULE_2__components_OfflineConsultations_ActiveOfflineConsultations__["a" /* default */],
    PastConsultations: __WEBPACK_IMPORTED_MODULE_3__components_OfflineConsultations_PastOfflineConsultations_vue__["a" /* default */],
    SearchModal: __WEBPACK_IMPORTED_MODULE_5__components_OfflineConsultations_SearchModal__["a" /* default */],
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_4__components_common_modals_UnsavedChanges__["a" /* default */]
  },
  data: function data() {
    return {
      search: { email: '', first_name: '', last_name: '', mobile_number: '', employee_id: '' },
      patients: [],
      selectedTab: 'connected',
      showSaveReminder: false,
      query: '',
      showSearchModal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    searchResult: 'offlineConsultation/searchResult',
    activeSection: 'configuration/getActiveSection',
    role: 'configuration/getRole'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activeOfflineConsults: function activeOfflineConsults(state) {
      return state.offlineConsultation.activeOfflineConsults;
    },
    pastOfflineConsults: function pastOfflineConsults(state) {
      return state.pastOfflineConsultation.pastOfflineConsults;
    },
    totalPastConsults: function totalPastConsults(state) {
      return state.pastOfflineConsultation.totalPastConsults;
    },
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    }
  })),
  methods: {
    openSearch: function openSearch(e) {
      this.showSearchModal = true;
      e.target.blur();
    },
    closeSearchModal: function closeSearchModal() {
      this.showSearchModal = false;
    },
    addNewCustomer: function addNewCustomer(customer) {
      this.$store.dispatch('offlineConsultation/addNewCustomer', customer);
      this.$emit('tabChange', 'consultation-summary');
    },
    setActiveSection: function setActiveSection(section) {
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      this.selectedTab = section;
      this.$store.dispatch('configuration/setOfflineActiveSection', section);
    },
    closeModal: function closeModal(params) {
      this.showSaveReminder = false;
    }
  }
});

/***/ }),

/***/ "3s5J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4/zo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(_ref) {
    var key = _ref.key,
        query = _ref.query;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/company_patients?term=' + query + '&key=' + key);
  },
  search_customer: function search_customer(query) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/search_customers', { customer: query });
  },
  uploadDocument: function uploadDocument(formData) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/customer/documents', formData, {
      progress: function progress(e) {
        if (e.lengthComputable) {
          // let progress = e.loaded / e.total * 100
          // this.dispatch('configuration/updateUploadProgress', progress)
        }
      }
    }).then(function (response) {
      if (response.body.status === 200) {
        var sendData = {
          url: response.body.file_url[0],
          type: 'document',
          fileIntent: 'file_attachment'
          // fileName: fileList[0].name,
          // channelID: channelID,
          // consultId: consultId
        };
        return sendData;
      } else {}
    }, function (response) {});
  },
  fetchSteps: function fetchSteps(customerId, fromDate, groupBy) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/steps?customer_id=' + customerId + '&from_date=' + fromDate + '&group_by=' + groupBy);
  }
});

/***/ }),

/***/ "49fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Appointments_vue__ = __webpack_require__("EqWT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ea0758_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Appointments_vue__ = __webpack_require__("umV2");
function injectStyle (ssrContext) {
  __webpack_require__("8eCR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41ea0758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Appointments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ea0758_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Appointments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4mdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  updateDoctorDetails: function updateDoctorDetails(formData) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/update', formData, {
      progress: function progress(e) {
        if (e.lengthComputable) {
          this.progress = e.loaded / e.total * 100;
        }
      }
    });
  },
  signout: function signout() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(window.API_URL + 'doctors/signout');
  },
  activityStatus: function activityStatus(status) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/activity_status', status);
  },
  getNotificatons: function getNotificatons() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/doctor_notifications');
  },
  updateViewed: function updateViewed(id) {
    var r = { last_viewed_id: id };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_notifications/update_viewed_all', r);
  },
  updateRead: function updateRead(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/doctor_notifications/' + id);
  },
  sendEnquiry: function sendEnquiry(_ref) {
    var id = _ref.id,
        message = _ref.message;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_notifications/' + id + '/enquire_now', { message: message });
  },
  customerUpdateViewed: function customerUpdateViewed(id) {
    var r = { last_viewed_id: id };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_notifications/update_viewed_specific_customer_related', r);
  }
});

/***/ }),

/***/ "53lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-start justify-between"},[_c('img',{staticClass:"bg-grey-extralight h-6 w-6 p-1 rounded-full mr-3",staticStyle:{"z-index":"2"},attrs:{"src":_vm.statusIcon}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-full font-semibold justify-center pl-5 pb-4",class:_vm.itemPosition === 'last' ? '' : 'border-l-2 border-dashed',staticStyle:{"margin-left":"-1.55rem","margin-top":"-1px"}},[_c('div',{staticClass:"flex flex-row text-base items-center justify-between",staticStyle:{"margin-top":"-0.215rem"}},[_c('div',{staticClass:"leading-loose"},[_vm._v(_vm._s(_vm.activity.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.activity.type === 'Challenge'),expression:"activity.type === 'Challenge'"}]},[_vm._v(" ("+_vm._s(_vm.activity.name)+")")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.activity.type === 'Consultation' && _vm.activity.prescription_url),expression:"activity.type === 'Consultation' && activity.prescription_url"}],staticClass:"text-blue hover:no-underline cursor-pointer",attrs:{"target":"_blank","href":_vm.activity.prescription_url}},[_vm._v("Prescription")])]),_vm._v(" "),_c('div',[(_vm.activity.type === 'Consultation')?_c('div',{staticClass:"text-sm text-grey",class:_vm.summary ? 'summary' : '',domProps:{"innerHTML":_vm._s(_vm.statusText())}}):_c('div',{staticClass:"text-sm text-grey"},[_vm._v(_vm._s(_vm.statusText()))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activity.type === 'Challenge' && ['new', 'pending', 'completed'].includes(_vm.activity.status)),expression:"activity.type === 'Challenge' && ['new', 'pending', 'completed'].includes(activity.status)"}],staticClass:"text-sm text-grey leading-tight"},[(_vm.activity.status === 'completed')?_c('div',[_c('p',[_vm._v("Started the Challenge")]),_vm._v(" "),_c('ul',{staticStyle:{"margin-left":"-1rem"}},[_c('li',[_vm._v("Challenge progress: "+_vm._s(_vm.activity.progress))]),_vm._v(" "),_c('li',[_vm._v("Days Taken: "+_vm._s(_vm.activity.days_utilized)+" consecutive days")])])]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showArrowIcon),expression:"showArrowIcon"}],staticClass:"h-5 w-5 bg-grey-extralight rounded-full"},[_c('img',{staticClass:"h-3 m-1 cursor-pointer stroke-current text-grey-darkest",attrs:{"src":__webpack_require__("uPNi")},on:{"click":_vm.toggleView}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "57jN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



/* harmony default export */ __webpack_exports__["a"] = ({
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation/create', data);
  },
  updateSummary: function updateSummary(summary) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultations/summary', { summary_notes: summary });
  },
  getConsultation: function getConsultation(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation/' + id);
  },
  getMessages: function getMessages(consultationRequestId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/' + consultationRequestId + '/fetch-messages');
  },
  getAllPatientMessages: function getAllPatientMessages() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/fetch-all-patient-last-message');
  },
  createFollowUp: function createFollowUp(followUp) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_followup_reminders', followUp);
  },

  // fetchAvailableDoctors () {
  //   return Vue.http.get(window.API_URL + 'doctors/available-doctors', {doctors_ids: ably.getPresentMembers('doctors_channel')})
  // },

  transferToNewDoctor: function transferToNewDoctor(doctorId, consultationId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/transfer-to-doctor', {
      doctor_id: doctorId,
      consultation_id: consultationId
    });
  },
  uploadFile: function uploadFile(formData, file, channelId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/customer/documents', formData, {
      progress: function progress(e) {
        if (e.lengthComputable) {
          file.progress = parseInt(e.loaded / e.total * 100);
          file.state = 'uploading';
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('message/documentUploadProgress', { file: file, channelId: channelId });
        }
      }
    });
  },
  endConsultation: function endConsultation(requestId) {
    var credentials = {
      consultation_request_id: requestId,
      status: 'SUCCESS'
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_requests/end', credentials);
  },
  endOfflineConsultation: function endOfflineConsultation(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultations/end_chat', data);
  },
  getCustomerPastConsultation: function getCustomerPastConsultation(customerId, page, queries) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/customers/past_consults?page=' + page + '&customer_id=' + customerId + '&fetch_queries=' + queries);
  },
  updateOfflineConsultation: function updateOfflineConsultation(consultId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(window.API_URL + 'doctors/consultations/' + consultId + '/accept');
  },
  fetchMesaagesConsultation: function fetchMesaagesConsultation(consultationId, consultationRequestId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/customers/past_consults/fetch-messages?consultation_id=' + consultationId + '&consultation_request_id=' + consultationRequestId);
  },
  familyDoctorReplyToOfflineCustomer: function familyDoctorReplyToOfflineCustomer(messageId, consultationRequestId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + ('doctors/consultation_requests/' + consultationRequestId + '/query_reply'), { chat_message: { unique_id: messageId } });
  },
  doctorReplyToOfflineCustomer: function doctorReplyToOfflineCustomer(messageId, consultationRequestId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + ('doctors/consultation_requests/' + consultationRequestId + '/doctor_reply'), { chat_message: { unique_id: messageId } });
  }
});

/***/ }),

/***/ "5Ies":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTcyIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMTcyIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTcyIiBoZWlnaHQ9IjYwIiByeD0iMTAuMjMwNiIgZmlsbD0iIzAwNEE0NCIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDgxOF8zMjQ0KSI+CjxtYXNrIGlkPSJtYXNrMF80ODE4XzMyNDQiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIxNCIgeT0iMTQiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+CjxwYXRoIGQ9Ik0xNCAxNEg0NlY0NkgxNFYxNFoiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF80ODE4XzMyNDQpIj4KPHBhdGggZD0iTTMxLjcwMzYgMTQuOTM3NVYxNy40Mzc1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuODc1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDAuNDUzNiAxNC45Mzc1VjE3LjQzNzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS44NzUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPHBhdGggZD0iTTMzLjEzNjcgMzIuOTk0TDM2LjA3ODUgMzkuOTM3NUwzOS4wMjAzIDMyLjk5NCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjg3NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPG1hc2sgaWQ9Im1hc2sxXzQ4MThfMzI0NCIgc3R5bGU9Im1hc2stdHlwZTpsdW1pbmFuY2UiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjE0IiB5PSIxNCIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIj4KPHBhdGggZD0iTTE0IDE0SDQ2VjQ2SDE0VjE0WiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2sxXzQ4MThfMzI0NCkiPgo8cGF0aCBkPSJNNDAuNDUzNSAxNi4xODc1SDQxLjkzNTZDNDQuMDExOCAxNi4xODc1IDQ1LjUxMDcgMTguMTc0NyA0NC45NDA0IDIwLjE3MUw0Mi40NTIxIDI4Ljg3OTlDNDEuNjM5MSAzMS43MjU2IDM5LjAzODEgMzMuNjg3NSAzNi4wNzg1IDMzLjY4NzVDMzMuMTE4OSAzMy42ODc1IDMwLjUxNzkgMzEuNzI1NiAyOS43MDQ5IDI4Ljg3OTlMMjcuMjE2NiAyMC4xNzFDMjYuNjQ2MiAxOC4xNzQ3IDI4LjE0NTIgMTYuMTg3NSAzMC4yMjE0IDE2LjE4NzVIMzEuNzAzNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC42ODc1IDM2LjQzNzVWMzMuMzc1QzE4LjY4NzUgMzAuOTI0MyAyMC42NzQyIDI4LjkzNzUgMjMuMTI1IDI4LjkzNzVDMjUuNTc1NyAyOC45Mzc1IDI3LjU2MjUgMzAuOTI0MyAyNy41NjI1IDMzLjM3NVYzOS44MDQ1QzI3LjU2MjUgNDIuMTU2MSAyOS40Njg5IDQ0LjA2MjUgMzEuODIwNSA0NC4wNjI1QzM0LjE3MjEgNDQuMDYyNSAzNi4wNzg1IDQyLjE1NjEgMzYuMDc4NSAzOS44MDQ1VjM4LjkzNzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMi4zIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuOTM3NSA0MS4xODc1QzE0LjkzNzUgNDMuMjU4NiAxNi42MTY0IDQ0LjkzNzUgMTguNjg3NSA0NC45Mzc1QzIwLjc1ODYgNDQuOTM3NSAyMi40Mzc1IDQzLjI1ODYgMjIuNDM3NSA0MS4xODc1QzIyLjQzNzUgMzkuMTE2NCAyMC43NTg2IDM3LjQzNzUgMTguNjg3NSAzNy40Mzc1QzE2LjYxNjQgMzcuNDM3NSAxNC45Mzc1IDM5LjExNjQgMTQuOTM3NSA0MS4xODc1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyLjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy43NSA0MS4xODc1QzE3Ljc1IDQxLjcwNTMgMTguMTY5NyA0Mi4xMjUgMTguNjg3NSA0Mi4xMjVDMTkuMjA1MyA0Mi4xMjUgMTkuNjI1IDQxLjcwNTMgMTkuNjI1IDQxLjE4NzVDMTkuNjI1IDQwLjY2OTcgMTkuMjA1MyA0MC4yNSAxOC42ODc1IDQwLjI1QzE4LjE2OTcgNDAuMjUgMTcuNzUgNDAuNjY5NyAxNy43NSA0MS4xODc1WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L2c+CjxwYXRoIGQ9Ik02NS41Njc2IDM4LjI4OEM2My45MDM2IDM4LjI4OCA2Mi40MzE2IDM3LjkyIDYxLjE1MTYgMzcuMTg0QzU5Ljg4NzYgMzYuNDMyIDU4Ljg4NzYgMzUuNDA4IDU4LjE1MTYgMzQuMTEyQzU3LjQzMTYgMzIuOCA1Ny4wNzE2IDMxLjI5NiA1Ny4wNzE2IDI5LjZDNTcuMDcxNiAyNy45MDQgNTcuNDMxNiAyNi40MDggNTguMTUxNiAyNS4xMTJDNTguODg3NiAyMy44IDU5Ljg4NzYgMjIuNzc2IDYxLjE1MTYgMjIuMDRDNjIuNDMxNiAyMS4yODggNjMuOTAzNiAyMC45MTIgNjUuNTY3NiAyMC45MTJDNjYuNzgzNiAyMC45MTIgNjcuODk1NiAyMS4xMjggNjguOTAzNiAyMS41NkM2OS45Mjc2IDIxLjk3NiA3MC44MDc2IDIyLjU2OCA3MS41NDM2IDIzLjMzNkM3Mi4yOTU2IDI0LjEwNCA3Mi44NzE2IDI0Ljk5MiA3My4yNzE2IDI2TDY5LjY0NzYgMjcuMjI0QzY5LjQwNzYgMjYuNjY0IDY5LjA3OTYgMjYuMTc2IDY4LjY2MzYgMjUuNzZDNjguMjYzNiAyNS4zNDQgNjcuNzk5NiAyNS4wMjQgNjcuMjcxNiAyNC44QzY2Ljc1OTYgMjQuNTc2IDY2LjE5MTYgMjQuNDY0IDY1LjU2NzYgMjQuNDY0QzY0LjY4NzYgMjQuNDY0IDYzLjkwMzYgMjQuNjggNjMuMjE1NiAyNS4xMTJDNjIuNTI3NiAyNS41NDQgNjEuOTkxNiAyNi4xNTIgNjEuNjA3NiAyNi45MzZDNjEuMjIzNiAyNy43MDQgNjEuMDMxNiAyOC41OTIgNjEuMDMxNiAyOS42QzYxLjAzMTYgMzAuNjA4IDYxLjIyMzYgMzEuNTA0IDYxLjYwNzYgMzIuMjg4QzYyLjAwNzYgMzMuMDU2IDYyLjU1MTYgMzMuNjY0IDYzLjIzOTYgMzQuMTEyQzYzLjk0MzYgMzQuNTQ0IDY0Ljc0MzYgMzQuNzYgNjUuNjM5NiAzNC43NkM2Ni4yOTU2IDM0Ljc2IDY2Ljg3OTYgMzQuNjQgNjcuMzkxNiAzNC40QzY3LjkwMzYgMzQuMTYgNjguMzQzNiAzMy44MjQgNjguNzExNiAzMy4zOTJDNjkuMDk1NiAzMi45NiA2OS40MjM2IDMyLjQ2NCA2OS42OTU2IDMxLjkwNEw3My4zMTk2IDMzLjEyOEM3Mi45MzU2IDM0LjE1MiA3Mi4zNjc2IDM1LjA1NiA3MS42MTU2IDM1Ljg0QzcwLjg2MzYgMzYuNjA4IDY5Ljk3NTYgMzcuMjA4IDY4Ljk1MTYgMzcuNjRDNjcuOTI3NiAzOC4wNzIgNjYuNzk5NiAzOC4yODggNjUuNTY3NiAzOC4yODhaTTgyLjc4OTEgMzhMODIuNTczMSAzNS43OTJWMjZIODYuMzE3MVYzOEg4Mi43ODkxWk03NC44NDUxIDMyLjE0NFYyNkg3OC41ODkxVjMyLjE0NEg3NC44NDUxWk03OC41ODkxIDMyLjE0NEM3OC41ODkxIDMyLjc2OCA3OC42NjExIDMzLjI3MiA3OC44MDUxIDMzLjY1NkM3OC45NDkxIDM0LjA0IDc5LjE1NzEgMzQuMzIgNzkuNDI5MSAzNC40OTZDNzkuNzAxMSAzNC42NzIgODAuMDIxMSAzNC43NjggODAuMzg5MSAzNC43ODRDODEuMTA5MSAzNC43ODQgODEuNjUzMSAzNC41ODQgODIuMDIxMSAzNC4xODRDODIuMzg5MSAzMy43NjggODIuNTczMSAzMy4xNTIgODIuNTczMSAzMi4zMzZIODMuNzAxMUM4My43MDExIDMzLjYgODMuNTA5MSAzNC42OCA4My4xMjUxIDM1LjU3NkM4Mi43NDExIDM2LjQ1NiA4Mi4yMTMxIDM3LjEyOCA4MS41NDExIDM3LjU5MkM4MC44ODUxIDM4LjA1NiA4MC4xMTcxIDM4LjI4OCA3OS4yMzcxIDM4LjI4OEM3OC4yNzcxIDM4LjI4OCA3Ny40NjkxIDM4LjA5NiA3Ni44MTMxIDM3LjcxMkM3Ni4xNTcxIDM3LjMxMiA3NS42NjExIDM2LjcxMiA3NS4zMjUxIDM1LjkxMkM3NS4wMDUxIDM1LjExMiA3NC44NDUxIDM0LjA4OCA3NC44NDUxIDMyLjg0VjMyLjE0NEg3OC41ODkxWk05MS41MzA5IDMxLjc4NEM5MS41MzA5IDMwLjQ4OCA5MS43ODY5IDI5LjQwOCA5Mi4yOTg5IDI4LjU0NEM5Mi44MjY5IDI3LjY4IDkzLjQ4MjkgMjcuMDMyIDk0LjI2NjkgMjYuNkM5NS4wNjY5IDI2LjE2OCA5NS44OTg5IDI1Ljk1MiA5Ni43NjI5IDI1Ljk1MlYyOS42Qzk2LjAyNjkgMjkuNiA5NS4zMzA5IDI5LjY4IDk0LjY3NDkgMjkuODRDOTQuMDM0OSAzMCA5My41MTQ5IDMwLjI0OCA5My4xMTQ5IDMwLjU4NEM5Mi43MTQ5IDMwLjkwNCA5Mi41MTQ5IDMxLjMyIDkyLjUxNDkgMzEuODMyTDkxLjUzMDkgMzEuNzg0Wk04OC43NzA5IDM4VjI2SDkyLjUxNDlWMzhIODguNzcwOVpNMTA1LjQ2MSAzOEwxMDUuMzY1IDM1LjQwOFYzMi4wMjRDMTA1LjM2NSAzMS4zODQgMTA1LjMwOSAzMC44MjQgMTA1LjE5NyAzMC4zNDRDMTA1LjA4NSAyOS44NjQgMTA0Ljg4NSAyOS40ODggMTA0LjU5NyAyOS4yMTZDMTA0LjMwOSAyOC45NDQgMTAzLjg3NyAyOC44MDggMTAzLjMwMSAyOC44MDhDMTAyLjg1MyAyOC44MDggMTAyLjQ2MSAyOC45MTIgMTAyLjEyNSAyOS4xMkMxMDEuNzg5IDI5LjMyOCAxMDEuNTAxIDI5LjYxNiAxMDEuMjYxIDI5Ljk4NEw5Ny45OTc0IDI4LjkwNEM5OC4yNjk0IDI4LjMxMiA5OC42Mzc0IDI3Ljc3NiA5OS4xMDE0IDI3LjI5NkM5OS41ODE0IDI2LjgxNiAxMDAuMTY1IDI2LjQzMiAxMDAuODUzIDI2LjE0NEMxMDEuNTQxIDI1Ljg1NiAxMDIuMzQxIDI1LjcxMiAxMDMuMjUzIDI1LjcxMkMxMDQuNTAxIDI1LjcxMiAxMDUuNTU3IDI1Ljk0NCAxMDYuNDIxIDI2LjQwOEMxMDcuMjg1IDI2Ljg3MiAxMDcuOTMzIDI3LjUyIDEwOC4zNjUgMjguMzUyQzEwOC43OTcgMjkuMTg0IDEwOS4wMTMgMzAuMTY4IDEwOS4wMTMgMzEuMzA0TDEwOC45NjUgMzhIMTA1LjQ2MVpNMTAyLjE5NyAzOC4yODhDMTAwLjc3MyAzOC4yODggOTkuNjY5NCAzNy45NjggOTguODg1NCAzNy4zMjhDOTguMTAxNCAzNi42ODggOTcuNzA5NCAzNS43ODQgOTcuNzA5NCAzNC42MTZDOTcuNzA5NCAzMy4zNTIgOTguMTE3NCAzMi40MDggOTguOTMzNCAzMS43ODRDOTkuNzQ5NCAzMS4xNiAxMDAuODkzIDMwLjg0OCAxMDIuMzY1IDMwLjg0OEgxMDUuNjUzVjMzLjI0OEgxMDMuNzgxQzEwMi45ODEgMzMuMjQ4IDEwMi40MDUgMzMuMzYgMTAyLjA1MyAzMy41ODRDMTAxLjcwMSAzMy44MDggMTAxLjUyNSAzNC4xMiAxMDEuNTI1IDM0LjUyQzEwMS41MjUgMzQuODA4IDEwMS42NTMgMzUuMDQgMTAxLjkwOSAzNS4yMTZDMTAyLjE4MSAzNS4zNzYgMTAyLjU0OSAzNS40NTYgMTAzLjAxMyAzNS40NTZDMTAzLjQ3NyAzNS40NTYgMTAzLjg4NSAzNS4zNiAxMDQuMjM3IDM1LjE2OEMxMDQuNTg5IDM0Ljk2IDEwNC44NjEgMzQuNjg4IDEwNS4wNTMgMzQuMzUyQzEwNS4yNjEgMzQuMDE2IDEwNS4zNjUgMzMuNjQ4IDEwNS4zNjUgMzMuMjQ4SDEwNi4zMDFDMTA2LjMwMSAzNC44NDggMTA1Ljk2NSAzNi4wODggMTA1LjI5MyAzNi45NjhDMTA0LjYyMSAzNy44NDggMTAzLjU4OSAzOC4yODggMTAyLjE5NyAzOC4yODhaTTExNi45NjcgMzhWMjEuMkgxMjAuNzExVjM4SDExNi45NjdaTTEyNC42OTUgMzhWMzEuODU2SDEyOC40MzlWMzhIMTI0LjY5NVpNMTI0LjY5NSAzMS44NTZDMTI0LjY5NSAzMS4yMTYgMTI0LjYyMyAzMC43MTIgMTI0LjQ3OSAzMC4zNDRDMTI0LjMzNSAyOS45NiAxMjQuMTI3IDI5LjY4IDEyMy44NTUgMjkuNTA0QzEyMy41ODMgMjkuMzI4IDEyMy4yNjMgMjkuMjMyIDEyMi44OTUgMjkuMjE2QzEyMi4xNzUgMjkuMiAxMjEuNjMxIDI5LjQgMTIxLjI2MyAyOS44MTZDMTIwLjg5NSAzMC4yMTYgMTIwLjcxMSAzMC44MzIgMTIwLjcxMSAzMS42NjRIMTE5LjU4M0MxMTkuNTgzIDMwLjQgMTE5Ljc3NSAyOS4zMjggMTIwLjE1OSAyOC40NDhDMTIwLjU0MyAyNy41NTIgMTIxLjA2MyAyNi44NzIgMTIxLjcxOSAyNi40MDhDMTIyLjM5MSAyNS45NDQgMTIzLjE1OSAyNS43MTIgMTI0LjAyMyAyNS43MTJDMTI0Ljk5OSAyNS43MTIgMTI1LjgxNSAyNS45MTIgMTI2LjQ3MSAyNi4zMTJDMTI3LjEyNyAyNi42OTYgMTI3LjYxNSAyNy4yODggMTI3LjkzNSAyOC4wODhDMTI4LjI3MSAyOC44ODggMTI4LjQzOSAyOS45MTIgMTI4LjQzOSAzMS4xNlYzMS44NTZIMTI0LjY5NVpNMTM4LjUgMzhMMTM4LjI4NCAzNS43OTJWMjZIMTQyLjAyOFYzOEgxMzguNVpNMTMwLjU1NiAzMi4xNDRWMjZIMTM0LjNWMzIuMTQ0SDEzMC41NTZaTTEzNC4zIDMyLjE0NEMxMzQuMyAzMi43NjggMTM0LjM3MiAzMy4yNzIgMTM0LjUxNiAzMy42NTZDMTM0LjY2IDM0LjA0IDEzNC44NjggMzQuMzIgMTM1LjE0IDM0LjQ5NkMxMzUuNDEyIDM0LjY3MiAxMzUuNzMyIDM0Ljc2OCAxMzYuMSAzNC43ODRDMTM2LjgyIDM0Ljc4NCAxMzcuMzY0IDM0LjU4NCAxMzcuNzMyIDM0LjE4NEMxMzguMSAzMy43NjggMTM4LjI4NCAzMy4xNTIgMTM4LjI4NCAzMi4zMzZIMTM5LjQxMkMxMzkuNDEyIDMzLjYgMTM5LjIyIDM0LjY4IDEzOC44MzYgMzUuNTc2QzEzOC40NTIgMzYuNDU2IDEzNy45MjQgMzcuMTI4IDEzNy4yNTIgMzcuNTkyQzEzNi41OTYgMzguMDU2IDEzNS44MjggMzguMjg4IDEzNC45NDggMzguMjg4QzEzMy45ODggMzguMjg4IDEzMy4xOCAzOC4wOTYgMTMyLjUyNCAzNy43MTJDMTMxLjg2OCAzNy4zMTIgMTMxLjM3MiAzNi43MTIgMTMxLjAzNiAzNS45MTJDMTMwLjcxNiAzNS4xMTIgMTMwLjU1NiAzNC4wODggMTMwLjU1NiAzMi44NFYzMi4xNDRIMTM0LjNaTTE0NC40ODIgMzhWMjEuMkgxNDguMjI2VjM1Ljc2OEwxNDguMDM0IDM4SDE0NC40ODJaTTE1MS42MzQgMzguMjg4QzE1MC42NDIgMzguMjg4IDE0OS44MSAzOC4wNCAxNDkuMTM4IDM3LjU0NEMxNDguNDY2IDM3LjAzMiAxNDcuOTYyIDM2LjMwNCAxNDcuNjI2IDM1LjM2QzE0Ny4yOSAzNC40MTYgMTQ3LjEyMiAzMy4yOTYgMTQ3LjEyMiAzMkMxNDcuMTIyIDMwLjY4OCAxNDcuMjkgMjkuNTY4IDE0Ny42MjYgMjguNjRDMTQ3Ljk2MiAyNy42OTYgMTQ4LjQ2NiAyNi45NzYgMTQ5LjEzOCAyNi40OEMxNDkuODEgMjUuOTY4IDE1MC42NDIgMjUuNzEyIDE1MS42MzQgMjUuNzEyQzE1Mi43NTQgMjUuNzEyIDE1My43MjIgMjUuOTY4IDE1NC41MzggMjYuNDhDMTU1LjM1NCAyNi45NzYgMTU1Ljk3OCAyNy42OTYgMTU2LjQxIDI4LjY0QzE1Ni44NDIgMjkuNTY4IDE1Ny4wNTggMzAuNjg4IDE1Ny4wNTggMzJDMTU3LjA1OCAzMy4yOTYgMTU2Ljg0MiAzNC40MTYgMTU2LjQxIDM1LjM2QzE1NS45NzggMzYuMzA0IDE1NS4zNTQgMzcuMDMyIDE1NC41MzggMzcuNTQ0QzE1My43MjIgMzguMDQgMTUyLjc1NCAzOC4yODggMTUxLjYzNCAzOC4yODhaTTE1MC42NzQgMzQuODMyQzE1MS4xNTQgMzQuODMyIDE1MS41NzggMzQuNzEyIDE1MS45NDYgMzQuNDcyQzE1Mi4zMTQgMzQuMjMyIDE1Mi42MSAzMy45MDQgMTUyLjgzNCAzMy40ODhDMTUzLjA1OCAzMy4wNTYgMTUzLjE3IDMyLjU2IDE1My4xNyAzMkMxNTMuMTcgMzEuNDQgMTUzLjA2NiAzMC45NTIgMTUyLjg1OCAzMC41MzZDMTUyLjY1IDMwLjEwNCAxNTIuMzU0IDI5Ljc2OCAxNTEuOTcgMjkuNTI4QzE1MS42MDIgMjkuMjg4IDE1MS4xNzggMjkuMTY4IDE1MC42OTggMjkuMTY4QzE1MC4yMTggMjkuMTY4IDE0OS43ODYgMjkuMjg4IDE0OS40MDIgMjkuNTI4QzE0OS4wMzQgMjkuNzY4IDE0OC43NDYgMzAuMTA0IDE0OC41MzggMzAuNTM2QzE0OC4zMyAzMC45NjggMTQ4LjIyNiAzMS40NTYgMTQ4LjIyNiAzMkMxNDguMjI2IDMyLjU2IDE0OC4zMyAzMy4wNTYgMTQ4LjUzOCAzMy40ODhDMTQ4Ljc0NiAzMy45MDQgMTQ5LjAzNCAzNC4yMzIgMTQ5LjQwMiAzNC40NzJDMTQ5Ljc3IDM0LjcxMiAxNTAuMTk0IDM0LjgzMiAxNTAuNjc0IDM0LjgzMloiIGZpbGw9IndoaXRlIi8+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzQ4MThfMzI0NCI+CjxyZWN0IHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0IDE0KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ "5JOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5OtV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-64 bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest"},[(_vm.role !== 'specialistDoctor')?_c('div',{staticClass:"flex flex-col flex-no-shrink p-2 bg-grey-extralight"},[_c('input',{staticClass:"text-sm border border-grey-lightest rounded-m mb-1",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"placeholder":"Search Patient","type":"text"},on:{"click":function($event){return _vm.openSearch($event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex relative flex-col pt-1 flex-no-shrink flex-no-grow border-solid border-t border-grey-lightest"},[_c('div',{staticClass:"flex flex-row h-12 text-xs items-center"},[_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'connected' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('connected')}}},[_vm._v("Connected")]),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'consults' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('consults')}}},[_vm._v("Completed")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest"},[_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'connected' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'consults' ? 'bg-blue' : '']})]),_vm._v(" "),(_vm.activeOfflineConsults.length>0)?_c('div',{staticClass:"absolute text-xs bg-green text-white flex flex-row justify-center items-center",staticStyle:{"top":"0rem","left":"1.5rem","width":"2rem","height":"1rem","border-bottom-left-radius":"50%","border-bottom-right-radius":"50%"}},[_vm._v(" \n      "+_vm._s(_vm.activeOfflineConsults.length)+" \n    ")]):_vm._e(),_vm._v(" "),(_vm.pastOfflineConsults.length>0)?_c('div',{staticClass:"absolute text-xs bg-grey-lighter text-white flex flex-row justify-center items-center",staticStyle:{"top":"0rem","left":"7rem","width":"2rem","height":"1rem","border-bottom-left-radius":"50%","border-bottom-right-radius":"50%"}},[_vm._v("\n      "+_vm._s(_vm.totalPastConsults)+"\n    ")]):_vm._e()]),_vm._v(" "),(_vm.activeSection === 'connected')?_c('div',{staticClass:"overflow-auto"},[(_vm.activeOfflineConsults.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No Active Offline Consultations")])]):_c('active-consultations')],1):_vm._e(),_vm._v(" "),(_vm.activeSection === 'consults')?_c('div',{staticClass:"overflow-auto"},[(_vm.pastOfflineConsults.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No past offline consultations")])]):_c('past-consultations')],1):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e(),_vm._v(" "),(_vm.showSearchModal)?_c('SearchModal',{on:{"closeSearchModal":_vm.closeSearchModal,"addNewCustomer":_vm.addNewCustomer}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5SnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Toaster__ = __webpack_require__("bBuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_localforage__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_2__components_Navbar__["a" /* default */],
    Toaster: __WEBPACK_IMPORTED_MODULE_3__components_common_Toaster__["a" /* default */]
  },
  data: function data() {
    return {
      doctorprofile: { photo: {} },
      languages: '',
      files: [],
      signature: null,
      profile: null,
      isLoading: false,
      otp_code: '',
      backUpCodes: [],
      copyCodes: 'copy',
      showBackUpCodes: false,
      enableViaAuthApp: false,
      enableViaOtp: false,
      showQR: true,
      altCode: '34586253465943432FEWRWERWE324',
      qrCode: '',
      showQRText: "I Can't Scan the QR Code"
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    role: function role(state) {
      return state.configuration.role;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    doctor: 'configuration/doctor'
  })),
  methods: {
    goBack: function goBack() {
      this.enableViaAuthApp = false;
      this.enableViaOtp = false;
      this.showBackUpCodes = false;
      this.otp_code = '';
    },
    goBackToProfile: function goBackToProfile() {
      this.enableViaAuthApp = false;
      this.enableViaOtp = false;
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/profile');
    },
    viaAuthenticatorApp: function viaAuthenticatorApp() {
      var _this = this;

      this.enableViaAuthApp = true;
      this.isLoading = true;
      this.$http.get(window.API_URL + 'doctors/mfa_settings/mfa_qr_code').then(function (response) {
        if (response.status === 200) {
          _this.isLoading = false;
          _this.altCode = response.body.alternative_code;
          var qrCode = response.body.qr_code;
          _this.qrCode = 'data:image/svg+xml;base64,' + btoa(qrCode);
        }
      }).catch(function () {
        this.isLoading = false;
        this.$toast.open({
          message: 'Failed to generate QR-code',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    },
    viaOtp: function viaOtp() {
      var _this2 = this;

      this.enableViaOtp = true;
      this.isLoading = true;
      this.$http.get(window.API_URL + 'doctors/mfa_settings/mfa_otp_code').then(function (response) {
        if (response.status === 200) {
          _this2.isLoading = false;
          _this2.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          });
        }
      }).catch(function () {
        this.isLoading = false;
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        });
        this.enableViaOtp = false;
      });
    },
    configMfaSettings: function configMfaSettings() {
      var _this3 = this;

      this.isLoading = true;
      if (this.otp_code !== '') {
        this.$http.post(window.API_URL + 'doctors/mfa_settings/mfa_create', { otp_code: this.otp_code }).then(function (response) {
          _this3.enableViaAuthApp = false;
          _this3.enableViaOtp = false;
          _this3.showBackUpCodes = true;
          if (response.status === 200) {
            _this3.isLoading = false;
            _this3.backUpCodes = response.body.backup_codes;
            _this3.$toast.open({
              message: response.body.message,
              type: 'success',
              position: 'top',
              queue: false
            });
          }
        }).catch(function (error) {
          this.isLoading = false;
          this.$toast.open({
            message: error.body.message || 'Something went wrong!',
            type: 'error',
            position: 'top',
            queue: false
          });
        });
      }
    },
    showMfaQr: function showMfaQr() {
      if (this.showQR) {
        this.showQRText = 'Scan a QR Code';
      } else {
        this.showQRText = "I Can't Scan the QR Code";
      }
      this.showQR = !this.showQR;
    },
    copyCodesToClip: function copyCodesToClip() {
      var _this4 = this;

      this.copyCodes = 'copied!';
      var textToCopy = this.backUpCodes.join(', ');
      var tempTextarea = document.createElement('textarea');
      tempTextarea.value = textToCopy;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand('copy');
      this.$toast.open({
        message: 'Text copied to clipboard!',
        type: 'success',
        position: 'top',
        queue: false
      });
      document.body.removeChild(tempTextarea);
      setTimeout(function () {
        _this4.copyCodes = 'copy';
      }, 1500);
    },

    clearLocalForage: function clearLocalForage() {
      __WEBPACK_IMPORTED_MODULE_9_localforage___default.a.iterate(function (data, key, index) {
        if (index === 1) {
          return [key, data];
        }
      }).then(function (result) {
        var data = result[1];
        var i = data.length;
        while (i--) {
          var entryDate = new Date(data[i].created_at);
          var now = new Date();
          var diff = Math.abs(now - entryDate);
          var diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
          if (diffDays >= 3) {
            data.splice(i, 1);
          }
        }
        __WEBPACK_IMPORTED_MODULE_9_localforage___default.a.setItem('audits', data);
      });
    }
  },
  mounted: function mounted() {
    if (!sessionStorage.length) {
      // Ask other tabs for session storage
      localStorage.setItem('getSessionStorage', Date.now());
    }
    if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
      this.showAlreadyLogged = true;
      this.showLogin = false;
    } else {
      window.addEventListener('storage', function (event) {
        if (event.key === 'getSessionStorage') {
          // Some tab asked for the sessionStorage -> send it
          localStorage.setItem('sessionStorage', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sessionStorage));
          localStorage.removeItem('sessionStorage');
        } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
          // sessionStorage is empty -> fill it
          var data = JSON.parse(event.newValue);
          for (var key in data) {
            sessionStorage.setItem(key, data[key]);
          }
          if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
            this.showAlreadyLogged = true;
            this.showLogin = false;
          } else {
            this.showAlreadyLogged = false;
            this.showLogin = true;
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "5Whe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_vm._l((_vm.activeConsults),function(cp,index){return _c('div',{key:index,staticClass:"flex flex-col px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight",class:(cp.channelId === _vm.activeChannel) ? 'bg-grey-extralight': '',on:{"click":function($event){return _vm.selectFromConnectedList(cp.channelId, cp.customerId)}}},[_c('div',{staticClass:"flex flex-row justify-between mb-2 h-4 items-center"},[_c('div',{staticClass:"text-m font-semibold text-grey-darker capitalize mr-1"},[_vm._v(" "+_vm._s(cp.name ? cp.name: cp.customerId))]),_vm._v(" "),(cp.isOnline)?_c('div',{staticClass:"self-center bg-green flex-no-shrink flex-no-grow mr-auto",staticStyle:{"height":"10px","width":"10px","border-radius":"50%"}}):(!cp.isOnline)?_c('div',{staticClass:"self-center bg-red flex-no-shrink flex-no-grow mr-auto",staticStyle:{"height":"10px","width":"10px","border-radius":"50%"}}):_vm._e(),_vm._v(" "),(cp.consultationRequest.status === 'accepted')?_c('div',{staticClass:"flex-no-shrink flex-no-grow text-xs font-semibold"},[_c('time-elapsed',{key:cp.customerId,attrs:{"time":cp.accepted_at},on:{"timerColor":_vm.timerColor}})],1):_vm._e(),_vm._v(" "),(cp.isFamilyDoctor && cp.consultationRequest.status === 'accepted')?_c('div',{staticClass:"flex-no-shrink flex-no-grow ml-1"},[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})]):_vm._e(),_vm._v(" "),(cp.isFamilyDoctor && cp.consultationRequest.status === 'query_accepted' && (cp.consultationRequest.request_type === 'queried' || cp.consultationRequest.request_type === 'missed'))?_c('div',{staticClass:"flex-no-shrink flex-no-grow py-1 px-2 self-center text-brown text-xs font-semibold justify-center items-center",staticStyle:{"border-radius":"25px","color":"#70411b","background-color":"#faedce"}},[_vm._v("Query")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-4"},[_c('div',{staticClass:"flex justify-start items-center w-64 truncate"},[(cp.isOnline && cp.isCustomerTyping === true)?_c('div',{staticClass:"text-sm font-light text-grey-dark truncate"},[_vm._v("User is typing ...")]):_c('div',{staticClass:"text-sm font-light text-grey-dark truncate"},[_vm._v(_vm._s(_vm.patientLastMessage(cp.channelId)))]),_vm._v(" "),(_vm.patientNewMessages(cp.channelId) > 0)?_c('div',{staticClass:"flex flex-col self-center font-semibold text-xs text-grey-darker bg-yellow-light rounded-full px-2 py-1 flex-no-shrink flex-no-grow ml-auto"},[_vm._v(_vm._s(_vm.patientNewMessages(cp.channelId))+" Unread")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-end items-center ml-auto w-24"},[_c('div',{staticClass:"text-xs font-light text-grey-dark"},[_vm._v(_vm._s(_vm.patientLastMessageTime(cp.channelId)))])])])])}),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5WzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ably__ = __webpack_require__("oKrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_initialise_store__ = __webpack_require__("II+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_doctor__ = __webpack_require__("4mdi");

// import Vue from 'vue'




// State
var state = {
  role: null,
  availableForChat: JSON.parse(sessionStorage.getItem('availableForChat')),
  connectivityStatus: 'not_connected', // connecting & connected are others
  enableChat: true, // For non sponsor doctors
  doctorId: null,
  phrases: [],
  isCompanyDoctor: null,
  ablyKey: null,
  name: null,
  id: null,
  profileDetails: {},
  companyId: null,
  prescriptionFlag: null,
  chatStatus: null,
  activeAdminMiniMenu: 'DoctorMain',
  activeMiniMenu: 'Chat',
  onlineActiveSection: 'connected',
  offlineActiveSection: 'connected',
  activeRightPaneTab: 'consultation-summary'

  // Getters
};var getters = {
  getRole: function getRole() {
    return state.role;
  },
  isChatEnabled: function isChatEnabled() {
    return state.enableChat;
  },
  doctor: function doctor() {
    return state.profileDetails;
  },
  getActiveSection: function getActiveSection(state, getters, rootState) {
    if (state.activeMiniMenu === 'Chat') {
      return state.onlineActiveSection;
    } else if (state.activeMiniMenu === 'OfflineConsults') {
      return state.offlineActiveSection;
    }
  },


  getActiveRightPaneTab: function getActiveRightPaneTab() {
    return state.activeRightPaneTab;
  },

  getActiveMiniMenu: function getActiveMiniMenu(state) {
    return state.activeMiniMenu;
  },
  getActivePatientProfile: function getActivePatientProfile(state, getters, rootState) {
    var consult = null;
    if (state.activeMiniMenu === 'Chat') {
      if (state.onlineActiveSection === 'connected' && rootState.consultation.activeChannelId !== null) {
        consult = rootState.consultation.activeConsults.find(function (ele) {
          return ele.channelId === rootState.consultation.activeChannelId;
        });
      } else if (state.onlineActiveSection === 'consults' && rootState.pastConsultation.activePastConsultationRequestId !== null) {
        consult = rootState.pastConsultation.pastConsults.find(function (ele) {
          return ele.consultationRequest.consultationRequestId === rootState.pastConsultation.activePastConsultationRequestId;
        });
      }
    } else if (state.activeMiniMenu === 'OfflineConsults') {
      if (state.offlineActiveSection === 'connected' && rootState.offlineConsultation.activeCustomerId !== null) {
        consult = rootState.offlineConsultation.activeOfflineConsults.find(function (ele) {
          return ele.channelId === rootState.offlineConsultation.activeCustomerId;
        });
      } else if (state.offlineActiveSection === 'consults' && rootState.pastOfflineConsultation.activePastConsultId !== null) {
        consult = rootState.pastOfflineConsultation.pastOfflineConsults.find(function (ele) {
          return ele.consultation.consultationId === rootState.pastOfflineConsultation.activePastConsultId;
        });
      }
    }
    if (consult) {
      return consult;
    }
  },
  customerNotifications: function customerNotifications(state, getters, rootState) {
    var activeCustomer = getters.getActivePatientProfile;
    if (activeCustomer && activeCustomer.details && activeCustomer.details.notifications && activeCustomer.details.notifications.length > 0) {
      return activeCustomer.details.notifications;
    }
    return [];
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__api_initialise_store__["a" /* default */].fetchConfigurations().then(function (response) {
      if (response.status === 200) {
        commit('setUpDoctor', response.body.doctor);
        if (!state.isCompanyDoctor && state.role !== 'admin') {
          dispatch('establishAblyConnection'); // init online consultations
          dispatch('pastConsultation/init', {}, { root: true }); // init past cosultations
          dispatch('consultationRequest/setUpQueries', {}, { root: true }); // init past cosultations
        } else if (state.isCompanyDoctor) {
          dispatch('setActiveMiniMenu', 'OfflineConsults');
        } else if (state.role === 'admin') {
          // basically for past consults
          commit('updateOnlineActiveSection', 'consults');
        }
        dispatch('notification/init', {}, { root: true }); // init notifications
        dispatch('preFilledMedications/init', {}, { root: true });
      }
    });
  },
  establishAblyConnection: function establishAblyConnection(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].init(state.doctorId, state.ablyKey);
    commit('setConnectivity', 'connecting');
  },
  ablyConnected: function ablyConnected(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    commit('setConnectivity', 'connected');
    __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].subscribeToChannel(state.doctorId + '_communication');
    if (state.availableForChat === true) {
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].subscribeToChannel('doctors_channel');
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].subscribeToChannel(state.doctorId);
      // init consult requests
      __WEBPACK_IMPORTED_MODULE_2__api_initialise_store__["a" /* default */].fetchConsultationRequestsDetails().then(function (response) {
        if (response.status === 200) {
          dispatch('consultationRequest/init', { details: response.body.consultation_requests }, { root: true });
        }
      });
    }
    // init ongoing consultations
    dispatch('consultation/init', {}, { root: true });
  },
  ablyDisconnected: function ablyDisconnected(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('setConnectivity', 'disconnected');
  },
  ablySuspended: function ablySuspended(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit('setConnectivity', 'suspended');
  },
  ablyFailed: function ablyFailed(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit('setConnectivity', 'failed');
  },
  setChatAvailability: function setChatAvailability(_ref7, status) {
    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;

    sessionStorage.setItem('availableForChat', status);
    commit('updateAvailableForChat', status);
    if (status === true) {
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].subscribeToChannel('doctors_channel');
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].subscribeToChannel(state.doctorId);
      __WEBPACK_IMPORTED_MODULE_2__api_initialise_store__["a" /* default */].fetchConsultationRequestsDetails().then(function (response) {
        if (response.status === 200) {
          dispatch('consultationRequest/init', { details: response.body.consultation_requests }, { root: true });
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].updatePresenceEvents('doctors_channel', 'leave');
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].updatePresenceEvents(state.doctorId, 'leave');
    }
  },
  setOnlineActiveSection: function setOnlineActiveSection(_ref8, section) {
    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState,
        dispatch = _ref8.dispatch;

    commit('updateOnlineActiveSection', section);
    if (rootState.pastConsultation.initiated) {
      if (section === 'consults' && !rootState.pastConsultation.activePastConsultationRequestId && rootState.pastConsultation.pastConsults.length > 0) {
        dispatch('pastConsultation/switchTo', {
          id: rootState.pastConsultation.pastConsults[0].consultation.consultationId,
          consultationRequestId: rootState.pastConsultation.pastConsults[0].consultationRequest.consultationRequestId
        }, { root: true });
      }
    }
  },
  setOfflineActiveSection: function setOfflineActiveSection(_ref9, section) {
    var commit = _ref9.commit,
        state = _ref9.state,
        rootState = _ref9.rootState,
        dispatch = _ref9.dispatch;

    commit('updateOfflineActiveSection', section);
    if (rootState.pastOfflineConsultation.initiated) {
      if (section === 'consults' && !rootState.pastOfflineConsultation.activePastConsultId && rootState.pastOfflineConsultation.pastOfflineConsults.length > 0) {
        dispatch('pastOfflineConsultation/switchTo', rootState.pastOfflineConsultation.pastOfflineConsults[0].consultation.consultationId, { root: true });
      }
    }
  },
  setRightPaneTab: function setRightPaneTab(_ref10, tab) {
    var commit = _ref10.commit;

    commit('updateRightPaneTab', tab);
  },
  setActiveMiniMenu: function setActiveMiniMenu(_ref11, menu) {
    var commit = _ref11.commit,
        state = _ref11.state,
        rootState = _ref11.rootState,
        dispatch = _ref11.dispatch;

    commit('updateActiveMiniMenu', menu);
    if (menu === 'OfflineConsults' && !rootState.offlineConsultation.initiated) {
      dispatch('offlineConsultation/init', {}, { root: true });
      dispatch('pastOfflineConsultation/init', {}, { root: true });
    } else if (menu === 'PreEmpAppointmentRequests' && !rootState.appointmentRequest.initiated) {
      dispatch('preEmpAppointmentRequest/setPreEmpAppointments', { status: 'scheduled', page: 1 }, { root: true });
    }
  },
  setActiveAdminMiniMenu: function setActiveAdminMiniMenu(_ref12, menu) {
    var commit = _ref12.commit,
        state = _ref12.state,
        rootState = _ref12.rootState,
        dispatch = _ref12.dispatch;

    commit('updateActiveAdminMiniMenu', menu);
  },
  updateDoctorAttribute: function updateDoctorAttribute(_ref13, payload) {
    var commit = _ref13.commit;

    commit('updateDoctorAttribute', payload);
  },
  saveDoctorDetails: function saveDoctorDetails(_ref14, _ref15) {
    var state = _ref14.state,
        commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    var signature = _ref15.signature,
        profile = _ref15.profile;

    var data = new FormData();
    data.append('name', state.profileDetails.name);
    data.append('qualification', state.profileDetails.qualification);
    data.append('description', state.profileDetails.description);
    data.append('mobile_number', state.profileDetails.mobile_number);
    data.append('registration_number', state.profileDetails.registration_number);
    if (signature !== null) {
      data.append('signature', signature, signature.name);
    }
    if (profile !== null) {
      data.append('photo', profile, profile.name);
    }
    __WEBPACK_IMPORTED_MODULE_3__api_doctor__["a" /* default */].updateDoctorDetails(data).then(function (response) {
      if (response.status === 200) {
        commit('updateDoctor', response.body.doctor);
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateReadNotification: function updateReadNotification(_ref16, id) {
    var commit = _ref16.commit,
        getters = _ref16.getters,
        dispatch = _ref16.dispatch;

    var activeCustomer = getters.getActivePatientProfile;
    __WEBPACK_IMPORTED_MODULE_3__api_doctor__["a" /* default */].updateRead(id).then(function (response) {
      if (response.status === 200) {
        commit('updateReadNotification', { id: id, activeCustomer: activeCustomer });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateViewedNotification: function updateViewedNotification(_ref17) {
    var commit = _ref17.commit,
        getters = _ref17.getters,
        dispatch = _ref17.dispatch;

    var activeCustomer = getters.getActivePatientProfile;
    var nId = activeCustomer.details.notifications[0] && activeCustomer.details.notifications[0].id ? activeCustomer.details.notifications[0].id : null;
    if (nId) {
      __WEBPACK_IMPORTED_MODULE_3__api_doctor__["a" /* default */].customerUpdateViewed(nId).then(function (response) {
        if (response.status === 200) {
          commit('updateViewedNotification', { activeCustomer: activeCustomer });
        }
      });
    }
  }
};

// Mutations
var mutations = {
  turOnVisibility: function turOnVisibility() {},
  turnOffVisibility: function turnOffVisibility() {},
  addRole: function addRole(role) {},
  setConnectivity: function setConnectivity(state, status) {
    state.connectivityStatus = status;
  },
  setUpDoctor: function setUpDoctor(state, doctor) {
    var externalAdmin = !doctor.profiledetails.internal_doctor && doctor.role === 'admin';
    var specialistDoctor = !doctor.profiledetails.internal_doctor && doctor.role.toLowerCase() === 'specialist';
    var newRole = externalAdmin ? 'externalAdmin' : specialistDoctor ? 'specialistDoctor' : doctor.role;
    console.log('Role - ', newRole);
    state.doctorId = doctor.doctor_id;
    state.name = doctor.name;
    state.id = doctor.did;
    state.chatStatus = doctor.chatstatus;
    state.profileDetails = doctor.profiledetails;
    state.role = newRole;
    state.companyId = doctor.company_id;
    state.prescriptionFlag = doctor.prescription_flag;
    state.isCompanyDoctor = doctor.is_company_doctor;
    state.ablyKey = doctor.ably_token;
    state.phrases = doctor.phrases;
  },
  updateAvailableForChat: function updateAvailableForChat(state, status) {
    state.availableForChat = status;
  },
  updateOnlineActiveSection: function updateOnlineActiveSection(state, section) {
    state.onlineActiveSection = section;
  },
  updateOfflineActiveSection: function updateOfflineActiveSection(state, section) {
    state.offlineActiveSection = section;
  },
  updateActiveMiniMenu: function updateActiveMiniMenu(state, menu) {
    state.activeMiniMenu = menu;
  },
  updateActiveAdminMiniMenu: function updateActiveAdminMiniMenu(state, menu) {
    state.activeAdminMiniMenu = menu;
  },
  updateDoctor: function updateDoctor(state, data) {
    var signature = data.signature;
    var photo = data.photo;
    data.photo = { url: photo };
    data.signature = { url: signature };
    state.profileDetails = data;
  },
  updateDoctorAttribute: function updateDoctorAttribute(state, data) {
    var profileDetails = state.profileDetails;
    state.profileDetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(profileDetails, data);
  },
  updateRightPaneTab: function updateRightPaneTab(state, tab) {
    state.activeRightPaneTab = tab;
  },
  updateReadNotification: function updateReadNotification(state, _ref18) {
    var id = _ref18.id,
        activeCustomer = _ref18.activeCustomer;

    if (activeCustomer && activeCustomer.details && activeCustomer.details.notifications && activeCustomer.details.notifications.length > 0) {
      var n = activeCustomer.details.notifications.find(function (c) {
        if (c.id === id) return c;
      });
      if (n) {
        var i = activeCustomer.details.notifications.indexOf(n);
        activeCustomer.details.notifications[i].is_read = true;
      }
    }
  },
  updateViewedNotification: function updateViewedNotification(state, _ref19) {
    var activeCustomer = _ref19.activeCustomer;

    if (activeCustomer && activeCustomer.details && activeCustomer.details.notifications && activeCustomer.details.notifications.length > 0) {
      activeCustomer.details.notifications.map(function (n) {
        n.is_viewed = true;
      });
    }
  },
  reset: function reset(state) {
    state = {};
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "5ZzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingQueries_vue__ = __webpack_require__("krm1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d29ec8f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingQueries_vue__ = __webpack_require__("oz7X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingQueries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d29ec8f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingQueries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5e3d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-y-auto"},[_vm._l((_vm.activeOfflineConsults),function(cp,index){return _c('div',{key:index,staticClass:"flex flex-col px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest justify-center hover:bg-grey-extralight cursor-pointer",class:(cp.channelId === _vm.activeCustomer) ? 'bg-grey-extralight': '',on:{"click":function($event){return _vm.selectFromConnectedList(cp.channelId)}}},[_c('div',{staticClass:"flex flex-row items-center h-4 mb-2"},[_c('div',{staticClass:"text-m font-semibold text-grey-darkest capitalize"},[_vm._v(_vm._s(cp.name ? cp.name : 'No Name'))]),_vm._v(" "),(cp.channelId === _vm.activeCustomer)?_c('div',{staticClass:"text-blue hover:text-white hover:bg-blue h-6 w-6 items-center rounded-full flex flex-col self-center justify-center ml-1",attrs:{"title":"View Profile"},on:{"click":function($event){return _vm.viewCustomerProfile($event)}}},[_c('i',{staticClass:"far fa-user fa-xs"})]):_vm._e(),_vm._v(" "),(cp.isFamilyDoctor)?_c('div',{staticClass:"flex m-1 ml-auto"},[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row text-grey-dark h-4 text-xs"},[_c('div',{staticClass:"flex self-center"},[_vm._v(_vm._s(cp.channelId))]),_vm._v(" "),_c('div',{staticClass:"flex ml-auto"},[(cp.channelId === _vm.activeCustomer)?_c('div',{staticClass:"hover:bg-green hover:text-white flex flex-col self-center justify-center mr-2 ml-auto items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-grey",attrs:{"title":"End Chat"},on:{"click":function($event){return _vm.endConsultation($event, 'endChatClicked')}}},[_c('i',{staticClass:"fa fa-xs pl-1 fa-check"})]):_vm._e(),_vm._v(" "),(cp.channelId === _vm.activeCustomer)?_c('div',{staticClass:"hover:bg-red hover:text-white flex flex-col self-center justify-center items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-grey",attrs:{"title":"Incomplete Chat"},on:{"click":function($event){return _vm.endConsultation($event, 'incompleteChatClicked')}}},[_c('i',{staticClass:"fa fa-xs pl-1 fa-times"})]):_vm._e()])])])}),_vm._v(" "),(_vm.viewProfile)?_c('customer-profile',{on:{"viewCustomerProfile":_vm.viewCustomerProfile}}):_vm._e(),_vm._v(" "),(_vm.endChatClicked || _vm.incompleteChatClicked)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeEndChatOverlay()}}}),_vm._v(" "),(_vm.endChatClicked)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Ending this consultation as valid")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeEndChatOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Are you sure you want to end this consult?")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.endChat('SUCCESS')}}},[_vm._v("Yes")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-grey-lightest ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-grey-dark text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeEndChatOverlay()}}},[_vm._v("No")])])])]):_vm._e(),_vm._v(" "),(_vm.incompleteChatClicked)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Ending this consultation as invalid")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeEndChatOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Reason for ending the consult as invalid")]),_vm._v(" "),_c('div',{staticClass:"border border-grey-lightest text-grey-darker text-sm border-solid rounded-sm px-1 py-2 my-2 focus:border-blue",staticStyle:{"outline":"none","max-height":"150px","overflow-y":"auto"},attrs:{"id":"editor","contenteditable":"true"},on:{"input":function($event){return _vm.reasonInput($event)}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-between"},[_c('div',{staticClass:"text-xs text-grey-darker self-center"}),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-blue px-4 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.endChat('FAILURE')}}},[_vm._v("Submit")])])])]):_vm._e()]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5tu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: function fetch(tab) {
    var calledOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var role = arguments[2];

    if (role === 'externalAdmin') {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/specialist_appointment_requests/admin_requests?status=' + tab);
    } else if (role === 'specialistDoctor') {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/specialist_appointment_requests?status=' + tab);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/appointment_requests/' + tab, { params: { calledOnce: calledOnce } });
    }
  },
  updateRemark: function updateRemark(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/appointment_requests/update_remark', obj);
  },
  updateStatus: function updateStatus(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/appointment_requests/update_status', obj);
  },
  selfAssign: function selfAssign(object) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/appointment_requests/' + object.id + '/' + object.type);
  },

  spcApttSatusChange: function spcApttSatusChange(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/specialist_appointment_requests/' + obj.id, obj);
  },
  doctorList: function doctorList(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/specialist_appointment_requests/' + obj.id + '/doctors_list');
  },
  slotsList: function slotsList(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/specialist_appointment_requests/slots', obj);
  },
  meeting_link: function meeting_link(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/specialist_appointment_requests/' + id + '/meeting_link');
  }
});

/***/ }),

/***/ "6/b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Chat_DrugPrescriptionCard__ = __webpack_require__("RnK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Chat_LabTestCard__ = __webpack_require__("wbZh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['messages', 'isActivePastChat', 'isActiveChat'],
  components: {
    DrugPrescriptionCard: __WEBPACK_IMPORTED_MODULE_0__components_Chat_DrugPrescriptionCard__["a" /* default */],
    LabTestCard: __WEBPACK_IMPORTED_MODULE_1__components_Chat_LabTestCard__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {
    messageStatus: function messageStatus(message) {
      if (message.status === null || message.status === undefined) {
        return false;
      }
      return true;
    },
    getDocument: function getDocument(doctype, docid) {
      var type = 'medical_records';
      if (doctype === 'Prescription') {
        type = 'prescriptions';
      }
      this.$http.get(window.API_URL + 'doctors/' + type + '/' + docid + '/download').then(function (response) {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank');
        } else {
          alert('Error fetching data');
        }
      }, function (response) {});
    },
    timeString: function timeString(milliTime) {
      var t = new Date(Number(milliTime));
      return t.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' });
    },
    isMsgSent: function isMsgSent(message) {
      if (message.status === null || message.status === undefined) {
        return false;
      } else if (message.status === 'sent') {
        return true;
      }
    },
    dashoffset: function dashoffset(percent) {
      var circle = document.querySelector('circle');
      if (!circle) return;
      var radius = circle.r.baseVal.value;
      var circumference = radius * 2 * Math.PI;
      return circumference - percent / 100 * circumference;
    },
    dasharray: function dasharray() {
      var circle = document.querySelector('circle');
      if (!circle) return;
      var radius = circle.r.baseVal.value;
      var circumference = radius * 2 * Math.PI;
      return circumference + ' ' + circumference;
    },
    resendMessage: function resendMessage(message) {
      this.$store.dispatch('message/resendMessage', message);
    },
    deleteMessage: function deleteMessage(message) {
      this.$store.dispatch('message/deleteMessage', message);
    }
  }
});

/***/ }),

/***/ "65UA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6fnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftPane_vue__ = __webpack_require__("TO6J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346e08d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftPane_vue__ = __webpack_require__("zRvW");
function injectStyle (ssrContext) {
  __webpack_require__("zBGg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-346e08d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346e08d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftPane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6zQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import Push from 'push.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  // notifyMe: function () {
  //   Push.create('Ekincare', {
  //     body: 'Patient is Waiting..',
  //     icon: '/static/ekincarelogo.png',
  //     timeout: 4000,
  //     onClick: function () {
  //       window.focus()
  //       this.close()
  //     }
  //   })
  // },
  create: function create(type) {
    if (type === 'msg') {
      this.newMessageSound();
    } else if (type === 'newuser') {
      // this.notifyMe()
      this.newUserSound();
    }
  },
  newMessageSound: function newMessageSound() {
    var audio = new Audio();
    if (typeof Audio !== 'undefined') {
      if (audio.canPlayType('audio/ogg') === 'probably') {
        audio = new Audio('/static/sounds/msg_received.ogg');
      } else {
        audio = new Audio('/static/sounds/msg_received.mp3');
      }
      audio.play().then().catch(function (e) {
        return console.log(e);
      });
    } else {}
  },
  newUserSound: function newUserSound() {
    var audio = new Audio();
    if (typeof Audio !== 'undefined') {
      if (audio.canPlayType('audio/ogg') === 'probably') {
        audio = new Audio('/static/sounds/waiting.ogg');
      } else {
        audio = new Audio('/static/sounds/waiting.mp3');
      }
      audio.play().then().catch(function (e) {
        console.log(e);
      });
    } else {}
  }
});

/***/ }),

/***/ "7dqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('left-pane',{on:{"tabChange":_vm.tabChange}}),_vm._v(" "),(_vm.isRightPaneActive)?_c('right-pane',{attrs:{"selectedTab":_vm.selectedRightTab,"showRightPane":_vm.isRightPaneActive,"showToggleButton":_vm.showToggleButton,"chatType":"offline"},on:{"tabChange":_vm.tabChange}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7hcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_SpeechRecognition__ = __webpack_require__("kUeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Customer_CustomerProfile__ = __webpack_require__("QE93");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Chat_ChatMessageContainer__ = __webpack_require__("gEdh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Consultations_TimeElapsed_vue__ = __webpack_require__("YIS4");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SpeechRecognition: __WEBPACK_IMPORTED_MODULE_2__components_common_SpeechRecognition__["a" /* default */],
    CustomerProfile: __WEBPACK_IMPORTED_MODULE_3__components_Customer_CustomerProfile__["a" /* default */],
    ChatMessageContainer: __WEBPACK_IMPORTED_MODULE_4__components_Chat_ChatMessageContainer__["a" /* default */],
    TimeElapsed: __WEBPACK_IMPORTED_MODULE_5__Consultations_TimeElapsed_vue__["a" /* default */]
  },
  data: function data() {
    return {
      // progress: 0,
      chatInput: this.inputMessage,
      viewProfile: false,
      endChatClicked: false,
      incompleteChatClicked: false,
      noMessage: false,
      reasons: null,
      sendNotifiactionTimeout: null,
      timerClass: 'text-green-darker',
      timerBg: 'bg-green-lightest',
      minutes: 0,
      seconds: 0,
      interval: null,
      intervals: {
        second: 1000,
        minute: 1000 * 60,
        hour: 1000 * 60 * 60,
        day: 1000 * 60 * 60 * 24
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isActiveChatPresent: 'consultation/isActiveChatPresent',
    customer: 'consultation/getActiveUserProfile',
    pastCustomer: 'pastConsultation/getActivePastCustomer',
    isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
    messages: 'message/getMessages',
    loader: 'loader/getLoaderData',
    activeSection: 'configuration/getActiveSection',
    inputMessage: 'consultation/getInputMessage'
  }), {
    message: {
      get: function get() {
        return this.chatInput;
      },
      set: function set(value) {
        this.updateInput(value);
      }
    },
    chatHeaderText: function chatHeaderText() {
      if (this.customer.isFamilyDoctor) {
        return 'Your Patient';
      } else {
        return 'Family Doctor: ' + this.customer.familyDoctor && this.customer.familyDoctor.name ? this.customer.familyDoctor.name : 'NA';
      }
    },
    dateToAge: function dateToAge() {
      if (this.customer.details && this.customer.details.date_of_birth) {
        var dateOfBirth = this.customer.details.date_of_birth;
        if (!isNaN(dateOfBirth) || new Date(dateOfBirth).toString() === 'Invalid Date') {
          return -1;
        } else {
          var birth = new Date(dateOfBirth);
          var curr = new Date();
          var diff = curr.getTime() - birth.getTime();
          return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
        }
      }
    },
    gender: function gender() {
      if (this.customer.details && this.customer.details.gender) {
        return this.customer.details.gender;
      }
    },
    PCdateToAge: function PCdateToAge() {
      if (this.pastCustomer.details && this.pastCustomer.details.date_of_birth) {
        var dateOfBirth = this.pastCustomer.details.date_of_birth;
        if (!isNaN(dateOfBirth) || new Date(dateOfBirth).toString() === 'Invalid Date') {
          return -1;
        } else {
          var birth = new Date(dateOfBirth);
          var curr = new Date();
          var diff = curr.getTime() - birth.getTime();
          return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
        }
      }
    },
    PCgender: function PCgender() {
      if (this.pastCustomer.details && this.pastCustomer.details.gender) {
        return this.pastCustomer.details.gender;
      }
    },
    isActiveChat: function isActiveChat() {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true;
      }
      return false;
    },
    isActivePastChat: function isActivePastChat() {
      if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true;
      }
      return false;
    },
    consultStatus: function consultStatus() {
      var consult = this.pastCustomer && this.pastCustomer.consultation ? this.pastCustomer.consultation : null;
      if (consult) {
        if (consult.summary_status === 'done' || consult.summary_status === 'not_needed' || consult.consultationId === null || consult.consultationId === undefined) {
          return true;
        } else {
          return false;
        }
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.missedRequestMessage();
    this.interval = setInterval(function () {
      _this.updatedTime();
    }, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
  },

  watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    input: function input(state) {
      return state.consultation.messages;
    }
  }), {
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.missedRequestMessage();
        this.sendNotifiactionTimeout = null;
      }
      if (newVal.isOnline && this.sendNotifiactionTimeout) {
        clearTimeout(this.sendNotifiactionTimeout);
      }
    },
    messages: function messages(newV, oldV) {
      if (newV !== oldV) {
        this.missedRequestMessage();
      }
    }
  }),
  methods: {
    updateInput: function updateInput(value) {
      var msg = {
        channelId: this.customer.channelId,
        message: this.inputMessage ? this.inputMessage : value
      };
      this.chatInput = this.inputMessage;
      if (this.inputMessage.length > 0) {
        this.$store.dispatch('consultation/storeMessage', msg);
      }
    },
    companyName: function companyName(cus) {
      if (cus.details && cus.details.company_name) {
        if (cus.details.company_name.length > 25) {
          return cus.details.company_name.substring(0, 25) + '...';
        } else {
          return cus.details.company_name;
        }
      } else return 'NA';
    },
    missedRequestMessage: function missedRequestMessage() {
      this.message = '';
      if (this.customer && this.customer.consultationRequest && this.customer.consultationRequest.request_type === 'missed' && this.messages.length < 3) {
        this.message = 'Hi ' + this.customer.name + ', sorry to miss your consultation request. Good to connect with you today.';
      }
    },
    getVoiceMessage: function getVoiceMessage(message) {
      this.chatInput = message;
      var msg = {
        channelId: this.customer.channelId,
        message: message
      };
      this.$store.dispatch('consultation/storeMessage', msg);
    },
    getDocument: function getDocument(doctype, docid) {
      var type = 'medical_records';
      if (doctype === 'Prescription') {
        type = 'prescriptions';
      }
      this.$http.get(window.API_URL + 'doctors/' + type + '/' + docid + '/download').then(function (response) {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank');
        } else {
          alert('Error fetching data');
        }
      }, function (response) {});
    },
    onDivInput: function onDivInput(e) {
      this.reasons = document.getElementById('editor').innerText;
    },
    viewCustomerProfile: function viewCustomerProfile(e) {
      e.stopPropagation();
      this.viewProfile = !this.viewProfile;
    },
    endConsultation: function endConsultation(item) {
      this[item] = true;
    },
    closeEndChatOverlay: function closeEndChatOverlay() {
      this.endChatClicked = false;
      this.incompleteChatClicked = false;
    },
    addMessage: function addMessage() {
      if (this.message.trim().length > 0) {
        this.$store.dispatch('message/send', { message: this.message, intentName: 'incoming_text', channelId: this.customer.channelId });
        this.$store.commit('consultation/updateInputMessage', { channelId: this.customer.channelId });
        this.message = '';
        this.chatInput = '';
      }
      var msg = {
        channelId: this.customer.channelId,
        message: ''
      };
      this.$store.dispatch('consultation/storeMessage', msg);
    },
    sendTyping: function sendTyping(e) {
      var message = e.target.value;
      this.chatInput = message;
      var msg = {
        channelId: this.customer.channelId,
        message: message
      };
      if (message !== '' && message.length % 5 === 0) {
        this.$store.dispatch('consultation/sendDoctorTyping', true);
      }if (message !== '') {
        this.$store.dispatch('consultation/storeMessage', msg);
      }
      if (message.length > 1) {
        this.$store.dispatch('consultation/storeMessage', msg);
      }
    },
    sendNotTyping: function sendNotTyping() {
      this.$store.dispatch('consultation/sendDoctorTyping', false);
    },
    chatFileUpload: function chatFileUpload(fieldName, fileList) {
      this.$store.dispatch('message/uploadDocument', { fileList: fileList });
    },
    endChat: function endChat(status) {
      var reasons = [];
      if (this.reasons !== null) {
        reasons.push(this.reasons);
      }
      if (this.noMessage) {
        reasons.push('No Message Exchanged');
      }
      this.$store.dispatch('consultation/endChat', { status: status, reasons: reasons });
      this.closeEndChatOverlay();
    },
    summaryNotNeeded: function summaryNotNeeded() {
      this.$store.dispatch('pastConsultation/summaryNotNeeded', { summary: 'NA', componentKey: 'CP-SummaryNotNeeded' });
    },
    reviewSummary: function reviewSummary() {
      this.$emit('tabChange', 'consultation-summary');
    },
    timerColor: function timerColor(value) {
      this.timerClass = value;
      if (value === 'text-green-darker') {
        this.timerBg = 'bg-green-lightest';
      } else if (value === 'text-yellow-darker') {
        this.timerBg = 'bg-yellow-lighter';
      } else if (value === 'text-red-dark') {
        this.timerBg = 'bg-red-lightest';
      }
    },
    updatedTime: function updatedTime() {
      var date = new Date(this.customer.accepted_at);
      var diff = Math.abs(Date.now() - date.getTime());
      this.days = Math.floor(diff / this.intervals.day);
      diff -= this.days * this.intervals.day;
      this.hours = Math.floor(diff / this.intervals.hour);
      diff -= this.hours * this.intervals.hour;
      this.minutes = Math.floor(diff / this.intervals.minute);
      diff -= this.minutes * this.intervals.minute;
      this.seconds = Math.floor(diff / this.intervals.second);

      if (this.minutes >= 10 && this.minutes < 15) {
        this.timerClass = 'text-yellow-darker';
        this.timerBg = 'bg-yellow-lighter';
      } else if (this.minutes >= 15) {
        this.timerClass = 'text-red-dark';
        this.timerBg = 'bg-red-lightest';
      } else {
        this.timerClass = 'text-green-darker';
        this.timerBg = 'bg-green-lightest';
      }
    }
  }
});

/***/ }),

/***/ "7q3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index_js__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ably__ = __webpack_require__("oKrw");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    logOut: function logOut() {
      __WEBPACK_IMPORTED_MODULE_1__core_ably__["a" /* default */].close();
      sessionStorage.clear();
      __WEBPACK_IMPORTED_MODULE_0__router_index_js__["a" /* default */].push({ path: 'Login' });
    }
  },
  mounted: function mounted() {
    this.logOut();
  }
});

/***/ }),

/***/ "7tb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),(_vm.pastConsults.length < 1)?_c('div',{staticClass:"flex flex-col bg-white px-4 py-6 text-grey-darker text-sm border-solid border-b border-grey-lightest"},[_vm._v("No consultation found")]):_vm._e(),_vm._v(" "),(!_vm.showDetails && _vm.pastConsults.length > 0)?_c('div',{staticClass:"flex flex-col bg-white overflow-y-auto px-4 py-6 flex-no-shrink flex-no-grow",staticStyle:{"height":"calc(100vh - 8rem)"}},[_c('div',{staticClass:"flex flex-row ml-auto mr-2 mb-1 items-center flex-no-shrink flex-no-grow"},[_c('input',{staticClass:"flex m-1 mb-2",attrs:{"type":"checkbox"},domProps:{"checked":_vm.queries},on:{"click":function($event){return _vm.fetchQueries()}}}),_vm._v(" "),_c('div',{staticClass:"flex ml-1 text-sm font-semibold"},[_vm._v("Show Conversations")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.pastConsults),function(consult,index){return _c('div',{key:index,staticClass:"grid_container text-grey-darkest text-xs"},[_c('div',{staticClass:"item truncate",attrs:{"title":consult.doctor_name}},[_vm._v(_vm._s(consult.doctor_name))]),_vm._v(" "),(consult.consultation_type === 'text')?_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm._f("formatDate")(consult.consultation_date)))]):_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm._f("formatDate")(consult.consultation_date)))]),_vm._v(" "),(consult.prescription)?_c('div',{staticClass:"item"},[_c('span',{staticClass:"text-blue font-semibold cursor-pointer",on:{"click":function($event){return _vm.getDocument(consult)}}},[_vm._v("Prescription")])]):_c('div',{staticClass:"item"},[_c('span',{staticClass:"text-grey"},[_vm._v("Prescription")])]),_vm._v(" "),(consult.consultation_type === 'text')?_c('div',{staticClass:"item"},[_c('span',{staticClass:"cursor-pointer font-semibold",class:[consult.is_query ? 'text-purple' : 'text-blue'],on:{"click":function($event){return _vm.fetchMessages(consult)}}},[_vm._v("Chat")])]):_c('div',{staticClass:"item"},[_c('span',{staticClass:"text-grey font-semibold"},[_vm._v("Call")])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"cursor-pointer font-semibold",class:[consult.is_query ? 'text-purple' : 'text-blue'],on:{"click":function($event){return _vm.showConsultDetails('Summary', consult)}}},[_vm._v("Summary")])])])})],2):_vm._e(),_vm._v(" "),(_vm.showDetails)?_c('div',{staticClass:"mx-4 mt-6 shadow"},[_c('div',{staticClass:"bg-grey-lightest h-8 flex flex-row rounded-sm justify-between"},[_c('div',{staticClass:"text-grey-darkest text-xs self-center pl-2"},[_vm._v("Consultation with "+_vm._s(_vm.selectedConsult.doctor_name))]),_vm._v(" "),_c('div',{staticClass:"self-center text-xs text-blue pr-2 cursor-pointer font-semibold",on:{"click":_vm.close}},[_vm._v("CLOSE")])]),_vm._v(" "),_c('div',{staticClass:"bg-grey-extralight h-8 flex flex-row rounded-sm shadow"},[_c('div',{staticClass:"text-grey-darker text-xs self-center pl-2"},[_vm._v(_vm._s(_vm.selectedType))])]),_vm._v(" "),(_vm.selectedType === 'Summary')?_c('div',{staticClass:"flex flex-col rounded-sm p-2 border-b border-solid border-grey-lightest bg-white",attrs:{"id":"Summary"}},[_c('div',{staticClass:"text-sm p-1 py-2 text-grey-darker"},[_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v("CHIEF COMPLAINT: ")]),_vm._v(_vm._s(_vm.selectedConsult.chief_compliant ? _vm.selectedConsult.chief_compliant : 'NA'))]),_vm._v(" "),_c('div',{staticClass:"text-sm p-1 py-2 text-grey-darker"},[_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v("DIAGNOSIS: ")]),_vm._v(_vm._s(_vm.selectedConsult.diagnosis ? _vm.selectedConsult.diagnosis : 'NA'))]),_vm._v(" "),_c('div',{staticClass:"text-sm p-1 py-2 text-grey-darker"},[_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v("SUMMARY: ")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedConsult.summary ? _vm.selectedConsult.summary : 'NA')}})])]):_vm._e(),_vm._v(" "),(_vm.selectedType === 'Chat')?_c('div',{staticClass:"container flex flex-row rounded-sm p-2 border-b border-solid border-grey-lightest overflow-y-auto bg-white",attrs:{"id":"Chat"}},[(_vm.messages.length<1)?_c('div',{staticClass:"text-grey-darker text-sm"},[_vm._v(" No message exchanged")]):_c('chat-message-container',{staticStyle:{"height":"calc(100vh - 15rem)"},attrs:{"messages":_vm.messages,"isActivePastChat":true}})],1):_vm._e()]):_c('div',{staticClass:"fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow",style:(_vm.$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);')},[_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages>0),expression:"totalPages>0"}],attrs:{"page-count":_vm.totalPages,"click-handler":_vm.changePage,"prev-text":'Prev',"next-text":'Next',"active-class":'active-page',"page-class":'list-item',"next-class":'next-class',"prev-class":'prev-class',"container-class":'pagination text-xs flex fixed pin-r pr-5'}},[_c('span',{staticClass:"hover:bg-blue hover:text-white flex flex-col self-center justify-center items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink cursor-pointer text-grey",attrs:{"slot":"prevContent"},slot:"prevContent"},[_c('i',{staticClass:"fa fa-s fa-arrow-left"})]),_vm._v(" "),_c('span',{staticClass:"hover:bg-blue hover:text-white flex flex-col self-center justify-center items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink cursor-pointer text-grey",attrs:{"slot":"nextContent"},slot:"nextContent"},[_c('i',{staticClass:"fa fa-s fa-arrow-right"})])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("Past Consultation")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid_container bg-grey-lightest"},[_c('div',{staticClass:"item_header text-grey-darker font-semibold text-xs"},[_vm._v("Doctor")]),_vm._v(" "),_c('div',{staticClass:"item_header text-grey-darker font-semibold text-xs"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"item_header text-grey-darker font-semibold text-xs"}),_vm._v(" "),_c('div',{staticClass:"item_header text-grey-darker font-semibold text-xs"}),_vm._v(" "),_c('div',{staticClass:"item_header text-grey-darker font-semibold text-xs"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "82PI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['medication'],
  data: function data() {
    return {
      med: this.medication
    };
  },

  methods: {
    remove: function remove() {
      this.$emit('removeSaved', this.medication.id);
    },
    edit: function edit() {
      this.$emit('editSaved', this.med);
    },
    add: function add() {
      this.$emit('addToMedications', this.med);
    },
    toggleCheckbox: function toggleCheckbox() {
      var isCurrent = { is_current: this.medication.is_current };
      this.$store.dispatch('preFilledMedications/editSavedDrug', { drugId: this.med.id, isCurrent: isCurrent });
    }
  }
});

/***/ }),

/***/ "8Ala":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm w-3/4 h-auto z-20 mx-32 px-8 py-6 flex-no-grow flex-no-shrink",staticStyle:{"top":"40px","z-index":"99"}},[_c('form',{on:{"submit":function($event){return _vm.fetchCustomers($event)}}},[_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"flex flex-col justify-center flex-1 m-2"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.first_name),expression:"search.first_name"}],staticClass:"text-sm border border-grey-lightest rounded-m mb-1 w-48",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"type":"text"},domProps:{"value":(_vm.search.first_name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "first_name", $event.target.value)},function($event){return _vm.onSearchInput($event, 'first_name')}]}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center flex-1 m-2"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.last_name),expression:"search.last_name"}],staticClass:"text-sm border border-grey-lightest rounded-m mb-1 w-48",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"type":"text"},domProps:{"value":(_vm.search.last_name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "last_name", $event.target.value)},function($event){return _vm.onSearchInput($event, 'last_name')}]}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center flex-1 m-2"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.email),expression:"search.email"}],staticClass:"text-sm border border-grey-lightest rounded-m mb-1 w-48",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"type":"text"},domProps:{"value":(_vm.search.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "email", $event.target.value)},function($event){return _vm.onSearchInput($event, 'email')}]}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center flex-1 m-2"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.customer_id),expression:"search.customer_id"}],staticClass:"text-sm border border-grey-lightest rounded-m mb-1 w-48",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"type":"text"},domProps:{"value":(_vm.search.customer_id)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "customer_id", $event.target.value)},function($event){return _vm.onSearchInput($event, 'customer_id')}]}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center flex-2 m-2"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.mobile_number),expression:"search.mobile_number"}],staticClass:"text-sm border border-grey-lightest rounded-m mb-1 w-48",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"type":"number"},domProps:{"value":(_vm.search.mobile_number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "mobile_number", $event.target.value)},function($event){return _vm.onSearchInput($event, 'mobile_number')}]}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center flex-1 m-2"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.employee_id),expression:"search.employee_id"}],staticClass:"text-sm border border-grey-lightest rounded-m mb-1 w-48",staticStyle:{"min-height":"40px","padding":"4px 8px 4px 8px"},attrs:{"type":"text"},domProps:{"value":(_vm.search.employee_id)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "employee_id", $event.target.value)},function($event){return _vm.onSearchInput($event, 'employee_id')}]}})])]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),(_vm.searchResult.length>0)?_c('div',{staticClass:"my-4"},[_c('div',{staticClass:"text-grey-darker font-semibold text-sm my-2"},[_vm._v("Results:")]),_vm._v(" "),_c('div',{staticClass:"border border-solid border-grey-lightest"},[_vm._m(7),_vm._v(" "),_vm._l((_vm.searchResult),function(result,i){return _c('div',{key:i,staticClass:"flex p-2 hover:bg-blue-lightest"},[_c('div',{staticClass:"flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue",on:{"click":function($event){return _vm.addNewCustomer(result)}}},[_vm._v(_vm._s(result.name))]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue",on:{"click":function($event){return _vm.addNewCustomer(result)}}},[_vm._v(_vm._s(result.email))]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue",on:{"click":function($event){return _vm.addNewCustomer(result)}}},[_vm._v(_vm._s(_vm.getMobileNo(result)))]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue",on:{"click":function($event){return _vm.addNewCustomer(result)}}},[_vm._v(_vm._s(result.customer_id))]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue",on:{"click":function($event){return _vm.addNewCustomer(result)}}},[_vm._v(_vm._s(result.employee_id))])])})],2)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs text-grey-light font-semibold mr-auto capitalize mb-1"},[_vm._v("SEARCH BY "),_c('span',{staticClass:"text-grey-darker"},[_vm._v("FIRST NAME")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs text-grey-light font-semibold mr-auto capitalize mb-1"},[_vm._v("SEARCH BY "),_c('span',{staticClass:"text-grey-darker"},[_vm._v("LAST NAME")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs text-grey-light font-semibold mr-auto capitalize mb-1"},[_vm._v("SEARCH BY "),_c('span',{staticClass:"text-grey-darker"},[_vm._v("EMAIL")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs text-grey-light font-semibold mr-auto capitalize mb-1"},[_vm._v("SEARCH BY "),_c('span',{staticClass:"text-grey-darker"},[_vm._v("EK ID")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs text-grey-light font-semibold mr-auto capitalize mb-1"},[_vm._v("SEARCH BY "),_c('span',{staticClass:"text-grey-darker"},[_vm._v("MOBILE NO.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs text-grey-light font-semibold mr-auto capitalize mb-1"},[_vm._v("SEARCH BY "),_c('span',{staticClass:"text-grey-darker"},[_vm._v("EMPLOYEE ID.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center mt-4 mb-2"},[_c('button',{staticClass:"hover:shadow-md bg-blue rounded text-white font-semibold cursor-pointer text-sm px-6 py-3",attrs:{"type":"submit"}},[_vm._v(" Search")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex p-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex-1 text-grey-light font-semibold text-sm"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-light font-semibold text-sm"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-light font-semibold text-sm"},[_vm._v("Mobile No.")]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-light font-semibold text-sm"},[_vm._v("Customer ID")]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-grey-light font-semibold text-sm"},[_vm._v("Employee ID")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8c6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__ = __webpack_require__("3Qx8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be2d6ce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__ = __webpack_require__("3DOc");
function injectStyle (ssrContext) {
  __webpack_require__("0Olh")
  __webpack_require__("1dtu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be2d6ce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8eCR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9CTg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACN0lEQVR4nO3bz6uMURzH8e8jLBRJ0ZUfWVxdKYmFRLkpd2HB1sYf4A+wsbS/f4LE3pqlbBUrlBpcrsYkXfmVH+Ft8cxGzXOmmTr31Jn3a/vMTJ++n6eZ5jnnREiSJEmSJEmSJEmSJEnSDADmgGVgU+ksMwfYBzyndQfYWDrTzAAOAD3+dwvYUDpb9YBDwFtGuwE0pTNWbXinpyyXzlg1YDNwd0wJ10vnrBqwBXgwpoRrpXNWDdgGPBxTwtXSOasGbAceJQr4C1wpnbNqwE7gaaKEP8Dl0jmrBuwBXiRK+A1cKp2zasB+4FWihF/AhdI5qwbMA/1ECT+B86VzVg1YAAaJEr4Bi6VzVg04CqwlSvgEnCids2rASeBzooSPwPHSOasGnAa+Jkp4DxwunbNqwBLwI1HCAFgY9zkTP2IF1qaLXKWtEZFasHkdEWeapnnT9YJpCmDS98y4XkQsNk3TH3XRlZ785iPiPjA36qIFFGYB+fUi4mzTNINRFy0gr9WIWOr6/o9I/4J32TF9nqpcjIib0X0T96O981fWLdGsAM4B3/0jVgBwCvjio4gCgGPDAXfxYVwuwBHgQ2L4Po7OBTgIvEsM3wWZXGiXJFcSw3dJMhdgL/AyMXwX5XMBdgHPEsN3W0outBuzHieG78asXHBrYjm4Obcc2u3p98YM3+3puQC3xwzfAxo50W68Wu0YvkeU1gMe0isP2A08GQ7fY6ol4EFtSZIkSZIkSZIkSZIkSZIkSZrQP/LUw2eK65zpAAAAAElFTkSuQmCC"

/***/ }),

/***/ "9PB9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "9kA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_doctor_roster__ = __webpack_require__("Ph2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      test: 'File Upload Page',
      rosterFile: {},
      chatFile: {},
      message: 'eg : file.csv',
      upload: 'doctorRoster'
    };
  },

  methods: {
    submitRosterFile: function submitRosterFile() {
      var _this = this;

      if (this.rosterFile && this.rosterFile.size) {
        var formData = new FormData();
        formData.append('file', this.rosterFile);
        __WEBPACK_IMPORTED_MODULE_2__api_doctor_roster__["a" /* default */].uploadRoster(formData).then(function (response) {
          if (response.status === 200) {
            _this.rosterFile = {};
            _this.$toast.open({
              message: 'File Uploaded Successfully',
              type: 'success',
              posision: 'bottom-right'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this.$toast.open({
            message: 'Error while uploading the roster',
            type: 'error',
            position: 'bottom-right'
          });
        });
      } else {
        this.$toast.open({
          message: 'Please select a file to upload',
          type: 'error',
          position: 'top-right'
        });
      }
    },
    submitChatFile: function submitChatFile() {
      var _this2 = this;

      if (this.chatFile && this.chatFile.size) {
        var formData = new FormData();
        formData.append('file', this.chatFile);
        __WEBPACK_IMPORTED_MODULE_2__api_doctor_roster__["a" /* default */].uploadChatAvailability(formData).then(function (response) {
          if (response.status === 200) {
            _this2.chatFile = {};
            _this2.$toast.open({
              message: 'Chat Availability File Uploaded Successfully',
              type: 'success',
              posision: 'bottom-right'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this2.$toast.open({
            message: 'Error while uploading the roster',
            type: 'error',
            position: 'bottom-right'
          });
        });
      }
    },
    cancel: function cancel() {
      this.chatFile = {};
      this.rosterFile = {};
    },
    handleFileUpload: function handleFileUpload() {
      this.rosterFile = this.$refs.file.files[0];
    },
    handleChatFileUpload: function handleChatFileUpload() {
      this.chatFile = this.$refs.chatfile.files[0];
    }
  }
});

/***/ }),

/***/ "AL1U":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "AOhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHome_vue__ = __webpack_require__("dVTs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66623eb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHome_vue__ = __webpack_require__("lLha");
function injectStyle (ssrContext) {
  __webpack_require__("GTZH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66623eb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "APno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackOnline_vue__ = __webpack_require__("PHZp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da803dfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackOnline_vue__ = __webpack_require__("/41y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackOnline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da803dfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackOnline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ApCf":
/***/ (function(module, exports) {

module.exports = {"name":"weekstart","version":"1.0.1","description":"Library to get first day of week.","homepage":"https://github.com/gamtiq/weekstart","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","umd:main":"dist/main.js","keywords":["week","start","first","day","locale","country","region"],"devDependencies":{"@babel/preset-env":"7.6.3","eslint":"6.5.1","eslint-config-guard":"1.0.3","ink-docstrap":"1.3.2","jest":"24.9.0","jsdoc":"3.6.3","microbundle":"0.4.4","version-bump-prompt":"5.0.5"},"scripts":{"lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","test":"jest","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.json","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","all":"npm run check-all && npm run doc && npm run build","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json"},"author":{"name":"Denis Sikuler"},"repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"license":"MIT","types":"./index.d.ts"}

/***/ }),

/***/ "Aqjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_vm._l((_vm.consultations),function(cp,index){return _c('div',{key:index,staticClass:"flex flex-col px-3 px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight",class:(cp.consultationRequest.consultationRequestId === _vm.activePastConsultationRequestId) ? 'bg-grey-extralight' : '',on:{"click":function($event){return _vm.selectFromPastList(cp.consultation.consultationId, cp.consultationRequest.consultationRequestId)}}},[_c('div',{staticClass:"flex flex-row justify-between mb-2 h-4"},[_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"flex items-center h-4"},[_c('div',{staticClass:"text-sm font-semibold text-grey-darkest capitalize"},[_vm._v(_vm._s(cp.name))])])]),_vm._v(" "),(cp.isFamilyDoctor)?_c('div',[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-4"},[(_vm.consultStatus(cp))?_c('div',{staticClass:"text-xs font-semibold text-green-light font-light"},[_vm._v("Case Closed")]):_c('div',{staticClass:"text-xs font-semibold text-red-light font-light"},[_vm._v("Summary Pending")]),_vm._v(" "),_c('div',{staticClass:"text-xs ml-auto text-grey-dark font-light"},[_vm._v(_vm._s(_vm._f("formatDate")(cp.consultationRequest.date)))])])])}),_vm._v(" "),(_vm.showLoadMore)?_c('div',{staticClass:"flex flex-col h-12 justify-center"},[_c('div',{staticClass:"flex px-3 py-1 justify-end cursor-pointer italic rounded-sm text-blue text-sm hover:text-grey-darker",on:{"click":_vm.fetchMoreConsults}},[_vm._v("\n          Load more . . .\n        ")])]):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AwPR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARUSURBVHgBxVdNbBtFFH5vdhPFpXE24tggJkFCai/Z3FIuNUUgIUC4gl44EPtQ6oiDHfXA0Yk4IHExOdmCg10OXFCUcOBCBfjW5FSXA0ggxATl2MpOnMZ1vN7pm/V/kl2vHVf9JO/u7L6Z+Tzvve/NIBDmYuWklJAABANGCYSCBLkm0sGtk5/4ZwdhZLh5ooPAueVySpFBwJwN9V0YIWjMJbpyWccF8d3FQg+hWJEDsEjHll2jWwhmb5eLc7HDLDwH8EjRmI2VJY/tr/a1JRtlqys3jXplWhC56RJN4mnDbxVN0DSTSZyXCKDDi4auJ1FCWJFxmv3seaJowFMtDCD52RYoAOp5kZkWMAREevIGj1U4gEVxDHFPQmo5saL/3sg+9LDU4bXlw8i/6Yt3YRhSmYCgGCpRkLuvkMoClESGgaAsXBGZybybHZN6ygaZ47HyrpudWz/Zlhrk5AWazg02C6uVkdK60T2JGogvH4Q7/25a2FUrSmOVmJPmPlEfM2SP7tnO1d1lDEwVH6djg0VQYhK6fNjMpoLtGmen0dSlN1ttlfakW0mPFYKCCuSGgHnDCXwJJnMCfDCovk5Qozal2u6Eju2ccgOivslvHZpeA7KKnm3oWW0NBkVVzyJY/6GUCdV0dZlyA9WbKGlECjV4cFLglKo6D09VKMqSRLYi0kOkvrRWJGg/kTB+SDEV9kx78W1wi1xGrtNCrjpkQwku2DnxTbAEQ6AZo5Sh+5zqWVj32wFGCCmlMbtC/B3BbeC5lA6aKEQ3Tj+13YjTDze2Lbj0Ml5bTDsxojJLVfUFONJytP1oF3XfpWMQlJ7I7OaOxaPXx+LZ32rm9t91OKg4oRbKBjB0ZYYROQYfX9XXG+FQme309lE6BoXxEgoiwi/PMPPLH6unvt97CPD1pxPqMa8uqmS0vvUtHUNi7aNFPfRJqgIztBJ7j+2ejzON1RGI2N5BOrtVkBHymQGjiiGKnXjpCBJ/7tn87Xkd7v1hwQ+JAKz/fAw75LbJAMLi6xosXR8T0KXOCqTuuwxYXjJpKnE9NyEikyI3JdTkB0ey/d6886T9HH1rDOLvjytZWKDV6ZEHkQnmoJH2VDrY+QgRGb5x30qcFS/dyP5ag2AAjfh74yrNc633jX1QE1ifogE9Soc/RH55aPky3LhfU7e27jinDlUyWr9+pcMneLebvLD32LGbar84ruflhBZtNTulQ+1jUHsVhkOBMmdp5596X8MrrzjO2G+1Va2EHvc1S4dEe534JekoBIOePu7crc7fvKrDxnatr+3lSw6hrQ6BM89loIvM1CptPWk/Yy8hsoFOrptE5OYbOpAQwl97tqud0p/P3x1X+pNrv7Q1k0pHstdSCq+duy+oTPv/kf3gg68qRtklnjK3J+AdU4/2EHLBuQk1SUWIVOqL76tG8AJSijeCWD1TXVOiuEZkVv2MNRJCTVKcbolmU1X11i5zi8jkwSeeAQ+w1q9LGtCHAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Ayzh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B/Nb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B1mA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B5By":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorMain_vue__ = __webpack_require__("EC9m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed3cb52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorMain_vue__ = __webpack_require__("ow8U");
function injectStyle (ssrContext) {
  __webpack_require__("y9Oy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed3cb52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BBcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_pre_filled_medications__ = __webpack_require__("aqji");



// STATE
var state = {
  drugs: []

  // GETTERS
};var getters = {
  getSavedDrugs: function getSavedDrugs() {
    return state.drugs;
  }
};

// ACTIONS
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_1__api_pre_filled_medications__["a" /* default */].getSavedMedications().then(function (response) {
      if (response.status === 200) {
        commit('setUpMedications', response.body.doctor_saved_medications);
      }
    });
  },
  addToSavedDrugs: function addToSavedDrugs(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;
    var drug = _ref3.drug;

    delete __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(drug, { is_active: drug.isActive }).isActive;
    __WEBPACK_IMPORTED_MODULE_1__api_pre_filled_medications__["a" /* default */].addToSavedMedications({ doctor_saved_medication: drug }).then(function (response) {
      if (response.status === 200) {
        commit('addToSavedDrugs', response.body.doctor_saved_medication);
      }
    });
  },
  removeSavedDrug: function removeSavedDrug(_ref4, _ref5) {
    var commit = _ref4.commit;
    var drugId = _ref5.drugId;

    __WEBPACK_IMPORTED_MODULE_1__api_pre_filled_medications__["a" /* default */].removedSavedMedication(drugId).then(function (response) {
      if (response.status === 200) {
        commit('removeSavedDrug', drugId);
      }
    });
  },
  editSavedDrug: function editSavedDrug(_ref6, _ref7) {
    var commit = _ref6.commit,
        state = _ref6.state;
    var drugId = _ref7.drugId,
        medication = _ref7.medication,
        isCurrent = _ref7.isCurrent;

    var med = !medication ? isCurrent : medication;
    delete __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(med, { is_active: med.isActive }).isActive;
    __WEBPACK_IMPORTED_MODULE_1__api_pre_filled_medications__["a" /* default */].editSavedMedication({ doctor_saved_medication_id: drugId, med: { doctor_saved_medication: med } }).then(function (response) {
      if (response.status === 200) {
        commit('editSavedDrug', response.body.doctor_saved_medication);
      }
    });
  },
  reset: function reset(state) {
    state = {};
  }
};

// MUTATIONS
var mutations = {
  setUpMedications: function setUpMedications(state, savedDrugs) {
    state.drugs = savedDrugs;
  },
  addToSavedDrugs: function addToSavedDrugs(state, drug) {
    delete __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(drug, { isActive: drug.is_active }).is_active;
    state.drugs.push(drug);
  },
  removeSavedDrug: function removeSavedDrug(state, id) {
    state.drugs = state.drugs.filter(function (drug) {
      return drug.id !== id;
    });
  },
  editSavedDrug: function editSavedDrug(state, drug) {
    delete __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(drug, { isActive: drug.is_active }).is_active;
    var index = state.drugs.findIndex(function (med) {
      return med.id === drug.id;
    });
    state.drugs.splice(index, 1, drug);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Br3c":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNGNEUzQzMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC4zNjc1IDE4LjM2NzVDMTYuNzI1IDE5Ljk4NzUgMTQuNDc1IDIxIDEyIDIxQzkuNTI1IDIxIDcuMjc1IDE5Ljk4NzUgNS42MzI1IDE4LjM2NzVDNC4wMTI1IDE2LjcyNSAzIDE0LjQ3NSAzIDEyQzMgNy4wMjc1IDcuMDI3NSAzIDEyIDNDMTQuNDc1IDMgMTYuNzI1IDQuMDEyNSAxOC4zNjc1IDUuNjMyNUMxOS45ODc1IDcuMjc1IDIxIDkuNTI1IDIxIDEyQzIxIDE0LjQ3NSAxOS45ODc1IDE2LjcyNSAxOC4zNjc1IDE4LjM2NzVaTTEyLjkgNy40MDk5OUMxMi45IDYuOTE0OTkgMTIuNDk1IDYuNTA5OTkgMTIgNi41MDk5OUMxMS41MDUgNi41MDk5OSAxMS4xIDYuOTE0OTkgMTEuMSA3LjQwOTk5VjEzLjUzQzExLjEgMTQuMDI1IDExLjUwNSAxNC40MyAxMiAxNC40M0MxMi40OTUgMTQuNDMgMTIuOSAxNC4wMjUgMTIuOSAxMy41M1Y3LjQwOTk5Wk0xMiAxNS41MTAxQzEyLjQ5NSAxNS41MTAxIDEyLjkgMTUuOTE1MSAxMi45IDE2LjQxMDFWMTYuNTkwMUMxMi45IDE3LjA4NTEgMTIuNDk1IDE3LjQ5MDEgMTIgMTcuNDkwMUMxMS41MDUgMTcuNDkwMSAxMS4xIDE3LjA4NTEgMTEuMSAxNi41OTAxVjE2LjQxMDFDMTEuMSAxNS45MTUxIDExLjUwNSAxNS41MTAxIDEyIDE1LjUxMDFaIiBmaWxsPSIjNzA0MTFCIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "BsEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isCompanyDoctor: false,
      patientOnHold: true,
      isActive: true,
      isClosable: true
    };
  },

  created: function created() {},
  mounted: function mounted() {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    requests: 'consultationRequest/getRequests'
  })),
  methods: {
    accept: function accept(request) {
      this.$store.dispatch('consultationRequest/acceptConsultationRequest', request);
    },
    acceptQuery: function acceptQuery(request) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', request);
    }
  }
});

/***/ }),

/***/ "CMP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "CkZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientTests_vue__ = __webpack_require__("uMY/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f0c9f04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientTests_vue__ = __webpack_require__("/oPf");
function injectStyle (ssrContext) {
  __webpack_require__("X10z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f0c9f04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientTests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f0c9f04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientTests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cm8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center"},[_vm._m(0),_vm._v(" "),(_vm.isCredentialsTypeValid)?_c('form',{staticClass:"w-1/2 flex flex-col h-screen justify-center items-center",on:{"submit":function($event){return _vm.submit()}}},[_c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Back\n      ")]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n          Enter OTP\n        ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mb-8"},[_vm._v("OTP has been sent to your registered e-mail")]),_vm._v(" "),_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("\n          OTP\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mfa.otp_code),expression:"mfa.otp_code"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"otp","type":"text","placeholder":"Code","value":"","maxlength":"10","has-counter":false},domProps:{"value":(_vm.mfa.otp_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mfa, "otp_code", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"submit"}},[_vm._v("\n          Submit\n        ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.resendOTP}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Resend OTP")])])])])]):_c('form',{staticClass:"w-1/2 flex flex-col h-screen justify-center items-center",on:{"submit":function($event){return _vm.submit()}}},[_c('div',{staticClass:"bg-white shadow-md rounded px-16 w-96 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Back\n      ")]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n          Multi-factor Authentication\n        ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mb-8"},[_vm._v("Enter an MFA code to login")]),_vm._v(" "),_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("\n          MFA Code\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mfa.otp_code),expression:"mfa.otp_code"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"otp","type":"text","placeholder":"Code","value":"","maxlength":"10","has-counter":false},domProps:{"value":(_vm.mfa.otp_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mfa, "otp_code", $event.target.value)}}})]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-1/2 flex h-screen bg-blue justify-center items-center"},[_c('h1',{staticClass:"text-3xl font-semibold text-blue-lightest"},[_vm._v(" Doctor Dashboard ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"submit"}},[_vm._v("\n          Connect\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cnwp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAotJREFUeAHt27GOElEUh/GZKVCRWG6xnbY+AxWN2URb38DNbuVb+Aaa+AiWu8lmG2x4Bms7C0tDIFDM7D2JJGBguIsEzv/wTUJ2WYbk3t83A5chWxRsCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgictsDr6989u0VSKFUmY/CT+tmdjbdbTS9+fD4bq4y9bZwSAZbw+38nM4oSwX2ANfiLAypEBNcBWvDDRHAbIAM/RIRqMQtvP6f1029pTIvX/Lbh9e3N2YK17eT1MbcBmrL4lNByVzqyEdy+BNkR+/LqT79oSlt65h7dcm/MrgOcQgT3AaJHkAgQOYJMgF0jzOrem19fy4k93+PmdhW0Duvnlxejomwu0mPZq6NONb71vESVOgMWUSKtjiQDWIgoEWQDRIkgHSBCBPkA6hFCBFCOECaAaoRQARQjhAugFiFkAKUIYQMsRbhPv3ftfsY2OvS1I6lrQRmAK7uUddVZ+cP2O/Ptu+x3j7BnwKvL8aApm5vElXv0D9PR/+7QV05DBlDBt3MpXAAl/HAB1PBDBVDEDxNAFT9EAGV8+QDq+NIBIuDLBoiCLxngsfhNUXyf1723h/6Ea7g5m9S1oMfiJ4ChZ3wLJPNJeBf8Y1zbyTnql/eRCBAVX+IMiIzvPkB0fNcBTgHfArhdBaX/EfuYxuf6yxQD/N/NbYBZ/fx9mtwwY4JH+SYrY1xZu7heBZ1/aLpPqrF9rTjYMBtpfJuT6wA2wJYI8vgSATZECIEvE+CfCIXCJ1wbc7jNXo7sFm5iTAgBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgf0KPAAG+6pbh+KyiwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "D8sW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"w-full"},[_c('section',{staticClass:"bg-white flex flex-row rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"flex flex-col px-5"},[_c('div',[_c('div',{staticClass:"flex flex-row flex-no-shrink flex-no-grow py-2"},[_c('h3',{staticClass:"text-md"},[_vm._v(" Profile Picture ")]),_vm._v(" "),_c('div',{staticClass:"db-file-upload ml-auto"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"myFiles",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.changeProfileImage($event.target.files)}}}),_vm._v(" "),_c('span',{staticClass:"py-2 px-2 mr-1 justify-center cursor-pointer rounded-sm text-blue text-xs",attrs:{"alt":"attach_file"}},[_vm._v("Upload")])])])])]),_vm._v(" "),(_vm.doctor.photo)?_c('div',[_c('img',{staticClass:"w-64 h-64",attrs:{"src":_vm.doctor.photo.url}})]):_c('div',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"61px"}},[_vm._v("person")])])]),_vm._v(" "),_c('div',{staticClass:"border border-b border-grey-lightest my-5"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"flex flex-row flex-no-shrink flex-no-grow py-2"},[_c('h3',{staticClass:"text-md"},[_vm._v(" Signature ")]),_vm._v(" "),_c('div',{staticClass:"db-file-upload ml-auto"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"myFiles",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".pdf, .png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.changeSignatureImage($event.target.files)}}}),_vm._v(" "),_c('span',{staticClass:"py-2 px-2 mr-1 justify-center cursor-pointer rounded-sm text-blue text-xs",attrs:{"alt":"attach_file"}},[_vm._v("Upload")])])])])]),_vm._v(" "),(_vm.doctor.signature)?_c('div',[_c('img',{staticClass:"w-64 h-64",attrs:{"src":_vm.doctor.signature.url}})]):_vm._e()])]),_vm._v(" "),(_vm.showBackUpCodes)?_c('div',{staticClass:"w-1/2 flex flex-col justify-center items-center"},[_c('div',{staticClass:"w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('label',{staticClass:"block text-grey-darker text-xl font-semibold mb-2"},[_vm._v("\n        Multi-Factor Authentication\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-lg text-grey-dark mt-2 leading-normal font-semibold"},[_vm._v("Back-up Codes")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mt-4"},[_vm._v("keep this backup codes safe incase you lose access to the authenticator app")]),_vm._v(" "),_c('div',{staticClass:"ml-8 bg-grey-extralight rounded-m w-3/4 shadow-inner hover:shadow-sm p-6 mt-6"},[_c('p',{staticClass:"float-right w-8 text-sm cursor-pointer hover:underline font-semibold text-grey-dark",on:{"click":_vm.copyCodesToClip}},[_vm._v(_vm._s(_vm.copyCodes))]),_vm._v(" "),_c('div',{staticClass:"grid-container text-grey-darker ml-8 mt-2"},_vm._l((_vm.backUpCodes),function(item){return _c('div',{key:item,staticClass:"mt-4 grid-item"},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mt-8 mb-4"},[_vm._v("Multi-factor authentication has been set-up successfully")]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"submit"},on:{"click":_vm.goBackToProfile}},[_vm._v("\n            Back to profile\n          ")])])])]):_c('div',{staticClass:"w-1/2 flex flex-col justify-center items-center"},[(_vm.enableViaAuthApp)?_c('div',{staticClass:"w-2/3 flex flex-col justify-center items-center"},[_c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Back\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mt-6 mb-8"},[(_vm.showQR)?_c('div',[_c('img',{staticStyle:{"height":"184px","width":"184px","margin-left":"108px"},attrs:{"src":_vm.qrCode,"alt":"qr_code"}})]):_c('div',[_c('p',{staticClass:"mt-6 ml-12 text-grey-dark tracking-widest text-lg font-semibold uppercase"},[_vm._v(_vm._s(_vm.altCode))])])]),_vm._v(" "),_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mt-4 mb-2 uppercase tracking-widest"},[_vm._v("\n          Verification Code\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp_code),expression:"otp_code"}],staticClass:"shadow appearance-none border rounded w-1/2 py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"otp","type":"text","placeholder":"Code","value":"","maxlength":"10","has-counter":false},domProps:{"value":(_vm.otp_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otp_code=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.configMfaSettings}},[_vm._v("\n            Connect\n          ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.showMfaQr}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.showQRText))])])])])]):(_vm.enableViaOtp)?_c('div',{staticClass:"w-2/3 flex flex-col justify-center items-center"},[_c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Back\n        ")]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n            Enter OTP\n          ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mb-8"},[_vm._v("OTP has been sent to your registered e-mail")]),_vm._v(" "),_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("\n            OTP\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp_code),expression:"otp_code"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"otp","type":"text","placeholder":"Code","value":"","maxlength":"10","has-counter":false},domProps:{"value":(_vm.otp_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otp_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.configMfaSettings}},[_vm._v("\n            Submit\n          ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.viaOtp}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Resend OTP")])])])])]):_c('div',{staticClass:"w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n          Register a Verification Method\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark"},[_c('div',{staticClass:"border mb-2 rounded-m w-3/4 p-3 cursor-pointer hover:bg-blue-lightest",on:{"click":_vm.viaAuthenticatorApp}},[_c('h3',{staticClass:"text-base"},[_vm._v("Authenticator App")]),_vm._v(" "),_c('p',{staticClass:"text-sm"},[_vm._v("Connect an authenticator app")])]),_vm._v(" "),_c('div',{staticClass:"border rounded-m  p-3 w-3/4 cursor-pointer hover:bg-blue-lightest",on:{"click":_vm.viaOtp}},[_c('h3',{staticClass:"text-base"},[_vm._v("One Time Password Generator")]),_vm._v(" "),_c('p',{staticClass:"text-sm"},[_vm._v("Receive OTP on your registered e-mail")])])]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.goBackToProfile}},[_vm._v("\n          Cancel\n        ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"toaster"},[_c('toaster')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n            Connect an Authenticator App\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-4 text-grey-dark"},[_vm._v("\n            Connect an authenticator app that generates verification codes. You can use the codes when we need to verify your identity.\n          ")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark text-base"},[_c('ol',{staticClass:"order-list"},[_c('li',[_vm._v("Download and install an authenticator app on your mobile device.")]),_vm._v(" "),_c('li',[_vm._v("Use the app to scan this QR code.")]),_vm._v(" "),_c('li',[_vm._v("Enter the code generated by the app.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DBDo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DIK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_paginate__ = __webpack_require__("kBYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_good_wizard__ = __webpack_require__("9tqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_tab__ = __webpack_require__("eYEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_tab_dist_v_tab_css__ = __webpack_require__("Um5v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_tab_dist_v_tab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_tab_dist_v_tab_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { Tabs, TabPane } from 'vue-bulma-tabs'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('paginate', __WEBPACK_IMPORTED_MODULE_3_vuejs_paginate___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_good_wizard__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */]);

if (window.location.host === 'consultations.ekincare.com' || window.location.host === 'doctorstaging.ekincare.com') {
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = 'https://bluebox.ekincare.com/api';
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = 'Token token=-J199Y_I1K29TOeVkvLJUQ';
} else {
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = 'http://localhost:5000/api';
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = 'Token token=AZEo0h-6GFFVNZRLI16GXQ';
}




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_tab___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */]
    // Tabs,
    // TabPane
  },

  data: function data() {
    return {
      feets: null,
      inches: null,
      centemetres: null,
      radioAnswers: [],
      answersResponse: [],
      answers: [],
      questionIds: [],
      remarks: [],
      doctorFeedback: null,
      generalTab: true,
      questionsTab: false,
      declarationTab: false,
      feedbackTab: false,
      openMerForm: false,
      openRejectMerForm: false,
      showReasonModal: false,
      mer: {},
      rejectingMer: {},
      rejectedMer: {},
      inProgressMers: [],
      completedMers: [],
      rejectedMers: [],
      merQuestions: [],
      afterCallAttempt: true,
      afterCallConnected: false,
      afterCallNotConnected: false,
      showDoctorRemarksForm: false,
      callConnectedOptions: null,
      isMerCompleted: false,
      inProgressTotalPages: 0,
      completedTotalPages: 0,
      rejectedTotalPages: 0,
      doctorProfile: {},
      callConnected: false,
      steps: [{
        label: 'General Questions',
        slot: 'page1'
      }, {
        label: 'Questionnaire',
        slot: 'page2'
      }, {
        label: 'Declaration',
        slot: 'page3'
      }, {
        label: 'Feedbck',
        slot: 'page4'
      }]
    };
  },

  methods: {
    openMerModal: function openMerModal(mer) {
      this.mer = mer;
      this.remarks = [];
      this.fetchMerAnswers();
      this.fetchMerQuestions();
      this.afterCallConnected = false;
      this.afterCallNotConnected = false;
      this.showDoctorRemarksForm = false;
      this.isMerCompleted = false;
    },

    closeMerModal: function closeMerModal() {
      this.openMerForm = false;
      this.afterCallAttempt = true;
      this.mer = {};
      this.answers = [];
      this.answersResponse = [];
      this.callConnected = false;
    },

    openRejectMerModal: function openRejectMerModal(mer) {
      this.openRejectMerForm = true;
      this.rejectingMer = mer;
    },

    closeRejectMerModal: function closeRejectMerModal() {
      this.openRejectMerForm = false;
      this.rejectingMer = {};
    },

    showReason: function showReason(mer) {
      this.showReasonModal = true;
      this.rejectedMer = mer;
    },

    closeReason: function closeReason() {
      this.showReasonModal = false;
      this.rejectedMer = {};
    },

    openDoctorRemarksForm: function openDoctorRemarksForm(s, i) {
      this.showDoctorRemarksForm = true;
      this.callConnectedOptions = i;
      this.mer.status = 'in_progress';
      if (i === 0) {
        this.afterCallConnected = false;
        this.mer.call_status = 'Connected: ' + s;
      } else {
        this.afterCallNotConnected = false;
        this.mer.call_status = 'Not Connected: ' + s;
      }
    },

    openDoctorRemarksFormFor: function openDoctorRemarksFormFor(s, i) {
      var _this = this;
      this.openDoctorRemarksForm(s, i);
      this.mer.reason_for_reject = s;
      var data = {
        mer_application: {
          call_status: this.mer.call_status,
          reason_for_reject: this.mer.reason_for_reject
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + this.mer.id + '/reject', data).then(function (response) {
        _this.$toast.open({
          message: _this.call_status + ', hence rejected',
          type: 'is-danger',
          position: 'is-bottom'
        });
        _this.fetchMers('in_progress', _this.page);
        _this.fetchMers('rejected', 1);
        _this.closeMerModal();
      }).catch(function (error) {
        console.log(error);
        _this.$toast.open({
          message: 'Something went wrong',
          type: 'is-danger',
          position: 'is-bottom'
        });
      });
    },

    backFromRemarksForm: function backFromRemarksForm() {
      if (this.callConnectedOptions === 0) {
        this.showDoctorRemarksForm = false;
        this.afterCallConnected = true;
      } else {
        this.showDoctorRemarksForm = false;
        this.afterCallNotConnected = true;
      }
    },

    saveDoctorRemarks: function saveDoctorRemarks() {
      var _this = this;
      var callStatus = this.mer.call_status;
      this.showDoctorRemarksForm = false;
      this.afterCallAttempt = true;

      var remarksData = {
        mer_application: {
          call_status: callStatus,
          doctor_remarks: this.mer.doctor_remarks
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + this.mer.id + '/doctor-remarks', remarksData).then(function (response) {
        _this.fetchMers('in_progress', _this.page);
        _this.fetchMers('rejected', 1);
        _this.fetchMers('completed', 1);
        _this.closeMerModal();
        _this.$toast.open({
          message: 'Remarks saved successfully!',
          type: 'is-success',
          position: 'is-bottom'
        });
        //        console.log(response.data)
      }).catch(function (error) {
        _this.$toast.open({
          message: 'Something went wrong while saving remaks',
          type: 'is-danger',
          position: 'is-bottom'
        });
        console.log(error);
      });
    },

    submitMerForm: function submitMerForm() {
      var _this = this;
      var answersArr = [];
      var merAnswersData = {};
      this.merQuestions.forEach(function (question, index) {
        var merAnwerData = {};
        merAnwerData['mer_question_id'] = question.id;
        merAnwerData['answer'] = _this.answers[index];
        merAnwerData['remarks'] = _this.remarks[index];
        answersArr.push(merAnwerData);
      });
      merAnswersData['mer_answers'] = answersArr;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/mer_applications/' + this.mer.id + '/mer_answers/create', merAnswersData).then(function (response) {}).catch(function (error) {
        _this.$toast.open({
          message: 'Something went wrong while submitting MER',
          type: 'is-danger',
          position: 'is-bottom'
        });
        console.log(error.data, 'error');
      });

      var generalQuestionsData = {
        mer_application: {
          height_in_feet: this.mer.height_in_feet,
          height_in_inches: this.mer.height_in_inches,
          height_in_cms: this.mer.height_in_cms,
          weight: this.mer.weight,
          submitted: 'true'
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + _this.mer.id, generalQuestionsData).then(function (response) {
        //        console.log(response.data.data, 'mer submitted successfully!')
        _this.mer.submitted = true;
      }).catch(function (error) {
        console.log(error.data, 'genralquestions err');
      });
    },

    updateMerForm: function updateMerForm() {
      var _this = this;
      var answersArr = [];
      var merAnswersData = {};
      this.answersResponse.forEach(function (answer, index) {
        var merAnwerData = {};
        merAnwerData['id'] = answer.id;
        merAnwerData['mer_question_id'] = answer.mer_question_id;
        merAnwerData['answer'] = _this.answers[index];
        merAnwerData['remarks'] = _this.remarks[index];
        answersArr.push(merAnwerData);
      });
      merAnswersData['mer_answers'] = answersArr;
      //      console.log(merAnswersData, 'ansData')
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + this.mer.id + '/update_mer_answers', merAnswersData).then(function (response) {}).catch(function (error) {
        _this.$toast.open({
          message: 'Something went wrong while updating MER',
          type: 'is-danger',
          position: 'is-bottom'
        });
        console.log(error.data, 'error');
      });

      var generalQuestionsData = {
        mer_application: {
          height_in_feet: this.mer.height_in_feet,
          height_in_inches: this.mer.height_in_inches,
          height_in_cms: this.mer.height_in_cms,
          weight: this.mer.weight,
          submitted: 'true'
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + _this.mer.id, generalQuestionsData).then(function (response) {
        //        console.log(response.data.data, 'mer updated successfully!')
      }).catch(function (error) {
        console.log(error.data, 'mer update err');
      });
    },

    submitFeedback: function submitFeedback() {
      var _this = this;
      var generalQuestionsData = {
        mer_application: {
          feedback: this.mer.feedback,
          call_status: this.mer.call_status
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + _this.mer.id + '/feedback', generalQuestionsData).then(function (response) {
        //        console.log(response.data.data, 'mer updated successfully!')
        _this.$toast.open({
          message: 'MER completed successfully!',
          type: 'is-success',
          position: 'is-bottom'
        });
        _this.fetchMers('in_progress', _this.page);
        _this.fetchMers('completed', 1);
        _this.fetchMers('rejected', 1);
        _this.closeMerModal();
      }).catch(function (error) {
        console.log(error.data, 'mer update err');
      });
    },

    fetchMerAnswers: function fetchMerAnswers() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/mer_applications/' + this.mer.id + '/mer_answers').then(function (response) {
        //        console.log(response.data.data, 'answers')
        response.data.data.forEach(function (answer, index) {
          _this.answersResponse[index] = answer;
          _this.answers[index] = answer.answer;
          _this.remarks[index] = answer.remarks;
        });
        _this.openMerForm = true;
      }).catch(function (error) {
        console.log(error.data);
      });
    },

    rejectMer: function rejectMer() {
      var _this = this;
      var rejectingmerData = {
        mer_application: {
          reason_for_reject: this.rejectingMer.reason_for_reject,
          call_status: this.rejectingMer.call_status
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + this.rejectingMer.id + '/reject', rejectingmerData).then(function (response) {
        //        console.log('mer rejected successfully!')
        _this.closeRejectMerModal();
        _this.fetchMers('in_progress', _this.page);
        _this.fetchMers('rejected', 1);
        _this.$toast.open({
          message: 'MER rejected successfully!',
          type: 'is-success',
          position: 'is-bottom'
        });
      }).catch(function (error) {
        console.log(error, 'mer reject error');
      });
    },

    verificationIncorrect: function verificationIncorrect() {
      var _this = this;
      var verificationIncorrectData = {
        mer_application: {
          call_status: this.mer.call_status,
          reason_for_reject: 'verification incorrect'
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + this.mer.id + '/reject', verificationIncorrectData).then(function (response) {
        _this.$toast.open({
          message: 'Verification Incorrect',
          type: 'is-danger',
          position: 'is-bottom'
        });
        _this.fetchMers('in_progress', _this.page);
        _this.fetchMers('rejected', 1);
        _this.closeMerModal();
      }).catch(function (error) {
        console.log(error);
        _this.$toast.open({
          message: 'Something went wrong',
          type: 'is-danger',
          position: 'is-bottom'
        });
      });
    },

    checkupAlreadyDone: function checkupAlreadyDone() {
      var _this = this;
      var checkupAlreadyDoneData = {
        mer_application: {
          call_status: this.mer.call_status,
          reason_for_reject: 'Medical checkup already done'
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + this.mer.id + '/reject', checkupAlreadyDoneData).then(function (response) {
        _this.$toast.open({
          message: 'Medical checkup already done',
          type: 'is-danger',
          position: 'is-bottom'
        });
        _this.fetchMers('in_progress', _this.page);
        _this.fetchMers('rejected', 1);
        _this.closeMerModal();
      }).catch(function (error) {
        console.log(error);
        _this.$toast.open({
          message: 'Something went wrong',
          type: 'is-danger',
          position: 'is-bottom'
        });
      });
    },

    showCallConnectedResult: function showCallConnectedResult() {
      this.afterCallAttempt = false;
      this.afterCallConnected = true;
      this.callConnected = true;
    },

    showCallNotConnectedResult: function showCallNotConnectedResult() {
      this.afterCallAttempt = false;
      this.afterCallNotConnected = true;
    },

    backToConnected: function backToConnected() {
      this.afterCallAttempt = true;
      this.afterCallConnected = false;
    },

    backToNotConnected: function backToNotConnected() {
      this.afterCallAttempt = true;
      this.afterCallNotConnected = false;
    },

    nextPageInProgressMers: function nextPageInProgressMers(pageNum) {
      this.page = pageNum;
      this.fetchMers('in_progress', pageNum);
    },

    nextPageCompletedMers: function nextPageCompletedMers(pageNum) {
      this.fetchMers('completed', pageNum);
    },

    nextPageRejectedMers: function nextPageRejectedMers(pageNum) {
      this.fetchMers('rejected', pageNum);
    },

    fetchMers: function fetchMers(status, page) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/mer_applications?status=' + status + '&page=' + page).then(function (response) {
        if (status === 'in_progress') {
          _this.inProgressMers = response.data.data;
          _this.inProgressTotalPages = response.data.total_pages;
        } else if (status === 'completed') {
          _this.completedMers = response.data.data;
          _this.completedTotalPages = response.data.total_pages;
        } else if (status === 'rejected') {
          _this.rejectedMers = response.data.data;
          _this.rejectedTotalPages = response.data.total_pages;
        }
      }).catch(function (error) {
        console.log(error.response);
      });
    },

    fetchMerQuestions: function fetchMerQuestions() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/mer_questions?gender=' + _this.mer.pi_gender).then(function (response) {
        _this.merQuestions = response.data.data;
        //        console.log(_this.merQuestions, 'merquestions')
      }).catch(function (error) {
        console.log(error.response);
      });
    },

    availableCallAttempts: function availableCallAttempts(mer) {
      var callCount = mer.total_call_attempts - mer.attempted_calls;
      return callCount <= 0 ? 0 : callCount;
    },

    convertToCms: function convertToCms() {
      var feet = this.mer.height_in_feet || 0;
      var inches = this.mer.height_in_inches || 0;
      var cms = parseInt(feet * 30.48 + inches * 2.54);
      this.mer.height_in_cms = cms;
    },

    convertToFeet: function convertToFeet() {
      var heightInCms = this.mer.height_in_cms || 0;
      var heightInFt = heightInCms * 0.0328;
      var ftInteger = parseInt(heightInFt);
      var heightInInches = parseInt((heightInFt - ftInteger) * 12);
      this.mer.height_in_feet = ftInteger;
      this.mer.height_in_inches = heightInInches;
    },

    nextClicked: function nextClicked(currentPage) {
      var _this2 = this;

      var _this = this;
      //      console.log(currentPage, 'current page')
      if (currentPage === 0) {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            var medicalCheckVerification = _this.mer.medical_check_verification;
            var customerNameVerfication = _this.mer.customer_name_verification;
            var genderVerification = _this.mer.gender_verification;
            var dobVerification = _this.mer.dob_verification;
            var occupationVerification = _this.mer.occupation_verification;
            if (customerNameVerfication === 'incorrect' || genderVerification === 'incorrect' || dobVerification === 'incorrect' || occupationVerification === 'incorrect') {
              _this.verificationIncorrect();
            } else if (medicalCheckVerification === 'yes') {
              _this.checkupAlreadyDone();
            } else {
              var generalQuestionsData = {
                mer_application: {
                  nominee_name: _this2.mer.nominee_name,
                  customer_name_verification: _this2.mer.customer_name_verification,
                  gender_verification: _this2.mer.gender_verification,
                  dob_verification: _this2.mer.dob_verification,
                  martial_status: _this2.mer.martial_status,
                  occupation_verification: _this2.mer.occupation_verification,
                  secret_answer: _this2.mer.secret_answer,
                  medical_check_verification: _this2.mer.medical_check_verification,
                  doctor: { name: _this2.doctorProfile.name, registration_no: _this2.doctorProfile.registration_number, signature: _this2.doctorProfile.signature }
                }
              };
              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/mer_applications/' + _this.mer.id, generalQuestionsData).then(function (response) {
                //                console.log(response.data.data, 'mer submitted successfully!')
                _this.$refs.wizard.goNext(true);
              }).catch(function (error) {
                console.log(error.data, 'genralquestions err');
                _this.$toast.open({
                  message: 'Something went wrong',
                  type: 'is-danger',
                  position: 'is-bottom'
                });
              });
            }
          }
        });
        return false;
      } else if (currentPage === 1) {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            if (!_this2.mer.submitted) {
              _this.submitMerForm();
              _this.$refs.wizard.goNext(true);
            } else {
              _this.updateMerForm();
              _this.$refs.wizard.goNext(true);
            }
          }
        });
      } else if (currentPage === 2) {
        return true;
      } else if (currentPage === 3) {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            _this.submitFeedback();
          }
        });
      }
      return false;
    },
    backClicked: function backClicked(currentPage) {
      //      console.log('back clicked', currentPage)
      return true;
    }
  },

  created: function created() {
    var _this = this;
    this.page = 1;
    this.fetchMers('in_progress', 1);
    this.fetchMers('completed', 1);
    this.fetchMers('rejected', 1);
    this.$http.get(window.API_URL + 'doctors/profile').then(function (response) {
      _this.doctorProfile = response.body.doctor;
    }).catch(function (error) {
      console.log(error);
    });
  },

  computed: {
    inProgressMerCount: function inProgressMerCount() {
      return this.inProgressMers.length;
    },

    completedMerCount: function completedMerCount() {
      return this.completedMers.length;
    },

    rejectedMerCount: function rejectedMerCount() {
      return this.rejectedMers.length;
    }

  }

});

/***/ }),

/***/ "DK5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  data: function data() {
    return {
      query: {},
      search: {
        email: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        customer_id: '',
        employee_id: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    searchResult: 'offlineConsultation/searchResult'
  })),
  mounted: function mounted() {},

  methods: {
    getMobileNo: function getMobileNo(result) {
      if (result.mobile_number && this.search.mobile_number === result.mobile_number) {
        return result.mobile_number;
      } else if (result.alternative_mobile_number && this.search.mobile_number === result.alternative_mobile_number) {
        return result.alternative_mobile_number;
      } else {
        return result.mobile_number ? result.mobile_number : result.alternative_mobile_number;
      }
    },
    onSearchInput: function onSearchInput(e, key) {
      var that = this;
      if (key === 'first_name' || key === 'last_name') {
        this.search.email = '';
        this.search.customer_id = '';
        this.search.mobile_number = '';
        this.search.employee_id = '';
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.query).forEach(function (o) {
          if (o !== 'first_name' || o !== 'last_name') {
            delete that.query[o];
          }
        });
        if (e.target.value && e.target.value.trim() !== '') {
          this.query[key] = e.target.value.trim();
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(that.search).forEach(function (o) {
          if (o !== key) {
            that.search[o] = '';
          }
        });
        if (e.target.value && e.target.value.trim() !== '') {
          that.query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, e.target.value);
        }
      }
    },
    description: function description(obj) {
      return obj.first_name + ' ' + obj.last_name + ' ' + obj.email + ' ' + obj.mobile_number + ' ' + obj.employee_id;
    },
    fetchCustomers: function fetchCustomers(e) {
      e.preventDefault();
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.query).length > 0) {
        this.$store.dispatch('offlineConsultation/fetchCustomers', this.query);
      }
    },
    closeModal: function closeModal() {
      this.query = {};
      this.$emit('closeSearchModal');
    },
    addNewCustomer: function addNewCustomer(c) {
      this.$emit('addNewCustomer', c);
      this.closeModal();
    }
  }
});

/***/ }),

/***/ "Dm+L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index_js__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_ably__ = __webpack_require__("oKrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_doctor__ = __webpack_require__("4mdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Notification_DoctorNotification__ = __webpack_require__("iJrm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DoctorNotification: __WEBPACK_IMPORTED_MODULE_5__components_Notification_DoctorNotification__["a" /* default */]
  },
  data: function data() {
    return {
      doctorName: sessionStorage.getItem('name'),
      currentStatus: sessionStorage.getItem('chatstatus') ? sessionStorage.getItem('chatstatus') : 'unavailable',
      company_id: JSON.parse(sessionStorage.getItem('company_id')),
      logOut: false,
      showNotification: false,
      showQueryPopUp: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    doctor: 'configuration/doctor',
    role: 'configuration/getRole',
    activeConsultsCount: 'consultation/activeConsultsCount',
    notViewedNotificationCount: 'notification/getNotViewedCount',
    notification: 'notification/getLatestNotification',
    queries: 'consultationRequest/getQueries'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    connectivityStatus: function connectivityStatus(state) {
      return state.configuration.connectivityStatus;
    },
    availableForChat: function availableForChat(state) {
      return state.configuration.availableForChat;
    },
    isCompanyDoctor: function isCompanyDoctor(state) {
      return state.configuration.isCompanyDoctor;
    }
  }), {
    ablyStatus: function ablyStatus() {
      if (this.connectivityStatus === 'suspended' || this.connectivityStatus === 'failed') {
        return false;
      } else {
        return true;
      }
    },
    ablyDisconnected: function ablyDisconnected() {
      if (this.connectivityStatus === 'suspended' || this.connectivityStatus === 'failed' || this.connectivityStatus === 'disconnected' || this.connectivityStatus === 'not_connected') {
        return true;
      } else {
        return false;
      }
    },

    ablyConnected: function ablyConnected() {
      if (this.connectivityStatus === 'connected') {
        return true;
      } else {
        return false;
      }
    },

    ablyStatusText: function ablyStatusText() {
      if (this.connectivityStatus === 'connecting') {
        return 'Connecting';
      } else if (this.connectivityStatus === 'connected') {
        return 'Connected';
      } else if (this.connectivityStatus === 'disconnected') {
        return 'Disconnected';
      } else {
        return 'Disconnected';
      }
    }
  }),
  methods: {
    goHome: function goHome() {
      if (window.location.pathname === '/home') {
        window.location.reload();
        return;
      }
      window.location.href = '/home';
    },
    enquireNow: function enquireNow(menu) {
      this.showNotification = false;
    },
    closeQueryPopUp: function closeQueryPopUp() {
      this.showQueryPopUp = false;
    },
    updateActiveStatus: function updateActiveStatus(value) {
      var _this = this;

      var status = value ? 2 : 3;
      __WEBPACK_IMPORTED_MODULE_4__api_doctor__["a" /* default */].activityStatus({ status: status }).then(function (response) {
        var value = response.data.status.availability;
        if (response.status === 200) {
          if (_this.queries.length > 0 && value === true) {
            _this.showQueryPopUp = true;
          }
          _this.$store.dispatch('configuration/setChatAvailability', value);
        }
      });
    },
    connectToAbly: function connectToAbly() {
      this.$store.dispatch('configuration/establishAblyConnection');
    },
    logoutClicked: function logoutClicked() {
      this.logOut = true;
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_doctor__["a" /* default */].signout().then(function (response) {
        if (response.status === 200) {
          __WEBPACK_IMPORTED_MODULE_2__core_ably__["a" /* default */].close();
          _this2.$store.dispatch('clearAll');
          sessionStorage.clear();
          __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].push({ path: 'login' });
        }
      });
    },
    closeLogoutOverlay: function closeLogoutOverlay() {
      this.logOut = false;
    },
    toggleNotification: function toggleNotification() {
      this.showNotification = !this.showNotification;
      if (this.showNotification && this.notification) {
        this.$store.dispatch('notification/updateViewed', this.notification.id);
      }
    }
  }
});

/***/ }),

/***/ "Dsin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_COVID_19_LeftPane__ = __webpack_require__("6fnu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_covid19__ = __webpack_require__("l4MF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LeftPane: __WEBPACK_IMPORTED_MODULE_0__components_COVID_19_LeftPane__["a" /* default */]
  },
  data: function data() {
    return {
      selectedPatient: {
        id: null,
        name: '',
        email: '',
        mobile_number: '',
        response: {
          age: null,
          gender: 'male'
        },
        sendPrescription: false,
        summary: '',
        address: '',
        provisional_diagnosis: ''
      },
      responseData: [],
      selectedTab: 'pending',
      status: null,
      showPopup: false
    };
  },

  computed: {
    answer3: function answer3() {
      if (this.selectedPatient.response['2']) {
        try {
          return JSON.parse(this.selectedPatient.response['2']).join(', ');
        } catch (err) {
          return null;
        }
      }
      return null;
    },
    answer4: function answer4() {
      if (this.selectedPatient.response['3']) {
        try {
          return JSON.parse(this.selectedPatient.response['3']).join(', ');
        } catch (err) {
          return null;
        }
      }
      return null;
    },
    answer5: function answer5() {
      if (this.selectedPatient.response['4']) {
        try {
          return JSON.parse(this.selectedPatient.response['4']).join(', ');
        } catch (err) {
          return null;
        }
      }
      return null;
    }
  },
  mounted: function mounted() {
    this.getContacts();
  },

  methods: {
    openPopup: function openPopup() {
      this.showPopup = true;
    },
    closeOverlay: function closeOverlay() {
      this.showPopup = false;
    },
    getContacts: function getContacts() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__api_covid19__["a" /* default */].index(this.status).then(function (response) {
        if (response.status === 200) {
          that.selectedPatient = {
            id: null,
            name: '',
            email: '',
            mobile_number: '',
            response: {
              age: null,
              gender: 'male'
            },
            sendPrescription: false,
            summary: ''
          };
          if (response.body.customer && response.body.customer.length > 0 && that.selectedTab !== 'covid-new') {
            that.responseData = response.body.customer;
            that.selectedPatient = response.body.customer[0];
          } else {
            that.responseData = response.body.customer;
            that.selectedPatient = {
              id: null,
              name: '',
              email: '',
              mobile_number: '',
              response: {
                age: null,
                gender: 'male'
              }
            };
          }
        }
      });
    },
    tabChange: function tabChange(tab) {
      this.selectedTab = tab;
      if (this.selectedTab === 'completed') {
        this.status = 'done';
      } else if (this.selectedTab === 'covid-new') {
        this.status = 'new';
        this.selectedPatient = {
          id: null,
          name: '',
          email: '',
          mobile_number: '',
          response: {
            age: null,
            gender: 'male'
          }
        };
      } else {
        this.status = null;
      }
      this.getContacts();
    },
    markAsDone: function markAsDone(status) {
      if (this.selectedPatient.name && this.selectedPatient.name.trim() !== '' && this.selectedPatient.email && this.selectedPatient.email.trim() !== '' && this.selectedPatient.summary && this.selectedPatient.summary.trim() !== '' && this.selectedPatient.address && this.selectedPatient.address.trim() !== '' && this.selectedPatient.provisional_diagnosis && this.selectedPatient.provisional_diagnosis.trim() !== '' && (this.selectedPatient.mobile_number && this.selectedPatient.mobile_number.trim() !== '' || this.status !== 'new')) {
        var payload = {
          name: this.selectedPatient.name,
          email: this.selectedPatient.email,
          age: this.selectedPatient.response.age,
          gender: this.selectedPatient.response.gender,
          summary: this.selectedPatient.summary,
          provisional_diagnosis: this.selectedPatient.provisional_diagnosis,
          address: this.selectedPatient.address,
          send_prescription: this.selectedPatient.sendPrescription,
          status: status
        };
        if (this.status === 'new') {
          payload['mobile_number'] = this.selectedPatient.mobile_number;
          return this.createHandler(payload);
        } else {
          return this.updateStatusHandler(payload);
        }
      } else {
        this.$toast.open({
          message: 'Please fill all mandatory fields',
          type: 'warning',
          position: 'top',
          queue: false
        });
      }
    },
    updateStatusHandler: function updateStatusHandler(payload) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__api_covid19__["a" /* default */].update({ id: this.selectedPatient.id, params: payload }).then(function (response) {
        if (response.status === 200) {
          that.getContacts();
        }
      });
    },

    createHandler: function createHandler(payload) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1__api_covid19__["a" /* default */].create({ params: payload }).then(function (response) {
        if (response.status === 200) {
          _this.getContacts();
        }
      });
    },

    popupStatus: function popupStatus() {
      this.closeOverlay();
      this.updateStatusHandler({ status: 'no_answer' });
    },
    selectFromList: function selectFromList(item) {
      this.selectedPatient = item;
    }
  }
});

/***/ }),

/***/ "DtAb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMwOTUxRTEiLz4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjQiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "EC9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Admin_AdminNavbar__ = __webpack_require__("wYs7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Chat_ChatPane__ = __webpack_require__("uG7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MiniMenu__ = __webpack_require__("x+Yt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Admin_AdminLeftPane__ = __webpack_require__("jZmd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RightPane__ = __webpack_require__("2f92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ChatPane: __WEBPACK_IMPORTED_MODULE_2__components_Chat_ChatPane__["a" /* default */],
    AdminNavbar: __WEBPACK_IMPORTED_MODULE_1__components_Admin_AdminNavbar__["a" /* default */],
    AdminLeftPane: __WEBPACK_IMPORTED_MODULE_4__components_Admin_AdminLeftPane__["a" /* default */],
    RightPane: __WEBPACK_IMPORTED_MODULE_5__components_RightPane__["a" /* default */],
    MiniMenu: __WEBPACK_IMPORTED_MODULE_3__components_MiniMenu__["a" /* default */]
  },
  data: function data() {
    return {
      selectedRightTab: 'patient-history',
      showRightPane: false,
      consultRequests: [],
      othersAcceptedRequests: [],
      cancelledRequests: [],
      showToggleButton: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    isActiveChatPresent: 'consultation/isActiveChatPresent',
    isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
    requests: 'consultationRequest/getRequests',
    alreadyAssignedRequests: 'consultationRequest/getOthersAcceptedRequest',
    patientCancelledRequests: 'consultationRequest/getCancelledRequest',
    activeSection: 'configuration/getActiveSection'
  }), {
    incomingRequests: function incomingRequests() {
      this.consultRequests = this.requests;
      this.othersAcceptedRequests = this.alreadyAssignedRequests;
      this.cancelledRequests = this.patientCancelledRequests;
      return this.requests;
    },
    isActiveChat: function isActiveChat() {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true;
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true;
      }
      return false;
    }
  }),
  methods: {
    tabChange: function tabChange(tab) {
      this.showRightPane = true;
      this.selectedRightTab = tab;
    },
    toggleRightPane: function toggleRightPane(state) {
      this.showRightPane = state;
    }
  }
});

/***/ }),

/***/ "EDgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("bZyC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55457179_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("0xqD");
function injectStyle (ssrContext) {
  __webpack_require__("oKlt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55457179"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55457179_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZCc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncomingRequests_vue__ = __webpack_require__("BsEF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5d71354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncomingRequests_vue__ = __webpack_require__("iQwr");
function injectStyle (ssrContext) {
  __webpack_require__("5JOj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncomingRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5d71354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncomingRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EqWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Appointments_AppointmentTable__ = __webpack_require__("SSuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Appointments_RequestedAppointmentTable__ = __webpack_require__("REiN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_appointments__ = __webpack_require__("5tu9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_toast_notification___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppointmentTable: __WEBPACK_IMPORTED_MODULE_1__components_Appointments_AppointmentTable__["a" /* default */],
    RequestedAppointmentTable: __WEBPACK_IMPORTED_MODULE_2__components_Appointments_RequestedAppointmentTable__["a" /* default */]
  },
  name: 'Appointments',
  data: function data() {
    return {
      data: {},
      showOptions: false,
      showSlots: false,
      selectedDoctor: '',
      selectDoctorId: null,
      selectedSlot: '',
      doctorsList: [],
      doctorsListCopy: [],
      slotsList: [],
      intervalIds: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    activeTab: 'appointmentRequest/getActiveTab',
    showModal: 'appointmentRequest/getDoctorAssignModalHandler',
    selectedAppointment: 'appointmentRequest/getSelectedAppointment',
    role: 'configuration/getRole'
  })),
  methods: {
    searchDoctors: function searchDoctors() {
      var search = this.selectedDoctor.toLowerCase().replace(/\s+/g, '');
      if (search.length > 0) {
        this.doctorsList = this.doctorsListCopy.filter(function (obj) {
          var doctorName = obj.name.toLowerCase().replace(/\s+/g, '');
          if (doctorName.includes(search)) {
            return obj;
          }
        });
      } else {
        this.doctorsList = this.doctorsListCopy;
      }
    },
    toggleDropdown: function toggleDropdown() {
      this.showOptions = !this.showOptions;
    },
    selectTab: function selectTab(tab) {
      this.$store.dispatch('appointmentRequest/updateActiveTab', tab);
      this.fetchAppointment(tab);
    },
    selectDoctor: function selectDoctor(data) {
      this.slotsList = [];
      this.selectedSlot = '';
      this.showSlots = false;
      this.showOptions = false;
      var selectedOrSearchDr = this.doctorsList.find(function (obj) {
        if (obj.doctor_id === data.doctor_id) {
          return obj || {};
        }
      });
      this.selectedDoctor = selectedOrSearchDr.name;
      this.selectDoctorId = selectedOrSearchDr.doctor_id;
      this.getSlots(selectedOrSearchDr);
    },
    selectSlot: function selectSlot(slot) {
      this.selectedSlot = slot;
    },
    groupedAppointments: function groupedAppointments(data) {
      return data.reduce(function (acc, appointment) {
        var date = appointment.date_string;
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(appointment);
        return acc;
      }, {});
    },
    getAppointments: function getAppointments(tab) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__api_appointments__["a" /* default */].fetch(tab, false, this.role).then(function (response) {
        if (response.status === 200) {
          _this.data = _this.role === 'externalAdmin' || _this.role === 'specialistDoctor' ? _this.groupedAppointments(response.body.appointment_requests) : response.body.appointment_requests;
        } else {
          _this.$toast.open({ message: 'Something went wrong', type: 'error', position: 'top', queue: false });
        }
      }, function (response) {
        _this.$toast.open({ message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false });
      });
    },
    fetchAppointment: function fetchAppointment(tab) {
      var _this2 = this;

      if (tab === 'requested' && this.role === 'externalAdmin' || tab === 'scheduled' && this.role === 'specialistDoctor') {
        this.getAppointments(tab);
        var intervalId = setInterval(function () {
          _this2.getAppointments(tab);
        }, 20000);
        this.intervalIds.push(intervalId);
      } else if (tab !== 'requested') {
        this.intervalIds.forEach(function (intervalId) {
          return clearInterval(intervalId);
        });
        this.intervalIds = [];
        return this.getAppointments(tab);
      }
    },
    closeModal: function closeModal() {
      this.$store.dispatch('appointmentRequest/toggleAssignModal');
      this.showOptions = false;
      this.showSlots = false;
      this.selectedDoctor = '';
      this.doctorsList = this.doctorsListCopy;
    },
    getDoctorList: function getDoctorList() {
      var _this3 = this;

      var obj = { id: this.selectedAppointment.id };
      __WEBPACK_IMPORTED_MODULE_6__api_appointments__["a" /* default */].doctorList(obj).then(function (response) {
        if (response.status === 200) {
          _this3.doctorsList = response.body.doctors;
          _this3.doctorsListCopy = response.body.doctors;
          if (_this3.selectedAppointment.doctor_id) {
            _this3.selectDoctor(_this3.selectedAppointment);
          }
        } else {
          _this3.$toast.open({ message: 'Something went wrong', type: 'error', position: 'top', queue: false });
        }
      }, function (response) {
        _this3.$toast.open({ message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false });
      });
    },
    getSlots: function getSlots(doctor) {
      var _this4 = this;

      var body = {
        provider_id: doctor.provider_id,
        booking_date: this.selectedAppointment.booking_date,
        benefit_type: 'specialist_consultation'
      };
      __WEBPACK_IMPORTED_MODULE_6__api_appointments__["a" /* default */].slotsList(body).then(function (response) {
        if (response.status === 200) {
          _this4.slotsList = response.body.slots;
          _this4.showSlots = _this4.slotsList.length > 0;
          !_this4.showSlots && _this4.$toast.open({ message: 'Slots not found', type: 'warning', position: 'top', queue: false });
        } else {
          _this4.$toast.open({
            message: 'Something went wrong',
            type: 'error',
            position: 'top',
            queue: false
          });
        }
      }, function (response) {
        _this4.$toast.open({ message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false });
        _this4.showSlots = false;
      });
    },
    updateRemark: function updateRemark(object) {
      var _this5 = this;

      var obj = {
        id: object.id,
        doctor_comments: object.remark
      };
      __WEBPACK_IMPORTED_MODULE_6__api_appointments__["a" /* default */].updateRemark(obj).then(function (response) {
        if (response.status === 200) {
          _this5.fetchAppointment(_this5.activeTab);
        } else {}
      }, function (response) {});
    },
    updateAppointmentStatus: function updateAppointmentStatus(payload) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_appointments__["a" /* default */].spcApttSatusChange(payload).then(function (response) {
        _this6.fetchAppointment(_this6.activeTab);
        if (response.status === 200) {
          _this6.$toast.open({ message: 'Status updated successfully', type: 'success', position: 'top', queue: false });
        } else {
          _this6.$toast.open({ message: 'Something went wrong', type: 'error', position: 'top', queue: false });
        }
      }, function (response) {
        _this6.fetchAppointment(_this6.activeTab);
        _this6.$toast.open({ message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false });
      });
    },
    updateStatus: function updateStatus(object) {
      var _this7 = this;

      var updateStatusText = {
        confirmed: 'confirm',
        completed: 'complete',
        rejected: 'reject',
        incomplete: 'incomplete',
        scheduled: 'schedule'
      };
      var otherPayload = { id: object.id, status: object.status };
      var spcPayload = { id: object.id, status: updateStatusText[object.status] };
      if (this.role === 'specialistDoctor' || this.role === 'externalAdmin') {
        this.updateAppointmentStatus(spcPayload);
      } else {
        __WEBPACK_IMPORTED_MODULE_6__api_appointments__["a" /* default */].updateStatus(otherPayload).then(function (response) {
          if (response.status === 200) {
            _this7.fetchAppointment(_this7.activeTab);
          } else {}
        }, function (response) {});
      }
    },
    assignDoctorHandler: function assignDoctorHandler() {
      if (this.selectedDoctor && this.selectedSlot) {
        var obj = {
          status: 'confirm',
          doctor_id: this.selectDoctorId,
          time: this.selectedSlot.utc_slot_time,
          id: this.selectedAppointment.id
        };
        this.updateAppointmentStatus(obj);
      } else {
        return;
      }
      this.closeModal();
    },
    startConsultation: function startConsultation(appointment) {
      this.$store.dispatch('configuration/setActiveMiniMenu', 'OfflineConsults');
      this.$store.dispatch('offlineConsultation/addAptConsultation', appointment);
    },
    uploadDocuments: function uploadDocuments(fileList, appointment, key, category) {
      var _this8 = this;

      var formData = new FormData();
      var channelId = appointment.ek_id;
      var consultId = appointment.consultation_id;
      formData.append('customer_id', channelId);
      formData.append('consultation_id', consultId);
      formData.append('category', category);
      Array.prototype.forEach.call(fileList, function (file) {
        formData.append('files[]', file, file.name);
      });
      var V = this;
      this.isLoading = true;
      V.$http.post(window.API_URL + 'doctors/customer/documents', formData, {
        progress: function progress(e) {
          if (e.lengthComputable) {
            V.progress = e.loaded / e.total * 100;
          }
        }
      }).then(function (response) {
        if (response.status === 200) {
          _this8.isLoading = false;
          _this8.$toast.open({
            message: 'Uploaded successfully',
            type: 'success',
            position: 'bottom-right',
            queue: false
          });
        }

        var app = V.data[key].find(function (ele) {
          return ele.consultation_id === appointment.consultation_id;
        });
        var index = V.data[key].indexOf(app);
        app.consultation_documents.unshift({ name: response.body.name, id: response.body.id });
        if (index > -1) {
          V.data[key].splice(index, 1, app);
        }
      }).catch(function (error) {
        console.log(error);
        _this8.isLoading = false;
        _this8.$toast.open({
          message: 'Something went wrong',
          type: 'error',
          position: 'bottom-right',
          queue: false
        });
      });
    },
    updateAptRequest: function updateAptRequest() {
      this.fetchAppointment(this.activeTab);
    }
  },
  mounted: function mounted() {
    if (this.role === 'externalAdmin') {
      this.$store.dispatch('appointmentRequest/updateActiveTab', 'requested');
    }
    this.fetchAppointment(this.activeTab);
    this.$watch('showModal', function (newValue, oldValue) {
      if (newValue) {
        this.getDoctorList();
      }
    });
  }
});

/***/ }),

/***/ "F1k2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: [],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  }), {
    testFollowupReminders: function testFollowupReminders() {
      var that = this;
      if (that.customer && that.customer.consultation && that.customer.consultation.followupReminders) {
        var followupReminders = that.customer.consultation.followupReminders.filter(function (ele) {
          return ele.followup_type === 'lab_test';
        });
        followupReminders.map(function (r) {
          var t = that.customer.consultation.recommendedTests.find(function (ele) {
            return ele.test_id === r.recommended_test_id;
          });
          if (t) {
            r.package_name = t.package_name;
          } else {
            r.package_name = 'NA';
          }
          return r;
        });
        return followupReminders;
      }
      return [];
    },
    consultFollowupReminders: function consultFollowupReminders() {
      if (this.customer && this.customer.consultation && this.customer.consultation.followupReminders) {
        return this.customer.consultation.followupReminders.filter(function (ele) {
          return ele.followup_type === 'consultation';
        });
      }
      return [];
    }
  }),
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ "F2Gu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FBWV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FNwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_TextField__ = __webpack_require__("qrBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_toast_notification___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_3__components_common_TextField__["a" /* default */]
  },
  props: ['customerId', 'consultType', 'saved', 'med'],
  data: function data() {
    return {
      drugList: [],
      showDrugList: false,
      search: '',
      medication: this.med ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.med) : {
        name: '',
        dose_quantity: null,
        dose_unit: '',
        frequency: '',
        frequency_unit: '',
        duration: null,
        duration_unit: '',
        is_current: false,
        route: '',
        instructions: ''
      },
      beforeMed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.med)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    currentDrug: 'consultation/getCurrentDrug'
  }), {
    frequencyText: function frequencyText() {
      if (!this.medication.frequency) return null;
      var frequencyText = this.medication.frequency;
      frequencyText = frequencyText !== 'PRN/SOS' ? this.medication.frequency + ' a ' + this.medication.frequency_unit : this.medication.frequency + '(Only if symptoms are there) ' + this.medication.frequency_unit;
      return frequencyText;
    },
    editedMedData: function editedMedData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.medication).reduce(function (med, field) {
        if (_this.medication[field] !== _this.beforeMed[field]) {
          med[field] = _this.medication[field];
        }
        return med;
      }, {});
    }
  }),
  created: function created() {
    if (this.consultType === 'online' && !this.med) {
      this.medication = this.currentDrug;
    } else if (this.med) {
      this.medication = this.med;
    }
  },

  methods: {
    updateMedication: function updateMedication(e, option) {
      if (option === 'dose_quantity') {
        this.medication.dose_quantity = e.target.value;
      } else if (option === 'dose_unit') {
        this.medication.dose_unit = e.target.value;
      } else if (option === 'frequency') {
        this.handleFrequencyChange(e);
      } else if (option === 'frequency_unit') {
        this.medication.frequency_unit = e.target.value;
      } else if (option === 'route') {
        this.medication.route = e.target;
      } else if (option === 'instructions') {
        this.medication.instrcutions = e.target;
      }
      if (this.consultType === 'online') {
        this.$store.commit('consultation/storeDrugs', { drugs: this.medication, channelId: this.customerId, isAdding: true });
      }
    },
    handleFrequencyChange: function handleFrequencyChange(e) {
      var newValue = e.target.value;
      var previousValue = this.medication.frequency;

      if (previousValue === 'PRN/SOS' && newValue !== 'PRN/SOS' || previousValue !== 'PRN/SOS' && newValue === 'PRN/SOS' || previousValue === '' || previousValue === null) {
        this.medication.frequency_unit = newValue === 'PRN/SOS' ? 'once a day' : 'day';
      }

      this.medication.frequency = newValue;
    },
    saveChange: function saveChange(data) {
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
      var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(data);
      this.medication[keys[0]] = values[0];
    },
    cancelEdit: function cancelEdit() {
      this.$emit('updateDrugs');
      this.$emit('updateSavedDrugs');
    },
    removeDrugs: function removeDrugs() {
      this.$store.dispatch('consultation/removeDrugs', { customerId: this.customerId });
    },
    fetchDrugData: function fetchDrugData(e) {
      var customerId = this.customerId;
      var vm = this;
      if (this.medication.name && this.medication.name.length > 2) {
        this.$http.get(window.API_URL + 'doctors/medicines/search-drugs?search_term=' + this.medication.name + '&customer_id=' + customerId).then(function (response) {
          if (response.status === 200) {
            vm.drugList = response.body.drugs;
            if (response.body.drugs.length !== 0) {
              vm.showDrugList = true;
            } else {
              vm.showDrugList = false;
            }
          } else {}
        }, function (response) {});
      } else {
        vm.drugList = [];
        vm.showDrugList = false;
      }
    },

    removeList: function removeList() {
      this.showDrugList = false;
    },
    selectDrug: function selectDrug(drug) {
      this.medication.name = drug.name;
      if (this.consultType === 'online') {
        this.$store.dispatch('consultation/storeDrugs', { drugs: this.medication, channelId: this.customerId, isAdding: true });
      }
      this.showDrugList = false;
    },
    durationHandler: function durationHandler() {
      switch (this.medication.duration_unit) {
        case 'day':
          this.medication.number_of_days = this.medication.duration;
          break;
        case 'week':
          this.medication.number_of_days = this.medication.duration * 7;
          break;
        case 'month':
          this.medication.number_of_days = this.medication.duration * 30;
          break;
      }
    },
    savePreFilled: function savePreFilled() {
      var canSave = true;
      var validDrugName = true;
      if (this.medication.name.length > 100) {
        validDrugName = false;
      }
      if (!this.medication.name || !this.medication.frequency || !this.medication.duration || !this.medication.duration_unit) {
        canSave = false;
      }
      if (!this.medication.frequency_unit) {
        canSave = false;
      }
      if (canSave && validDrugName && !this.med) {
        this.$emit('updateSavedDrugs', {
          name: this.medication.name,
          dose_quantity: this.medication.dose_quantity ? this.medication.dose_quantity : '',
          dose_unit: this.medication.dose_unit ? this.medication.dose_unit : '',
          frequency: this.frequencyText,
          number_of_days: this.medication.number_of_days,
          date: this.medication.date,
          duration: this.medication.duration,
          duration_unit: this.medication.duration_unit,
          isActive: this.medication.isActive,
          route: this.medication.route ? this.medication.route.trim() : null,
          instructions: this.medication.instructions ? this.medication.instructions.trim() : null,
          is_current: this.medication.is_current
        });
      }
      if (canSave && validDrugName && this.med) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.editedMedData).length === 0) {
          this.cancelEdit();
        } else {
          this.$emit('editSavedDrug', this.editedMedData);
        }
      } else if (!validDrugName) {
        this.$toast.open({
          message: 'Drug name should not be too long',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      } else {
        this.$toast.open({
          message: 'Please fill all mandatory fields',
          type: 'warning',
          position: 'top',
          queue: false
        });
      }

      var medication = {};
      if (this.consultType === 'online') {
        this.$store.dispatch('consultation/storeDrugs', { drugs: medication, channelId: this.customerId, isAdding: false });
      }
    },
    savePrescriptionDetails: function savePrescriptionDetails() {
      var canSave = true;
      var validDrugName = true;
      if (this.medication.name.length > 100) {
        validDrugName = false;
      }
      if (!this.medication.name || !this.medication.frequency || !this.medication.duration || !this.medication.duration_unit) {
        canSave = false;
      }
      if (!this.medication.frequency_unit) {
        canSave = false;
      }
      if (canSave && validDrugName) {
        this.$emit('updateDrugs', {
          name: this.medication.name,
          dose_quantity: this.medication.dose_quantity ? this.medication.dose_quantity : '',
          dose_unit: this.medication.dose_unit ? this.medication.dose_unit : '',
          frequency: this.frequencyText,
          number_of_days: this.medication.number_of_days,
          date: this.medication.date,
          duration: this.medication.duration,
          duration_unit: this.medication.duration_unit,
          isActive: this.medication.isActive,
          route: this.medication.route ? this.medication.route.trim() : null,
          instructions: this.medication.instructions ? this.medication.instructions.trim() : null,
          is_current: this.medication.is_current
        }, this.customerId);
        if (this.consultType === 'online') {
          this.$store.commit('consultation/storeCurrentDrugs', { drug: this.medication, customerId: this.customerId });
        } else if (this.consultType === 'offline') {
          this.$store.commit('offlineConsultation/storeCurrentDrugs', { drug: this.medication, customerId: this.customerId });
        }
        var medication = {
          name: null,
          dose_quantity: '',
          dose_unit: '',
          frequency: null,
          frequency_unit: null,
          date: null,
          duration: null,
          duration_unit: null,
          number_of_days: 0,
          isActive: true,
          route: null,
          instructions: null,
          is_current: false
        };
        if (this.consultType === 'online') {
          this.$store.dispatch('consultation/storeDrugs', { drugs: medication, channelId: this.customerId, isAdding: false });
        }
      } else if (!validDrugName) {
        this.$toast.open({
          message: 'Drug name should not be too long',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      } else {
        alert('Please fill all mandatory fields');
      }
    }
  }
});

/***/ }),

/***/ "FWNi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row pin-t border border-b border-grey-lightest h-12 w-screen shadow z-20 justify-between"},[_c('div',{staticClass:"flex flex-row items-center justify-start"},[_c('router-link',{staticClass:"no-underline",attrs:{"to":"/admin-home"}},[_c('img',{staticClass:"w-32 ml-4",attrs:{"src":__webpack_require__("0qeJ")}})])],1),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center justify-end"},[_c('span',{staticClass:" ml-4 mr-4"},[_vm._v("\n      "+_vm._s(_vm.doctor.name)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"cursor-pointer mx-4 mt-1 self-center",on:{"click":_vm.logout}},[_c('img',{staticStyle:{"height":"25px"},attrs:{"src":__webpack_require__("lwCE")}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FftZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FpCC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MiniMenu__ = __webpack_require__("x+Yt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader__ = __webpack_require__("TmLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Toaster__ = __webpack_require__("bBuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Chat_ChatMain__ = __webpack_require__("w6Kz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Appointments_Appointments__ = __webpack_require__("49fG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OfflineConsultations_OfflineConsultMain__ = __webpack_require__("J+Mq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DoctorRoster_DoctorSchedule__ = __webpack_require__("ioCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_COVID_19_COVID19_vue__ = __webpack_require__("/eMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_modals_NewUpdateAvailable__ = __webpack_require__("35nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_modals_PendingQueries__ = __webpack_require__("5ZzX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_modals_BackOnline__ = __webpack_require__("APno");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_alerts__ = __webpack_require__("6zQr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_snackbar_helpers__ = __webpack_require__("tjrC");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */],
    MiniMenu: __WEBPACK_IMPORTED_MODULE_2__components_MiniMenu__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_common_Loader__["a" /* default */],
    Toaster: __WEBPACK_IMPORTED_MODULE_4__components_common_Toaster__["a" /* default */],
    Chat: __WEBPACK_IMPORTED_MODULE_5__components_Chat_ChatMain__["a" /* default */],
    Appointments: __WEBPACK_IMPORTED_MODULE_6__components_Appointments_Appointments__["a" /* default */],
    OfflineConsults: __WEBPACK_IMPORTED_MODULE_7__components_OfflineConsultations_OfflineConsultMain__["a" /* default */],
    DoctorSchedule: __WEBPACK_IMPORTED_MODULE_8__components_DoctorRoster_DoctorSchedule__["a" /* default */],
    NewUpdateAvailableModal: __WEBPACK_IMPORTED_MODULE_10__components_common_modals_NewUpdateAvailable__["a" /* default */],
    PendingQueriesModal: __WEBPACK_IMPORTED_MODULE_11__components_common_modals_PendingQueries__["a" /* default */],
    COVID19: __WEBPACK_IMPORTED_MODULE_9__components_COVID_19_COVID19_vue__["a" /* default */],
    BackOnlineModal: __WEBPACK_IMPORTED_MODULE_12__components_common_modals_BackOnline__["a" /* default */]
  },
  data: function data() {
    return {
      isReloaded: true,
      newUserSoundAlerts: null,
      missedSnackbar: null,
      requestSnackbar: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* mapGetters */])({
    selectedMenu: 'configuration/getActiveMiniMenu',
    queries: 'consultationRequest/getQueries',
    consultRequests: 'consultationRequest/getRequests',
    missedRequests: 'consultationRequest/getMissedRequests',
    othersAcceptedRequests: 'consultationRequest/getOthersAcceptedRequest',
    cancelledRequests: 'consultationRequest/getCancelledRequest',
    role: 'configuration/getRole'
  })),
  mounted: function mounted() {
    try {
      this.mutedAudio();
    } catch (error) {
      console.log(error);
    }
    // check for Navigation Timing API support
    if (window.performance && window.performance.navigation.type === 1) {
      this.isReloaded = true;
    } else {
      this.isReloaded = false;
    }
  },

  watch: {
    role: {
      immediate: true,
      handler: function handler(role) {
        if (role === 'specialistDoctor') {
          this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments');
        }
      }
    },
    consultRequests: function consultRequests(newVal, oldVal) {
      var allNewOtherReq = newVal.filter(function (ele) {
        return ele.status === 'unicasted' || ele.status === 'broadcasted';
      });
      var allOldOtherReq = oldVal.filter(function (ele) {
        return ele.status === 'unicasted' || ele.status === 'broadcasted';
      });
      if (allNewOtherReq > allOldOtherReq) {
        if (allNewOtherReq.length >= 1 && allNewOtherReq[allNewOtherReq.length - 1].status === 'unicasted') {
          this.showSnackbar(allNewOtherReq[allNewOtherReq.length - 1]);
        } else if (allNewOtherReq.length > 1 && allNewOtherReq[allNewOtherReq.length - 1].status === 'unicasted') {
          this.showSnackbar(allNewOtherReq[allNewOtherReq.length - 1]);
        }
      }
      if (allNewOtherReq.length > 0) {
        // this.clearSetInterval()
        this.browserNotification({ body: this.getIncomingRequestText(allNewOtherReq[allNewOtherReq.length - 1]), icon: '/static/images/ekincare_logo.png' });
        this.soundNotification();
      }
      if (allNewOtherReq.length < 1) {
        if (this.requestSnackbar) {
          this.requestSnackbar.close();
        }
        this.clearSetInterval();
      }
    },
    missedRequests: function missedRequests(newVal, oldVal) {
      if (newVal > oldVal && newVal[newVal.length - 1].status !== 'broadcasted') {
        // this.showMissedSnackbar(newVal[0])
        console.log('Missed request');
      } else if (newVal.length < 1) {
        if (this.missedSnackbar) {
          this.missedSnackbar.close();
          this.missedSnackbar = null;
        }
      }
    },
    cancelledRequests: function cancelledRequests(newVal, oldVal) {
      if (newVal > oldVal && newVal[newVal.length - 1].status !== 'broadcasted') {
        this.removeSnackbarWithSameId(newVal[newVal.length - 1].customer_id);
        // this.showCancelledSnackbar(newVal[0])
        console.log('cancelled');
      }
    },
    othersAcceptedRequests: function othersAcceptedRequests(newVal, oldVal) {
      if (newVal > oldVal && newVal[newVal.length - 1].status !== 'broadcasted') {
        // this.showOtherAcceptedSnackbar(newVal[0])
        console.log('others accepted');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearSetInterval();
    if (this.missedSnackbar) this.missedSnackbar.close();this.missedSnackbar = null;
    if (this.requestSnackbar) this.requestSnackbar.close();this.requestSnackbar = null;
    this.newUserSoundAlerts = null;
  },

  methods: {
    mutedAudio: function mutedAudio() {
      // This plays a muted audio when the page loads for the first time to bypass chromes perfomance issues
      var audio = new Audio('/static/sounds/msg_received.ogg');
      audio.muted = true;
      audio.play().then().catch(function (e) {
        console.log(e);
        // this.isReloaded = true
      });
    },
    browserNotification: function browserNotification(options) {
      // Let's check if the browser supports notifications
      if (!('Notification' in window)) {
        console.log('This browser does not support desktop notification');
      } else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        this.notification = new Notification('Incoming Request', options);
      } else if (Notification.permission === 'denied') {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            this.notification = new Notification('Incoming Request', options);
          }
        });
      }
    },
    clearSetInterval: function clearSetInterval() {
      if (this.newUserSoundAlerts) {
        clearInterval(this.newUserSoundAlerts);
        // this.newUserSoundAlerts = null
      }
    },
    removeSnackbarWithSameId: function removeSnackbarWithSameId(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__components_common_snackbar_helpers__["a" /* removeElement */])(el);
      }
    },

    soundNotification: function soundNotification() {
      this.clearSetInterval();
      __WEBPACK_IMPORTED_MODULE_14__core_alerts__["a" /* default */].create('newuser');
      this.newUserSoundAlerts = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_14__core_alerts__["a" /* default */].create('newuser');
        __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.getItem('audits', function (err, data) {
          if (err === null) {
            data.push({ type: 'notification', notification_type: 'voice', created_at: new Date().toString() });
            __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.setItem('audits', data);
          }
        });
      }, 4000);
    },
    getIncomingRequestText: function getIncomingRequestText(request) {
      var text = 'Patient ' + request.customer_name + ' is waiting';
      __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({ type: 'notification', notification_type: 'text', customer_name: request.customer_name, created_at: new Date().toString() });
          __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.setItem('audits', data);
        }
      });
      if (request.isFamilyDoctor) {
        text = 'Your patient ' + request.customer_name + ' is waiting';
      }
      return text;
    },
    showSnackbar: function showSnackbar(request) {
      var _this = this;

      this.requestSnackbar = this.$snackbar.open({
        duration: 60000,
        message: this.getIncomingRequestText(request),
        type: 'is-info',
        request: request,
        position: 'is-bottom-left',
        actionText: 'Accept',
        queue: false,
        elementId: request.customer_id,
        onAction: function onAction() {
          _this.accept(request);
        }
      });
      __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({ type: 'snackbar', action: 'accept', customerId: request.customer_id, created_at: new Date().toString() });
          __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.setItem('audits', data);
        }
      });
    },
    showMissedSnackbar: function showMissedSnackbar(request) {
      var _this2 = this;

      var text = 'You missed a consultation from your patient ' + request.customer_name;
      this.missedSnackbar = this.$snackbar.open({
        message: text,
        type: 'is-query',
        request: request,
        position: 'is-bottom-left',
        actionText: 'Respond Back',
        queue: true,
        indefinite: true,
        elementId: request.customer_id,
        onAction: function onAction() {
          _this2.acceptQuery(request);
        }
      });
      __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({ type: 'snackbar', action: 'missed_consultation', customerId: request.customer_id, created_at: new Date().toString() });
          __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.setItem('audits', data);
        }
      });
    },
    showCancelledSnackbar: function showCancelledSnackbar(request) {
      var text = 'Patient ' + request.customer_name + ' has cancelled the consultation.';
      if (request.isFamilyDoctor) {
        text = 'Your patient ' + request.customer_name + ' has cancelled the consultation.';
      }
      this.$snackbar.open({
        duration: 5000,
        message: text,
        request: request,
        type: 'is-info',
        position: 'is-bottom-left',
        queue: false,
        elementId: request.customer_id
      });
      __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({ type: 'snackbar', action: 'patient_cancelled', customerId: request.customer_id, created_at: new Date().toString() });
          __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.setItem('audits', data);
        }
      });
    },
    showOtherAcceptedSnackbar: function showOtherAcceptedSnackbar(request) {
      this.$snackbar.open({
        duration: 5000,
        message: request.message,
        request: request,
        type: 'is-info',
        position: 'is-bottom-left',
        queue: false,
        elementId: request.customer_id
      });
      __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({ type: 'snackbar', action: 'other_accepted', customerId: request.customer_id, created_at: new Date().toString() });
          __WEBPACK_IMPORTED_MODULE_15_localforage___default.a.setItem('audits', data);
        }
      });
    },
    closeReloadOverlay: function closeReloadOverlay() {
      this.isReloaded = false;
      this.mutedAudio();
    },
    accept: function accept(request) {
      this.$store.dispatch('consultationRequest/acceptConsultationRequest', request);
    },
    acceptQuery: function acceptQuery(request) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', request);
    }
  }
});

/***/ }),

/***/ "FsTF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MfaOTPConfirmationScreen_vue__ = __webpack_require__("G44Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08adc4ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MfaOTPConfirmationScreen_vue__ = __webpack_require__("Cm8E");
function injectStyle (ssrContext) {
  __webpack_require__("IfU9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08adc4ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MfaOTPConfirmationScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08adc4ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MfaOTPConfirmationScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FyQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

// import store from '../../store'

/* harmony default export */ __webpack_exports__["a"] = ({
  saveSummaryDetails: function saveSummaryDetails(data, consultationId) {
    var obj = {
      consultation: data
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(window.API_URL + 'doctors/consultations/' + consultationId, obj);
  },
  sendSummary: function sendSummary(consultationId, componentKey) {
    var obj = {
      consultation_id: consultationId
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultations/' + consultationId + '/publish', obj, { componentKey: componentKey });
  },
  summaryNotNeeded: function summaryNotNeeded(consultationId, componentKey) {
    var obj = {
      consultation_id: consultationId
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultations/' + consultationId + '/not_needed', obj, { componentKey: componentKey });
  }
});

/***/ }),

/***/ "G44Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_localforage__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mfa: {
        type: true,
        enabled: false,
        otp_code: ''
      },
      credentials: {
        username: '',
        password: '',
        type: ''
      },
      error: false,
      showAlreadyLogged: false,
      showLogin: true,
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    role: function role(state) {
      return state.configuration.role;
    }
  }), {
    isCredentialsTypeValid: function isCredentialsTypeValid() {
      return this.mfa.type;
    }
  }),
  methods: {
    submit: function submit() {
      var _this = this;

      event.preventDefault();
      var credentials = {
        email: this.credentials.username,
        password: this.credentials.password,
        otp_code: this.mfa.otp_code
      };
      this.isLoading = true;
      this.$http.post(window.API_URL + 'online_doctors/sign_in', credentials).then(function (response) {
        if (response.status === 200) {
          if (response.headers.get('X-DOCTOR-KEY')) {
            __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.setUserContext({ name: response.body.doctor.name, id: response.body.doctor.doctor_id });
            sessionStorage.setItem('X-DOCTOR-KEY', response.headers.get('X-DOCTOR-KEY'));
            sessionStorage.setItem('availableForChat', false);
            sessionStorage.setItem('isLoggedIn', true);
            sessionStorage.removeItem('mfa_token');
            _this.$store.dispatch('configuration/init');
            if (response.body.doctor.role === 'admin') {
              sessionStorage.setItem('isAdmin', true);
              __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('admin-home');
            } else {
              __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('home');
            }
            _this.clearLocalForage();
          } else if (response.body.message === 'Invalid OTP code') {
            alert('Invalid OTP code');
            return;
          } else if (response.body.message === 'account locked') {
            alert('Your account has been locked, please try after 24 hours.');
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('login');
          } else {
            alert('No access token found');
            return;
          }
        }
      }).catch(function (error) {
        _this.isLoading = false;
        _this.$toast.open({
          message: error.body.message || 'something went wrong!',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    resendOTP: function resendOTP() {
      var _this2 = this;

      this.isLoading = true;
      var options = { email: this.credentials.username };
      this.$http.post(window.API_URL + 'doctors/mfa_settings/resend_otp', options).then(function (response) {
        if (response.status === 200) {
          _this2.isLoading = false;
          _this2.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          });
        }
      }).catch(function () {
        this.isLoading = false;
        this.enableViaOtp = false;
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    },
    clearLocalForage: function clearLocalForage() {
      __WEBPACK_IMPORTED_MODULE_8_localforage___default.a.iterate(function (data, key, index) {
        if (index === 1) {
          return [key, data];
        }
      }).then(function (result) {
        var data = result[1];
        var i = data.length;
        while (i--) {
          var entryDate = new Date(data[i].created_at);
          var now = new Date();
          var diff = Math.abs(now - entryDate);
          var diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
          if (diffDays >= 3) {
            data.splice(i, 1);
          }
        }
        __WEBPACK_IMPORTED_MODULE_8_localforage___default.a.setItem('audits', data);
      });
    }
  },
  mounted: function mounted() {
    this.credentials.username = this.$route.params.username;
    this.credentials.password = this.$route.params.password;
    this.mfa.type = this.$route.params.type === 'sms';
    if (!sessionStorage.length) {
      // Ask other tabs for session storage
      localStorage.setItem('getSessionStorage', Date.now());
    }
    if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
      this.showAlreadyLogged = true;
      this.showLogin = false;
    } else {
      window.addEventListener('storage', function (event) {
        if (event.key === 'getSessionStorage') {
          // Some tab asked for the sessionStorage -> send it
          localStorage.setItem('sessionStorage', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sessionStorage));
          localStorage.removeItem('sessionStorage');
        } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
          // sessionStorage is empty -> fill it
          var data = JSON.parse(event.newValue);
          for (var key in data) {
            sessionStorage.setItem(key, data[key]);
          }
          if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
            this.showAlreadyLogged = true;
            this.showLogin = false;
          } else {
            this.showAlreadyLogged = false;
            this.showLogin = true;
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "G5QQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_health_coach__ = __webpack_require__("j9/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_toast_notification__);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_toast_notification___default.a);

// STATE
var state = {
  programDetails: {},
  addGoals: [{ name: 'Weight', units: 'kgs', target_value: '' }, { name: 'Blood Pressure', units: 'mmHg', target_value: '' }, { name: 'Blood Sugar', units: 'mg/dl', target_value: '' }, { name: 'Triglycerides', units: 'mmol/L', target_value: '' }, { name: 'HbA1c', units: 'mmol/mol', target_value: '' }],
  goals: [],
  vitals: [],
  progress: [],
  currentVitalsWeek: '',
  timelineAndProgress: {},
  dailySteps: [],
  weeklySteps: []

  // GETTERS
};var getters = {
  getProgramDetails: function getProgramDetails() {
    return state.programDetails;
  },
  getVitalsWeek: function getVitalsWeek() {
    return state.currentVitalsWeek;
  },
  getCurrentGoals: function getCurrentGoals() {
    return state.goals;
  },
  getAddGoals: function getAddGoals() {
    return state.addGoals;
  },
  getVitals: function getVitals() {
    return state.vitals;
  },
  getProgress: function getProgress() {
    return state.progress;
  },
  getDailySteps: function getDailySteps() {
    return state.dailySteps;
  },
  getWeeklySteps: function getWeeklySteps() {
    return state.weeklySteps;
  },
  getTimelineAndProgress: function getTimelineAndProgress() {
    return state.timelineAndProgress;
  }
};

// ACTIONS
var actions = {
  healthCoachInitialState: function healthCoachInitialState(_ref, _ref2) {
    var commit = _ref.commit;
    var data = _ref2.data;

    commit('setInitialState', data);
  },
  setCustomerVitals: function setCustomerVitals(_ref3, _ref4) {
    var commit = _ref3.commit;
    var data = _ref4.data;

    commit('setVitals', data);
  },
  setDailyCustomerSteps: function setDailyCustomerSteps(_ref5, _ref6) {
    var commit = _ref5.commit;
    var data = _ref6.data;

    commit('setDailySteps', data);
  },
  setWeeklyCustomerSteps: function setWeeklyCustomerSteps(_ref7, _ref8) {
    var commit = _ref7.commit;
    var data = _ref8.data;

    commit('setWeeklySteps', data);
  },
  setTimelineAndProgress: function setTimelineAndProgress(_ref9, _ref10) {
    var commit = _ref9.commit;
    var data = _ref10.data;

    commit('setTimelineProgress', data);
  },
  addGoal: function addGoal(_ref11, _ref12) {
    var commit = _ref11.commit;
    var val = _ref12.val;

    var data = {
      name: val.name,
      target_value: val.target_value,
      program_enrollment_id: state.programDetails.programEnrollmentId
    };
    __WEBPACK_IMPORTED_MODULE_0__api_health_coach__["a" /* default */].createGoal(data).then(function (res) {
      if (res.status === 200) {
        if (res.body.goal) {
          commit('addGoal', res.body.goal);
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$toast.open({
            message: res.body.message,
            type: 'error',
            position: 'top',
            queue: false
          });
        }
      }
    });
  },
  updateGoal: function updateGoal(_ref13, _ref14) {
    var commit = _ref13.commit;
    var programEnrollmentId = _ref14.programEnrollmentId,
        val = _ref14.val;

    var healthCoachGoalsData = {
      goals: val.map(function (goal) {
        return {
          id: goal.id,
          target_value: goal.target_value
        };
      })
    };

    __WEBPACK_IMPORTED_MODULE_0__api_health_coach__["a" /* default */].bulkUpdateGoal(programEnrollmentId, healthCoachGoalsData).then(function (res) {
      if (res.status === 200) {
        commit('updateGoal', res.body.goals);
      } else {
        console.error('Failed to update goals:', res.body.message);
      }
    }).catch(function (error) {
      console.error('Error updating goals:', error);
    });
  },
  deleteGoal: function deleteGoal(_ref15, _ref16) {
    var commit = _ref15.commit;
    var goal = _ref16.goal;

    if (goal.id) {
      __WEBPACK_IMPORTED_MODULE_0__api_health_coach__["a" /* default */].deleteGoal(goal.id).then(function (res) {
        if (res.status === 200) {
          commit('deleteGoal', goal);
        }
      });
    } else {
      state.goals = state.goals.filter(function (ele) {
        return ele.name !== goal.name;
      });
    }
  },
  changeVitalsWeek: function changeVitalsWeek(_ref17, _ref18) {
    var commit = _ref17.commit;
    var week = _ref18.week;

    commit('changeVitalsWeek', week);
  },
  reset: function reset(state) {
    state = {};
  }
};

// MUTATIONS
var mutations = {
  setInitialState: function setInitialState(state, data) {
    state.programDetails = {
      programName: data.program_name,
      programType: data.program_type,
      duration: data.duration + ' ' + data.duration_type,
      currentWeek: data.week,
      programEnrollmentId: data.program_enrollment_id,
      startOfWeek: data.start_of_week,
      enrollmentDate: data.enrollment_date
    };
    state.goals = data.goals;
    state.addGoals = state.addGoals;
    state.progress = data.progress;
    state.currentVitalsWeek = state.programDetails.currentWeek.slice(5);
  },
  setVitals: function setVitals(state, data) {
    state.vitals = data.customer_goal_vitals;
  },
  setDailySteps: function setDailySteps(state, data) {
    state.dailySteps = data;
  },
  setWeeklySteps: function setWeeklySteps(state, data) {
    state.weeklySteps = data;
  },
  addGoal: function addGoal(state, val) {
    state.goals.push(val);
  },
  updateGoal: function updateGoal(state, goal) {
    state.goals = state.goals.map(function (ele) {
      return ele.id === goal.id ? goal : ele;
    });
  },
  deleteGoal: function deleteGoal(state, goal) {
    state.goals = state.goals.filter(function (ele) {
      return ele.id !== goal.id;
    });
    state.addGoals = state.addGoals.map(function (ele) {
      if (ele.name === goal.name) {
        ele.target_value = '';
      }
      return ele;
    });
  },
  changeVitalsWeek: function changeVitalsWeek(state, week) {
    // Changing vitals with week
    state.currentVitalsWeek = week.toString();
  },
  setTimelineProgress: function setTimelineProgress(state, data) {
    state.timelineAndProgress = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "G5Z6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMTBfNTIwKSI+CjxwYXRoIGQ9Ik03LjMzMzM3IDIuNjY2OTlIMi42NjY3MUMyLjMxMzA5IDIuNjY2OTkgMS45NzM5NSAyLjgwNzQ3IDEuNzIzOSAzLjA1NzUyQzEuNDczODUgMy4zMDc1NiAxLjMzMzM3IDMuNjQ2NyAxLjMzMzM3IDQuMDAwMzNWMTMuMzMzN0MxLjMzMzM3IDEzLjY4NzMgMS40NzM4NSAxNC4wMjY0IDEuNzIzOSAxNC4yNzY1QzEuOTczOTUgMTQuNTI2NSAyLjMxMzA5IDE0LjY2NyAyLjY2NjcxIDE0LjY2N0gxMkMxMi4zNTM3IDE0LjY2NyAxMi42OTI4IDE0LjUyNjUgMTIuOTQyOCAxNC4yNzY1QzEzLjE5MjkgMTQuMDI2NCAxMy4zMzM0IDEzLjY4NzMgMTMuMzMzNCAxMy4zMzM3VjguNjY2OTkiIHN0cm9rZT0iIzA5NTFFMSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuMzMzNCAxLjY2NzE0QzEyLjU5ODYgMS40MDE5MyAxMi45NTgzIDEuMjUyOTMgMTMuMzMzNCAxLjI1MjkzQzEzLjcwODQgMS4yNTI5MyAxNC4wNjgyIDEuNDAxOTMgMTQuMzMzNCAxLjY2NzE0QzE0LjU5ODYgMS45MzIzNiAxNC43NDc2IDIuMjkyMDcgMTQuNzQ3NiAyLjY2NzE0QzE0Ljc0NzYgMy4wNDIyMiAxNC41OTg2IDMuNDAxOTMgMTQuMzMzNCAzLjY2NzE0TDguMDAwMDQgMTAuMDAwNUw1LjMzMzM3IDEwLjY2NzFMNi4wMDAwNCA4LjAwMDQ4TDEyLjMzMzQgMS42NjcxNFoiIHN0cm9rZT0iIzA5NTFFMSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzExMTBfNTIwIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ "GLgn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GPk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__ = __webpack_require__("qrBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Customer_CurrentMedication__ = __webpack_require__("yYfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__["a" /* default */],
    CurrentMedication: __WEBPACK_IMPORTED_MODULE_2__components_Customer_CurrentMedication__["a" /* default */]
  },
  data: function data() {
    return {
      isEditing: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    activeSection: 'configuration/getActiveSection'
  }), {
    past_medical_history: function past_medical_history() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.past_medical_history;
      }
    },
    surgical_history: function surgical_history() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.surgical_history;
      }
    },
    drug_allergies: function drug_allergies() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.drug_allergies;
      }
    },
    food_allergies: function food_allergies() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.food_allergies;
      }
    },
    family_medical_history: function family_medical_history() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.family_medical_history;
      }
    },
    social_history: function social_history() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.social_history;
      }
    },
    menstrual_history: function menstrual_history() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.menstrual_history;
      }
    },
    diet_assessment: function diet_assessment() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.diet_assessment;
      }
    },
    medication: function medication() {
      if (this.customer && this.customer.details && this.customer.details.medication) {
        return this.customer.details.medication;
      }
      return [];
    },
    healthParameterDate: function healthParameterDate() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.date) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(this.customer.details.health_parameters.date)).format('DD MMM YYYY');
      }
      return 'NA';
    },
    familyHealthParameterDate: function familyHealthParameterDate() {
      if (this.customer && this.customer.details && this.customer.details.family_history && this.customer.details.family_history.date) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(this.customer.details.family_history.date)).format('DD MMM YYYY');
      }
      return 'NA';
    }
  }),
  methods: {
    getMotherHistory: function getMotherHistory(parameter) {
      if (this.customer && this.customer.details && this.customer.details.family_history && this.customer.details.family_history.mothers_history && this.customer.details.family_history.mothers_history.includes(parameter)) {
        return 'Yes';
      }
      return 'No';
    },
    getFatherHistory: function getFatherHistory(parameter) {
      if (this.customer && this.customer.details && this.customer.details.family_history && this.customer.details.family_history.fathers_history && this.customer.details.family_history.fathers_history.includes(parameter)) {
        return 'Yes';
      }
      return 'No';
    },
    saveChange: function saveChange(data) {
      if (this.$attrs.chatType === 'offline') {
        this.saveOfflineConsult(data);
      } else if (this.$attrs.chatType === 'online') {
        this.saveOnlineConsult(data);
      }
    },
    editCurrentMedication: function editCurrentMedication() {
      this.isEditing = !this.isEditing;
    },
    saveOnlineConsult: function saveOnlineConsult(data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('consultation/updateHealthParameters', data);
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastConsultation/updateHealthParameters', data);
      }
    },
    saveOfflineConsult: function saveOfflineConsult(data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('offlineConsultation/updateHealthParameters', data);
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastOfflineConsultation/updateHealthParameters', data);
      }
    }
  }
});

/***/ }),

/***/ "GTZH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GleQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Glgf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEyIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDVMMC44MDM4NDcgMC41TDExLjE5NjIgMC41MDAwMDFMNiA1WiIgZmlsbD0iIzMyNDQ2NyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "H2Sm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_appointment_request__ = __webpack_require__("kkfI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_appointments__ = __webpack_require__("5tu9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ = __webpack_require__("B3+F");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data', 'tab', 'canReschedule'],
  data: function data() {
    return {
      isLoading: false,
      isPaginated: true,
      isPaginationSimple: false,
      currentPage: 1,
      perPage: 10,
      showModal: false,
      newConsultationDate: undefined,
      comments: undefined,
      errorMessage: undefined,
      currentRecord: undefined,
      showRescheduleModal: false,
      fileCategory: null,
      selectedApt: null,
      selectedKey: null,
      selectedFiles: null,
      showUploadDocModal: false
    };
  },

  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_3_vue_datetime__["Datetime"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    role: 'configuration/getRole'
  }), {
    isEmpty: function isEmpty() {
      var isEmpty = false;
      if (this.data && this.data.length < 1) {
        isEmpty = true;
      }
      return isEmpty;
    },
    menu: function menu() {
      return this.tab;
    }
  }),
  methods: {
    copyLinkHandler: function copyLinkHandler(apt) {
      var _this = this;

      if (this.role === 'specialistDoctor' && this.disableJoinButton(apt.appointment_time)) {
        this.$toast.open({ message: 'Meeting link will enable 10 min before appointment time', type: 'warning', position: 'top', queue: false });
        return;
      }
      navigator.clipboard.writeText(apt.meeting_link).then(function () {
        _this.$toast.open({ message: 'Meeting link copied successfully!', type: 'success', position: 'top', queue: false });
      }).catch(function () {
        _this.$toast.open({ message: 'Failed to copy link', type: 'error', position: 'top', queue: false });
      });
    },

    showMessage: function showMessage(msg) {
      var message = msg || 'Meeting link will enable 10 min before appointment time';
      this.$toast.open({ message: message, type: 'warning', position: 'top', queue: false });
    },
    disableJoinButton: function disableJoinButton(dateOfAppointment) {
      var appointmentDate = new Date(dateOfAppointment);
      var currentTime = new Date();
      var timeDifference = appointmentDate.getTime() - currentTime.getTime();
      var timeDifferenceInMinutes = timeDifference / (1000 * 60);
      return timeDifferenceInMinutes > 10;
    },
    disableStartConsultation: function disableStartConsultation(appointment) {
      var appointmentDate = new Date(appointment.appointment_time);
      var currentTime = new Date();
      var timeDifference = appointmentDate.getTime() - currentTime.getTime();
      var timeDifferenceInMinutes = timeDifference / (1000 * 60);
      var disabled = timeDifferenceInMinutes > 10 || !['scheduled', 'no_response'].includes(appointment.status);
      return disabled;
    },
    handleMeetingLinkClick: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(row) {
        var response, meetingLink;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.disableJoinButton(row.appointment_time)) {
                  _context.next = 3;
                  break;
                }

                this.showMessage();
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api_appointments__["a" /* default */].meeting_link(row.id);

              case 6:
                response = _context.sent;
                meetingLink = response.body.meeting_link;


                if (meetingLink) {
                  __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["b" /* setUser */]({ id: row.ek_id });
                  __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["c" /* captureMessage */]('Meeting link clicked', {
                    level: 'info',
                    tags: { event_name: 'meeting_link_click' },
                    extra: {
                      meeting_link: meetingLink,
                      appointment_request_id: row.id
                    }
                  });

                  window.open(meetingLink, '_blank');
                } else {
                  this.$toast.open({
                    message: 'Meeting link not available',
                    type: 'error',
                    position: 'top',
                    queue: false
                  });
                }
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](3);

                console.error('Error fetching meeting link:', _context.t0);
                this.$toast.open({
                  message: 'Failed to fetch meeting link. Please try again later.',
                  type: 'error',
                  position: 'top',
                  queue: false
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11]]);
      }));

      function handleMeetingLinkClick(_x) {
        return _ref.apply(this, arguments);
      }

      return handleMeetingLinkClick;
    }(),
    handleFileUpload: function handleFileUpload(files) {
      this.selectedFiles = files;
    },

    selectFileCategory: function selectFileCategory(category) {
      this.fileCategory = category;
    },
    openUploadDocModal: function openUploadDocModal(apt, key) {
      this.selectedApt = apt;
      this.selectedKey = key;
      this.showModal = true;
      this.showUploadDocModal = true;
    },
    statusChanged: function statusChanged(status, id) {
      var obj = { status: status, id: id };
      this.$emit('updateStatus', obj);
    },
    toggleModal: function toggleModal(appointment) {
      this.$store.dispatch('appointmentRequest/toggleAssignModal');
      this.$store.dispatch('appointmentRequest/updateSelectedAppointment', appointment);
    },
    remarkChanged: function remarkChanged(remark, id) {
      this.hideRemarkEdit(id);
      this.$emit('updateRemark', { remark: remark, id: id });
    },
    selfAssign: function selfAssign(id) {
      this.$emit('selfAssign', { id: id });
    },
    startConsultation: function startConsultation(appointment) {
      this.$emit('startConsultation', appointment);
      this.$store.dispatch('configuration/setActiveMiniMenu', 'OfflineConsults');
    },
    uploadDoc: function uploadDoc() {
      if (!this.fileCategory) {
        this.$toast.open({
          message: 'Please select a document category',
          type: 'error',
          position: 'bottom-right',
          queue: false
        });
        return;
      }
      this.$emit('uploadDocuments', this.selectedFiles, this.selectedApt, this.selectedKey, this.fileCategory);
      this.closeModal();
    },
    showRemarkEdit: function showRemarkEdit(id) {
      document.getElementById('remark_edit' + id).style.display = 'block';
    },
    hideRemarkEdit: function hideRemarkEdit(id) {
      document.getElementById('remark_edit' + id).style.display = 'none';
      event.stopPropagation();
    },
    getDocument: function getDocument(docid) {
      this.$http.get(window.API_URL + 'doctors/medical_records/' + docid + '/download').then(function (response) {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank');
        } else {
          alert('Error fetching data');
        }
      }, function (response) {});
    },
    toggleUploadDialogBox: function toggleUploadDialogBox(id) {
      if (document.getElementById('upload_dialog_icon' + id).className === 'fas fa-chevron-down') {
        document.getElementById('uploadDialogBox' + id).style.display = 'block';
        document.getElementById('upload_dialog_icon' + id).className = 'fas fa-chevron-up';
      } else if (document.getElementById('upload_dialog_icon' + id).className === 'fas fa-chevron-up') {
        document.getElementById('uploadDialogBox' + id).style.display = 'none';
        document.getElementById('upload_dialog_icon' + id).className = 'fas fa-chevron-down';
      }
    },
    openRescheduleModal: function openRescheduleModal(row) {
      if (this.canReschedule && !['externalAdmin', 'specialistDoctor'].includes(this.role)) {
        this.showModal = true;
        this.showRescheduleModal = true;
        this.currentRecord = row;
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.showRescheduleModal = false;
      this.showUploadDocModal = false;
      this.currentRecord = undefined;
      this.comments = undefined;
      this.newConsultationDate = undefined;
      this.fileCategory = null;
      this.selectedApt = null;
      this.selectedKey = null;
      this.selectedFiles = null;
    },
    updateComments: function updateComments() {
      this.comments = this.text;
      this.errorMessage = undefined;
    },
    updateConsultationDate: function updateConsultationDate() {
      this.newConsultationDate = this.newDate;
      this.errorMessage = undefined;
    },
    rescheduleConsultation: function rescheduleConsultation() {
      var that = this;
      this.errorMessage = undefined;
      if (!this.newConsultationDate) {
        this.errorMessage = "Date of appointment can't be blank";
        return;
      }
      if (!(this.comments && this.comments.trim())) {
        this.errorMessage = "Comments can't be blank";
        return;
      }
      var body = {
        id: this.currentRecord.id,
        date_of_appointment: this.newConsultationDate,
        comments: this.comments,
        customer_id: this.currentRecord.customer_id
      };
      __WEBPACK_IMPORTED_MODULE_4__api_appointment_request__["a" /* default */].reschedule(body).then(function (response) {
        that.$emit('updateAptRequest');
        that.showModal = false;
      }, function (response) {});
    }
  }
});

/***/ }),

/***/ "HAqs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HMsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_SpeechRecognition__ = __webpack_require__("kUeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SpeechRecognition: __WEBPACK_IMPORTED_MODULE_3__components_common_SpeechRecognition__["a" /* default */]
  },
  props: ['value', 'label', 'fieldId', 'editMode', 'error'],
  data: function data() {
    var inEdit = false;
    if (this.editMode && this.editMode === 'true') {
      inEdit = true;
    }
    return {
      inEdit: inEdit,
      text: this.value ? this.value : '',
      message: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  }), {
    canEdit: function canEdit() {
      if (this.customer) {
        if (this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') {
          return false;
        } else {
          return true;
        }
      }
    }
  }),
  watch: {
    value: function value(val) {
      this.text = val;
    },
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!this.value) {
          this.text = '';
          if (document.getElementById('editor_' + this.fieldId)) {
            document.getElementById('editor_' + this.fieldId).innerHTML = '';
          }
          return;
        }
      }
    }
  },
  methods: {
    edit: function edit() {
      this.inEdit = true;
      var that = this;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
        document.getElementById('editor_' + that.fieldId).innerHTML = that.text ? that.text : '';
      });
    },
    save: function save() {
      if (this.error && this.error.hasError) {
        this.$toast.open({ message: this.error.message ? this.error.message : 'Something went wrong', type: 'error', position: 'top', queue: false });
        return;
      }
      var checkText = document.getElementById('editor_' + this.fieldId).innerText;
      if (!checkText.trim()) {
        this.$toast.open({
          message: this.label + ' cannot be empty',
          type: 'error',
          position: 'top',
          queue: false
        });
        return;
      }
      this.text = document.getElementById('editor_' + this.fieldId).innerHTML;
      this.inEdit = false;
      this.$emit('saveChange', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.fieldId, this.text));
      this.$store.dispatch('textField/updateTextFieldState', { inEdit: false, field: this.fieldId });
    },
    cancel: function cancel() {
      this.inEdit = false;
      this.$store.dispatch('textField/updateTextFieldState', { inEdit: false, field: this.fieldId });
    },
    onBlurEvent: function onBlurEvent() {
      if (this.editMode) {
        this.text = document.getElementById('editor_' + this.fieldId).innerText;
        this.$emit('saveChange', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.fieldId, this.text));
        this.$store.dispatch('textField/updateTextFieldState', { inEdit: false, field: this.fieldId });
      }
    },
    onDivInput: function onDivInput(e) {
      this.message = e.target.innerHTML;
      this.$emit('input', e.target.innerHTML);
      this.$store.dispatch('textField/updateTextFieldState', { inEdit: true, field: this.fieldId });
    },
    getVoiceMessage: function getVoiceMessage(message) {
      this.message = message;
      var that = this;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
        document.getElementById('editor_' + that.fieldId).innerHTML = message;
      });
    }
  }
});

/***/ }),

/***/ "HnX8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HyPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader.loading && _vm.loader.componentKey === null)?_c('div',{staticClass:"loader"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"position":"fixed","display":"flex","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0)","z-index":"49"}})]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute flex flex-col justify-center h-32 w-32  rounded-full",staticStyle:{"z-index":"50","top":"calc((80vh - 32px)/2)","left":"calc((100vw - 128px)/2)"}},[_c('img',{staticClass:"self-center h-24 w-24 -mt-3",attrs:{"src":__webpack_require__("rmBI")}}),_vm._v(" "),_c('div',{staticClass:"self-center text-center text-xs text-blue -mt-3"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "II+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  fetchConfigurations: function fetchConfigurations() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/configurations');
  },
  fetchConsultationRequestsDetails: function fetchConsultationRequestsDetails() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/fetch_all_requests');
  },
  fetchQueries: function fetchQueries() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/fetch_queries');
  },
  fetchActiveConsultationsDetails: function fetchActiveConsultationsDetails() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/ongoing_consultations');
  },
  fetchPastConsultationsDetails: function fetchPastConsultationsDetails() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/past_consults?page=' + page);
  },
  fetchActiveOfflineConsultationsDetails: function fetchActiveOfflineConsultationsDetails() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/active_offline_consultations');
  },
  fetchPastOfflineConsultationsDetails: function fetchPastOfflineConsultationsDetails() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/past_offline_consults?page=' + page);
  }
});

/***/ }),

/***/ "INHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_configuration__ = __webpack_require__("5WzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_consultation_request__ = __webpack_require__("S5cm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_consultation__ = __webpack_require__("LZFJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_past_consultation__ = __webpack_require__("/Jfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_message__ = __webpack_require__("oMgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_loader__ = __webpack_require__("0D7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_toaster__ = __webpack_require__("fB3m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_offline_consultation__ = __webpack_require__("kZm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_past_offline_consultation__ = __webpack_require__("KIIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_pre_emp_appointment_request__ = __webpack_require__("w2nt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_appointment_request__ = __webpack_require__("LKLm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_notification__ = __webpack_require__("z9hz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_pre_filled_medications__ = __webpack_require__("BBcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_text_field__ = __webpack_require__("3MlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_health_coach__ = __webpack_require__("G5QQ");


















var debug = "production" !== 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    consultationRequest: __WEBPACK_IMPORTED_MODULE_3__modules_consultation_request__["a" /* default */],
    consultation: __WEBPACK_IMPORTED_MODULE_4__modules_consultation__["a" /* default */],
    configuration: __WEBPACK_IMPORTED_MODULE_2__modules_configuration__["a" /* default */],
    pastConsultation: __WEBPACK_IMPORTED_MODULE_5__modules_past_consultation__["a" /* default */],
    message: __WEBPACK_IMPORTED_MODULE_6__modules_message__["a" /* default */],
    loader: __WEBPACK_IMPORTED_MODULE_7__modules_loader__["a" /* default */],
    toaster: __WEBPACK_IMPORTED_MODULE_8__modules_toaster__["a" /* default */],
    offlineConsultation: __WEBPACK_IMPORTED_MODULE_9__modules_offline_consultation__["a" /* default */],
    pastOfflineConsultation: __WEBPACK_IMPORTED_MODULE_10__modules_past_offline_consultation__["a" /* default */],
    preEmpAppointmentRequest: __WEBPACK_IMPORTED_MODULE_11__modules_pre_emp_appointment_request__["a" /* default */],
    appointmentRequest: __WEBPACK_IMPORTED_MODULE_12__modules_appointment_request__["a" /* default */],
    notification: __WEBPACK_IMPORTED_MODULE_13__modules_notification__["a" /* default */],
    preFilledMedications: __WEBPACK_IMPORTED_MODULE_14__modules_pre_filled_medications__["a" /* default */],
    textField: __WEBPACK_IMPORTED_MODULE_15__modules_text_field__["a" /* default */],
    healthCoach: __WEBPACK_IMPORTED_MODULE_16__modules_health_coach__["a" /* default */]
  },
  actions: {
    clearAll: function clearAll(_ref) {
      var commit = _ref.commit;

      commit('configuration/reset');
      commit('consultationRequest/reset');
      commit('consultation/reset');
      commit('pastConsultation/reset');
      commit('message/reset');
      commit('notification/reset');
      commit('preFilledMedications/reset');
      commit('healthCoach/reset');
    }
  },
  strict: debug
}));

/***/ }),

/***/ "IfU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IjEF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADIElEQVR4nO3dO2sUURjG8eedBHTRTiyipBAEv0EaMRhThBRCBCGQKk2Wze7mC2irrU1gd7NapPECgWiwCEK8BEHxQwgieAE3jQoxsjOvVQrJbq7vzHs28/zKyXLOsH9m5uQEJgAREREREREREeWFpDm4ViqjiONJRNEVqA4COJXmfHtYRX//DZmf33I8hx1SCaDl8kWo3gdwNY3xjyC4COYBtFS6DJEVAGesxzYSVATTAFqtXkAcfwBw1nLcFLzA5uaELC7+8T6RyHS0OH6A8L98ABhDofBMp6dPep+I2RWglcookmTNaryMuN+O+s1GiuNJSMeeWwBuIY4fS7P5zWy+PejsrO7jY+Not5/q3JxbBLtbkMhwx+Oqt6Vev5fll39A2xFOeExu+Qw433mG6KHhHGkZR7u94vFMsAxwutNBqdW+G86RJpcHs+0qqDes7vKzMRQKy1nejvIXoNWaAPB8l09kejvKXQBZWvqLVusmdo+Q2e0odwGAsCLkMgAQToTcBgDCiJDrAIB/hNwHAHwj2O0F9Yh97hF1sx3BbCubV8DBjaFQWLYajAEOZ9xqIAZwxgDOGMDZsV0FSb1u8ufWI66a9sQrwBkDOGMAZwzgjAGcMYAzBnDGAM4YwBkDOGMAZ8HtBaW992K1R2SFV4AzBnDGAM4YwBkDOAtuFRTaKiVtvAKcMYAzBnDGAM4YwFlwqyCrvaBeWU3xCnDGAM4YwBkDOGMAZ8Gtgnpl9WKFV4AzBnDGAM4YwBkDOGMAZwzgjAGcWQb41emgFosDhnNkSqvVc11+9NNqDssAXzvPEE0ZzpGtJOl27l+sprDcilgHcGnHUZG7WioBSfIo4Lfn/keLxQFE0RRU73T5yLrVXHYv7y6VrkHkpdV4QVMdkUbjjcVQZrcgaTReAei1t6cfxmurLx+wXgWpzgD4YTpmWDYQxzOWA5oGkEbjE0QmAGxYjhuIFpLkujSbHy0HNf89QGq1dwCGoHqcngdr6OsbkoWF99YDp/tvrMrlEQCTUB0GMIgub1gP0G8AnyHyFknyxPKeT0RERERERERE+fUPU6zykRhd63oAAAAASUVORK5CYII="

/***/ }),

/***/ "J+Mq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfflineConsultMain_vue__ = __webpack_require__("MLuQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ecd388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineConsultMain_vue__ = __webpack_require__("7dqf");
function injectStyle (ssrContext) {
  __webpack_require__("T4dJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfflineConsultMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ecd388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineConsultMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JA1j":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "JD8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-col overflow-y-auto pb-6",staticStyle:{"height":"calc(100vh - 8rem)"}},[_c('div',{staticClass:"flex flex-row bg-white px-2 py-4 mb-3 flex-no-shrink flex-no-grow border-solid border-b border-grey-lighest"},[_c('TextField',{attrs:{"label":"Chief Complaint","fieldId":"chief_compliant","value":_vm.chiefComplaint},on:{"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('div',{staticClass:"relative flex flex-row px-2 py-4 mb-3 bg-white flex-no-shrink flex-no-grow border-solid border-b border-t border-grey-lighest"},[_c('auto-complete',{attrs:{"list":_vm.idc_codes,"label":"Diagnosis","fieldId":"provisional_diagnois","value":_vm.provisionalDiagnosis,"error":_vm.error},on:{"input":function($event){return _vm.getCodes($event)},"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-white px-2 py-4 mb-3 flex-no-shrink flex-no-grow border-solid border-b border-t border-grey-lighest"},[_c('TextField',{attrs:{"label":"Summary","fieldId":"summary_notes","value":_vm.summaryNotes,"error":_vm.error},on:{"saveChange":_vm.saveChange}})],1),_vm._v(" "),(_vm.activeSection === 'consults' && _vm.customer.consultation.consultationId)?_c('div',[_c('div',{staticClass:"flex"}),_vm._v(" "),_c('scheduled-follow-up'),_vm._v(" "),_c('set-up-follow-up',{attrs:{"consultType":_vm.$attrs.chatType}})],1):_vm._e()]),_vm._v(" "),(_vm.activeSection === 'consults')?_c('div',{staticClass:"fixed pin-b flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow",style:(_vm.$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);')},[_c('div',{staticClass:"flex flex-row mx-auto"},[(!_vm.caseClosed)?_c('div',{staticClass:"hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.sendSummary()}}},[(_vm.loader.loading && _vm.loader.componentKey === 'CS-SendSummary')?_c('span',[_vm._m(1)]):_c('span',{staticClass:"text-sm font-semibold"},[_vm._v("Send Summary")])]):_vm._e(),_vm._v(" "),(_vm.caseClosed)?_c('div',{staticClass:"self-center bg-green p-2 rounded text-white font-light ml-2 text-sm font-semibold px-4"},[_vm._v("Case closed")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('div',[_c('SummaryNotSavedModal',{on:{"close":_vm.closeModal}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("Summary")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"buttonload",staticStyle:{"color":"white"}},[_c('i',{staticClass:"mr-2 fa fa-spinner fa-spin"}),_vm._v(" Loading\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JabX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DoctorSlots__ = __webpack_require__("cCX/");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DoctorSlots: __WEBPACK_IMPORTED_MODULE_4__DoctorSlots__["a" /* default */] },
  data: function data() {
    var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date());
    return {
      checkedMohanDr: false,
      checkedMaheshDr: false,
      checkedVarunDr: false,
      checkedArmanDr: false,
      showModal: false,
      openReplaceDr: false,
      selectedDoctor: {},
      isLoading: false,
      addDoctors: false,
      addSelectedDoctor: {},
      timeSlots: ['07:00-07:30', '07:30-08:00', '08:00-08:30', '08:30-09:00', '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00', '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00', '15:00-15:30', '15:30-16:00', '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00', '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00', '20:00-20:30', '20:30-21:00', '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00'],
      doctors: [],
      years: [2022, 2023, 2024],
      months: [{ text: 'January', value: '01' }, { text: 'Feburary', value: '02' }, { text: 'March', value: '03' }, { text: 'April', value: '04' }, { text: 'May', value: '05' }, { text: 'June', value: '06' }, { text: 'July', value: '07' }, { text: 'August', value: '08' }, { text: 'September', value: '09' }, { text: 'October', value: 10 }, { text: 'November', value: 11 }, { text: 'December', value: 12 }],
      selectedMonth: { value: today.format('MM'), text: today.format('MMMM') },
      selectedYear: today.format('YYYY'),
      response: [],
      slotDoctors: [],
      activeSlots: 'family_doctor'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    role: 'configuration/getRole'
  }), {
    dates: function dates() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response);
    }
  }),
  methods: {
    onMonthYearChange: function onMonthYearChange() {
      this.getDoctorsSlots();
    },
    openModal: function openModal(showModal, slot, date) {
      if (this.role !== 'admin') {
        return;
      }
      this.showModal = !this.showModal;
      this.selectedSlot = slot;
      this.selectedDate = date;
      this.slotDoctors = this.getDocsForASlot(slot, date);
    },
    closeModal: function closeModal() {
      this.slotDoctors = [];
      this.selectedDate = '';
      this.selectedSlot = '';
      this.selectedDoctor = {};
      this.showModal = false;
      this.addDoctors = false;
      this.openReplaceDr = false;
      this.getDoctorsSlots();
    },
    dateObject: function dateObject(date) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response[date]).length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response[date]);
      }
      return [];
    },
    selectDoctors: function selectDoctors(i, doc) {
      this.doctors[i].selected = !this.doctors[i].selected;
    },
    showAllDoctors: function showAllDoctors() {
      this.doctors.map(function (doctor) {
        doctor.selected = false;
      });
    },
    setActiveSlots: function setActiveSlots(section) {
      this.activeSlots = section;
    }
  },
  watch: {
    role: {
      immediate: true,
      handler: function handler(newRole) {
        if (newRole === 'externalAdmin') {
          this.activeSlots = 'external_doctor';
        }
      }
    }
  }
});

/***/ }),

/***/ "JoJM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "JxBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Admin_DoctorsList__ = __webpack_require__("Kg8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Admin_DoctorConsultations__ = __webpack_require__("LEJf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DoctorsList: __WEBPACK_IMPORTED_MODULE_0__components_Admin_DoctorsList__["a" /* default */],
    DoctorConsultations: __WEBPACK_IMPORTED_MODULE_1__components_Admin_DoctorConsultations__["a" /* default */]
  },
  data: function data() {
    return {
      doctor: null
    };
  },

  computed: {},
  mounted: function mounted() {},
  methods: {
    getDoctor: function getDoctor(doctor) {
      this.doctor = doctor;
    },
    goBack: function goBack() {
      this.doctor = null;
      this.$store.dispatch('pastConsultation/reset');
    }
  }
});

/***/ }),

/***/ "KCBn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KIIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_consultation__ = __webpack_require__("57jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_customer_summary__ = __webpack_require__("FyQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_customer_profile__ = __webpack_require__("h6cF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_initialise_store__ = __webpack_require__("II+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_customer_health_parameters__ = __webpack_require__("O4OI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_customer_document__ = __webpack_require__("eX/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_customer_medication__ = __webpack_require__("kmHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var state = {
  initiated: false,
  pastOfflineConsults: [],
  activePastConsultId: null,
  currentPage: 1,
  totalPastConsults: 0
};

var getters = {
  isPastChatPresent: function isPastChatPresent() {
    if (state.activePastConsultId !== null) {
      return true;
    } else {
      return false;
    }
  },
  getActivePastCustomer: function getActivePastCustomer() {
    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    var index = state.pastOfflineConsults.indexOf(patient);
    if (index > -1) {
      return state.pastOfflineConsults[index];
    } else {
      return {};
    }
  },
  getPastConsults: function getPastConsults() {
    return state.pastOfflineConsults;
  },
  showLoadMore: function showLoadMore() {
    if (state.pastOfflineConsults.length < state.totalPastConsults) {
      return true;
    } else {
      return false;
    }
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_3__api_initialise_store__["a" /* default */].fetchPastOfflineConsultationsDetails().then(function (response) {
      if (response.status === 200) {
        commit('setUpPastConsults', { details: response.body.past_offline_consults, total: response.body.total });
      }
    });
  },
  fetchMoreConsults: function fetchMoreConsults(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    var newPage = state.currentPage + 1;
    __WEBPACK_IMPORTED_MODULE_3__api_initialise_store__["a" /* default */].fetchPastOfflineConsultationsDetails(newPage).then(function (response) {
      if (response.status === 200) {
        commit('loadMoreConsults', { pastConsults: response.body.past_offline_consults });
      }
    });
  },
  switchTo: function switchTo(_ref3, id) {
    var state = _ref3.state,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('switchTo', id);
    if (id !== null) {
      dispatch('fetchCustomerProfile', id);
    }
  },
  fetchCustomerProfile: function fetchCustomerProfile(_ref4, consultationId) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === consultationId;
    });
    __WEBPACK_IMPORTED_MODULE_2__api_customer_profile__["a" /* default */].getCustomerDetails(patient.channelId).then(function (response) {
      if (response.status === 200) {
        commit('updateCustomerDetails', { activePastConsultId: state.activePastConsultId, customerDetails: response.body.customer });
      }
    });
  },
  addToPastConsultation: function addToPastConsultation(_ref5, _ref6) {
    var commit = _ref5.commit,
        state = _ref5.state;
    var consult = _ref6.consult;

    commit('addToPastConsultation', consult);
  },
  updateSummary: function updateSummary(_ref7, _ref8) {
    var commit = _ref7.commit,
        state = _ref7.state;
    var summary = _ref8.summary;

    __WEBPACK_IMPORTED_MODULE_0__api_consultation__["a" /* default */].updateSummary(summary).then(function (response) {
      if (response.status === 200) {}
    });
  },
  updateConsultation: function updateConsultation(_ref9, data) {
    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    __WEBPACK_IMPORTED_MODULE_1__api_customer_summary__["a" /* default */].saveSummaryDetails(data, patient.consultation.consultationId).then(function (response) {
      if (response.status === 200) {
        commit('updateConsultation', { activePastConsultId: state.activePastConsultId, consultation: response.body.consultation });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateHealthParameters: function updateHealthParameters(_ref10, data) {
    var commit = _ref10.commit,
        state = _ref10.state,
        dispatch = _ref10.dispatch;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    __WEBPACK_IMPORTED_MODULE_4__api_customer_health_parameters__["a" /* default */].updateHealthParameters(data, patient.channelId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { activePastConsultId: patient.consultation.consultationId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  uploadDocuments: function uploadDocuments(_ref11, formData) {
    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;

    __WEBPACK_IMPORTED_MODULE_5__api_customer_document__["a" /* default */].uploadDocuments(formData).then(function (response) {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', { activePastConsultId: state.activePastConsultId, data: response.body });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', { activePastConsultId: state.activePastConsultId, data: response.body.prescriptions })
        // }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateCurrentMedication: function updateCurrentMedication(_ref12, medications) {
    var commit = _ref12.commit,
        state = _ref12.state,
        dispatch = _ref12.dispatch;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    __WEBPACK_IMPORTED_MODULE_6__api_customer_medication__["a" /* default */].update(patient.customerId, medications).then(function (resp) {
      if (resp.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('updateCurrentMedication', { activePastConsultId: state.activePastConsultId, medications: resp.body.medications });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  sendSummary: function sendSummary(_ref13, data) {
    var commit = _ref13.commit,
        state = _ref13.state,
        dispatch = _ref13.dispatch;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    var summaryNotes = patient.consultation.summaryNotes;
    if (!summaryNotes) {
      dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Please add summary' }, { root: true });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__api_customer_summary__["a" /* default */].sendSummary(patient.consultation.consultationId, data.componentKey).then(function (response) {
        if (response.status === 200) {
          commit('updateConsultation', { activePastConsultId: state.activePastConsultId, consultation: response.body.consultation });
          dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    }
  },
  summaryNotNeeded: function summaryNotNeeded(_ref14, data) {
    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    __WEBPACK_IMPORTED_MODULE_1__api_customer_summary__["a" /* default */].summaryNotNeeded(patient.consultation.consultationId, data.componentKey).then(function (response) {
      if (response.status === 200) {
        commit('updateConsultation', { activePastConsultId: state.activePastConsultId, consultation: response.body.consultation });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  setFollowUp: function setFollowUp(_ref15, followUps) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    __WEBPACK_IMPORTED_MODULE_0__api_consultation__["a" /* default */].createFollowUp({ consultation_id: patient.consultation.consultationId, consultation_followup_reminders: followUps }).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('setFollowUp', { followUps: response.body.followup_reminders });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  }
};

// Mutations
var mutations = {
  setUpPastConsults: function setUpPastConsults(state, _ref16) {
    var details = _ref16.details,
        total = _ref16.total;

    state.pastOfflineConsults = [];
    state.activePastConsultId = null;
    state.totalPastConsults = total;
    for (var i = 0; i < details.length; i++) {
      var pc = {
        channelId: details[i].customer_id,
        customerId: details[i].customer_id,
        name: details[i].name,
        isFamilyDoctor: details[i].is_family_doctor,
        familyDoctor: { id: details[i].family_doctor.id, name: details[i].family_doctor.name },
        consultation: {
          chiefComplaint: details[i].chief_compliant,
          consultationId: details[i].consultation_id,
          provisionalDiagnosis: details[i].provisional_diagnois,
          summaryNotes: details[i].summary_notes,
          date: details[i].consultation_date,
          status: details[i].status,
          summary_status: details[i].summary_status,
          prescribedDrugs: details[i].prescribed_drugs,
          followupReminders: details[i].followup_reminders,
          recommendedTests: details[i].recommended_tests
        },
        details: {}
      };
      state.pastOfflineConsults.push(pc);
    }
    state.initiated = true;
  },
  switchTo: function switchTo(state, id) {
    state.activePastConsultId = id;
  },
  updateCustomerDetails: function updateCustomerDetails(state, _ref17) {
    var activePastConsultId = _ref17.activePastConsultId,
        customerDetails = _ref17.customerDetails;

    var consult = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === activePastConsultId;
    });
    var index = state.pastOfflineConsults.indexOf(consult);
    if (index > -1) {
      state.pastOfflineConsults[index].details = customerDetails;
    }
  },
  addToPastConsultation: function addToPastConsultation(state, consult) {
    var pc = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === consult.consultation.consultationId;
    });
    var index = state.pastOfflineConsults.indexOf(pc);
    consult.consultation.date = consult.consultation.date !== '' ? consult.consultation.date : __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date()).format('DD MMM YYYY h:mm:A');
    if (index < 0) {
      var latestPc = {
        channelId: consult.channelId,
        customerId: consult.customerId,
        name: consult.name,
        isFamilyDoctor: consult.isFamilyDoctor,
        consultation: consult.consultation
      };
      if (!consult.isFamilyDoctor && consult.familyDoctor) {
        latestPc.familyDoctor = { id: consult.familyDoctor.id, name: consult.familyDoctor.name };
      }
      state.pastOfflineConsults.unshift(latestPc);
      state.totalPastConsults++;
    }
  },
  updateConsultation: function updateConsultation(state, _ref18) {
    var activePastConsultId = _ref18.activePastConsultId,
        consultation = _ref18.consultation;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === activePastConsultId;
    });
    var index = state.pastOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.pastOfflineConsults[index].consultation.chiefComplaint = consultation.chief_compliant;
      state.pastOfflineConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois;
      state.pastOfflineConsults[index].consultation.summaryNotes = consultation.summary_notes;
      state.pastOfflineConsults[index].consultation.summary_status = consultation.summary_status;
    }
  },
  updateHealthParameter: function updateHealthParameter(state, _ref19) {
    var activePastConsultId = _ref19.activePastConsultId,
        healthParameters = _ref19.healthParameters;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === activePastConsultId;
    });
    var index = state.pastOfflineConsults.indexOf(patient);
    if (index > -1) {
      healthParameters.map(function (param) {
        state.pastOfflineConsults[index].details.health_parameters[param.question_tag] = param.result;
      });
    }
  },
  updateDocuments: function updateDocuments(state, _ref20) {
    var activePastConsultId = _ref20.activePastConsultId,
        data = _ref20.data;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === activePastConsultId;
    });
    var index = state.pastOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.pastOfflineConsults[index].details.documents.push(data);
    }
  },
  updateCurrentMedication: function updateCurrentMedication(state, _ref21) {
    var activePastConsultId = _ref21.activePastConsultId,
        medications = _ref21.medications;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === activePastConsultId;
    });
    var index = state.pastOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.pastOfflineConsults[index].details.medications = medications;
    }
  },


  // updatePrescriptions (state, { activePastConsultId, data }) {
  //   let patient = state.pastOfflineConsults.find(function (ele) {
  //     return (ele.consultation.consultationId === activePastConsultId)
  //   })
  //   let index = state.pastOfflineConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.pastOfflineConsults[index].details.prescriptions = state.pastOfflineConsults[index].details.prescriptions.concat(data)
  //   }
  // },

  loadMoreConsults: function loadMoreConsults(state, _ref22) {
    var pastConsults = _ref22.pastConsults;

    if (pastConsults.length > 0) {
      state.currentPage += 1;
    }
    for (var i = 0; i < pastConsults.length; i++) {
      var pc = {
        channelId: pastConsults[i].customer_id,
        customerId: pastConsults[i].customer_id,
        name: pastConsults[i].name,
        isFamilyDoctor: pastConsults[i].is_family_doctor,
        familyDoctor: { id: pastConsults[i].family_doctor.id, name: pastConsults[i].family_doctor.name },
        consultation: {
          chiefComplaint: pastConsults[i].chief_compliant,
          consultationId: pastConsults[i].consultation_id,
          provisionalDiagnosis: pastConsults[i].provisional_diagnois,
          summaryNotes: pastConsults[i].summary_notes,
          date: pastConsults[i].consultation_date,
          status: pastConsults[i].status,
          summary_status: pastConsults[i].summary_status,
          prescribedDrugs: pastConsults[i].prescribed_drugs,
          followupReminders: pastConsults[i].followup_reminders,
          recommendedTests: pastConsults[i].recommended_tests
        },
        details: {}
      };
      state.pastOfflineConsults.push(pc);
    }
  },
  setFollowUp: function setFollowUp(state, _ref23) {
    var followUps = _ref23.followUps;

    var patient = state.pastOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === state.activePastConsultId;
    });
    if (patient) {
      var i = state.pastOfflineConsults.indexOf(patient);
      state.pastOfflineConsults[i].consultation.followupReminders = followUps;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "KNjL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiByeD0iNiIgZmlsbD0iI0U1RUVGRiIvPgo8cGF0aCBvcGFjaXR5PSIwLjEiIGQ9Ik00Mi4wOSAxLjVIMS45MUMxLjY4MzU2IDEuNSAxLjUgMS42ODM1NiAxLjUgMS45MVY0Mi4wOUMxLjUgNDIuMzE2NCAxLjY4MzU2IDQyLjUgMS45MSA0Mi41SDQyLjA5QzQyLjMxNjQgNDIuNSA0Mi41IDQyLjMxNjQgNDIuNSA0Mi4wOVYxLjkxQzQyLjUgMS42ODM1NiA0Mi4zMTY0IDEuNSA0Mi4wOSAxLjVaIiBmaWxsPSIjRjVGN0Y5IiBmaWxsLW9wYWNpdHk9IjAuMDEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNy4yOTc1IDEyLjk4NjFDMzcuMjk3NSAxMi4wMTI0IDM3LjI1MTEgMTEuMDM4NyAzNy4yNTExIDEwLjE1NzZDMzcuMjUxMSA5LjQ2MjEgMzYuNjk0NyA4Ljg1OTMgMzUuOTUyOCA4Ljg1OTNDMzAuNDgxMyA4Ljg1OTMgMjYuMjYxNyA3LjI4Mjc2IDIyLjc4NCAzLjg5NzgyQzIyLjI3MzkgMy40MzQxMyAyMS40ODU3IDMuNDM0MTMgMjAuOTc1NiAzLjg5NzgyQzE3LjQ5NzkgNy4yODI3NiAxMy4zMjQ3IDguODU5MyA3LjgwNjc5IDguODU5M0M3LjExMTI2IDguODU5MyA2LjUwODQ2IDkuNDE1NzMgNi41MDg0NiAxMC4xNTc2QzYuNTA4NDYgMTEuMDg1IDYuNTA4NDYgMTIuMDEyNCA2LjQ2MjA5IDEyLjk4NjFDNi4yNzY2MSAyMi4yMTM2IDYuMDQ0NzcgMzQuODI2IDIxLjQzOTMgNDAuMTU4NEMyMS41Nzg0IDQwLjIwNDggMjEuNzE3NSA0MC4yNTExIDIxLjg1NjYgNDAuMjUxMUMyMS45OTU3IDQwLjI1MTEgMjIuMTM0OCA0MC4yMDQ4IDIyLjI3MzkgNDAuMTU4NEMzNy42Njg1IDM0LjgyNiAzNy40MzY2IDIyLjIxMzYgMzcuMjk3NSAxMi45ODYxWiIgZmlsbD0iIzJBQjI2OCIvPgo8cGF0aCBkPSJNMjkuNTkzMiAxOC44ODc3QzI4LjA1NzggMTguODM4NSAyNi4xMjYzIDE3LjM2MzYgMjMuNjk5NSAxOC4zNDY4VjE0LjE2ODJDMjcuMjY1NCAxMC41NzkzIDMwLjA4ODQgMTYuODcyMSAzNC40NDY3IDE2LjIzM0MzNC4xNDk2IDE2LjgyMyAzMy43MDM5IDE3LjYzNjEgMzEuNjczMyAxNy4xNDQ2TDMyLjU2NDggMTguMjUyOUMzMS42NzMzIDE4LjU0NzkgMzAuODMxNCAxOC4wNTIzIDI5LjkzOTkgMTcuNTYwNkMyOS42NDI4IDE4LjA1MjMgMzAuMTg3NSAxOC40OTQ2IDMwLjE4NzUgMTguODM4N0MzMC4wMzg4IDE4LjgzODUgMjkuNzkxMiAxOC44ODc3IDI5LjU5MzIgMTguODg3N1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMy44MTQ5IDE4Ljc4OTFDMTMuODE0OSAxOC40NDUgMTQuMzU5NiAxOC4wMDI0IDE0LjA2MjUgMTcuNTEwOUMxMy4xNzEgMTguMDUxOCAxMi4zMjkxIDE4LjU0NzQgMTEuNDM3NiAxOC4yMDMzTDEyLjMyOTEgMTcuMDk1QzEwLjI5ODUgMTcuNTg2NyA5Ljg1MjgzIDE2Ljc3MzQgOS41NTU2NiAxNi4xODM0QzEzLjg2NDQgMTYuODIyNSAxNi42ODc0IDEwLjUyOTggMjAuMzAyOSAxNC4xMTg1VjE4LjI5NzRDMTcuNTc4OSAxNy4xNjY4IDE1LjQ0OTQgMTkuMzI5OSAxMy44MTQ5IDE4Ljc4OTFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIuMDE0NyAxMi45NzkyQzIzLjI0MjIgMTIuOTc5MiAyNC4yMzczIDExLjk3OTYgMjQuMjM3MyAxMC43NDY0QzI0LjIzNzMgOS41MTMzMiAyMy4yNDIyIDguNTEzNjcgMjIuMDE0NyA4LjUxMzY3QzIwLjc4NzMgOC41MTM2NyAxOS43OTIyIDkuNTEzMzIgMTkuNzkyMiAxMC43NDY0QzE5Ljc5MjIgMTEuOTc5NiAyMC43ODczIDEyLjk3OTIgMjIuMDE0NyAxMi45NzkyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIyLjAxNDcgMzUuNTg4M0MyMS43NzM2IDM1LjU4ODMgMjEuNTc4IDM1LjM5MjcgMjEuNTc4IDM1LjE1MTdWMTIuODMyMkMyMS41NzggMTIuNTkxMSAyMS43NzM2IDEyLjM5NTUgMjIuMDE0NyAxMi4zOTU1QzIyLjI1NTcgMTIuMzk1NSAyMi40NTE0IDEyLjU5MTEgMjIuNDUxNCAxMi44MzIyVjM1LjE1MTdDMjIuNDUxNCAzNS4zOTI3IDIyLjI1NiAzNS41ODgzIDIyLjAxNDcgMzUuNTg4M1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yNS44NjIzIDI4Ljc3NTZDMjUuNTE5NyAyOC43NzU2IDI1LjMxMDMgMjguMzgxMyAyNS40OTkgMjguMDk3MkMyNS44MDg2IDI3LjYzMSAyNi4xMzg3IDI2Ljk0IDI1Ljk1MjIgMjYuMjkzN0MyNS42NzI1IDI1LjMyNDcgMjQuMjgyNCAyNC44ODg5IDIzLjQ1MTggMjQuNjI4NEwyMy4yNTYxIDI0LjU2NjZDMjIuMjI3NSAyNC4yMzcxIDIxLjM1NDggMjQuMjkxMSAyMC41MTA1IDI0LjM0MjZDMTkuNDQ3MSAyNC40MDc5IDE4LjQ0MzIgMjQuNDY5NCAxNy40NDg5IDIzLjcwMjJDMTYuOTczNSAyMy4zMzU2IDE2LjE3MzMgMjIuNTQ1NiAxNi4xNTE3IDIxLjM3NTNDMTYuMTI3MiAyMC4wNjcyIDE3LjEwNDUgMTkuMTk5NyAxNy40MDQ1IDE4Ljk2NDhDMTcuNTk0NSAxOC44MTYxIDE3Ljg2OSAxOC44NDk5IDE4LjAxNzcgMTkuMDM5N0MxOC4xNjYzIDE5LjIyOTYgMTguMTMyNyAxOS41MDQxIDE3Ljk0MjggMTkuNjUyOEMxNy43ODY0IDE5Ljc3NTEgMTcuMDA3NiAyMC40MzE4IDE3LjAyNDggMjEuMzU5MUMxNy4wMzk3IDIyLjE2NDggMTcuNjMxMiAyMi43Mzk3IDE3Ljk4MjUgMjMuMDEwN0MxOC43MTcyIDIzLjU3NzcgMTkuNDg0OSAyMy41MzAzIDIwLjQ1NzIgMjMuNDcwN0MyMS4zMzkxIDIzLjQxNjYgMjIuMzM4MiAyMy4zNTUyIDIzLjUyMyAyMy43MzQ3TDIzLjcxMzYgMjMuNzk0OEMyNC43MTE2IDI0LjEwNzYgMjYuMzgxOSAyNC42MzE1IDI2Ljc5MTggMjYuMDUxMUMyNy4wMTI5IDI2LjgxNjggMjYuODE3NSAyNy42OTE1IDI2LjIyNjcgMjguNTgwMkMyNi4xNDI0IDI4LjcwNzMgMjYuMDAzOCAyOC43NzU2IDI1Ljg2MjMgMjguNzc1NloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yNC41ODI1IDMyLjAyNUMyNC4yMzk3IDMyLjAyNSAyNC4wMzAzIDMxLjYzMDYgMjQuMjE5MiAzMS4zNDY2QzI0LjQyMjYgMzEuMDQwNCAyNC42NDA2IDMwLjU4OTggMjQuNTIyNiAzMC4xODFDMjQuMzQ0NSAyOS41NjM2IDIzLjQwNDcgMjkuMjY5IDIyLjg0MzQgMjkuMDkzTDIyLjcwNDcgMjkuMDQ5NEMyMi4wMDE5IDI4LjgyNCAyMS4zOTc5IDI4Ljg2MTIgMjAuODE0MyAyOC44OTcyQzIwLjA3MzcgMjguOTQzIDE5LjMwNzcgMjguOTg5OCAxOC41Njc2IDI4LjQxODhDMTguMjE0MSAyOC4xNDYxIDE3LjYxODQgMjcuNTU3MiAxNy42MDIzIDI2LjY3NzVDMTcuNTgzOSAyNS42OTYxIDE4LjMxMTkgMjUuMDQ4NSAxOC41MzUyIDI0Ljg3MzNDMTguNzI1MiAyNC43MjQ3IDE4Ljk5OTQgMjQuNzU4MyAxOS4xNDg0IDI0Ljk0NzhDMTkuMjk3IDI1LjEzNzggMTkuMjYzOSAyNS40MTIgMTkuMDczOSAyNS41NjA5QzE4Ljk3MTkgMjUuNjQwOCAxOC40NjQzIDI2LjA2OSAxOC40NzU0IDI2LjY2MTZDMTguNDg1IDI3LjE3NjQgMTguODcxNSAyNy41NTA0IDE5LjEwMTIgMjcuNzI3NUMxOS41ODEzIDI4LjA5ODEgMjAuMDc2MSAyOC4wNjc3IDIwLjc2MDggMjguMDI1NkMyMS4zOTQyIDI3Ljk4NjcgMjIuMTEyMSAyNy45NDI4IDIyLjk3MTEgMjguMjE3N0wyMy4xMDQ1IDI4LjI1OThDMjMuODMzNiAyOC40ODg0IDI1LjA1MzQgMjguODcwOCAyNS4zNjE3IDI5LjkzOTFDMjUuNTI4NiAzMC41MTY5IDI1LjM4NTEgMzEuMTcxIDI0Ljk0NjcgMzEuODMwNEMyNC44NjI0IDMxLjk1NjYgMjQuNzIzNyAzMi4wMjUgMjQuNTgyNSAzMi4wMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjMuNTU2IDM0Ljk5ODlDMjMuMjEzNCAzNC45OTg5IDIzLjAwNCAzNC42MDQ2IDIzLjE5MjcgMzQuMzIwNUMyMy4yODk0IDM0LjE3NDkgMjMuNDQyIDMzLjg5NjEgMjMuMzc1OCAzMy42NjY0QzIzLjI3OTEgMzMuMzMxIDIyLjcwMDkgMzMuMTQ5OCAyMi4zNTUzIDMzLjA0MTVMMjIuMjYyMSAzMy4wMTJDMjEuODIwOCAzMi44NzA1IDIxLjQzMjggMzIuODk0NSAyMS4wNTc5IDMyLjkxNzRDMjAuNTM4IDMyLjk0OTUgMjAuMDAwNyAzMi45ODIzIDE5LjQ2NDkgMzIuNTY5QzE5LjAyMjcgMzIuMjI3MyAxOC43NzQ1IDMxLjc3NTcgMTguNzY1OCAzMS4yOTczQzE4Ljc1MjQgMzAuNTc2OCAxOS4yODAyIDMwLjEwNjMgMTkuNDQyNCAyOS45NzkyQzE5LjYzMjQgMjkuODMwNSAxOS45MDY2IDI5Ljg2MzcgMjAuMDU1NSAzMC4wNTM0QzIwLjIwNDIgMzAuMjQzMiAyMC4xNzEgMzAuNTE3NiAxOS45ODEzIDMwLjY2NjZDMTkuOTIzIDMwLjcxMjIgMTkuNjMzIDMwLjk1NjMgMTkuNjM4OSAzMS4yODFDMTkuNjQ0MSAzMS41NjIyIDE5Ljg2NjQgMzEuNzc1MyAxOS45OTgzIDMxLjg3NzNDMjAuMjYyMSAzMi4wODA4IDIwLjUyNDkgMzIuMDc1MyAyMS4wMDQ0IDMyLjA0NTRDMjEuNDE3MyAzMi4wMjAzIDIxLjkzMDkgMzEuOTg4NiAyMi41Mjg1IDMyLjE3OTlMMjIuNjE2NyAzMi4yMDc4QzIzLjA5NTkgMzIuMzU4MSAyMy45ODgxIDMyLjYzOCAyNC4yMTQ3IDMzLjQyMzhDMjQuMzM3OSAzMy44NTA2IDI0LjIzNjEgMzQuMzI3NyAyMy45MTk3IDM0LjgwMzVDMjMuODM1OSAzNC45MzA2IDIzLjY5NzIgMzQuOTk4OSAyMy41NTYgMzQuOTk4OVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yNi4xMDA1IDIzLjY0OTJDMjUuNjI1MiAyMy42NDkyIDI1LjUwNDkgMjIuOTY0IDI1Ljk1MTQgMjIuODAyQzI2LjYzNzcgMjIuNTUyOSAyNy4wODgxIDIxLjk3NCAyNy4wOTkyIDIxLjMyNzdDMjcuMTA5NyAyMC43MTQ0IDI2LjcxMDQgMjAuMTM2OSAyNi4wODIgMTkuODU2NUMyNS44NjE3IDE5Ljc1ODMgMjUuNzYzIDE5LjUgMjUuODYxIDE5LjI3OTdDMjUuOTU5NSAxOS4wNTk2IDI2LjIxNzggMTguOTYwNSAyNi40Mzc5IDE5LjA1ODdDMjcuMzg2NiAxOS40ODIxIDI3Ljk4OSAyMC4zNzg0IDI3Ljk3MjQgMjEuMzQyNEMyNy45NTQ5IDIyLjM1MzkgMjcuMjc4NyAyMy4yNDg5IDI2LjI0OTQgMjMuNjIyN0MyNi4yMDA1IDIzLjY0MDYgMjYuMTUwMSAyMy42NDkyIDI2LjEwMDUgMjMuNjQ5MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMC41OTM5IDM1LjI0NjRDMjAuMzQwOSAzNS4yNDY0IDIwLjA5MjYgMzUuMTU4IDE5Ljg5NjEgMzQuOTk0OUMxOS42Njk1IDM0LjgwNjkgMTkuNTMwNiAzNC41MzU1IDE5LjUxNDkgMzQuMjUwNEMxOS40ODQ4IDMzLjY5NDUgMTkuOTIyNSAzMy4xOTczIDIwLjQ5MDcgMzMuMTQyMUMyMC43MzE5IDMzLjExOTggMjAuOTQ0MiAzMy4yOTQ1IDIwLjk2NzUgMzMuNTM0NEMyMC45OTA3IDMzLjc3NDYgMjAuODE1MSAzMy45ODc5IDIwLjU3NTIgMzQuMDExM0MyMC4zMDg0IDM0LjAzNzMgMjAuMzYxMiAzNC40MDYzIDIwLjYyMTIgMzQuMzcxMUMyMC44OCAzNC4zMzYgMjEuMTE2NCAzNC41NDU2IDIxLjExNTEgMzQuODA2M0MyMS4xMTM4IDM1LjEwMDYgMjAuODU5MiAzNS4yNDY0IDIwLjU5MzkgMzUuMjQ2NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "KOeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KTTO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kg8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorsList_vue__ = __webpack_require__("U2SJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee81fcb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorsList_vue__ = __webpack_require__("Tlky");
function injectStyle (ssrContext) {
  __webpack_require__("k/wg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee81fcb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KuaY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADDElEQVR4nO3dv08TYRzH8c9zh4PRiWiQWlJoYvwPcFEUwmp0w7DzLxhSOraFzeiKs8rojghqNPFvEG1BCgRh8EdcuOdxkMGQa+LR57lPCZ/XeL0830vfueMOUgqIiIiInEWGfQD/Kle3JhNrpgxwC0ARwIWMS/wC8NUZvHHOLm00iq/8H6VfPRGgXN28Zm28COC214UdVmOXzKwvDH3yuq5H9ADlufZN6/ASQH+gEQeRwb3P9cK7QOt3hRqgVN0ZgbUfDXAp8KiD2CY3evFMiJjDTZI8zeHNB4D+xMSLOczJjBagXN2ahDETuQ00uFOq7uQ37z/1sQYf3e2k+Q2DWePipS+Ngd0sa45UdgcckgcA5gGcP/66sXYKwMoJDjcYWgADjHV4YbZZLzw5yZpHwR4Pz7UNHB6l7JI+k4h2CXJAIW27cfFSt2sbFz/vMLPY7dq+0QIY4GLa9qyXnSxrdJrJRL0LEgWgy/wgNlxpuxAHcto0GwUvD7E6A8gUgEwByBSATAHIvP06utPdka+7hdBYx68zgEwByBSATAHIFICM9geZrHcdofdn0RlApgBkCkCmAGQKQKYAZApApgBkCkCmAGQKQKYAZApApgBkCkCmAGQKQKYAZApApgBkCkCmAGQKQKYAZApApgBkCkCmAGQKQKYAZApApgBkCkCmAGQKQKYAZApApgBkCkCmAGQKQEb7pHzWT6yH3p9FZwCZApD5DPAjbWOpsjfocUYQQw83Uv+ROIDvoWf7DNBO33w47XFGEH3xuU7HuBV8tse11gBcP77RwNVLlW0Afc9ajcvbHud17e/ZeTjt4GoddlkLfQze7hRK1Z0JY23Pf29XJpEZb9YGV4OO8LVQq3ZlxTks+1qvB7wO/eYDnu+CjDMzAPZ8rkmyn0TxTB6DvAZoLgw2nXH3Aez7XDdPDvjmnL27WRtYz2Oe9+eAVv3qe2vjUQNz6n4eOIdlRNFoa774Ia+ZQR/XS5XtcQM3BWDMAUO99h0uDvhpgA0AbxGZF3lc80VERERERERE5Oz6A9Alv3IIQREFAAAAAElFTkSuQmCC"

/***/ }),

/***/ "L53c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.consultFollowupReminders.length > 0 || _vm.testFollowupReminders.length > 0)?_c('div',{staticClass:"flex flex-col px-2 py-4 bg-white border-b border-t border-solid border-grey-lightest mb-3"},[_vm._m(0),_vm._v(" "),(_vm.consultFollowupReminders.length > 0)?_c('div',_vm._l((_vm.consultFollowupReminders),function(r,i){return _c('div',{key:i,staticClass:"flex flex-col border border-solid border-grey-lightest rounded-sm mx-2 p-4 my-2"},[(r.followup_type === 'consultation')?_c('div',[_c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"flex flex-row items-center"},[_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("1JxI")}}),_vm._v(" "),_c('div',{staticClass:"text-green ml-4 font-semibold flex text-sm"},[_vm._v("\n              Consultation "),_c('p',{staticClass:"ml-1 text-grey-darkest font-semibold"},[_vm._v("on "+_vm._s(_vm._f("formatDateWithoutTime")(r.scheduled_time)))])])]),_vm._v(" "),_c('div',{staticClass:"flex ml-auto text-sm"},[_vm._v("\n            Set on: "),_c('p',{staticClass:"ml-1 text-grey-darkest font-semibold"},[_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(r.created_at)))])])]),_vm._v(" "),_c('div',{staticClass:"flex mx-10 mt-4"},[_c('p',{staticClass:"text-xs text-grey-dark"},[_vm._v("Reminder will be sent to "+_vm._s(_vm.customer.name)+" 48 hours before the event to consult back to you")])])]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.testFollowupReminders.length > 0)?_c('div',{staticClass:"flex flex-col border border-solid border-grey-lightest rounded-sm mx-2 p-4 my-2"},[_c('div',{staticClass:"flex flex-row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex ml-auto text-sm"},[_vm._v("\n        Set on: "),_c('p',{staticClass:"ml-1 text-grey-darkest font-semibold"},[_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(_vm.testFollowupReminders[0].created_at)))])])]),_vm._v(" "),_vm._l((_vm.testFollowupReminders),function(l,i){return _c('div',{key:i,staticClass:"flex flex-row w-auto ml-10 mt-2 text-sm bg-grey-extralight h-8 text-dark py-2 px-3",staticStyle:{"border-radius":"25px"}},[_vm._v("\n      "+_vm._s(l.package_name)+" "),_c('p',{staticClass:"flex text-grey-darkest font-semibold"},[_vm._v("on "+_vm._s(_vm._f("formatDateWithoutTime")(l.scheduled_time)))])])}),_vm._v(" "),_c('div',{staticClass:"flex mx-10 mt-4"},[_c('p',{staticClass:"text-xs text-grey-dark"},[_vm._v("Reminder will be sent to "+_vm._s(_vm.customer.name)+" 48 hours before the event to consult back to you")])])],2):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-white mt-2 mx-2 flex-no-shrink flex-no-grow"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 mr-1 tracking-wide",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Scheduled follow ups")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center"},[_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("1JxI")}}),_vm._v(" "),_c('div',{staticClass:"text-green ml-4 font-semibold flex text-sm"},[_vm._v("\n          Lab Test follow ups\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LDrI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index_js__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      otp_code: '',
      backUpCodes: [],
      copyCodes: 'copy',
      showBackUpCodes: false,
      enableViaAuthApp: false,
      enableViaOtp: false,
      showQR: true,
      altCode: '',
      qrCode: '',
      showQRText: "I Can't Scan the QR Code"
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    role: function role(state) {
      return state.configuration.role;
    }
  })),
  methods: {
    goBack: function goBack() {
      this.enableViaAuthApp = false;
      this.enableViaOtp = false;
      this.showBackUpCodes = false;
      this.otp_code = '';
    },
    goBackToLogin: function goBackToLogin() {
      this.enableViaAuthApp = false;
      this.enableViaOtp = false;
      sessionStorage.removeItem('mfa_token');
      sessionStorage.removeItem('mfa_enabled');
      __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].push('login');
    },
    viaAuthenticatorApp: function viaAuthenticatorApp() {
      var _this = this;

      this.enableViaAuthApp = true;
      this.isLoading = true;
      var options = { mfa_token: sessionStorage.getItem('mfa_token') };
      this.$http.post(window.API_URL + 'doctors/mfa_settings/qr_code', options).then(function (response) {
        if (response.status === 200) {
          _this.isLoading = false;
          _this.altCode = response.body.alternative_code;
          var qrCode = response.body.qr_code;
          _this.qrCode = 'data:image/svg+xml;base64,' + btoa(qrCode);
        }
      }).catch(function () {
        this.isLoading = false;
        this.$toast.open({
          message: 'Failed to generate QR-code',
          type: 'error',
          position: 'top',
          queue: false
        });
        this.enableViaAuthApp = false;
      });
    },
    viaOtp: function viaOtp() {
      var _this2 = this;

      this.enableViaOtp = true;
      this.isLoading = true;
      var options = { mfa_token: sessionStorage.getItem('mfa_token') };
      this.$http.post(window.API_URL + 'doctors/mfa_settings/otp_code', options).then(function (response) {
        if (response.status === 200) {
          _this2.isLoading = false;
          _this2.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          });
        }
      }).catch(function () {
        this.isLoading = false;
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        });
        this.enableViaOtp = false;
      });
    },
    configMfaSettings: function configMfaSettings() {
      var _this3 = this;

      this.isLoading = true;
      var options = {
        mfa_token: sessionStorage.getItem('mfa_token'),
        otp_code: this.otp_code
      };
      if (this.otp_code !== '') {
        this.$http.post(window.API_URL + 'doctors/mfa_settings', options).then(function (response) {
          _this3.showBackUpCodes = true;
          _this3.enableViaAuthApp = false;
          _this3.enableViaOtp = false;
          if (response.status === 200) {
            _this3.isLoading = false;
            _this3.backUpCodes = response.body.backup_codes;
            _this3.$toast.open({
              message: response.body.message,
              type: 'success',
              position: 'top',
              queue: false
            });
          }
        }).catch(function (error) {
          _this3.isLoading = false;
          _this3.$toast.open({
            message: error.body.message || 'Something went wrong!',
            type: 'error',
            position: 'top',
            queue: false
          });
        });
      }
    },
    showMfaQr: function showMfaQr() {
      if (this.showQR) {
        this.showQRText = 'Scan a QR Code';
      } else {
        this.showQRText = "I Can't Scan the QR Code";
      }
      this.showQR = !this.showQR;
    },
    resendOTP: function resendOTP() {
      var _this4 = this;

      this.isLoading = true;
      var options = { mfa_token: sessionStorage.getItem('mfa_token') };
      this.$http.post(window.API_URL + 'doctors/mfa_settings/resend_otp', options).then(function (response) {
        if (response.status === 200) {
          _this4.isLoading = false;
          _this4.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          });
        }
      }).catch(function () {
        this.isLoading = false;
        this.enableViaOtp = false;
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    },
    copyCodesToClip: function copyCodesToClip() {
      var _this5 = this;

      this.copyCodes = 'copied!';
      var textToCopy = this.backUpCodes.join(', ');
      var tempTextarea = document.createElement('textarea');
      tempTextarea.value = textToCopy;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand('copy');
      this.$toast.open({
        message: 'Text copied to clipboard',
        type: 'success',
        position: 'top',
        queue: false
      });
      document.body.removeChild(tempTextarea);
      setTimeout(function () {
        _this5.copyCodes = 'copy';
      }, 1500);
    }
  }
});

/***/ }),

/***/ "LEJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorConsultations_vue__ = __webpack_require__("0OM2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6332faa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorConsultations_vue__ = __webpack_require__("uKUm");
function injectStyle (ssrContext) {
  __webpack_require__("KOeV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorConsultations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6332faa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorConsultations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LKLm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  activeTab: 'scheduled',
  openDoctorAssignModal: false,
  selectedAppointment: {}
};

var getters = {
  getActiveTab: function getActiveTab(state) {
    return state.activeTab;
  },
  getDoctorAssignModalHandler: function getDoctorAssignModalHandler(state) {
    return state.openDoctorAssignModal;
  },
  getSelectedAppointment: function getSelectedAppointment(state) {
    return state.selectedAppointment;
  }
};

var actions = {
  updateActiveTab: function updateActiveTab(_ref, tab) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    commit('updateActiveTab', tab);
  },
  toggleAssignModal: function toggleAssignModal(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    commit('toggleAssignModal');
  },
  updateSelectedAppointment: function updateSelectedAppointment(_ref3, appointment) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    commit('updateSelectedAppointment', appointment);
  }
};

var mutations = {
  updateActiveTab: function updateActiveTab(state, tab) {
    state.activeTab = tab;
  },
  toggleAssignModal: function toggleAssignModal(state) {
    state.openDoctorAssignModal = !state.openDoctorAssignModal;
  },
  updateSelectedAppointment: function updateSelectedAppointment(state, appointment) {
    state.selectedAppointment = appointment;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "LLFE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LR/b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LTnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "LZFJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_consultation_request__ = __webpack_require__("eJoz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_consultation__ = __webpack_require__("57jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_customer_profile__ = __webpack_require__("h6cF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_customer_medication__ = __webpack_require__("kmHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_ably__ = __webpack_require__("oKrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__ = __webpack_require__("II+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_customer_prescription__ = __webpack_require__("b8jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__ = __webpack_require__("O4OI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_customer_summary__ = __webpack_require__("FyQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_customer_document__ = __webpack_require__("eX/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_snackbar_helpers__ = __webpack_require__("tjrC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sentry_vue__ = __webpack_require__("B3+F");

















__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_toast_notification___default.a);

// State
var state = {
  initiated: false,
  activeConsults: [],
  activeCustomerId: null,
  activeChannelId: null,
  messages: [],
  inputMessage: '',
  selectedTests: [],
  selectedDrugs: [],
  drugs: []
  // Getters
};var getters = {
  getActiveConsults: function getActiveConsults() {
    return state.activeConsults;
  },
  getActiveUserProfile: function getActiveUserProfile() {
    var consult = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    if (consult) {
      return consult;
    }
    return {};
  },
  isActiveChatPresent: function isActiveChatPresent() {
    if (state.activeChannelId !== null) {
      return true;
    } else {
      return false;
    }
  },
  activeConsultsCount: function activeConsultsCount() {
    return state.activeConsults.length;
  },
  getInputMessage: function getInputMessage() {
    var index = state.messages.findIndex(function (msg) {
      return msg.channelId === state.activeChannelId;
    });
    var message = '';
    if (index === -1) {
      state.inputMessage = '';
      message = '';
    } else {
      state.inputMessage = state.messages[index].message;
      message = state.messages[index].message;
    }
    // Logging for jumbled messages in production
    // Temporary code to capture the input message
    if (state.activeChannelId !== state.activeCustomerId && message.length > 0) {
      var maskedMessage = '';
      maskedMessage = '*'.repeat(Math.max(0, message.length - 4)) + message.slice(-4);
      __WEBPACK_IMPORTED_MODULE_16__sentry_vue__["b" /* setUser */]({ id: state.activeChannelId });
      __WEBPACK_IMPORTED_MODULE_16__sentry_vue__["c" /* captureMessage */]('Input Message', {
        level: 'info',
        tags: { event_name: 'input_message' },
        extra: {
          msgChannelId: message.channelId,
          activeChannelId: state.activeChannelId,
          index: index,
          message: maskedMessage,
          activeCustomerId: state.activeCustomerId
        }
      });
    }

    return message;
  },
  getLabTests: function getLabTests() {
    var index = state.selectedTests.findIndex(function (test) {
      return test.customerId === state.activeCustomerId;
    });
    if (index > -1) {
      return state.selectedTests[index].tests;
    } else {
      return [];
    }
  },
  getIsAdding: function getIsAdding() {
    var index = state.selectedDrugs.findIndex(function (drug) {
      return drug.customerId === state.activeCustomerId;
    });
    if (index > -1) {
      return state.selectedDrugs[index].isAdding;
    } else {
      return false;
    }
  },
  getDrugs: function getDrugs() {
    var index = state.drugs.findIndex(function (ele) {
      return ele.customerId === state.activeCustomerId;
    });
    if (index > -1) {
      return state.drugs[index].drugs;
    } else {
      return [];
    }
  },
  getCurrentDrug: function getCurrentDrug() {
    var index = state.selectedDrugs.findIndex(function (drug) {
      return drug.customerId === state.activeCustomerId;
    });
    if (index > -1) {
      return state.selectedDrugs[index].drugs;
    } else {
      var medication = {
        name: null,
        dose_quantity: '',
        dose_unit: '',
        frequency: null,
        frequency_unit: null,
        date: null,
        duration: null,
        duration_unit: null,
        number_of_days: 0,
        isActive: true,
        route: null,
        instructions: null,
        is_current: false
      };
      return medication;
    }
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState;

    __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__["a" /* default */].fetchActiveConsultationsDetails().then(function (response) {
      if (response.status === 200) {
        commit('setUpDetails', response.body.active_consultations);
        dispatch('message/setUpAllPatientMessages', {}, { root: true });
        if (state.activeConsults.length > 0) {
          dispatch('switchTo', { channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId });
        } else {
          dispatch('switchTo', { channelId: null, customerId: null });
        }
      }
    });
  },
  addToActiveConsultation: function addToActiveConsultation(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;
    var request = _ref3.request,
        consultation = _ref3.consultation;

    commit('addToActiveConsults', { request: request, consultation: consultation });
    dispatch('joinCustomerChannel', request.channelId);
    dispatch('switchTo', { channelId: request.channelId, customerId: request.customer_id, isNewPatient: true });
  },
  addQueryToActiveConsultation: function addQueryToActiveConsultation(_ref4, _ref5) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;
    var request = _ref5.request,
        consultation = _ref5.consultation;

    commit('addQueryToActiveConsults', { request: request, consultation: consultation });
    dispatch('joinCustomerChannel', request.channelId);
    dispatch('switchTo', { channelId: request.channelId, customerId: request.customer_id });
  },
  removeConsultation: function removeConsultation(_ref6, customerId) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit('remove', customerId);
    if (state.activeConsults.length > 0) {
      commit('switchTo', { channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId });
    } else {
      commit('switchTo', { channelId: null, customerId: null });
    }
    __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePresenceEvents(customerId, 'leave');
  },
  joinCustomerChannel: function joinCustomerChannel(_ref7, channelId) {
    var state = _ref7.state;

    __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].subscribeToChannel(channelId);
  },
  endChat: function endChat(_ref8, _ref9) {
    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState,
        dispatch = _ref8.dispatch;
    var status = _ref9.status,
        reasons = _ref9.reasons,
        id = _ref9.id;

    var patient = void 0;
    if (id) {
      patient = state.activeConsults.find(function (ele) {
        return ele.channelId === id;
      });
    } else {
      patient = state.activeConsults.find(function (ele) {
        return ele.channelId === state.activeChannelId;
      });
    }
    var channelId = patient.channelId;
    if (status === 'SUCCESS') {
      __WEBPACK_IMPORTED_MODULE_1__api_consultation_request__["a" /* default */].end(patient.consultationRequest.consultationRequestId).then(function (response) {
        if (response.status === 200 || response.status === 204) {
          if (response.body.message === 'Diagnosis can not be empty') {
            __WEBPACK_IMPORTED_MODULE_13_vue__["default"].$toast.open({
              message: 'Diagnosis can not be empty',
              type: 'error',
              position: 'top',
              queue: false
            });
          } else if (response.body.status === 'error') {
            __WEBPACK_IMPORTED_MODULE_13_vue__["default"].$toast.open({
              message: response.body.message,
              type: 'error',
              position: 'top',
              queue: false
            });
            commit('remove', channelId);
            commit('switchTo', { channelId: null, customerId: null });
          } else {
            commit('remove', channelId);
            commit('removeDrugs', { customerId: patient.customerId });
            if (state.activeConsults.length > 0) {
              commit('switchTo', { channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId });
            } else {
              commit('switchTo', { channelId: null, customerId: null });
            }
            __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'leave');
            dispatch('message/removeChat', { channelId: channelId }, { root: true });
            dispatch('pastConsultation/addToPastConsultation', { consult: patient }, { root: true });
            dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
            // window.location.reload()
          }
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    } else if (status === 'FAILURE') {
      __WEBPACK_IMPORTED_MODULE_1__api_consultation_request__["a" /* default */].endIncomplete(patient.consultationRequest.consultationRequestId, reasons).then(function (response) {
        if (response.status === 200 || response.status === 204) {
          commit('remove', channelId);
          if (response.body.status === 'error') {
            __WEBPACK_IMPORTED_MODULE_13_vue__["default"].$toast.open({
              message: response.body.message,
              type: 'error',
              position: 'top',
              queue: false
            });
            commit('switchTo', { channelId: null, customerId: null });
          } else if (state.activeConsults.length > 0) {
            commit('switchTo', { channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId });
            dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
          } else {
            commit('switchTo', { channelId: null, customerId: null });
            dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
          }
          __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'leave');
          dispatch('message/removeChat', { channelId: channelId }, { root: true });
          dispatch('pastConsultation/addToPastConsultation', { consult: patient }, { root: true });
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    }
  },
  fetchCustomerProfile: function fetchCustomerProfile(_ref10, _ref11) {
    var commit = _ref10.commit,
        state = _ref10.state;
    var customerId = _ref11.customerId,
        channelId = _ref11.channelId;

    __WEBPACK_IMPORTED_MODULE_3__api_customer_profile__["a" /* default */].getCustomerDetails(customerId).then(function (response) {
      if (response.status === 200) {
        commit('updateCustomerDetails', { channelId: channelId, customerDetails: response.body.customer });
      }
    });
  },
  switchTo: function switchTo(_ref12, _ref13) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch,
        state = _ref12.state,
        rootState = _ref12.rootState;
    var channelId = _ref13.channelId,
        customerId = _ref13.customerId,
        _ref13$isNewPatient = _ref13.isNewPatient,
        isNewPatient = _ref13$isNewPatient === undefined ? false : _ref13$isNewPatient;

    commit('switchTo', { channelId: channelId, customerId: customerId });
    if (channelId !== null && customerId !== null) {
      dispatch('message/setUpMessages', { channelId: channelId, customerId: customerId, isNewPatient: isNewPatient }, { root: true });
      dispatch('fetchCustomerProfile', { customerId: customerId, channelId: channelId });
    }
  },
  sendDoctorTyping: function sendDoctorTyping(_ref14, isTyping) {
    var state = _ref14.state,
        commit = _ref14.commit;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    if (patient) {
      __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePresenceEvents(state.activeChannelId, 'update', { isTyping: isTyping, lastReadMessage: patient.lastReadMsg, deliveredMessage: patient.lastReceivedMsg, consultation_request_id: patient.consultationRequest.consultationRequestId });
    }
  },
  storeMessage: function storeMessage(_ref15, message) {
    var state = _ref15.state,
        commit = _ref15.commit;

    commit('storeMessage', { message: message });
  },
  receiveCustomerTyping: function receiveCustomerTyping(_ref16, _ref17) {
    var commit = _ref16.commit,
        state = _ref16.state;
    var channelId = _ref17.channelId,
        isTyping = _ref17.isTyping;

    commit('setCustomerTyping', { channelId: channelId, typing: isTyping });
  },
  updateIsOnline: function updateIsOnline(_ref18, _ref19) {
    var commit = _ref18.commit,
        state = _ref18.state;
    var channelId = _ref19.channelId,
        status = _ref19.status;

    commit('togglePatientAvailability', { channelId: channelId, status: status });
  },
  ablyEnabled: function ablyEnabled(_ref20, _ref21) {
    var commit = _ref20.commit,
        state = _ref20.state;
    var channelId = _ref21.channelId,
        status = _ref21.status;

    commit('updateAblyChannelStatus', { channelId: channelId, status: status });
  },
  updateRecommendedTests: function updateRecommendedTests(_ref22, data) {
    var commit = _ref22.commit,
        state = _ref22.state;

    commit('updateRecommendedTests', data);
  },
  transferToDoctor: function transferToDoctor(_ref23, _ref24) {
    var commit = _ref23.commit,
        state = _ref23.state;
    var doctorId = _ref24.doctorId;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    var channelId = patient.channelId;
    __WEBPACK_IMPORTED_MODULE_2__api_consultation__["a" /* default */].transferToNewDoctor(doctorId, patient.consultationRequest.consultationRequestId).then(function (response) {
      if (response.status === 200 && response.body.msg === 'Success') {
        commit('remove', channelId);
        if (state.activeConsults.length > 0) {
          commit('switchTo', { channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId });
        } else {
          commit('switchTo', { channelId: null, customerId: null });
        }
        __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'leave');
      }
    });
  },
  previewPrescription: function previewPrescription(_ref25, _ref26) {
    var commit = _ref25.commit,
        state = _ref25.state;
    var data = _ref26.data;

    __WEBPACK_IMPORTED_MODULE_7__api_customer_prescription__["a" /* default */].createPrescription(data, 'preview', state.activeChannelId).then(function (response) {
      if (response.status === 200) {
        window.open(response.body.prescription_url, '_blank');
      }
    });
  },
  updateHealthParameters: function updateHealthParameters(_ref27, data) {
    var commit = _ref27.commit,
        state = _ref27.state,
        dispatch = _ref27.dispatch;

    __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__["a" /* default */].updateHealthParameters(data, state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeChannelId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateGeneralParameters: function updateGeneralParameters(_ref28, data) {
    var commit = _ref28.commit,
        state = _ref28.state,
        dispatch = _ref28.dispatch;

    __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__["a" /* default */].updateGeneralParameters({ gender: data.gender, date_of_birth: data.date_of_birth }, state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.body).length > 0) {
          commit('updateCustomerDetails', { channelId: state.activeChannelId, customerDetails: { gender: response.body.gender, date_of_birth: response.body.date_of_birth } });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
    __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__["a" /* default */].updateHealthParameters({ blood_group: data.blood_group }, state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeChannelId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateMedication: function updateMedication(_ref29, data) {
    var commit = _ref29.commit,
        state = _ref29.state;

    commit('updateMedication', { channelId: state.activeChannelId, prescribedDrugs: data.prescribedDrugs });
  },
  updateCurrentMedication: function updateCurrentMedication(_ref30, medications) {
    var commit = _ref30.commit,
        state = _ref30.state,
        dispatch = _ref30.dispatch;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    __WEBPACK_IMPORTED_MODULE_4__api_customer_medication__["a" /* default */].update(patient.customerId, medications).then(function (resp) {
      if (resp.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('updateCurrentMedication', { channelId: state.activeChannelId, medications: resp.body.medications });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateConsultation: function updateConsultation(_ref31, data) {
    var commit = _ref31.commit,
        state = _ref31.state,
        dispatch = _ref31.dispatch;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    if (patient.consultation.consultationId) {
      __WEBPACK_IMPORTED_MODULE_9__api_customer_summary__["a" /* default */].saveSummaryDetails(data, patient.consultation.consultationId).then(function (response) {
        if (response.status === 200) {
          dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
          commit('updateConsultation', { channelId: state.activeChannelId, consultation: response.body.consultation });
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    } else if (patient) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data)[0] === 'chief_compliant') {
        data.customer_id = state.activeCustomerId;
        data.consultation_request_id = patient.consultationRequest.consultationRequestId;
        dispatch('createConsultation', data);
      } else {
        __WEBPACK_IMPORTED_MODULE_13_vue__["default"].$toast.open({
          message: 'Please add Chief complaint to create consultation',
          type: 'error',
          position: 'top',
          queue: false
        });
        commit('updateConsultation', { channelId: state.activeChannelId, consultation: {} });
      }
    }
  },
  createConsultation: function createConsultation(_ref32, data) {
    var commit = _ref32.commit,
        state = _ref32.state,
        dispatch = _ref32.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__api_consultation__["a" /* default */].create(data).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('setupNewConsultation', { channelId: state.activeChannelId, consultation: response.body.consultation });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  sendSummary: function sendSummary(_ref33, data) {
    var commit = _ref33.commit,
        state = _ref33.state,
        dispatch = _ref33.dispatch;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    __WEBPACK_IMPORTED_MODULE_9__api_customer_summary__["a" /* default */].sendSummary(patient.consultation.consultationId, data.componentKey).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  summaryNotNeeded: function summaryNotNeeded(_ref34, data) {
    var commit = _ref34.commit,
        state = _ref34.state,
        dispatch = _ref34.dispatch;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    __WEBPACK_IMPORTED_MODULE_9__api_customer_summary__["a" /* default */].summaryNotNeeded(patient.consultation.consultationId, data.componentKey).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  uploadDocuments: function uploadDocuments(_ref35, formData) {
    var commit = _ref35.commit,
        state = _ref35.state,
        dispatch = _ref35.dispatch;

    __WEBPACK_IMPORTED_MODULE_10__api_customer_document__["a" /* default */].uploadDocuments(formData).then(function (response) {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', { channelId: state.activeChannelId, data: response.body });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', {channelId: state.activeChannelId, data: response.body.prescriptions})
        // }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  receivedDocumentUpdate: function receivedDocumentUpdate(_ref36, data) {
    var commit = _ref36.commit,
        state = _ref36.state;

    var report = {
      id: data.message.payload.id,
      name: data.message.payload.file_name,
      date: new Date(Number(data.message.uniqueId))
    };
    commit('updateDocuments', { channelId: data.channelId, data: [report] });
  },
  storeLabTests: function storeLabTests(_ref37, _ref38) {
    var state = _ref37.state,
        commit = _ref37.commit;
    var tests = _ref38.tests,
        customerId = _ref38.customerId;

    commit('storeLabTests', { tests: tests, customerId: customerId });
  },
  storeDrugs: function storeDrugs(_ref39, _ref40) {
    var state = _ref39.state,
        commit = _ref39.commit;
    var drugs = _ref40.drugs,
        channelId = _ref40.channelId,
        isAdding = _ref40.isAdding;

    commit('storeDrugs', { drugs: drugs, channelId: channelId, isAdding: isAdding });
  },
  removeDrugs: function removeDrugs(_ref41, _ref42) {
    var state = _ref41.state,
        commit = _ref41.commit;
    var customerId = _ref42.customerId;

    commit('removeDrugs', { customerId: customerId });
  }
};

// Mutations
var mutations = {
  setUpDetails: function setUpDetails(state, details) {
    state.activeConsults = [];
    state.activeCustomerId = null;
    state.activeChannelId = null;
    for (var i = 0; i < details.length; i++) {
      var consult = {
        ablyEnabled: false,
        channelId: details[i].channel_id,
        customerId: details[i].customer_id,
        name: details[i].customer_name,
        isFamilyDoctor: details[i].is_family_doctor,
        familyDoctor: { id: details[i].family_doctor.id, name: details[i].family_doctor.name },
        accepted_at: details[i].accepted_at,
        consultationRequest: {
          consultationRequestId: details[i].consultation_request.consultation_request_id,
          chiefComplaint: details[i].consultation_request.chief_complaint,
          duration: details[i].consultation_request.duration,
          status: details[i].consultation_request.request_status,
          request_type: details[i].consultation_request.request_type,
          date: details[i].consultation_request.date
        },
        consultation: {
          chiefComplaint: details[i].consultation.chief_complaint,
          consultationId: details[i].consultation.consultation_id,
          provisionalDiagnosis: details[i].consultation.provisional_diagnois,
          summaryNotes: details[i].consultation.summary,
          date: details[i].consultation.date,
          summary_status: details[i].consultation.summary_status,
          prescribedDrugs: details[i].consultation.prescribed_drugs,
          recommendedTests: details[i].consultation.recommended_tests,
          followupReminders: details[i].consultation.followup_reminders
        },
        isCustomerTyping: false,
        isDoctorTyping: false,
        isOnline: false,
        details: {
          consultations: {},
          bmi: {},
          documents: [],
          medications: [],
          notifications: [],
          health_parameters: {},
          health_risks: {},
          lab_tests: [],
          medical_history: {},
          prescriptions: [],
          tags: [],
          wellness_score: {}
        },
        guardian_ek_id: ''
      };
      state.activeConsults.push(consult);
      state.initiated = true;
      __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].subscribeToChannel(details[i].channel_id);
    }
  },
  remove: function remove(state, channelId) {
    var consult = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(consult);
    if (index > -1) {
      if (state.activeConsults.length > 1) {
        state.activeConsults.splice(index, 1);
      } else {
        state.activeConsults.splice(index, 1);
        state.activeConsults = [];
      }
    }
  },
  setupNewConsultation: function setupNewConsultation(state, _ref43) {
    var channelId = _ref43.channelId,
        consultation = _ref43.consultation;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      state.activeConsults[index].consultation.chiefComplaint = consultation.chief_compliant;
      state.activeConsults[index].consultation.consultationId = consultation.id;
    }
  },
  setCustomerTyping: function setCustomerTyping(state, options) {
    var consult = state.activeConsults.find(function (ele) {
      return ele.channelId === options.channelId;
    });
    var index = state.activeConsults.indexOf(consult);
    if (index > -1) {
      state.activeConsults[index].isCustomerTyping = options.typing;
    }
  },
  switchTo: function switchTo(state, _ref44) {
    var channelId = _ref44.channelId,
        customerId = _ref44.customerId;

    state.activeChannelId = channelId;
    state.activeCustomerId = customerId;
    var index = state.messages.findIndex(function (msg) {
      return msg.channelId === channelId;
    });
    if (index === -1) {
      state.inputMessage = '';
    } else {
      state.inputMessage = state.messages[index].message;
    }
  },
  updateInputMessage: function updateInputMessage(state, _ref45) {
    var channelId = _ref45.channelId;

    // state.inputMessage = ''
    var updatedMesssages = state.messages.filter(function (msg) {
      if (msg.channelId !== channelId) {
        return msg;
      }
    });
    state.messages = updatedMesssages;
  },
  addToActiveConsults: function addToActiveConsults(state, _ref46) {
    var request = _ref46.request,
        consultation = _ref46.consultation;

    var consult = {
      ablyEnabled: false,
      channelId: request.channelId,
      customerId: request.customer_id,
      name: request.customer_name,
      isFamilyDoctor: request.isFamilyDoctor,
      accepted_at: Date.now(),
      consultationRequest: {
        consultationRequestId: request.consultationRequestId,
        chiefComplaint: request.chiefComplaint,
        duration: request.duration,
        status: request.status,
        request_type: request.request_type,
        date: request.time
      },
      consultation: {
        chiefComplaint: consultation.chief_compliant,
        consultationId: consultation.id,
        provisionalDiagnosis: consultation.provisional_diagnois,
        status: consultation.summary_notes,
        date: consultation.date ? consultation.date : __WEBPACK_IMPORTED_MODULE_14_moment___default()(consultation.created_at).format('DD MMM YYYY'),
        summary_status: consultation.summary_status,
        prescribedDrugs: [],
        recommendedTests: [],
        followupReminders: []
      },
      isCustomerTyping: false,
      isDoctorTyping: false,
      isOnline: true,
      details: {
        consultations: {},
        bmi: {},
        documents: [],
        medications: [],
        notifications: [],
        health_parameters: {},
        health_risks: {},
        lab_tests: [],
        medical_history: {},
        prescriptions: [],
        tags: [],
        wellness_score: {}
      },
      guardian_ek_id: ''
    };
    if (!request.isFamilyDoctor && request.familyDoctor) {
      consult.familyDoctor = { id: request.familyDoctor.id, name: request.familyDoctor.name };
    }
    state.activeConsults.unshift(consult);
    state.activeCustomerId = request.customer_id;
    state.activeChannelId = request.channelId;
    __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePatientStatus(request.channelId);
  },
  addQueryToActiveConsults: function addQueryToActiveConsults(state, _ref47) {
    var request = _ref47.request,
        consultation = _ref47.consultation;

    var consult = state.activeConsults.find(function (ele) {
      return ele.channelId === request.channelId;
    });
    if (!consult) {
      var newConsult = {
        ablyEnabled: false,
        channelId: request.channelId,
        customerId: request.customer_id,
        name: request.customer_name,
        isFamilyDoctor: request.isFamilyDoctor,
        accepted_at: new Date(),
        consultationRequest: {
          consultationRequestId: request.consultationRequestId,
          chiefComplaint: request.chiefComplaint,
          duration: request.duration,
          status: request.status,
          request_type: request.request_type,
          date: request.time
        },
        consultation: {
          chiefComplaint: '',
          consultationId: null,
          provisionalDiagnosis: '',
          status: '',
          date: '',
          summary_status: '',
          prescribedDrugs: [],
          recommendedTests: [],
          followupReminders: []
        },
        isCustomerTyping: false,
        isDoctorTyping: false,
        isOnline: true,
        details: {
          consultations: {},
          bmi: {},
          documents: [],
          medications: [],
          notifications: [],
          health_parameters: {},
          health_risks: {},
          lab_tests: [],
          medical_history: {},
          prescriptions: [],
          tags: [],
          wellness_score: {}
        },
        guardian_ek_id: ''
      };
      if (!request.isFamilyDoctor) {
        newConsult.familyDoctor = { id: request.familyDoctor.id, name: request.familyDoctor.name };
      }
      state.activeConsults.unshift(newConsult);
      state.activeCustomerId = request.customer_id;
      state.activeChannelId = request.channelId;
      __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePatientStatus(request.channelId);
    }
  },


  // Updates Customer Details
  updateCustomerDetails: function updateCustomerDetails(state, _ref48) {
    var channelId = _ref48.channelId,
        customerDetails = _ref48.customerDetails;

    var consult = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(consult);
    if (index > -1) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customerDetails).length === 2) {
        state.activeConsults[index].details.date_of_birth = customerDetails.date_of_birth;
        state.activeConsults[index].details.gender = customerDetails.gender;
        state.activeConsults[index].guardian_ek_id = customerDetails.guardian_ek_id;
      } else {
        state.activeConsults[index].details = customerDetails;
        state.activeConsults[index].guardian_ek_id = customerDetails.guardian_ek_id;
      }
    }
    __WEBPACK_IMPORTED_MODULE_5__core_ably__["a" /* default */].updatePatientStatus(channelId);
  },
  updateRecommendedTests: function updateRecommendedTests(state, data) {
    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === state.activeChannelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      state.activeConsults[index].consultation.recommendedTests = data;
    }
  },


  // Changes the Patient availability status to offline/online
  togglePatientAvailability: function togglePatientAvailability(state, _ref49) {
    var channelId = _ref49.channelId,
        status = _ref49.status;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      if (status === true) {
        patient.isOnline = true;
      } else {
        patient.isOnline = false;
      }
      state.activeConsults.splice(index, 1, patient);
    }
  },
  updateDocuments: function updateDocuments(state, _ref50) {
    var channelId = _ref50.channelId,
        data = _ref50.data;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      state.activeConsults[index].details.documents.push(data);
    }
  },


  // updatePrescriptions (state, { channelId, data }) {
  //   let patient = state.activeConsults.find(function (ele) {
  //     return (ele.channelId === channelId)
  //   })

  //   let index = state.activeConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.activeConsults[index].details.prescriptions = state.activeConsults[index].details.prescriptions.concat(data)
  //   }
  // },

  updateHealthParameter: function updateHealthParameter(state, _ref51) {
    var channelId = _ref51.channelId,
        healthParameters = _ref51.healthParameters;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      healthParameters.map(function (param) {
        state.activeConsults[index].details.health_parameters[param.question_tag] = param.result;
        if (param.question_tag === 'height') {
          var answer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__components_common_snackbar_helpers__["b" /* convertHeightToFeetInches */])(param.result);
          state.activeConsults[index].details.health_parameters['feet'] = answer[0];
          state.activeConsults[index].details.health_parameters['inches'] = answer[1];
        }
      });
    }
  },
  updateMedication: function updateMedication(state, _ref52) {
    var channelId = _ref52.channelId,
        prescribedDrugs = _ref52.prescribedDrugs;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      state.activeConsults[index].consultation.prescribedDrugs = prescribedDrugs;
    }
  },
  updateCurrentMedication: function updateCurrentMedication(state, _ref53) {
    var channelId = _ref53.channelId,
        medications = _ref53.medications;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      state.activeConsults[index].details.medications = medications;
    }
  },
  updateConsultation: function updateConsultation(state, _ref54) {
    var channelId = _ref54.channelId,
        consultation = _ref54.consultation;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });

    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      state.activeConsults[index].consultation.chiefComplaint = consultation.chief_compliant;
      state.activeConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois;
      state.activeConsults[index].consultation.summaryNotes = consultation.summary_notes;
    }
  },
  updateAblyChannelStatus: function updateAblyChannelStatus(state, _ref55) {
    var channelId = _ref55.channelId,
        status = _ref55.status;

    var patient = state.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeConsults.indexOf(patient);
    if (index > -1) {
      patient.ablyEnabled = status;
      state.activeConsults.splice(index, 1, patient);
    }
  },
  storeMessage: function storeMessage(state, _ref56) {
    var message = _ref56.message;

    var index = state.messages.findIndex(function (msg) {
      return msg.channelId === message.channelId;
    });
    var messages = state.messages;
    if (index === -1) {
      messages.push(message);
    } else {
      messages[index] = message;
      state.inputMessage = message;
    }
    // Logging for jumbled messages in production
    // Temporary code to capture the store message
    if (message.channelId !== state.activeChannelId || state.activeChannelId !== state.activeCustomerId && message.length > 0) {
      var maskedMessage = '';
      maskedMessage = '*'.repeat(Math.max(0, message.length - 4)) + message.slice(-4);
      __WEBPACK_IMPORTED_MODULE_16__sentry_vue__["b" /* setUser */]({ id: state.activeChannelId });
      __WEBPACK_IMPORTED_MODULE_16__sentry_vue__["c" /* captureMessage */]('Store Message', {
        level: 'info',
        tags: { event_name: 'store_message' },
        extra: {
          msgChannelId: message.channelId,
          activeChannelId: state.activeChannelId,
          index: index,
          message: maskedMessage,
          activeCustomerId: state.activeCustomerId
        }
      });
    }
    state.messages = messages;
  },
  storeLabTests: function storeLabTests(state, _ref57) {
    var tests = _ref57.tests,
        customerId = _ref57.customerId;

    var index = state.selectedTests.findIndex(function (test) {
      return test.customerId === customerId;
    });
    var selectedLabTests = {};
    var selectedTests = state.selectedTests;
    if (index > -1) {
      state.selectedTests[index].tests = tests;
    } else {
      selectedLabTests = {
        customerId: customerId,
        tests: tests
      };
      selectedTests.push(selectedLabTests);
      state.selectedTests = selectedTests;
    }
  },
  storeDrugs: function storeDrugs(state, _ref58) {
    var drugs = _ref58.drugs,
        channelId = _ref58.channelId,
        isAdding = _ref58.isAdding;

    var index = state.selectedDrugs.findIndex(function (drug) {
      return drug.customerId === channelId;
    });
    var selectedMedications = {};
    var selectedDrugs = state.selectedDrugs;
    if (index > -1) {
      state.selectedDrugs[index].drugs = drugs;
      state.selectedDrugs[index].isAdding = isAdding;
    } else {
      selectedMedications = {
        customerId: channelId,
        drugs: drugs,
        isAdding: isAdding
      };
      selectedDrugs.push(selectedMedications);
      state.selectedDrugs = selectedDrugs;
    }
  },
  removeDrugs: function removeDrugs(state, _ref59) {
    var customerId = _ref59.customerId;

    var index = state.selectedDrugs.findIndex(function (drug) {
      return drug.customerId === customerId;
    });
    state.selectedTests = state.selectedTests.filter(function (ele) {
      return ele.customerId !== customerId;
    });
    if (index > -1) {
      state.selectedDrugs = state.selectedDrugs.filter(function (ele) {
        return ele.customerId !== customerId;
      });
      // delete state.selectedDrugs[index]
      state.drugs = state.drugs.filter(function (ele) {
        return ele.customerId !== customerId;
      });
    }
  },
  storeCurrentDrugs: function storeCurrentDrugs(state, _ref60) {
    var drug = _ref60.drug,
        customerId = _ref60.customerId;

    if (drug.frequency === 'PRN/SOS') {
      drug.frequency = 'PRN/SOS (Only if symptoms are there) ' + drug.frequency_unit;
    } else if (drug.frequency_unit !== null) {
      drug.frequency = drug.frequency + ' a ' + drug.frequency_unit;
    }
    drug.route = drug.route ? drug.route.trim() : null;
    drug.instructions = drug.instructions ? drug.instructions.trim() : null;
    var index = state.drugs.findIndex(function (ele) {
      return ele.customerId === customerId;
    });
    if (index > -1) {
      state.drugs[index].drugs.push(drug);
    } else {
      var drugs = {
        drugs: [drug],
        customerId: customerId
      };
      state.drugs.push(drugs);
    }
  },
  reset: function reset(state) {
    state = {};
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Lfub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryNotSaved_vue__ = __webpack_require__("m3gr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c40dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryNotSaved_vue__ = __webpack_require__("NUbP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryNotSaved_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c40dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryNotSaved_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LgFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.toaster.isVisible && _vm.toaster.type)?_c('div',{staticClass:"toast",attrs:{"name":"fade"}},[(_vm.toaster.type === 'error')?_c('div',{staticClass:"toaster-container bg-red rounded-full text-white px-6 py-3 rounded relative",staticStyle:{"width":"350px","position":"absolute","top":"40px","right":"calc((100vw - 500px)/2)"},attrs:{"role":"alert"}},[_c('strong',{staticClass:"font-semibold"},[_vm._v("Failure")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.toaster.message !== null)?_c('span',{staticClass:"block sm:inline"},[_vm._v(_vm._s(_vm.toaster.message))]):_c('span',{staticClass:"block sm:inline"},[_vm._v("Request failed")])]):_vm._e(),_vm._v(" "),(_vm.toaster.type === 'success')?_c('div',{staticClass:"toaster-container bg-green rounded-full text-white px-6 py-3 rounded relative",staticStyle:{"width":"350px","position":"absolute","top":"40px","right":"calc((100vw - 500px)/2)"},attrs:{"role":"alert"}},[_c('strong',{staticClass:"font-semibold"},[_vm._v("Success")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"block sm:inline"},[_vm._v("Request successful")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44da9044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("VZIu");
function injectStyle (ssrContext) {
  __webpack_require__("gwqB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44da9044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MCWQ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA3LjAwMzgyQzE0IDExLjM2MzYgMTAuMDA1OSAxNC43OTUyIDUuNTA1NCAxMy44Mzg5QzIuODYxMzkgMTMuMjc2MyAwLjcyMzY3NSAxMS4xMzg2IDAuMTYxMTE5IDguNDk0NkMtMC43OTUyMjYgMy45OTQxNSAyLjYzNjM3IDAgNi45OTYxOCAwQzguOTM2OTkgMCAxMC43MDkgMC44MTU3MDYgMTEuOTc0OCAyLjEwOTU5QzEyLjM5NjcgMi41MzE1IDEyLjc2MjQgMy4wMDk2OCAxMy4wNzE4IDMuNTE1OThDMTMuNjYyNSA0LjUyODU4IDE0IDUuNzM4MDcgMTQgNy4wMDM4MloiIGZpbGw9IiNGRkI1MDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCA3LjAwMTY0QzEwIDguODcwMTMgOC4yODgyMiAxMC4zNDA4IDYuMzU5NDYgOS45MzA5NUM1LjIyNjMxIDkuNjg5ODUgNC4zMTAxNSA4Ljc3MzY5IDQuMDY5MDUgNy42NDA1NEMzLjY1OTE5IDUuNzExNzggNS4xMjk4NyA0IDYuOTk4MzYgNEM3LjgzMDE0IDQgOC41ODk1OSA0LjM0OTU5IDkuMTMyMDYgNC45MDQxMUM5LjMxMjg4IDUuMDg0OTMgOS40Njk1OSA1LjI4OTg2IDkuNjAyMTkgNS41MDY4NUM5Ljg1NTM0IDUuOTQwODIgMTAgNi40NTkxNyAxMCA3LjAwMTY0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "MLuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OfflineConsultations_LeftPaneOffline__ = __webpack_require__("yp8T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RightPane__ = __webpack_require__("2f92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LeftPane: __WEBPACK_IMPORTED_MODULE_1__components_OfflineConsultations_LeftPaneOffline__["a" /* default */],
    RightPane: __WEBPACK_IMPORTED_MODULE_2__components_RightPane__["a" /* default */]
  },
  name: 'OfflineConsultMain',
  data: function data() {
    return {
      consultRequests: [],
      othersAcceptedRequests: [],
      cancelledRequests: [],
      isUpdateAvailable: false,
      isReloaded: true,
      newUserNotification: [],
      showToggleButton: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    isActivePastChatPresent: 'pastOfflineConsultation/isPastChatPresent',
    activeSection: 'configuration/getActiveSection',
    selectedRightTab: 'configuration/getActiveRightPaneTab'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    activeConsults: function activeConsults(state) {
      return state.offlineConsultation.activeOfflineConsults;
    }
  }), {
    isRightPaneActive: function isRightPaneActive() {
      if (this.activeSection === 'connected' && this.activeConsults.length > 0) {
        return true;
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true;
      }
      return false;
    }
  }),
  watch: {},
  mounted: function mounted() {},

  methods: {
    tabChange: function tabChange(tab) {
      this.$store.dispatch('configuration/setRightPaneTab', tab);
    }
  }
});

/***/ }),

/***/ "MhWj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNzRfMTE5NikiPgo8cGF0aCBkPSJNMTQuNjY2NiA3LjM4NjI1VjcuOTk5NThDMTQuNjY1OCA5LjQzNzIgMTQuMjAwMyAxMC44MzYgMTMuMzM5NSAxMS45ODc1QzEyLjQ3ODcgMTMuMTM4OSAxMS4yNjg4IDEzLjk4MTIgOS44OTAxNiAxNC4zODg5QzguNTExNTQgMTQuNzk2NSA3LjAzODA5IDE0Ljc0NzUgNS42ODk1NyAxNC4yNDkzQzQuMzQxMDQgMTMuNzUxMSAzLjE4OTY5IDEyLjgzMDMgMi40MDcyMyAxMS42MjQzQzEuNjI0NzYgMTAuNDE4MyAxLjI1MzExIDguOTkxNjMgMS4zNDc3IDcuNTU3MTNDMS40NDIyOSA2LjEyMjYzIDEuOTk4MDYgNC43NTcxNCAyLjkzMjExIDMuNjY0M0MzLjg2NjE1IDIuNTcxNDYgNS4xMjg0NCAxLjgwOTg0IDYuNTMwNzEgMS40OTMwMUM3LjkzMjk4IDEuMTc2MTkgOS40MDAxIDEuMzIxMTQgMTAuNzEzMyAxLjkwNjI1IiBzdHJva2U9IiMwOTUxRTEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC42NjY3IDIuNjY2OTlMOCA5LjM0MDMzTDYgNy4zNDAzMyIgc3Ryb2tlPSIjMDk1MUUxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEyNzRfMTE5NiI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ "MlP6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADrUlEQVR4nO2cPU8UURSG35klrMlKYWEQcHFBtPEP2ECCSggdGkNpZUursEJcDFmR1sbEUmvEWFAYxYTGP2CFyvKxGKLBQkl0w8xYuBS6M/sxe2bOsPM+5czl3JvzcO7cPbsZgBBCCCGEEEIIIYTEBSPI4H3Z4ogNY8IABgGcBZAKcr4arLT9OLj+8fGF34prqCAQAf3TOxdtw3wKYCiI+E0QOQniAvru7Q45DpYBnJKOLUSkJIgKKP/nv0d0k39EZCSYksFsw3yC6CcfAMYOO1IvM7mNE9oLERPQly2OABiWihcCoygllwYm15Oai2iTClQ+7bhRguPMWpb1fHuxd1dqvlpksrtOHcPGDjtSLwYm19W2I7EKKB81K3Gc2cLDnsUwk98gRxJUKkFMgAP0uF432p9JzREgas8EyQo46XZ9M3/6i9QcATOKUnI5bAmip6BjwkqVe6E/mGMnINX+fRwwXlUZEup2FDsBH3KXSqn2/Zs1JIS2HcVOABAtCbEUAERHQmwFANGQEGsBgL6E2AsAdCWI9YKOC149ooMSANRsHx1JGC/k+n5JrIcV0DijKCWXpIJRgD/GpAJRgDIUoAwFKNOyp6BCvlvkBwd1frPmG1aAMhSgDAUoQwHKUIAyFKAMBShDAcpQgDIUoAwFKBO5XlDQvRepHpEUrABlKEAZClCGApShAGXETgRep5eonTqiBitAGQpQhgKUoQBlKECZlu0FBf27IKn4rABlKEAZClCGApShAGUidwqKW++IFaAMBShDAcpQgDIUoAwFKEMBylCAMpKvrfzpdv1c9muX1BytiORrK4vu10u3pOZoRSQrYM39jvEgM707lb6z1S01Vysh1nfpnyles23jtVQ8n2zZdmJ4a6Hzs9eATLaYA4z7Ia4JgDNXyPfk3O6INr4y08U3MIwrkjF9sG2ZieHt+c5PXgMy2eJdwFgIZzlGrpDvmvO6K3oKchKJ2w7wTTKmD9IJ21pNz+yd9xpQyPc8Apyp4JdSPfmAsIDN+TMbpoMbAPYl4/ognbCtt71Te/1eA8oSqianOZy5WskHAvgcsPGwe800rctw8E46doP0mqa1WkNCLhgJ3nv+/wT65UdvdueqCXMCwKADpL3esB4wIT+Y608+ELCA44TMg7n2nl/xF81N2Fo0J6Hx5AMUUIE/Cf6SD1CAK41J8J98gAI8qU9Cc8kHKKAq1SU0n3yAAmriLkEm+QAF1MW/EuSSTxogky3m/n5gI4SQluEPjGxIcr0CJWMAAAAASUVORK5CYII="

/***/ }),

/***/ "MswO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Myi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drugs_vue__ = __webpack_require__("O4I6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc8faa3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drugs_vue__ = __webpack_require__("zhcf");
function injectStyle (ssrContext) {
  __webpack_require__("DBDo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drugs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc8faa3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drugs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w-1/2 flex flex-col h-screen justify-center items-center"},[_c('div',{staticClass:"w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-2"},[_vm._v("\n        Set New Password\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword1),expression:"newPassword1"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"newPassword","minlength":"8","type":"password","placeholder":"New Password"},domProps:{"value":(_vm.newPassword1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword1=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword2),expression:"newPassword2"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline",attrs:{"type":"password","minlength":"8","placeholder":"Re Enter Password"},domProps:{"value":(_vm.newPassword2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword2=$event.target.value}}}),_vm._v(" "),(_vm.error && _vm.setPasswordError)?_c('p',{staticClass:"text-red text-xs italic"},[_vm._v(_vm._s(_vm.setPasswordError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.cancelReset}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('button',{staticClass:"bg-blue self-center hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.setPassword}},[_vm._v("\n          Next\n          "),(_vm.isLoading)?_c('i',{staticClass:"ml-2 fa fa-spinner fa-spin"}):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-1/2 flex h-screen bg-blue justify-center items-center"},[_c('h1',{staticClass:"text-3xl font-semibold text-blue-lightest"},[_vm._v(" Doctor Dashboard ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bus", function() { return Bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_styles_app_css__ = __webpack_require__("ldQ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_styles_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_styles_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_styles_common_css__ = __webpack_require__("slWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_styles_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_styles_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_styles_font_css__ = __webpack_require__("Yodc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_styles_font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_styles_font_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_snackbar_css__ = __webpack_require__("yxwu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_snackbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_snackbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_dropdown_css__ = __webpack_require__("1Faf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css__ = __webpack_require__("suTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll__ = __webpack_require__("bNL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button__ = __webpack_require__("nkUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_raven_js_plugins_vue__ = __webpack_require__("6fN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__core_ably__ = __webpack_require__("oKrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__interceptors_loader__ = __webpack_require__("2T23");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_snackbar__ = __webpack_require__("tWij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sentry_vue__ = __webpack_require__("B3+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sentry_tracing__ = __webpack_require__("D3zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_apexcharts__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_apexcharts__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



























var environment = '';
if (window.location.host === 'consultations.ekincare.com') {
  environment = 'production';
} else if (window.location.host === 'doctorstaging.ekincare.com') {
  environment = 'staging';
} else {
  environment = 'development';
}
__WEBPACK_IMPORTED_MODULE_17_raven_js___default.a.config('https://88811500135a45ae856d3aa4bb627e8b@sentry.io/1210314', {
  environment: environment
}).addPlugin(__WEBPACK_IMPORTED_MODULE_18_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_7_vue__["default"]).install();

__WEBPACK_IMPORTED_MODULE_23__sentry_vue__["a" /* init */]({
  dsn: 'https://88811500135a45ae856d3aa4bb627e8b@o65160.ingest.us.sentry.io/1210314',
  environment: environment,
  integrations: [new __WEBPACK_IMPORTED_MODULE_24__sentry_tracing__["a" /* Integrations */].BrowserTracing() // Enable tracing
  ],
  tracesSampleRate: 1.0
});

var Bus = new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]();
var Ably = {
  install: function install(Vue, options) {
    Vue.realtime = function () {
      return __WEBPACK_IMPORTED_MODULE_19__core_ably__["a" /* default */];
    };
  }
};

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_js_popover___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(Ably);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__components_common_snackbar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_apexcharts___default.a);

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].http.interceptors.push(function (request, next) {
  request.headers.set('X-DOCTOR-KEY', sessionStorage.getItem('X-DOCTOR-KEY'));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__interceptors_loader__["a" /* beforeRequestSuccess */])(request);
  next(function (response) {
    if (response.status === 200) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__interceptors_loader__["b" /* onSuccess */])();
    } else if (response.status === 401) {
      sessionStorage.clear();
      __WEBPACK_IMPORTED_MODULE_19__core_ably__["a" /* default */].close();
      __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('clearAll');
      window.location.href = '/login';
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__interceptors_loader__["c" /* onError */])();
      // alert('Something went wrong')
    }
  });
});

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()(String(value)).format('DD MMM YYYY, h:mm A');
  }
});

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('formatDateIST', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(String(value)).local().format('DD MMM YYYY, h:mm A');
  }
});

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('formatDateWithoutTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()(String(value)).format('DD MMM YYYY');
  }
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('formatDateMonth', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()(value, 'DD/MM/YYYY').format('Do MMM');
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */] }
});

// Check user logged in
if (sessionStorage.getItem('X-DOCTOR-KEY') !== undefined && sessionStorage.getItem('X-DOCTOR-KEY') !== null) {
  __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('configuration/init');
}

__WEBPACK_IMPORTED_MODULE_22_localforage___default.a.config({
  driver: __WEBPACK_IMPORTED_MODULE_22_localforage___default.a.INDEXEDDB, // Force INDEXEDDB; same as using setDriver()
  name: 'audits',
  version: 1.0,
  storeName: 'audits', // Should be alphanumeric, with underscores.
  description: 'This is to track events'
});
__WEBPACK_IMPORTED_MODULE_22_localforage___default.a.getItem('audits', function (err, data) {
  if (err === null && data === null) {
    __WEBPACK_IMPORTED_MODULE_22_localforage___default.a.setItem('audits', []);
  }
});

/***/ }),

/***/ "NUbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Summary not saved!")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Please save the consultation summary before sending.")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeOverlay()}}},[_vm._v("Okay")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nw0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-hidden bg-white"},[_c('div',{staticClass:"flex flex-row bg-white justify-between items-center px-10 h-14 my-4"},[_c('div',{staticClass:"text-dark text-2xl font-semibold h-15 text-center mr-auto"},[_vm._v("DOCTOR CHAT AVAILABILITY")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between m-2 ml-auto"},[_c('div',{staticClass:"flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMonth.value),expression:"selectedMonth.value"}],staticClass:"flex appearance-none mr-2 w-auto h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedMonth, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onMonthYearChange]}},_vm._l((_vm.months),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v("\n            "+_vm._s(month.text)+"\n          ")])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedYear),expression:"selectedYear"}],staticClass:"flex appearance-none w-16 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onMonthYearChange]}},_vm._l((_vm.years),function(year,index){return _c('option',{key:index,domProps:{"value":year}},[_vm._v("\n            "+_vm._s(year)+"\n          ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"flex px-10 mb-1 text-m font-semibold text-grey-darker tracking-wide"},[_vm._v("DOCTOR'S ON SCHEDULE")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap bg-white px-8"},[_c('div',{staticClass:"text-grey text-center cursor-pointer text-sm flex-no-shrink flex-no-grow px-4 py-2 m-2 rounded-full ",class:[_vm.autoSelectAllDoc ? 'bg-blue' : 'border border-solid border-grey-lightest'],on:{"click":function($event){return _vm.showAllDoctors()}}},[_c('label',{staticClass:"text-xs cursor-pointer",class:[_vm.autoSelectAllDoc ? 'text-white' : 'text-black'],attrs:{"for":"Show All Doctor's"}},[_vm._v("Show All Doctor's")])]),_vm._v(" "),_vm._l((_vm.doctors),function(doctor,i){return _c('div',{key:i,staticClass:"cursor-pointer text-red text-sm rounded-full flex-no-shrink flex-no-grow text-center bg-gray-400 px-4 py-2 m-2",class:[doctor.selected ? '' : 'border border-solid border-grey-lightest'],style:([doctor.selected ? {'background': doctor.color} : {'background':'white'}]),on:{"click":function($event){return _vm.selectDoctors(i, doctor)}}},[_c('label',{staticClass:"text-xs cursor-pointer",class:[doctor.selected ? 'text-white' : 'text-black']},[_vm._v(_vm._s(doctor.name))])])})],2),_vm._v(" "),_c('table',{staticClass:"mx-1 mt-2 w-full",staticStyle:{"overflow":"scroll","height":"calc(100vh - 12rem)"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"h-full w-full sticky top-0 left-0 bg-white border-none p-0 m-0 shadow-none z-50",staticStyle:{"top":"0","left":"0"}}),_vm._v(" "),_vm._l((_vm.timeSlots),function(time,i){return _c('th',{key:i,staticClass:"z-40 flex flex-col w-full h-full sticky left-0 items-start p-0 bg-white cursor-default",staticStyle:{"left":"0"}},[_c('div',{staticClass:"flex font-semibold justify-end items-center w-full h-8 pr-4 mt-px bg-grey-lightest text-sm",staticStyle:{"box-shadow":"0px 0px 0px 1px #d7dbde","margin-left":"1px"}},[_vm._v("\n            "+_vm._s(time)+"\n          ")])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dates),function(date,i){return _c('tr',{key:i},[_c('td',{staticClass:"flex sticky top-0 text-xs cursor-default p-1 font-semibold text-left justify-center items-center h-12 bg-grey-lightest z-40",staticStyle:{"box-shadow":"inset 0px 0px 0px 1px #d7dbde","top":"0"}},[_vm._v(_vm._s(_vm._f("formatDateMonth")(date)))]),_vm._v(" "),_vm._l((_vm.dateObject(date)),function(slot,index){return _c('td',{key:index,staticClass:"flex flex-wrap p-2 bg-white hover:bg-blue-100 ",class:_vm.role === 'admin' ? 'cursor-pointer' : '',on:{"click":function($event){return _vm.openModal(_vm.showModal, slot, date)}}},_vm._l((_vm.getDocsForASlot(slot, date)),function(doc,i){return _c('div',{key:i,staticClass:"flex w-5 h-5 m-1 rounded-full text-white text-sm justify-center items-center leading-none flex-shrink-0",style:({background:doc.color}),attrs:{"title":doc.name}},[_vm._v(_vm._s(_vm.getDocInitials(doc.name)))])}),0)})],2)}),0)]),_vm._v(" "),(_vm.showModal)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"100","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto",staticStyle:{"width":"550px","left":"calc((100vw - 600px)/2)","top":"80px","height":"auto","z-index":"110"}},[_c('div',{staticClass:"w-full bg-grey flex flex-col px-5 py-4"},[_c('div',{staticClass:"text-lg",staticStyle:{"color":"#207ae6"}},[_vm._v("Manage Doctors")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between mt-2"},[_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.selectedDate))]),_vm._v(" "),_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.selectedSlot))])])]),_vm._v(" "),_c('div',{staticClass:"bg-white px-5 py-5"},_vm._l((_vm.slotDoctors),function(doctor,i){return _c('div',{key:i,staticClass:"border border-solid border-gray-300 my-1 rounded-sm"},[_c('div',{staticClass:"flex flex-row p-2 justify-between items-center border-solid border-gray-300"},[_c('div',{staticClass:"flex flex-row items-center m-1 mr-auto"},[_c('div',{staticClass:"rounded-full w-2 h-2 mr-2",style:([{'background-color':doctor.color}])}),_vm._v(" "),_c('div',{staticClass:"flex text-sm text-grey-darkest"},[_vm._v(_vm._s(doctor.name))])]),_vm._v(" "),(_vm.selectedDoctor.id === doctor.id && _vm.openReplaceDr)?_c('div',{staticClass:"flex flex-col text-sm items-center ml-auto"},[_c('div',{staticClass:"flex text-grey-dark cursor-pointer ml-auto mb-1",on:{"click":function($event){return _vm.undoReplace(i)}}},[_vm._v("Undo")]),_vm._v(" "),_c('div',{staticClass:"flex w-64"},[_c('select',{staticClass:"flex cursor-pointer appearance-none w-auto h-8 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"width":"400px"},on:{"change":function($event){return _vm.replaceHandler(i)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Select a doctor")]),_vm._v(" "),_vm._l((_vm.dropdownDoctorList),function(doc,index){return _c('option',{key:index,domProps:{"value":doc.id}},[_c('div',[_vm._v(_vm._s(doc.name))])])})],2)])]):_c('div',{staticClass:"flex flex-row text-sm items-center"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"ml-2 text-grey cursor-pointer",on:{"click":function($event){return _vm.replaceDoctor(i, doctor)}}},[_vm._v("Replace")]),_vm._v(" "),_c('div',{staticClass:"ml-2 cursor-pointer",on:{"click":function($event){return _vm.deleteDoctor(i, doctor)}}},[_c('img',{attrs:{"src":__webpack_require__("TpOy")}})])])])])}),0),_vm._v(" "),(_vm.addDoctors)?_c('div',{staticClass:"flex bg-white px-5"},[_c('select',{staticClass:"flex appearance-none cursor-pointer w-full h-8 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",attrs:{"name":"Replace doctor from selection","id":""},on:{"change":function($event){return _vm.addHandler()}}},[_c('option',{staticClass:"invisible",attrs:{"value":"0"}},[_vm._v("Add doctor from Selection")]),_vm._v(" "),_vm._l((_vm.dropdownDoctorList),function(doc,index){return _c('option',{key:index,domProps:{"value":doc.id}},[_c('div',[_vm._v(_vm._s(doc.name))])])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bg-white px-5 py-4 flex flex-row justify-start items-center cursor-pointer",on:{"click":function($event){return _vm.addDoctor()}}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-gray-600 text-sm ml-2 h-5"},[_vm._v("Add Doctor")])]),_vm._v(" "),_c('div',{staticClass:"bg-white flex flex-row justify-end px-5 py-4 mb-2"},[_c('div',{staticClass:"border  ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm  text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-blue ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.updateChatSlot()}}},[_vm._v("Save Update")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer"},[_c('img',{attrs:{"src":__webpack_require__("Dm+L")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-6 w-6 self-center"},[_c('img',{attrs:{"src":__webpack_require__("1bhZ")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O4I6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__ = __webpack_require__("qrBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Customer_AddDrug__ = __webpack_require__("ffOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SavedDrug_vue__ = __webpack_require__("WdZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__["a" /* default */],
    AddDrug: __WEBPACK_IMPORTED_MODULE_2__components_Customer_AddDrug__["a" /* default */],
    SavedDrug: __WEBPACK_IMPORTED_MODULE_3__SavedDrug_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isEditing: false,
      recommendations: null,
      drugs: [],
      isAdding: this.isOpen && this.customer,
      isAddingSaved: false,
      savedDrugs: [],
      currentSavedDrug: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    isOpen: 'consultation/getIsAdding',
    currentDrugs: 'consultation/getDrugs',
    offlineDrugs: 'offlineConsultation/getDrugs',
    doctorSavedMedications: 'preFilledMedications/getSavedDrugs'
  }), {
    medications: function medications() {
      this.drugs = [];
      if (this.customer && this.customer.consultation && (this.currentDrugs.length > 0 || this.offlineDrugs.length > 0 || this.customer.consultation.prescribedDrugs)) {
        if (this.customer.consultation.prescribedDrugs && !this.customer.consultationRequest) {
          this.drugs = this.customer.consultation.prescribedDrugs;
        } else {
          if (this.$attrs.chatType === 'online') {
            this.drugs = this.currentDrugs;
          } else {
            this.drugs = this.offlineDrugs;
          }
        }
      }
      return this.drugs;
    },
    canUpdate: function canUpdate() {
      if (this.customer && this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') {
        return false;
      } else {
        return true;
      }
    },
    savedMedications: function savedMedications() {
      this.savedDrugs = [];
      if (this.doctorSavedMedications) {
        this.savedDrugs = this.doctorSavedMedications;
      }
      return this.savedDrugs;
    }
  }),
  created: function created() {
    if (this.customer && this.customer.consultation.prescribedDrugs && this.customer.consultation.prescribedDrugs.length <= 0) {
      this.drugs = this.$attrs.chatType === 'online' ? this.currentDrugs : this.offlineDrugs;
    }
  },

  watch: {
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isAdding = this.isOpen;
      }
    }
  },
  methods: {
    editDrugs: function editDrugs() {
      this.isEditing = true;
    },
    addDrug: function addDrug() {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      if (this.customer.consultation.provisionalDiagnosis === null || this.customer.consultation && this.customer.consultation.consultationId && this.customer.consultation.provisionalDiagnosis && this.customer.consultation.provisionalDiagnosis.trim().length < 1) {
        this.$toast.open({
          message: 'Please add diagnosis before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      this.isAdding = true;
    },
    addSavedDrug: function addSavedDrug() {
      this.currentSavedDrug = null;
      this.isAddingSaved = true;
      this.isEditing = true;
    },
    saveClicked: function saveClicked() {
      this.isEditing = false;
      this.isAdding = false;
    },
    cancelClicked: function cancelClicked() {
      this.isEditing = false;
      this.isAdding = false;
    },
    updateDrugs: function updateDrugs(medication, customerId) {
      if (medication) {
        if (this.$attrs.chatType === 'offline') {
          if (this.isEditing) {
            this.drugs = medication;
          } else if (this.isAdding) {
            this.drugs.push(medication);
          }
          // this.$store.dispatch('offlineConsultation/updateMedication', {data: data})
          this.$store.dispatch('offlineConsultation/updateMedication', { prescribedDrugs: this.drugs });
        } else if (this.$attrs.chatType === 'online') {
          // } else if (this.isAdding && (this.customer.customerId === customerId)) {
          //   this.drugs.push(medication)
          // }
          this.$store.dispatch('consultation/updateMedication', { prescribedDrugs: this.drugs });
        }
      }
      this.isEditing = false;
      this.isAdding = false;
    },
    updateSavedDrugs: function updateSavedDrugs(medication) {
      if (medication) {
        this.$store.dispatch('preFilledMedications/addToSavedDrugs', { drug: medication });
      }
      this.isEditing = false;
      this.isAddingSaved = false;
    },
    removeSavedDrug: function removeSavedDrug(medicationId) {
      this.$store.dispatch('preFilledMedications/removeSavedDrug', { drugId: medicationId });
    },
    addToMedications: function addToMedications(medication) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      if (this.customer.consultation.provisionalDiagnosis === null || this.customer.consultation && this.customer.consultation.consultationId && this.customer.consultation.provisionalDiagnosis && this.customer.consultation.provisionalDiagnosis.trim().length < 1) {
        this.$toast.open({
          message: 'Please add diagnosis before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      var med = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, medication);
      med.frequency = '' + med.frequency;
      med.route = med.route ? med.route.trim().length > 0 ? med.route : '' : null;
      med.dose_quantity = med.dose_quantity ? med.dose_quantity : '';
      med.dose_unit = med.dose_unit ? med.dose_unit : '';
      med.instructions = med.instructions ? med.instructions.trim().length > 0 ? med.instructions : '' : null;
      if (this.$attrs.chatType === 'online') {
        this.$store.commit('consultation/storeCurrentDrugs', { drug: med, customerId: this.customer.customerId });
        this.$store.dispatch('consultation/updateMedication', { prescribedDrugs: this.drugs });
      } else if (this.$attrs.chatType === 'offline') {
        this.drugs.push(med);
        this.$store.commit('offlineConsultation/storeCurrentDrugs', { drug: med, customerId: this.customer.customerId });
        this.$store.dispatch('offlineConsultation/updateMedication', { prescribedDrugs: this.drugs });
      }
    },
    editSaved: function editSaved(medication) {
      this.currentSavedDrug = medication;
      this.isAddingSaved = true;
      this.isEditing = true;
    },
    editSavedDrug: function editSavedDrug(medication) {
      this.$store.dispatch('preFilledMedications/editSavedDrug', { drugId: this.currentSavedDrug.id, medication: medication });
      this.isAddingSaved = false;
      this.currentSavedDrug = null;
    },
    preview: function preview() {
      if (this.medications.length === 0) {
        this.$store.dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Please add medications' }, { root: true });
        return;
      }
      var data = {
        prescription: {
          customer_id: this.customer.customerId,
          consultation_id: this.customer.consultation.consultationId,
          medications: this.medications,
          recommendations: this.recommendations
        }
      };
      if (this.$attrs.chatType === 'offline') {
        this.$store.dispatch('offlineConsultation/previewPrescription', { data: data });
      } else if (this.$attrs.chatType === 'online') {
        this.$store.dispatch('consultation/previewPrescription', { data: data });
      }
    },
    sendToPatient: function sendToPatient() {
      if (this.medications.length === 0) {
        this.$store.dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Please add medications' }, { root: true });
        return;
      }
      var data = {
        prescription: {
          customer_id: this.customer.customerId,
          consultation_id: this.customer.consultation.consultationId,
          medications: this.medications,
          recommendations: this.recommendations
        }
      };
      if (this.$attrs.chatType === 'offline') {
        this.$store.dispatch('offlineConsultation/sendPrescription', { data: data });
      } else if (this.$attrs.chatType === 'online') {
        this.$store.dispatch('message/sendPrescription', { data: data });
      }
    },
    deleteDrug: function deleteDrug(med, index) {
      this.drugs.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "O4OI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var HealthParameters = function HealthParameters() {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HealthParameters);
};

HealthParameters.updateHealthParameters = function (data, customerId) {
  data.id = customerId;
  if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).includes('feet')) {
    var height = data.feet * 30.48 + data.inches * 2.54;
  }
  data.height = height;
  return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(window.API_URL + 'doctors/customer_health_parameters', data);
};

HealthParameters.updateGeneralParameters = function (data, customerId) {
  data.id = customerId;
  return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.patch(window.API_URL + 'doctors/customers/' + customerId + '/update_customer_details', data);
};

/* harmony default export */ __webpack_exports__["a"] = (HealthParameters);

/***/ }),

/***/ "ODi0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Standard__ = __webpack_require__("dvBI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Custom__ = __webpack_require__("fyV+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Standard: __WEBPACK_IMPORTED_MODULE_0__Standard__["a" /* default */],
    Custom: __WEBPACK_IMPORTED_MODULE_1__Custom__["a" /* default */]
  },
  data: function data() {
    return {
      showPhrases: false,
      selectedTab: 'standard'
    };
  },

  methods: {
    togglePhrases: function togglePhrases() {
      this.showPhrases = !this.showPhrases;
    },
    tabClicked: function tabClicked(tab) {
      this.selectedTab = tab;
    }
  }
});

/***/ }),

/***/ "OjCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ['consultType'],
  data: function data() {
    return {
      testsChecked: false,
      consultationChecked: false,
      followUpConsultDays: '0',
      enableSetFollowupButton: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  }), {
    recommendedTests: function recommendedTests() {
      if (this.customer && this.customer.consultation && this.customer.consultation.recommendedTests) {
        this.customer.consultation.recommendedTests.map(function (t) {
          t.days = '0';
        });
        return this.customer.consultation.recommendedTests;
      }
      return [];
    },
    showSetUpLabFollowUp: function showSetUpLabFollowUp() {
      if (this.customer && this.customer.consultation && this.customer.consultation.followupReminders && this.customer.consultation.followupReminders.length > 0) {
        var r = this.customer.consultation.followupReminders.find(function (f) {
          if (f.followup_type === 'lab_test') return f;
        });
        if (!r && this.recommendedTests.length > 0) return true;
        return false;
      } else if (this.recommendedTests.length > 0) {
        return true;
      }
      return false;
    },
    showSetUpConsultationFollowUp: function showSetUpConsultationFollowUp() {
      if (this.customer && this.customer.consultation && this.customer.consultation.followupReminders && this.customer.consultation.followupReminders.length > 0) {
        var r = this.customer.consultation.followupReminders.find(function (f) {
          if (f.followup_type === 'consultation') return f;
        });
        if (!r) return true;
        return false;
      }
      return true;
    },
    testFollowupReminders: function testFollowupReminders() {
      var that = this;
      if (that.customer && that.customer.consultation && that.customer.consultation.followupReminders) {
        var followupReminders = that.customer.consultation.followupReminders.filter(function (ele) {
          return ele.followup_type === 'lab_test';
        });
        followupReminders.map(function (r) {
          var t = that.customer.consultation.recommendedTests.find(function (ele) {
            return ele.test_id === r.recommended_test_id;
          });
          if (t) {
            r.package_name = t.package_name;
          } else {
            r.package_name = 'NA';
          }
          return r;
        });
        return followupReminders;
      }
      return [];
    }
  }),
  watch: {
    customer: function customer(newV, oldV) {
      if (newV !== oldV) {
        this.enableSetFollowupButton = false;
        // this.newLabTestFollowUp = {}
        // this.newConsultationFollowUP = {}
        this.consultationChecked = false;
        this.followUpConsultDays = '0';
      }
    }
  },
  methods: {
    labFollowupSelect: function labFollowupSelect(e) {
      if (e.target.value !== '0') {
        this.enableSetFollowupButton = true;
      }
    },
    consultationFollowupSelect: function consultationFollowupSelect(e) {
      if (e.target.value !== '0') {
        this.enableSetFollowupButton = true;
      }
    },
    followUpFor: function followUpFor(type) {
      if (type === 'consultation' && !this.showSetUpConsultationFollowUp) {
        this.$toast.open({
          message: 'Follow up for consultation is already scheduled',
          type: 'warning',
          position: 'top',
          queue: true
        });
      } else if (type === 'lab_test' && !this.showSetUpLabFollowUp) {
        this.$toast.open({
          message: 'Follow up for lab tests is already scheduled',
          type: 'warning',
          position: 'top',
          queue: true
        });
      }
    },
    setUpFollowUp: function setUpFollowUp() {
      if (!this.enableSetFollowupButton) {
        return;
      }
      var followUps = [];
      if (!this.customer.consultation.date) {
        this.$toast.open({
          message: 'Consultation date not found',
          type: 'error',
          position: 'top',
          queue: true
        });
        return;
      }
      var createdAt = new Date(this.customer.consultation.date);
      if (this.testsChecked) {
        if (this.testFollowupReminders.length < 1) {
          var a = [];
          var allTestSelected = true;
          this.recommendedTests.map(function (test) {
            var scheduledTime = new Date(createdAt);
            if (test.days === '0') {
              allTestSelected = false;
              return;
            }
            var date = createdAt.getDate() + JSON.parse(test.days);
            scheduledTime.setDate(date);
            a.push({ recommended_test_id: test.test_id, followup_type: 'lab_test', scheduled_time: scheduledTime });
          });
          if (!allTestSelected) {
            this.$toast.open({
              message: 'Please schedule follow for all the tests',
              type: 'warning',
              position: 'top',
              queue: true
            });
            return;
          }
          followUps = followUps.concat(a);
        }
      }
      if (this.consultationChecked) {
        var scheduledTime = new Date(createdAt);
        var date = createdAt.getDate() + JSON.parse(this.followUpConsultDays);
        scheduledTime.setDate(date);
        followUps.push({ followup_type: 'consultation', scheduled_time: scheduledTime });
        if (this.followUpConsultDays < 1) {
          this.$toast.open({
            message: 'Please select a day for consultation',
            type: 'warning',
            position: 'top',
            queue: true
          });
          return;
        }
      }
      if (this.consultType === 'offline') {
        this.$store.dispatch('pastOfflineConsultation/setFollowUp', followUps);
      } else {
        this.$store.dispatch('pastConsultation/setFollowUp', followUps);
      }
    }
  }
});

/***/ }),

/***/ "Oquu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerPastConsults_vue__ = __webpack_require__("dF0K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a95fb18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerPastConsults_vue__ = __webpack_require__("7tb8");
function injectStyle (ssrContext) {
  __webpack_require__("xyZ0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a95fb18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerPastConsults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a95fb18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerPastConsults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oqxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveDoctorsCard_vue__ = __webpack_require__("22C3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81c47bf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveDoctorsCard_vue__ = __webpack_require__("uITx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveDoctorsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81c47bf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveDoctorsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ore3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeSaveReminderOverlay: function closeSaveReminderOverlay() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "P/Ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vipSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cancelRequestSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generalRequestSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mergeRequests; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var vipSort = function vipSort(requests) {
  var vipList = requests.filter(function (req) {
    return req.vip;
  });
  return vipList;
};

var cancelRequestSort = function cancelRequestSort(requests) {
  var cancelRequestList = requests.filter(function (req) {
    return !req.vip && req.cancelled_requests_count > 0;
  });
  var collection = [];
  cancelRequestList.forEach(function (req) {
    var added = false;
    if (collection.length === 0) {
      collection.push(req);
    } else {
      for (var j = 0; j < collection.length; j++) {
        if (req.cancelled_requests_count > collection[j].cancelled_requests_count) {
          collection.splice(j, -1, req);
          added = true;
          break;
        }
      }
      if (!added) {
        collection.push(req);
      }
    }
  });
  return collection;
};

var generalRequestSort = function generalRequestSort(requests) {
  var generalSort = requests.filter(function (req) {
    return !req.vip && !req.cancelled_requests_count;
  });
  return generalSort;
};

var mergeRequests = function mergeRequests(vipList, cancelledRequestList, generalRequestList) {
  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(vipList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cancelledRequestList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(generalRequestList));
};

/***/ }),

/***/ "P1MB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MfaAccountSettings_vue__ = __webpack_require__("5SnA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d2c5d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MfaAccountSettings_vue__ = __webpack_require__("D8sW");
function injectStyle (ssrContext) {
  __webpack_require__("wHOX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16d2c5d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MfaAccountSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d2c5d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MfaAccountSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P2qI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5o5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P6bk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      elapsedTime: '',
      date: new Date(this.time),
      minutes: 0,
      seconds: 0,
      interval: null,
      intervals: {
        second: 1000,
        minute: 1000 * 60,
        hour: 1000 * 60 * 60,
        day: 1000 * 60 * 60 * 24
      },
      timerColor: 'text-green-darker'
    };
  },

  props: ['time', 'timerClass'],
  emits: ['update:timerClass'],
  mounted: function mounted() {
    var _this = this;

    this.interval = setInterval(function () {
      _this.updatedTime();
    }, 1000);

    this.updatedTime();
    if (this.minutes >= 10 && this.minutes < 15) {
      this.timerColor = 'text-yellow-darker';
    } else if (this.minutes >= 15) {
      this.timerColor = 'text-red-dark';
    }
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
  },

  methods: {
    updatedTime: function updatedTime() {
      var diff = Math.abs(Date.now() - this.date.getTime());
      this.days = Math.floor(diff / this.intervals.day);
      diff -= this.days * this.intervals.day;
      this.hours = Math.floor(diff / this.intervals.hour);
      diff -= this.hours * this.intervals.hour;
      this.minutes = Math.floor(diff / this.intervals.minute);
      diff -= this.minutes * this.intervals.minute;
      this.seconds = Math.floor(diff / this.intervals.second);

      if (this.minutes === 10 && this.seconds === 0) {
        this.timerColor = 'text-yellow-darker';
      } else if (this.minutes === 15 && this.seconds === 0) {
        this.timerColor = 'text-red-dark';
      }
    }
  }
});

/***/ }),

/***/ "P7hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-64 bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest"},[(!_vm.doctor)?_c('div',{staticClass:"flex flex-col"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow"}),_vm._v(" "),_c('DoctorsList',{on:{"getDoctor":_vm.getDoctor}})],1):_c('div',[_c('div',{staticClass:"flex relative flex-row p-1 justify-between items-center flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mr-auto justify-center items-center cursor-pointer",on:{"click":function($event){return _vm.goBack()}}},[_c('img',{staticStyle:{"height":"18px"},attrs:{"src":__webpack_require__("r0/D")}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-10 mr-auto self-center text-xs items-center text-blue font-semibold"},[_vm._v("\n        "+_vm._s(_vm.doctor.name + "'s Consultations")+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow"}),_vm._v(" "),_c('DoctorConsultations',{attrs:{"doctor":_vm.doctor}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex relative flex-row p-1 justify-between self-center flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row h-10 mr-auto self-center text-xs items-center text-blue font-semibold"},[_vm._v("\n        Doctors\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PElW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__["a" /* default */]
  },
  data: function data() {
    return {
      showSaveReminder: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activeMiniMenu: function activeMiniMenu(state) {
      return state.configuration.activeMiniMenu;
    },
    activeAdminMiniMenu: function activeAdminMiniMenu(state) {
      return state.configuration.activeAdminMiniMenu;
    },
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    },
    isCompanyDoctor: function isCompanyDoctor(state) {
      return state.configuration.isCompanyDoctor;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    role: 'configuration/getRole'
  }), {
    is_Admin: function is_Admin() {
      if (sessionStorage.getItem('isAdmin')) {
        return true;
      }
      return false;
    }
  }),
  methods: {
    selectMenu: function selectMenu(menu) {
      if (this.is_Admin) {
        this.$emit('getAdminMenu', menu);
        this.$store.dispatch('configuration/setActiveAdminMiniMenu', menu);
        return;
      }
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      this.$store.dispatch('configuration/setActiveMiniMenu', menu);
    },
    closeModal: function closeModal(params) {
      this.showSaveReminder = false;
    },
    isGeneralDoctor: function isGeneralDoctor() {
      return !this.is_Admin && !this.isCompanyDoctor;
    },
    isAdminDoctor: function isAdminDoctor() {
      return this.is_Admin && !this.isCompanyDoctor;
    }
  }
});

/***/ }),

/***/ "PHZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeReloadOverlay: function closeReloadOverlay() {
      this.$emit('close');
    },
    getTips: function getTips() {
      var tips = ['Make sure your chat status is "Yes" if you wish to receive patient requests. ', 'Your connection status must always be in Connected state. ', 'If your connection status shows "Disconnected" check your internet connectivity.', 'Make sure you save your consultation summary before sending it to the patient.', 'Make sure you complete case summaries for all your patients within 24 hours of consultation.', 'Make sure your system volume is turned on to avoid missing any request notifications.', 'Remember to end all your consultations before logging out.'];
      var tip = tips[Math.floor(Math.random() * tips.length)];
      return tip;
    }
  }
});

/***/ }),

/***/ "PLr4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabMenu_vue__ = __webpack_require__("wEHN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793eae44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabMenu_vue__ = __webpack_require__("kL2/");
function injectStyle (ssrContext) {
  __webpack_require__("/Mpz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793eae44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PY9l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pa/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row pin-t border border-b border-grey-lightest h-12 w-screen shadow z-20 justify-between"},[_c('div',{staticClass:"flex flex-row items-center justify-start"},[_c('div',{staticClass:"no-underline cursor-pointer",on:{"click":function($event){return _vm.goHome()}}},[_c('img',{staticClass:"w-32 ml-4",attrs:{"src":__webpack_require__("0qeJ")}})])]),_vm._v(" "),(!_vm.isCompanyDoctor && _vm.role !== 'specialistDoctor')?_c('div',{staticClass:"flex flex-row items-center justify-start"},[_c('span',{staticClass:"text-lg ml-4",class:{'text-red': _vm.ablyDisconnected, 'text-green font-semibold': _vm.ablyConnected},attrs:{"title":"Ably Status"}},[_vm._v("\n      "+_vm._s(_vm.ablyStatusText)+"\n    ")]),_vm._v(" "),(!_vm.ablyStatus)?_c('button',{staticClass:"hover:bg-grey-lightest bg-white text-blue font-semibold py-2 px-4 rounded",on:{"click":_vm.connectToAbly}},[_vm._v("\n      Reconnect\n    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ml-6 mr-4 text-black"},[_vm._v(" Ready to take Chat? ")]),_vm._v(" "),_c('toggle-button',{attrs:{"value":_vm.availableForChat,"sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"color":{checked: '#3fcb7f', unchecked: '#ff6969'}},on:{"change":function($event){return _vm.updateActiveStatus($event.value)}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center justify-end"},[_c('span',{staticClass:"ml-4 mr-8"},[_c('router-link',{staticClass:"no-underline text-black font-semibold",attrs:{"to":"/profile"}},[_vm._v("\n        "+_vm._s(_vm.doctor.name)+"\n      ")])],1),_vm._v(" "),(!_vm.isCompanyDoctor)?_c('span',{staticClass:"mr-8 cursor-pointer pt-1 self-center",on:{"click":function($event){return _vm.toggleNotification()}}},[_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"src":__webpack_require__("SqJs"),"alt":"Notifications"}}),_vm._v(" "),(_vm.notViewedNotificationCount > 0)?_c('div',{staticClass:"flex bg-red justify-center items-center rounded-full flex-no-grow flex-no-shrink cursor-pointer w-5 h-5 mt-2 ml-3",staticStyle:{"border-radius":"50%","position":"absolute","top":"0px"}},[_c('p',{staticClass:"flex flex-col self-center justify-center text-xs text-white"},[_vm._v(_vm._s(_vm.notViewedNotificationCount))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.activeConsultsCount === 0)?_c('span',{staticClass:"cursor-pointer mr-8 pt-1 self-center",on:{"click":_vm.logout}},[_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"src":__webpack_require__("1PhP")}})]):_c('span',{staticClass:"flex-no-shrink flex-no-grow relative cursor-pointer mr-8 pt-1 self-center",on:{"click":_vm.logoutClicked}},[_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"src":__webpack_require__("1PhP")}})]),_vm._v(" "),(_vm.logOut)?_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"}}):_vm._e(),_vm._v(" "),(_vm.logOut)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" You have "+_vm._s(_vm.activeConsultsCount)+" active consultations")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeLogoutOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Are you sure you want to logout?")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.logout()}}},[_vm._v("Yes")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col border-grey-lightest border-solid border ml-4 px-4 py-2 justify-center font-semibold cursor-pointer rounded-sm text-grey-dark text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeLogoutOverlay()}}},[_vm._v("No")])])])]):_vm._e()]),_vm._v(" "),(_vm.showNotification)?_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.toggleNotification()}}}):_vm._e(),_vm._v(" "),(_vm.showNotification)?_c('doctor-notification',{on:{"enquireNow":_vm.enquireNow}}):_vm._e(),_vm._v(" "),(_vm.showQueryPopUp)?_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeQueryPopUp()}}}):_vm._e(),_vm._v(" "),(_vm.showQueryPopUp)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"380px","height":"300px","left":"calc((108vw - 500px)/2)","top":"200px","z-index":"99"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2"},[_c('img',{staticClass:"flex self-center mt-8",staticStyle:{"width":"90px"},attrs:{"src":__webpack_require__("ZYU2")}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs mx-8 text-center",staticStyle:{"position":"absolute","bottom":"74px","left":"10px","text-align":"center"}},[_vm._v("\n          You have pending queries from your patients. Please complete the conversations to close them.\n        ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-5 justify-start",staticStyle:{"position":"absolute","bottom":"0px","left":"31%","margin-left":"38px"}},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeQueryPopUp()}}},[_vm._v("Okay")])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row mb-2 justify-between items-center",staticStyle:{"position":"absolute","bottom":"94px","left":"31%"}},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2",staticStyle:{"color":"#70411b"}},[_vm._v("Pending Queries")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ph2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/* harmony default export */ __webpack_exports__["a"] = ({
  getDoctorsSlots: function getDoctorsSlots(doctorType, month, year) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/doctor_rosters?roster_type=' + doctorType + '&month=' + month + '&year=' + year);
  },
  getDoctorsList: function getDoctorsList() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/doctor_rosters/family_doctors');
  },
  updateSlot: function updateSlot(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_rosters/bulk_update', { roster: data });
  },
  uploadRoster: function uploadRoster(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_rosters/', data);
  },
  getDoctorChatSlots: function getDoctorChatSlots(month, year) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/doctor_chat_availabilities?month=' + month + '&year=' + year);
  },
  updateChatSlot: function updateChatSlot(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_chat_availabilities/bulk_update', data);
  },
  uploadChatAvailability: function uploadChatAvailability(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_chat_availabilities/', data);
  }
});

/***/ }),

/***/ "Q+Y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PastConsultations_vue__ = __webpack_require__("1pBD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243d29ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PastConsultations_vue__ = __webpack_require__("Aqjr");
function injectStyle (ssrContext) {
  __webpack_require__("aagr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PastConsultations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243d29ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PastConsultations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q5GJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q8/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      error: false,
      setPasswordError: null,
      newPassword1: null,
      newPassword2: null
    };
  },

  methods: {
    setPassword: function setPassword() {
      var _this = this;

      event.preventDefault();
      if (this.newPassword1 && this.newPassword2 && this.newPassword1 === this.newPassword2) {
        if (this.newPassword1.length < 8) {
          this.error = true;
          this.setPasswordError = 'Password is too short (minimum is 8 characters)';
        } else {
          var credentials = {
            reset_password_token: this.$route.params.token,
            password: this.newPassword1
          };
          this.isLoading = true;
          this.$http.post(window.API_URL + 'doctors/reset_password', credentials).then(function (response) {
            if (response.status === 200) {
              _this.isLoading = false;
              window.location.href = '/login';
            }
          }).catch(function (error) {
            this.isLoading = false;
            console.log(error);
            if (error.status === 401) {
              this.$toast.open({
                message: error.body.message,
                type: 'error',
                position: 'top',
                queue: false
              });
            } else if (error.status === 403) {
              this.$toast.open({
                message: error.body.message,
                type: 'warning',
                position: 'top',
                queue: false
              });
            }
          });
        }
      } else if (!this.newPassword1 || !this.newPassword2) {
        this.error = true;
        this.setPasswordError = "Passwords can't be empty";
      } else {
        this.error = true;
        this.setPasswordError = "Both the passwords don't match";
      }
    },
    cancelReset: function cancelReset() {
      this.$router.replace('/login');
    }
  }
});

/***/ }),

/***/ "QDv6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QE93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerProfile_vue__ = __webpack_require__("Y57z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd59d48a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerProfile_vue__ = __webpack_require__("cXcz");
function injectStyle (ssrContext) {
  __webpack_require__("lN29")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd59d48a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd59d48a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QSbr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-12 bg-white pin-l shadow flex-no-shrink flex-no-grow z-10"},[(_vm.isGeneralDoctor() && _vm.role !== 'specialistDoctor')?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeMiniMenu==='Chat' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Chat"},on:{"click":function($event){return _vm.selectMenu('Chat')}}},[_c('img',{staticClass:"h-6 w-6 self-center -ml-1",attrs:{"src":__webpack_require__("it8Z"),"alt":"Chat"}})]):_vm._e(),_vm._v(" "),(!_vm.is_Admin)?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeMiniMenu==='OfflineConsults' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Search Patient"},on:{"click":function($event){return _vm.selectMenu('OfflineConsults')}}},[_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"src":__webpack_require__("65UA"),"alt":"Search Patient"}})]):_vm._e(),_vm._v(" "),(_vm.isGeneralDoctor())?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeMiniMenu==='Appointments' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Appointments"},on:{"click":function($event){return _vm.selectMenu('Appointments')}}},[_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"src":__webpack_require__("GLgn"),"alt":"Appointments"}})]):_vm._e(),_vm._v(" "),(_vm.role === 'externalAdmin')?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeAdminMiniMenu==='Appointments' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Appointments"},on:{"click":function($event){return _vm.selectMenu('Appointments')}}},[_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"src":__webpack_require__("GLgn"),"alt":"Appointments"}})]):_vm._e(),_vm._v(" "),(_vm.isAdminDoctor() && _vm.role !== 'externalAdmin')?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeAdminMiniMenu==='DoctorMain' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Doctors"},on:{"click":function($event){return _vm.selectMenu('DoctorMain')}}},[_c('img',{staticClass:"h-6 w-6 self-center -ml-1",attrs:{"src":__webpack_require__("it8Z"),"alt":"Doctors"}})]):_vm._e(),_vm._v(" "),(_vm.isAdminDoctor())?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeAdminMiniMenu==='UploadDoctorRoster' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Upload Doctor Roster"},on:{"click":function($event){return _vm.selectMenu('UploadDoctorRoster')}}},[_c('img',{staticClass:"h-6 w-6 self-center",staticStyle:{"color":"blue"},attrs:{"src":__webpack_require__("ToFN"),"alt":"Upload a File"}})]):_vm._e(),_vm._v(" "),(_vm.isAdminDoctor())?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeAdminMiniMenu==='DoctorSchedule' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Schedule of Doctor"},on:{"click":function($event){return _vm.selectMenu('DoctorSchedule')}}},[_c('img',{staticClass:"h-6 w-6 self-center",staticStyle:{"color":"blue"},attrs:{"src":__webpack_require__("JoJM"),"alt":"Schedule of Doctor"}})]):_vm._e(),_vm._v(" "),(_vm.isAdminDoctor() && _vm.role !== 'externalAdmin')?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeAdminMiniMenu==='DoctorChatAvailability' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Chat availability of Doctor"},on:{"click":function($event){return _vm.selectMenu('DoctorChatAvailability')}}},[_c('img',{staticClass:"h-6 w-6 self-center",staticStyle:{"color":"blue"},attrs:{"src":__webpack_require__("ixOE"),"alt":"Chat availability of Doctor"}})]):_vm._e(),_vm._v(" "),(_vm.isGeneralDoctor() && _vm.role !== 'specialistDoctor')?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeMiniMenu==='DoctorSchedule' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"Schedule of Doctor"},on:{"click":function($event){return _vm.selectMenu('DoctorSchedule')}}},[_c('img',{staticClass:"h-6 w-6 self-center",staticStyle:{"color":"blue"},attrs:{"src":__webpack_require__("ixOE"),"alt":"Schedule of Doctor"}})]):_vm._e(),_vm._v(" "),(!_vm.isCompanyDoctor && !['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink",class:[_vm.activeMiniMenu==='COVID19' ? 'border-l-4 border-solid border-blue' : 'opacity-50'],attrs:{"title":"COVID-19"},on:{"click":function($event){return _vm.selectMenu('COVID19')}}},[_c('img',{staticClass:"h-6 w-6 self-center",staticStyle:{"color":"blue"},attrs:{"src":__webpack_require__("AL1U"),"alt":"COVID-19"}})]):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QWj2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-pattern1.cc4f5a0.svg";

/***/ }),

/***/ "QY/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loader: 'loader/getLoaderData'
  })),
  methods: {
    removeLoader: function removeLoader() {
      this.$store.dispatch('loader/setLoader', { loading: false, componentKey: null });
    }
  }
});

/***/ }),

/***/ "REiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestedAppointmentTable_vue__ = __webpack_require__("x8qm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e27373b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestedAppointmentTable_vue__ = __webpack_require__("UjkI");
function injectStyle (ssrContext) {
  __webpack_require__("32Py")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e27373b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestedAppointmentTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e27373b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestedAppointmentTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RIlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_customer_document__ = __webpack_require__("eX/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatientReports__ = __webpack_require__("m6sa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PatientReports: __WEBPACK_IMPORTED_MODULE_4__PatientReports__["a" /* default */]
  },
  data: function data() {
    return {
      modal: false,
      showModal: false,
      fileCategory: null,
      selectedApt: null,
      selectedKey: null,
      selectedFiles: null,
      showUploadDocModal: false,
      activeDocs: 'recently uploaded',
      activeResults: 'results',
      showFullView: false,
      document: null,
      filesUploadedByPatient: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    isActiveChatPresent: 'consultation/isActiveChatPresent',
    isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
    activeSection: 'configuration/getActiveSection'
  }), {
    isActiveChat: function isActiveChat() {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return 'ongoing';
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return 'past';
      }
    },
    otherDocuments: function otherDocuments() {
      if (this.customer && this.customer.details && this.customer.details.documents) {
        var presList = this.customer.details.prescriptions.map(function (el) {
          var o = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, el);
          o.category = 'Prescription';
          return o;
        });
        var allDocs = presList.concat(this.customer.details.documents, this.filesUploadedByPatient);
        allDocs.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
        var date = new Date();
        var res = date.setTime(date.getTime() - 30 * 24 * 60 * 60 * 1000);
        var resDate = new Date(res);
        var within30Days = allDocs.filter(function (el, index) {
          return resDate < new Date(el.date);
        });
        return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pullAllBy(allDocs, within30Days);
      }
      return [];
    },
    last30Days: function last30Days() {
      if (this.customer && this.customer.details && this.customer.details.documents) {
        var presList = this.customer.details.prescriptions.map(function (el) {
          var o = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, el);
          o.category = 'Prescription';
          return o;
        });
        var allDocs = presList.concat(this.customer.details.documents, this.filesUploadedByPatient);
        allDocs.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
        var date = new Date();
        var res = date.setTime(date.getTime() - 30 * 24 * 60 * 60 * 1000);
        var resDate = new Date(res);
        var within30Days = allDocs.filter(function (el, index) {
          return resDate < new Date(el.date);
        });
        return within30Days;
      }
      return [];
    }
  }),
  methods: {
    fetchCustomerUploadedFiles: function fetchCustomerUploadedFiles() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api_customer_document__["a" /* default */].getCustomerUploadedFiles(this.customer.customerId).then(function (response) {
        if (response.status === 200) {
          var newData = _this.transformUploadedFiles(response.body);
          _this.filesUploadedByPatient = newData;
        } else {
          _this.$toast.open({ message: 'Error fetching data', type: 'error', position: 'top-right' });
        }
      }, function () {
        _this.$toast.open({ message: 'Error fetching data', type: 'error', position: 'top-right' });
      });
    },
    transformUploadedFiles: function transformUploadedFiles(data) {
      if (!data || !Array.isArray(data)) return [];
      return data.map(function (appointment) {
        var appointmentName = appointment.description || '';
        var appointmentDate = appointment.time;
        var documents = Array.isArray(appointment.documents) ? appointment.documents : [];
        var reports = documents.map(function (doc) {
          return { id: doc.id || null, name: doc.file_name || '' };
        });

        return {
          category: 'Others',
          spc_consultation_name: appointmentName,
          date: appointmentDate,
          health_assessment_status: '',
          lab_results: [],
          notes: [],
          reports: reports
        };
      });
    },
    handleFileUpload: function handleFileUpload(files) {
      this.selectedFiles = files;
    },

    selectFileCategory: function selectFileCategory(category) {
      this.fileCategory = category;
    },
    openUploadDocModal: function openUploadDocModal(apt, key) {
      this.selectedApt = apt;
      this.selectedKey = key;
      this.showModal = true;
      this.showUploadDocModal = true;
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.showUploadDocModal = false;
      this.fileCategory = null;
      this.selectedApt = null;
      this.selectedKey = null;
      this.selectedFiles = null;
    },
    getDocument: function getDocument(reportType, reportId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_customer_document__["a" /* default */].fetch(reportType, reportId).then(function (response) {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank');
        } else {
          _this2.$toast.open({
            message: 'Error fetching data',
            type: 'error',
            position: 'top-right'
          });
        }
      }, function (response) {});
    },
    uploadDoc: function uploadDoc(file) {
      if (!this.fileCategory) {
        this.$toast.open({
          message: 'Please select a document category',
          type: 'error',
          position: 'bottom-right',
          queue: false
        });
        return;
      }
      if (this.customer.consultation && !this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Cannot Upload documents without a consultation.',
          type: 'error',
          position: 'bottom-right',
          queue: false
        });
        return;
      }
      var formData = new FormData();
      formData.append('customer_id', this.customer.customerId);
      formData.append('consultation_id', this.customer.consultation.consultationId);
      formData.append('category', this.fileCategory);
      Array.prototype.forEach.call(this.selectedFiles, function (file) {
        formData.append('files[]', file, file.name);
      });
      if (this.$attrs.chatType === 'offline') {
        this.uploadOffline(formData);
      } else if (this.$attrs.chatType === 'online') {
        this.uploadOnline(formData);
      }
      this.closeModal();
    },

    uploadOffline: function uploadOffline(formData) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('offlineConsultation/uploadDocuments', formData);
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastOfflineConsultation/uploadDocuments', formData);
      }
    },
    uploadOnline: function uploadOnline(formData) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('consultation/uploadDocuments', formData);
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastConsultation/uploadDocuments', formData);
      }
    },
    setActiveDocs: function setActiveDocs(section) {
      this.activeDocs = section;
    },
    setActiveResults: function setActiveResults(resultsSection) {
      this.activeResults = resultsSection;
    },
    showFullViewModal: function showFullViewModal(fullView, doc) {
      this.showFullView = fullView;
      this.document = doc;
    }
  },
  mounted: function mounted() {
    this.fetchCustomerUploadedFiles();
  }
});

/***/ }),

/***/ "RSzj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RaxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__ = __webpack_require__("qrBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_lab_tests__ = __webpack_require__("y1lv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from 'lodash'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      freqTests: [],
      sponsoredTests: [],
      otherTests: [],
      selectedTests: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    isActiveChatPresent: 'consultation/isActiveChatPresent',
    isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
    isActivePastOfflineChatPresent: 'pastOfflineConsultation/isPastChatPresent',
    activeSection: 'configuration/getActiveSection',
    activeMiniMenu: 'configuration/getActiveMiniMenu',
    storedTests: 'consultation/getLabTests',
    storedOfflineTests: 'offlineConsultation/getLabTests'
  }), {
    filteredList: function filteredList() {
      var _this = this;

      return this.otherTests.filter(function (test) {
        return test.name.toLowerCase().includes(_this.searchTerm.toLowerCase());
      });
    },

    isActiveChat: function isActiveChat() {
      if (this.activeMiniMenu === 'OfflineConsults') {
        if (this.activeSection === 'connected' && this.isActivePastOfflineChatPresent === true) {
          return 'ongoing';
        } else if (this.activeSection === 'consults' && this.isActivePastOfflineChatPresent === true) {
          return 'past';
        }
      } else {
        if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
          return 'ongoing';
        } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
          return 'past';
        }
      }
    }
  }),
  watch: {
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedTests = [];
      } else {
        this.selectedTests = this.$attrs.chatType === 'online' ? this.storedTests : this.storedOfflineTests;
      }
    }
  },
  created: function created() {
    this.selectedTests = this.$attrs.chatType === 'online' ? this.storedTests : this.storedOfflineTests;
  },
  mounted: function mounted() {
    this.fetchLabPackages();
  },

  methods: {
    addFreqTests: function addFreqTests(test) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      if (this.isActiveChat !== 'past') {
        var lab = this.selectedTests.find(function (obj) {
          return obj.id === test.id;
        });
        if (!lab) {
          test.type = 'frequentlyOrdered';
          this.selectedTests.push(test);
          var index = this.freqTests.indexOf(test);
          if (this.$attrs.chatType === 'online') {
            this.$store.dispatch('consultation/storeLabTests', { tests: this.selectedTests, customerId: this.customer.customerId });
          } else {
            this.$store.dispatch('offlineConsultation/storeLabTests', { tests: this.selectedTests, customerId: this.customer.customerId });
          }
          if (index > -1) {
            this.freqTests.splice(index, 1);
          }
        }
      } else {
        this.$toast.open({
          message: 'Cannot add tests to past consultation',
          type: 'warning',
          position: 'top',
          queue: false
        });
      }
    },
    addSponsoredTests: function addSponsoredTests(test) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      if (this.isActiveChat !== 'past') {
        var lab = this.selectedTests.find(function (obj) {
          return obj.id === test.id;
        });
        if (!lab) {
          test.type = 'sponsored';
          this.selectedTests.push(test);
          var index = this.sponsoredTests.indexOf(test);
          if (this.$attrs.chatType === 'online') {
            this.$store.dispatch('consultation/storeLabTests', { tests: this.selectedTests, customerId: this.customer.customerId });
          } else {
            this.$store.dispatch('offlineConsultation/storeLabTests', { tests: this.selectedTests, customerId: this.customer.customerId });
          }
          if (index > -1) {
            this.sponsoredTests.splice(index, 1);
          }
        }
      } else {
        this.$toast.open({
          message: 'Cannot add tests to past consultation',
          type: 'warning',
          position: 'top',
          queue: false
        });
      }
    },
    addOtherTests: function addOtherTests(test) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      if (this.isActiveChat !== 'past') {
        var lab = this.selectedTests.find(function (obj) {
          return obj.id === test.id;
        });
        if (!lab) {
          var testObj = {
            id: test.id,
            name: test.name,
            number_of_tests: test.number_of_tests,
            tests_list: test.tests_list
          };
          testObj.type = 'other';
          this.selectedTests.push(testObj);
          var index = this.otherTests.indexOf(test);
          if (this.$attrs.chatType === 'online') {
            this.$store.dispatch('consultation/storeLabTests', { tests: this.selectedTests, customerId: this.customer.customerId });
          } else {
            this.$store.dispatch('offlineConsultation/storeLabTests', { tests: this.selectedTests, customerId: this.customer.customerId });
          }
          if (index > -1) {
            this.otherTests.splice(index, 1);
          }
        }
      } else {
        this.$toast.open({
          message: 'Cannot add tests to past consultation',
          type: 'warning',
          position: 'top',
          queue: false
        });
      }
    },
    removeTests: function removeTests(index) {
      var test = this.selectedTests[index];
      var listIndex = test.index;
      if (test.type === 'other') {
        delete test.type;
        this.otherTests.splice(listIndex, 0, test);
      } else if (test.type === 'frequentlyOrdered') {
        delete test.type;
        this.freqTests.splice(listIndex, 0, test);
      } else {
        delete test.type;
        this.sponsoredTests.splice(listIndex, 0, test);
      }
      this.selectedTests.splice(index, 1);
    },
    fetchLabPackages: function fetchLabPackages() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_lab_tests__["a" /* default */].getPackages(this.customer.customerId).then(function (response) {
        if (response.status === 200) {
          _this2.otherTests = response.body.packages.map(function (test, idx) {
            test.index = idx;
            return test;
          });
          _this2.freqTests = response.body.frequently_ordered_packages.map(function (test, idx) {
            test.index = idx;
            return test;
          });
          _this2.sponsoredTests = response.body.sponsored_packages.filter(function (test) {
            return !test.availed_package;
          }).map(function (test, idx) {
            test.index = idx;
            return test;
          });
        } else {}
      }, function (response) {}).catch(function (e) {
        console.log(e);
      });
    },
    sendToPatient: function sendToPatient() {
      if (this.selectedTests.length === 0) {
        alert('Please select atleast 1 test');
      } else {
        var pids = this.selectedTests.map(function (tests) {
          return tests.id;
        });
        // let pnames = this.selectedTests.map(function (tests) { return tests.name })
        var recommendedTests = this.selectedTests.map(function (test) {
          return { id: test.id, name: test.name, number_of_tests: test.number_of_tests, package_id: test.id };
        });
        var data = {
          customer_id: this.customer.customerId,
          consultation_id: this.customer.consultation.consultationId,
          recommended_tests: recommendedTests,
          package_ids: pids
        };
        this.$store.dispatch('message/sendRecommendedTests', { data: data, consultationType: this.activeMiniMenu });
        this.selectedTests = [];
        if (this.$attrs === 'online') {
          this.$store.dispatch('consultation/storeLabTests', { tests: [], customerId: this.customer.customerId });
        } else {
          this.$store.dispatch('offlineConsultation/storeLabTests', { tests: [], customerId: this.customer.customerId });
        }
      }
    }
  }
});

/***/ }),

/***/ "Rd3L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RnK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrugPrescriptionCard_vue__ = __webpack_require__("v+pk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92f91c94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrugPrescriptionCard_vue__ = __webpack_require__("3+8l");
function injectStyle (ssrContext) {
  __webpack_require__("w9q5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrugPrescriptionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92f91c94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrugPrescriptionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RoHf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S+5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-extralight font-semibold text-grey-darker mx-4 my-3 text-sm rounded py-3"},[_c('div',{staticClass:"px-4 pb-3 mb-1 border-b",staticStyle:{"border-color":"#e6e8ef"}},[_c('div',[_vm._v(_vm._s(_vm.healthParameter.type)+" "),_c('span',{staticClass:"text-xs text-grey font-normal"},[_vm._v("(Updated on: "),_c('span',{staticClass:"text-grey-darker"},[_vm._v(_vm._s(_vm.hraDate))]),_vm._v(")")])])]),_vm._v(" "),_c('div',{staticClass:"px-4"},[(_vm.healthParameter.type === 'FAMILY HISTORY')?_c('div',{staticClass:"border border-grey-lightest mt-2"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.healthParameter.items),function(item){return _c('div',{key:item.name,staticClass:"flex flex-row items-center justify-between px-3"},[_c('p',{staticClass:"pb-3"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center justify-evenly",staticStyle:{"min-width":"170px"}},[_c('div',{staticClass:"flex flex-row items-center pl-3 pb-3 border-l",staticStyle:{"width":"89px"}},[_c('p',{staticClass:"mx-auto",class:item.mother.color},[_vm._v(_vm._s(item.mother.text))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center pl-3 pb-3 border-l",staticStyle:{"width":"85px"}},[_c('p',{staticClass:"mx-auto",class:item.father.color},[_vm._v(_vm._s(item.father.text))])])])])})],2):_vm._l((_vm.healthParameter.items),function(item){return _c('div',{key:item.name,staticClass:"flex flex-row justify-between pt-2"},[_c('div',{staticClass:"capitalize"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{class:item.color},[_vm._v(_vm._s(item.text))])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center justify-between bg-white px-3 mb-3"},[_c('p',{staticClass:"py-3"},[_vm._v("Medical Problem")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center justify-evenly",staticStyle:{"min-width":"170px"}},[_c('div',{staticClass:"flex flex-row items-center pl-3 py-3 border-l",staticStyle:{"width":"89px"}},[_c('img',{staticClass:"w-4 mr-1",attrs:{"src":__webpack_require__("Z8dw")}}),_c('p',[_vm._v("Mother")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-center pl-3 py-3 border-l",staticStyle:{"width":"85px"}},[_c('img',{staticClass:"w-4 mr-1",attrs:{"src":__webpack_require__("d3DZ")}}),_c('p',[_vm._v("Father")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S5cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_consultation_request__ = __webpack_require__("eJoz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__ = __webpack_require__("II+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_request_sort__ = __webpack_require__("P/Ae");








// import Vue from 'vue'
// State

var state = {
  requests: [],
  followUpQuestions: [],
  loadDetails: [],
  setRequests: [],
  snackbarRequests: []

  // Getters
};var getters = {
  getRequests: function getRequests() {
    var jsonRequests = state.requests.map(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default.a);
    var requestSet = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(jsonRequests);
    state.requests = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(requestSet).map(JSON.parse);
    return state.requests.filter(function (ele) {
      return ele.status === 'unicasted' || ele.status === 'broadcasted' || ele.status === 'queried';
    });
  },
  getQueries: function getQueries() {
    return state.requests.filter(function (ele) {
      return ele.status === 'queried' && ele.request_type === 'queried';
    });
  },
  getMissedRequests: function getMissedRequests() {
    return state.requests.filter(function (ele) {
      return ele.status === 'queried' && ele.request_type === 'missed';
    });
  },
  getAcceptedRequest: function getAcceptedRequest() {
    return state.requests.filter(function (ele) {
      return ele.status === 'accepted';
    });
  },
  getOthersAcceptedRequest: function getOthersAcceptedRequest() {
    return state.requests.filter(function (ele) {
      return ele.status === 'already_assigned';
    });
  },
  getCancelledRequest: function getCancelledRequest() {
    return state.requests.filter(function (ele) {
      return ele.status === 'cancelled';
    });
  },
  getRejectedRequest: function getRejectedRequest() {
    return state.requests.filter(function (ele) {
      return ele.status === 'rejected';
    });
  },
  getFollowupQuestions: function getFollowupQuestions() {
    return state.followUpQuestions;
  }
};

// Actions
var actions = {
  init: function init(_ref, _ref2) {
    var commit = _ref.commit,
        state = _ref.state;
    var details = _ref2.details;

    commit('setUpRequests', { details: details });
  },
  setUpQueries: function setUpQueries(_ref3) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_6__api_initialise_store__["a" /* default */].fetchQueries().then(function (response) {
      if (response.status === 200) {
        commit('setUpRequests', { details: response.body.consultation_requests });
      }
    });
  },
  addConsultationRequest: function addConsultationRequest(_ref4, message) {
    var commit = _ref4.commit,
        state = _ref4.state,
        rootState = _ref4.rootState,
        dispatch = _ref4.dispatch;

    if (message.request_status === 'unicasted') {
      commit('addUnicastedRequest', message);
    } else {
      if (message.family_doctor_id !== rootState.configuration.doctorId) {
        commit('add', message);
      }
    }
  },
  acceptConsultationRequest: function acceptConsultationRequest(_ref5, request) {
    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState,
        dispatch = _ref5.dispatch;

    __WEBPACK_IMPORTED_MODULE_5__api_consultation_request__["a" /* default */].accept(request.consultationRequestId, rootState.configuration.doctorId).then(function (response) {
      if (response.status === 200) {
        if (response.body.state === 'assigned') {
          commit('remove', { channelId: request.channelId, status: 'accepted' });
          var consultation = response.body.consultation;
          dispatch('consultation/addToActiveConsultation', { request: request, consultation: consultation }, { root: true });
        } else if (response.body.state === 'already_assigned') {
          commit('remove', { channelId: request.channelId, status: 'already_assigned' });
        } else if (response.body.status === 'error') {
          dispatch('toaster/setToaster', { status: true, type: 'error', message: response.body.message }, { root: true });
          commit('remove', { channelId: request.channelId, status: 'already_assigned' });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  acceptQueriedConsultationRequest: function acceptQueriedConsultationRequest(_ref6, request) {
    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState,
        dispatch = _ref6.dispatch;

    __WEBPACK_IMPORTED_MODULE_5__api_consultation_request__["a" /* default */].acceptQuery(request.consultationRequestId, rootState.configuration.doctorId).then(function (response) {
      if (response.status === 200) {
        commit('remove', { channelId: request.channelId, status: 'query_accepted' });
        var consultation = response.body.consultation;
        dispatch('consultation/addQueryToActiveConsultation', { request: request, consultation: consultation }, { root: true });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  queriedConsultationRequest: function queriedConsultationRequest(_ref7, message) {
    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    message.request_type = 'queried';
    commit('addQueriedRequest', message);
  },
  missedConsultationRequest: function missedConsultationRequest(_ref8, message) {
    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState;

    commit('updateMissedReq', { channelId: message.payload.channel_id, status: 'queried', type: 'missed', message: 'Request was missed' });
  },
  removeRequest: function removeRequest(_ref9, _ref10) {
    var commit = _ref9.commit,
        state = _ref9.state;
    var message = _ref10.message,
        status = _ref10.status;

    commit('remove', { channelId: message.payload.channel_id, status: status, message: message.payload.text
    });
  },
  loadDetails: function loadDetails(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    __WEBPACK_IMPORTED_MODULE_5__api_consultation_request__["a" /* default */].load_details().then(function (response) {
      if (response.status === 200) {
        commit('saveLoadDetails', response.body.details);
      }
    });
  }
};

// Mutations
var mutations = {
  setUpRequests: function setUpRequests(state, _ref12) {
    var _this = this;

    var details = _ref12.details;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(details.length > 0)) {
                _context2.next = 2;
                break;
              }

              return _context2.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var vipList, cancelledRequestList, generalRequestList, requests, _loop, i;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        vipList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_request_sort__["a" /* vipSort */])(details);
                        cancelledRequestList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_request_sort__["b" /* cancelRequestSort */])(details);
                        generalRequestList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_request_sort__["c" /* generalRequestSort */])(details);
                        _context.next = 5;
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_request_sort__["d" /* mergeRequests */])(vipList, cancelledRequestList, generalRequestList);

                      case 5:
                        requests = _context.sent;

                        _loop = function _loop(i) {
                          var req = state.requests.find(function (ele) {
                            return ele.customer_id === requests[i].customer_id;
                          });
                          var index = state.requests.indexOf(req);
                          if (index < 0) {
                            var request = {
                              channelId: requests[i].channel_id,
                              customer_id: requests[i].customer_id,
                              customer_name: requests[i].customer_name,
                              consultationRequestId: requests[i].consultation_request_id,
                              status: requests[i].request_status,
                              request_type: requests[i].request_type,
                              time: requests[i].time,
                              chiefComplaint: requests[i].chief_complaint,
                              duration: requests[i].duration,
                              isFamilyDoctor: requests[i].is_family_doctor,
                              familyDoctor: { id: requests[i].family_doctor.id, name: requests[i].family_doctor.name },
                              cancelledRequestsCount: requests[i].cancelled_requests_count,
                              vip: requests[i].vip
                            };
                            state.requests.push(request);
                          }
                        };

                        for (i = 0; i < requests.length; i++) {
                          _loop(i);
                        }

                      case 8:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              })(), 't0', 2);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  addUnicastedRequest: function addUnicastedRequest(state, message) {
    var req = state.requests.find(function (ele) {
      return ele.channelId === message.payload.channel_id && (ele.request_status === 'unicasted' || ele.request_status === 'queried');
    });
    // let index = state.requests.indexOf(req)
    if (!req) {
      var customerDetails = {
        consultationRequestId: message.consultation_id,
        chiefComplaint: message.chief_complaint,
        duration: message.duration,
        channelId: message.payload.channel_id,
        customer_id: message.payload.customer_id,
        customer_name: message.payload.customer_name,
        status: message.request_status,
        request_type: message.request_type,
        time: message.time,
        isFamilyDoctor: message.is_family_doctor,
        initiatorId: message.payload.initiator_id,
        initiatorName: message.payload.initiator_name,
        cancelledRequestsCount: message.cancelled_requests_count,
        vip: message.vip
      };
      if (state.requests.length === 0) {
        state.requests.push(customerDetails);
        return;
      }
      var vipIndex = state.requests.filter(function (ele) {
        return ele.vip;
      }).length;
      var requestCountLength = vipIndex + state.requests.filter(function (ele) {
        return !ele.vip && ele.cancelledRequestsCount > 0;
      }).length;
      if (customerDetails.vip) {
        state.requests.splice(vipIndex, 0, customerDetails);
      } else if (customerDetails.cancelledRequestsCount > 0 && !customerDetails.vip) {
        var added = false;
        if (state.requests.length === 0) {
          state.requests.push(customerDetails);
        } else {
          for (var i = vipIndex; i < requestCountLength; i++) {
            if (customerDetails.cancelledRequestsCount > state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i, -1, customerDetails);
              added = true;
              break;
            } else if (customerDetails.cancelledRequestsCount === state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i + 1, 0, customerDetails);
              added = true;
            }
          }
          if (!added) {
            state.requests.splice(requestCountLength, -1, customerDetails);
            added = true;
          }
        }
        if (!added) {
          state.requests.splice(vipIndex, -1, customerDetails);
        }
      } else {
        state.requests.push(customerDetails);
      }
    }
  },
  add: function add(state, message) {
    var req = state.requests.find(function (ele) {
      return ele.channelId === message.payload.channel_id && ele.status === 'broadcasted';
    });
    // let index = state.requests.indexOf(req)
    if (!req) {
      var customerDetails = {
        consultationRequestId: message.consultation_id,
        chiefComplaint: message.chief_complaint,
        duration: message.duration,
        channelId: message.payload.channel_id,
        customer_id: message.payload.customer_id,
        customer_name: message.payload.customer_name,
        status: message.request_status,
        time: message.time,
        isFamilyDoctor: message.is_family_doctor,
        familyDoctor: { id: message.family_doctor.id, name: message.family_doctor.name },
        cancelledRequestsCount: message.cancelled_requests_count,
        vip: message.vip
      };
      if (state.requests.length === 0) {
        state.requests.push(customerDetails);
        return;
      }
      var vipIndex = state.requests.filter(function (ele) {
        return ele.vip;
      }).length;
      var requestCountLength = vipIndex + state.requests.filter(function (ele) {
        return !ele.vip && ele.cancelledRequestsCount > 0;
      }).length;
      if (customerDetails.vip) {
        state.requests.splice(vipIndex, 0, customerDetails);
      } else if (customerDetails.cancelledRequestsCount > 0 && !customerDetails.vip) {
        var added = false;
        if (state.requests.length === 0) {
          state.requests.push(customerDetails);
        } else {
          for (var i = vipIndex; i < requestCountLength; i++) {
            if (customerDetails.cancelledRequestsCount > state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i, -1, customerDetails);
              added = true;
              break;
            } else if (customerDetails.cancelledRequestsCount === state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i + 1, 0, customerDetails);
              added = true;
            }
          }
          if (!added) {
            state.requests.splice(requestCountLength, -1, customerDetails);
            added = true;
          }
        }
        if (!added) {
          state.requests.splice(vipIndex, -1, customerDetails);
        }
      } else {
        state.requests.push(customerDetails);
      }
      // notification.create('newuser')
    }
  },
  addQueriedRequest: function addQueriedRequest(state, message) {
    var req = state.requests.find(function (ele) {
      return ele.channelId === message.payload.channel_id && (ele.request_status === 'unicasted' || ele.request_status === 'queried');
    });
    // let index = state.requests.indexOf(req)
    var customerDetails = void 0;
    if (!req) {
      customerDetails = {
        consultationRequestId: message.consultation_id,
        chiefComplaint: message.chief_complaint,
        duration: message.duration,
        channelId: message.payload.channel_id,
        customer_id: message.payload.customer_id,
        customer_name: message.payload.customer_name,
        status: message.request_status,
        request_type: message.request_type,
        time: message.time,
        isFamilyDoctor: message.is_family_doctor,
        initiatorId: message.payload.initiator_id,
        initiatorName: message.payload.initiator_name,
        cancelledRequestsCount: message.cancelled_requests_count,
        vip: message.vip
      };
      state.requests.push(customerDetails);
    }
    var vipIndex = state.requests.filter(function (ele) {
      return ele.vip;
    }).length;
    var requestCountLength = vipIndex + state.requests.filter(function (ele) {
      return !ele.vip && ele.cancelledRequestsCount > 0;
    }).length;
    if (customerDetails.vip) {
      if (vipIndex === 0) {
        state.requests.unshift(customerDetails);
      } else {
        state.requests.splice(vipIndex, 0, customerDetails);
      }
    } else if (customerDetails.cancelledRequestsCount > 0 && !customerDetails.vip) {
      var added = false;
      if (state.requests.length === 0) {
        state.requests.push(customerDetails);
      } else {
        for (var i = vipIndex; i < requestCountLength; i++) {
          if (customerDetails.cancelledRequestsCount > state.requests[i].cancelledRequestsCount) {
            state.requests.splice(i, -1, customerDetails);
            added = true;
            break;
          } else if (customerDetails.cancelledRequestsCount === state.requests[i].cancelledRequestsCount) {
            state.requests.splice(i + 1, 0, customerDetails);
            added = true;
          }
        }
        if (!added) {
          state.requests.splice(requestCountLength, -1, customerDetails);
          added = true;
        }
      }
      if (!added) {
        state.requests.splice(vipIndex, -1, customerDetails);
      }
    } else {
      state.requests.push(customerDetails);
    }
  },
  updateMissedReq: function updateMissedReq(state, _ref13) {
    var channelId = _ref13.channelId,
        status = _ref13.status,
        type = _ref13.type,
        message = _ref13.message;

    var req = state.requests.find(function (ele) {
      return ele.channelId === channelId && ele.status === 'unicasted';
    });
    var index = state.requests.indexOf(req);
    if (index > -1) {
      var _req = state.requests[index];
      _req.status = status;
      _req.request_type = type;
      _req.message = message;
      state.requests.splice(index, 1);
      state.requests.push(_req);
    }
  },
  remove: function remove(state, _ref14) {
    var channelId = _ref14.channelId,
        status = _ref14.status,
        message = _ref14.message;

    var req = state.requests.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.requests.indexOf(req);
    if (index > -1) {
      var _req2 = state.requests[index];
      _req2.status = status;
      _req2.message = message;
      state.requests = state.requests.filter(function (ele) {
        return ele.channelId !== channelId;
      });
      // state.requests.push(req)
    }
  },
  saveLoadDetails: function saveLoadDetails(state, details) {
    state.loadDetails = details;
  },
  reset: function reset(state) {
    state = {};
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "SH8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['message'],
  data: function data() {
    return {
      showMic: true,
      isRecording: false,
      recognizer: null,
      finalTranscript: ''
    };
  },

  watch: {
    message: function message(newVal, oldVal) {
      if (newVal === '') {
        this.finalTranscript = '';
      }
    }
  },
  mounted: function mounted() {
    this.initializeSpeechRecognition();
  },

  methods: {
    initializeSpeechRecognition: function initializeSpeechRecognition() {
      var vm = this;
      var firstInterim = false;
      window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || null;
      if (window.SpeechRecognition === null) {
        vm.showMic = false;
        console.log("Browser doesn't suport speech recognition");
      } else {
        vm.recognizer = new window.SpeechRecognition();
        vm.recognizer.continuous = true;
        // Start recognising
        vm.recognizer.onresult = function (event) {
          var interimTranscript = '';
          for (var i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              vm.finalTranscript += event.results[i][0].transcript;
            } else {
              interimTranscript += event.results[i][0].transcript;
            }
          }
          if (interimTranscript === '') {
            firstInterim = true;
          }
          vm.finalTranscript = vm.capitalize(vm.finalTranscript);
          vm.finalTranscript = vm.linebreak(vm.finalTranscript);
          interimTranscript = vm.linebreak(interimTranscript);
          vm.$emit('getVoiceMessage', vm.finalTranscript);
          if (firstInterim) {
            interimTranscript = vm.finalTranscript + interimTranscript;
          }
          if (interimTranscript !== '') {
            vm.$emit('getVoiceMessage', interimTranscript);
          }
        };
        // Listen for errors
        vm.recognizer.onerror = function (event) {
          console.log('Recognition error(2): ' + event.message);
        };
      }
    },
    linebreak: function linebreak(s) {
      var twoLine = /\n\n/g;
      var oneLine = /\n/g;
      return s.replace(twoLine, '<p></p>').replace(oneLine, '<br>');
    },
    capitalize: function capitalize(s) {
      if (!s) {
        s = '';
      }
      var firstChar = /\S/;
      return s.replace(firstChar, function (m) {
        return m.toUpperCase();
      });
    },

    toggleRecording: function toggleRecording(isRecording) {
      var vm = this;
      vm.isRecording = isRecording;
      vm.finalTranscript = vm.message;
      if (vm.isRecording) {
        vm.recognizer.stop();
        vm.isRecording = false;
        console.log('Recognition stopped');
      } else {
        try {
          vm.recognizer.start();
          vm.isRecording = true;
          console.log('Recognition started');
        } catch (ex) {
          console.log('Recognition error(1): ' + ex.message);
        }
      }
    },
    stopRecording: function stopRecording(isRecording) {
      this.toggleRecording(isRecording);
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "SJtH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var hraMixin = {
  data: function data() {
    return {
      hraDate: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  }), {
    healthParameters: function healthParameters() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        var healthParams = this.customer.details.health_parameters;
        this.hraDate = healthParams.date ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(healthParams.date).format('Do MMM YYYY') : 'NA';
        var Hra = [];
        Hra.push(this.addDietAssessment(healthParams));
        Hra.push(this.addPastMedicalHistory(healthParams));
        Hra.push(this.addLifestyleHistory(healthParams));
        Hra.push(this.addFamilyHistory(this.customer.details.family_history));
        return Hra;
      }
      return [];
    }
  }),
  methods: {
    addDietAssessment: function addDietAssessment(healthParams) {
      var values = {
        0: { text: 'High', color: 'text-red' },
        1: { text: 'Medium', color: 'text-orange' },
        2: { text: 'Low', color: 'text-green' }
      };
      var noData = { text: 'NA', color: '' };
      return {
        type: 'DIET ASSESSMENT',
        updatedOn: '',
        items: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Whole Grains' }, values[healthParams.whole_grains] || noData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Fruits and vegetables' }, values[healthParams.fruits_and_vegetables] || noData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'fried fruits & refined carboydrates' }, values[healthParams.fried_foods_and_refined_carbohydrates] || noData)]
      };
    },
    addPastMedicalHistory: function addPastMedicalHistory(healthParams) {
      var values = {
        true: { text: 'Yes', color: 'text-red' },
        false: { text: 'No', color: 'text-green' }
      };
      var noData = { text: 'NA', color: '' };
      return {
        type: 'PAST MEDICAL HISTORY',
        items: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Diabetes' }, values[healthParams.diabetic_treatment] || noData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Cancer' }, values[healthParams.cancer] || noData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'BP' }, values[healthParams.hypertensive_treatment] || noData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Heart Condition' }, values[healthParams.cvd_treatment] || noData)]
      };
    },
    addLifestyleHistory: function addLifestyleHistory(healthParams) {
      var values = {
        true: { text: 'Yes', color: 'text-red' },
        false: { text: 'No', color: 'text-green' }
      };
      return {
        type: 'LIFESTYLE HISTORY',
        items: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Low Self Esteem' }, values[healthParams.low_self_esteem]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Fatigue' }, values[healthParams.fatigue]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Body Aches' }, values[healthParams.body_aches]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Anxiety' }, values[healthParams.anxiety]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Nervous Breakdown' }, values[healthParams.nervous_breakdown]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: 'Stress Eating' }, values[healthParams.stress_eating])]
      };
    },
    addFamilyHistory: function addFamilyHistory(healthParams) {
      var values = {
        true: { text: 'Yes', color: 'text-red' },
        false: { text: 'No', color: 'text-green' }
      };
      var fathersHistory = healthParams.fathers_history || ['None'];
      var mothersHistory = healthParams.mothers_history || ['None'];
      return {
        type: 'FAMILY HISTORY',
        items: [{ name: 'Diabetes', father: values[fathersHistory.includes('Diabeties')], mother: values[mothersHistory.includes('Diabeties')] }, { name: 'BP', father: values[fathersHistory.includes('Hypertension')], mother: values[mothersHistory.includes('Hypertension')] }, { name: 'Heart Condition', father: values[fathersHistory.includes('Heart Condition')], mother: values[mothersHistory.includes('Heart Condition')] }, { name: 'Cancer', father: values[fathersHistory.includes('Cancer')], mother: values[mothersHistory.includes('Diabetes')] }]
      };
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (hraMixin);

/***/ }),

/***/ "SQQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-white border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"my-1 flex flex-col rounded flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-col p-2"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.medication.name),expression:"medication.name"}],staticClass:"w-64 h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest",staticStyle:{"outline":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.medication.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.medication, "name", $event.target.value)},_vm.fetchDrugData]}}),_vm._v(" "),(_vm.showDrugList)?_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.removeList()}}}):_vm._e(),_vm._v(" "),(_vm.showDrugList)?_c('ul',{staticClass:"autocomplete-results w-64 h-auto z-10 shadow-md",attrs:{"id":"autocomplete-results"}},_vm._l((_vm.drugList),function(item,i){return _c('li',{key:i,staticClass:"autocomplete-result"},[_c('div',{staticClass:"p-2",on:{"click":function($event){return _vm.selectDrug(item)}}},[_vm._v(_vm._s(item.name))])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-col ml-auto p-2"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Dosage ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{staticClass:"w-16 h-8 p-2 mr-2 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":_vm.medication.dose_quantity},on:{"input":function (e) { return _vm.updateMedication(e, 'dose_quantity'); }}}),_vm._v(" "),_c('select',{staticClass:"flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"2.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"},domProps:{"value":_vm.medication.dose_unit},on:{"input":function (e) { return _vm.updateMedication(e, 'dose_unit'); }}},[_c('option',{attrs:{"value":"mg"}},[_vm._v("mg")]),_vm._v(" "),_c('option',{attrs:{"value":"ml"}},[_vm._v("ml")]),_vm._v(" "),_c('option',{attrs:{"value":"micro-g"}},[_vm._v("µg")]),_vm._v(" "),_c('option',{attrs:{"value":"g"}},[_vm._v("g")]),_vm._v(" "),_c('option',{attrs:{"value":"IU"}},[_vm._v("IU")])])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-col mt-2 p-2"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('select',{staticClass:"flex appearance-none mr-4 w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"6.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"},domProps:{"value":_vm.medication.frequency},on:{"change":function (e) { return _vm.updateMedication(e, 'frequency'); }}},[_c('option',{attrs:{"value":"once"}},[_vm._v("once")]),_vm._v(" "),_c('option',{attrs:{"value":"twice"}},[_vm._v("twice")]),_vm._v(" "),_c('option',{attrs:{"value":"thrice"}},[_vm._v("thrice")]),_vm._v(" "),_c('option',{attrs:{"value":"four times"}},[_vm._v("4 times")]),_vm._v(" "),_c('option',{attrs:{"value":"five times"}},[_vm._v("5 times")]),_vm._v(" "),_c('option',{attrs:{"value":"six times"}},[_vm._v("6 times")]),_vm._v(" "),_c('option',{attrs:{"value":"PRN/SOS"}},[_vm._v("PRN/SOS")])]),_vm._v(" "),(_vm.medication.frequency !== 'PRN/SOS')?_c('select',{key:_vm.medication.frequency,staticClass:"flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"6.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage_type"},domProps:{"value":_vm.medication.frequency_unit},on:{"change":function (e) { return _vm.updateMedication(e, 'frequency_unit'); }}},[_c('option',{attrs:{"value":"day","selected":""}},[_vm._v("day")]),_vm._v(" "),_c('option',{attrs:{"value":"week"}},[_vm._v("week")]),_vm._v(" "),_c('option',{attrs:{"value":"month"}},[_vm._v("month")])]):_c('select',{staticClass:"flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"6.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage_type_day"},domProps:{"value":_vm.medication.frequency_unit},on:{"change":function (e) { return _vm.updateMedication(e, 'frequency_unit'); }}},[_c('option',{attrs:{"value":"once a day","selected":""}},[_vm._v("once a day")]),_vm._v(" "),_c('option',{attrs:{"value":"twice a day"}},[_vm._v("twice a day")]),_vm._v(" "),_c('option',{attrs:{"value":"thrice a day"}},[_vm._v("thrice a day")])]),_vm._v(" "),(_vm.frequencyText)?_c('span',{staticClass:"flex self-center mt-auto ml-4 text-sm text-grey-light"},[_vm._v(_vm._s(_vm.frequencyText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col mt-2 p-2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.medication.duration),expression:"medication.duration"}],staticClass:"w-24 h-8 p-2 mr-4 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0","name":"drug_duration"},domProps:{"value":(_vm.medication.duration)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.medication, "duration", $event.target.value)},_vm.durationHandler]}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.medication.duration_unit),expression:"medication.duration_unit"}],staticClass:"flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"4.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.medication, "duration_unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.durationHandler]}},[_c('option',{attrs:{"value":"day"}},[_vm._v("day")]),_vm._v(" "),_c('option',{attrs:{"value":"week"}},[_vm._v("week")]),_vm._v(" "),_c('option',{attrs:{"value":"month"}},[_vm._v("month")])]),_vm._v(" "),(_vm.medication.duration && _vm.medication.duration_unit)?_c('span',{staticClass:"flex self-center mt-auto ml-4 text-sm text-grey-light"},[_vm._v(_vm._s(("for " + (_vm.medication.duration) + " " + (_vm.medication.duration_unit))))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"flex mt-2 flex-col flex-no-shrink flex-no-grow"},[_c('TextField',{key:"1",attrs:{"label":"Route","fieldId":"route","value":_vm.medication.route,"editMode":"true"},on:{"input":function (e) { return _vm.updateMedication(e, 'route'); },"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('div',{staticClass:"flex mt-2 flex-col flex-no-shrink flex-no-grow"},[_c('TextField',{key:"2",attrs:{"label":"Special Instructions","fieldId":"instructions","value":_vm.medication.instructions,"editMode":"true"},on:{"input":function (e) { return _vm.updateMedication(e, 'instructions'); },"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('div',{staticClass:"flex my-2 p-2 flex-row flex-no-shrink flex-no-grow"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.medication.is_current),expression:"medication.is_current"}],staticClass:"h-8 p-2 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"checkbox","name":"drug_duration"},domProps:{"checked":Array.isArray(_vm.medication.is_current)?_vm._i(_vm.medication.is_current,null)>-1:(_vm.medication.is_current)},on:{"change":function($event){var $$a=_vm.medication.is_current,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.medication, "is_current", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.medication, "is_current", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.medication, "is_current", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"p-2 mr-2 text-sm font-semibold text-grey-dark",staticStyle:{"text-transform":"uppercase"}},[_vm._v(" Is Current Medication")])])]),_vm._v(" "),_c('div',{staticClass:"mt-4 self-center"},[_c('span',{staticClass:"hover:shadow-md cursor-pointer my-3 py-2 px-5 border border-solid border-grey-lightest text-blue font-semibold text-center rounded self-center flex-no-shrink",on:{"click":function($event){return _vm.cancelEdit()}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.saved === false)?_c('span',{staticClass:"hover:shadow-md cursor-pointer border border-solid border-blue bg-blue my-3 py-2 px-5 ml-2 text-white font-semibold text-center rounded self-center flex-no-shrink items-end",on:{"click":function($event){return _vm.savePrescriptionDetails()}}},[_vm._v("Save")]):(_vm.saved === true)?_c('span',{staticClass:"hover:shadow-md cursor-pointer border border-solid border-blue bg-blue my-3 py-2 px-5 ml-2 text-white font-semibold text-center rounded self-center flex-no-shrink items-end",on:{"click":function($event){return _vm.savePreFilled()}}},[_vm._v("Save")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Drug "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v(" Frequency "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("Duration "),_c('span',{staticClass:"text-red text-m"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SSuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentTable_vue__ = __webpack_require__("H2Sm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90675b18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentTable_vue__ = __webpack_require__("iqkS");
function injectStyle (ssrContext) {
  __webpack_require__("kewD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90675b18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90675b18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SqJs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMzI0NDY3O30KPC9zdHlsZT4KPGcgaWQ9Ik5ldy1JY29ucyI+Cgk8ZyBpZD0ibm90aWZpY2F0aW9uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4KCQk8Zz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE3LjMsMTQuMUwxNy4zLDE0LjFjLTAuMSwwLTEuMy0wLjEtMS4zLTIuNFY2LjljMC0zLjktMy4yLTcuMS03LjEtNy4xQzUuMS0wLjEsMiwzLDIsNi45djQuOAoJCQkJYzAsMi4zLTEuMiwyLjQtMS4zLDIuNGMtMC40LDAtMC44LDAuNC0wLjgsMC44YzAsMC41LDAuNCwwLjgsMC44LDAuOGg1LjhjMC4xLDEuMywxLjEsMi4zLDIuNSwyLjNjMS4zLDAsMi40LTEuMSwyLjUtMi40aDUuOAoJCQkJYzAuNSwwLDAuOC0wLjQsMC44LTAuOEMxOC4xLDE0LjUsMTcuOCwxNC4yLDE3LjMsMTQuMXogTTksMTYuNGMtMC40LDAtMC43LTAuMi0wLjctMC42aDEuNUM5LjcsMTYuMiw5LjQsMTYuNCw5LDE2LjR6IE0zLjEsMTQuMQoJCQkJYzAuMy0wLjYsMC41LTEuMywwLjUtMi4ydi01QzMuNiw0LDYsMS41LDksMS41YzMsMCw1LjQsMi40LDUuNCw1LjR2NC44YzAsMC4yLDAsMC4zLDAsMC40YzAsMC44LDAuMiwxLjQsMC41LDJIMy4xeiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "T4dJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5iq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"chat-scroll",rawName:"v-chat-scroll"}],staticClass:"flex-1 overflow-y-auto py-2 pt-3 px-3"},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,class:'bubble ' + message.type},[(_vm.isActiveChat && message.user && message.user.type === 'doctor')?_c('div',[_c('div',{staticClass:"flex flex-no-grow flex-no-shrink justify-end mb-2"},[_c('div',{staticClass:"rounded-lg rounded-br-none bg-blue-lightest shadow-sm",staticStyle:{"max-width":"500px","word-wrap":"break-word"}},[(message.intentName === 'recommended_tests')?_c('lab-test-card',{attrs:{"data":message.payload}}):_vm._e(),_vm._v(" "),(message.intentName === 'file_prescription')?_c('drug-prescription-card',{attrs:{"data":message.payload}}):_vm._e(),_vm._v(" "),(message.intentName === 'file_attachment')?_c('div',{staticClass:"py-2 pt-3 px-3",class:{opaque: !_vm.messageStatus(message)}},[_c('div',{staticClass:"flex flex-row self-end flex-no-shrink flex-no-grow"},[(message.state === 'uploading')?_c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"relative flex flex-col justify-center items-center"},[_c('svg',{staticClass:"progress-ring",staticStyle:{"z-index":"1"},attrs:{"width":"48","height":"48"}},[_c('circle',{staticClass:"progress-ring-circle",attrs:{"stroke-dasharray":_vm.dasharray(),"stroke-dashoffset":_vm.dashoffset(message.progress),"stroke":"green","stroke-width":"3","fill":"transparent","r":"17","cx":"24","cy":"24","stroke-linecap":"round"}})]),_vm._v(" "),_c('svg',{staticStyle:{"z-index":"0","position":"absolute"},attrs:{"width":"48","height":"48"}},[_c('circle',{attrs:{"width":"48","height":"48","stroke":"white","stroke-width":"3","fill":"transparent","r":"17","cx":"24","cy":"24"}})])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col self-center"},[_c('div',{staticClass:"text-xs mx-2 font-semibold text-green-dark",staticStyle:{"margin-bottom":"2px"}},[_vm._v("Uploading... "+_vm._s(message.progress)+" %")]),_vm._v(" "),_c('div',{staticClass:"text-xs mx-2 text-grey-darkest"},[_vm._v(_vm._s(message.payload.file_name)+" ")])])]):(message.state === 'preparing')?_c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"flex flex-col justify-center items-center"},[_c('svg',{staticClass:"flex flex-col w-12 h-12 self-center"},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(5 6)","stroke-width":"3"}},[_c('circle',{attrs:{"stroke-opacity":"","cx":"18","cy":"18","r":"18","stroke":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M36 18c0-9.94-8.06-18-18-18","stroke-linecap":"round","stroke":"blue"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 18 18","to":"360 18 18","dur":"1s","repeatCount":"indefinite"}})],1)])])]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"flex flex-col self-center"},[_c('div',{staticClass:"text-xs mx-2 font-semibold text-grey-darker",staticStyle:{"color":"blue","margin-bottom":"2px"}},[_vm._v("Preparing Upload")]),_vm._v(" "),_c('div',{staticClass:"text-xs mx-2 text-grey-darkest"},[_vm._v(_vm._s(message.payload.file_name))])])]):(message.state === 'reload')?_c('div',{staticClass:"h-auto flex flex-row self-end rounded-lg rounded-br-none"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"flex flex-col self-center"},[_c('div',{staticClass:"text-xs mx-2 font-semibold",staticStyle:{"margin-bottom":"2px","color":"#0000ff"}},[_vm._v("Retry Upload ")]),_vm._v(" "),_c('div',{staticClass:"text-xs mx-2 text-grey-darkest"},[_vm._v(_vm._s(message.payload.file_name))])])]):_c('div',{staticClass:"flex flex-row justify-center items-center"},[_c('img',{staticClass:"w-5 h-5 mr-1",attrs:{"src":__webpack_require__("IjEF")}}),_vm._v(" "),_c('a',{staticClass:"text-m text-grey-darkest cursor-pointer",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.getDocument('medical_records', message.payload.id)}}},[_vm._v("\n                  "+_vm._s(message.payload.file_name)+"\n                ")])])])]):(message.intentName === 'incoming_text')?_c('div',{staticClass:"text-m text-grey-darkest py-2 pt-3 px-3",class:{opaque: !_vm.messageStatus(message)},staticStyle:{"line-height":"22px"}},[_vm._v("\n            "+_vm._s(message.payload.text)+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-no-grow h-6 justify-end pb-2 px-3"},[_c('div',{staticClass:"text-xs text-grey pr-1 self-center"},[_vm._v(_vm._s(message.timestamp ? _vm.timeString(message.timestamp) : _vm.timeString(message.uniqueId)))]),_vm._v(" "),(message.status === 'read')?_c('span',{staticClass:"flex self-center"},[_c('img',{attrs:{"src":"https://res.cloudinary.com/ekincare/image/upload/v1536866423/talk_with_doc/double_tick_blue.svg","width":"15px","height":"25px"}})]):(message.status === 'delivered')?_c('span',{staticClass:"flex self-center"},[_c('img',{attrs:{"src":"https://res.cloudinary.com/ekincare/image/upload/v1536866451/talk_with_doc/double_tick.svg","width":"25px","height":"25px"}})]):(_vm.isMsgSent(message))?_c('span',{staticClass:"flex self-center"},[_c('img',{attrs:{"src":"https://res.cloudinary.com/ekincare/image/upload/v1536866423/talk_with_doc/single_tick.svg","width":"15px","height":"15px"}})]):(!_vm.isMsgSent(message))?_c('span',{staticClass:"flex self-center text-red"},[_c('button',{staticClass:"hover:bg-grey-lightest bg-white text-green font-semibold py-2 px-4 rounded",on:{"click":function($event){return _vm.resendMessage(message)}}},[_vm._v("\n                Resend\n              ")]),_vm._v(" "),_c('button',{staticClass:"hover:bg-grey-lightest bg-white text-red font-semibold py-2 px-4 rounded",on:{"click":function($event){return _vm.deleteMessage(message)}}},[_vm._v("\n                Delete\n              ")])]):_vm._e()])],1)])]):_vm._e(),_vm._v(" "),(_vm.isActivePastChat && message.user && message.user.type === 'doctor')?_c('div',[_c('div',{staticClass:"flex justify-end mb-2"},[_c('div',{staticClass:"rounded-lg rounded-br-none bg-blue-lightest py-2 pt-3 px-3 shadow-sm",staticStyle:{"max-width":"500px","word-wrap":"break-word"}},[(message.intentName === 'recommended_tests')?_c('lab-test-card',{attrs:{"data":message.payload}}):_vm._e(),_vm._v(" "),(message.intentName === 'file_prescription')?_c('drug-prescription-card',{attrs:{"data":message.payload}}):_vm._e(),_vm._v(" "),(message.intentName === 'file_attachment')?_c('div',{staticClass:"flex flex-row justify-center items-center ",class:{opaque: !_vm.messageStatus(message)}},[_c('img',{staticClass:"w-5 h-5 mr-1",attrs:{"src":__webpack_require__("IjEF")}}),_vm._v(" "),_c('a',{staticClass:"text-m test-grey-darkest cursor-pointer",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.getDocument('medical_records', message.payload.id)}}},[_vm._v("\n              "+_vm._s(message.payload.file_name)+"\n            ")])]):(message.intentName === 'incoming_text')?_c('p',{staticClass:"text-m text-grey-darkest",staticStyle:{"line-height":"22px"}},[_vm._v("\n            "+_vm._s(message.payload.text)+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-right text-xs text-grey mt-2"},[_vm._v("\n            "+_vm._s(message.timestamp ? _vm.timeString(message.timestamp) : _vm.timeString(message.uniqueId))+"\n          ")])],1)])]):_vm._e(),_vm._v(" "),(message.user && message.user.type === 'customer')?_c('div',[_c('div',{staticClass:"flex mb-2"},[_c('div',{staticClass:"rounded-lg rounded-bl-none py-2 pt-3 px-3 bg-white shadow-sm",staticStyle:{"max-width":"500px","word-wrap":"break-word"}},[(message.intentName === 'file_customer')?_c('div',{staticClass:"flex flex-row items-center justify-center"},[_c('img',{staticClass:"w-5 mr-1",attrs:{"src":__webpack_require__("IjEF")}}),_vm._v(" "),_c('a',{staticClass:"text-m text-grey-darkest cursor-pointer self-center",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.getDocument('medical_records', message.payload.id)}}},[_vm._v("\n              "+_vm._s(message.payload.file_name)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-m text-grey-darkest",staticStyle:{"line-height":"22px"}},[_vm._v("\n            "+_vm._s(message.payload.text)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"text-right text-xs text-grey mt-2"},[_vm._v("\n            "+_vm._s(message.timestamp ? _vm.timeString(message.timestamp) : _vm.timeString(message.uniqueId))+"\n          ")])])])]):_vm._e()])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-6 h-6 cursor-pointer self-center",staticStyle:{"position":"absolute","z-index":"2"}},[_c('img',{attrs:{"src":__webpack_require__("JA1j")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center items-center"},[_c('div',{staticClass:"h-12 flex flex-col justify-center px-1 cursor-pointer"},[_c('img',{staticClass:"w-10",attrs:{"src":__webpack_require__("rId7")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TA6h":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIHN0cm9rZT0iI0E0QjBDQyIgc3Ryb2tlLXdpZHRoPSIxLjMzMzMzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "TO6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data', 'selectedPatient'],
  data: function data() {
    return {
      activeSection: 'request'
    };
  },

  computed: {},
  methods: {
    setActiveSection: function setActiveSection(section) {
      this.activeSection = section;
      this.$emit('tabChange', this.activeSection);
    },
    selectFromList: function selectFromList(item) {
      this.$emit('selectFromList', item);
    }
  }
});

/***/ }),

/***/ "TPlb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-row h-10 bg-white flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm"},[_vm._v("Forms")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TX5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("318Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("tjrC");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    elementId: {
      type: String,
      default: 'temp'
    },
    type: {
      type: String,
      default: 'is-dark'
    },
    message: String,
    duration: Number,
    queue: {
      type: Boolean,
      default: undefined
    },
    position: {
      type: String,
      default: 'is-top',
      validator: function validator(value) {
        return ['is-top-right', 'is-top', 'is-top-left', 'is-bottom-right', 'is-bottom', 'is-bottom-left'].indexOf(value) > -1;
      }
    },
    container: String
  },
  data: function data() {
    return {
      isActive: false,
      parentTop: null,
      parentBottom: null,
      newContainer: this.container || __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].defaultContainerElement
    };
  },

  computed: {
    correctParent: function correctParent() {
      switch (this.position) {
        case 'is-top-right':
        case 'is-top':
        case 'is-top-left':
          return this.parentTop;

        case 'is-bottom-right':
        case 'is-bottom':
        case 'is-bottom-left':
          return this.parentBottom;
      }
    },
    transition: function transition() {
      switch (this.position) {
        case 'is-top-right':
        case 'is-top':
        case 'is-top-left':
          return {
            enter: 'fadeInDown',
            leave: 'fadeOut'
          };
        case 'is-bottom-right':
        case 'is-bottom':
        case 'is-bottom-left':
          return {
            enter: 'fadeInUp',
            leave: 'fadeOut'
          };
      }
    }
  },
  methods: {
    shouldQueue: function shouldQueue() {
      var queue = this.queue !== undefined ? this.queue : __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].defaultNoticeQueue;

      if (!queue) return false;

      return this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0;
    },
    removeSnackbarWithSameId: function removeSnackbarWithSameId() {
      var el = document.getElementById(this.elementId);
      if (el) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* removeElement */])(el);
      }
    },
    close: function close() {
      var _this = this;

      clearTimeout(this.timer);
      this.isActive = false;

      // Timeout for the animation complete before destroying
      setTimeout(function () {
        _this.$destroy();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* removeElement */])(_this.$el);
      }, 150);
    },
    showNotice: function showNotice() {
      var _this2 = this;

      if (this.shouldQueue()) {
        // Call recursively if should queue
        setTimeout(function () {
          return _this2.showNotice();
        }, 250);
        return;
      }
      this.removeSnackbarWithSameId();
      this.correctParent.insertAdjacentElement('afterbegin', this.$el);
      this.isActive = true;

      if (!this.indefinite) {
        this.timer = setTimeout(function () {
          return _this2.close();
        }, this.newDuration);
      }
    },
    setupContainer: function setupContainer() {
      this.parentTop = document.querySelector('.notices.is-top');
      this.parentBottom = document.querySelector('.notices.is-bottom');

      if (this.parentTop && this.parentBottom) return;

      if (!this.parentTop) {
        this.parentTop = document.createElement('div');
        this.parentTop.className = 'notices is-top';
      }

      if (!this.parentBottom) {
        this.parentBottom = document.createElement('div');
        this.parentBottom.className = 'notices is-bottom';
      }

      var container = document.querySelector(this.newContainer) || document.body;

      container.appendChild(this.parentTop);
      container.appendChild(this.parentBottom);

      if (this.newContainer) {
        this.parentTop.classList.add('has-custom-container');
        this.parentBottom.classList.add('has-custom-container');
      }
    }
  },
  beforeMount: function beforeMount() {
    this.setupContainer();
  },
  mounted: function mounted() {
    this.showNotice();
  }
});

/***/ }),

/***/ "Tb1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    notifications: 'notification/getNotifications',
    requests: 'consultationRequest/getRequests'
  })),
  methods: {
    onNotificationClick: function onNotificationClick(n) {
      this.$store.dispatch('notification/UpdateRead', n.id);
      if (n.title === 'Appointments Scheduled for Today') {
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments');
        this.$store.dispatch('appointmentRequest/updateActiveTab', 'scheduled');
      } else if (n.title === 'Appointment Requested') {
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments');
        this.$store.dispatch('appointmentRequest/updateActiveTab', 'requested');
      } else if (n.title === 'Appointment Scheduled') {
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments');
        this.$store.dispatch('appointmentRequest/updateActiveTab', 'scheduled');
      }
    },
    requiredAction: function requiredAction(n) {
      if (n.required_action === 'Respond Back') {
        var req = this.requests.find(function (ele) {
          return ele.consultationRequestId === n.request_id;
        });
        if (req) this.acceptQuery(req);
        this.$emit('enquireNow');
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Chat');
      } else if (n.required_action === 'Enquire Now') {
        this.$emit('enquireNow');
        this.$store.dispatch('configuration/setActiveMiniMenu', 'OfflineConsults');
        this.$store.dispatch('configuration/setOfflineActiveSection', 'connected');
        this.$store.dispatch('offlineConsultation/addEnquireNowConsult', n);
      }
    },
    acceptQuery: function acceptQuery(request) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', request);
    }
  }
});

/***/ }),

/***/ "Tlky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"p-2 relative bg-white rounded-sm border border-solid border-grey-lightest \n  text-base text-grey-darkest focus:border-blue",staticStyle:{"width":"100%"},attrs:{"type":"search","placeholder":"Search doctors.."},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value},_vm.searchDoctors]}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow"}),_vm._v(" "),(_vm.doctorList.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No Doctors")])]):_c('div',{staticClass:"flex flex-col overflow-y-auto",staticStyle:{"height":"calc(100vh - 8.5rem)"}},_vm._l((_vm.doctorList),function(doctor,index){return _c('div',{key:index,staticClass:"flex flex-col h-12 pl-3 pr-3 justify-center pt-3 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight",class:{doctorActive : (doctor.id === _vm.selectedDoctor)},on:{"click":function($event){return _vm.selectDoctor(doctor)}}},[_c('div',{staticClass:"flex flex-row mb-2 items-center"},[_c('div',{staticClass:"text-sm font-semibold self-center capitalize"},[_vm._v(_vm._s(doctor.name))])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TmLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("QY/O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_633e6810_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("HyPL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_633e6810_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ToFN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAJTElEQVR4nO2ca2wcVxXH/+fOep2Xi7FU4bWd7Dp2QtGm5AMVgopQQhKoaREgGlQJAR+SNhUoKOERJ2uFLmq8JpHAhYiWRI1UQAVEVFAFqqEBpzxEK/gCNAukee0m9tqhImqTOInXO3P4YM96ZvY1472zazv3J620cx/n3j3/mXMfM7OAQqFQKBQKhUKhuN0gvxvoio2v02FsB2MzCBEAy/1u0xv8zVSiPV6v1n0TIBpPBm9kmwcZ9BgA4Vc7cqifCL4IEI0ngxOTzUMg+rAf9v2hPiL4cmbeyDYPLiznAwA9HomNxmveqmyDMzH/7wA02bZrQ22vBOlXgM7GI1iwzgemr4Sxb9WqNfkhiLBZus2aw721CkfSBWBglWyb9aE2V4L0MSASy3C5/FSizfe1Rzkq9a8QOphKhPb605t5Pz+fD3Cvn1eCEsAV/omgBHCNPyIoATwhXwQlgGfkiqAEmBPyRFACzBk5IigBqqJ6EZQAVVOdCEoAKcxdBCWANOYmghJAKtzrtYYSoM4oAeqMEqDOBOrdgVpT7f0I7/cTyqOugDqjBKgzSoA64zkert4/freRM7YD2DQ/n/WsL17HGNeDcPfOM425puWDhm7sAKkrRxauBJhx/hCAjT7357bD1Zmca1r+JJTzfaGiAKv3j98N4NEa9OW2pKIAMwOuivk+Udmxi+JZz/lLRQEWz7Oe85OKAhCwwpNFxmsAdhkarbuZFStuZsUKQ6N1AHYxcMqDpZtgPMls3Cv0Jc2pM6EAC7EaxJ9k4l8DKLonYxhaVyrRRuYH4J+X6eyz1rKGoXV5+akykLkZNwmm3anG1iOIk+HISwJIIs6Hw1PjjxHzIIBgGVtjhkZbLj4RSloT08AFTH9eiMRGHwboh047gvQtAI7kE5iGQfhMsUaIabhI3Zoia3CdZFBPaiD0dBHnzxInI90feoqF6AGQLVWMCA87ne8klWj/GTH1Falrc6KAcbKUjSmh2wRw1q0FcgQg7EonQiV/qJP0gdZhBn2leC6/eqG/7Y/mUTSeDEb6xg5GYpnhcGz0UPfOM41m3rLGK98DKGOrDWzEVs6/oXN+oON1BkaKNHR6pH/laP5oK2sM1Py9tuoFYLyWaggdtSZ17xnpCMcyxyOxzNWZzy9W7xtZay2TPtP6AzAKznJi+ov1+Ea2pRfMewBsJNDXc03Ldpl5yXg0C/CvHCZaOteOv8dmExhGIba0SPflewC8vdxPrQQD173WqV4AwjFr2OneM9KRC4h/EPAQgKaZz6cMEq907xnpyNc7TjoIx5zmmPia9dgA22ZhBNrgaP8/ThsGsz2UOGI9UBj/CUZV4YeB6xqhx2u9qgdhg+mE9XgqIAYJaClStCUXEN8BZgdEDeKEDvuQwaB2ezX6CcBfANAwnY8HbHelisyFiLEZQH++HWEM62zbpDSy0G0hk6uI/6bzz/e3/dlr3aqvgKV64JL1mICPliluywvktLSzAAE91hieToROMugTAC45y5aEcO87vjae3yY/199+iUFnLSX+OTrQ8T/z4J173mgC8H7X9i1U43xAggCnD915zZHUVKb4HZFYhs3PZGDqapEy7Z1rxm0DdDoRGgpcm1jDzNsBnHHRreCSIH/QmkDgfMghtsf/KU2/DzNXmBeqdT4wT/d4GDzQ2ZexbQCePbxmMj3QfgzByXeD6BAAvZwNgmMcoFkBDNDvrVnGHOK/DOcD81QAABozjkT6MkNdey91WzNS8c5bqf5QL4g/jTJrCYY9pmsN2snpZEwt0QN/shX2GP9lOR+YvwJMw7g/J7R/h/syPyoQor/9BSbsK1WVgGg49kbIPD4Xb/0vGKcA/M0aNrv6RlcCeJf7LslzPiBBgJkBzIpzTLDylnXvpTHXcEcl+wQEiPE5XWj/isQyNoenXw99F0DBQG5WFTzl3Mk9yWSP/7rhfrdXtvMBCQLc1HIrHUknihYEQMDvrMe5gB52lmHgGQBHARxlwo8tWQ0AEp2xsc/nU46TDsYvS7VnCEdoETxcuCYgV+HHD+cDEgQQZB/sBBv7AFwpUvQKCd12ButFB7+Gb6QSbTtSibYd1DD5KIBJay6D7dNcgQul+kZMm4DZBYDILX2ZgrdeyReIs3Bzv8Mv5wMSBGBgu3PvJZAz1gM4DuAqgKsEPC+E/r7zB1bOTiG3sgbGNqc9MqbWm99T8c5bAL1ka8+xfUFMbyvTu7au2OVovm8HW96atjlN+FZmPYA7K/w+35wPSFgJE7AuvHZ8Rxp4ykw7e6hjBCi+BWzSuSbzRQZFneks8FkAv5m1Lx5h0g+CcRcIJxuuTXzbVh68wWnDik7GZpS4D1Fp99Nv5wMuHsxy+TBqloXoSR9oLbbpVcCq2MgmAfEiitwTYCBHJDak+ltfrWRndV/mHoPxV5T7HYQXU/1tDxTLCu/LnKASIagWzgfkTUODZBhD4djYl6zhqICtrHXGRneWcj4wPesB8/OdfWPvLddgZF/mLoNxHJVOIsZ90XiyoK2O3ZeWEuEDxavUxvmAvCtgFkYShGMaxIklQZECgFtZI6LD2ALGNhAKwk4JsiD8lJifI51OixsTl6eamlsET3Uz8BAI2+D2sUimD6UGQn+wJnXuzXyEBX5b2P3aOR9wIUA4lrnm+b7wwmUCgh5MHQi97Kbw9L9qiSXV/J+Qm5vyF+dqfCHBwHVBuN+b8+nxWrwnXHJhtYiYIEEfdxt2Zp1v4uN7whrEM6iw87iQmfuZX2DJn/eEzyVaTxH4SKVyCxGvA25p5+ctehbB1TR0WfDN3WB2NcdfKMh3ft6yJxFcCZCMR7PLG9/sIfD3sQjCkX/Oz7fgWgTPryit2j8WFTpvm7nhEVloU1T/nW+l8l9e3nb/G+qF6pxvUl6E+X1HrI7IcT5QKRwpAYogz/kmpUVQAjiQ73yT4iIoASz453yTQhGUADP473wTuwhKANTS+SazItx2f1fjpPbON+HeSGzMl3XAVZR/PrSmyF53yF7n+BGC3D/FrPBBAMZLlQspTKQLYARoUd8/kI10AS4+EUoy09Oy7S5WfJmGrmi88lVyPIOvKI4vAiTj0eyy4JWPMegwVDgqi28LsWQ8mk0nQl82NFoPYJCBU3N5jXOx4/tCbOaN9xIvZSvUVkSdUQLUGSVAnVEC1BklQJ1RAtQZJUCd+T/kqa0E4Jwx8QAAAABJRU5ErkJggg=="

/***/ }),

/***/ "TpOy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "TrYx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "U1SN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center"},[_vm._m(0),_vm._v(" "),(_vm.showBackUpCodes)?_c('div',{staticClass:"w-1/2 flex flex-col h-screen justify-center items-center"},[_c('div',{staticClass:"w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('label',{staticClass:"block text-grey-darker text-xl font-semibold mb-2"},[_vm._v("\n        Multi-Factor Authentication\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-lg text-grey-dark mt-2 leading-normal font-semibold"},[_vm._v("Back-up Codes")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark my-6"},[_vm._v("keep this backup codes safe incase you lose access to the authenticator app")]),_vm._v(" "),_c('div',{staticClass:"ml-8 bg-grey-lightest rounded-m w-3/4 shadow-inner hover:shadow-sm p-6"},[_c('p',{staticClass:"float-right w-max text-sm cursor-pointer hover:underline font-semibold text-grey-dark",on:{"click":_vm.copyCodesToClip}},[_vm._v(_vm._s(_vm.copyCodes))]),_vm._v(" "),_c('div',{staticClass:"grid-container text-grey-darker ml-8 mt-2"},_vm._l((_vm.backUpCodes),function(item){return _c('div',{key:item,staticClass:"mt-4 grid-item"},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mt-8 mb-4"},[_vm._v("Multi-factor authentication has been set-up successfully")]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",on:{"click":_vm.goBackToLogin}},[_vm._v("\n            Login\n          ")])])])]):_c('div',{staticClass:"w-1/2 flex flex-col h-screen justify-center items-center"},[(_vm.enableViaAuthApp)?_c('div',{staticClass:"w-2/3 flex flex-col h-screen justify-center items-center"},[_c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Back\n        ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"ml-10 mt-4 mb-8"},[(_vm.showQR)?_c('div',[_c('img',{staticStyle:{"height":"184px","width":"184px","margin-left":"108px"},attrs:{"src":_vm.qrCode,"alt":"qr_code"}})]):_c('div',[_c('p',{staticClass:"mt-6 ml-6 text-grey-dark tracking-widest text-lg font-semibold uppercase"},[_vm._v(_vm._s(_vm.altCode))])])]),_vm._v(" "),_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mt-4 mb-2 uppercase tracking-widest"},[_vm._v("\n          Verification Code\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp_code),expression:"otp_code"}],staticClass:"shadow appearance-none border rounded w-1/2 py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"otp","type":"text","placeholder":"Code","value":"","maxlength":"10","has-counter":false},domProps:{"value":(_vm.otp_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otp_code=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.configMfaSettings}},[_vm._v("\n            Connect\n          ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.showMfaQr}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.showQRText))])])])])]):(_vm.enableViaOtp)?_c('div',{staticClass:"w-2/3 flex flex-col h-screen justify-center items-center"},[_c('div',{staticClass:"bg-white shadow-md rounded px-16 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Back\n        ")]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n            Enter OTP\n          ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-dark mb-8"},[_vm._v("OTP has been sent to your registered e-mail")]),_vm._v(" "),_c('label',{staticClass:"block text-grey-darker text-sm font-semibold mb-2"},[_vm._v("\n            OTP\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp_code),expression:"otp_code"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"otp","type":"text","placeholder":"Code","value":"","maxlength":"10","has-counter":false},domProps:{"value":(_vm.otp_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otp_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"},on:{"click":_vm.configMfaSettings}},[_vm._v("\n            Submit\n          ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.resendOTP}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Resend OTP")])])])])]):_c('div',{staticClass:"w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n          Register a Verification Method\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark"},[_c('div',{staticClass:"border mb-3 rounded-m w-3/4 p-3 cursor-pointer hover:bg-blue-lightest",on:{"click":_vm.viaAuthenticatorApp}},[_c('h3',{staticClass:"text-base"},[_vm._v("Authenticator App")]),_vm._v(" "),_c('p',{staticClass:"text-sm mt-1"},[_vm._v("Connect an authenticator app")])]),_vm._v(" "),_c('div',{staticClass:"border rounded-m p-3 w-3/4 cursor-pointer hover:bg-blue-lightest",on:{"click":_vm.viaOtp}},[_c('h3',{staticClass:"text-base"},[_vm._v("One Time Password Generator")]),_vm._v(" "),_c('p',{staticClass:"text-sm mt-1"},[_vm._v("Receive OTP on your registered e-mail")])])])]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",on:{"click":_vm.goBackToLogin}},[_vm._v("\n          Cancel\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-1/2 flex h-screen bg-blue justify-center items-center"},[_c('h1',{staticClass:"text-3xl font-semibold text-blue-lightest"},[_vm._v(" Doctor Dashboard ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-4"},[_vm._v("\n            Connect an Authenticator App\n          ")]),_vm._v(" "),_c('p',{staticClass:"mb-4 text-grey-dark"},[_vm._v("\n            Connect an authenticator app that generates verification codes. You can use the codes when we need to verify your identity.\n          ")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark mx-3 text-base"},[_c('ol',{staticClass:"order-list"},[_c('li',[_vm._v("Download and install an authenticator app on your mobile device.")]),_vm._v(" "),_c('li',[_vm._v("Use the app to scan this QR code.")]),_vm._v(" "),_c('li',[_vm._v("Enter the code generated by the app.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U22S":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4yNDUgMTAuMjQ1QzkuMTUgMTEuMzI1IDcuNjUgMTIgNiAxMkM0LjM1IDEyIDIuODUgMTEuMzI1IDEuNzU1IDEwLjI0NUMwLjY3NSA5LjE1IDAgNy42NSAwIDZDMCAyLjY4NSAyLjY4NSAwIDYgMEM3LjY1IDAgOS4xNSAwLjY3NTAwMSAxMC4yNDUgMS43NTVDMTEuMzI1IDIuODUgMTIgNC4zNSAxMiA2QzEyIDcuNjUgMTEuMzI1IDkuMTUgMTAuMjQ1IDEwLjI0NVpNNi41OTk4OCAyLjkzOTk5QzYuNTk5ODggMi42MDk5OSA2LjMyOTg4IDIuMzQgNS45OTk4OCAyLjM0QzUuNjY5ODggMi4zNCA1LjM5OTg4IDIuNjA5OTkgNS4zOTk4OCAyLjkzOTk5VjcuMDJDNS4zOTk4OCA3LjM1IDUuNjY5ODggNy42MiA1Ljk5OTg4IDcuNjJDNi4zMjk4OCA3LjYyIDYuNTk5ODggNy4zNSA2LjU5OTg4IDcuMDJWMi45Mzk5OVpNNS45OTk4OCA4LjM0QzYuMzI5ODggOC4zNCA2LjU5OTg4IDguNjEgNi41OTk4OCA4Ljk0VjkuMDZDNi41OTk4OCA5LjM5IDYuMzI5ODggOS42NiA1Ljk5OTg4IDkuNjZDNS42Njk4OCA5LjY2IDUuMzk5ODggOS4zOSA1LjM5OTg4IDkuMDZWOC45NEM1LjM5OTg4IDguNjEgNS42Njk4OCA4LjM0IDUuOTk5ODggOC4zNFoiIGZpbGw9IiNDODAwMTAiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "U2SJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      doctorList: [],
      isLoading: false,
      selectedDoctor: null,
      search: ''
    };
  },

  created: function created() {},
  mounted: function mounted() {
    this.loadDoctors();
  },
  methods: {
    loadDoctors: function loadDoctors() {
      var _this = this;

      this.isLoading = true;
      this.$http.get(window.API_URL + 'doctors/doctors_list').then(function (response) {
        if (response.status === 200) {
          _this.doctorList = response.body;
          _this.isLoading = false;
        } else {
          _this.isLoading = false;
        }
      }, function (response) {});
    },
    searchDoctors: function searchDoctors() {
      var search = this.search;
      if (search.length > 0) {
        this.doctorList = this.doctorList.filter(function (obj) {
          if (obj.email.includes(search) || obj.name.includes(search)) {
            return obj;
          }
        });
      } else {
        this.loadDoctors();
      }
    },
    selectDoctor: function selectDoctor(doctor) {
      this.$emit('getDoctor', doctor);
    }
  }
});

/***/ }),

/***/ "UjkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.requestedAppointments),function(dates,date){return _c('div',{key:date},[_c('details',{staticClass:"flex flex-col border-solid border-b border-grey-lightest details"},[_c('summary',{staticClass:"flex flex-row text-grey-extradark h-12 px-4 cursor-pointer summary"},[_c('div',{staticClass:"text-xs self-center mx-5 pointer-none"},[_vm._v(_vm._s(date ? date : '-'))]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mx-auto items-baseline self-center"},[_c('div',{staticClass:"-ml-24 text-xs "},[_vm._v("APPOINTMENTS")]),_vm._v(" "),_c('div',{staticClass:"text-xs font-semibold"},[_vm._v("  "+_vm._s(Object.keys(dates).reduce(function (total, date) { return total += dates[date].length; }, 0)))])])]),_vm._v(" "),_vm._l((dates),function(timeRanges,range){return _c('div',{key:range},[_c('details',{staticClass:"flex flex-col border-solid border-b border-grey-lightest sub-details"},[_c('summary',{staticClass:"flex flex-row h-10 px-4 text-grey-darker cursor-pointer bg-grey-lightest sub-summary"},[_c('div',{staticClass:"text-xs self-center mx-5 pointer-none"},[_vm._v(_vm._s(range))]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-baseline self-center"},[_c('div',{staticClass:"ml-24 text-xs "},[_vm._v("APPOINTMENTS")]),_vm._v(" "),_c('div',{staticClass:"text-xs font-semibold"},[_vm._v("  "+_vm._s(timeRanges.length))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-baseline self-center"},[_c('div',{staticClass:"ml-24 text-xs "},[_vm._v("Self Assigned")]),_vm._v(" "),_c('div',{staticClass:"text-xs font-semibold"},[_vm._v(" ("+_vm._s(_vm.getSelfAssignedCount(timeRanges).selfAssigned)+")")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row items-baseline self-center"},[_c('div',{staticClass:"ml-24 text-xs "},[_vm._v("Un Assigned")]),_vm._v(" "),_c('div',{staticClass:"text-xs font-semibold"},[_vm._v(" ("+_vm._s(_vm.getSelfAssignedCount(timeRanges).unAssigned)+")")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_vm._m(0,true),_vm._v(" "),_vm._l((timeRanges),function(appt){return _c('div',{key:appt.id,staticClass:"grid_container"},[_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.date_of_appointment ? appt.date_of_appointment : '-'))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.ek_id))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.email))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.name))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.mobile_number))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.program ? appt.program : 'NA'))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(appt.status))]),_vm._v(" "),_c('div',{staticClass:"item flex flex-row"},[_c('i',{staticClass:"fas fa-eye text-blue cursor-pointer",attrs:{"id":"remark_preview_icon"}},[_c('div',{staticClass:"relative",attrs:{"id":"remark_preview"}},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-2 rounded overflow-y-auto",staticStyle:{"width":"300px"}},[(!appt.comments)?_c('div',{staticClass:"text-black text-xs font-sans leading-tight",staticStyle:{"word-break":"break-all"},attrs:{"id":"remark_preview_text"}},[_vm._v("No Remarks Added")]):_c('div',{staticClass:"text-black text-xs font-sans leading-tight",staticStyle:{"word-break":"break-all"},attrs:{"id":"remark_preview_text"}},[_vm._v(_vm._s(appt.comments))])])])]),_vm._v(" "),_c('span',[_vm._v("    ")]),_vm._v(" "),_c('i',{staticClass:"far fa-edit text-blue cursor-pointer",attrs:{"id":("remark_edit_icon" + (appt.id))},on:{"click":function($event){return _vm.showRemarkEdit(appt.id)}}},[_c('div',{staticClass:"relative",staticStyle:{"display":"none"},attrs:{"id":("remark_edit" + (appt.id))}},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-3 rounded overflow-y-auto",staticStyle:{"width":"300px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(appt.comments),expression:"appt.comments"}],staticClass:"rounded-sm text-black text-xs font-sans leading-tight outline-none py-2 px-2",staticStyle:{"word-break":"break-all","width":"auto"},attrs:{"type":"text","id":("remark_input_" + (appt.id)),"name":"remark_input","placeholder":"Enter your remark here"},domProps:{"value":(appt.comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(appt, "comments", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-end mt-3 font-sans text-xs"},[_c('div',{staticClass:"mx-3 cursor-pointer",on:{"click":function($event){return _vm.remarkChanged(appt.id)}}},[_vm._v("Save")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.hideRemarkEdit(appt.id)}}},[_vm._v("Cancel")])])])])])]),_vm._v(" "),_c('div',{staticClass:"item flex justify-start"},[(appt.status === 'scheduled' && appt.doctor.id !== _vm.current_doctor_id)?_c('p',{staticClass:"text-center text-green font-semibold"},[_vm._v(_vm._s(appt.doctor.name)+" has self assigned")]):_vm._e(),_vm._v(" "),(appt.status !== 'scheduled' || appt.doctor.id === _vm.current_doctor_id)?_c('button',{staticClass:"flex-no-shrink hover:shadow-md flex-no-grow px-3 text-white rounded-sm j text-center py-1 items-center",class:[(appt.status === 'scheduled' && appt.doctor.id === _vm.current_doctor_id) ? 'bg-red' : 'bg-blue'],on:{"click":function($event){return _vm.selfAssign(appt.id, appt.date_of_appointment, appt.doctor.id, appt.status)}}},[_vm._v("\n                  "+_vm._s((appt.status === 'scheduled' && appt.doctor.id === _vm.current_doctor_id) ? 'Unassign' : 'Self Assign')+"\n               ")]):_vm._e()])])})],2)])])})],2)])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid_container bg-grey-extralight text-grey-dark"},[_c('div',{staticClass:"item_header"},[_vm._v("Apt. Time")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Patient ID")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Patient Email")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Patient Name")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Mobile Number")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Program Name")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Remarks")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Actions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighter"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighter"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Um5v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V0vx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VCj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VZIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"antialiased",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vo6z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WC7W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WdZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavedDrug_vue__ = __webpack_require__("82PI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ca227a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavedDrug_vue__ = __webpack_require__("uOOq");
function injectStyle (ssrContext) {
  __webpack_require__("ouuo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09ca227a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavedDrug_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ca227a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavedDrug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WhZd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doctor.f7b8534.svg";

/***/ }),

/***/ "X10z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XC34":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/enquire.4ba420b.svg";

/***/ }),

/***/ "XI+S":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNzRfMTIwMCkiPgo8cGF0aCBkPSJNMTQuNjY2NiA3LjM4NjI1VjcuOTk5NThDMTQuNjY1OCA5LjQzNzIgMTQuMjAwMyAxMC44MzYgMTMuMzM5NSAxMS45ODc1QzEyLjQ3ODcgMTMuMTM4OSAxMS4yNjg4IDEzLjk4MTIgOS44OTAxNiAxNC4zODg5QzguNTExNTQgMTQuNzk2NSA3LjAzODA5IDE0Ljc0NzUgNS42ODk1NyAxNC4yNDkzQzQuMzQxMDQgMTMuNzUxMSAzLjE4OTY5IDEyLjgzMDMgMi40MDcyMyAxMS42MjQzQzEuNjI0NzYgMTAuNDE4MyAxLjI1MzExIDguOTkxNjMgMS4zNDc3IDcuNTU3MTNDMS40NDIyOSA2LjEyMjYzIDEuOTk4MDYgNC43NTcxNCAyLjkzMjExIDMuNjY0M0MzLjg2NjE1IDIuNTcxNDYgNS4xMjg0NCAxLjgwOTg0IDYuNTMwNzEgMS40OTMwMUM3LjkzMjk4IDEuMTc2MTkgOS40MDAxIDEuMzIxMTQgMTAuNzEzMyAxLjkwNjI1IiBzdHJva2U9IiNBNEIwQ0MiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC42NjY3IDIuNjY2OTlMOCA5LjM0MDMzTDYgNy4zNDAzMyIgc3Ryb2tlPSIjQTRCMENDIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEyNzRfMTIwMCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ "Xdl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhrasesMain_vue__ = __webpack_require__("ODi0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef351d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhrasesMain_vue__ = __webpack_require__("bPmL");
function injectStyle (ssrContext) {
  __webpack_require__("P5o5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhrasesMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef351d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhrasesMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XemJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center w-full h-screen"},[_c('div',{staticClass:"w-3/5 flex h-screen bg-blue justify-center items-center"},[_c('div',{staticClass:"w-full h-full overflow-hidden bg-blue-800 pt-12 pl-24 text-white",style:({
      background: ("url(" + _vm.loginPattern1 + ") no-repeat top right, url(" + _vm.loginPattern2 + ") no-repeat bottom left"),
      backgroundColor: '#03318C',
    })},[_c('h1',{staticClass:"text-4xl font-fig-bold font mb-0 pt-12 leading-none inline-block",staticStyle:{"color":"#FFC72D"}},[_vm._v("\n        Doctor Dashboard\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-2xl font-fig-semibold mb-0 mt-4 mr-32 break-words leading-normal"},[_vm._v("\n        Empowering doctors to deliver healthcare\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-2xl font-fig-semibold mb-0 mr-32 break-words leading-normal"},[_vm._v("\n        through seamless virtual consultations.\n      ")]),_vm._v(" "),_c('div',{staticClass:"mt-12 w-9/12"},_vm._l((_vm.content),function(item,index){return _c('div',{key:index,staticClass:"flex items-center mt-8"},[_c('img',{staticClass:"mr-5",attrs:{"src":item.image}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-lg font-fig-normal mb-0 break-words leading-normal"},[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"text-lg font-fig-normal mb-0 break-words leading-normal"},[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])])])}),0),_vm._v(" "),_c('div',{staticClass:"flex justify-between mt-12 mr-80 "},_vm._l((_vm.keyPoints),function(item,index){return _c('div',{key:index,staticClass:"items-center mt-8 mb-0"},[_c('div',{staticClass:"text-4xl font-fig-bold mb-0 break-words"},[_vm._v("\n            "+_vm._s(item.heading)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"text-sm mt-2 font-fig-normal mb-0 break-words"},[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])])}),0)])]),_vm._v(" "),(_vm.isEmailVerified)?_c('div',{staticClass:"w-2/5 flex flex-col h-screen justify-center items-center"},[_vm._m(0)]):_c('div',{staticClass:"w-2/5 flex flex-col h-screen justify-center items-center"},[(_vm.isForgotPassword)?_c('form',{staticClass:"w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-2"},[_vm._v("\n          What's your email address?\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"email","type":"email","placeholder":"Email","value":"","maxlength":"50","has-counter":false},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.error && _vm.email)?_c('p',{staticClass:"text-red text-xs italic"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",on:{"click":_vm.goBack}},[_vm._v("\n          Back\n        ")]),_vm._v(" "),_c('button',{staticClass:"bg-blue self-center hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"submit"},on:{"click":_vm.submitEmail}},[_vm._v("\n          Next\n          "),(_vm.isLoading)?_c('i',{staticClass:"ml-2 fa fa-spinner fa-spin"}):_vm._e()])])]):(_vm.secureAccount)?_c('div',{staticClass:"w-2/5 flex flex-col h-screen justify-center items-center"},[_c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between mt-4"},[_c('button',{staticClass:"bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"submit"},on:{"click":_vm.enableMfaSetting}},[_vm._v("\n            Continue\n          ")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold",on:{"click":_vm.skipMfaSetting}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Skip")])])])])]):_c('form',{on:{"submit":function($event){return _vm.submit()}}},[_c('div',{staticClass:"mt-12 bg-white"},[_c('img',{attrs:{"src":_vm.curaLogo}}),_vm._v(" "),_c('h1',{staticClass:"mb-0 text-gray-900 mt-10 text-2xl font-fig-bold leading-none"},[_vm._v("\n          Log in to Doctor Dashboard\n        ")]),_vm._v(" "),_c('div',{staticClass:"mt-12 text-gray-600 text-xs flex flex-col w-full"},[_c('span',{staticClass:"mb-3 text-gray-700 text-sm font-fig-semibold"},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.username),expression:"credentials.username"}],class:[
              'text-base caret-blue-600 text-gray-700 leading-4 h-12 placeholder-gray-300 font-fig-semibold pl-4 border border-gray-200 rounded-md w-96 focus:border-gray-400 bg-gray-100 focus:bg-gray-100 focus:ring-0 focus:outline-none',
              _vm.usernameError ? 'border-red-600' : 'focus:border-gray-400' ],attrs:{"id":"input_username","type":"text","name":"username","placeholder":"enter email"},domProps:{"value":(_vm.credentials.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "username", $event.target.value)}}}),_vm._v(" "),(_vm.error && _vm.usernameError)?_c('p',{staticClass:"mb-0 mt-2 text-xs font-fig-semibold text-red-600 flex flex-row"},[_c('img',{staticClass:"h-3 w-3 mr-1",attrs:{"src":_vm.alertIcon}}),_vm._v("\n            "+_vm._s(_vm.usernameError)+"\n          ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"mt-8 mb-3 text-gray-700 text-sm font-fig-semibold"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"flex items-end"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],class:[
                'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-fig-semibold pl-4 border border-gray-200 focus:border-gray-400 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0 focus:outline-none',
                _vm.passwordError ? 'border-red-600' : 'focus:border-gray-400' ],attrs:{"id":"input_password","name":"password","placeholder":"*********","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.credentials.password)?_vm._i(_vm.credentials.password,null)>-1:(_vm.credentials.password)},on:{"change":function($event){var $$a=_vm.credentials.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.credentials, "password", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.credentials, "password", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.credentials, "password", $$c)}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],class:[
                'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-fig-semibold pl-4 border border-gray-200 focus:border-gray-400 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0 focus:outline-none',
                _vm.passwordError ? 'border-red-600' : 'focus:border-gray-400' ],attrs:{"id":"input_password","name":"password","placeholder":"*********","type":"radio"},domProps:{"checked":_vm._q(_vm.credentials.password,null)},on:{"change":function($event){return _vm.$set(_vm.credentials, "password", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],class:[
                'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-fig-semibold pl-4 border border-gray-200 focus:border-gray-400 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0 focus:outline-none',
                _vm.passwordError ? 'border-red-600' : 'focus:border-gray-400' ],attrs:{"id":"input_password","name":"password","placeholder":"*********","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"inline-block h-6 w-6 relative bottom-3 right-10 cursor-pointer",attrs:{"src":_vm.showPassword ? _vm.eye : _vm.eyeoff,"alt":"eye_icon"},on:{"click":_vm.toggleVisibility}})]),_vm._v(" "),(_vm.error && _vm.passwordError)?_c('p',{staticClass:"mb-0 mt-2 font-fig-semibold text-xs text-red-600 flex flex-row"},[_c('img',{staticClass:"h-3 w-3 mr-1",attrs:{"src":_vm.alertIcon}}),_vm._v(" "),_c('span',{staticClass:"break-words"},[_vm._v(_vm._s(_vm.passwordError))])]):_vm._e(),_vm._v(" "),_c('button',{class:[
            'text-white w-96 py-4 rounded-md text-lg mt-16 font-fig-semibold focus:outline-none',
            (!_vm.credentials.password || !_vm.credentials.username || _vm.isLoading)
              ? 'bg-gray-300 hover:bg-slate-300 cursor-not-allowed'
              : 'bg-blue-600 hover:bg-blue-700 cursor-pointer' ],attrs:{"type":"submit","disabled":_vm.disabled || _vm.isLoading}},[_vm._v("\n            Log in\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-end mt-4 mr-6",on:{"click":_vm.forgotPassword}},[_c('a',{staticClass:"mb-6 text-blue-500 font-fig-normal",attrs:{"href":"#"}},[_vm._v("Forgot password?")])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-2"},[_vm._v("\n        We just emailed you a link\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-base pt-1"},[_vm._v("Please check your email and click the secure link.")]),_vm._v(" "),_c('p',{staticClass:"text-base pt-2"},[_vm._v("If you don’t see our email, check your spam folder")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-grey-darker text-base font-semibold mb-2"},[_vm._v("\n            Secure your account\n          ")]),_vm._v(" "),_c('p',{staticClass:"text-sm mb-2 text-grey-dark pt-1"},[_vm._v("You are required to enroll in Multi-Factor Authentication (MFA)\n            for a extra layer of protection for your account.")]),_vm._v(" "),_c('p',{staticClass:"text-sm pt-2 text-grey-dark"},[_vm._v("Enroll using Google Authenticator or Authy app.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 font-fig-normal text-gray-600 mt-8 text-sm w-96 text-center"},[_vm._v("\n              By logging in, you will agree with ekincare’s\n            "),_c('a',{staticClass:"text-blue-500 cursor-pointer hover:text-blue-500 hover:underline",attrs:{"href":"https://www.ekincare.com/about/terms","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n              Terms and conditions\n            ")]),_vm._v("\n            and\n            "),_c('a',{staticClass:"text-blue-500 cursor-pointer hover:text-blue-500 hover:underline",attrs:{"href":"https://www.ekincare.com/about/privacy","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n              privacy policy\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-gray-500 mt-12 text-center"},[_vm._v("\n            A product by\n            "),_c('a',{staticClass:"text-gray-700 text-xs font-fig-semibold cursor-pointer hover:text-blue-900 hover:underline",attrs:{"href":"https://www.ekincare.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n              ekincare\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XmHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex-no-shrink flex-no-grow flex-col bg-white py-4"},[_c('div',{staticClass:"h-8 flex flex-row rounded-sm mx-2"},[_c('div',{staticClass:"w-1/2 text-sm border-r border-grey-lightest border-solid p-2 font-semibold text-grey-dark"},[_vm._v("TEST LIST")]),_vm._v(" "),_c('div',{staticClass:"w-1/2 flex flex-row justify-between"},[_c('div',{staticClass:"text-sm self-center pl-4 font-semibold text-grey-dark"},[_vm._v("SELECTED TESTS")]),_vm._v(" "),_c('diV',{staticClass:"pt-1 text-xs text-grey-darker font-light self-center pr-2"},[_vm._v("Total Selected : "),_c('span',{staticClass:"text-grey-darkest font-semibold"},[_vm._v(" "+_vm._s(_vm.selectedTests.length)+" ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mx-2 flex-no-shrink flex-no-grow",staticStyle:{"height":"calc(100vh - 11.6rem)"}},[_c('div',{staticClass:"flex flex-col w-1/2 pl-2 flex-no-shrink flex-no-grow border-r border-solid border-grey-lightest"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"flex my-3 mb-4 px-2 h-8 mr-2 text-sm border border-grey-lightest border-solid bg-grey-extralight rounded-sm flex-no-shrink flex-no-grow",staticStyle:{"width":"96%"},attrs:{"type":"search","name":"test_list","placeholder":"Search for a test"},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"overflow-y-auto pr-2",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:"text-sm font-semibold text-grey-darker mb-2",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Recommended Packages")]),_vm._v(" "),_vm._l((_vm.sponsoredTests),function(test,idx){return _c('div',{key:'freq'+idx,staticClass:"flex text-sm my-4 cursor-pointer",on:{"click":function($event){return _vm.addSponsoredTests(test);}}},[_c('span',{staticClass:"w-full text-m text-grey-darker"},[_vm._v(" "+_vm._s(test.name))]),_vm._v(" "),(test.test_component_names != undefined && test.test_component_names.split(',').length > 0)?_c('i',{staticClass:"fas fa-info text-grey-light text-sm cursor-pointer self-center",attrs:{"id":"tests_list_icon"}},[_c('div',{staticClass:"relative"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lightest px-3 py-2 rounded overflow-y-auto",staticStyle:{"width":"200px","z-index":"10","max-height":"200px","padding":"5px"}},[_c('div',{staticClass:"text-grey-darkest text-xs font-regular",staticStyle:{"word-break":"break-all"}},[_c('div',{staticClass:"flex flex-col justify-start"},_vm._l((test.test_component_names.split(',')),function(name,index){return _c('div',{key:index,staticClass:"ml-1 my-1"},[_vm._v("\n                                "+_vm._s(name)+"\n                              ")])}),0)])])])]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"h-3 w-1/6 self-center opacity-75",staticStyle:{"float":"right"},attrs:{"src":__webpack_require__("uPNi"),"alt":""}})])}),_vm._v(" "),(_vm.searchTerm.length<1)?_c('div',[_c('div',{staticClass:"text-sm font-semibold text-grey-darker mb-2",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Frequently Ordered Tests ")]),_vm._v(" "),_vm._l((_vm.freqTests),function(test,idx){return _c('div',{key:'freq'+idx,staticClass:"flex text-sm my-4 cursor-pointer",on:{"click":function($event){return _vm.addFreqTests(test);}}},[_c('span',{staticClass:"w-full text-m text-grey-darker"},[_vm._v(" "+_vm._s(test.name))]),_vm._v(" "),(test.tests_list != undefined && test.tests_list.length > 0)?_c('i',{staticClass:"fas fa-info text-grey-light text-sm cursor-pointer self-center",attrs:{"id":"tests_list_icon"}},[_c('div',{staticClass:"relative"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lightest px-3 py-2 rounded overflow-y-auto",staticStyle:{"width":"200px","z-index":"10","max-height":"200px","padding":"5px"}},[_c('div',{staticClass:"text-grey-darkest text-xs font-regular",staticStyle:{"word-break":"break-all"}},[_c('div',{staticClass:"flex flex-col justify-start"},_vm._l((test.tests_list),function(name,index){return _c('div',{key:index,staticClass:"ml-1 my-1"},[_vm._v("\n                                "+_vm._s(name)+"\n                              ")])}),0)])])])]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"h-3 w-1/6 self-center opacity-75",staticStyle:{"float":"right"},attrs:{"src":__webpack_require__("uPNi"),"alt":""}})])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-sm font-semibold text-grey-darker mb-2 mt-6",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Other Tests ")]),_vm._v(" "),_vm._l((_vm.filteredList),function(test,idx){return _c('div',{key:'other'+idx,staticClass:"flex text-sm my-4 cursor-pointer",on:{"click":function($event){return _vm.addOtherTests(test);}}},[_c('span',{staticClass:"w-full text-m text-grey-darker"},[_vm._v(" "+_vm._s(test.name))]),_vm._v(" "),(test.tests_list != undefined && test.tests_list.length > 0)?_c('i',{staticClass:"fas fa-info text-grey-light text-sm cursor-pointer self-center",attrs:{"id":"tests_list_icon"}},[_c('div',{staticClass:"relative"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lightest px-3 py-2 rounded overflow-y-auto",staticStyle:{"width":"200px","z-index":"10","max-height":"200px","padding":"5px"}},[_c('div',{staticClass:"text-black text-xs font-regular",staticStyle:{"word-break":"break-all"}},[_c('div',{staticClass:"flex flex-col justify-start"},_vm._l((test.tests_list),function(name,index){return _c('div',{key:index,staticClass:"ml-1 my-1"},[_vm._v("\n                              "+_vm._s(name)+"\n                            ")])}),0)])])])]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"h-3 w-1/6 self-center opacity-75",staticStyle:{"float":"right"},attrs:{"src":__webpack_require__("uPNi"),"alt":""}})])})],2)]),_vm._v(" "),_c('div',{staticClass:"w-1/2 pl-4 mt-4"},_vm._l((_vm.selectedTests),function(test,idx){return _c('div',{key:'selected'+idx,staticClass:"flex text-sm my-4 cursor-pointer"},[_c('span',{staticClass:"w-full text-m text-grey-darker"},[_vm._v(" "+_vm._s(test.name))]),_vm._v(" "),_c('img',{staticClass:"h-3 w-1/6 self-center opacity-75",staticStyle:{"float":"right"},attrs:{"src":__webpack_require__("f71c"),"alt":""},on:{"click":function($event){return _vm.removeTests(idx)}}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow",style:(_vm.$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);')},[(_vm.isActiveChat != 'past')?_c('div',{staticClass:"flex flex-row mx-auto"},[_c('div',{staticClass:"cursor-pointer self-center bg-blue p-2 rounded text-white font-semibold ml-2 text-sm px-4",on:{"click":function($event){return _vm.sendToPatient()}}},[_vm._v("Send")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("Lab Tests")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighte"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighte"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighter"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XnN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xqth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerNotification_vue__ = __webpack_require__("mryS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b10928e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerNotification_vue__ = __webpack_require__("y2q6");
function injectStyle (ssrContext) {
  __webpack_require__("Vo6z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b10928e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xsot":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Xw7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scheduled_vue__ = __webpack_require__("F1k2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e7e63b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scheduled_vue__ = __webpack_require__("L53c");
function injectStyle (ssrContext) {
  __webpack_require__("3s5J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39e7e63b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scheduled_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e7e63b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scheduled_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y57z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__("IC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: [''],
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      blood_groups: [{ 'id': 1, 'blood_type': 'A+' }, { 'id': 2, 'blood_type': 'A-' }, { 'id': 3, 'blood_type': 'B+' }, { 'id': 4, 'blood_type': 'B-' }, { 'id': 5, 'blood_type': 'AB+' }, { 'id': 6, 'blood_type': 'AB-' }, { 'id': 7, 'blood_type': 'O+' }, { 'id': 8, 'blood_type': 'O-' }],
      genders: ['Male', 'Female', 'Non-binary'],
      editGeneralInfo: false,
      editBMI: false,
      editBP: false,
      editHeart: false
      // customer: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    currentCustomer: 'configuration/getActivePatientProfile',
    activeSection: 'configuration/getActiveSection'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activeMiniMenu: function activeMiniMenu(state) {
      return state.configuration.activeMiniMenu;
    }
  }), {
    customer: function customer() {
      var patient = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.currentCustomer);
      return patient;
    },
    dateToAge: function dateToAge() {
      var dateOfBirth = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.customer.details.date_of_birth, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!dateOfBirth.isValid()) return 'NA';

      var now = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      var years = now.diff(dateOfBirth, 'years');
      var months = now.diff(dateOfBirth.add(years, 'years'), 'months');
      return years + ' Years ' + months + ' Months';
    },
    gender: function gender() {
      if (this.customer.details && this.customer.details.gender) {
        return this.customer.details.gender;
      }
      return 'NA';
    },
    contactNumber: function contactNumber() {
      if (this.customer.details) {
        return this.customer.details.mobile_number || this.customer.details.alternative_mobile_number || 'NA';
      }
      return 'NA';
    },
    bloodGroup: function bloodGroup() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters.blood_group !== null) {
        var length = this.blood_groups.length;
        for (var i = 0; i < length; i++) {
          if (this.blood_groups[i].id === parseInt(this.customer.details.health_parameters.blood_group)) {
            return this.blood_groups[i].blood_type;
          }
        }
        return 'NA';
      }
    },
    feet: function feet() {
      var carry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.feet) {
        return this.customer.details.health_parameters.feet;
      }
      return 0;
    },
    inches: function inches() {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.inches) {
        return this.customer.details.health_parameters.inches;
      }
      return 0;
    },
    weight: function weight() {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.weight) {
        return this.customer.details.health_parameters.weight;
      }
      return 0;
    },
    bmi: function bmi() {
      if (this.customer.details && this.customer.details.health_parameters) {
        var height = 0;
        var weight = 0;
        var heightInFeet = 0;
        var heightInInches = 0;
        if (this.customer.details.health_parameters.feet) {
          heightInFeet = Number(this.customer.details.health_parameters.feet) * 12;
        }
        if (this.customer.details.health_parameters.inches) {
          heightInInches = Number(this.customer.details.health_parameters.inches);
        }
        height = heightInFeet + heightInInches;
        if (this.customer.details.health_parameters.weight) {
          weight = Number(this.customer.details.health_parameters.weight);
        }
        if (height > 0) {
          height = height * 0.0254;
          var bmi = weight / (height * height);
          return bmi.toFixed(2);
        }
        return 'NA';
      }
    },
    diastolic: function diastolic() {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.blood_pressure && this.customer.details.health_parameters.blood_pressure.diastolic) {
        return this.customer.details.health_parameters.blood_pressure.diastolic + ' mmHg';
      }
      return 'NA';
    },
    systolic: function systolic() {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.blood_pressure && this.customer.details.health_parameters.blood_pressure.systolic) {
        return this.customer.details.health_parameters.blood_pressure.systolic + ' mmHg';
      }
      return 'NA';
    },
    pulse: function pulse() {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.pulse) {
        return this.customer.details.health_parameters.pulse + ' bpm';
      }
      return 'NA';
    }
  }),
  methods: {
    close: function close(e) {
      this.$emit('viewCustomerProfile', e);
    },
    edit: function edit(item) {
      this[item] = true;
    },
    getBloodGroupbyId: function getBloodGroupbyId() {
      if (this.customer && this.customer.details && this.customer.details.health_parameters.blood_group !== null) {
        var length = this.blood_groups.length;
        for (var i = 0; i < length; i++) {
          if (this.blood_groups[i].id === this.customer.details.health_parameters.blood_group) {
            return this.blood_groups[i].blood_type;
          }
        }
        return 'NA';
      }
    },
    validateHealthParameters: function validateHealthParameters(parameters) {
      for (var key in parameters) {
        if (parameters[key] < 0) {
          return false;
        }
      }
      return true;
    },
    save: function save(item, keys) {
      var data = {};
      var healthParameters = this.customer.details.health_parameters;
      keys.map(function (key) {
        data[key] = healthParameters[key];
      });
      // Validate data before saving
      if (!this.validateHealthParameters(data)) {
        this.$toast.open({
          message: 'Please ensure all numeric values are non-negative.',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }

      this[item] = false;
      this.dispatchMethod(data, 'health');
    },
    saveBP: function saveBP(item) {
      var data = {
        blood_pressure: {
          diastolic: this.customer.details.health_parameters.blood_pressure.diastolic,
          systolic: this.customer.details.health_parameters.blood_pressure.systolic
        }
        // Validate data before saving
      };if (!this.validateHealthParameters(data.blood_pressure)) {
        this.$toast.open({
          message: 'Please ensure all numeric values are non-negative.',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }

      this[item] = false;
      this.dispatchMethod(data, 'health');
    },
    saveGeneral: function saveGeneral(item, keys) {
      var data = {
        blood_group: this.customer.details.health_parameters.blood_group,
        gender: this.customer.details.gender,
        date_of_birth: this.customer.details.date_of_birth
      };
      this[item] = false;
      this.dispatchMethod(data, 'general');
    },
    dispatchMethod: function dispatchMethod(data, type) {
      if (this.activeMiniMenu === 'Chat') {
        if (this.activeSection === 'connected') {
          if (type === 'general') {
            this.$store.dispatch('consultation/updateGeneralParameters', data);
          } else {
            this.$store.dispatch('consultation/updateHealthParameters', data);
          }
        } else if (this.activeSection === 'consults') {
          if (type === 'general') {
            this.$store.dispatch('pastConsultation/updateGeneralParameters', data);
          } else {
            this.$store.dispatch('pastConsultation/updateHealthParameters', data);
          }
        }
      } else if (this.activeMiniMenu === 'OfflineConsults') {
        if (this.activeSection === 'connected') {
          if (type === 'general') {
            this.$store.dispatch('offlineConsultation/updateGeneralParameters', data);
          } else {
            this.$store.dispatch('offlineConsultation/updateHealthParameters', data);
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "YCf1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YD0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeSaveReminderOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Unsaved Changes")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeSaveReminderOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Leaving this page will discard all unsaved changes. Please save/cancel changes before you proceed. ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeSaveReminderOverlay()}}},[_vm._v("Okay")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YIS4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeElapsed_vue__ = __webpack_require__("P6bk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a09bff1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeElapsed_vue__ = __webpack_require__("0/tJ");
function injectStyle (ssrContext) {
  __webpack_require__("pDRg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeElapsed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a09bff1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeElapsed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YJuw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthProfile_vue__ = __webpack_require__("0zGs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a47a46ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthProfile_vue__ = __webpack_require__("wawq");
function injectStyle (ssrContext) {
  __webpack_require__("PY9l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a47a46ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YRl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col rounded-m bg-grey-extralight m-3"},[_c('div',{staticClass:"bg-grey-lightest rounded-t-m text-grey-darkest font-semibold p-4"},[_vm._v("Recommended Lab Tests")]),_vm._v(" "),_c('div',{staticClass:"p-4"},_vm._l((_vm.data.recommended_tests),function(test,index){return _c('div',{key:index,staticClass:"text-sm text-grey-darkest p-2"},[_vm._v("\n      "+_vm._s(index+1)+". "+_vm._s(test.name)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Doctor_Profile__ = __webpack_require__("EDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MFASettings__ = __webpack_require__("b2Js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Doctor_MfaAccountSettings__ = __webpack_require__("P1MB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Doctor_MfaOTPConfirmationScreen__ = __webpack_require__("FsTF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ResetPassword__ = __webpack_require__("yiqP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Logout__ = __webpack_require__("0Kyw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Mer_Mer__ = __webpack_require__("10ad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Appointments_Appointments__ = __webpack_require__("49fG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Admin_AdminHome__ = __webpack_require__("AOhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_ably__ = __webpack_require__("oKrw");












// import PreEmployees from '@/components/PreEmployees/PreEmployees'



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
// Vue.use(Buefy)

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Home__["a" /* default */]
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Doctor_Profile__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]
  }, {
    path: '/mfa-otp',
    name: 'MFA-OTP',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Doctor_MfaOTPConfirmationScreen__["a" /* default */]
  }, {
    path: '/mfa-settings',
    name: 'MFA',
    component: __WEBPACK_IMPORTED_MODULE_4__components_MFASettings__["a" /* default */]
  }, {
    path: '/profile/mfa-account-settings',
    name: 'MFASettings',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Doctor_MfaAccountSettings__["a" /* default */]
  }, {
    path: '/resetPassword/:token',
    name: 'resetPassword',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ResetPassword__["a" /* default */]
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Home__["a" /* default */]
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Logout__["a" /* default */]
  }, {
    path: '/admin-home',
    name: 'adminHome',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Admin_AdminHome__["a" /* default */]
  }, {
    path: '/mer',
    name: 'mer',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Mer_Mer__["a" /* default */]
  }, {
    path: '/appointments',
    name: 'appointments',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Appointments_Appointments__["a" /* default */]
    // {
    //   path: '/pre-employees',
    //   name: 'pre-employees',
    //   component: PreEmployees
    // }
  }]
});

router.beforeEach(function (to, from, next) {
  // redirect to login page if not logged in and trying to access a restricted page
  var publicPages = ['login', 'Login', 'resetPassword', 'MFA', 'MFA-OTP'];
  var authRequired = !publicPages.includes(to.name);
  var loggedIn = false;
  var isAdmin = false;
  if (sessionStorage.getItem('isLoggedIn')) {
    loggedIn = JSON.parse(sessionStorage.getItem('isLoggedIn'));
  }
  if (sessionStorage.getItem('isAdmin')) {
    isAdmin = JSON.parse(sessionStorage.getItem('isAdmin'));
  }
  if (authRequired && !loggedIn) {
    __WEBPACK_IMPORTED_MODULE_13__core_ably__["a" /* default */].close();
    sessionStorage.clear();
    return next('login');
  } else if (!authRequired && loggedIn) {
    if (isAdmin) {
      return next('admin-home');
    }
    return next('home');
  } else if (authRequired && loggedIn) {
    var adminPaths = ['/admin-home'];
    if (isAdmin) {
      var canAccess = adminPaths.includes(to.path);
      if (!canAccess) {
        return next('admin-home');
      }
    } else {
      var cantAccess = adminPaths.includes(to.path);
      if (cantAccess) {
        return next('home');
      }
    }
  }
  next();
});

// Vue.http.interceptors.push((req, next) => {
//   req.headers.set('X-DOCTOR-KEY', sessionStorage.getItem('X-DOCTOR-KEY'))
//   next(res => {
//     if (res.status === 401) {
//       ably.close()
//       sessionStorage.clear()
//       return next('/login')
//     } else if (res.status === 200) {
//       return next('/home')
//     }
//   })
// })

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yodc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z8dw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ZP4w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_customer_document__ = __webpack_require__("eX/k");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['doc'],
  data: function data() {
    return {
      activeResults: 'results',
      isView: false,
      docIndex: null,
      showFullView: false,
      document: null
    };
  },

  methods: {
    getDocument: function getDocument(reportType, reportId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_customer_document__["a" /* default */].fetch(reportType, reportId).then(function (response) {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank');
        } else {
          _this.$toast.open({
            message: 'Error fetching data',
            type: 'error',
            position: 'top-right'
          });
        }
      }, function (response) {});
    },
    setActiveResults: function setActiveResults(resultsSection) {
      this.activeResults = resultsSection;
    },
    showResultsModal: function showResultsModal(doc) {
      this.isView = !this.isView;
      if (this.doc.lab_results < 1 || this.doc.health_assessment_status !== 'done') {
        this.activeResults = 'reports';
      } else if (this.doc.category === 'Prescription') {
        this.activeResults = 'reports';
      }
    },
    showFullViewModal: function showFullViewModal(doc) {
      this.showFullView = true;
      this.document = doc;
      this.$emit('fullView', this.showFullView, doc);
    },
    hasHTML: function hasHTML(str) {
      var doc = new DOMParser().parseFromString(str, 'text/html');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(doc.body.childNodes).some(function (node) {
        return node.nodeType === 1;
      });
    }
  }
});

/***/ }),

/***/ "ZTRo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACl0lEQVR4nO3bPatcVRgF4HcSRAkiaBCFoKJEgqIIErAIFoGIimCRSgQtUgoq+AMstFWwSWNlFfILbEwKPxA7QbRRUJKAH0QhGq9JNMljMdcicu8eZjLjlj3rqWf2LNYLh33OPlMVERERERERERERERERERERERGxJLgBb+HO3lnWDnbimKlvcW/vTGsDE7zrWqewt3e24W2Wf9TWfsBDvTMODW9vU/4/3uudcVh4c0b5J3BT75xDwmszyv8UN/fOOSS8MqP8z3Fr75xDwhFcbZT/BXb3zjkkvIArjfK/lpuw1cBh/NUo/xTu6Z1zSHgKFxvln5E739XAIVxolP8THuidc0g4gN8b5Z+VO93VwGP4rVH+OezvnXNIeAS/NMrfwOO9cw4J+/Bjo/w/cLB3ziHhfnzfKP8Snumd8/9ussiXTLeRH1bVXY2PXa6q84usv41bqmrnEtf7T00mky27nnsA2FNVH1XVfdcbap1sN4Ad8yyCO6rqZKX8pZlrAFV1oao2VhFkXS1yCbq9qj6uqn3LjzOupVyCNhc6W1VPVNWZ6w0VC+6CqqrwcE13Qtsdppyrqier6ptFf+Nffp1MJleXtNYYNh9BtJ7/nMbdvXMOzfQJ6KXGEL7Ebb1zDg3Pa59+fSaH7quFlxoDgA9wY++cQ8MbM4ZwDHPvvGIOeGfGEI72zjg07MDxGUN4vXfOoZm++//+jCG82jvn0LALnzQGcAXP9c45NOzGV40h/Imne+ccGvbgu8YQNnCgd86hYa/22fHPeLB3zqFhv/arK6exq3fOoeGgrd+cu4wjvfOtBTzr2hd3L+Jw71xrBS+a/m/gPA71zrOW8DIe7Z0jIiIiIiIiIiIiIiIiIiIiIiIiIiIiIpbhbxsHvKxcMM/jAAAAAElFTkSuQmCC"

/***/ }),

/***/ "ZX/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZYU2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Zjzk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zmdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Consultations_IncomingRequests__ = __webpack_require__("EZCc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Consultations_ActiveConsultations_vue__ = __webpack_require__("plc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Consultations_PastConsultations_vue__ = __webpack_require__("Q+Y/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Phrases_PhrasesMain__ = __webpack_require__("Xdl+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Consultations_ActiveDoctorsCard__ = __webpack_require__("Oqxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IncomingRequests: __WEBPACK_IMPORTED_MODULE_1__components_Consultations_IncomingRequests__["a" /* default */],
    ActiveConsultations: __WEBPACK_IMPORTED_MODULE_2__components_Consultations_ActiveConsultations_vue__["a" /* default */],
    PastConsultations: __WEBPACK_IMPORTED_MODULE_3__components_Consultations_PastConsultations_vue__["a" /* default */],
    Phrases: __WEBPACK_IMPORTED_MODULE_4__components_Phrases_PhrasesMain__["a" /* default */],
    ActiveDoctorsCard: __WEBPACK_IMPORTED_MODULE_5__components_Consultations_ActiveDoctorsCard__["a" /* default */],
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_6__components_common_modals_UnsavedChanges__["a" /* default */]
  },
  data: function data() {
    return {
      isShowLoad: false,
      showSaveReminder: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    requests: 'consultationRequest/getRequests',
    activeSection: 'configuration/getActiveSection'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    activeConsults: function activeConsults(state) {
      return state.consultation.activeConsults;
    },
    pastConsults: function pastConsults(state) {
      return state.pastConsultation.pastConsults;
    },
    totalPastConsults: function totalPastConsults(state) {
      return state.pastConsultation.totalPastConsults;
    },
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    }
  })),
  methods: {
    setActiveSection: function setActiveSection(section) {
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      this.isShowLoad = false;
      this.$store.dispatch('configuration/setOnlineActiveSection', section);
    },
    showLoad: function showLoad() {
      this.isShowLoad = !this.isShowLoad;
      if (this.isShowLoad) {
        this.$store.dispatch('consultationRequest/loadDetails');
      }
    },
    closePopup: function closePopup(val) {
      this.isShowLoad = val;
    },
    closeModal: function closeModal(params) {
      this.showSaveReminder = false;
    }
  }
});

/***/ }),

/***/ "aagr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aqFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-10 absolute flex flex-col flex-shrink pin-r pin-t mt-12 mr-6 bg-grey-lightest rounded overflow-y-auto",staticStyle:{"width":"400px","max-height":"450px","box-shadow":"0px 8px 16px 0px rgba(0,0,0,0.2)"}},[(_vm.notifications && _vm.notifications.length<1)?_c('div',{staticClass:"px-4 py-6 bg-grey-extralight"},[_c('div',{staticClass:"text-m text-grey-darkest mr-auto"},[_vm._v("No notification available")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(n,i){return _c('div',{key:i,staticClass:"flex flex-row px-4 py-6 border-b border-solid border-grey-lightest hover:bg-blue-lightest cursor-pointer flex-no-shrink flex-no-grow",class:[n.is_read ? 'bg-white' : 'bg-grey-extralight'],on:{"click":function($event){return _vm.onNotificationClick(n)}}},[_c('div',{staticClass:"flex flex-col text-m text-grey-darkest mr-auto"},[_vm._v("\n      "+_vm._s(n.description)+"\n      "),_c('div',{staticClass:"text-xs text-grey mt-2"},[_vm._v("\n        "+_vm._s(n.time)+"\n      ")])]),_vm._v(" "),(n.required_action)?_c('div',{staticClass:"flex text-blue font-semibold text-xs justify-end",staticStyle:{"text-transform":"uppercase","width":"200px"},on:{"click":function($event){return _vm.requiredAction(n)}}},[_vm._v("\n      "+_vm._s(n.required_action)+"\n    ")]):_vm._e()])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aqji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  getSavedMedications: function getSavedMedications() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/doctor_saved_medications');
  },
  addToSavedMedications: function addToSavedMedications(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/doctor_saved_medications', data);
  },
  editSavedMedication: function editSavedMedication(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(window.API_URL + ('doctors/doctor_saved_medications/' + data.doctor_saved_medication_id), data.med);
  },
  removedSavedMedication: function removedSavedMedication(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(window.API_URL + ('doctors/doctor_saved_medications/' + id));
  }
});

/***/ }),

/***/ "b0gp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthScore_vue__ = __webpack_require__("LTnY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0c621fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthScore_vue__ = __webpack_require__("ivbo");
function injectStyle (ssrContext) {
  __webpack_require__("F2Gu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0c621fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b2Js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MFASettings_vue__ = __webpack_require__("LDrI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3a7797_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MFASettings_vue__ = __webpack_require__("U1SN");
function injectStyle (ssrContext) {
  __webpack_require__("Ayzh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e3a7797"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MFASettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3a7797_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MFASettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b8jy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



/* harmony default export */ __webpack_exports__["a"] = ({
  createPrescription: function createPrescription(file, action, channelId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/prescriptions/create', file, {
      progress: function progress(e) {
        if (e.lengthComputable && action === 'send') {
          file.progress = parseInt(e.loaded / e.total * 100);
          file.state = 'uploading';
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('message/documentUploadProgress', { file: file, channelId: channelId });
        }
      }
    });
  }
});

/***/ }),

/***/ "bBuP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toaster_vue__ = __webpack_require__("bMwx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed2c1b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toaster_vue__ = __webpack_require__("LgFN");
function injectStyle (ssrContext) {
  __webpack_require__("+8rZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toaster_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed2c1b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toaster_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bMwx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    toaster: 'toaster/toasterState'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    setToaster: 'toaster/setToaster'
  }))
});

/***/ }),

/***/ "bPmL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col relative pin-b mt-auto flex-no-shrink flex-no-grow border-t border-solid border-grey-lightest bg-white",staticStyle:{"max-height":"24rem"}},[_c('div',{staticClass:"flex flex-row h-10  pl-4 pr-4 justify-between flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"self-center text-sm text-black"},[_vm._v(" Phrases ")]),_vm._v(" "),_c('div',{staticClass:"self-center h-4 w-4 cursor-pointer",on:{"click":function($event){return _vm.togglePhrases()}}},[_c('img',{attrs:{"src":__webpack_require__("TrYx"),"alt":"collapse button"}})])]),_vm._v(" "),(_vm.showPhrases)?_c('div',{staticClass:"flex flex-row h-10 relative pin-t border-b-4 border-solid border-grey-lightest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"self-center font-light text-grey text-xs ml-4  ",class:[_vm.selectedTab === 'standard' ? 'border-b-4 border-solid border-blue text-xs font-semibold text-blue' : '' ],on:{"click":function($event){return _vm.tabClicked('standard')}}},[_vm._v(" Standard")]),_vm._v(" "),_c('div',{staticClass:"self-center font-light text-grey text-xs ml-4",class:[_vm.selectedTab === 'custom' ? 'border-b-4 border-solid border-blue text-xs font-semibold text-blue' : '' ],on:{"click":function($event){return _vm.tabClicked('custom')}}},[_vm._v(" Custom ")])]):_vm._e(),_vm._v(" "),(_vm.showPhrases)?_c('div',{staticClass:"flex flex-col overflow-y-auto py-2"},[(_vm.selectedTab === 'standard')?_c('Standard'):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'custom')?_c('Custom'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bZyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Toaster__ = __webpack_require__("bBuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */],
    Toaster: __WEBPACK_IMPORTED_MODULE_2__components_common_Toaster__["a" /* default */]
  },
  data: function data() {
    return {
      doctorprofile: { photo: {} },
      languages: '',
      files: [],
      signature: null,
      profile: null,
      isLoading: false,
      isPopupVisible: false,
      mfa: {
        type: '',
        enabled: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    doctor: 'configuration/doctor'
  })),
  watch: {
    data: function data() {
      this.fetchMfaStatus();
    }
  },
  mounted: function mounted() {
    this.fetchMfaStatus();
  },

  methods: {
    saveProfile: function saveProfile() {
      this.$store.dispatch('configuration/saveDoctorDetails', { profile: this.profile, signature: this.signature });
    },
    changeProfileImage: function changeProfileImage(fileList) {
      var name = 'doc-' + fileList[0].name;
      this.profile = new File([fileList[0]], name, { type: fileList[0].type });
      this.saveProfile();
    },
    changeSignatureImage: function changeSignatureImage(fileList) {
      var name = 'doc-' + fileList[0].name;
      this.signature = new File([fileList[0]], name, { type: fileList[0].type });
      this.saveProfile();
    },
    moveToMfaSettings: function moveToMfaSettings() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('profile/mfa-account-settings');
    },
    fetchMfaStatus: function fetchMfaStatus() {
      var _this = this;

      this.isLoading = true;
      this.$http.get(window.API_URL + 'doctors/mfa_settings/new').then(function (response) {
        if (response.status === 200) {
          _this.isLoading = false;
          _this.mfa.enabled = response.body.mfa_enabled;
          _this.mfa.type = response.body.mfa_type;
        }
      }).catch(function () {
        this.isLoading = false;
        this.$toast.open({
          message: 'Something went wrong!',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    },
    disableMfaSettings: function disableMfaSettings() {
      var _this2 = this;

      this.isLoading = true;
      this.$http.delete(window.API_URL + 'doctors/mfa_settings').then(function (response) {
        if (response.status === 200) {
          _this2.isLoading = false;
          _this2.mfa.enabled = false;
          _this2.isPopupVisible = false;
          _this2.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          });
        }
      }).catch(function () {
        this.isLoading = false;
        this.isPopupVisible = false;
        this.$toast.open({
          message: 'Something went wrong!',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    },
    showOrClosePopup: function showOrClosePopup() {
      this.isPopupVisible = !this.isPopupVisible;
    },

    onName: function onName(event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', { name: event.target.value });
    },
    onDescription: function onDescription(event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', { description: event.target.value });
    },
    onQualification: function onQualification(event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', { qualification: event.target.value });
    },
    onMobileNumber: function onMobileNumber(event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', { mobile_number: event.target.value });
    },
    onRegistrationNumber: function onRegistrationNumber(event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', { registration_number: event.target.value });
    }
  }
});

/***/ }),

/***/ "btYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMic)?_c('div',{staticClass:"mic",class:_vm.isRecording ? 'mic_on' : '',on:{"click":function($event){return _vm.toggleRecording(_vm.isRecording)}}},[_c('img',{attrs:{"src":__webpack_require__("+igM")}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cCX/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorSlots_vue__ = __webpack_require__("xvXW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908b2b3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorSlots_vue__ = __webpack_require__("yNYv");
function injectStyle (ssrContext) {
  __webpack_require__("jYHe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-908b2b3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorSlots_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908b2b3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorSlots_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cWAw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cXcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.close($event)}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col absolute bg-white shadow z-40 h-auto rounded-sm flex-no-shrink flex-no-grow pin-x mx-auto",staticStyle:{"width":"620px","top":"5rem"}},[_c('div',{staticClass:"flex flex-row justify-between mx-4 mt-2 items-center"},[_c('div',{staticClass:"mt-2 mr-2 font-semibold"},[_vm._v(_vm._s(_vm.customer.name.trim())+"'s Profile")]),_vm._v(" "),_c('div',{staticClass:"h-6 w-6 mt-2 cursor-pointer",on:{"click":function($event){return _vm.close($event)}}},[_c('img',{attrs:{"src":__webpack_require__("JA1j")}})])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white mx-4 mb-4 mt-4 flex-no-shrink flex-no-grow"},[(_vm.editGeneralInfo)?_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          General \n          "),_c('span',{staticClass:"h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold",on:{"click":function($event){return _vm.saveGeneral('editGeneralInfo', ['blood_group', 'gender', 'date_of_birth'])}}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"flex flex-col ml-2"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Blood Group")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.blood_group),expression:"customer.details.health_parameters.blood_group"}],staticClass:"flex appearance-none w-32 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"6.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.customer.details.health_parameters, "blood_group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.blood_groups),function(item,index){return _c('option',{key:index,domProps:{"value":item.id}},[_vm._v(_vm._s(item.blood_type))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col ml-8"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.gender),expression:"customer.details.gender"}],staticClass:"flex appearance-none w-32 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"6.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.customer.details, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.genders),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col ml-8"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('date-picker',{attrs:{"format":"dd/MM/yyyy","input-class":"w-32 h-8 text-sm tracking-wider pl-2 cursor-auto rounded-sm border text-grey-darkest"},model:{value:(_vm.customer.details.date_of_birth),callback:function ($$v) {_vm.$set(_vm.customer.details, "date_of_birth", $$v)},expression:"customer.details.date_of_birth"}})],1)])])])]):_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          General \n          "),_c('span',{staticClass:"h-5 w-5 mr-4 ml-auto cursor-pointer text-sm text-blue font-semibold",on:{"click":function($event){return _vm.edit('editGeneralInfo')}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-4/5 text-grey-darkest"},[_c('div',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.dateToAge))]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.gender))]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.bloodGroup))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.contactNumber))])])])]),_vm._v(" "),(_vm.editBMI)?_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          BMI (Body Mass Index)\n          "),_c('span',{staticClass:"h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold",on:{"click":function($event){return _vm.save('editBMI', ['feet', 'inches', 'weight'])}}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-col ml-2 mr-4"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Height")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.feet),expression:"customer.details.health_parameters.feet"}],staticClass:"w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.customer.details.health_parameters.feet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.details.health_parameters, "feet", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:" text-grey-darker font-light self-center"},[_vm._v(" feet ")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col ml-2 mt-4"},[_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.inches),expression:"customer.details.health_parameters.inches"}],staticClass:"w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.customer.details.health_parameters.inches)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.details.health_parameters, "inches", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:" text-grey-darker font-light self-center"},[_vm._v(" inches ")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col ml-2 ml-16"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Weight")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.weight),expression:"customer.details.health_parameters.weight"}],staticClass:"w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.customer.details.health_parameters.weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.details.health_parameters, "weight", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:" text-grey-darker font-light self-center"},[_vm._v(" kg ")])])])])]):_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          BMI (Body Mass Index) \n          "),_c('span',{staticClass:"h-5 w-5 mr-4 ml-auto cursor-pointer text-sm font-semibold text-blue",on:{"click":function($event){return _vm.edit('editBMI')}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-4/5 text-grey-darkest"},[_c('div',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.feet)+" ft "+_vm._s(_vm.inches)+" inches")]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.weight)+" kg")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.bmi))])])])]),_vm._v(" "),(_vm.editBP)?_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          BP (Blood Pressure) \n          "),_c('span',{staticClass:"h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold",on:{"click":function($event){return _vm.saveBP('editBP')}}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-col ml-2 mr-4"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Systolic")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.blood_pressure.systolic),expression:"customer.details.health_parameters.blood_pressure.systolic"}],staticClass:"w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.customer.details.health_parameters.blood_pressure.systolic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.details.health_parameters.blood_pressure, "systolic", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:" text-grey-darker font-light self-center"},[_vm._v(" mmHg ")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col ml-2 ml-12"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Diastolic")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.blood_pressure.diastolic),expression:"customer.details.health_parameters.blood_pressure.diastolic"}],staticClass:"w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.customer.details.health_parameters.blood_pressure.diastolic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.details.health_parameters.blood_pressure, "diastolic", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:" text-grey-darker font-light self-center"},[_vm._v(" mmHg ")])])])])]):_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          BP (Blood Pressure) \n          "),_c('span',{staticClass:"h-5 w-5 mr-4 ml-auto cursor-pointer text-sm font-semibold text-blue",on:{"click":function($event){return _vm.edit('editBP')}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-4/5 text-grey-darkest"},[_c('div',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.systolic))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.diastolic))])])])]),_vm._v(" "),(_vm.editHeart)?_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          Heart \n          "),_c('span',{staticClass:"h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold",on:{"click":function($event){return _vm.save('editHeart', ['pulse'])}}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-col ml-2 mr-4"},[_c('label',{staticClass:"text-xs text-grey-darker mb-1 tracking-wide",attrs:{"for":"prescribe_drug"}},[_vm._v("Pulse")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.details.health_parameters.pulse),expression:"customer.details.health_parameters.pulse"}],staticClass:"w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none"},attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.customer.details.health_parameters.pulse)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.details.health_parameters, "pulse", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:" text-grey-darker font-light self-center"},[_vm._v(" bpm ")])])])])]):_c('div',[_c('div',{staticClass:"flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"},[_vm._v(" \n          Heart \n          "),_c('span',{staticClass:"h-5 w-5 mr-4 ml-auto cursor-pointer text-sm font-semibold text-blue",on:{"click":function($event){return _vm.edit('editHeart')}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-4/5 text-grey-darkest"},[_c('div',[_vm._v(_vm._s(_vm.pulse))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-1/5"},[_c('div',{staticClass:"pb-1"},[_vm._v("Age")]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_vm._v("Blood Group")]),_vm._v(" "),_c('div',[_vm._v("Mobile Number")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-1/5"},[_c('div',{staticClass:"pb-1"},[_vm._v("Height")]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_vm._v("Weight")]),_vm._v(" "),_c('div',[_vm._v("BMI")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-1/5"},[_c('div',{staticClass:"pb-1"},[_vm._v("Systolic")]),_vm._v(" "),_c('div',[_vm._v("Dystolic")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-1/5"},[_c('div',[_vm._v("Pulse")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ce3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isUpdateAvailable: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    /* Check for version updates */
    setInterval(function () {
      _this.checkUpdates();
    }, 15 * 60 * 1000);
  },

  methods: {
    reload: function reload() {
      window.location.reload();
    },
    closeOverlay: function closeOverlay() {
      this.isUpdateAvailable = false;
    },
    checkUpdates: function checkUpdates() {
      var vm = this;
      var previousHtml = sessionStorage.getItem('previousHtml') ? sessionStorage.getItem('previousHtml') : null;
      return fetch(window.location.protocol + '//' + window.location.host + '/index.html').then(function (response) {
        if (response.status !== 200) {
          throw new Error('offline');
        }
        return response.text();
      }).then(function (html) {
        if (!previousHtml) {
          previousHtml = html;
          sessionStorage.setItem('previousHtml', previousHtml);
          return false;
        }
        if (previousHtml !== html) {
          previousHtml = html;
          sessionStorage.setItem('previousHtml', previousHtml);
          console.log('Update Available');
          vm.isUpdateAvailable = true;
          return true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ "ce7E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d3DZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "d6or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Chat_ChatPane__ = __webpack_require__("uG7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Consultations_LeftPane__ = __webpack_require__("fbz1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RightPane__ = __webpack_require__("2f92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ChatPane: __WEBPACK_IMPORTED_MODULE_1__components_Chat_ChatPane__["a" /* default */],
    LeftPane: __WEBPACK_IMPORTED_MODULE_2__components_Consultations_LeftPane__["a" /* default */],
    RightPane: __WEBPACK_IMPORTED_MODULE_3__components_RightPane__["a" /* default */]
  },
  name: 'ChatMain',
  data: function data() {
    return {
      showRightPane: false,
      consultRequests: [],
      othersAcceptedRequests: [],
      cancelledRequests: [],
      showToggleButton: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    isActiveChatPresent: 'consultation/isActiveChatPresent',
    isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
    requests: 'consultationRequest/getRequests',
    alreadyAssignedRequests: 'consultationRequest/getOthersAcceptedRequest',
    patientCancelledRequests: 'consultationRequest/getCancelledRequest',
    activeSection: 'configuration/getActiveSection',
    selectedRightTab: 'configuration/getActiveRightPaneTab'
  }), {
    incomingRequests: function incomingRequests() {
      this.consultRequests = this.requests;
      this.othersAcceptedRequests = this.alreadyAssignedRequests;
      this.cancelledRequests = this.patientCancelledRequests;
      return this.requests;
    },
    isActiveChat: function isActiveChat() {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true;
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true;
      }
      return false;
    }
  }),
  methods: {
    tabChange: function tabChange(tab) {
      this.showRightPane = true;
      this.$store.dispatch('configuration/setRightPaneTab', tab);
    },
    toggleRightPane: function toggleRightPane(state) {
      this.showRightPane = state;
    }
  }
});

/***/ }),

/***/ "dC1Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "dF0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Chat_ChatMessageContainer__ = __webpack_require__("gEdh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_consultation__ = __webpack_require__("57jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_paginate__ = __webpack_require__("kBYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_customer_document__ = __webpack_require__("eX/k");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ChatMessageContainer: __WEBPACK_IMPORTED_MODULE_1__components_Chat_ChatMessageContainer__["a" /* default */],
    Paginate: __WEBPACK_IMPORTED_MODULE_4_vuejs_paginate___default.a
  },
  data: function data() {
    return {
      showDetails: false,
      selectedConsult: {},
      selectedType: '',
      pastConsults: [],
      messages: [],
      totalPages: 1,
      queries: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  })),
  watch: {
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedConsult = {};
        this.selectedType = '';
        this.showDetails = false;
        this.queries = false;
        this.getPastConsults();
        return;
      }
    }
  },
  mounted: function mounted() {
    this.getPastConsults();
  },

  methods: {
    showConsultDetails: function showConsultDetails(type, consult) {
      this.showDetails = true;
      this.selectedConsult = consult;
      this.selectedType = type;
    },
    fetchMessages: function fetchMessages(consult) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api_consultation__["a" /* default */].fetchMesaagesConsultation(consult.consultation_id, consult.consultation_request_id).then(function (response) {
        if (response.status === 200) {
          _this.messages = response.body.messages;
          _this.selectedType = 'Chat';
          _this.showDetails = true;
        } else {}
      }, function (response) {});
    },
    close: function close() {
      this.showDetails = false;
      this.selectedConsult = {};
    },
    getPastConsults: function getPastConsults() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.customer) {
        __WEBPACK_IMPORTED_MODULE_3__api_consultation__["a" /* default */].getCustomerPastConsultation(this.customer.customerId, page, queries).then(function (response) {
          if (response.status === 200) {
            _this2.pastConsults = response.body.past_consults;
            _this2.totalPages = Math.ceil(response.body.total / response.body.per_page);
          } else {}
        }, function (response) {});
      }
    },
    changePage: function changePage(pageNum) {
      this.getPastConsults(pageNum);
    },
    getDocument: function getDocument(consult) {
      __WEBPACK_IMPORTED_MODULE_5__api_customer_document__["a" /* default */].fetch('Prescription', consult.prescription.id).then(function (response) {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank');
        } else {
          alert('Error fetching data');
        }
      }, function (response) {});
    },
    fetchQueries: function fetchQueries() {
      this.queries = !this.queries;

      if (this.queries) {
        this.getPastConsults(1, true);
      } else {
        this.getPastConsults();
      }
    }
  }
});

/***/ }),

/***/ "dVTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Admin_AdminNavbar__ = __webpack_require__("wYs7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Admin_DoctorMain__ = __webpack_require__("B5By");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin_UploadDoctorRoster__ = __webpack_require__("wz3/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DoctorRoster_DoctorSchedule__ = __webpack_require__("ioCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Admin_DoctorChatAvailability__ = __webpack_require__("/VGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MiniMenu__ = __webpack_require__("x+Yt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Admin_AdminLeftPane__ = __webpack_require__("jZmd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Loader__ = __webpack_require__("TmLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Toaster__ = __webpack_require__("bBuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Appointments_Appointments_vue__ = __webpack_require__("49fG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AdminNavbar: __WEBPACK_IMPORTED_MODULE_1__components_Admin_AdminNavbar__["a" /* default */],
    AdminLeftPane: __WEBPACK_IMPORTED_MODULE_7__components_Admin_AdminLeftPane__["a" /* default */],
    MiniMenu: __WEBPACK_IMPORTED_MODULE_6__components_MiniMenu__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_8__components_common_Loader__["a" /* default */],
    Toaster: __WEBPACK_IMPORTED_MODULE_9__components_common_Toaster__["a" /* default */],
    DoctorMain: __WEBPACK_IMPORTED_MODULE_2__components_Admin_DoctorMain__["a" /* default */],
    UploadDoctorRoster: __WEBPACK_IMPORTED_MODULE_3__components_Admin_UploadDoctorRoster__["a" /* default */],
    DoctorSchedule: __WEBPACK_IMPORTED_MODULE_4__components_DoctorRoster_DoctorSchedule__["a" /* default */],
    DoctorChatAvailability: __WEBPACK_IMPORTED_MODULE_5__components_Admin_DoctorChatAvailability__["a" /* default */],
    Appointments: __WEBPACK_IMPORTED_MODULE_11__components_Appointments_Appointments_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedMenu: 'doctor-main'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])({
    isActiveChatPresent: 'consultation/isActiveChatPresent',
    isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
    requests: 'consultationRequest/getRequests',
    alreadyAssignedRequests: 'consultationRequest/getOthersAcceptedRequest',
    patientCancelledRequests: 'consultationRequest/getCancelledRequest',
    activeSection: 'configuration/getActiveSection',
    role: 'configuration/getRole'
  }), {
    incomingRequests: function incomingRequests() {
      this.consultRequests = this.requests;
      this.othersAcceptedRequests = this.alreadyAssignedRequests;
      this.cancelledRequests = this.patientCancelledRequests;
      return this.requests;
    },
    isActiveChat: function isActiveChat() {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true;
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true;
      }
      return false;
    }
  }),
  watch: {
    role: {
      immediate: true,
      handler: function handler(newRole) {
        if (newRole === 'externalAdmin') {
          this.$store.dispatch('configuration/setActiveAdminMiniMenu', 'Appointments');
          this.selectedMenu = 'appointments';
        }
      }
    }
  },
  methods: {
    getAdminMenu: function getAdminMenu(menu) {
      this.selectedMenu = menu;
    }
  }
});

/***/ }),

/***/ "dvBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Standard_vue__ = __webpack_require__("15t0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37bd44e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Standard_vue__ = __webpack_require__("iLSo");
function injectStyle (ssrContext) {
  __webpack_require__("cWAw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Standard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37bd44e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Standard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eBPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex border-r border-grey-lightest border-solid flex-col pin-l justify-between container"},[(_vm.isActiveChat)?[_c('div',{staticClass:"flex flex-row h-12 bg-white justify-between border-solid border-b border-grey-lightest px-4"},[_c('div',{staticClass:"flex flex-col flex-no-shrink self-center mr-auto"},[_c('div',{staticClass:"flex flex-row text-sm items-baseline"},[_c('div',{staticClass:"flex font-semibold mr-1 text-grey-darker capitalize items-center",attrs:{"title":_vm.customer.name}},[_vm._v(_vm._s(_vm.customer.name))]),_vm._v(" "),(_vm.customer.isOnline === true)?_c('div',{staticClass:"bg-green self-center flex-no-shrink flex-no-grow mr-2",staticStyle:{"height":"10px","width":"10px","border-radius":"50%"}}):(_vm.customer.isOnline === false)?_c('div',{staticClass:"bg-red self-center flex-no-shrink flex-no-grow mr-2",staticStyle:{"height":"10px","width":"10px","border-radius":"50%"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-grey-dark font-light text-xs mr-1"},[_vm._v(_vm._s(_vm.dateToAge))]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark text-xs"},[_vm._v(_vm._s(_vm.gender))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row text-sm items-baseline"},[_c('div',{staticClass:"text-grey-darker text-xs pt-1 mr-1"},[_vm._v(_vm._s(_vm.customer.customerId))]),_vm._v(" "),_c('div',{staticClass:"text text-xl mr-1 h-1 w-1 rounded-full bg-black"}),_vm._v(" "),_c('div',{staticClass:"text-grey-darker text-xs pt-1"},[_vm._v(_vm._s(_vm.companyName(_vm.customer)))])])]),_vm._v(" "),_c('div',{staticClass:"relative flex flex-row self-center flex-no-shrink flex-no-grow mx-1"},[_c('div',{staticClass:"flex flex-row self-center"},[(_vm.customer.isFamilyDoctor)?_c('div',{staticClass:"flex py-2 pl-2 pr-3 h-8 self-center text-sm items-center",staticStyle:{"border-radius":"25px","color":"#1b7042","background-color":"#c4f1d8"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ml-2"},[_vm._v("Your Patient")])]):_c('div',{staticClass:"flex bg-grey-lightest h-8 text-dark text-sm py-2 px-3",staticStyle:{"border-radius":"25px"}},[_vm._v("Family Doctor: "),_c('p',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.customer.familyDoctor && _vm.customer.familyDoctor.name ? _vm.customer.familyDoctor.name : 'NA'))])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row self-center ml-auto",class:_vm.timerClass},[_c('div',{staticClass:"flex h-8 text-md px-3 font-semibold items-center rounded-full pb-px",class:_vm.timerBg},[_c('p',[_vm._v("Elapsed time: ")]),_vm._v(_vm._s(_vm.minutes)+"m "+_vm._s(_vm.seconds)+"s")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row self-center ml-2"},[_c('div',{staticClass:"hover:shadow-md flex flex-col self-center justify-center mx-4 items-center ml-auto h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-white bg-green",attrs:{"title":"End Chat"},on:{"click":function($event){return _vm.endConsultation('endChatClicked')}}},[_c('i',{staticClass:"fa fa-xs pl-1 fa-check"})]),_vm._v(" "),_c('div',{staticClass:"hover:shadow-md flex flex-col self-center justify-center mx-4 items-center ml-auto h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-white bg-red",attrs:{"title":"Incomplete Chat"},on:{"click":function($event){return _vm.endConsultation('incompleteChatClicked')}}},[_c('i',{staticClass:"fa fa-xs pl-1 fa-times"})]),_vm._v(" "),_c('div',{staticClass:"flex self-center text-blue text-xs flex-no-shrink flex-no-grow cursor-pointer font-semibold",on:{"click":function($event){return _vm.viewCustomerProfile($event)}}},[_vm._v(" View Profile ")]),_vm._v(" "),(_vm.endChatClicked || _vm.incompleteChatClicked)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeEndChatOverlay()}}}),_vm._v(" "),(_vm.endChatClicked)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Ending this consultation as valid")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeEndChatOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Are you sure you want to end this consult?")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue font-semibold px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.endChat('SUCCESS')}}},[_vm._v("Yes")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white font-semibold ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-blue text-sm hover:shadow-md border border-solid border-grey-lightest",on:{"click":function($event){return _vm.closeEndChatOverlay()}}},[_vm._v("No")])])])]):_vm._e(),_vm._v(" "),(_vm.incompleteChatClicked)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Ending this consultation as invalid")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeEndChatOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Reason for ending the consult as invalid")]),_vm._v(" "),_c('div',{staticClass:"border border-grey-lightest text-grey-darker text-sm border-solid rounded-sm px-1 py-2 my-2 focus:border-blue",staticStyle:{"outline":"none","max-height":"150px","overflow-y":"auto"},attrs:{"id":"editor","contenteditable":"true"},on:{"input":function($event){return _vm.onDivInput($event)}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-between"},[_c('div',{staticClass:"text-xs text-grey-darker self-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.noMessage),expression:"noMessage"}],attrs:{"type":"checkbox","name":"no_messsage","value":"0"},domProps:{"checked":Array.isArray(_vm.noMessage)?_vm._i(_vm.noMessage,"0")>-1:(_vm.noMessage)},on:{"change":function($event){var $$a=_vm.noMessage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.noMessage=$$a.concat([$$v]))}else{$$i>-1&&(_vm.noMessage=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.noMessage=$$c}}}}),_vm._v("  No Message Exchanged")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-blue px-4 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.endChat('FAILURE')}}},[_vm._v("Submit")])])])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('chat-message-container',{attrs:{"messages":_vm.messages,"isActiveChat":_vm.isActiveChat}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row relative pin-b p-2 flex-no-shrink flex-no-grow border-t border-solid border-grey-lightest bg-white overflow-auto",staticStyle:{"min-height":"3.2rem"}},[_c('textarea',{staticClass:"p-2 pr-12 m-2 relative bg-grey-extralight rounded-m border border-solid border-grey-lightest borderRadius-m text-base text-grey-darkest",staticStyle:{"outline":"none","overflow-y":"auto","text-overflow":"auto","line-height":"1","width":"100%","resize":"none"},attrs:{"type":"text","row":"3"},domProps:{"value":_vm.message},on:{"input":_vm.sendTyping,"blur":_vm.sendNotTyping,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addMessage($event)}}}),_vm._v(" "),_c('div',{staticClass:"self-center h-10 w-10",staticStyle:{"position":"absolute","right":"100px","z-index":"1"}},[_c('speech-recognition',{attrs:{"message":_vm.message},on:{"getVoiceMessage":_vm.getVoiceMessage}})],1),_vm._v(" "),_c('div',{staticClass:"hover:shadow-md bg-blue my-2 mr-2 text-white font-semibold text-center rounded self-center flex-no-shrink cursor-pointer",staticStyle:{"padding":"15px 16px"},on:{"click":_vm.addMessage}},[_vm._v(" Send ")])])]:_vm._e(),_vm._v(" "),(_vm.isActivePastChat)?[_c('div',{staticClass:"flex flex-row h-12 bg-white justify-between border-solid border-b border-grey-lightest px-4"},[_c('div',{staticClass:"flex flex-col flex-no-shrink self-center"},[_c('div',{staticClass:"flex flex-row text-sm items-baseline"},[_c('div',{staticClass:"font-semibold mr-2 capitalize",attrs:{"title":_vm.customer.name}},[_vm._v(_vm._s(_vm.pastCustomer.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark font-light text-xs mr-1"},[_vm._v(_vm._s(_vm.PCdateToAge))]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark text-xs"},[_vm._v(_vm._s(_vm.PCgender))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row text-sm items-baseline"},[_c('div',{staticClass:"text-grey-darker text-xs pt-1 mr-1"},[_vm._v(_vm._s(_vm.pastCustomer.customerId))]),_vm._v(" "),_c('div',{staticClass:"text text-xl mr-1 h-1 w-1 rounded-full bg-black"}),_vm._v(" "),_c('div',{staticClass:"text-grey-darker text-xs pt-1"},[_vm._v(_vm._s(_vm.companyName(_vm.pastCustomer)))])])]),_vm._v(" "),_c('div',{staticClass:"relative flex flex-row self-center mx-auto"},[_c('div',{staticClass:"flex flex-row self-center flex-no-shrink flex-no-grow mx-1"},[(_vm.pastCustomer.isFamilyDoctor)?_c('div',{staticClass:"flex py-2 px-3 h-8 self-center text-sm items-center",staticStyle:{"border-radius":"25px","color":"#1b7042","background-color":"#c4f1d8"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"ml-2"},[_vm._v("Your Patient")])]):_c('div',{staticClass:"flex bg-grey-lightest h-8 text-dark text-sm py-2 px-3",staticStyle:{"border-radius":"25px"}},[_vm._v("Family Doctor: "),_c('p',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.pastCustomer.familyDoctor && _vm.pastCustomer.familyDoctor.name ? _vm.pastCustomer.familyDoctor.name : 'NA'))])])])]),_vm._v(" "),_c('div',{staticClass:"flex self-center text-blue text-xs flex-no-shrink flex-no-grow cursor-pointer font-semibold",on:{"click":function($event){return _vm.viewCustomerProfile($event)}}},[_vm._v(" View Profile ")])]),_vm._v(" "),_c('chat-message-container',{attrs:{"messages":_vm.pastCustomer.messages,"isActivePastChat":_vm.isActivePastChat}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-12 bg-white justify-center border-solid border-t border-grey-lightest px-4"},[(!_vm.consultStatus)?_c('div',{staticClass:"hover:shadow-md cursor-pointer self-center bg-green p-2 rounded text-white font-light ml-2 text-sm font-semibold px-4",on:{"click":_vm.reviewSummary}},[_vm._v("Write Summary")]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.viewProfile)?_c('customer-profile',{on:{"viewCustomerProfile":_vm.viewCustomerProfile}}):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('img',{staticClass:"w-5",attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('img',{staticClass:"w-5",attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eEaB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eIUC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJoz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  accept: function accept(id, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/accept', {
      doctor_id: doctorId });
  },
  acceptQuery: function acceptQuery(id, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/accept_query', {
      doctor_id: doctorId });
  },
  reject: function reject(id, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/reject', {
      doctor_id: doctorId
    });
  },
  end: function end(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/success', { doctor_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.configuration.doctorId });
  },
  endIncomplete: function endIncomplete(id) {
    var reasons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/incomplete', { doctor_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.configuration.doctorId, reasons: reasons });
  },
  load_details: function load_details() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/consultation_requests/load_details');
  }
});

/***/ }),

/***/ "eNOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("318Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoticeMixin_js__ = __webpack_require__("TX5P");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BSnackbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__NoticeMixin_js__["a" /* default */]],
  props: {
    actionText: {
      type: String,
      default: 'OK'
    },
    onAction: {
      type: Function,
      default: function _default() {}
    },
    indefinite: {
      type: Boolean,
      default: false
    },
    elementId: {
      type: String,
      default: 'temp'
    },
    request: {
      type: Object,
      default: { status: 'broadcasted' }
    }
  },
  data: function data() {
    return {
      newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].defaultSnackbarDuration
    };
  },

  methods: {
    /**
     * Click listener.
     * Call action prop before closing (from Mixin).
     */
    action: function action() {
      this.onAction();
      this.close();
    }
  }
});

/***/ }),

/***/ "eX/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

// import store from '../../store'

/* harmony default export */ __webpack_exports__["a"] = ({
  uploadDocuments: function uploadDocuments(formData) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/customer/documents', formData);
  },
  uploadLabDocs: function uploadLabDocs(formData, data) {
    var url = '';
    if (data.documentType === 'Lab Report') {
      url = window.API_URL + 'doctors/lab_reports';
    } else {
      url = window.API_URL + 'doctors/prescriptions';
    }
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, formData);
  },

  fetch: function fetch(doctype, docid) {
    var type = 'medical_records';
    if (doctype === 'Prescription') {
      type = 'prescriptions';
    }
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/' + type + '/' + docid + '/download');
  },
  getCustomerUploadedFiles: function getCustomerUploadedFiles(customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/customers/' + customerId + '/consultation_uploads');
  }
});

/***/ }),

/***/ "eZGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-col overflow-y-auto pb-4 bg-grey-extralight",staticStyle:{"height":"calc(100vh - 5rem)"}},[_c('div',{staticClass:"flex flex-col mb-3 py-4 bg-white border-solid border-b border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row bg-white mx-2"},[_c('TextField',{attrs:{"label":"Past Medical History","fieldId":"past_medical_history","value":_vm.past_medical_history},on:{"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('details',{staticClass:"mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight"},[_c('summary',{staticClass:"flex flex-row p-2 py-3 justify-center cursor-pointer"},[_c('div',{staticClass:"text-grey-dark font-semibold mr-auto"},[_vm._v("HRA Info")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark ml-auto"},[_vm._v("Updated on: "),_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v(_vm._s(_vm.healthParameterDate))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col py-1 border-solid border-t border-grey-lighest"},[_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto font-semibold text-grey-darker"},[_vm._v("Diabetes")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.diabetic_treatment === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.diabetic_treatment === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto font-semibold text-grey-darker"},[_vm._v("BP")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.hypertensive_treatment === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.hypertensive_treatment === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto font-semibold text-grey-darker"},[_vm._v("Heart Condition")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.cvd_treatment === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.cvd_treatment === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col mb-3 py-4 bg-white border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-col px-2"},[_c('current-medication',{attrs:{"chatType":_vm.$attrs.chatType,"medication":_vm.medication}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-col mb-3 py-4 bg-white border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Surgical History","fieldId":"surgical_history","value":_vm.surgical_history},on:{"saveChange":_vm.saveChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-col mb-3 py-4 bg-white border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Known Drug Allergies","fieldId":"drug_allergies","value":_vm.drug_allergies},on:{"saveChange":_vm.saveChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Know Food Allergies","fieldId":"food_allergies","value":_vm.food_allergies},on:{"saveChange":_vm.saveChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Family History","fieldId":"family_medical_history","value":_vm.family_medical_history},on:{"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('details',{staticClass:"mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight"},[_c('summary',{staticClass:"flex flex-row p-2 py-3 justify-center cursor-pointer"},[_c('div',{staticClass:"text-grey-dark font-semibold mr-auto"},[_vm._v("HRA Info")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark ml-auto"},[_vm._v("Updated on: "),_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v(_vm._s(_vm.familyHealthParameterDate))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row border border-solid border-dark rounded-sm"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-auto"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getMotherHistory('Diabetes') === 'Yes' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getMotherHistory('Diabetes')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getMotherHistory('Hypertension') === 'Yes' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getMotherHistory('Hypertension')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getMotherHistory('Diabetes') === 'Heart Condition' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getMotherHistory('Heart Condition')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-r border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getMotherHistory('Cancer') === 'Yes' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getMotherHistory('Cancer')))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-auto"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b  border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getFatherHistory('Diabetes') === 'Yes' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getFatherHistory('Diabetes')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b  border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getFatherHistory('Hypertension') === 'Yes' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getFatherHistory('Hypertension')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b  border-dark"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getFatherHistory('Diabetes') === 'Heart Condition' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getFatherHistory('Heart Condition')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2"},[_c('div',{staticClass:"flex font-semibold text-grey-darker",class:_vm.getFatherHistory('Cancer') === 'Yes' ? 'text-red': 'text-green'},[_vm._v(_vm._s(_vm.getFatherHistory('Cancer')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Lifestyle History","fieldId":"social_history","value":_vm.social_history},on:{"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('details',{staticClass:"mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight"},[_c('summary',{staticClass:"flex flex-row p-2 py-3 justify-center cursor-pointer"},[_c('div',{staticClass:"text-grey-dark font-semibold mr-auto"},[_vm._v("HRA Info")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark ml-auto"},[_vm._v("Updated on: "),_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v(_vm._s(_vm.healthParameterDate))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col py-1 border-solid border-t border-grey-lighest"},[_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Low Self Esteem ")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.low_self_esteem === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.low_self_esteem === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Fatigue")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fatigue === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fatigue === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Body Aches")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.body_aches === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.body_aches === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Anxiety")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.anxiety === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.anxiety === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Nervous Breakdown")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.nervous_breakdown === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.nervous_breakdown === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Stress Eating")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.stress_eating === 'true')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Yes")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.stress_eating === 'false')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Diet Assessment","fieldId":"diet_assessment","value":_vm.diet_assessment},on:{"saveChange":_vm.saveChange}})],1),_vm._v(" "),_c('details',{staticClass:"mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight"},[_c('summary',{staticClass:"flex flex-row p-2 py-3 justify-center cursor-pointer"},[_c('div',{staticClass:"text-grey-dark font-semibold mr-auto"},[_vm._v("HRA Info")]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark ml-auto"},[_vm._v("Updated on: "),_c('span',{staticClass:"text-grey-dark font-semibold"},[_vm._v(_vm._s(_vm.healthParameterDate))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col py-1 border-solid border-t border-grey-lighest"},[_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Whole Grains")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.whole_grains === '2')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Low")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.whole_grains === '1')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("Medium")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.whole_grains === '0')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("High")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Fruits and Vegetables")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fruits_and_vegetables === '2')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("Low")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fruits_and_vegetables === '1')?_c('div',{staticClass:"flex ml-auto font-semibold text-yellow"},[_vm._v("Medium")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fruits_and_vegetables === '0')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("High")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Fried Foods and Refined Carbohydrates")]),_vm._v(" "),(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fried_foods_and_refined_carbohydrates === '2')?_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("Low")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fried_foods_and_refined_carbohydrates === '1')?_c('div',{staticClass:"flex ml-auto font-semibold text-yellow"},[_vm._v("Medium")]):(_vm.customer && _vm.customer.details && _vm.customer.details.health_parameters && _vm.customer.details.health_parameters.fried_foods_and_refined_carbohydrates === '0')?_c('div',{staticClass:"flex ml-auto font-semibold text-red"},[_vm._v("High")]):_c('div',{staticClass:"flex ml-auto font-semibold text-grey-dark"},[_vm._v("NA")])])])])]),_vm._v(" "),(!_vm.customer.details.gender || _vm.customer.details.gender !== 'Male')?_c('div',{staticClass:"flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row mx-2"},[_c('TextField',{attrs:{"label":"Menstrual History","fieldId":"menstrual_history","value":_vm.menstrual_history},on:{"saveChange":_vm.saveChange}})],1)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("Patient History")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row justify-center mx-4 py-2"},[_c('div',{staticClass:"flex mr-auto font-semibold text-grey-darker"},[_vm._v("Cancer")]),_vm._v(" "),_c('div',{staticClass:"flex ml-auto font-semibold text-green"},[_vm._v("No")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-64"},[_c('div',{staticClass:"flex flex-row h-6 justify-center bg-white px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex mr-auto text-grey-darker self-center"},[_vm._v("Medical Problem")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Diabetes")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("BP")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Heart Condition")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center px-4 py-2 border-solid border-r border-dark"},[_c('div',{staticClass:"flex mr-auto text-grey-darker font-semibold"},[_vm._v("Cancer")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-6 justify-center bg-white px-4 py-2 border-solid border-b border-r border-dark"},[_c('img',{staticClass:"flex mr-auto w-6",attrs:{"src":__webpack_require__("Z8dw")}}),_vm._v(" "),_c('div',{staticClass:"flex pl-2 text-grey-darker self-center"},[_vm._v("Mother")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-6 justify-center bg-white px-4 py-2 border-solid border-b border-dark"},[_c('img',{staticClass:"flex mr-auto w-6",attrs:{"src":__webpack_require__("d3DZ")}}),_vm._v(" "),_c('div',{staticClass:"flex pl-2 text-grey-darker self-center"},[_vm._v("Father")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "efRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "f71c":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MDAgNTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzY2NjY2Njt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ2MS43LDQ2MC45Yy00LjksNC45LTExLjMsNy4zLTE3LjcsNy4zYy02LjQsMC0xMi44LTIuNC0xNy43LTcuM2wtMTc2LTE3NS42bC0xNzUuNiwxNzYKCQljLTQuOSw0LjktMTEuMyw3LjQtMTcuNyw3LjRjLTYuNCwwLTEyLjgtMi40LTE3LjctNy4zYy05LjgtOS44LTkuOC0yNS42LDAtMzUuNGwxNzUuNi0xNzZMMzguOCw3NC41Yy05LjgtOS44LTkuOC0yNS42LDAtMzUuMwoJCWM5LjgtOS44LDI1LjYtOS44LDM1LjQsMGwxNzYsMTc1LjZsMTc1LjYtMTc2YzkuOC05LjgsMjUuNi05LjgsMzUuMywwYzkuOCw5LjgsOS44LDI1LjYsMCwzNS4zTDI4NS42LDI1MGwxNzYuMSwxNzUuNgoJCUM0NzEuNCw0MzUuMyw0NzEuNSw0NTEuMSw0NjEuNyw0NjAuOXoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "fB3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  isVisible: false,
  type: null, // success & error
  message: null
};

var getters = {
  toasterState: function toasterState() {
    return state;
  }
};

var actions = {
  setToaster: function setToaster(_ref, toaster) {
    var commit = _ref.commit;

    commit('setToaster', toaster);
    setTimeout(function () {
      commit('setToaster', { status: false, type: null, message: null });
    }, 3000);
  }
};

var mutations = {
  setToaster: function setToaster(state, toaster) {
    state.isVisible = toaster.status;
    state.type = toaster.type;
    state.message = toaster.message;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "fbz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftPane_vue__ = __webpack_require__("Zmdn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c31c936_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftPane_vue__ = __webpack_require__("rqYd");
function injectStyle (ssrContext) {
  __webpack_require__("KTTO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c31c936_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftPane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ffOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDrug_vue__ = __webpack_require__("FNwy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ccd2ffc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDrug_vue__ = __webpack_require__("SQQG");
function injectStyle (ssrContext) {
  __webpack_require__("RSzj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ccd2ffc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDrug_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ccd2ffc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDrug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fiF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  storeMessage: function storeMessage(message) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/store_messages', { message: message });
  }
});

/***/ }),

/***/ "fyV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Custom_vue__ = __webpack_require__("CMP/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fad81fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Custom_vue__ = __webpack_require__("vwW0");
function injectStyle (ssrContext) {
  __webpack_require__("y4/U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Custom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fad81fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Custom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g8Eo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gEdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessageContainer_vue__ = __webpack_require__("6/b1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59b5cdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessageContainer_vue__ = __webpack_require__("T5iq");
function injectStyle (ssrContext) {
  __webpack_require__("V0vx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessageContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59b5cdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessageContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ggx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HealthCoachProgress_vue__ = __webpack_require__("kiJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PatientHra_vue__ = __webpack_require__("z7QW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_health_coach__ = __webpack_require__("j9/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_customer_general__ = __webpack_require__("4/zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_hra_mixin__ = __webpack_require__("SJtH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatientTests_vue__ = __webpack_require__("CkZI");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_hra_mixin__["a" /* default */]],
  components: {
    HealthCoachProgress: __WEBPACK_IMPORTED_MODULE_4__HealthCoachProgress_vue__["a" /* default */],
    PatientHra: __WEBPACK_IMPORTED_MODULE_5__PatientHra_vue__["a" /* default */],
    PatientTests: __WEBPACK_IMPORTED_MODULE_13__PatientTests_vue__["a" /* default */],
    VueApexCharts: __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts___default.a
  },
  data: function data() {
    return {
      selectWeek: false,
      editGoal: { edit: false, name: '', prevValue: '' },
      programEnrollmentId: null,
      drawerVisible: false,
      selectedChart: 'weight',
      stepsUnit: 'day',
      showTests: false,
      reportsData: {},
      summaryData: {},
      chartTypes: {
        weight: 'Weight',
        bloodSugar: 'Blood Sugar',
        bloodPressure: 'Blood Pressure',
        HbA1c: 'HbA1c'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    programDetails: 'healthCoach/getProgramDetails',
    goals: 'healthCoach/getCurrentGoals',
    vitals: 'healthCoach/getVitals',
    progress: 'healthCoach/getProgress',
    currentWeek: 'healthCoach/getVitalsWeek',
    dailyStepsData: 'healthCoach/getDailySteps',
    weeklyStepsData: 'healthCoach/getWeeklySteps',
    timelineAndProgress: 'healthCoach/getTimelineAndProgress'
  }), {
    currentVitals: function currentVitals() {
      var _this = this;

      return this.vitals.filter(function (ele) {
        return ele.week.toString() === _this.currentWeek.toString();
      });
    },
    goalsList: function goalsList() {
      return this.addGoals;
    },
    uniqueWeeks: function uniqueWeeks() {
      var weeks = this.vitals.map(function (v) {
        return v.week;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(weeks)));
    },
    weightChartOptions: function weightChartOptions() {
      var _this2 = this;

      return {
        chart: {
          id: 'weight-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('weight').map(function (v) {
            return _this2.formatDate(v.created_at);
          })
        },
        stroke: {
          width: 3,
          colors: ['#2168F3']
        },
        markers: {
          size: 4,
          colors: ['#2168F3']
        }
      };
    },
    weightSeriesData: function weightSeriesData() {
      return [{
        name: 'Weight',
        data: this.getVitalsByName('weight').map(function (v) {
          return v.current_value;
        })
      }];
    },
    bloodSugarChartOptions: function bloodSugarChartOptions() {
      var _this3 = this;

      return {
        chart: {
          id: 'blood-sugar-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('blood_sugar').map(function (v) {
            return _this3.formatDate(v.created_at);
          })
        },
        stroke: {
          width: 3,
          colors: ['#2168F3']
        },
        markers: {
          size: 4,
          colors: ['#2168F3']
        }
      };
    },
    bloodSugarSeriesData: function bloodSugarSeriesData() {
      return [{
        name: 'Blood Sugar',
        data: this.getVitalsByName('blood_sugar').map(function (v) {
          return v.current_value;
        })
      }];
    },
    bloodPressureChartOptions: function bloodPressureChartOptions() {
      var _this4 = this;

      return {
        chart: {
          id: 'blood-pressure-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('blood_pressure').map(function (v) {
            return _this4.formatDate(v.created_at);
          })
        },
        stroke: {
          width: 3,
          colors: ['#2168F3', '#FF6969']
        },
        markers: {
          size: 4,
          colors: ['#2168F3', '#FF6969']
        },
        legend: {
          labels: {
            colors: ['#2168F3', '#FF6969'],
            useSeriesColors: false
          },
          markers: {
            fillColors: ['#2168F3', '#FF6969']
          }
        }
      };
    },
    bloodPressureSeriesData: function bloodPressureSeriesData() {
      return [{
        name: 'systolic',
        data: this.systolicBloodPressure()
      }, {
        name: 'diastolic',
        data: this.diastolicBloodPressure()
      }];
    },
    hba1cChartOptions: function hba1cChartOptions() {
      var _this5 = this;

      return {
        chart: {
          id: 'hba1c-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('hba1c').map(function (v) {
            return _this5.formatDate(v.created_at);
          })
        },
        stroke: {
          width: 3,
          colors: ['#2168F3']
        },
        markers: {
          size: 4,
          colors: ['#2168F3']
        }
      };
    },
    hba1cSeriesData: function hba1cSeriesData() {
      return [{
        name: 'HbA1c',
        data: this.getVitalsByName('hba1c').map(function (v) {
          return v.current_value;
        })
      }];
    },
    dailyStepsChartOptions: function dailyStepsChartOptions() {
      var _this6 = this;

      return {
        chart: {
          id: 'steps-chart',
          toolbar: {
            show: false
          },
          width: 1200
        },
        xaxis: {
          categories: this.dailyStepsData.map(function (v) {
            return _this6.formatDate(v.date);
          })
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: '50%'
          }
        },
        dataLabels: {
          enabled: false
        }
      };
    },
    dailyStepsSeriesData: function dailyStepsSeriesData() {
      return [{
        name: 'Steps',
        data: this.dailyStepsData.map(function (v) {
          return v.count;
        })
      }];
    },
    weeklyStepsChartOptions: function weeklyStepsChartOptions() {
      return {
        chart: {
          id: 'steps-chart',
          toolbar: {
            show: false
          },
          width: 1200
        },
        xaxis: {
          categories: this.weeklyStepsData.map(function (v) {
            return v.week;
          })
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: '50%'
          }
        },
        dataLabels: {
          enabled: false
        }
      };
    },
    weeklyStepsSeriesData: function weeklyStepsSeriesData() {
      return [{
        name: 'Steps',
        data: this.weeklyStepsData.map(function (v) {
          return v.count;
        })
      }];
    },
    chartWidth: function chartWidth() {
      var baseWidth = 30;
      var padding = 50;

      var data = this.stepsUnit === 'week' ? this.weeklyStepsSeriesData[0].data || [] : this.dailyStepsSeriesData[0].data || [];
      var finalWidth = data.length * baseWidth + padding;

      if (finalWidth < 400) {
        return 400;
      } else if (finalWidth > 1200) {
        return 1200;
      } else {
        return finalWidth;
      }
    }
  }),
  watch: {
    goals: function goals(newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.prevGoals = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.goals));
      }
    },
    customer: function customer(newVal, oldVal) {
      if (newVal.customerId !== oldVal.customerId) {
        this.getHealthCoachDetails();
      }
    }
  },
  mounted: function mounted() {
    this.getHealthCoachDetails();
  },

  methods: {
    getHealthCoachDetails: function getHealthCoachDetails() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_health_coach__["a" /* default */].getHealthCoachDetails(this.customer.customerId).then(function (response) {
        _this7.$store.dispatch('healthCoach/healthCoachInitialState', { data: response.data });
        _this7.programEnrollmentId = response.data.program_enrollment_id;
        _this7.getCustomerGoalVitals();
        _this7.getDailyCustomerSteps();
        _this7.getWeeklyCustomerSteps();
        _this7.getTimelineAndProgress();
      }).catch(function (err) {
        _this7.progress = [];
        if (err.status === 404) {
          _this7.$toast.open({
            message: 'Not enrolled in a program',
            type: 'warning',
            position: 'top',
            queue: false
          });
        } else if (err.status === 500) {
          _this7.$toast.open({
            message: 'Error fetching health coach details',
            type: 'error',
            position: 'top',
            queue: false
          });
        }
      });
      this.prevGoals = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.goals));
    },
    getCustomerGoalVitals: function getCustomerGoalVitals() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_health_coach__["a" /* default */].getCustomerGoalVitals(this.programEnrollmentId, this.customer.customerId).then(function (response) {
        _this8.$store.dispatch('healthCoach/setCustomerVitals', { data: response.data });
      });
    },

    saveGoal: function saveGoal() {
      var _this9 = this;

      var val = this.goals;
      var programEnrollmentId = this.programEnrollmentId;

      this.$store.dispatch('healthCoach/updateGoal', { programEnrollmentId: programEnrollmentId, val: val }).then(function () {
        _this9.editGoal.edit = false;
      }).catch(function (error) {
        _this9.$toast.warning('Failed to save goal: ' + error + '. Please try again.', {
          position: 'top',
          duration: 5000,
          queue: false
        });
      });
    },
    changeWeek: function changeWeek(week) {
      this.$store.dispatch('healthCoach/changeVitalsWeek', { week: week });
      this.selectWeek = false;
    },
    openInsights: function openInsights() {
      this.drawerVisible = true;
    },
    formatDate: function formatDate(isoString) {
      var date = new Date(isoString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short'
      });
    },
    getVitalsByName: function getVitalsByName(name) {
      return this.vitals.filter(function (ele) {
        return ele.name === name;
      }).sort(function (ele1, ele2) {
        return new Date(ele1.created_at) - new Date(ele2.created_at);
      });
    },
    lastUpdateAt: function lastUpdateAt(name) {
      var vitals = this.getVitalsByName(name);
      if (!vitals.length) return 'No data available';
      var lastVital = vitals.slice(-1)[0];
      return this.formatDate(lastVital.created_at);
    },
    systolicBloodPressure: function systolicBloodPressure() {
      return this.getVitalsByName('blood_pressure').map(function (v) {
        return v.current_value.split('/')[0];
      });
    },
    diastolicBloodPressure: function diastolicBloodPressure() {
      return this.getVitalsByName('blood_pressure').map(function (v) {
        return v.current_value.split('/')[1];
      });
    },
    getDailyCustomerSteps: function getDailyCustomerSteps() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_7__api_customer_general__["a" /* default */].fetchSteps(this.customer.customerId, this.programDetails.enrollmentDate, 'day').then(function (response) {
        _this10.$store.dispatch('healthCoach/setDailyCustomerSteps', { data: response.data });
      });
    },
    getWeeklyCustomerSteps: function getWeeklyCustomerSteps() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_7__api_customer_general__["a" /* default */].fetchSteps(this.customer.customerId, this.programDetails.enrollmentDate, 'week').then(function (response) {
        _this11.$store.dispatch('healthCoach/setWeeklyCustomerSteps', { data: response.data });
      });
    },
    stepsLastUpdateAt: function stepsLastUpdateAt(unit) {
      if (unit === 'day') {
        if (this.dailyStepsData === undefined || this.dailyStepsData.length === 0) {
          return 'No data available';
        }
        return this.formatDate(this.dailyStepsData.slice(-1)[0].date);
      } else {
        if (this.weeklyStepsData === undefined || this.weeklyStepsData.length === 0) {
          return 'No data available';
        }
        return this.formatDate(this.weeklyStepsData.slice(-1)[0].start_date);
      }
    },
    getTimelineAndProgress: function getTimelineAndProgress() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_health_coach__["a" /* default */].getTimelineAndProgress(this.customer.customerId).then(function (response) {
        _this12.$store.dispatch('healthCoach/setTimelineAndProgress', { data: response.data });
      });
    },
    getIcon: function getIcon(status) {
      if (status === 'received' || status === 'completed') {
        return __webpack_require__("j/3f");
      } else if (status === 'scheduled' || status === 'in_progress') {
        return __webpack_require__("MCWQ");
      }
    },
    getActivityDetails: function getActivityDetails(activity) {
      var _this13 = this;

      var type = '';
      console.log(activity.cta_text);
      if (activity.cta_text === 'View reports') {
        type = 'reports';
      } else if (activity.cta_text === 'View summary') {
        type = 'summary';
      }

      __WEBPACK_IMPORTED_MODULE_6__api_health_coach__["a" /* default */].getActivityDetails(this.customer.details.id, activity.activity_id, type).then(function (response) {
        if (type === 'reports') {
          _this13.reportsData = response.data;
          _this13.showTests = true;
        } else if (type === 'summary') {
          _this13.$set(_this13.summaryData, activity.activity_id, response.data.summary);
        }
      });
    }
  }
});

/***/ }),

/***/ "gqxa":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gwqB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gxl/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-y-auto"},[_vm._l((_vm.consultations),function(cp,index){return _c('div',{key:index,staticClass:"flex flex-col px-3 py-4 flex-no-shrink flex-no-grow justify-center border-b border-solid border-grey-lightest hover:bg-grey-extralight cursor-pointer",class:(cp.consultation.consultationId === _vm.activePastConsultId) ? 'bg-grey-extralight': '',on:{"click":function($event){return _vm.selectFromPastList(cp.consultation.consultationId)}}},[_c('div',{staticClass:"flex flex-row items-center h-8 mb-2"},[_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"flex items-center h-4"},[_c('div',{staticClass:"text-sm font-semibold text-grey-darkest capitalize"},[_vm._v("\n              "+_vm._s(cp.name ? cp.name : 'No Name')+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"text-grey-dark text-xs mt-1"},[_vm._v(_vm._s(cp.channelId))])]),_vm._v(" "),(cp.isFamilyDoctor)?_c('div',{staticClass:"flex ml-auto"},[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-4"},[(_vm.consultStatus(cp))?_c('div',{staticClass:"text-xs font-semibold text-green-light font-light"},[_vm._v("Case Closed")]):_c('div',{staticClass:"text-xs font-semibold text-red-light font-light"},[_vm._v("Summary Pending")]),_vm._v(" "),(cp.consultation.date !== '')?_c('div',{staticClass:"text-xs ml-auto text-grey-dark font-light"},[_vm._v(_vm._s(_vm._f("formatDate")(cp.consultation.date)))]):_vm._e()])])}),_vm._v(" "),(_vm.showLoadMore)?_c('div',{staticClass:"flex flex-col h-12 justify-center"},[_c('div',{staticClass:"flex px-3 py-1 justify-end cursor-pointer italic rounded-sm text-blue text-sm hover:text-grey-darker",on:{"click":_vm.fetchMoreConsults}},[_vm._v("\n      Load more . . .\n    ")])]):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h1kQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h6cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/* harmony default export */ __webpack_exports__["a"] = ({
  getCustomerDetails: function getCustomerDetails(customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/customers/' + customerId + '/profile');
  }
});

/***/ }),

/***/ "hm3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col m-4"},[_c('div',{staticClass:"flex flex-row bg-white p-1 justify-center"},[_c('div',{staticClass:"text-grey text-m mx-6 font-semibold cursor-pointer",class:_vm.upload === 'doctorRoster' ? 'text-blue' : 'hover:text-blue',on:{"click":function($event){_vm.upload = 'doctorRoster'}}},[_vm._v("Upload Doctor Roster")]),_vm._v(" "),_c('div',{staticClass:"text-grey text-m mx-6 font-semibold cursor-pointer",class:_vm.upload === 'chatAvailability' ? 'text-blue' : 'hover:text-blue',on:{"click":function($event){_vm.upload = 'chatAvailability'}}},[_vm._v("Upload Chat Availability")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-lightest self-center mb-4",staticStyle:{"height":"0.125rem","width":"420px"}},[_c('div',{staticClass:"w-1/2",class:[_vm.upload === 'doctorRoster' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/2",class:[_vm.upload === 'chatAvailability' ? 'bg-blue' : '']})]),_vm._v(" "),(_vm.upload === 'doctorRoster')?_c('div',{staticClass:"m-4"},[_c('p',{staticClass:"text-sm py-6 text-center"},[_vm._v(" Please select a file to upload")]),_vm._v(" "),_c('div',{staticClass:"fieldsDiv"},[_c('div',{staticClass:"message display:flex flex-direction:column"},[_c('div',{staticClass:"border-b border-solid w-64 h-8 text-align"},[_c('p',{staticClass:"pt-3 text-m truncate"},[_vm._v(_vm._s(_vm.rosterFile.name))])]),_vm._v(" "),_c('div',{staticClass:"text-xs py-1 "},[_vm._v("\n          "+_vm._s(_vm.message)+"\n        ")])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"px-4 items-center margin-top:-9px"},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"db-file-upload"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label width:100%"},[_c('input',{ref:"file",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".csv, .pdf, .png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('div',{staticClass:"hover:shadow-md self-center bg-blue p-2 px-3 rounded text-white text-xs font-light cursor-pointer"},[_vm._v("Select")])])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.upload === 'doctorRoster')?_c('div',{staticClass:"buttons"},[_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4",class:!_vm.rosterFile || !_vm.rosterFile.name ? 'cursor-not-allowed' : 'cursor-pointer',on:{"click":function($event){_vm.rosterFile && _vm.rosterFile.size && _vm.submitRosterFile()}}},[_vm._v("Upload")])])]):_vm._e(),_vm._v(" "),(_vm.upload === 'chatAvailability')?_c('div',{staticClass:"m-4"},[_c('p',{staticClass:"text-sm py-6 text-center"},[_vm._v(" Please select a file to upload chat availability")]),_vm._v(" "),_c('div',{staticClass:"fieldsDiv"},[_c('div',{staticClass:"message display:flex flex-direction:column"},[_c('div',{staticClass:"border-b border-solid w-64 h-8 text-align"},[_c('p',{staticClass:"pt-3 text-m truncate"},[_vm._v(_vm._s(_vm.chatFile.name))])]),_vm._v(" "),_c('div',{staticClass:"text-xs py-1 "},[_vm._v("\n          "+_vm._s(_vm.message)+"\n        ")])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"px-4 items-center margin-top:-9px"},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"db-file-upload"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label width:100%"},[_c('input',{ref:"chatfile",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".pdf, .png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.handleChatFileUpload()}}}),_vm._v(" "),_c('div',{staticClass:"hover:shadow-md self-center bg-blue p-2 px-3 rounded text-white text-xs font-light cursor-pointer"},[_vm._v("Select")])])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.upload === 'chatAvailability')?_c('div',{staticClass:"buttons"},[_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4",class:!_vm.chatFile || !_vm.chatFile.name ? 'cursor-not-allowed' : 'cursor-pointer',on:{"click":function($event){_vm.chatFile && _vm.chatFile.size && _vm.submitChatFile()}}},[_vm._v("Upload")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hoQL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bulb.e59d2f8.png";

/***/ }),

/***/ "iAtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderLabs_vue__ = __webpack_require__("RaxJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5365ed6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderLabs_vue__ = __webpack_require__("XmHG");
function injectStyle (ssrContext) {
  __webpack_require__("eEaB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderLabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5365ed6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderLabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iJrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorNotification_vue__ = __webpack_require__("Tb1b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542f65fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorNotification_vue__ = __webpack_require__("aqFV");
function injectStyle (ssrContext) {
  __webpack_require__("Rd3L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542f65fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iLSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-y-auto py-2"},[_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iQwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isCompanyDoctor)?_c('div',{staticClass:"class='flex flex-col overflow-y-auto'"},_vm._l((_vm.requests),function(patient,index){return _c('div',{key:index,staticClass:"hover:bg-grey-extralight flex flex-col px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest justify-center cursor-pointer"},[_c('div',{staticClass:"flex flex-row justify-between mb-1 h-4"},[_c('div',{staticClass:"text-sm font-semibold text-grey-darkest capitalize"},[_vm._v(_vm._s(patient.customer_name))]),_vm._v(" "),(patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'missed')?_c('div',[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("xf//"),"alt":"Personal Patient"}})]):_vm._e(),_vm._v(" "),(patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'queried')?_c('div',{staticClass:"py-1 px-2 self-center text-xs font-semibold justify-center items-center",staticStyle:{"border-radius":"25px","color":"#70411b","background-color":"#faedce"}},[_vm._v("Query")]):_vm._e(),_vm._v(" "),(patient.isFamilyDoctor && patient.status === 'unicasted')?_c('div',[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("3Zfj"),"alt":"Personal Patient"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between mb-2"},[_c('div',{staticClass:"text-sm font-light text-grey-dark truncate"},[_vm._v(_vm._s(patient.chiefComplaint))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row text-xs mt-1 justify-between"},[_c('div',{staticClass:"text-xs font-light text-grey-dark"},[_vm._v(_vm._s(_vm._f("formatDate")(patient.time)))]),_vm._v(" "),(patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'queried')?_c('div',[_c('button',{staticClass:"text-blue font-semibold ml-auto",on:{"click":function($event){return _vm.acceptQuery(patient)}}},[_vm._v("REPLY")])]):(patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'missed')?_c('div',[_c('button',{staticClass:"text-blue font-semibold ml-auto",on:{"click":function($event){return _vm.acceptQuery(patient)}}},[_vm._v("RESPOND BACK")])]):_c('div',[_c('button',{staticClass:"text-blue ml-auto font-semibold mr-2",on:{"click":function($event){return _vm.accept(patient)}}},[_vm._v("ACCEPT")])])])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iTEw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ioCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorSchedule_vue__ = __webpack_require__("JabX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f52adf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorSchedule_vue__ = __webpack_require__("kn1c");
function injectStyle (ssrContext) {
  __webpack_require__("h1kQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f52adf7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f52adf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iqkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.data),function(item,key,index){return _c('div',{key:index},[_c('details',{staticClass:"flex flex-col border-solid border-b border-grey-extralight"},[_c('summary',{staticClass:"flex flex-row text-grey h-12 bg-grey-lightest px-4 cursor-pointer"},[_c('div',{staticClass:"text-xs self-center mx-5 text-grey-dark pointer-none"},[_vm._v(_vm._s(key ? key : '-'))]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mx-auto items-baseline self-center"},[_c('div',{staticClass:"-ml-24 text-xs text-grey-dark "},[_vm._v("APPOINTMENTS")]),_vm._v(" "),_c('div',{staticClass:"text-l font-semibold text-grey-darkest"},[_vm._v("  "+_vm._s(item.length))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"grid_container bg-grey-extralight"},[_c('div',{staticClass:"item_header"},[_vm._v("Apt. Time")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Patient ID")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Patient Email")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Patient Name")]),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Mobile Number")]),_vm._v(" "),(!['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item_header"},[_vm._v("Requested for")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Program Name")]),_vm._v(" "),(['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item_header"},[_vm._v("Mode")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Status")]),_vm._v(" "),(['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item_header"},[_vm._v("Assigned to")]):_vm._e(),_vm._v(" "),(!['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item_header"},[_vm._v("Remarks")]):_vm._e(),_vm._v(" "),(['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item_header"},[_vm._v("Consult type")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item_header"},[_vm._v("Actions")])]),_vm._v(" "),_vm._l((item),function(row,index){return _c('div',{key:index,staticClass:"grid_container"},[_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.date_of_appointment ? row.date_of_appointment : '-'))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.ek_id))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.email))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.mobile_number))]),_vm._v(" "),(!['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.service_requested))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("\n            "+_vm._s(row.program ? row.program : 'NA')+"\n            "),(row.program && row.service_type)?_c('div',[_vm._v("\n              "+_vm._s(("(" + (row.service_type) + " consultation)"))+"\n            ")]):_vm._e()]),_vm._v(" "),(['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item flex flex-col"},[_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.service_mode))]),_vm._v(" "),_c('div',{staticClass:"flex"},[(_vm.role === 'specialistDoctor' && row.service_mode === 'Video' && row.meeting_link && _vm.menu === 0)?_c('a',{staticClass:"text-xs font-semibold",class:[_vm.disableJoinButton(row.appointment_time) ? 'text-grey cursor-pointer' : 'text-blue cursor-pointer hover:underline'],attrs:{"href":_vm.disableJoinButton(row.appointment_time) ? null : row.meeting_link,"target":"_blank","rel":"noopener noreferrer"},on:{"click":function($event){return _vm.handleMeetingLinkClick(row)}}},[_vm._v("\n                Join meet link\n              ")]):_vm._e(),_vm._v(" "),(_vm.role === 'specialistDoctor' && row.service_mode === 'Video' && row.meeting_link && _vm.menu === 0)?_c('img',{staticClass:"cursor-pointer ml-2 h-3 w-3",attrs:{"title":"Copy meeting link","src":__webpack_require__("2IkP"),"alt":"copy"},on:{"click":function($event){return _vm.copyLinkHandler(row)}}}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.role === 'externalAdmin')?_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.status))]):_c('div',{staticClass:"item"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(row.status),expression:"row.status"}],staticClass:"-mt-4",attrs:{"name":"status","placeholder":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(row, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.statusChanged(row.status, row.id)}]}},[(_vm.menu === 0)?_c('option',{attrs:{"value":"scheduled"}},[_vm._v("Scheduled")]):_vm._e(),_vm._v(" "),(_vm.menu === 1 || (_vm.role !== 'specialistDoctor' && _vm.menu === 0))?_c('option',{attrs:{"value":"completed"}},[_vm._v("Completed")]):_vm._e(),_vm._v(" "),(_vm.menu === 0 || _vm.menu === 3)?_c('option',{attrs:{"value":"incomplete"}},[_vm._v("Incomplete")]):_vm._e(),_vm._v(" "),(_vm.menu === 4 || (_vm.role !== 'specialistDoctor' && _vm.menu === 0))?_c('option',{attrs:{"value":"rejected"}},[_vm._v("Rejected")]):_vm._e(),_vm._v(" "),(_vm.menu === 5)?_c('option',{attrs:{"value":"received"}},[_vm._v("Received")]):_vm._e()])])]),_vm._v(" "),(['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',[(row.consult_type === 'Priority' && _vm.role === 'externalAdmin' && _vm.menu === 6)?_c('div',{staticClass:"item font-semibold cursor-pointer",staticStyle:{"color":"#0951E1"},on:{"click":function($event){return _vm.toggleModal(row)}}},[_vm._v("Assign Doctor")]):_c('div',{staticClass:"item",staticStyle:{"color":"#00A04F"}},[_vm._v(_vm._s(row.assigned_doctor))])]):_vm._e(),_vm._v(" "),(!['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item flex flex-row"},[_c('i',{staticClass:"fas fa-eye text-blue cursor-pointer",attrs:{"id":"remark_preview_icon"}},[_c('div',{staticClass:"relative",attrs:{"id":"remark_preview"}},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-2 rounded overflow-y-auto",staticStyle:{"width":"300px"}},[(row.comments == null || row.comments == '')?_c('div',{staticClass:"text-black text-xs font-sans leading-tight",staticStyle:{"word-break":"break-all"},attrs:{"id":"remark_preview_text"}},[_vm._v("No Remarks Added")]):_c('div',{staticClass:"text-black text-xs font-sans leading-tight",staticStyle:{"word-break":"break-all"},attrs:{"id":"remark_preview_text"}},[_vm._v(_vm._s(row.comments))])])])]),_vm._v(" "),_c('span',[_vm._v("    ")]),_vm._v(" "),_c('i',{staticClass:"far fa-edit text-blue cursor-pointer",attrs:{"id":("remark_edit_icon" + (row.id))},on:{"click":function($event){return _vm.showRemarkEdit(row.id)}}},[_c('div',{staticClass:"relative",staticStyle:{"display":"none"},attrs:{"id":("remark_edit" + (row.id))}},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-3 rounded overflow-y-auto",staticStyle:{"width":"300px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.comments),expression:"row.comments"}],staticClass:"rounded-sm text-black text-xs font-sans leading-tight outline-none py-2 px-2",staticStyle:{"word-break":"break-all","width":"auto"},attrs:{"type":"text","name":"remark_input","placeholder":"Enter your remark here"},domProps:{"value":(row.comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "comments", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-end mt-3 font-sans text-xs"},[_c('div',{staticClass:"mx-3 cursor-pointer",on:{"click":function($event){return _vm.remarkChanged(row.comments, row.id)}}},[_vm._v("Save")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.hideRemarkEdit(row.id)}}},[_vm._v("Cancel")])])])])])]):_vm._e(),_vm._v(" "),(['externalAdmin', 'specialistDoctor'].includes(_vm.role))?_c('div',{staticClass:"item"},[_vm._v(_vm._s(row.consult_type))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item flex justify-start"},[(_vm.role !== 'externalAdmin')?_c('div',{staticClass:"item flex justify-center"},[(_vm.menu === 0 && _vm.disableStartConsultation(row))?_c('button',{staticClass:"flex-no-shrink hover:shadow-md flex-no-grow px-3 bg-grey-light text-white rounded text-center py-2 items-center self-center cursor-not-allowed",attrs:{"id":"remark_preview_icon"}},[_vm._v("\n                Start Consult\n                "),_vm._m(2,true)]):_vm._e(),_vm._v(" "),(_vm.menu === 0 && !_vm.disableStartConsultation(row))?_c('button',{staticClass:"flex-no-shrink hover:shadow-md flex-no-grow px-3 bg-blue text-white rounded text-center py-2 items-center self-center cursor-pointer",on:{"click":function($event){return _vm.startConsultation(row)}}},[_vm._v("\n                Start Consult\n              ")]):_vm._e(),_vm._v(" "),(_vm.menu === 1 && _vm.role !== 'specialistDoctor')?_c('div',{staticClass:"db-file-upload hover:shadow-md flex-no-shrink flex-no-grow px-3 bg-blue text-white rounded text-center py-2 items-center self-center cursor-pointer",on:{"click":function($event){return _vm.openUploadDocModal(row, key)}}},[_vm._v("\n                Upload\n              ")]):_vm._e(),_vm._v(" "),(_vm.menu == 2 && row.consultation_documents.length !== 0)?_c('div',{staticClass:"flex flex-no-shrink flex-no-grow px-2 py-1 mx-1 border border-blue bg-white text-blue rounded items-center self-center relative cursor-pointer",on:{"click":function($event){return _vm.toggleUploadDialogBox(row.id)}}},[_c('i',{staticClass:"fas fa-chevron-down",attrs:{"id":("upload_dialog_icon" + (row.id))}}),_vm._v(" "),_c('div',{staticClass:"z-10 absolute flex flex-col flex-shrink pin-r pin-t mt-6 -mr-1 bg-grey-lightest shadow-md px-3 py-3 rounded overflow-y-auto",staticStyle:{"width":"300px","display":"none"},attrs:{"id":("uploadDialogBox" + (row.id))}},[_c('div',{staticClass:"flex flex-col justify-start text-xs"},_vm._l((row.consultation_documents),function(doc,index){return _c('div',{key:index,staticClass:"ml-1 underline my-1"},[_c('span',{on:{"click":function($event){return _vm.getDocument(doc.id)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(doc.name))])])])}),0)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.role === 'externalAdmin' && _vm.menu === 0)?_c('div',[_c('img',{staticClass:"cursor-pointer",attrs:{"src":__webpack_require__("G5Z6"),"alt":"action"},on:{"click":function($event){return _vm.toggleModal(row)}}}),_vm._v(" "),(row.service_mode === 'Video' && row.meeting_link)?_c('img',{staticClass:"cursor-pointer ml-4",attrs:{"title":"Copy meeting link","src":__webpack_require__("2IkP"),"alt":"copy"},on:{"click":function($event){return _vm.copyLinkHandler(row)}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.role === 'externalAdmin' && _vm.menu === 6)?_c('div',[(row.assigned_doctor)?_c('img',{staticClass:"cursor-pointer",attrs:{"src":__webpack_require__("MhWj"),"alt":"action"},on:{"click":function($event){return _vm.statusChanged('confirmed', row.id)}}}):_c('img',{staticClass:"cursor-pointer",attrs:{"src":__webpack_require__("XI+S"),"alt":"action"},on:{"click":function($event){return _vm.showMessage('Please assign doctor first')}}})]):_vm._e()])])})],2)])])}),_vm._v(" "),(_vm.showModal)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":_vm.closeModal}}),_vm._v(" "),(_vm.showRescheduleModal)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticStyle:{"padding":"20px"}},[_vm._m(3),_vm._v(" "),_c('h4',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Date of Appointment")]),_vm._v(" "),_c('datetime',{staticClass:"p-2 bg-white rounded-sm border border-solid \n                   border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"margin-bottom":"20px"},attrs:{"type":"datetime","format":"yyyy-MM-dd HH:mm:ss","input-style":"width: 100%;"},on:{"input":_vm.updateConsultationDate},model:{value:(_vm.newDate),callback:function ($$v) {_vm.newDate=$$v},expression:"newDate"}}),_vm._v(" "),_c('h4',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Comments")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"p-2 bg-white rounded-sm border border-solid \n                   border-grey-lightest text-base text-grey-darkest focus:border-blue",staticStyle:{"width":"100%"},domProps:{"value":(_vm.text)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.text=$event.target.value},_vm.updateComments]}}),_vm._v(" "),(_vm.errorMessage)?_c('p',{staticClass:"text-red",staticStyle:{"margin-top":"20px"}},[_vm._v(_vm._s(this.errorMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('button',{staticClass:"flex-no-shrink flex-no-grow px-5 py-2 bg-grey \n              text-white rounded-sm j text-center items-center",on:{"click":_vm.closeModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"flex-no-shrink flex-no-grow ml-2 px-6 py-2 bg-blue \n              text-white rounded-sm j text-center items-center",on:{"click":_vm.rescheduleConsultation}},[_vm._v("Save")])])],1)]):_vm._e(),_vm._v(" "),(_vm.showUploadDocModal)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-4 border-b border-solid border-grey-lighter"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Upload Documents")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeModal()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Categories:")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start"},[_c('div',{staticClass:"flex px-2 py-1 m-1 ml-0 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'lab_report' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('lab_report')}}},[_vm._v("Lab Report")]),_vm._v(" "),_c('div',{staticClass:"flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'diet' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('diet')}}},[_vm._v("Diet Plan")]),_vm._v(" "),_c('div',{staticClass:"flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'fitness' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('fitness')}}},[_vm._v("Fitness Plan")]),_vm._v(" "),_c('div',{staticClass:"flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'others' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('others')}}},[_vm._v("Others")])]),_vm._v(" "),_c('div',{staticClass:"flex my-6 justify-center"},[_c('div',{staticClass:"border-b border-solid w-64 h-8 text-align"},[(_vm.selectedFiles)?_c('p',{staticClass:"pt-3 text-sm text-grey-darkest truncate"},[_vm._v(_vm._s(_vm.selectedFiles[0].name))]):_c('p',{staticClass:"pt-3 text-m truncate text-grey text-sm"},[_vm._v("Please select a file to upload")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"mx-4 items-center"},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"db-file-upload"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label width:100%"},[_c('input',{ref:"file",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".pdf, .png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.handleFileUpload($event.target.files)}}}),_vm._v(" "),_c('div',{staticClass:"hover:shadow-md self-center bg-blue p-2 px-4 rounded text-white text-xs font-light cursor-pointer"},[_vm._v("Select")])])])])])])])]),_vm._v(" "),(_vm.selectedFiles)?_c('div',{staticClass:"buttons flex justify-center my-2"},[_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.uploadDoc()}}},[_vm._v("Upload")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Cancel")])])]):_vm._e()])]):_vm._e()]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighter"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighter"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",attrs:{"id":"remark_preview"}},[_c('div',{staticClass:"absolute mt-1"},[_c('i',{staticClass:"fas fa-caret-up text-xl text-grey-lighter"})]),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-shrink pin-r mt-4 mr-2 bg-grey-lighter px-3 py-2 rounded overflow-y-auto",staticStyle:{"width":"300px"}},[_c('div',{staticClass:"text-black text-xs font-sans leading-tight",staticStyle:{"word-break":"break-all"},attrs:{"id":"remark_preview_text"}},[_vm._v("Consultation opens 10 min before scheduled time")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-bottom":"1px solid #b8c2cc","margin":"0px -20px 20px"}},[_c('h3',{staticStyle:{"padding":"0px 20px 15px"}},[_vm._v("Reschedule Consultation")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "it8Z":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ivbo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("HealthSocre")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ixOE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDE5IDE5Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE3IiB4PSIuNSIgeT0iLjUiIHN0cm9rZT0iIzIwN0FFNiIgcng9IjQiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMjA3QUU2IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik02IC45NzJoMXYxNy4wNTZINnpNMTIgLjk3MmgxdjE3LjA1NmgtMXoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMjA3QUU2IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xIDEzdi0xaDE4djF6TTEgN1Y2aDE4djF6Ii8+CiAgICAgICAgPGNpcmNsZSBjeD0iMTUuNSIgY3k9IjE1LjUiIHI9IjEuNSIgZmlsbD0iIzIwN0FFNiIvPgogICAgICAgIDxjaXJjbGUgY3g9IjkuNSIgY3k9IjMuNSIgcj0iMS41IiBmaWxsPSIjMjA3QUU2Ii8+CiAgICAgICAgPGNpcmNsZSBjeD0iMy41IiBjeT0iOS41IiByPSIxLjUiIGZpbGw9IiMyMDdBRTYiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI5LjUiIGN5PSI5LjUiIHI9IjEuNSIgZmlsbD0iIzIwN0FFNiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "j/3f":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA4LjAwNDM3QzE2IDEyLjk4NyAxMS40MzUzIDE2LjkwODggNi4yOTE4OSAxNS44MTU5QzMuMjcwMTYgMTUuMTcyOSAwLjgyNzA1NyAxMi43Mjk4IDAuMTg0MTM2IDkuNzA4MTFDLTAuOTA4ODMgNC41NjQ3NCAzLjAxMjk5IDAgNy45OTU2MyAwQzEwLjIxMzcgMCAxMi4yMzg5IDAuOTMyMjM2IDEzLjY4NTUgMi40MTA5NUMxNC4xNjc3IDIuODkzMTUgMTQuNTg1NiAzLjQzOTYzIDE0LjkzOTIgNC4wMTgyNkMxNS42MTQyIDUuMTc1NTIgMTYgNi41NTc4IDE2IDguMDA0MzdaIiBmaWxsPSIjMkFCMjY4Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuOTM4NyA0LjAxODE5TDguNzY2NjYgMTEuMzE1M0M4LjYwNTkzIDExLjU0MDQgOC4zMTY2MSAxMS42NjkgOC4wNTk0NSAxMS42NjlINy45OTUxNUM3LjczNzk4IDExLjY2OSA3LjQ4MDgyIDExLjU3MjUgNy4yODc5NCAxMS4zNzk2TDQuMDA5MDQgOC4wNjg2QzMuNjIzMjkgNy42ODI4NCAzLjYyMzI5IDcuMDM5OTIgNC4wMDkwNCA2LjY1NDE3QzQuMzk0NzkgNi4yNjg0MiA1LjAzNzcyIDYuMjY4NDIgNS40MjM0NyA2LjY1NDE3TDcuOTMwODYgOS4xNjE1NkwxMy42ODUgMi40MTA4OUMxNC4xNjcyIDIuODkzMDggMTQuNTg1MSAzLjQwNzQyIDE0LjkzODcgNC4wMTgxOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "j9/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

// import store from '../store'

/* harmony default export */ __webpack_exports__["a"] = ({
  getHealthCoachDetails: function getHealthCoachDetails(customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + ('doctors/health_coach/customer/' + customerId + '/timelines'));
  },
  createGoal: function createGoal(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/health-coach-goals/create', data);
  },
  updateGoal: function updateGoal(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + ('doctors/health-coach-goals/' + data.id), { health_coach_goals: { target_value: data.target_value } });
  },
  deleteGoal: function deleteGoal(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(window.API_URL + ('doctors/health-coach-goals/' + id));
  },
  getCustomerGoalVitals: function getCustomerGoalVitals(programEnrollmentId, customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + ('doctors/customers/' + customerId + '/program_enrollments/' + programEnrollmentId + '/customer_goal_vitals'));
  },
  bulkUpdateGoal: function bulkUpdateGoal(programEnrollmentId, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(window.API_URL + ('doctors/health-coach-goals/' + programEnrollmentId + '/bulk_update'), data);
  },
  getTimelineAndProgress: function getTimelineAndProgress(customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + ('doctors/health_coach/customer/' + customerId + '/program_enrollment_timeline'));
  },
  getActivityDetails: function getActivityDetails(customerId, activityId, action) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + ('doctors/health_coach/customer/' + customerId + '/activity_details/' + activityId + '?action_type=' + action));
  }
});

/***/ }),

/***/ "jIWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-row h-12 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest justify-between"},[_c('div',{staticClass:"self-center ml-4 text-base font-semibold text-grey-darkest"},[_vm._v("Documents")]),_vm._v(" "),(_vm.showFullView)?_c('div',{staticClass:"self-center mr-4 text-grey font-mono font-thin cursor-pointer",on:{"click":function($event){(_vm.showFullView = false)}}},[_c('img',{attrs:{"src":__webpack_require__("uDPR")}})]):_vm._e()]),_vm._v(" "),(!_vm.showFullView)?_c('div',[_c('div',{staticClass:"flex flex-col bg-white py-3 overflow-y-auto",staticStyle:{"height":"calc(100vh - 8rem)"}},[_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"doc_header"},[_c('div',{staticClass:"text-grey text-sm cursor-pointer hover:text-blue",class:[_vm.activeDocs === 'recently uploaded' ? 'text-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveDocs('recently uploaded')}}},[_vm._v("Recently Uploaded")]),_vm._v(" "),_c('div',{staticClass:"text-grey text-sm cursor-pointer",class:[_vm.activeDocs === 'old documents' ? 'text-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveDocs('old documents')}}},[_vm._v("Old Documents")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-lightest mb-4",staticStyle:{"height":"0.125rem"}},[_c('div',{staticClass:"w-1/2",class:[_vm.activeDocs === 'recently uploaded' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/2",class:[_vm.activeDocs === 'old documents' ? 'bg-blue' : '']})]),_vm._v(" "),(_vm.activeDocs === 'recently uploaded')?_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow px-4"},[_c('div',{staticClass:"flex mb-3 items-center"},[_c('div',{staticClass:"font-semibold text-sm",staticStyle:{"color":"#4d6189"}},[_vm._v("UPLOADED IN LAST 30 DAYS")]),_vm._v(" "),_c('div',{staticClass:"bg-orange-lightest text-grey-dark rounded-lg font-semibold border border-orange-light ml-4 px-4 py-1 cursor-pointer",on:{"click":function($event){return _vm.fetchCustomerUploadedFiles()}}},[_vm._v("Refresh")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.last30Days.length < 1)?_c('div',{staticClass:"flex flex-col bg-white m-2 text-grey-darker text-sm flex-no-shrink flex-no-grow"},[_vm._v("No documents found")]):_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow border border-solid border-light-grey",staticStyle:{"border-top":"none","border-radius":"0 0 3px 3px","border-sizing":"border-box"}},_vm._l((_vm.last30Days),function(doc,index){return _c('div',{key:index},[_c('PatientReports',{attrs:{"doc":doc},on:{"fullView":_vm.showFullViewModal}})],1)}),0)]):_vm._e(),_vm._v(" "),(_vm.activeDocs === 'old documents')?_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow px-4"},[_vm._m(1),_vm._v(" "),(_vm.otherDocuments.length < 1)?_c('div',{staticClass:"flex flex-col bg-white m-2 text-grey-darker text-sm flex-no-shrink flex-no-grow"},[_vm._v("No documents found")]):_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow border border-solid border-light-grey",staticStyle:{"border-top":"none","border-radius":"0 0 3px 3px","border-sizing":"border-box"}},_vm._l((_vm.otherDocuments),function(doc,index){return _c('div',{key:index},[_c('PatientReports',{attrs:{"doc":doc},on:{"fullView":_vm.showFullViewModal}})],1)}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow",style:(_vm.$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);')},[_c('div',{staticClass:"flex flex-row mx-auto pb-2"},[_c('div',{staticClass:"hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer flex flex-row font-semibold",on:{"click":_vm.openUploadDocModal}},[_c('img',{staticClass:"mr-2",attrs:{"src":__webpack_require__("dC1Y")}}),_c('span',[_vm._v("Upload")])])])]),_vm._v(" "),(_vm.showModal)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":_vm.closeModal}}),_vm._v(" "),(_vm.showUploadDocModal)?_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-4 border-b border-solid border-grey-lighter"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" Upload Documents")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeModal()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Categories:")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start"},[_c('div',{staticClass:"flex px-2 py-1 m-1 ml-0 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'lab_report' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('lab_report')}}},[_vm._v("Lab Report")]),_vm._v(" "),_c('div',{staticClass:"flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'diet' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('diet')}}},[_vm._v("Diet Plan")]),_vm._v(" "),_c('div',{staticClass:"flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow",class:[_vm.fileCategory === 'fitness' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest'],on:{"click":function($event){return _vm.selectFileCategory('fitness')}}},[_vm._v("Fitness Plan")])]),_vm._v(" "),_c('div',{staticClass:"flex my-6 justify-center"},[_c('div',{staticClass:"border-b border-solid w-64 h-8 text-align"},[(_vm.selectedFiles && _vm.selectedFiles.length>0)?_c('p',{staticClass:"pt-3 text-sm text-grey-darkest truncate"},[_vm._v(_vm._s(_vm.selectedFiles[0].name))]):_c('p',{staticClass:"pt-3 text-m truncate text-grey text-sm"},[_vm._v("Please select a file to upload")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"mx-4 items-center"},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"db-file-upload"},[_c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label width:100%"},[_c('input',{ref:"file",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"accept":".pdf, .png, .jpg, .jpeg","type":"file","name":"chatfile","id":"file"},on:{"change":function($event){return _vm.handleFileUpload($event.target.files)}}}),_vm._v(" "),_c('div',{staticClass:"hover:shadow-md self-center bg-blue p-2 px-4 rounded text-white text-xs font-light cursor-pointer"},[_vm._v("Select")])])])])])])])]),_vm._v(" "),(_vm.selectedFiles && _vm.selectedFiles.length>0)?_c('div',{staticClass:"buttons flex justify-center my-2"},[_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.uploadDoc()}}},[_vm._v("Upload")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Cancel")])])]):_vm._e()])]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showFullView)?_c('div',[_c('div',{staticClass:"flex flex-col bg-white overflow-y-auto",staticStyle:{"height":"calc(100vh - 8rem)","font-size":".875rem","color":"#324467"}},[_c('div',{staticClass:"pt-2"},[_c('div',{staticClass:"flex flex-row h-7 border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"text-grey text-sm cursor-pointer pb-2 ml-4 mr-4",class:[_vm.activeResults === 'results' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveResults('results')}}},[_vm._v("Results")]),_vm._v(" "),_c('div',{staticClass:"text-grey text-sm cursor-pointer pb-2 mr-4",class:[_vm.activeResults === 'notes' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveResults('notes')}}},[_vm._v("Notes")]),_vm._v(" "),_c('div',{staticClass:"text-grey text-sm cursor-pointer pb-2",class:[_vm.activeResults === 'reports' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveResults('reports')}}},[_vm._v("Reports")])]),_vm._v(" "),((_vm.document.category === 'Prescription'))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"m-4 text-sm"},[_vm._v("No Results")]):((_vm.document.health_assessment_status === null))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"text-sm m-4"},[_vm._v("No Results")]):((_vm.document.health_assessment_status !== 'done') && (_vm.document.health_assessment_status !== undefined))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"text-sm m-4"},[_vm._v("Lab results digitization under "+_vm._s(_vm.document.health_assessment_status))]):(_vm.document.lab_results && _vm.document.lab_results.length < 1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"text-sm m-4"},[_vm._v("No Results")]):((_vm.document.health_assessment_status === 'done'))?_vm._l((_vm.document.lab_results),function(lab_result,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],key:index,staticClass:" border-radius-3 border-solid border-grey-lightest overflow-y-auto px-2"},[_c('div',{staticClass:"font-semibold text-sm py-3 px-2"},[_vm._v(_vm._s(lab_result.name))]),_vm._v(" "),_c('div'),_vm._v(" "),_vm._l((lab_result.results),function(result,index){return _c('div',{key:index,staticClass:"text-grey text-sm flex flex-row flex-no-grow flex-no-shrink justify-between"},[_c('div',{staticClass:"pb-3 px-2"},[_vm._v(_vm._s(result.test_component_name))]),_vm._v(" "),_c('div',{staticClass:"pb-3 px-2",class:result.color},[_vm._v(_vm._s(result.result))])])})],2)}):_vm._e(),_vm._v(" "),((_vm.document.category === 'Prescription'))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'notes'),expression:"activeResults === 'notes'"}],staticClass:"m-4 text-sm"},[_vm._v("No Notes")]):(_vm.document.notes.length<1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'notes'),expression:"activeResults === 'notes'"}],staticClass:"m-4 text-sm"},[_vm._v("No Notes")]):_vm._e(),_vm._v(" "),_vm._l((_vm.document.notes),function(note,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'notes'),expression:"activeResults === 'notes'"}],key:index,staticClass:"m-4"},[_c('div',{staticClass:"font-semibold pb-2"},[_vm._v(_vm._s(note.title))]),_vm._v(" "),_c('div',{staticClass:"pb-3 leading-normal text-grey"},[_vm._v(_vm._s(note.description))])])}),_vm._v(" "),(_vm.activeResults === 'reports')?_c('div',{staticClass:"text-sm flex flex-col flex-no-grow flex-no-shrink",staticStyle:{"max-height":"155px"}},[((_vm.document.reports === undefined) && (_vm.document.category === 'Prescription'))?_c('div',{staticClass:"m-4",attrs:{"data-toggle":"modal","data-target":"#myModal"},on:{"click":function($event){return _vm.getDocument(_vm.document.category, _vm.document.id)}}},[_c('span',{staticClass:"text-blue font-semibold cursor-pointer"},[_vm._v(_vm._s(_vm.document.name))])]):(_vm.document.reports.length<1)?_c('div',{staticClass:"m-4 text-sm"},[_vm._v("No Reports")]):_vm._l((_vm.document.reports),function(report,index){return _c('div',{key:index,staticClass:"m-4",staticStyle:{"margin-bottom":"0"}},[_c('div',{attrs:{"data-toggle":"modal","data-target":"#myModal"},on:{"click":function($event){return _vm.getDocument(report.category, report.id)}}},[_c('span',{staticClass:"text-blue font-semibold cursor-pointer"},[_vm._v(_vm._s(report.name))])])])})],2):_vm._e()],2)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid_container bg-grey-lightest text-sm",staticStyle:{"border-radius":"3px 3px 0 0","color":"#324467"}},[_c('div',{staticClass:"item_header font-semibold"},[_vm._v("Provider/Customer")]),_vm._v(" "),_c('div',{staticClass:"item_header font-semibold"},[_vm._v("Category")]),_vm._v(" "),_c('div',{staticClass:"item_header font-semibold"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid_container bg-grey-lightest text-sm",staticStyle:{"border-radius":"3px 3px 0 0","color":"#324467"}},[_c('div',{staticClass:"item_header font-semibold"},[_vm._v("Provider/Customer")]),_vm._v(" "),_c('div',{staticClass:"item_header font-semibold"},[_vm._v("Category")]),_vm._v(" "),_c('div',{staticClass:"item_header font-semibold"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jYHe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZmd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminLeftPane_vue__ = __webpack_require__("JxBx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba675b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminLeftPane_vue__ = __webpack_require__("P7hk");
function injectStyle (ssrContext) {
  __webpack_require__("kXfy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminLeftPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba675b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminLeftPane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k/wg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k0Td":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsavedChanges_vue__ = __webpack_require__("Ore3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a46ea5f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsavedChanges_vue__ = __webpack_require__("YD0K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsavedChanges_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a46ea5f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsavedChanges_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kL2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'patient-history' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Patient History"},on:{"click":function($event){return _vm.tabClicked('patient-history')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'patient-history' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("nNde"),"alt":"chat_icon"}})]),_vm._v(" "),_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'drugs' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Prescribe Drugs"},on:{"click":function($event){return _vm.tabClicked('drugs')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'drugs' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("FftZ"),"alt":"chat_icon"}})]),_vm._v(" "),_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'order-labs' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Order Labs"},on:{"click":function($event){return _vm.tabClicked('order-labs')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'order-labs' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("1h9A"),"alt":"chat_icon"}})]),_vm._v(" "),_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'patient-documents' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Documents"},on:{"click":function($event){return _vm.tabClicked('patient-documents')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'patient-documents' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("MlP6"),"alt":"chat_icon"}})]),_vm._v(" "),_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'customer-past-consults' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Past Consultations"},on:{"click":function($event){return _vm.tabClicked('customer-past-consults')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'customer-past-consults' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("uwbl"),"alt":"chat_icon"}})]),_vm._v(" "),_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'health-coach' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Health Coach"},on:{"click":function($event){return _vm.tabClicked('health-coach')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'health-coach' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("AwPR"),"alt":"chat_icon"}})]),_vm._v(" "),_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'consultation-summary' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Summary"},on:{"click":function($event){return _vm.tabClicked('consultation-summary')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'consultation-summary' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("GleQ"),"alt":"chat_icon"}})]),_vm._v(" "),(_vm.customer && _vm.customer.isFamilyDoctor)?_c('div',{staticClass:"w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer",class:[_vm.selectedTab === 'notification' ? 'border-l-4 border-solid border-blue' : '' ],attrs:{"title":"Summary"},on:{"click":function($event){return _vm.tabClicked('notification')}}},[_c('img',{staticClass:"h-6 w-6 self-center",class:[_vm.selectedTab === 'notification' ? '-ml-1' : 'opacity-50' ],attrs:{"src":__webpack_require__("mT1R"),"alt":"chat_icon"}}),_vm._v(" "),(_vm.notViewedNotifications > 0)?_c('div',{staticClass:"flex bg-red justify-center items-center rounded-full flex-no-grow flex-no-shrink cursor-pointer w-5 h-5 mt-2 ml-2",staticStyle:{"border-radius":"50%","position":"absolute"}},[_c('p',{staticClass:"flex flex-col self-center justify-center text-xs text-white"},[_vm._v(_vm._s(_vm.notViewedNotifications))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kUeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechRecognition_vue__ = __webpack_require__("SH8R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e8037b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpeechRecognition_vue__ = __webpack_require__("btYt");
function injectStyle (ssrContext) {
  __webpack_require__("iTEw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60e8037b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechRecognition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e8037b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpeechRecognition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kXfy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kZm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_customer_general__ = __webpack_require__("4/zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_customer_profile__ = __webpack_require__("h6cF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_customer_summary__ = __webpack_require__("FyQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_consultation__ = __webpack_require__("57jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_customer_medication__ = __webpack_require__("kmHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_initialise_store__ = __webpack_require__("II+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__ = __webpack_require__("O4OI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_customer_document__ = __webpack_require__("eX/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_customer_prescription__ = __webpack_require__("b8jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_snackbar_helpers__ = __webpack_require__("tjrC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("7+uW");















__WEBPACK_IMPORTED_MODULE_14_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_toast_notification___default.a);

// State
var state = {
  initiated: false,
  activeOfflineConsults: [],
  activeCustomerId: null,
  searchResult: [],
  drugs: [],
  selectedTests: []

  // Getters
};var getters = {
  getActiveOfflineConsults: function getActiveOfflineConsults() {
    return state.activeOfflineConsults;
  },
  searchResult: function searchResult() {
    return state.searchResult;
  },
  getDrugs: function getDrugs() {
    var index = state.drugs.findIndex(function (ele) {
      return ele.customerId === state.activeCustomerId;
    });
    if (index > -1) {
      return state.drugs[index].drugs;
    } else {
      return [];
    }
  },
  getLabTests: function getLabTests() {
    var index = state.selectedTests.findIndex(function (test) {
      return test.customerId === state.activeCustomerId;
    });
    if (index > -1) {
      return state.selectedTests[index].tests;
    } else {
      return [];
    }
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState;

    __WEBPACK_IMPORTED_MODULE_7__api_initialise_store__["a" /* default */].fetchActiveOfflineConsultationsDetails().then(function (response) {
      if (response.status === 200) {
        commit('setUpDetails', response.body.active_offline_consultations);
        if (state.activeOfflineConsults.length > 0) {
          dispatch('switchTo', state.activeOfflineConsults[0].channelId);
        } else {
          dispatch('switchTo', null);
        }
      }
    });
  },

  fetchCustomers: function fetchCustomers(_ref2, query) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__api_customer_general__["a" /* default */].search_customer(query).then(function (response) {
      if (response.status === 200) {
        commit('updateSearchResult', response.body.customers);
      }
    });
  },
  addNewCustomer: function addNewCustomer(_ref3, customer) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    commit('addNewCustomer', customer);
    dispatch('switchTo', customer.customer_id);
  },
  addAptConsultation: function addAptConsultation(_ref4, appointment) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    commit('addAptConsultation', appointment);
    dispatch('switchTo', appointment.ek_id);
    dispatch('fetchConsultation', appointment);
  },
  addEnquireNowConsult: function addEnquireNowConsult(_ref5, notification) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    commit('addEnquireNowConsult', notification);
    dispatch('switchTo', notification.customer_id);
    setTimeout(function () {
      dispatch('configuration/setRightPaneTab', 'notification', { root: true });
    }, 1600);
  },
  storeLabTests: function storeLabTests(_ref6, _ref7) {
    var state = _ref6.state,
        commit = _ref6.commit;
    var tests = _ref7.tests,
        customerId = _ref7.customerId;

    commit('storeLabTests', { tests: tests, customerId: customerId });
  },

  fetchConsultation: function fetchConsultation(_ref8, appointment) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    __WEBPACK_IMPORTED_MODULE_5__api_consultation__["a" /* default */].getConsultation(appointment.consultation_id).then(function (response) {
      if (response.status === 200) {
        commit('updateConsultation', { channelId: state.activeCustomerId, consultation: response.body.consultation });
      }
    });
  },
  switchTo: function switchTo(_ref9, customerId) {
    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch,
        rootState = _ref9.rootState;

    commit('switchTo', customerId);
    if (customerId !== null) {
      dispatch('fetchCustomerProfile', customerId);
    }
  },
  fetchCustomerProfile: function fetchCustomerProfile(_ref10, customerId) {
    var commit = _ref10.commit,
        state = _ref10.state;

    __WEBPACK_IMPORTED_MODULE_3__api_customer_profile__["a" /* default */].getCustomerDetails(customerId).then(function (response) {
      if (response.status === 200 && response.body.customer) {
        commit('updateCustomerDetails', {
          customerId: customerId,
          customerDetails: response.body.customer
        });
      }
    });
  },
  updateConsultation: function updateConsultation(_ref11, data) {
    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === state.activeCustomerId;
    });
    if (patient.consultation.consultationId) {
      __WEBPACK_IMPORTED_MODULE_4__api_customer_summary__["a" /* default */].saveSummaryDetails(data, patient.consultation.consultationId).then(function (response) {
        if (response.status === 200) {
          dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
          commit('updateConsultation', { channelId: state.activeCustomerId, consultation: response.body.consultation });
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    } else {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data)[0] === 'chief_compliant') {
        data.customer_id = state.activeCustomerId;
        dispatch('createConsultation', data);
      } else {
        __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
          message: 'Please add Chief complaint to create consultation',
          type: 'error',
          position: 'top',
          queue: false
        });
        commit('updateConsultation', { channelId: state.activeCustomerId, consultation: {} });
      }
    }
  },
  updateHealthParameters: function updateHealthParameters(_ref12, data) {
    var commit = _ref12.commit,
        state = _ref12.state,
        dispatch = _ref12.dispatch;

    __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__["a" /* default */].updateHealthParameters(data, state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeCustomerId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  updateGeneralParameters: function updateGeneralParameters(_ref13, data) {
    var commit = _ref13.commit,
        state = _ref13.state,
        dispatch = _ref13.dispatch;

    __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__["a" /* default */].updateGeneralParameters({ gender: data.gender, date_of_birth: data.date_of_birth }, state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.body).length > 0) {
          commit('updateCustomerDetails', { customerId: state.activeCustomerId, customerDetails: { gender: response.body.gender, date_of_birth: response.body.date_of_birth } });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
    __WEBPACK_IMPORTED_MODULE_8__api_customer_health_parameters__["a" /* default */].updateHealthParameters({ blood_group: data.blood_group }, state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeCustomerId, healthParameters: response.body.customer_health_parameters });
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  uploadDocuments: function uploadDocuments(_ref14, formData) {
    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch;

    __WEBPACK_IMPORTED_MODULE_9__api_customer_document__["a" /* default */].uploadDocuments(formData).then(function (response) {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', { channelId: state.activeCustomerId, data: response.body });
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', {channelId: state.activeCustomerId, data: response.body.prescriptions})
        // }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  previewPrescription: function previewPrescription(_ref15, _ref16) {
    var commit = _ref15.commit,
        state = _ref15.state;
    var data = _ref16.data;

    __WEBPACK_IMPORTED_MODULE_10__api_customer_prescription__["a" /* default */].createPrescription(data, 'preview', state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        window.open(response.body.prescription_url, '_blank');
      }
    });
  },
  sendPrescription: function sendPrescription(_ref17, _ref18) {
    var commit = _ref17.commit,
        state = _ref17.state;
    var data = _ref18.data;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === state.activeCustomerId;
    });
    if (!patient.consultation.consultationId) {
      __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
        message: 'Please fill chief complaint to proceed',
        type: 'success',
        position: 'bottom-right',
        queue: true
      });
      return;
    }
    __WEBPACK_IMPORTED_MODULE_10__api_customer_prescription__["a" /* default */].createPrescription(data, 'preview', state.activeCustomerId).then(function (response) {
      if (response.status === 200) {
        __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
          message: 'Prescription sent successfully',
          type: 'success',
          position: 'bottom-right',
          queue: false
        });
      }
    }).catch(function (e) {
      __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
        message: 'Something went wrong',
        type: 'error',
        position: 'bottom-right',
        queue: false
      });
    });
  },
  updateMedication: function updateMedication(_ref19, data) {
    var commit = _ref19.commit,
        state = _ref19.state;

    commit('updateMedication', { channelId: state.activeCustomerId, prescribedDrugs: data.prescribedDrugs });
  },
  updateCurrentMedication: function updateCurrentMedication(_ref20, medications) {
    var commit = _ref20.commit,
        state = _ref20.state,
        dispatch = _ref20.dispatch;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === state.activeCustomerId;
    });
    if (patient) {
      __WEBPACK_IMPORTED_MODULE_6__api_customer_medication__["a" /* default */].update(patient.customerId, medications).then(function (resp) {
        if (resp.status === 200) {
          dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
          commit('updateCurrentMedication', { channelId: state.activeCustomerId, medications: resp.body.medications });
        } else {
          dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        }
      });
    }
  },
  createConsultation: function createConsultation(_ref21, data) {
    var commit = _ref21.commit,
        state = _ref21.state,
        dispatch = _ref21.dispatch;

    __WEBPACK_IMPORTED_MODULE_5__api_consultation__["a" /* default */].create(data).then(function (response) {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        commit('setupNewConsultation', { channelId: state.activeCustomerId, consultation: response.body.consultation });
      }
    }).catch(function (error) {
      return dispatch('toaster/setToaster', { status: true, type: 'error', message: error.body.message }, { root: true });
    });
  },
  endConsultation: function endConsultation(_ref22, _ref23) {
    var commit = _ref22.commit,
        state = _ref22.state,
        rootState = _ref22.rootState,
        dispatch = _ref22.dispatch;
    var status = _ref23.status,
        reasons = _ref23.reasons;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === state.activeCustomerId;
    });
    // when consultation ended with no consultation id, means it was never created in db.
    if (!patient.consultation.consultationId) {
      commit('removeConsultation', patient.consultation.consultationId);
      if (state.activeOfflineConsults.length > 0) {
        commit('switchTo', state.activeOfflineConsults[0].channelId);
      } else {
        commit('switchTo', null);
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_5__api_consultation__["a" /* default */].endOfflineConsultation({ consultation_id: patient.consultation.consultationId, status: status }).then(function (response) {
        if (response.status === 200 || response.status === 204) {
          if (response.body.message === 'Diagnosis can not be empty') {
            __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
              message: 'Diagnosis can not be empty',
              type: 'error',
              position: 'top',
              queue: false
            });
          } else {
            commit('removeDrugs', { customerId: patient.customerId });
            commit('removeConsultation', patient.consultation.consultationId);
            if (state.activeOfflineConsults.length > 0) {
              commit('switchTo', state.activeOfflineConsults[0].channelId);
            } else {
              commit('switchTo', null);
            }
            dispatch('pastOfflineConsultation/addToPastConsultation', { consult: patient }, { root: true });
            dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
            dispatch('pastOfflineConsultation/init', {}, { root: true });
          }
        }
      }).catch(function (error) {
        console.log(error);
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      });
    }
  }
};

// Mutations
var mutations = {
  setUpDetails: function setUpDetails(state, details) {
    var _loop = function _loop(i) {
      var activeConsult = state.activeOfflineConsults.find(function (ele) {
        return ele.customerId === details[i].customer_id;
      });
      if (!activeConsult) {
        var consult = {
          ablyEnabled: false,
          channelId: details[i].customer_id,
          customerId: details[i].customer_id,
          name: details[i].name,
          isFamilyDoctor: details[i].is_family_doctor,
          familyDoctor: { id: details[i].family_doctor.id, name: details[i].family_doctor.name },
          consultation: {
            chiefComplaint: details[i].chief_compliant,
            consultationId: details[i].consultation_id,
            provisionalDiagnosis: details[i].provisional_diagnois,
            summaryNotes: details[i].summary_notes,
            date: details[i].consultation_date,
            status: details[i].status,
            prescribedDrugs: details[i].prescribed_drugs
          },
          isOnline: false,
          details: {}
        };
        state.activeOfflineConsults.push(consult);
      } else {
        if (!activeConsult.consultation.consultationId) {
          var index = state.activeOfflineConsults.indexOf(activeConsult);
          state.activeOfflineConsults[index] = {
            ablyEnabled: false,
            channelId: details[i].customer_id,
            customerId: details[i].customer_id,
            name: details[i].name,
            isFamilyDoctor: details[i].is_family_doctor,
            familyDoctor: { id: details[i].family_doctor.id, name: details[i].family_doctor.name },
            consultation: {
              chiefComplaint: details[i].chief_compliant,
              consultationId: details[i].consultation_id,
              provisionalDiagnosis: details[i].provisional_diagnois,
              summaryNotes: details[i].summary_notes,
              date: details[i].consultation_date,
              status: details[i].status,
              prescribedDrugs: details[i].prescribed_drugs
            },
            isOnline: false,
            details: {}
          };
        }
      }
    };

    for (var i = 0; i < details.length; i++) {
      _loop(i);
    }
    state.initiated = true;
  },

  updateSearchResult: function updateSearchResult(state, data) {
    state.searchResult = data;
  },
  addNewCustomer: function addNewCustomer(state, customer) {
    var consult = state.activeOfflineConsults.find(function (ele) {
      return ele.customerId === customer.customer_id;
    });
    if (!consult) {
      var newConsult = {
        channelId: customer.customer_id,
        customerId: customer.customer_id,
        name: customer.first_name + ' ' + customer.last_name,
        isFamilyDoctor: false,
        familyDoctor: { id: null, name: '' },
        consultation: {
          chiefComplaint: '',
          consultationId: null,
          provisionalDiagnosis: '',
          summaryNotes: '',
          date: '',
          status: '',
          consultationType: 'audio',
          prescribedDrugs: []
        },
        isOnline: false,
        details: {}
      };
      state.activeOfflineConsults.unshift(newConsult);
      state.activeCustomerId = customer.customer_id;
    } else {
      __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
        message: 'You have already selected this patient once',
        type: 'warning',
        position: 'top',
        queue: false
      });
    }
  },
  addAptConsultation: function addAptConsultation(state, appointment) {
    var consult = state.activeOfflineConsults.find(function (ele) {
      return ele.customerId === appointment.ek_id;
    });
    if (!consult) {
      var newConsult = {
        channelId: appointment.ek_id,
        customerId: appointment.ek_id,
        name: appointment.name,
        isFamilyDoctor: false,
        familyDoctor: { id: null, name: '' },
        consultation: {
          chiefComplaint: '',
          consultationId: appointment.consultation_id,
          provisionalDiagnosis: '',
          summaryNotes: '',
          date: '',
          status: '',
          consultationType: 'audio',
          prescribedDrugs: []
        },
        isOnline: false,
        details: {}
      };
      __WEBPACK_IMPORTED_MODULE_5__api_consultation__["a" /* default */].updateOfflineConsultation(appointment.consultation_id).then(function (response) {
        if (response.status === 200) {
          state.activeOfflineConsults.unshift(newConsult);
          state.activeCustomerId = appointment.ek_id;
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
          message: 'Something went wrong',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
        message: 'Already have an ongoing offline consultation for this patient',
        type: 'warning',
        position: 'top',
        queue: false
      });
    }
  },
  addEnquireNowConsult: function addEnquireNowConsult(state, notification) {
    var consult = state.activeOfflineConsults.find(function (ele) {
      return ele.customerId === notification.customer_id;
    });
    if (!consult) {
      var newConsult = {
        channelId: notification.customer_id,
        customerId: notification.customer_id,
        name: notification.details.customer_name,
        isFamilyDoctor: false,
        familyDoctor: { id: null, name: '' },
        consultation: {
          chiefComplaint: '',
          consultationId: null,
          provisionalDiagnosis: '',
          summaryNotes: '',
          date: '',
          status: '',
          consultationType: 'audio',
          prescribedDrugs: []
        },
        isOnline: false,
        details: {}
      };
      state.activeOfflineConsults.unshift(newConsult);
      state.activeCustomerId = notification.ek_id;
    } else {
      __WEBPACK_IMPORTED_MODULE_14_vue__["default"].$toast.open({
        message: 'Already have an ongoing offline consultation for this patient',
        type: 'warning',
        position: 'top',
        queue: false
      });
    }
  },
  switchTo: function switchTo(state, customerId) {
    state.activeCustomerId = customerId;
  },

  // Updates Customer Details
  updateCustomerDetails: function updateCustomerDetails(state, _ref24) {
    var customerId = _ref24.customerId,
        customerDetails = _ref24.customerDetails;

    var consult = state.activeOfflineConsults.find(function (ele) {
      return ele.customerId === customerId;
    });
    var index = state.activeOfflineConsults.indexOf(consult);
    if (index > -1) {
      if (customerDetails.family_doctor && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(customerDetails.family_doctor).length === 0 && customerDetails.family_doctor.constructor === Object) {
        state.activeOfflineConsults[index].isFamilyDoctor = false;
      } else {
        state.activeOfflineConsults[index].isFamilyDoctor = true;
        state.activeOfflineConsults[index].familyDoctor = customerDetails.family_doctor;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(customerDetails).length === 2) {
        state.activeOfflineConsults[index].details.date_of_birth = customerDetails.date_of_birth;
        state.activeOfflineConsults[index].details.gender = customerDetails.gender;
      } else state.activeOfflineConsults[index].details = customerDetails;
    }
  },
  setupNewConsultation: function setupNewConsultation(state, _ref25) {
    var channelId = _ref25.channelId,
        consultation = _ref25.consultation;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.activeOfflineConsults[index].consultation.chiefComplaint = consultation.chief_compliant;
      state.activeOfflineConsults[index].consultation.consultationId = consultation.id;
    }
  },
  updateConsultation: function updateConsultation(state, _ref26) {
    var channelId = _ref26.channelId,
        consultation = _ref26.consultation;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.activeOfflineConsults[index].consultation.chiefComplaint = consultation.chief_compliant;
      state.activeOfflineConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois;
      state.activeOfflineConsults[index].consultation.summaryNotes = consultation.summary_notes;
      state.activeOfflineConsults[index].consultation.status = consultation.summary_status;
    }
  },
  removeConsultation: function removeConsultation(state, consultationId) {
    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.consultation.consultationId === consultationId;
    });
    var index = state.activeOfflineConsults.indexOf(patient);
    if (index > -1) {
      if (state.activeOfflineConsults.length > 1) {
        state.activeOfflineConsults.splice(index, 1);
      } else {
        state.activeOfflineConsults.splice(index, 1);
        state.activeOfflineConsults = [];
      }
    }
  },
  updateHealthParameter: function updateHealthParameter(state, _ref27) {
    var channelId = _ref27.channelId,
        healthParameters = _ref27.healthParameters;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (!patient || !patient.details) return;
    var patientHealthParameters = patient.details.health_parameters || {};
    healthParameters.forEach(function (_ref28) {
      var questionTag = _ref28.question_tag,
          result = _ref28.result;

      patientHealthParameters[questionTag] = result;
      if (questionTag === 'height') {
        var _convertHeightToFeetI = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_common_snackbar_helpers__["b" /* convertHeightToFeetInches */])(result),
            _convertHeightToFeetI2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_convertHeightToFeetI, 2),
            feet = _convertHeightToFeetI2[0],
            inches = _convertHeightToFeetI2[1];

        patientHealthParameters.feet = feet;
        patientHealthParameters.inches = inches;
      }
    });
  },
  updateDocuments: function updateDocuments(state, _ref29) {
    var channelId = _ref29.channelId,
        data = _ref29.data;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.activeOfflineConsults[index].details.documents.push(data);
    }
  },


  // updatePrescriptions (state, { channelId, data }) {
  //   let patient = state.activeOfflineConsults.find(function (ele) {
  //     return (ele.channelId === channelId)
  //   })
  //   let index = state.activeOfflineConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.activeOfflineConsults[index].details.prescriptions = state.activeOfflineConsults[index].details.prescriptions.concat(data)
  //   }
  // },
  updateMedication: function updateMedication(state, _ref30) {
    var channelId = _ref30.channelId,
        prescribedDrugs = _ref30.prescribedDrugs;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.activeOfflineConsults[index].consultation.prescribedDrugs = prescribedDrugs;
      // state.activeOfflineConsults[index].details.prescribedDrugs = prescribedDrugs
    }
  },
  updateCurrentMedication: function updateCurrentMedication(state, _ref31) {
    var channelId = _ref31.channelId,
        medications = _ref31.medications;

    var patient = state.activeOfflineConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.activeOfflineConsults.indexOf(patient);
    if (index > -1) {
      state.activeOfflineConsults[index].details.medications = medications;
    }
  },
  storeCurrentDrugs: function storeCurrentDrugs(state, _ref32) {
    var drug = _ref32.drug,
        customerId = _ref32.customerId;

    drug.frequency = drug.frequency_unit !== null ? drug.frequency + ' a ' + drug.frequency_unit : drug.frequency;
    drug.route = drug.route ? drug.route.trim() : null;
    drug.instructions = drug.instructions ? drug.instructions.trim() : null;
    var index = state.drugs.findIndex(function (ele) {
      return ele.customerId === customerId;
    });
    if (index > -1) {
      state.drugs[index].drugs.push(drug);
    } else {
      var drugs = {
        drugs: [drug],
        customerId: customerId
      };
      state.drugs.push(drugs);
    }
  },
  removeDrugs: function removeDrugs(state, _ref33) {
    var customerId = _ref33.customerId;

    var drugIndex = state.drugs.findIndex(function (ele) {
      return ele.customerId === customerId;
    });
    state.selectedTests = state.selectedTests.filter(function (ele) {
      return ele.customerId !== customerId;
    });
    if (drugIndex > -1) {
      state.drugs = state.drugs.filter(function (ele) {
        return ele.customerId !== customerId;
      });
    }
  },
  storeLabTests: function storeLabTests(state, _ref34) {
    var tests = _ref34.tests,
        customerId = _ref34.customerId;

    var index = state.selectedTests.findIndex(function (test) {
      return test.customerId === customerId;
    });
    var selectedLabTests = {};
    var selectedTests = state.selectedTests;
    if (index > -1) {
      state.selectedTests[index].tests = tests;
    } else {
      selectedLabTests = {
        customerId: customerId,
        tests: tests
      };
      selectedTests.push(selectedLabTests);
      state.selectedTests = selectedTests;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "kewD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kf5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('navbar'),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.openMerForm)?_c('div',{class:[_vm.openMerForm ?  'is-active' : '', 'modal']},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":_vm.closeMerModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-quarter border-right"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"customer-name"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-quarter"}),_vm._v(" "),_c('div',{staticClass:"column is-centered"},[_c('h3',[_c('b',[_vm._v(_vm._s(_vm.mer.insured_name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.pi_mobile_number))])])])]),_vm._v(" "),_c('div',{staticClass:"call-attempt"},[_vm._v("\n              Calls Attempted: "+_vm._s(_vm.mer.attempted_calls)+"\n            ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.afterCallAttempt),expression:"afterCallAttempt"}],staticClass:"after-call-attempt"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"call-connected",on:{"click":_vm.showCallConnectedResult}},[_c('p',[_vm._v("Call Connected")])]),_vm._v(" "),_c('div',{staticClass:"call-not-connected",on:{"click":_vm.showCallNotConnectedResult}},[_c('p',[_vm._v("Call Not Connected")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.afterCallConnected),expression:"afterCallConnected"}],staticClass:"after-call-connected"},[_c('div',{staticClass:"call-heading"},[_c('p',[_c('b',[_c('span',{staticClass:"icon left-arrow",on:{"click":_vm.backToConnected}},[_c('i',{staticClass:"fa fa-home"}),_c('img',{attrs:{"src":"/static/images/back.png"}})]),_vm._v(" Call Connected:")])])]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Verification incomplete', 0)}}},[_vm._v("Verification incomplete")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Call Customer Later', 0)}}},[_vm._v("Call Customer Later")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){_vm.openDoctorRemarksForm('Call Status Call Disconnected (after picking up call)', 0)}}},[_vm._v("Call Status Call Disconnected (after picking up call)")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Customer not Audible', 0)}}},[_vm._v("Customer not Audible")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksFormFor('Language Missmatch with Customer', 0)}}},[_vm._v("Language Missmatch with Customer")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksFormFor('Customer not Co-operative', 0)}}},[_vm._v("Customer not Co-operative")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Medical Checkup done already', 0)}}},[_vm._v("Medical Checkup done already")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksFormFor('Wrong Customer on Call', 0)}}},[_vm._v("Wrong Customer on Call")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){_vm.openDoctorRemarksForm('Other Reason(s)', 0)}}},[_vm._v("Other Reason(s)")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.afterCallNotConnected),expression:"afterCallNotConnected"}],staticClass:"after-call-not-connected"},[_c('div',{staticClass:"call-heading"},[_c('p',[_c('b',[_c('span',{staticClass:"icon left-arrow",on:{"click":_vm.backToNotConnected}},[_c('i',{staticClass:"fa fa-home"}),_c('img',{attrs:{"src":"/static/images/back.png"}})]),_vm._v(" Call Not Connected:")])])]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Mobile Switched Off / Out of Coverage', 1)}}},[_vm._v("Mobile Switched Off / Out of Coverage")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Number Invalid', 1)}}},[_vm._v("Number Invalid")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){_vm.openDoctorRemarksForm('Call Disconnected(before picking of the call)', 1)}}},[_vm._v("Call Disconnected(before picking of the call)")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){return _vm.openDoctorRemarksForm('Network Busy', 1)}}},[_vm._v("Network Busy")]),_vm._v(" "),_c('p',{staticClass:"call-item",on:{"click":function($event){_vm.openDoctorRemarksForm('Other Reason(s)', 1)}}},[_vm._v("Other Reason(s)")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDoctorRemarksForm),expression:"showDoctorRemarksForm"}],staticClass:"doctor-remarks"},[_c('div',{staticClass:"call-heading"},[_c('p',[_c('b',[_c('span',{staticClass:"icon left-arrow",on:{"click":_vm.backFromRemarksForm}},[_c('i',{staticClass:"fa fa-home"}),_c('img',{attrs:{"src":"/static/images/back.png"}})]),_vm._v(" "+_vm._s(_vm.mer.call_status))])])]),_vm._v(" "),_c('div',{staticClass:"doctor-remarks-form"},[_vm._m(3),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.doctor_remarks),expression:"mer.doctor_remarks"}],attrs:{"cols":"30","rows":"5"},domProps:{"value":(_vm.mer.doctor_remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "doctor_remarks", $event.target.value)}}}),_vm._v(" "),_c('div',[_c('button',{staticClass:"button is-primary is-pulled-right",on:{"click":_vm.saveDoctorRemarks}},[_vm._v("save")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMerCompleted),expression:"isMerCompleted"}],staticClass:"mer-completed"},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"column modal-right-section"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"vertical-tab-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.callConnected),expression:"!callConnected"}],staticClass:"init-wizard has-text-centered"},[_c('b',[_vm._v("Click on call connected to start MER Questionnaire")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.callConnected),expression:"callConnected"}],staticClass:"wizard-wrapper"},[_c('vue-good-wizard',{ref:"wizard",attrs:{"steps":_vm.steps,"onNext":_vm.nextClicked,"onBack":_vm.backClicked}},[_c('div',{attrs:{"slot":"page1"},slot:"page1"},[_c('div',{staticClass:"inner-wrapper"},[_c('form',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Proposal No")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.application_no))])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Customer Name")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.insured_name))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.customer_name_verification),expression:"mer.customer_name_verification"},{name:"validate",rawName:"v-validate",value:('required|in:correct,incorrect'),expression:"'required|in:correct,incorrect'"}],attrs:{"type":"radio","name":"customer_name","value":"correct"},domProps:{"checked":_vm._q(_vm.mer.customer_name_verification,"correct")},on:{"change":function($event){return _vm.$set(_vm.mer, "customer_name_verification", "correct")}}}),_vm._v("\n                              Correct\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('customer_name')),expression:"errors.has('customer_name')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('customer_name')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.customer_name_verification),expression:"mer.customer_name_verification"}],attrs:{"type":"radio","name":"customer_name","value":"incorrect"},domProps:{"checked":_vm._q(_vm.mer.customer_name_verification,"incorrect")},on:{"change":function($event){return _vm.$set(_vm.mer, "customer_name_verification", "incorrect")}}}),_vm._v("\n                              Incorrect\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Name of the Nominee")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.nominee_name),expression:"mer.nominee_name"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],attrs:{"type":"text","name":"nominee_name"},domProps:{"value":(_vm.mer.nominee_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "nominee_name", $event.target.value)}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('nominee_name')),expression:"errors.has('nominee_name')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('nominee_name')))])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Gender")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.pi_gender))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.gender_verification),expression:"mer.gender_verification"},{name:"validate",rawName:"v-validate",value:('required|in:correct,incorrect'),expression:"'required|in:correct,incorrect'"}],attrs:{"type":"radio","name":"gender","value":"correct"},domProps:{"checked":_vm._q(_vm.mer.gender_verification,"correct")},on:{"change":function($event){return _vm.$set(_vm.mer, "gender_verification", "correct")}}}),_vm._v("\n                              Correct\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('gender')),expression:"errors.has('gender')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('gender')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.gender_verification),expression:"mer.gender_verification"}],attrs:{"type":"radio","name":"gender","value":"incorrect"},domProps:{"checked":_vm._q(_vm.mer.gender_verification,"incorrect")},on:{"change":function($event){return _vm.$set(_vm.mer, "gender_verification", "incorrect")}}}),_vm._v("\n                              Incorrect\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Date of Birth")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.dob))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.dob_verification),expression:"mer.dob_verification"},{name:"validate",rawName:"v-validate",value:('required|in:correct,incorrect'),expression:"'required|in:correct,incorrect'"}],attrs:{"type":"radio","name":"dob","value":"correct"},domProps:{"checked":_vm._q(_vm.mer.dob_verification,"correct")},on:{"change":function($event){return _vm.$set(_vm.mer, "dob_verification", "correct")}}}),_vm._v("\n                              Correct\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('dob')),expression:"errors.has('dob')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('dob')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.dob_verification),expression:"mer.dob_verification"}],attrs:{"type":"radio","name":"dob","value":"incorrect"},domProps:{"checked":_vm._q(_vm.mer.dob_verification,"incorrect")},on:{"change":function($event){return _vm.$set(_vm.mer, "dob_verification", "incorrect")}}}),_vm._v("\n                              Incorrect\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Martial Status")])]),_vm._v(" "),_c('p',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.martial_status),expression:"mer.martial_status"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"martial_status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.mer, "martial_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select an Option")]),_vm._v(" "),_c('option',{attrs:{"value":"Unmarried"}},[_vm._v("Unmarried")]),_vm._v(" "),_c('option',{attrs:{"value":"Married"}},[_vm._v("Married")]),_vm._v(" "),_c('option',{attrs:{"value":"Divorced"}},[_vm._v("Divorced")])])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('martial_status')),expression:"errors.has('martial_status')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('martial_status')))])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Occupation")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.occupation))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.occupation_verification),expression:"mer.occupation_verification"},{name:"validate",rawName:"v-validate",value:('required|in:correct,incorrect'),expression:"'required|in:correct,incorrect'"}],attrs:{"type":"radio","name":"occupation","value":"correct"},domProps:{"checked":_vm._q(_vm.mer.occupation_verification,"correct")},on:{"change":function($event){return _vm.$set(_vm.mer, "occupation_verification", "correct")}}}),_vm._v("\n                              Correct\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('occupation')),expression:"errors.has('occupation')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('occupation')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.occupation_verification),expression:"mer.occupation_verification"}],attrs:{"type":"radio","name":"occupation","value":"incorrect"},domProps:{"checked":_vm._q(_vm.mer.occupation_verification,"incorrect")},on:{"change":function($event){return _vm.$set(_vm.mer, "occupation_verification", "incorrect")}}}),_vm._v("\n                              Incorrect\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Question for Customer")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.secret_question))])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Answer")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.secret_answer),expression:"mer.secret_answer"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"answer"},domProps:{"value":(_vm.mer.secret_answer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "secret_answer", $event.target.value)}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('answer')),expression:"errors.has('answer')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('answer')))])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Customer has undergone medical check for PNB ?")])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.medical_check_verification),expression:"mer.medical_check_verification"},{name:"validate",rawName:"v-validate",value:('required|in:yes,no'),expression:"'required|in:yes,no'"}],attrs:{"type":"radio","name":"medical_check","value":"yes"},domProps:{"checked":_vm._q(_vm.mer.medical_check_verification,"yes")},on:{"change":function($event){return _vm.$set(_vm.mer, "medical_check_verification", "yes")}}}),_vm._v("\n                              Yes\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('medical_check')),expression:"errors.has('medical_check')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('medical_check')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.medical_check_verification),expression:"mer.medical_check_verification"}],attrs:{"type":"radio","name":"medical_check","value":"no"},domProps:{"checked":_vm._q(_vm.mer.medical_check_verification,"no")},on:{"change":function($event){return _vm.$set(_vm.mer, "medical_check_verification", "no")}}}),_vm._v("\n                              No\n                            ")])])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"page2"},slot:"page2"},[_c('div',{staticClass:"inner-wrapper"},_vm._l((_vm.merQuestions),function(q,i){return _c('div',{staticClass:"columns"},[(i == 0)?_c('div',{staticClass:"column"},[_c('p',[_c('span',[_vm._v(_vm._s(i+1)+". ")]),_vm._v(" "+_vm._s(q.question))]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.height_in_feet),expression:"mer.height_in_feet"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"number","name":"height-in-feet","min":"0","max":"6","placeholder":"feet"},domProps:{"value":(_vm.mer.height_in_feet)},on:{"change":_vm.convertToCms,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "height_in_feet", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.height_in_inches),expression:"mer.height_in_inches"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"number","name":"height-in-inches","min":"0","max":"12","placeholder":"inches"},domProps:{"value":(_vm.mer.height_in_inches)},on:{"change":_vm.convertToCms,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "height_in_inches", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('height-in-feet') && _vm.errors.has('height-in-cms')),expression:"errors.has('height-in-feet') && errors.has('height-in-cms')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('height-in-feet')))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('height-in-inches') && _vm.errors.has('height-in-cms')),expression:"errors.has('height-in-inches') && errors.has('height-in-cms')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('height-in-inches')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b',[_vm._v("( or )")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.height_in_cms),expression:"mer.height_in_cms"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"number","name":"height-in-cms","min":"1","max":"215","placeholder":"in centemetres"},domProps:{"value":(_vm.mer.height_in_cms)},on:{"change":_vm.convertToFeet,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "height_in_cms", $event.target.value)}}}),_vm._v(" Cms\n                              "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('height-in-cms') && _vm.errors.has('height-in-feet')),expression:"errors.has('height-in-cms') && errors.has('height-in-feet')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('height-in-cms')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.weight),expression:"mer.weight"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"number","name":"weight","min":"1","max":"100","placeholder":"weight"},domProps:{"value":(_vm.mer.weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "weight", $event.target.value)}}}),_vm._v(" Kgs\n                              "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('weight')),expression:"errors.has('weight')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('weight')))])])])])]):_vm._e(),_vm._v(" "),(i > 0)?_c('div',{staticClass:"column"},[_c('div',{staticClass:"mer-question"},[_c('p',[_c('span',[_vm._v(_vm._s(i+1)+". ")]),_vm._v(" "+_vm._s(q.question))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(q.alt_question !== null && q.alt_question !== undefined),expression:"q.alt_question !== null && q.alt_question !== undefined"}],staticClass:"alt-question"},[_c('p',[_c('b',[_vm._v("(or)")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(q.alt_question))])]),_vm._v(" "),_c('div',{staticClass:"columns  mb-0"},[_c('div',{staticClass:"is-one-quarter column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answers[i]),expression:"answers[i]"},{name:"validate",rawName:"v-validate",value:('required|in:yes,no'),expression:"'required|in:yes,no'"}],attrs:{"type":"radio","name":'q' + (i + 1),"value":"yes"},domProps:{"checked":_vm._q(_vm.answers[i],"yes")},on:{"change":function($event){return _vm.$set(_vm.answers, i, "yes")}}}),_vm._v(" Yes\n                              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('q' + (i + 1))),expression:"errors.has('q' + (i + 1))"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('q' + (i + 1))))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answers[i]),expression:"answers[i]"}],attrs:{"type":"radio","name":'q' + (i +1),"value":"no"},domProps:{"checked":_vm._q(_vm.answers[i],"no")},on:{"change":function($event){return _vm.$set(_vm.answers, i, "no")}}}),_vm._v(" No\n                              ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.answers[i] == 'yes' ),expression:"answers[i] == 'yes' "}],staticClass:"remarks-wrapper"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remarks[i]),expression:"remarks[i]"},{name:"validate",rawName:"v-validate",value:(_vm.answers[i] == 'yes' ? 'required' : ''),expression:"answers[i] == 'yes' ? 'required' : ''"}],attrs:{"name":'remarks' + (i + 1),"rows":"3","cols":"50","placeholder":"Remarks"},domProps:{"value":(_vm.remarks[i])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remarks, i, $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('remarks' + (i + 1))),expression:"errors.has('remarks' + (i + 1))"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('remarks' + (i + 1))))])])])]):_vm._e()])}),0)]),_vm._v(" "),_c('div',{attrs:{"slot":"page3"},slot:"page3"},[_c('div',{staticClass:"inner-wrapper"},[_c('div',{staticClass:"declaration-wrapper"},[_c('p',[_c('b',[_vm._v("Met Life Doctor :")])]),_vm._v(" "),_c('p',[_vm._v("Sir, I would like to take you through the Declaration which is part of this call.")]),_vm._v(" "),_c('div',{staticClass:"declaration-content"},[_c('p',[_c('b',[_vm._v("Declaration: ")])]),_vm._v(" "),_c('p',[_vm._v("\n                            You Mr/Ms "),_c('span',[_vm._v(_vm._s(_vm.mer.insured_name))]),_vm._v(", declare that, you have fully understood the questions asked to you as per this call and have furnished complete, true and accurate information after fully understanding the same.\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"declaration-content"},[_c('p',[_c('b',[_vm._v("MetLife Doctor :")])]),_vm._v(" "),_c('p',[_vm._v("Sir, are you in agreement with the declaration that I have read out to you ?\n                          ")]),_vm._v(" "),_c('p',[_vm._v("We thank you for having taken the time to confirm the details. We will process your proposal based on the information provided.")])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"page4"},slot:"page4"},[_c('div',{staticClass:"inner-wrapper"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Proposal No.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.application_no))])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Name of the proposed Insured")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mer.insured_name))])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Doctors Feedback and Findings")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mer.feedback),expression:"mer.feedback"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"cols":"70","rows":"5","name":"feedback"},domProps:{"value":(_vm.mer.feedback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mer, "feedback", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('feedback')),expression:"errors.has('feedback')"}],staticClass:"help is-danger"},[_c('small',[_vm._v(_vm._s(_vm.errors.first('feedback')))])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"declaration-content"},[_c('p',[_vm._v("\n                              I hereby declare that I have conducted Tele MER of proposed insured, mentioned herein, after due\n                              verification of his / her identity and the replies given by me above are based on the said Tele MER.\n                              I further affirm that nothing has been misrepresented or concealed by me. I understand that findings\n                              of the Tele Medical Examination are significant since the findings herein are relevant for assignment\n                              of risk by "),_c('b',[_vm._v("PNB MetLife India Insurance Company Ltd.")]),_vm._v(" and shall form the part of the contract between\n                              the life examine and the "),_c('b',[_vm._v("PNB MetLife India India Insurance Company Ltd.")])])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Registration No.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.doctorProfile.registration_number))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Signature")])]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":_vm.doctorProfile.signature}})])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Date")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("formatDate")(new Date())))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_c('small',[_vm._v("Name of the Examiner")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.doctorProfile.name))])])])])])])],1)])])])])])]):_vm._e(),_vm._v(" "),_c('div',{class:[_vm.openRejectMerForm ?  'is-active' : '', 'modal']},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Reject MER")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":_vm.closeRejectMerModal}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_vm._m(7),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.rejectingMer.application_no))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._m(8),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.availableCallAttempts(_vm.rejectingMer)))])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_vm._m(9),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rejectingMer.reason_for_reject),expression:"rejectingMer.reason_for_reject"}],attrs:{"cols":"70","rows":"5"},domProps:{"value":(_vm.rejectingMer.reason_for_reject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rejectingMer, "reason_for_reject", $event.target.value)}}})])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-primary is-pulled-right",on:{"click":_vm.rejectMer}},[_vm._v("Reject")])])])]),_vm._v(" "),_c('div',{class:[_vm.showReasonModal ?  'is-active' : '', 'modal']},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Reason to Reject")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":_vm.closeReason}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_vm._m(10),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.rejectedMer.application_no))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._m(11),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.rejectedMer.call_status))])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_vm._m(12),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.rejectedMer.reason_for_reject || '-'))])])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"})])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"id":"content"}},[_c('h4',[_vm._v("Medical Examination Report List")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call-status"},[_c('h3',[_c('b',[_vm._v("Call Status")])]),_vm._v(" "),_c('p',[_c('small',[_vm._v("Do call the customer and update the call status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Tell us what happened ?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Doctor's Remarks(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-centered"},[_c('h2',[_c('b',[_vm._v("MER Completed")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('b',[_vm._v("MER Test - PNB")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Please enter and verify below details when on call with the customer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Proposal No.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Attempts Available")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Reason for rejection")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Proposal No.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Call Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Reason For Reject")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kgdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index_js__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      doctorName: sessionStorage.getItem('name'),
      currentStatus: sessionStorage.getItem('chatstatus') ? sessionStorage.getItem('chatstatus') : 'unavailable',
      role: sessionStorage.getItem('role'),
      company_id: JSON.parse(sessionStorage.getItem('company_id')),
      logOut: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    doctor: 'configuration/doctor'
  })),
  methods: {
    logout: function logout() {
      sessionStorage.clear();
      // ably.close()
      this.$store.dispatch('clearAll');
      __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].go('/logout');
    }
  }
});

/***/ }),

/***/ "kiJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthCoachProgress_vue__ = __webpack_require__("3f2R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4e632d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthCoachProgress_vue__ = __webpack_require__("53lz");
function injectStyle (ssrContext) {
  __webpack_require__("KCBn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4e632d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthCoachProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4e632d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthCoachProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kkfI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: function fetch(status, page) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/appointment_requests?status=' + status + '&page=' + page);
  },
  approve: function approve(id, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/appointment_requests/' + id, { doctor_status: 'Approved', doctor_id: doctorId });
  },
  reject: function reject(id, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/appointment_requests/' + id, { doctor_status: 'Rejected', doctor_id: doctorId });
  },
  furtherTesting: function furtherTesting(id, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/appointment_requests/' + id, { doctor_status: 'further_testing', doctor_id: doctorId });
  },
  saveComment: function saveComment(id, comment, doctorId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/appointment_requests/' + id, { doctor_comments: comment, doctor_id: doctorId });
  },
  search: function search(query) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/appointment_requests/search?q=' + query);
  },
  reschedule: function reschedule(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(window.API_URL + 'doctors/customers/appointment_requests/' + payload.id, payload);
  }
});

/***/ }),

/***/ "kmHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/* harmony default export */ __webpack_exports__["a"] = ({
  update: function update(customerId, medications) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(window.API_URL + 'doctors/medication/update', { customer_id: customerId, medications: medications });
  }
});

/***/ }),

/***/ "kn1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-hidden bg-white"},[_c('div',{staticClass:"flex flex-row bg-white justify-between items-center px-10 h-14 my-4"},[_c('div',{staticClass:"text-dark text-2xl font-semibold h-15 text-center mr-auto"},[_vm._v("DOCTOR ROSTER")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between m-2 ml-auto"},[_c('div',{staticClass:"flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMonth.value),expression:"selectedMonth.value"}],staticClass:"flex appearance-none mr-2 w-auto h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedMonth, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onMonthYearChange]}},_vm._l((_vm.months),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v("\n            "+_vm._s(month.text)+"\n          ")])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedYear),expression:"selectedYear"}],staticClass:"flex appearance-none w-16 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onMonthYearChange]}},_vm._l((_vm.years),function(year,index){return _c('option',{key:index,domProps:{"value":year}},[_vm._v("\n            "+_vm._s(year)+"\n          ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"doc_header bg-grey-lightest"},[(!['externalAdmin'].includes(this.role))?_c('div',{staticClass:"text-grey text-md font-semibold cursor-pointer hover:text-blue pt-1",class:[_vm.activeSlots === 'family_doctor' ? 'text-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveSlots('family_doctor')}}},[_vm._v("Internal Doctors")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-grey text-md font-semibold cursor-pointer pt-1",class:[_vm.activeSlots === 'external_doctor' ? 'text-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveSlots('external_doctor')}}},[_vm._v("External Doctors")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-grey-lightest mb-4",staticStyle:{"height":"0.125rem"}},[(!['externalAdmin'].includes(this.role))?_c('div',{staticClass:"w-1/2",class:[_vm.activeSlots === 'family_doctor' ? 'bg-blue' : '']}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-1/2",class:[_vm.activeSlots === 'external_doctor' ? 'bg-blue' : '']})]),_vm._v(" "),_c('doctor-slots',{attrs:{"rosterType":_vm.activeSlots,"selectedMonth":_vm.selectedMonth.value,"selectedYear":_vm.selectedYear}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "krm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeReloadOverlay: function closeReloadOverlay() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "l4MF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(status) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + 'doctors/covid?status=' + status);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/covid/' + data.id, data.params);
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/covid', data.params);
  }
});

/***/ }),

/***/ "lCzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closePopup()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20 p-4",staticStyle:{"width":"380px","left":"calc((108vw - 500px)/2)","top":"150px","z-index":"99"}},[_c('img',{staticClass:"w-6 h-6 cursor-pointer flex absolute pin-r m-2 pin-t",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closePopup()}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center mb-4 mx-4 mt-16 pt-10 bg-grey-lighter"},[_c('img',{staticClass:"flex self-center mt-10 absolute pin-t",staticStyle:{"width":"100px"},attrs:{"src":__webpack_require__("XC34")}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"border border-solid border-grey-lightest p-1 py-2 rounded m-1 my-2 text-sm",attrs:{"name":"","id":"","cols":"30","rows":"6"},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center mb-4"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.sendEnquiry()}}},[_vm._v("Send Enquiry")])])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center items-center p-1"},[_c('label',{staticClass:"flex align-center text-grey-darker text-xs",staticStyle:{"color":"#ffb100"}},[_vm._v("Note")]),_vm._v(" "),_c('div',{staticClass:"flex text-grey-dark text-xs p-1 px-4 text-center"},[_vm._v("The patient will schedule a call consultation if his query is not answered")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lGU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabMenu__ = __webpack_require__("PLr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Customer_HealthCoachProgram__ = __webpack_require__("p4+P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Customer_PatientMedicalHistory__ = __webpack_require__("xhXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Customer_Drugs__ = __webpack_require__("Myi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Customer_Forms__ = __webpack_require__("ykgE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Customer_HealthProfile__ = __webpack_require__("YJuw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Customer_HealthScore__ = __webpack_require__("b0gp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Customer_OrderLabs__ = __webpack_require__("iAtw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Customer_CustomerPastConsults__ = __webpack_require__("Oquu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Customer_PatientDocs__ = __webpack_require__("oFZC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Customer_ConsultationSummary__ = __webpack_require__("v3A3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Customer_CustomerNotification__ = __webpack_require__("Xqth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TabMenu: __WEBPACK_IMPORTED_MODULE_0__components_TabMenu__["a" /* default */],
    HealthCoach: __WEBPACK_IMPORTED_MODULE_1__components_Customer_HealthCoachProgram__["a" /* default */],
    PatientHistory: __WEBPACK_IMPORTED_MODULE_2__components_Customer_PatientMedicalHistory__["a" /* default */],
    Drugs: __WEBPACK_IMPORTED_MODULE_3__components_Customer_Drugs__["a" /* default */],
    Forms: __WEBPACK_IMPORTED_MODULE_4__components_Customer_Forms__["a" /* default */],
    HealthProfile: __WEBPACK_IMPORTED_MODULE_5__components_Customer_HealthProfile__["a" /* default */],
    HealthScore: __WEBPACK_IMPORTED_MODULE_6__components_Customer_HealthScore__["a" /* default */],
    OrderLabs: __WEBPACK_IMPORTED_MODULE_7__components_Customer_OrderLabs__["a" /* default */],
    CustomerPastConsults: __WEBPACK_IMPORTED_MODULE_8__components_Customer_CustomerPastConsults__["a" /* default */],
    PatientDocuments: __WEBPACK_IMPORTED_MODULE_9__components_Customer_PatientDocs__["a" /* default */],
    ConsultationSummary: __WEBPACK_IMPORTED_MODULE_10__components_Customer_ConsultationSummary__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_11__components_Customer_CustomerNotification__["a" /* default */]
  },
  props: ['selectedTab', 'showRightPane', 'showToggleButton', 'chatType'],
  data: function data() {
    return {};
  },

  computed: {
    url: function url() {
      return '../assets/close_bar.png';
    },
    currentProps: function currentProps() {
      return { chatType: this.chatType };
    }
  },
  methods: {
    tabChange: function tabChange(tab) {
      this.$emit('tabChange', tab);
    },
    togglePane: function togglePane() {
      this.$emit('toggleRightPane', !this.showRightPane);
    }
  }
});

/***/ }),

/***/ "lLha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('admin-navbar'),_vm._v(" "),_c('div',{staticClass:"relative w-screen flex flex-row flex-no-grow flex-no-shrink overflow-y-hidden z-0",staticStyle:{"height":"calc(100vh - 3rem)"}},[_c('mini-menu',{on:{"getAdminMenu":_vm.getAdminMenu}}),_vm._v(" "),_c(_vm.selectedMenu,{tag:"component",staticClass:"flex flex-row w-screen",staticStyle:{"height":"inherit"},on:{"getAdminMenu":_vm.getAdminMenu}})],1),_vm._v(" "),(_vm.role !== 'externalAdmin')?_c('div',{staticClass:"loader"},[_c('loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toaster"},[_c('toaster')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lN29":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a938fb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("mj7P");
function injectStyle (ssrContext) {
  __webpack_require__("zjGQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a938fb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lXhI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiNGNUY3RjkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "lY5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PastOfflineConsultations_vue__ = __webpack_require__("pRXO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f71f4de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PastOfflineConsultations_vue__ = __webpack_require__("gxl/");
function injectStyle (ssrContext) {
  __webpack_require__("B1mA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PastOfflineConsultations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f71f4de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PastOfflineConsultations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lYso":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQwOTYyIDkuNDE0ODNDNy4yMTA1NyA5LjY5OTE5IDYuNzg5NDQgOS42OTkxOSA2LjU5MDM4IDkuNDE0ODNMMC41NTA3MTQgMC43ODY3MzNDMC4zMTg3NDIgMC40NTUzNDMgMC41NTU4MTcgMCAwLjk2MDMyOSAwSDEzLjAzOTdDMTMuNDQ0MiAwIDEzLjY4MTMgMC40NTUzNDIgMTMuNDQ5MyAwLjc4NjczMUw3LjQwOTYyIDkuNDE0ODNaIiBmaWxsPSIjN0M4Q0FCIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "ldQ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12eef7da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("Pa/7");
function injectStyle (ssrContext) {
  __webpack_require__("RoHf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12eef7da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12eef7da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lwCE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MDAgNTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzY2NjY2Njt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0OS44LDQ3N2MtMTE3LDAtMjEyLjMtOTUuMi0yMTIuMy0yMTIuM2MwLTcwLjYsMzUtMTM2LjQsOTMuNi0xNzZjMTEuNC03LjcsMjctNC43LDM0LjcsNi43czQuNywyNy02LjcsMzQuNwoJCWMtNDQuOCwzMC4zLTcxLjYsODAuNi03MS42LDEzNC42YzAsODkuNSw3Mi44LDE2Mi4zLDE2Mi4zLDE2Mi4zczE2Mi4zLTcyLjgsMTYyLjMtMTYyLjNjMC01NC43LTI3LjMtMTA1LjQtNzMtMTM1LjYKCQljLTExLjUtNy42LTE0LjctMjMuMS03LjEtMzQuNmM3LjYtMTEuNSwyMy4xLTE0LjcsMzQuNi03LjFjNTkuOCwzOS41LDk1LjUsMTA1LjcsOTUuNSwxNzcuM0M0NjIuMSwzODEuOCwzNjYuOCw0NzcsMjQ5LjgsNDc3eiIvPgo8L2c+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0OC43LDI1Ny42YzAsMC0wLjEsMC0wLjEsMGMtMTMuOC0wLjEtMjQuOS0xMS4zLTI0LjktMjUuMWwxLjEtMTg0LjZjMC4xLTEzLjgsMTEuMy0yNC45LDI1LTI0LjkKCQljMCwwLDAuMSwwLDAuMSwwYzEzLjgsMC4xLDI0LjksMTEuMywyNC45LDI1LjFsLTEuMSwxODQuNkMyNzMuNywyNDYuNSwyNjIuNSwyNTcuNiwyNDguNywyNTcuNnoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "m3gr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeOverlay: function closeOverlay() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "m6sa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientReports_vue__ = __webpack_require__("ZP4w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6092d752_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientReports_vue__ = __webpack_require__("xO57");
function injectStyle (ssrContext) {
  __webpack_require__("P2qI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6092d752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6092d752_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mT1R":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMjE2OEYzO30KPC9zdHlsZT4KPGcgaWQ9Ik5ldy1JY29ucyI+Cgk8ZyBpZD0ibm90aWZpY2F0aW9uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4KCQk8Zz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE3LjMsMTQuMUwxNy4zLDE0LjFjLTAuMSwwLTEuMy0wLjEtMS4zLTIuNFY2LjljMC0zLjktMy4yLTcuMS03LjEtNy4xQzUuMS0wLjEsMiwzLDIsNi45djQuOAoJCQkJYzAsMi4zLTEuMiwyLjQtMS4zLDIuNGMtMC40LDAtMC44LDAuNC0wLjgsMC44YzAsMC41LDAuNCwwLjgsMC44LDAuOGg1LjhDNi42LDE3LDcuNiwxOCw5LDE4YzEuMywwLDIuNC0xLjEsMi41LTIuNGg1LjgKCQkJCWMwLjUsMCwwLjgtMC40LDAuOC0wLjhDMTguMSwxNC41LDE3LjgsMTQuMiwxNy4zLDE0LjF6IE05LDE2LjRjLTAuNCwwLTAuNy0wLjItMC43LTAuNmgxLjVDOS43LDE2LjIsOS40LDE2LjQsOSwxNi40eiBNMy4xLDE0LjEKCQkJCWMwLjMtMC42LDAuNS0xLjMsMC41LTIuMnYtNUMzLjYsNCw2LDEuNSw5LDEuNXM1LjQsMi40LDUuNCw1LjR2NC44YzAsMC4yLDAsMC4zLDAsMC40YzAsMC44LDAuMiwxLjQsMC41LDJIMy4xeiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "mj7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"relative w-screen flex flex-row flex-no-grow flex-no-shrink overflow-y-hidden z-0 bg-grey-extralight",staticStyle:{"height":"calc(100vh - 3rem)"}},[_c('mini-menu',{staticStyle:{"height":"inherit"}}),_vm._v(" "),_c(_vm.selectedMenu,{tag:"component",staticClass:"flex flex-row w-screen",staticStyle:{"height":"inherit"}})],1),_vm._v(" "),_c('div',{staticClass:"loader"},[_c('loader')],1),_vm._v(" "),_c('div',{staticClass:"toaster"},[_c('toaster')],1),_vm._v(" "),_c('NewUpdateAvailableModal'),_vm._v(" "),(_vm.isReloaded)?_c('div',[(_vm.queries.length > 0)?_c('PendingQueriesModal',{on:{"close":_vm.closeReloadOverlay}}):_c('BackOnlineModal',{on:{"close":_vm.closeReloadOverlay}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mnRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keyPoints; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_doctor_svg__ = __webpack_require__("WhZd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_doctor_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_doctor_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_chat_svg__ = __webpack_require__("Xsot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_chat_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_chat_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_response_svg__ = __webpack_require__("nycC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_response_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_response_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_secure_svg__ = __webpack_require__("KNjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_secure_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_secure_svg__);





var content = [{
  heading: 'Facilitates smooth, real-time doctor-user',
  text: ' communication for efficient consultations.',
  image: __WEBPACK_IMPORTED_MODULE_0__assets_doctor_svg___default.a
}, {
  heading: 'Supports video, voice, and text consultations,',
  text: ' offering flexible options for users.',
  image: __WEBPACK_IMPORTED_MODULE_1__assets_chat_svg___default.a
}, {
  heading: 'Allows doctors to provide prompt responses to',
  text: ' medical queries, enhancing care delivery.',
  image: __WEBPACK_IMPORTED_MODULE_2__assets_response_svg___default.a
}, {
  heading: 'Maintains patient confidentiality through a secure,',
  text: ' HIPAA-compliant platform.',
  image: __WEBPACK_IMPORTED_MODULE_3__assets_secure_svg___default.a
}];

var keyPoints = [{
  heading: '1,000+',
  text: 'registered doctors'
}, {
  heading: '1,000+',
  text: 'consultations conducted'
}, {
  heading: '50+',
  text: 'specialties covered'
}];

/***/ }),

/***/ "mryS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modals_EnquireNowCard__ = __webpack_require__("y5on");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EnquireNowCard: __WEBPACK_IMPORTED_MODULE_2__components_common_modals_EnquireNowCard__["a" /* default */]
  },
  data: function data() {
    return {
      enquireNow: false,
      activeNotification: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    requests: 'consultationRequest/getRequests',
    notifications: 'configuration/customerNotifications'
  })),
  methods: {
    onNotificationClick: function onNotificationClick(n) {
      this.$store.dispatch('configuration/updateReadNotification', n.id);
    },
    requiredAction: function requiredAction(n) {
      this.activeNotification = n;
      if (n.required_action === 'Respond Back') {
        var req = this.requests.find(function (ele) {
          return ele.consultationRequestId === n.request_id;
        });
        if (req) this.acceptQuery(req);
      } else if (n.required_action === 'Enquire Now') {
        this.enquireNow = true;
      }
    },
    acceptQuery: function acceptQuery(n) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', n);
    },
    closePopup: function closePopup() {
      this.enquireNow = false;
    }
  }
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index_js__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_loginContent__ = __webpack_require__("mnRD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_login_pattern1_svg__ = __webpack_require__("QWj2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_login_pattern1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_login_pattern1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_login_pattern2_svg__ = __webpack_require__("udZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_login_pattern2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_login_pattern2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_cura_hub_svg__ = __webpack_require__("5Ies");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_cura_hub_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_cura_hub_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_alert_icon_svg__ = __webpack_require__("U22S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_alert_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_alert_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_eye_svg__ = __webpack_require__("9PB9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_eye_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_eye_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_eyeoff_svg__ = __webpack_require__("gqxa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_eyeoff_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_eyeoff_svg__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_toast_notification___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      credentials: {
        username: '',
        password: '',
        url: 'online_doctors/sign_in'
      },
      error: false,
      showAlreadyLogged: false,
      showLogin: true,
      isLoading: false,
      isActive: true,
      isClosable: false,
      isFullPage: true,
      usernameError: null,
      passwordError: null,
      emailError: null,
      isForgotPassword: false,
      email: null,
      isEmailVerified: false,
      secureAccount: false,
      content: __WEBPACK_IMPORTED_MODULE_9__data_loginContent__["a" /* content */],
      keyPoints: __WEBPACK_IMPORTED_MODULE_9__data_loginContent__["b" /* keyPoints */],
      loginPattern1: __WEBPACK_IMPORTED_MODULE_10__assets_login_pattern1_svg___default.a,
      loginPattern2: __WEBPACK_IMPORTED_MODULE_11__assets_login_pattern2_svg___default.a,
      disabled: false,
      showPassword: false,
      curaLogo: __WEBPACK_IMPORTED_MODULE_12__assets_cura_hub_svg___default.a,
      alertIcon: __WEBPACK_IMPORTED_MODULE_13__assets_alert_icon_svg___default.a,
      eye: __WEBPACK_IMPORTED_MODULE_14__assets_eye_svg___default.a,
      eyeoff: __WEBPACK_IMPORTED_MODULE_15__assets_eyeoff_svg___default.a
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    role: function role(state) {
      return state.configuration.role;
    }
  })),
  methods: {
    submit: function submit() {
      var _this = this;

      event.preventDefault();
      if (this.credentials.username.length < 2) {
        this.usernameError = 'Please enter username';
        this.passwordError = null;
        this.error = true;
        return;
      }
      if (this.credentials.password.length < 1) {
        this.passwordError = 'Please enter a password';
        this.usernameError = null;
        this.error = true;
        return;
      }
      var credentials = {
        email: this.credentials.username,
        password: this.credentials.password
      };
      var mfaToken = sessionStorage.getItem('mfa_token');
      if (mfaToken) {
        credentials = { mfa_token: mfaToken };
      }
      this.isLoading = true;
      this.$http.post(window.API_URL + this.credentials.url, credentials).then(function (response) {
        if (response.status === 200) {
          if (response.headers.get('X-DOCTOR-KEY')) {
            __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.setUserContext({ name: response.body.doctor.name, id: response.body.doctor.doctor_id });
            sessionStorage.setItem('X-DOCTOR-KEY', response.headers.get('X-DOCTOR-KEY'));
            sessionStorage.setItem('availableForChat', false);
            sessionStorage.setItem('isLoggedIn', true);
            sessionStorage.removeItem('mfa_token');
            _this.$store.dispatch('configuration/init');
            if (response.body.doctor.role === 'admin') {
              sessionStorage.setItem('isAdmin', true);
              __WEBPACK_IMPORTED_MODULE_2__router_index_js__["a" /* default */].push('admin-home');
            } else {
              __WEBPACK_IMPORTED_MODULE_2__router_index_js__["a" /* default */].push('home');
            }
            _this.clearLocalForage();
          } else if (response.body.mfa_token) {
            sessionStorage.setItem('mfa_token', response.body.mfa_token);
            sessionStorage.setItem('role', response.body.role);
            _this.secureAccount = true;
          } else if (response.body.mfa_enabled) {
            sessionStorage.setItem('mfa_enabled', response.body.mfa_enabled);
            sessionStorage.setItem('mfa_type', response.body.mfa_type);
            __WEBPACK_IMPORTED_MODULE_2__router_index_js__["a" /* default */].push({
              name: 'MFA-OTP',
              params: {
                username: _this.credentials.username,
                password: _this.credentials.password,
                type: response.body.mfa_type
              }
            });
          } else {
            _this.isLoading = false;
            _this.error = true;
            if (response.body.message === 'Invalid Credentials') {
              _this.passwordError = 'Password does not match. Please enter correct password to continue.';
              _this.usernameError = null;
            } else if (response.body.message === 'account locked') {
              _this.$toast.open({
                message: 'Your account has been locked, please try after 24 hours.',
                type: 'error',
                position: 'top',
                queue: false
              });
            } else {
              _this.usernameError = 'Email does not exist. Please enter correct email to continue.';
              _this.passwordError = null;
            }
          }
        }
      }, function (response) {});
    },

    forgotPassword: function forgotPassword() {
      this.isForgotPassword = true;
    },
    submitEmail: function submitEmail() {
      var _this2 = this;

      event.preventDefault();
      var email = this.email;
      this.isLoading = true;
      this.$http.post(window.API_URL + 'doctors/verify_email?email=' + email).then(function (response) {
        if (response.status === 200) {
          _this2.isLoading = false;
          console.log('mail has been sent to your email');
          _this2.isEmailVerified = true;
          _this2.error = false;
          _this2.emailError = null;
        }
      }).catch(function (error) {
        this.isLoading = false;
        console.log(error);
        if (error.status === 401) {
          this.isEmailVerified = false;
          this.error = true;
          this.emailError = error.body.message;
        } else if (error.status === 500) {
          this.$toast.open({
            message: error.body.message,
            type: 'error',
            position: 'top',
            queue: false
          });
        }
      });
    },
    goBack: function goBack() {
      this.isForgotPassword = false;
      this.isEmailVerified = false;
      this.email = null;
      this.error = false;
      this.emailError = null;
    },
    enableMfaSetting: function enableMfaSetting() {
      this.secureAccount = false;
      __WEBPACK_IMPORTED_MODULE_2__router_index_js__["a" /* default */].push('mfa-settings');
    },
    skipMfaSetting: function skipMfaSetting() {
      this.credentials.url = 'doctors/mfa_settings/skip_enable_mfa';
      this.submit();
    },

    toggleVisibility: function toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    clearLocalForage: function clearLocalForage() {
      __WEBPACK_IMPORTED_MODULE_8_localforage___default.a.iterate(function (data, key, index) {
        if (index === 1) {
          return [key, data];
        }
      }).then(function (result) {
        var data = result[1];
        var i = data.length;
        while (i--) {
          var entryDate = new Date(data[i].created_at);
          var now = new Date();
          var diff = Math.abs(now - entryDate);
          var diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
          if (diffDays >= 3) {
            data.splice(i, 1);
          }
        }
        __WEBPACK_IMPORTED_MODULE_8_localforage___default.a.setItem('audits', data);
      });
    }
  },
  mounted: function mounted() {
    if (!sessionStorage.length) {
      // Ask other tabs for session storage
      localStorage.setItem('getSessionStorage', Date.now());
    }
    if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
      this.showAlreadyLogged = true;
      this.showLogin = false;
    } else {
      window.addEventListener('storage', function (event) {
        if (event.key === 'getSessionStorage') {
          // Some tab asked for the sessionStorage -> send it
          localStorage.setItem('sessionStorage', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sessionStorage));
          localStorage.removeItem('sessionStorage');
        } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
          // sessionStorage is empty -> fill it
          var data = JSON.parse(event.newValue);
          for (var key in data) {
            sessionStorage.setItem(key, data[key]);
          }
          if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
            this.showAlreadyLogged = true;
            this.showLogin = false;
          } else {
            this.showAlreadyLogged = false;
            this.showLogin = true;
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "nNde":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAE+ElEQVR4nO2dTUxcVRTH/+e9oaBtakJtgdLOUGBjoC51YdTadqVJoyGRSqJLajfaxIUyQpwojJhWt2DqymoKidFo1F0xumhiXNqPTWk7TGEmNbSxSmA+3j0upAnifTDT3pkzlPNbnvvuOW/eb+68++57PABFURRFURRFURRFURRls0CVTB6N3zhE5PUS42kAewFsrWQ9hywASAP4hT1vMjXcPFWpQhUR0PFOujMg/zQIByqRv+owTwV+pD893DTtOrVzAdGB2ac8om8B7HCdW5h5Jj6SGmk97zKpUwGxwew+MuZXADtd5q0hbvkmeHJ6dO8VVwk9V4kAgILgMzy4Bx8AGgPyT7tM6ExANH7jEIgOuspXsxAOxOKZ51yli7hKROT1gq1NOSbEwXVnU8mdGVf1Kkks/kcLUOwj8AiA+tXtBO4F8JOLWu4EMJ6xxRn0bmqk5RNXdarB8hfl430DGWLik5ZNnnVVy9lPEAOttjgV/C9d1ag2XPS/sMaBPa5qOBNAwDZb/PrJXVlXNapN2L6HfdZ7weksSCkfFSCMChBGBQijAoRRAcKoAGFUgDDOliLKpS0+Z185EuJ6cndF7w6GoSNAGBUgjAoQRgUIowKEEZsFSc06ag0dAcKoAGFUgDAqQBgVIIwKEEYFCKMChFEBwqgAYVSAMDV3RyxsjajcO2iu1poqvWalI0AYFSCMChBGBQijAoRxdoYvd1YjRa09j6QjQBgVIIwKEEYFCKMChNl0a0Hl5i93FlduHh0BwqgAYVSAMCpAGBUgzIZ5OroKa0p3AGxfHexK3Nx2MbHr71ISdCbmtxfzOVvTUlgfHQF3YaRt4cWl4LFSUxRzhbBtb4b1UQHLsMfXbHHj8SslJyFj3ZaA38O6qIBlPEPfhTQdjw5lutbr3z6U3Q/gmK3NMH8TWre03XvwCbjwFYC8panBC/jHjni2O6xv+1B2vwnM9wAaLM155uLXYX3FTsK1xsxo7HbbwNw4CG9YmqMBzG9tA3PjgDextd67CAALBdMNNkdNYF6H5eV+y4zNjMZuh9VVASuI1NcPFfO5Htjff9cAwgnAnFjIm9ISErJeseG9tTbRn6AVXEnsuMOe9xoA61yyTJaYqe/qR41/rrWRClhFarh5iphfZqB4H2kCYno1lWxZ992iLgX8ZQv++xLUjQV7Dh5WKDGHSwFz9nCxz2GNitM+OHsYTJN0f+dHn5nPxAaz677K2aWAn21BAo/E4pm3NsJIaH/71iPG0OcIn9GUQz0ZPtOZmP/f8sZKnM2C2PMmyZh+646ATwGFU23xkEFSAe5l7ch4S+8DCPuiLBJjjJgmFop0CQAerucuZj4K4Dis1wC8u5jLfQDgzbCaThe42gZmz9XKG9TLFbAnkW6M5P0MgC2W5pRhen7mw5ZLtr4d8Wx3APMDgKilOW9MoTnsWsDpLCjwI/0A5l3mrBZ1Ob8H9oO/uNbBB4DpZPMFH94LsK96bvG9up6wvk4FpIebppn4CDagBCa8ZIsTY2ytg3+X6WTzBTDGQ5pfDOvn/DogNdJ63hj/CQKdc527wjxuCxLTRKkJyKOztjiH5AYqdCE2M9p09Vqy5TCDDgL4FMBlBkq6qSHIo7bgQw3+5VITbClEwrYN/bcuNfXksiT6XNAmRQUIowKEUQHCqABhNt0sSP9GTPkPKkAYFSCMChBGBQjzDy65fOoa0l+yAAAAAElFTkSuQmCC"

/***/ }),

/***/ "nZiJ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjU5MDM4IDAuNTg1MTY3QzYuNzg5NDMgMC4zMDA4MDkgNy4yMTA1NiAwLjMwMDgwOSA3LjQwOTYyIDAuNTg1MTY3TDEzLjQ0OTMgOS4yMTMyN0MxMy42ODEzIDkuNTQ0NjYgMTMuNDQ0MiAxMCAxMy4wMzk3IDEwTDAuOTYwMzI2IDEwQzAuNTU1ODE1IDEwIDAuMzE4NzM4IDkuNTQ0NjYgMC41NTA3MSA5LjIxMzI3TDYuNTkwMzggMC41ODUxNjdaIiBmaWxsPSIjN0M4Q0FCIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "nxCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col p-2 flex-no-shrink flex-no-grow rounded-sm bg-white",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"flex justify-between w-full mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex mr-auto"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark tracking-wide",staticStyle:{"text-transform":"uppercase"},attrs:{"for":"prescribe_drug"}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])]),_vm._v(" "),(!_vm.inEdit && _vm.canEdit)?_c('div',{staticClass:"flex ml-auto mr-1",on:{"click":function($event){return _vm.edit()}}},[_c('span',{staticClass:"justify-center cursor-pointer text-blue text-sm font-semibold"},[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.inEdit)?_c('div',{staticClass:"flex ml-auto"},[(!_vm.editMode || _vm.editMode === 'false')?_c('span',{staticClass:"justify-center cursor-pointer text-blue text-sm font-semibold",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!_vm.editMode || _vm.editMode === 'false')?_c('span',{staticClass:"pl-2 justify-center cursor-pointer text-grey-light text-sm font-semibold",on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel")]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.inEdit)?_c('div',[_c('p',{staticClass:"text-grey-darker text-m",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_c('div',{staticClass:"flex flex-row flex-no-shrink flex-no-grow relative"},[_c('div',{staticClass:"p-2 pr-10 w-full relative bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest",staticStyle:{"outline":"none","overflow-y":"auto","text-overflow":"inherit","min-height":"2rem","line-height":"1.2"},attrs:{"contenteditable":"true","id":'editor_'+_vm.fieldId},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"input":function($event){return _vm.onDivInput($event)},"blur":function($event){return _vm.onBlurEvent()}}}),_vm._v(" "),_c('div',{staticClass:"h-8 w-8 absolute pin-r",staticStyle:{"margin-top":"2px"}},[_c('SpeechRecognition',{attrs:{"message":_vm.message},on:{"getVoiceMessage":_vm.getVoiceMessage}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nycC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "oFZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientDocs_vue__ = __webpack_require__("RIlB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8691368e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientDocs_vue__ = __webpack_require__("jIWn");
function injectStyle (ssrContext) {
  __webpack_require__("QDv6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8691368e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientDocs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8691368e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientDocs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oKlt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKrw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ably__ = __webpack_require__("cQ0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ably___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ably__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parser__ = __webpack_require__("2JCH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_chat_message__ = __webpack_require__("fiF/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_localforage__);


// import Vue from 'vue'






/* harmony default export */ __webpack_exports__["a"] = ({
  channels: [],
  realtime: null,

  init: function init(doctorId, token) {
    if (window.realtime === undefined) {
      if (window.location.host === 'consultations.ekincare.com') {
        // Production Key
        window.realtime = new __WEBPACK_IMPORTED_MODULE_2_ably__["Realtime"]({ key: token, clientId: doctorId });
      } else {
        // Staging or local
        window.realtime = new __WEBPACK_IMPORTED_MODULE_2_ably__["Realtime"]({ key: token, clientId: doctorId });
      }
    }
    window.realtime.connection.on('connected', this.connected);
    window.realtime.connection.on('disconnected', this.disconnected);
    window.realtime.connection.on('suspended', this.suspended);
    window.realtime.connection.on('failed', this.failed);

    window.realtime.connection.on('closing', this.closing);
    window.realtime.connection.on('closed', this.closed);
    window.realtime.connection.on('connecting', this.connecting);
    window.realtime.connection.on('initialized', this.initialized);
  },
  close: function close() {
    if (window.realtime !== undefined) {
      window.realtime.connection.close();
      delete window.realtime;
    }
    this.channels = [];
  },
  connected: function connected() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('configuration/ablyConnected');
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'connected', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  disconnected: function disconnected() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('configuration/ablyDisconnected');
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'disconnected', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  suspended: function suspended() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('configuration/ablySuspended');
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'suspended', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  failed: function failed() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('configuration/ablyFailed');
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'failed', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  closed: function closed(channelId, payload) {
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'closed', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  closing: function closing(channelId, payload) {
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'closing', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  connecting: function connecting(channelId, payload) {
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'connecting', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  initialized: function initialized(channelId, payload) {
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({ type: 'ably', event: 'initialized', created_at: new Date().toString() });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
  },
  publishMessage: function publishMessage(channelId, payload) {
    var channel = this.channels.find(function (ele) {
      return ele.name === channelId;
    });
    channel.publish('update', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload), function (err) {
      if (err) {
        console.log('Unable to publish message; err = ' + err.message);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('message/sentMsgStatus', { message: payload, status: false, channelId: channelId });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('message/sentMsgStatus', { message: payload, status: true, channelId: channelId });
      }
    });
  },
  receiveMessage: function receiveMessage(channelId, payload) {
    var message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, payload);
    message.channelId = channelId;
    __WEBPACK_IMPORTED_MODULE_4__parser__["a" /* default */].parseMessage(channelId, payload);

    var payloadData = JSON.parse(payload.data);
    __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({
          type: 'message',
          event: 'receive_message',
          channel_name: channelId,
          consultation_request_id: payloadData.consultation_request_id,
          customer_id: payloadData.customer_id,
          intent_name: payloadData.intentName,
          unique_id: payloadData.uniqueId,
          user: payloadData.user,
          created_at: new Date().toString()
        });
        __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
      }
    });
    if (JSON.parse(message.data).intentName === 'file_customer') {
      var _channelId = message.channelId;
      var customerId = message.channelId;
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('consultation/fetchCustomerProfile', { customerId: customerId, channelId: _channelId });
    }
    __WEBPACK_IMPORTED_MODULE_5__api_chat_message__["a" /* default */].storeMessage(message).then(function (response) {
      if (response.status === 200) {
        console.log('stored');
      }
    }).catch(function (e) {
      return console.log(e);
    });
  },


  // updatePresenceEvents (channelId, event, isTyping = false) {
  updatePresenceEvents: function updatePresenceEvents(channelId, event) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (window.realtime) {
      var channel = window.realtime.channels.get(channelId);
      if (event === 'enter') {
        channel.presence.enter('', function (err) {
          if (err) {
            console.log('Error entering presence');
            __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
              if (err === null && data !== null && data !== undefined) {
                data.push({ type: 'error', event: 'enter', channel_name: channelId, error: err, created_at: new Date().toString() });
                __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
              }
            });
          }

          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('consultation/ablyEnabled', { channelId: channelId, status: true });

          __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({ type: 'presence', event: 'enter', channel_name: channelId, created_at: new Date().toString() });
              __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
            }
          });
        });
      } else if (event === 'leave') {
        channel.unsubscribe();
        channel.presence.leave('', function (err) {
          if (err) {
            console.log('Error leaving presence');
            __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
              if (err === null && data !== null && data !== undefined) {
                data.push({ type: 'error', event: 'leave', channel_name: channelId, created_at: new Date().toString() });
                __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
              }
            });
          }
          console.log('doctor left ' + channelId);

          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('consultation/ablyEnabled', { channelId: channelId, status: false });

          __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({ type: 'presence', event: 'leave', channel_name: channelId, created_at: new Date().toString().toString() });
              __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
            }
          });
        });
      } else if (event === 'update') {
        var msg = __WEBPACK_IMPORTED_MODULE_4__parser__["a" /* default */].buildPresenceUpdate(data);
        channel.presence.update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(msg));
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Chat error.Please Refresh' }, { root: true });
    }
  },
  subscribePresenceEvents: function subscribePresenceEvents(channel, event) {
    var that = this;
    channel.presence.subscribe(event, function (member) {
      if (event === 'enter') {
        if (channel !== 'doctor_channel' && member.clientId !== __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.configuration.doctorId) {
          that.updatePatientStatus(channel.name);
        }
      } else if (event === 'leave' && member.clientId !== __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.configuration.doctorId) {
        if (channel !== 'doctor_channel') {
          that.updatePatientStatus(channel.name);
        }
      } else if (event === 'update' && member.clientId !== __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.configuration.doctorId) {
        if (member.data[0] === '{') {
          var data = JSON.parse(member.data);
          if (data.user && data.user.type === 'customer') {
            that.updateMessagesStatus(channel.name, data);
          }
        }
      }
    });
  },
  getConsultation: function getConsultation(channelId) {
    var consult = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.consultation.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    return consult;
  },
  updatePatientStatus: function updatePatientStatus(channelId) {
    if (window.realtime) {
      var consult = this.getConsultation(channelId);
      var channel = window.realtime.channels.get(channelId);
      var ids = [];
      channel.presence.get(function (err, members) {
        if (err) {
          console.log('Error fetching channel members');
          return [];
        }
        for (var i = 0; i < members.length; i++) {
          ids.push(members[i].clientId);
        }
        if (ids.includes(consult.customerId) || ids.includes(consult.guardian_ek_id)) {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('consultation/updateIsOnline', { channelId: channelId, status: true });
          __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({ type: 'patient_presence', event: 'subscribe', online: true, customer_id: consult.customerId, channel_name: channelId, created_at: new Date().toString() });
              __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('consultation/updateIsOnline', { channelId: channelId, status: false });
          __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({ type: 'patient_presence', event: 'subscribe', online: false, customer_id: consult.customerId, channel_name: channelId, created_at: new Date().toString() });
              __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('audits', data);
            }
          });
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Chat error.Please Refresh' }, { root: true });
    }
  },
  updateMessagesStatus: function updateMessagesStatus(channelId, data) {
    if (window.realtime) {
      var consult = this.getConsultation(channelId);
      var channel = window.realtime.channels.get(channelId);
      var ids = [];
      channel.presence.get(function (err, members) {
        if (err) {
          console.log('Error fetching channel members');
          return [];
        }
        for (var i = 0; i < members.length; i++) {
          ids.push(members[i].clientId);
        }
        if (ids.includes(consult.customerId) || ids.includes(consult.guardian_ek_id)) {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('consultation/receiveCustomerTyping', { channelId: channelId, isTyping: data.typing });
          if (data.deliveredMessage !== undefined && data.deliveredMessage !== '') {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('message/receiveCustomerLastDelivered', { channelId: channelId, deliveredMessage: data.deliveredMessage });
          }
          if (data.lastReadMessage !== undefined && data.lastReadMessage !== '') {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('message/receiveCustomerLastRead', { channelId: channelId, lastReadMessage: data.lastReadMessage });
          }
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toaster/setToaster', { status: true, type: 'error', message: 'Chat error.Please Refresh' }, { root: true });
    }
  },
  subscribeToChannel: function subscribeToChannel(channelId) {
    if (window.realtime) {
      var channel = window.realtime.channels.get(channelId);
      var newFunction = this.receiveMessage.bind('', channelId);
      channel.subscribe(newFunction);
      this.updatePresenceEvents(channelId, 'enter');
      this.subscribePresenceEvents(channel, 'enter');
      this.subscribePresenceEvents(channel, 'leave');
      this.subscribePresenceEvents(channel, 'update');
      this.channels.push(channel);
    } else {
      alert('There is some error when connecting to chat service, please refresh and try.');
    }
  },


  // Subscribes to channels
  subscribeToChannels: function subscribeToChannels(customerIds) {
    customerIds.forEach(function (channelId) {
      this.subscribeToChannel(channelId);
    });
  }
});

/***/ }),

/***/ "oMgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ably__ = __webpack_require__("oKrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_parser__ = __webpack_require__("2JCH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_consultation__ = __webpack_require__("57jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_customer_prescription__ = __webpack_require__("b8jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_lab_tests__ = __webpack_require__("y1lv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_alerts__ = __webpack_require__("6zQr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("7+uW");










__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_toast_notification___default.a);
// import _ from 'lodash'

// State
var state = {
  patientMessages: []

  // Getters
};var getters = {
  getMessages: function getMessages(state, getters, rootState) {
    var consult = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });
    if (consult) {
      var obj = state.patientMessages.find(function (ele) {
        return ele.consultationRequestId === consult.consultationRequest.consultationRequestId;
      });
      if (obj) {
        return obj.messages;
      }
    }
    return [];
  },
  getAllPatientsMessages: function getAllPatientsMessages() {
    return state.patientMessages;
  }
};

// Actions
var actions = {
  setUpAllPatientMessages: function setUpAllPatientMessages(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState,
        dispatch = _ref.dispatch;

    commit('preSetUp', rootState.consultation.activeConsults);
    __WEBPACK_IMPORTED_MODULE_2__api_consultation__["a" /* default */].getAllPatientMessages().then(function (response) {
      if (response.status === 200) {
        commit('setUpAllPatientMessages', { allMessages: response.body.all_messages, activeConsults: rootState.consultation.activeConsults });
      }
    });
  },
  setUpMessages: function setUpMessages(_ref2, _ref3) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState,
        dispatch = _ref2.dispatch;
    var channelId = _ref3.channelId,
        customerId = _ref3.customerId,
        isNewPatient = _ref3.isNewPatient;

    var consult = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (consult) {
      var pm = state.patientMessages.find(function (ele) {
        return ele.channelId === consult.channelId;
      });
      if (!pm) {
        commit('preSetUp', [consult]);
      }
      __WEBPACK_IMPORTED_MODULE_2__api_consultation__["a" /* default */].getMessages(consult.consultationRequest.consultationRequestId).then(function (response) {
        if (response.status === 200) {
          var messages = response.body.messages;
          var patientMsgs = messages.filter(function (ele) {
            return ele.user && ele.user.type === 'customer';
          });
          var msgs = messages;
          if (patientMsgs.length > 0) {
            var patinetLastMsg = patientMsgs[patientMsgs.length - 1];
            __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'update', { isRead: true, lastReadMessage: patinetLastMsg.uniqueId, deliveredMessage: patinetLastMsg.uniqueId, consultation_request_id: consult.consultationRequest.consultationRequestId });
            commit('setUpMessages', { messages: msgs, customerId: customerId, channelId: channelId, consultationRequestId: consult.consultationRequest.consultationRequestId, lastReceivedMsg: patinetLastMsg.uniqueId, lastReadMsg: patinetLastMsg.uniqueId });
          } else {
            __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'update', { isRead: true, lastReadMessage: '', deliveredMessage: '', consultation_request_id: consult.consultationRequest.consultationRequestId });
            commit('setUpMessages', { messages: msgs, customerId: customerId, channelId: channelId, consultationRequestId: consult.consultationRequest.consultationRequestId, lastReceivedMsg: '', lastReadMsg: '' });
          }
          if (isNewPatient === true) {
            dispatch('addWelcomeMessage');
          }
        }
      });
    }
  },
  sendUnreadMsgNotification: function sendUnreadMsgNotification(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        rootState = _ref4.rootState,
        getters = _ref4.getters;

    var customer = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });
    if (!customer.isOnline) {
      var doctorMessages = getters.getMessages.filter(function (msg) {
        return msg.user.type === 'doctor';
      });
      var lastMessage = doctorMessages.pop();
      if (lastMessage && lastMessage.status === 'sent') {
        if (doctorMessages.length < 1 || doctorMessages.pop().status === 'read') {
          sessionStorage.setItem('doctor_notification', 0);
        }
        var doctorNotification = sessionStorage.getItem('doctor_notification');
        if (doctorNotification !== '1') {
          __WEBPACK_IMPORTED_MODULE_2__api_consultation__["a" /* default */].doctorReplyToOfflineCustomer(lastMessage.uniqueId, customer.consultationRequest.consultationRequestId).then(function (response) {
            if (response.status === 200) {
              sessionStorage.setItem('doctor_notification', 1);
              // console.log(response)
            } else {}
          }, function (response) {});
        }
      }
    } else {
      var dNotification = sessionStorage.getItem('doctor_notification');

      if (dNotification === '1') {
        sessionStorage.setItem('doctor_notification', 0);
      }
    }
  },
  send: function send(_ref5, _ref6) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        rootState = _ref5.rootState;
    var message = _ref6.message,
        intentName = _ref6.intentName,
        channelId = _ref6.channelId;

    var patient = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (patient) {
      var msg = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildMessage({ 'text': message }, { intentName: intentName, patient: patient, activeCustomerId: rootState.consultation.activeCustomerId });
      commit('add', { message: msg, status: false, consultationRequestId: patient.consultationRequest.consultationRequestId });
      __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].publishMessage(channelId, msg);
    }
  },
  addWelcomeMessage: function addWelcomeMessage(_ref7) {
    var state = _ref7.state,
        commit = _ref7.commit,
        rootState = _ref7.rootState;

    var patient = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });

    var msg = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildWelcomeTextMessage({ patient: patient, activeCustomerId: rootState.consultation.activeCustomerId });
    var consult = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });
    if (consult) {
      commit('add', { message: msg, status: false, consultationRequestId: consult.consultationRequest.consultationRequestId });
      __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].publishMessage(rootState.consultation.activeChannelId, msg);
    }
  },
  receive: function receive(_ref8, _ref9) {
    var state = _ref8.state,
        commit = _ref8.commit,
        rootState = _ref8.rootState,
        dispatch = _ref8.dispatch;
    var channelId = _ref9.channelId,
        message = _ref9.message;

    var consult = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (consult) {
      var consultationRequestId = consult.consultationRequest.consultationRequestId;
      if (message.user && message.user.type === 'customer') {
        commit('add', { message: message, consultationRequestId: consultationRequestId });
        __WEBPACK_IMPORTED_MODULE_5__core_alerts__["a" /* default */].newMessageSound();
        dispatch('updateDeliveredMsg', { channelId: channelId, message: message });
        if (message.intentName === 'file_customer') {
          dispatch('consultation/receivedDocumentUpdate', { channelId: channelId, message: message }, { root: true });
        }
        if (channelId === rootState.consultation.activeChannelId) {
          dispatch('updateReadMsg', { channelId: channelId, message: message });
        }
      }
    }
  },
  resendMessage: function resendMessage(_ref10, message) {
    var state = _ref10.state,
        commit = _ref10.commit,
        rootState = _ref10.rootState;

    commit('addResendMessage', { message: message, status: false, channelId: rootState.consultation.activeChannelId });
  },
  deleteMessage: function deleteMessage(_ref11, message) {
    var state = _ref11.state,
        commit = _ref11.commit,
        rootState = _ref11.rootState;

    commit('deleteMessage', { message: message, channelId: rootState.consultation.activeChannelId });
  },
  sentMsgStatus: function sentMsgStatus(_ref12, _ref13) {
    var state = _ref12.state,
        commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    var message = _ref13.message,
        status = _ref13.status,
        channelId = _ref13.channelId;

    commit('sentMsgStatus', { message: message, status: status, channelId: channelId });
    dispatch('sendUnreadMsgNotification');
    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (consult) {
      var index = state.patientMessages.indexOf(consult);
      var customerMessages = state.patientMessages[index].messages.filter(function (msg) {
        return msg.user.type === 'customer';
      });
      var timer = customerMessages.length > 1 ? 480000 : 180000;
      setTimeout(function () {
        if (state.patientMessages[index]) {
          if (message.uniqueId === state.patientMessages[index].messages.slice(-1)[0].uniqueId) {
            dispatch('consultation/endChat', { status: 'FAILURE', reasons: ['Customer did not respond'], id: channelId }, { root: true });
          }
        }
      }, timer);
    }
  },
  updateDeliveredMsg: function updateDeliveredMsg(_ref14, _ref15) {
    var state = _ref14.state,
        commit = _ref14.commit;
    var channelId = _ref15.channelId,
        message = _ref15.message;

    var patient = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (patient) {
      __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'update', { isDelivered: true, lastReadMessage: patient.lastReadMsg, deliveredMessage: message.uniqueId, consultation_request_id: patient.consultationRequestId });
      commit('updateLastReceivedMsg', { channelId: channelId, id: message.uniqueId });
    }
  },
  updateReadMsg: function updateReadMsg(_ref16, _ref17) {
    var state = _ref16.state,
        commit = _ref16.commit;
    var channelId = _ref17.channelId,
        message = _ref17.message;

    var patient = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    if (patient) {
      __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].updatePresenceEvents(channelId, 'update', { isRead: true, lastReadMessage: message.uniqueId, deliveredMessage: patient.lastReceivedMsg, consultation_request_id: patient.consultationRequestId });
      commit('updateLastReadMsg', { channelId: channelId, id: message.uniqueId });
    }
  },
  receiveCustomerLastDelivered: function receiveCustomerLastDelivered(_ref18, _ref19) {
    var commit = _ref18.commit,
        state = _ref18.state;
    var channelId = _ref19.channelId,
        deliveredMessage = _ref19.deliveredMessage;

    commit('messageDelivered', { channelId: channelId, deliveredMessage: deliveredMessage });
  },
  receiveCustomerLastRead: function receiveCustomerLastRead(_ref20, _ref21) {
    var commit = _ref20.commit,
        state = _ref20.state;
    var channelId = _ref21.channelId,
        lastReadMessage = _ref21.lastReadMessage;

    commit('messageRead', { channelId: channelId, lastReadMessage: lastReadMessage });
  },
  documentUploadProgress: function documentUploadProgress(_ref22, _ref23) {
    var state = _ref22.state,
        commit = _ref22.commit,
        dispatch = _ref22.dispatch,
        rootState = _ref22.rootState;
    var file = _ref23.file,
        channelId = _ref23.channelId;

    file.uniqueId = 'temp';
    commit('addFileUploadMessage', { message: file, status: false, channelId: channelId });
    dispatch('loader/setLoader', { loading: false, componentKey: null }, { root: true });
  },
  uploadDocument: function uploadDocument(_ref24, _ref25) {
    var state = _ref24.state,
        commit = _ref24.commit,
        rootState = _ref24.rootState,
        dispatch = _ref24.dispatch;
    var fileList = _ref25.fileList;

    var patient = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });
    var consultationId = rootState.consultation.consultationId;
    var activeCustomerId = rootState.consultation.activeCustomerId;

    var formData = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildFileData(fileList, { patient: patient, consultationId: consultationId, activeCustomerId: activeCustomerId });
    var file = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildTempFileData(fileList[0]);
    // let customerId = rootState.consultation.activeCustomerId
    var channelId = rootState.consultation.activeChannelId;
    commit('addFileUploadMessage', { message: file, status: false, channelId: channelId });
    __WEBPACK_IMPORTED_MODULE_2__api_consultation__["a" /* default */].uploadFile(formData, file, channelId).then(function (response) {
      if (response.status === 200) {
        var msg = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildDocumentMessage({
          url: response.body.file_url[0],
          id: response.body.id,
          fileName: fileList[0].name,
          type: 'document',
          intentName: 'file_attachment'
        });
        if (__WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].publishMessage(channelId, msg)) {
          msg.progress = 100;
          msg.state = 'uploaded';
          commit('addFileUploadMessage', { message: msg, status: true, channelId: channelId });
          dispatch('consultation/receivedDocumentUpdate', { channelId: channelId, message: msg }, { root: true });
        } else {
          msg.progress = 100;
          msg.state = 'uploaded';
          commit('addFileUploadMessage', { message: msg, status: false, channelId: channelId });
          dispatch('consultation/receivedDocumentUpdate', { channelId: channelId, message: msg }, { root: true });
        }
      }
    }).catch(function (e) {
      file.state = 'reload';
      commit('addFileUploadMessage', { message: file, status: true, channelId: channelId });
    });
  },
  sendPrescription: function sendPrescription(_ref26, _ref27) {
    var commit = _ref26.commit,
        state = _ref26.state,
        dispatch = _ref26.dispatch,
        rootState = _ref26.rootState;
    var data = _ref27.data;

    var date = Date.now();
    var file = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildTempFileData({ name: 'rx_' + date + '.pdf' });
    file.prescription = data.prescription;
    // let customerId = rootState.consultation.activeCustomerId
    var activeChannelId = rootState.consultation.activeChannelId;
    var activeCustomerId = rootState.consultation.activeCustomerId;
    var patient = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });
    commit('addFileUploadMessage', { message: file, status: true, channelId: activeChannelId });
    __WEBPACK_IMPORTED_MODULE_3__api_customer_prescription__["a" /* default */].createPrescription(file, 'send', activeChannelId).then(function (response) {
      if (response.status === 200) {
        var msg = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildDocumentMessage({
          url: response.body.prescription_url,
          id: response.body.id,
          fileName: response.body.prescription_name,
          type: 'prescription',
          intentName: 'file_prescription',
          medications: response.body.medications,
          activeChannelId: activeChannelId,
          activeCustomerId: activeCustomerId,
          patient: patient,
          activeConsultationId: patient.consultation.consultationId,
          activeConsultationRequestId: patient.consultationRequest.consultationRequestId
        });
        if (__WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].publishMessage(activeChannelId, msg)) {
          msg.progress = 100;
          msg.state = 'uploaded';
          commit('addFileUploadMessage', { message: msg, status: true, channelId: activeChannelId });
        } else {
          msg.progress = 100;
          msg.state = 'uploaded';
          commit('addFileUploadMessage', { message: msg, status: false, channelId: activeChannelId });
        }
      }
    }).catch(function (e) {
      file.state = 'reload';
      commit('addFileUploadMessage', { message: file, status: true, channelId: activeChannelId });
    });
  },
  sendRecommendedTests: function sendRecommendedTests(_ref28, _ref29) {
    var commit = _ref28.commit,
        state = _ref28.state,
        dispatch = _ref28.dispatch,
        rootState = _ref28.rootState;
    var data = _ref29.data,
        consultationType = _ref29.consultationType;

    var patient = rootState.consultation.activeConsults.find(function (ele) {
      return ele.channelId === rootState.consultation.activeChannelId;
    });

    var consult = null;
    var msg = null;

    if (consultationType === 'Chat') {
      msg = __WEBPACK_IMPORTED_MODULE_1__core_parser__["a" /* default */].buildMessage({ 'recommended_tests': data.recommended_tests }, { intentName: 'recommended_tests', patient: patient, activeCustomerId: rootState.consultation.activeCustomerId });
      consult = rootState.consultation.activeConsults.find(function (ele) {
        return ele.channelId === rootState.consultation.activeChannelId;
      });
    } else if (consultationType === 'OfflineConsults') {
      consult = rootState.offlineConsultation.activeOfflineConsults.find(function (ele) {
        return ele.consultation.consultationId === data.consultation_id;
      });
    }
    if (consult) {
      __WEBPACK_IMPORTED_MODULE_4__api_lab_tests__["a" /* default */].storeRecommendedTests({ consultation_id: data.consultation_id || consult.consultation.consultationId, package_ids: data.package_ids }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].$toast.open({
          message: 'Lab tests successfully sent!',
          type: 'success',
          position: 'bottom-right',
          queue: false
        });
        if (consultationType === 'Chat') {
          commit('add', { message: msg, status: false, consultationRequestId: consult.consultationRequest ? consult.consultationRequest.consultationRequestId : null });
          dispatch('consultation/updateRecommendedTests', response.body.recommended_tests, { root: true });
          __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].publishMessage(rootState.consultation.activeChannelId, msg);
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  removeChat: function removeChat(_ref30, _ref31) {
    var commit = _ref30.commit;
    var channelId = _ref31.channelId;

    commit('removeChat', { channelId: channelId });
  }
};

// Mutations
var mutations = {
  preSetUp: function preSetUp(state, activeConsults) {
    for (var i = 0; i < activeConsults.length; i++) {
      var chiefComp = activeConsults[i].consultationRequest.chiefComplaint;
      if (!chiefComp) {
        chiefComp = 'Patient did not answer this.';
      }
      var timeInMilliSeconds = new Date(activeConsults[i].consultationRequest.date).getTime();
      if (isNaN(timeInMilliSeconds)) {
        var tempDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()).format('DD MMM YYYY');
        var tempDateTime = tempDate + ' ' + activeConsults[i].consultationRequest.date;
        timeInMilliSeconds = new Date(tempDateTime).getTime();
      }
      var topMsgs = [{ payload: { text: 'Please let us know your health issue' }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'doctor' } }, { payload: { text: chiefComp }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'customer' } }];
      state.patientMessages.push({
        messages: topMsgs,
        customerId: activeConsults[i].customerId,
        channelId: activeConsults[i].channelId,
        consultationRequestId: activeConsults[i].consultationRequest.consultationRequestId,
        lastReceivedMsg: '',
        lastReadMsg: '',
        newMessages: 0
      });
    }
  },
  setUpAllPatientMessages: function setUpAllPatientMessages(state, _ref32) {
    var allMessages = _ref32.allMessages,
        activeConsults = _ref32.activeConsults;

    var _loop = function _loop(i) {
      var obj = allMessages.find(function (ele) {
        return ele.consultation_request_id === activeConsults[i].consultationRequest.consultationRequestId;
      });
      if (obj) {
        var objAlready = state.patientMessages.find(function (ele) {
          return ele.channelId === activeConsults[i].channelId;
        });
        if (objAlready) {
          var _loop2 = function _loop2(_i) {
            var mi = objAlready.messages.findIndex(function (ele) {
              return parseInt(ele.uniqueId) === parseInt(obj.messages[_i].uniqueId);
            });
            if (mi < 0) {
              objAlready.messages.push(obj.messages[_i]);
            }
          };

          for (var _i = 0; _i < obj.messages.length; _i++) {
            _loop2(_i);
          }
          state.patientMessages[i].messages = objAlready.messages;
          state.patientMessages[i].lastReceivedMsg = objAlready.lastReceivedMsg;
          state.patientMessages[i].lastReadMsg = objAlready.lastReadMsg;
        } else {
          state.patientMessages.push({
            messages: obj.messages,
            customerId: activeConsults[i].customerId,
            channelId: activeConsults[i].channelId,
            consultationRequestId: activeConsults[i].consultationRequest.consultationRequestId,
            lastReceivedMsg: '',
            lastReadMsg: '',
            newMessages: 0
          });
        }
      }
    };

    for (var i = 0; i < activeConsults.length; i++) {
      _loop(i);
    }
  },
  setUpMessages: function setUpMessages(state, _ref33) {
    var messages = _ref33.messages,
        customerId = _ref33.customerId,
        channelId = _ref33.channelId,
        consultationRequestId = _ref33.consultationRequestId,
        lastReceivedMsg = _ref33.lastReceivedMsg,
        lastReadMsg = _ref33.lastReadMsg;

    var index = state.patientMessages.findIndex(function (ele) {
      return ele.channelId === channelId;
    });
    if (index > -1) {
      if (state.patientMessages[index].messages.length > 2) {
        (function () {
          var topMessages = state.patientMessages[index].messages.slice(0, 2);
          messages = topMessages.concat(messages);
          var pm = state.patientMessages[index].messages.filter(function (ele) {
            return ele.user && ele.user.type === 'doctor';
          });

          var _loop3 = function _loop3(i) {
            var mi = messages.findIndex(function (ele) {
              return parseInt(ele.uniqueId) === parseInt(pm[i].uniqueId);
            });
            if (mi < 0) {
              messages.push(pm[i]);
            }
          };

          for (var i = 2; i < pm.length; i++) {
            _loop3(i);
          }
        })();
      } else {
        messages = state.patientMessages[index].messages.concat(messages);
      }
      state.patientMessages[index].messages = messages;
      state.patientMessages[index].lastReceivedMsg = lastReceivedMsg;
      state.patientMessages[index].lastReadMsg = lastReadMsg;
      state.patientMessages[index].newMessages = 0;
    } else {
      state.patientMessages.push({ messages: messages, customerId: customerId, channelId: channelId, consultationRequestId: consultationRequestId, lastReceivedMsg: lastReceivedMsg, lastReadMsg: lastReadMsg, newMessages: 0 });
    }
  },
  add: function add(state, _ref34) {
    var message = _ref34.message,
        status = _ref34.status,
        consultationRequestId = _ref34.consultationRequestId;

    var obj = state.patientMessages.find(function (ele) {
      return ele.consultationRequestId === consultationRequestId;
    });
    var index = state.patientMessages.indexOf(obj);
    if (obj) {
      if (status === true) {
        // doctor side messages
        message.status = 'sent';
      } else if (status === false) {
        message.status = null;
      }
      var messages = obj.messages;
      var m = messages.find(function (ele) {
        return ele.uniqueId === message.uniqueId;
      });
      var messageIndex = messages.indexOf(m);
      if (messageIndex === -1) {
        state.patientMessages[index].messages.push(message);
      }
    }
  },
  addFileUploadMessage: function addFileUploadMessage(state, _ref35) {
    var channelId = _ref35.channelId,
        message = _ref35.message,
        status = _ref35.status;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      message.status = 'sent';
      var messages = state.patientMessages[index].messages;
      var m = messages.find(function (ele) {
        return ele.uniqueId === message.uniqueId;
      });
      var messageIndex = messages.indexOf(m);
      if (messageIndex === -1) {
        if (message.uniqueId) {
          state.patientMessages[index].messages.splice(messages.length - 1, 1, message);
        } else {
          state.patientMessages[index].messages.push(message);
        }
      } else {
        state.patientMessages[index].messages.splice(messages.length - 1, 1, message);
      }
    }
  },
  addResendMessage: function addResendMessage(state, _ref36) {
    var channelId = _ref36.channelId,
        message = _ref36.message,
        status = _ref36.status;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      var messages = state.patientMessages[index].messages;
      var m = messages.find(function (ele) {
        return ele.uniqueId === message.uniqueId;
      });
      var messageIndex = messages.indexOf(m);
      if (messageIndex > -1) {
        state.patientMessages[index].messages.splice(messageIndex, 1);
      }
      message.uniqueId = new Date().getTime();
      delete message.status;
      __WEBPACK_IMPORTED_MODULE_0__core_ably__["a" /* default */].publishMessage(channelId, message);
      if (status === true) {
        message.status = 'sent';
      } else if (status === false) {
        message.status = null;
      }
      state.patientMessages[index].messages.push(message);
    }
  },
  deleteMessage: function deleteMessage(state, _ref37) {
    var channelId = _ref37.channelId,
        message = _ref37.message;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      var messages = state.patientMessages[index].messages;
      var m = messages.find(function (ele) {
        return ele.uniqueId === message.uniqueId;
      });
      var messageIndex = messages.indexOf(m);
      if (messageIndex > -1) {
        state.patientMessages[index].messages.splice(messageIndex, 1);
      }
    }
  },
  sentMsgStatus: function sentMsgStatus(state, _ref38) {
    var message = _ref38.message,
        status = _ref38.status,
        channelId = _ref38.channelId;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      var messages = state.patientMessages[index].messages;
      var m = messages.find(function (ele) {
        return ele.uniqueId === message.uniqueId;
      });
      var messageIndex = messages.indexOf(m);
      if (messageIndex > -1) {
        if (status === true && state.patientMessages[index].messages[messageIndex].status === null) {
          state.patientMessages[index].messages[messageIndex].status = 'sent';
        } else if (status === false) {
          state.patientMessages[index].messages[messageIndex].status = null;
        }
      }
    }
  },
  updateLastReceivedMsg: function updateLastReceivedMsg(state, _ref39) {
    var channelId = _ref39.channelId,
        id = _ref39.id;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      state.patientMessages[index].lastReceivedMsg = id;
      state.patientMessages[index].newMessages += 1;
    }
  },
  updateLastReadMsg: function updateLastReadMsg(state, _ref40) {
    var channelId = _ref40.channelId,
        id = _ref40.id;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      state.patientMessages[index].lastReadMsg = id;
      state.patientMessages[index].newMessages = 0;
    }
  },
  messageDelivered: function messageDelivered(state, _ref41) {
    var channelId = _ref41.channelId,
        deliveredMessage = _ref41.deliveredMessage;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      var msgs = state.patientMessages[index].messages;
      for (var i = 0; i < msgs.length; i++) {
        if (msgs[i].user && msgs[i].user.type === 'doctor' && parseInt(msgs[i].uniqueId) <= parseInt(deliveredMessage) && (msgs[i].status === null || msgs[i].status === 'sent')) {
          state.patientMessages[index].messages[i].status = 'delivered';
        }
      }
    }
  },
  messageRead: function messageRead(state, _ref42) {
    var channelId = _ref42.channelId,
        lastReadMessage = _ref42.lastReadMessage;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      var msgs = state.patientMessages[index].messages;
      for (var i = 0; i < msgs.length; i++) {
        if (msgs[i].user && msgs[i].user.type === 'doctor' && parseInt(msgs[i].uniqueId) <= parseInt(lastReadMessage) && (msgs[i].status === null || msgs[i].status === 'sent' || msgs[i].status === 'delivered')) {
          state.patientMessages[index].messages[i].status = 'read';
        }
      }
    }
  },
  removeChat: function removeChat(state, _ref43) {
    var channelId = _ref43.channelId;

    var consult = state.patientMessages.find(function (ele) {
      return ele.channelId === channelId;
    });
    var index = state.patientMessages.indexOf(consult);
    if (index > -1) {
      state.patientMessages.splice(index, 1);
    }
  },
  reset: function reset(state) {
    state = {};
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ouuo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ow8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('admin-left-pane'),_vm._v(" "),(_vm.isActiveChat)?_c('chat-pane',{on:{"tabChange":_vm.tabChange}}):_vm._e(),_vm._v(" "),(_vm.isActiveChat)?_c('right-pane',{attrs:{"selectedTab":_vm.selectedRightTab,"chatType":"online","showToggleButton":_vm.showToggleButton,"showRightPane":_vm.showRightPane},on:{"tabChange":_vm.tabChange,"toggleRightPane":_vm.toggleRightPane}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oz7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeReloadOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"380px","height":"300px","left":"calc((108vw - 500px)/2)","top":"200px","z-index":"99"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2"},[_c('img',{staticClass:"flex self-center mt-8",staticStyle:{"width":"90px"},attrs:{"src":__webpack_require__("ZYU2")}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs mx-8 text-center",staticStyle:{"position":"absolute","bottom":"74px","left":"10px","text-align":"center"}},[_vm._v("\n          You have pending queries from your patients. Please complete the conversations to close them.\n        ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-5 justify-start",staticStyle:{"position":"absolute","bottom":"0px","left":"31%","margin-left":"38px"}},[_c('div',{staticClass:"flex flex-col font-semibold bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeReloadOverlay()}}},[_vm._v("Okay")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row mb-2 justify-between items-center",staticStyle:{"position":"absolute","bottom":"94px","left":"31%"}},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2",staticStyle:{"color":"#70411b"}},[_vm._v("Pending Queries")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p0pl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p4+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthCoachProgram_vue__ = __webpack_require__("ggx2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d30a95c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthCoachProgram_vue__ = __webpack_require__("srhj");
function injectStyle (ssrContext) {
  __webpack_require__("eIUC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d30a95c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthCoachProgram_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d30a95c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthCoachProgram_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pDRg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pRXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__["a" /* default */]
  },
  data: function data() {
    return {
      search: '',
      viewProfile: false,
      showSaveReminder: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activePastConsultId: function activePastConsultId(state) {
      return state.pastOfflineConsultation.activePastConsultId;
    },
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    consultations: 'pastOfflineConsultation/getPastConsults',
    showLoadMore: 'pastOfflineConsultation/showLoadMore'
  })),
  watch: {
    consultations: function consultations(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.consultations = newVal;
      }
    }
  },
  methods: {
    selectFromPastList: function selectFromPastList(id) {
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      this.$store.dispatch('pastOfflineConsultation/switchTo', id);
    },
    consultStatus: function consultStatus(cp) {
      if (cp.consultation.summary_status === 'done' || cp.consultation.summary_status === 'not_needed') {
        return true;
      } else {
        return false;
      }
    },
    viewCustomerProfile: function viewCustomerProfile(e) {
      e.stopPropagation();
      this.viewProfile = !this.viewProfile;
    },
    fetchMoreConsults: function fetchMoreConsults() {
      this.$store.dispatch('pastOfflineConsultation/fetchMoreConsults');
    },
    closeModal: function closeModal(params) {
      this.showSaveReminder = false;
    }
  }
});

/***/ }),

/***/ "pU0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Customer_CustomerProfile__ = __webpack_require__("QE93");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomerProfile: __WEBPACK_IMPORTED_MODULE_2__components_Customer_CustomerProfile__["a" /* default */]
  },
  data: function data() {
    return {
      endChatClicked: false,
      incompleteChatClicked: false,
      viewProfile: false,
      reasons: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activeOfflineConsults: function activeOfflineConsults(state) {
      return state.offlineConsultation.activeOfflineConsults;
    },
    activeCustomer: function activeCustomer(state) {
      return state.offlineConsultation.activeCustomerId;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({})),
  methods: {
    selectFromConnectedList: function selectFromConnectedList(customerId) {
      this.$store.dispatch('offlineConsultation/switchTo', customerId);
    },
    endChat: function endChat(status) {
      this.$store.dispatch('offlineConsultation/endConsultation', { status: status, reasons: this.reasons });
      this.closeEndChatOverlay();
    },
    endConsultation: function endConsultation(e, item) {
      this[item] = true;
      e.stopPropagation();
    },
    closeEndChatOverlay: function closeEndChatOverlay() {
      this.endChatClicked = false;
      this.incompleteChatClicked = false;
    },
    viewCustomerProfile: function viewCustomerProfile(e) {
      e.stopPropagation();
      this.viewProfile = !this.viewProfile;
    },
    reasonInput: function reasonInput(e) {
      this.reasons = document.getElementById('editor').innerText;
    }
  }
});

/***/ }),

/***/ "pax8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc_consultation.6f91a69.svg";

/***/ }),

/***/ "pev1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetUp_vue__ = __webpack_require__("OjCJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af3b1f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetUp_vue__ = __webpack_require__("tDmF");
function injectStyle (ssrContext) {
  __webpack_require__("u7ah")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4af3b1f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af3b1f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__ = __webpack_require__("qrBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Customer_AddDrug__ = __webpack_require__("ffOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__["a" /* default */],
    AddDrug: __WEBPACK_IMPORTED_MODULE_2__components_Customer_AddDrug__["a" /* default */]
  },
  props: ['chatType'],
  data: function data() {
    return {
      isEditing: false,
      isAdding: false,
      recommendations: null,
      drugs: [],
      showDeleteWarning: false,
      selectedMed: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    activeSection: 'configuration/getActiveSection'
  }), {
    medications: function medications() {
      if (this.customer && this.customer.details && this.customer.details.medications) {
        return this.customer.details.medications;
      }
      return [];
    }
  }),
  watch: {
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isAdding = false;
      }
    }
  },
  methods: {
    closeEndChatOverlay: function closeEndChatOverlay() {
      this.showDeleteWarning = false;
    },
    editDrugs: function editDrugs() {
      this.isEditing = true;
    },
    addDrug: function addDrug() {
      this.isAdding = true;
    },
    saveClicked: function saveClicked() {
      this.isEditing = false;
      this.isAdding = false;
    },
    cancelClicked: function cancelClicked() {
      this.isEditing = false;
      this.isAdding = false;
    },
    updateDrugs: function updateDrugs(data) {
      if (data) {
        if (this.chatType === 'offline') {
          if (this.isAdding) {
            this.drugs.push(data);
          }
          if (this.activeSection === 'consults') {
            this.$store.dispatch('pastOfflineConsultation/updateCurrentMedication', this.drugs);
          } else if (this.activeSection === 'connected') {
            this.$store.dispatch('offlineConsultation/updateCurrentMedication', this.drugs);
          }
        } else if (this.chatType === 'online') {
          if (this.isAdding) {
            this.drugs.push(data);
          }
          if (this.activeSection === 'consults') {
            this.$store.dispatch('pastConsultation/updateCurrentMedication', this.drugs);
          } else if (this.activeSection === 'connected') {
            this.$store.dispatch('consultation/updateCurrentMedication', this.drugs);
          }
        }
      }
      this.isEditing = false;
      this.isAdding = false;
    },
    deleteDrug: function deleteDrug(med, index) {
      this.showDeleteWarning = true;
      this.selectedMed = med;
    },
    deleteHandler: function deleteHandler() {
      if (this.chatType === 'offline') {
        this.$store.dispatch('offlineConsultation/updateCurrentMedication', [this.selectedMed]);
      } else if (this.chatType === 'online') {
        this.$store.dispatch('consultation/updateCurrentMedication', [this.selectedMed]);
      }
      this.showDeleteWarning = false;
      this.selectedMed = {};
    }
  }
});

/***/ }),

/***/ "plc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveConsultations_vue__ = __webpack_require__("ssvh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08236e8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveConsultations_vue__ = __webpack_require__("5Whe");
function injectStyle (ssrContext) {
  __webpack_require__("HAqs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveConsultations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08236e8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveConsultations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qOaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ['notification'],
  data: function data() {
    return {
      text: 'Hi ' + this.notification.details.customer_name + ', I noticed that you consulted with ' + this.notification.details.doctor_name + ' on ' + this.notification.details.date + '. Is your health query answered?'
    };
  },

  computed: {},
  methods: {
    sendEnquiry: function sendEnquiry() {
      this.$store.dispatch('notification/sendEnquiryToPatient', { id: this.notification.id, message: this.text });
      this.$emit('closePopup');
    },
    closePopup: function closePopup() {
      this.$emit('closePopup');
    }
  }
});

/***/ }),

/***/ "qazf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qrBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__ = __webpack_require__("HMsB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f911c98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__ = __webpack_require__("nxCR");
function injectStyle (ssrContext) {
  __webpack_require__("g8Eo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f911c98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f911c98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qrkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__ = __webpack_require__("eNOE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9d7a2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__ = __webpack_require__("3X9N");
function injectStyle (ssrContext) {
  __webpack_require__("ZX/n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9d7a2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r0/D":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MDAgNTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzY2NjY2Njt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTM2NC41LDM4LjdjNC45LDQuOSw3LjMsMTEuMyw3LjMsMTcuN2MwLDYuNC0yLjQsMTIuOC03LjMsMTcuN0wxODksMjUwLjJsMTc2LDE3NS40CgkJYzQuOSw0LjksNy40LDExLjMsNy40LDE3LjdjMCw2LjQtMi40LDEyLjgtNy4zLDE3LjdjLTkuOCw5LjgtMjUuNiw5LjgtMzUuNCwwLjFMMTM2LDI2OGMtOS44LTkuNy05LjgtMjUuNi0wLjEtMzUuNEwzMjkuMiwzOC43CgkJQzMzOC45LDI5LDM1NC43LDI4LjksMzY0LjUsMzguN3oiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "rId7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA79JREFUeAHtmzmO1EAUht0sYoeEiIQTcAeEhAQ5REjAAQhYxCYWEXEKkEbDegR2hp2AgICQlAQSEAgQ2+OvHtdMD223u90u82b6K6nG7iqX69X3udy2x51lJAhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEliAB25dl9l7ZlL8rX1NevQQHuhiGZIdzEUFGb76FlNb92ZF/JPQKCeu3kdKaFDtaISPKuaPt1rQW1mR2ZMeGlBGl3EVKsiPFjo8oI0q5h5TGpdiJmjKilPtqv7bxsCZzh3ZyTBlRygOkjH0E2amGZEQpD5FSW4qdrpDxo6S+rDxKmVG7dbXDmsyGdqYEdoT6UvUXSraZUvnNkrrY/pHqkTLcwWVnK2C+UP1G5bKbw0uqW658QzkKKFoGKeuHi2lit7JzFRCfq14yQhokpFsfpFyv2N9j1SOly7Pvj52vgBdkbJhvViVkTkp44Fg0Q2LZE6TMU83X7FAFtGcLZXRhDzhl9XbQPX1drdi/vnNIOYFww2ZfBwB72i8jNB1mhkTIXSlXBvQRZsuWuPX/XC77n53nfW/VsuwhoGRku7Ks83m8ODu/1f6AsqSUJhdXXR6EvBWiDwWYdG7PdkvGl4K6GkWdP2p0UHm6oPErlYU4SLMEbKdOGa/zU8pPLS8rVxyxo5yyejmbDsLuPUw8Tc7oc5ilpH4C4Spq2H/B1hUSe7UV6mtT/ORlqaA8pXG/K0YZS+eXtv40Sos2tvXwHdLGOBdNHwhxpgohCHFGwFk4zBCEOCPgLBxmCEKcEXAWDjMEIc4IOAuHGYIQZwSchcMMQYgzAs7CYYYgxBkBZ+EwQxDijICzcJghCHFGwFk4zBCEOCPgLJxErwHZdo1zfz7Wab19OJOvN7n4WLKzsvKSzUcpbmVcowQ0zLa2Ry+g6bXNuZ8AhHWVNZ3C24b2racfy9d3NN3T7P7aGlfj0dubAkgqS5Fsr/rSjOjKD78t1M+nU6U2x9XoGExvms/NjnjUqixVslXqb5tyz495UvTVzrg6zYceZBSlToK+ivpJVdbOuLjsTeWv5n4RUhNcqmYISUW25n4RUhNcqmYISUW25n4T3akXRWObi0opW0ggwaVo2eXhwo6XzqdmL+c5ZTk7MhAyAULeORtjynAaH2uKGTKVkoCzfS+GsdpKPei7qKyjp+8hY3zYuNiXYWxhjBorCQIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIACBNgj8BfXwZnrZ2FB5AAAAAElFTkSuQmCC"

/***/ }),

/***/ "rmBI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwcHgiICBoZWlnaHQ9IjIwMHB4IiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiIGNsYXNzPSJsZHMtYmFsbDIiIHN0eWxlPSJiYWNrZ3JvdW5kOiBub25lOyI+PGcgbmctYXR0ci10cmFuc2Zvcm09InRyYW5zbGF0ZSgwLHt7Y29uZmlnLmR5fX0pIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLC0xMCkiPjxjaXJjbGUgY3g9IjUwIiBuZy1hdHRyLWN5PSJ7e2NvbmZpZy5jeX19IiByPSI5LjE2MDciIG5nLWF0dHItZmlsbD0ie3tjb25maWcuYzF9fSIgY3k9IjM4IiBmaWxsPSIjMjE2OGYzIiB0cmFuc2Zvcm09InJvdGF0ZSg4My45NTM0IDUwIDUwKSI+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGNhbGNNb2RlPSJsaW5lYXIiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiIGtleVRpbWVzPSIwOzEiIGR1cj0iMS41cyIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlVHJhbnNmb3JtPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGNhbGNNb2RlPSJzcGxpbmUiIHZhbHVlcz0iMDsyMDswIiBrZXlUaW1lcz0iMDswLjU7MSIgZHVyPSIxLjUiIGtleVNwbGluZXM9IjAuMiAwIDAuOCAxOzAuMiAwIDAuOCAxIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGU+PC9jaXJjbGU+PGNpcmNsZSBjeD0iNTAiIG5nLWF0dHItY3k9Int7Y29uZmlnLmN5fX0iIHI9IjEwLjgzOTMiIG5nLWF0dHItZmlsbD0ie3tjb25maWcuYzJ9fSIgY3k9IjM4IiBmaWxsPSIjMTZjNzY5IiB0cmFuc2Zvcm09InJvdGF0ZSgyNjMuOTUzIDUwIDUwKSI+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGNhbGNNb2RlPSJsaW5lYXIiIHZhbHVlcz0iMTgwIDUwIDUwOzU0MCA1MCA1MCIga2V5VGltZXM9IjA7MSIgZHVyPSIxLjVzIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGVUcmFuc2Zvcm0+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgY2FsY01vZGU9InNwbGluZSIgdmFsdWVzPSIyMDswOzIwIiBrZXlUaW1lcz0iMDswLjU7MSIgZHVyPSIxLjUiIGtleVNwbGluZXM9IjAuMiAwIDAuOCAxOzAuMiAwIDAuOCAxIiBiZWdpbj0iMHMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGU+PC9jaXJjbGU+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "rqYd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest w-64"},[_c('div',{staticClass:"flex relative flex-col h-12 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"flex flex-row text-xs pt-3 items-center mt-auto"},[_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'connected' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('connected')}}},[_vm._v("Connected")]),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'requested' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('requested')}}},[_vm._v("Request")]),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'consults' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('consults')}}},[_vm._v("Completed")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest mt-auto"},[_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'connected' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'requested' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'consults' ? 'bg-blue' : '']})]),_vm._v(" "),(_vm.activeConsults.length>0)?_c('div',{staticClass:"absolute text-xs bg-green text-white flex flex-row justify-center items-center",staticStyle:{"top":"0rem","left":"1.5rem","width":"2rem","height":"1rem","border-bottom-left-radius":"50%","border-bottom-right-radius":"50%"}},[_vm._v(" \n      "+_vm._s(_vm.activeConsults.length)+" \n    ")]):_vm._e(),_vm._v(" "),(_vm.requests.length>0)?_c('div',{staticClass:"absolute text-xs bg-red text-white flex flex-row justify-center items-center",staticStyle:{"top":"0rem","left":"7rem","width":"2rem","height":"1rem","border-bottom-left-radius":"50%","border-bottom-right-radius":"50%"}},[_vm._v("   \n      "+_vm._s(_vm.requests.length)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.pastConsults.length>0)?_c('div',{staticClass:"absolute text-xs bg-grey-lighter text-white flex flex-row justify-center items-center",staticStyle:{"top":"0rem","left":"12.5rem","width":"2rem","height":"1rem","border-bottom-left-radius":"50%","border-bottom-right-radius":"50%"}},[_vm._v("\n      "+_vm._s(_vm.totalPastConsults)+"\n    ")]):_vm._e()]),_vm._v(" "),(_vm.activeSection === 'connected')?_c('div',[(_vm.activeConsults.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No Active Consultations")])]):_c('active-consultations')],1):_vm._e(),_vm._v(" "),(_vm.activeSection === 'requested')?_c('div',{staticClass:"relative"},[_c('div',{staticClass:"flex h-12 text-blue text-sm flex-col flex-no-shrink flex-no-grow pt-4 items-center",on:{"click":function($event){return _vm.showLoad()}}},[_vm._m(0)]),_vm._v(" "),(_vm.isShowLoad)?_c('active-doctors-card',{on:{"closePopup":_vm.closePopup}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.activeSection === 'requested')?_c('div',{staticClass:"relative overflow-y-auto"},[_c('div',{staticClass:"flex flex-row bg-grey-lightest",staticStyle:{"height":".10rem"}}),_vm._v(" "),(_vm.requests.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No Patient Request Pending")])]):_vm._e(),_vm._v(" "),(_vm.requests.length > 0)?_c('incoming-requests'):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.activeSection === 'consults')?_c('div',{staticClass:"flex flex-col overflow-y-auto"},[(_vm.pastConsults.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No past consultations")])]):_c('past-consultations')],1):_vm._e(),_vm._v(" "),(_vm.showSaveReminder)?_c('UnsavedChangesModal',{on:{"close":_vm.closeModal}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center cursor-pointer"},[_c('div',{staticClass:"font-semibold"},[_vm._v("Active Consultations of Doctors")]),_vm._v(" "),_c('img',{staticClass:"w-5 h-5 flex flex-col",attrs:{"src":__webpack_require__("Cnwp")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s4wO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row bg-white flex-no-shrink flex-no-grow overflow-y-hidden",style:(_vm.chatType === 'online' ? 'height: calc(100vh - 3rem);' : 'width: calc(100% - 16rem); height: calc(100vh - 3rem);')},[[_c('div',{staticClass:"flex flex-col bg-white w-12 flex-no-show flex-no-shrink border-solid border-r border-grey-lightest"},[(_vm.showToggleButton)?_c('div',{staticClass:"w-12 h-12 border-solid border-b border-grey-lightest bg-grey-darker flex flex-row justify-center flex-no-shrink",on:{"click":_vm.togglePane}},[(_vm.showRightPane)?_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"title":"Hide Details","src":__webpack_require__("9CTg")}}):_vm._e(),_vm._v(" "),(!_vm.showRightPane)?_c('img',{staticClass:"h-6 w-6 self-center",attrs:{"title":"Show Details","src":__webpack_require__("ZTRo")}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('tab-menu',{attrs:{"selectedTab":_vm.selectedTab},on:{"tabChange":_vm.tabChange}})],1),_vm._v(" "),(_vm.showRightPane)?_c('div',{staticClass:"flex flex-col bg-grey-extralight flex-no-show",class:_vm.chatType == 'online' ? 'flex-no-shrink' : 'w-full',style:(_vm.chatType === 'online' ? 'width: calc(674px - 12rem); padding-bottom: 50px;' : 'padding-bottom: 50px;')},[_c(_vm.selectedTab,_vm._b({tag:"component"},'component',_vm.currentProps,false))],1):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "slWF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "srhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-row px-4 justify-between h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center text-sm font-semibold text-grey-darkest"},[_vm._v("Health Coach")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTests),expression:"showTests"}],staticClass:"w-3 cursor-pointer",attrs:{"src":__webpack_require__("f71c")},on:{"click":function($event){_vm.showTests = false}}})]),_vm._v(" "),(!_vm.showTests)?_c('div',[_c('div',{staticClass:"bg-white flex flex-col p-4 text-sm text-grey-darkest font-semibold"},[_c('div',{staticClass:"flex flex-row items-center justify-between"},[_c('p',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.timelineAndProgress.program_name))]),_vm._v(" "),_c('p',{staticClass:"px-3 py-1 bg-yellow-lighter rounded-full capitalize"},[_vm._v(_vm._s(_vm.programDetails.currentWeek))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-xs"},[_vm._v(_vm._s(("Duration: " + (_vm.timelineAndProgress.program_duration))))])])]),_vm._v(" "),_c('div',{class:_vm.selectWeek ? 'overflow-hidden' : 'overflow-y-scroll',staticStyle:{"height":"calc(100vh - 8rem)"}},[_c('div',{staticClass:"p-4 mt-4 bg-white text-sm"},[_c('div',{staticClass:"flex flex-row items-center justify-between font-semibold border-b border-dashed pb-2"},[_c('p',{staticClass:"text-grey-darkest font-semibold"},[_vm._v("Goals")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editGoal.edit),expression:"!editGoal.edit"}],staticClass:"text-blue cursor-pointer",on:{"click":function($event){_vm.editGoal.edit ? '' : _vm.editGoal.edit = true}}},[_vm._v(" Edit ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.editGoal.edit),expression:"editGoal.edit"}],staticClass:"flex flex-row justify-between"},[_c('p',{staticClass:"text-red-dark cursor-pointer",on:{"click":function($event){_vm.editGoal.edit ? _vm.editGoal.edit = false : _vm.editGoal.edit = true}}},[_vm._v(" Cancel ")]),_vm._v(" "),_c('p',{staticClass:"text-blue pl-4 cursor-pointer",on:{"click":_vm.saveGoal}},[_vm._v(" Save ")])])]),_vm._v(" "),_c('div',_vm._l((_vm.goals),function(goal){return _c('div',{key:goal.id,staticClass:"pt-4 flex flex-row justify-between text-grey-darkest"},[_c('p',{staticClass:"w-1/2 capitalize"},[_vm._v(_vm._s(goal.display_name))]),_vm._v(" "),_c('div',{staticClass:"w-1/2"},[_c('div',{staticClass:"flex flex-row justify-end"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editGoal.edit),expression:"!editGoal.edit"}],staticClass:"font-semibold"},[_vm._v(_vm._s(goal.target_value)+" "+_vm._s(goal.units && goal.units.trim() !== '' && goal.units.trim() !== 'nil' ? goal.units : ''))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.editGoal.edit),expression:"editGoal.edit"}],staticClass:"flex flex-row justify-end items-center font-semibold w-32 text-left border rounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(goal.target_value),expression:"goal.target_value"}],ref:goal.name,refInFor:true,staticClass:"bg-grey-extralight p-2 focus:bg-grey-extralight w-1/2 text-left",domProps:{"value":(goal.target_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(goal, "target_value", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"text-grey p-2 text-right bg-grey-extralight w-1/2 flex-shrink-0"},[_vm._v("\n                    "+_vm._s(goal.units && goal.units.trim() !== '' && goal.units.trim() !== 'nil' ? goal.units : 'N/A')+"\n                  ")])])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"p-4 mt-4 bg-white text-sm"},[_c('div',{staticClass:"flex flex-col justify-between"},[_c('div',{staticClass:"flex flex-row items-center justify-between text-grey-darkest font-semibold border-b border-dashed pb-2"},[_c('div',{staticClass:"flex flex-row items-center justify-between w-full"},[_c('div',{staticClass:"flex flex-row items-center"},[_c('p',{staticClass:"mr-2 text-grey-darkest font-semibold"},[_vm._v("Vitals")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"rounded border bg-grey-extralight p-2 flex flex-row items-center cursor-pointer",on:{"click":function($event){_vm.vitals.length > 1 ? _vm.selectWeek = !_vm.selectWeek : ''}}},[_c('div',{staticClass:"mr-2"},[_vm._v("Week "+_vm._s(_vm.currentWeek))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Glgf")}})]),_vm._v(" "),(_vm.selectWeek)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vitals.length > 0),expression:"vitals.length > 0"}],staticClass:"absolute mt-8 w-48 z-20 max-h-36 border bg-white font-semibold text-grey-dark overflow-y-scroll"},_vm._l((_vm.uniqueWeeks),function(week){return _c('p',{key:week,staticClass:"cursor-pointer py-4 pl-12 hover:bg-blue-extralight",on:{"click":function($event){return _vm.changeWeek(week)}}},[_vm._v("Week "+_vm._s(week))])}),0):_vm._e()])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"text-blue cursor-pointer",on:{"click":function($event){return _vm.openInsights()}}},[_vm._v(" View Insights")])])])]),_vm._v(" "),_vm._l((_vm.currentVitals),function(vital){return _c('div',{key:vital.units,staticClass:"pt-5 flex flex-row justify-between text-grey-darkest"},[_c('p',{staticClass:"capitalize"},[_vm._v(_vm._s(vital.display_name))]),_vm._v(" "),_c('p',{staticClass:"font-semibold"},[_vm._v(_vm._s(vital.current_value)+" "+_vm._s(vital.units && vital.units.trim() !== '' && vital.units.trim() !== "nil" ? vital.units : ''))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"w-full mt-4 px-4 py-5 text-grey-darker bg-white text-sm"},[_c('p',{staticClass:"text-grey-darkest font-semibold border-b border-dashed pb-4"},[_vm._v("Progress")]),_vm._v(" "),_vm._l((_vm.timelineAndProgress.activities),function(activities,week){return _c('div',{key:week,staticClass:"flex flex-col py-4 border-b"},[_c('div',{staticClass:"mb-2 font-semibold text-grey-dark"},[_vm._v("Week "+_vm._s(week))]),_vm._v(" "),_vm._l((activities),function(activity,index){return _c('div',{key:index,staticClass:"relative"},[_c('div',{staticClass:"flex flex-row items-end pt-6",class:{ 'mt-0': index === 0 }},[_c('img',{staticClass:"bg-grey-extralight h-6 w-6 p-1 rounded-full mr-3",staticStyle:{"z-index":"2"},attrs:{"src":_vm.getIcon(activity.status)}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between w-full"},[_c('div',[_c('p',{staticClass:"text-grey-darkest font-semibold"},[_vm._v(_vm._s(activity.title))]),_vm._v(" "),(_vm.summaryData[activity.activity_id])?_c('p',{staticClass:"text-grey-dark mt-1"},[_vm._v("\n                    "+_vm._s(_vm.summaryData[activity.activity_id])+"\n                  ")]):_c('p',{staticClass:"text-grey mt-1 capitalize"},[_vm._v(_vm._s(activity.subtitle))]),_vm._v(" "),(activity.activity_type === 'challenge')?_c('ul',{staticClass:"mt-1"},[_c('li',{staticClass:"text-grey"},[_vm._v("Challenge progress: 50%")]),_vm._v(" "),_c('li',{staticClass:"text-grey"},[_vm._v("Days Taken: 5 consecutive days")])]):_vm._e()]),_vm._v(" "),(activity.cta_text)?_c('div',{staticClass:"ml-4"},[_c('div',{staticClass:"text-blue font-semibold cursor-pointer",on:{"click":function($event){return _vm.getActivityDetails(activity)}}},[_vm._v(_vm._s(activity.cta_text))])]):_vm._e()])]),_vm._v(" "),(index !== activities.length - 1)?_c('div',{staticClass:"absolute w-px border-l-2 border-grey-lightest border-dashed",staticStyle:{"left":"11px","height":"30px"}}):_vm._e()])})],2)})],2)])]):(_vm.showTests)?_c('div',[_c('patient-tests',{attrs:{"showTests":_vm.showTests,"data":_vm.reportsData},on:{"close":function($event){_vm.showTests = false}}})],1):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"right-drawer",style:({
        width: _vm.drawerVisible ? '35vw' : '0'
      })},[_c('div',{staticClass:"flex flex-row justify-between border-b p-4"},[_c('h3',[_vm._v("Insights")]),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":function($event){_vm.drawerVisible = false}}},[_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")}})])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row m-4 justify-start"},_vm._l((_vm.chartTypes),function(label,key){return _c('button',{key:key,class:['bg-transparent hover:bg-blue text-grey hover:text-white border hover:border-transparent rounded-lg px-2 py-2', { 'border-blue text-blue': _vm.selectedChart === key, 'ml-4': key !== 'weight' }],on:{"click":function($event){_vm.selectedChart = key}}},[_vm._v("\n          "+_vm._s(label)+"\n        ")])}),0),_vm._v(" "),(_vm.selectedChart === 'weight')?_c('div',{staticClass:"p-4 border-b"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-grey text-sm mt-2"},[_vm._v("Last updated: "),_c('span',[_vm._v(" "+_vm._s(_vm.lastUpdateAt('weight'))+" ")])]),_vm._v(" "),(_vm.weightSeriesData[0].data.length)?_c('VueApexCharts',{attrs:{"type":"line","height":"200","options":_vm.weightChartOptions,"series":_vm.weightSeriesData}}):_c('div',{staticClass:"text-grey text-sm mt-4"},[_vm._v("No data available for Weight")])],1):(_vm.selectedChart === 'bloodSugar')?_c('div',{staticClass:"p-4 border-b"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text-grey text-sm mt-2"},[_vm._v("Last updated: "),_c('span',[_vm._v(" "+_vm._s(_vm.lastUpdateAt('blood_sugar'))+" ")])]),_vm._v(" "),(_vm.bloodSugarSeriesData[0].data.length)?_c('VueApexCharts',{attrs:{"type":"line","height":"200","options":_vm.bloodSugarChartOptions,"series":_vm.bloodSugarSeriesData}}):_c('div',{staticClass:"text-grey text-sm mt-4"},[_vm._v("No data available for Blood Sugar")])],1):(_vm.selectedChart === 'bloodPressure')?_c('div',{staticClass:"p-4 border-b"},[_vm._m(2),_vm._v(" "),_c('p',{staticClass:"text-grey text-sm mt-2"},[_vm._v("Last updated: "),_c('span',[_vm._v(" "+_vm._s(_vm.lastUpdateAt('blood_pressure'))+" ")])]),_vm._v(" "),(_vm.bloodPressureSeriesData[0].data.length && _vm.bloodPressureSeriesData[1].data.length)?_c('VueApexCharts',{attrs:{"type":"line","height":"200","options":_vm.bloodPressureChartOptions,"series":_vm.bloodPressureSeriesData}}):_c('div',{staticClass:"text-grey text-sm mt-4"},[_vm._v("No data available for Blood Pressure")])],1):(_vm.selectedChart === 'HbA1c')?_c('div',{staticClass:"p-4 border-b"},[_vm._m(3),_vm._v(" "),_c('p',{staticClass:"text-grey text-sm mt-2"},[_vm._v("Last updated: "),_c('span',[_vm._v(" "+_vm._s(_vm.lastUpdateAt('hba1c'))+" ")])]),_vm._v(" "),(_vm.hba1cSeriesData[0].data.length)?_c('VueApexCharts',{attrs:{"type":"line","height":"200","options":_vm.hba1cChartOptions,"series":_vm.hba1cSeriesData}}):_c('div',{staticClass:"text-grey text-sm mt-4"},[_vm._v("No data available for HbA1c")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-10 p-4"},[_c('div',{staticClass:"flex flex-row justify-between items-center w-full"},[_c('div',[_c('h3',[_vm._v("Steps Graph")]),_vm._v(" "),_c('p',{staticClass:"text-grey text-sm mt-2"},[_vm._v("Last updated: "),_c('span',[_vm._v(" "+_vm._s(_vm.stepsLastUpdateAt(_vm.stepsUnit))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between"},[_c('div',{attrs:{"className":"flex items-center rounded-lg"}},[_c('div',{staticClass:"relative z-10 flex items-center rounded-lg border border-stroke bg-grey-lightest p-1"},[_c('button',{staticClass:"inline-flex h-6 items-center justify-center rounded px-3 text-sm font-medium duration-200 hover:bg-white hover:text-black g-grey-lightest text-grey-light transition-all duration-300 ease-in-out",class:{ 'bg-white text-black scale-105': _vm.stepsUnit === 'day' },on:{"click":function($event){_vm.stepsUnit = 'day'}}},[_vm._v("Day")]),_vm._v(" "),_c('button',{staticClass:"inline-flex h-6 items-center justify-center rounded px-3 text-sm font-medium duration-200 hover:bg-white hover:text-black ml-2 bg-grey-lightest text-grey-light transition-all duration-300 ease-in-out",class:{ 'bg-white text-black scale-105': _vm.stepsUnit === 'week' },on:{"click":function($event){_vm.stepsUnit = 'week'}}},[_vm._v("week")])])])])]),_vm._v(" "),_c('div',{staticClass:"max-h-[320px] overflow-auto pr-2"},[(_vm.stepsUnit === 'week')?_c('div',[(_vm.dailyStepsSeriesData[0].data.length)?_c('VueApexCharts',{attrs:{"type":"bar","height":"300","width":_vm.chartWidth,"options":_vm.weeklyStepsChartOptions,"series":_vm.weeklyStepsSeriesData}}):_c('div',{staticClass:"text-grey text-sm mt-4"},[_vm._v("No daily step data available")])],1):(_vm.stepsUnit === 'day')?_c('div',[(_vm.weeklyStepsSeriesData[0].data.length)?_c('VueApexCharts',{attrs:{"type":"bar","height":"300","width":_vm.chartWidth,"options":_vm.dailyStepsChartOptions,"series":_vm.dailyStepsSeriesData}}):_c('div',{staticClass:"text-grey text-sm mt-4"},[_vm._v("No weekly step data available")])],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"drawer-mask",style:({
        width: _vm.drawerVisible ? '100vw' : '0',
        opacity: _vm.drawerVisible ? '0.6' : '0',
      }),on:{"click":function($event){_vm.drawerVisible = false}}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("Weight "),_c('span',{staticClass:"text-grey",staticStyle:{"font-weight":"400"}},[_vm._v(" (kgs) ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("Blood Sugar "),_c('span',{staticClass:"text-grey",staticStyle:{"font-weight":"400"}},[_vm._v(" (mg/dL) ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("Blood Pressure "),_c('span',{staticClass:"text-grey",staticStyle:{"font-weight":"400"}},[_vm._v(" (mmHg) ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("HbA1c "),_c('span',{staticClass:"text-grey",staticStyle:{"font-weight":"400"}},[_vm._v(" (%) ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ssvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeElapsed_vue__ = __webpack_require__("YIS4");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__["a" /* default */],
    TimeElapsed: __WEBPACK_IMPORTED_MODULE_3__TimeElapsed_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showSaveReminder: false,
      timerClass: 'text-green-darker'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    activeConsults: function activeConsults(state) {
      return state.consultation.activeConsults;
    },
    activeCustomer: function activeCustomer(state) {
      return state.consultation.activeCustomerId;
    },
    activeChannel: function activeChannel(state) {
      return state.consultation.activeChannelId;
    },
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    allMessages: 'message/getAllPatientsMessages'
  })),
  methods: {
    selectFromConnectedList: function selectFromConnectedList(channelId, customerId) {
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      if (channelId !== this.activeChannel) {
        this.$store.dispatch('consultation/switchTo', { channelId: channelId, customerId: customerId });
      }
    },
    patientLastMessage: function patientLastMessage(channelId) {
      var consult = this.allMessages.find(function (ele) {
        return ele.channelId === channelId;
      });
      if (consult) {
        var patientMessages = consult.messages.filter(function (ele) {
          return ele.user && ele.user.type === 'customer';
        });
        if (patientMessages.length > 0) {
          if (patientMessages[patientMessages.length - 1].intentName === 'incoming_text') {
            return patientMessages[patientMessages.length - 1].payload.text.substring(0, 45);
          } else if (patientMessages[patientMessages.length - 1].intentName === 'file_customer') {
            return patientMessages[patientMessages.length - 1].payload.file_name.substring(0, 45);
          }
        }
      }
      return '';
    },
    patientLastMessageTime: function patientLastMessageTime(channelId) {
      var consult = this.allMessages.find(function (ele) {
        return ele.channelId === channelId;
      });
      if (consult) {
        var patientMessages = consult.messages.filter(function (ele) {
          return ele.user && ele.user.type === 'customer';
        });
        if (patientMessages.length > 0) {
          var milliTime = patientMessages[patientMessages.length - 1].uniqueId;
          var t = new Date(Number(milliTime));
          return t.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' });
        }
      }
      return '';
    },
    patientNewMessages: function patientNewMessages(channelId) {
      var consult = this.allMessages.find(function (ele) {
        return ele.channelId === channelId;
      });
      if (consult) {
        var patientMessages = consult.messages;
        if (patientMessages.length > 0) {
          if (this.activeChannel !== channelId) {
            return consult.newMessages;
          }
        }
        return 0;
      }
    },
    closeModal: function closeModal(params) {
      this.showSaveReminder = false;
    },
    timerColor: function timerColor(value) {
      this.timerClass = value;
    }
  }
});

/***/ }),

/***/ "suTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t2QX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tDmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSetUpConsultationFollowUp || _vm.showSetUpLabFollowUp)?_c('div',{staticClass:"flex flex-col px-2 py-4 bg-white border-b border-t border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-col mt-2 mx-2 flex-no-shrink flex-no-grow"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-2 mr-1 tracking-wide",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Follow up for "+_vm._s(_vm.customer.name))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col rounded-xs bg-grey-extralight py-4 px-3 mt-2 mx-2 flex-no-shrink flex-no-grow"},[_c('label',{staticClass:"text-sm font-semibold text-grey-dark mb-4"},[_vm._v("Follow up for")]),_vm._v(" "),(_vm.showSetUpLabFollowUp)?_c('div',{staticClass:"flex flex-col mb-6"},[_c('div',{staticClass:"flex flex-row items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.testsChecked),expression:"testsChecked"}],staticClass:"flex m-1 mb-2",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.testsChecked)?_vm._i(_vm.testsChecked,null)>-1:(_vm.testsChecked)},on:{"change":function($event){var $$a=_vm.testsChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.testsChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.testsChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.testsChecked=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"flex ml-1 text-sm font-semibold text-grey-darkest"},[_vm._v("Lab Tests")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col mt-1"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.recommendedTests),function(test,i){return _c('div',{key:i,staticClass:"flex flex-row mb-3"},[_c('label',{staticClass:"text-sm text-grey-dark w-64 h-6 self-center pl-2 mr-4"},[_vm._v(_vm._s(test.package_name))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(test.days),expression:"test.days"}],staticClass:"flex appearance-none w-24 h-8 pl-2 mr-1 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"4.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"disabled":_vm.testsChecked ? false : true,"name":"dosage type"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(test, "days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.labFollowupSelect]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("7")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("60")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("90")])]),_vm._v(" "),_vm._m(1,true)])})],2)]):_vm._e(),_vm._v(" "),(_vm.showSetUpConsultationFollowUp)?_c('div',[_c('div',{staticClass:"flex flex-row items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.consultationChecked),expression:"consultationChecked"}],staticClass:"flex m-1 mb-2",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.consultationChecked)?_vm._i(_vm.consultationChecked,null)>-1:(_vm.consultationChecked)},on:{"change":function($event){var $$a=_vm.consultationChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.consultationChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.consultationChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.consultationChecked=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"flex ml-1 text-sm font-semibold text-grey-darkest"},[_vm._v("Consultation")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col mt-1"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex flex-row mb-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.followUpConsultDays),expression:"followUpConsultDays"}],staticClass:"flex appearance-none w-24 h-8 pl-2 mr-1 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"4.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"disabled":_vm.consultationChecked ? false : true,"name":"dosage type"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.followUpConsultDays=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultationFollowupSelect]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("7")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("60")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("90")])]),_vm._v(" "),_vm._m(3)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex mt-4"},[_c('div',{staticClass:"flex px-4 py-3 w-32 text-xs justify-center font-semibold rounded-sm text-white",class:_vm.enableSetFollowupButton ? 'bg-blue cursor-pointer' : 'bg-grey-lightest cursor-not-allowed',on:{"click":function($event){return _vm.setUpFollowUp()}}},[_vm._v("Set follow up")])])]),_vm._v(" "),_c('div',{staticClass:"flex mx-4 py-2"},[_c('p',{staticClass:"text-xs text-grey-dark"},[_vm._v("Reminder will be sent to "+_vm._s(_vm.customer.name)+" 48 hours before the event to schedule a follow up consultation")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"flex appearance-none w-64 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"}),_vm._v(" "),_c('div',{staticClass:"flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"},[_vm._v("After")]),_vm._v(" "),_c('div',{staticClass:"flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"flex appearance-none w-24 h-8 pl-2 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"4.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"}},[_c('option',{attrs:{"value":"days"}},[_vm._v("days")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row"},[_c('div',{staticClass:"flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"},[_vm._v("After")]),_vm._v(" "),_c('div',{staticClass:"flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"flex appearance-none w-24 h-8 pl-2 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"outline":"none","background-position":"4.4rem 0.5rem","background-repeat":"no-repeat","background-size":"0.9rem 0.9rem"},attrs:{"name":"dosage type"}},[_c('option',{attrs:{"value":"days"}},[_vm._v("days")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tWij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Snackbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Snackbar__ = __webpack_require__("qrkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__("xfme");






var SnackbarProgrammatic = {
  open: function open(params) {
    var message = void 0;
    if (typeof params === 'string') message = params;

    var defaultParam = {
      type: 'is-success',
      position: 'is-bottom-right',
      message: message
    };
    var propsData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(defaultParam, params);

    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : __WEBPACK_IMPORTED_MODULE_1_vue__["default"];
    var SnackbarComponent = vm.extend(__WEBPACK_IMPORTED_MODULE_2__Snackbar__["a" /* default */]);
    return new SnackbarComponent({
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__plugins__["a" /* registerComponentProgrammatic */])(Vue, '$snackbar', SnackbarProgrammatic);
  }
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__plugins__["b" /* use */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "tjrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeElement;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertHeightToFeetInches;
function removeElement(el) {
  if (typeof el.remove !== 'undefined') {
    el.remove();
  } else {
    el.parentNode.removeChild(el);
  }
}

function convertHeightToFeetInches(height) {
  var feet = Math.floor(height / 2.54 / 12);
  var inches = height / 2.54;
  var remInches = Math.round(inches % 12);
  if (remInches === 12) {
    feet = feet + 1;
    inches = 0;
  } else inches = remInches;
  return [feet, inches];
}

/***/ }),

/***/ "u1n2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('left-pane',{attrs:{"incomingRequests":_vm.incomingRequests}}),_vm._v(" "),(_vm.isActiveChat)?_c('chat-pane',{on:{"tabChange":_vm.tabChange}}):_vm._e(),_vm._v(" "),(_vm.isActiveChat)?_c('right-pane',{attrs:{"selectedTab":_vm.selectedRightTab,"chatType":"online","showRightPane":_vm.showRightPane,"showToggleButton":_vm.showToggleButton},on:{"tabChange":_vm.tabChange,"toggleRightPane":_vm.toggleRightPane}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u7ah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDPR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Dcm9zczwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJEb2N1bWVudHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDExLjAwMDAwMCwgLTY0LjAwMDAwMCkiIHN0cm9rZT0iIzdDOENBQiIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9IkNyb3NzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDEyLjAwMDAwMCwgNjUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC43NSwxMS4yNSBMMTEuMjUsMC43NSIgaWQ9IkxpbmUtNiI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTAuNzUsMTEuMjUgTDExLjI1LDAuNzUiIGlkPSJMaW5lLTYtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi4wMDAwMDAsIDYuMDAwMDAwKSByb3RhdGUoLTkwLjAwMDAwMCkgdHJhbnNsYXRlKC02LjAwMDAwMCwgLTYuMDAwMDAwKSAiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "uG7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatPane_vue__ = __webpack_require__("7hcX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_366be698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatPane_vue__ = __webpack_require__("eBPN");
function injectStyle (ssrContext) {
  __webpack_require__("B/Nb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-366be698"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_366be698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatPane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uITx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0)","z-index":"-1","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closePopup()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col absolute justify-content rounded shadow-lg bg-grey-extralight z-20",staticStyle:{"left":"260px","top":"0px","width":"max-content","max-width":"600px"}},[_c('div',{staticClass:"flex flex-row justify-between px-4 py-2 items-center border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"font-semibold text-sm text-grey-dark py-2 mr-auto"},[_vm._v("Active Consultations")]),_vm._v(" "),_c('img',{staticClass:"flex flex-col w-5 h-5 cursor-pointer ml-8",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closePopup()}}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap p-4 items-top justify-center"},[(_vm.loadDetails.length<1)?_c('div',{staticClass:"flex text-sm text-grey-darkest my-4 items-center"},[_vm._v("No doctor is Active")]):_vm._e(),_vm._v(" "),_vm._l((_vm.loadDetails),function(loadDetail,index){return _c('div',{key:index,staticClass:"flex flex-col bg-grey-lightest rounded m-1 px-2 py-2 flex-no-shrink items-center flex-no-grow"},[_c('div',{staticClass:"text-xs my-1 font-semibold text-blue border border-solid border-blue flex flex-row rounded-full h-8 w-8 flex self-center items-center justify-center"},[_vm._v("\n            "+_vm._s(loadDetail.count)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex text-xs font-semibold text-grey-darkest my-1 capitalize"},[_vm._v("\n            "+_vm._s(loadDetail.doctor_name)+"\n          ")]),_vm._v(" "),(loadDetail.patients && loadDetail.patients.length>0)?_c('div',{staticClass:"flex flex-col text-xs text-grey-darker capitalize my-1 w-full items-center overflow-y-auto",staticStyle:{"max-height":"56px"}},_vm._l((loadDetail.patients),function(patient,index){return _c('div',{key:index},[_c('div',{staticClass:"mr-1"},[_vm._v("* "+_vm._s(patient))])])}),0):_vm._e()])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uJpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAdding)?_c('add-drug',{staticClass:"my-2 pb-6 px-2 pt-2",attrs:{"drugs":_vm.isAdding ? [] : _vm.drugs,"customerId":_vm.customer.customerId},on:{"updateDrugs":_vm.updateDrugs}}):_c('div',{staticClass:"flex flex-row bg-white mt-1"},[_c('table',{staticClass:"flex flex-col min-w-full max-w-full overflow-y-auto p-2"},[_c('tr',{staticClass:"flex flex-row bg-white mb-2 rounded-tl rounded-tr items-center justify-center"},[_c('th',{staticClass:"text-sm font-semibold text-grey-dark mr-auto"},[_vm._v("CURRENT MEDICATIONS")]),_vm._v(" "),_c('th',{staticClass:"justify-center cursor-pointer text-blue text-sm font-semibold ml-auto mr-1",on:{"click":function($event){return _vm.addDrug()}}},[_vm._v("+ Add Medication")])]),_vm._v(" "),(_vm.medications.length>0)?_c('tr',{staticClass:"flex flex-row h-10 p-2 items-center border-solid border-b border-grey-lightest bg-grey-extralight text-sm text-grey-dark text-left"},[_c('th',{staticClass:"text-grey-darker font-semibold w-4/5"},[_vm._v("Drug")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-2/5"},[_vm._v("Dosage")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-2/5"},[_vm._v("Frequency")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-2/5 pl-4"},[_vm._v("Duration")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-1/5"},[_vm._v("Action")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.medications),function(med,index){return _c('tr',{key:index,staticClass:"flex flex-row h-10 p-2 bg-grey-extralight text-sm text-grey-darker text-left"},[_c('td',{staticClass:"text-grey-darker w-4/5 truncate"},[_vm._v(_vm._s(med.name))]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-2/5"},[_vm._v(_vm._s(med.dose_quantity)+" "+_vm._s(med.dose_unit))]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-2/5 text-center"},[_vm._v(_vm._s(med.frequency))]),_vm._v(" "),(med.duration&&med.duration_unit)?_c('td',{staticClass:"text-grey-darker w-2/5 pl-4 text-center"},[_vm._v(_vm._s(med.duration)+" "+_vm._s(med.duration_unit))]):_c('td',{staticClass:"text-grey-darker w-2/5 pl-4 text-center"},[_vm._v(_vm._s(med.number_of_days)+" days")]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-1/5 text-center self-center",on:{"click":function($event){return _vm.deleteDrug(med, index)}}},[_c('img',{staticClass:"w-4",attrs:{"src":__webpack_require__("KuaY")}})])])})],2)]),_vm._v(" "),(_vm.showDeleteWarning)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeEndChatOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_vm._m(0),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Are you sure you want to delete this medicine from current medication?")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.deleteHandler()}}},[_vm._v("Delete")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-grey-light ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-grey-dark text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeEndChatOverlay()}}},[_vm._v("Cancel")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-m text-left font-semibold py-2"},[_vm._v("Delete medication")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uKUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"p-2 relative bg-white rounded-sm border border-solid border-grey-lightest \n  text-base text-grey-darkest focus:border-blue",staticStyle:{"width":"100%"},attrs:{"type":"search","placeholder":"Search by name, email..."},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value},_vm.fetchConsults]}}),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow"}),_vm._v(" "),(_vm.consultations.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No Consultations")])]):_c('div',{staticClass:"flex flex-col overflow-y-auto pb-4",staticStyle:{"height":"calc(100vh - 8.5rem)"}},[_vm._l((_vm.consultations),function(cp,index){return _c('div',{key:index,staticClass:"flex flex-col h-16 pl-3 flex-no-shrink flex-no-grow justify-center hover:bg-grey-extralight cursor-pointer",class:(cp.consultationRequest.consultationRequestId === _vm.activePastConsultationRequestId) ? 'bg-grey-extralight' : '',on:{"click":function($event){return _vm.selectFromPastList(cp.consultation.consultationId, cp.consultationRequest.consultationRequestId)}}},[_c('div',{staticClass:"flex flex-row pt-2"},[_c('div',{staticClass:"text-sm font-semibold self-center capitalize"},[_vm._v(_vm._s(cp.name ? cp.name: cp.customerId))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row py-2 pr-2"},[(_vm.consultStatus(cp))?_c('div',{staticClass:"text-xs text-green-light font-light"},[_vm._v("Case Closed")]):_c('div',{staticClass:"text-xs text-red-light font-light"},[_vm._v("Summary Pending")]),_vm._v(" "),_c('div',{staticClass:"text-xs ml-auto text-grey-dark font-light"},[_vm._v(_vm._s(_vm._f("formatDate")(cp.consultationRequest.date)))])])])}),_vm._v(" "),(_vm.showLoadMore)?_c('div',{staticClass:"flex flex-col h-12 justify-center"},[_c('div',{staticClass:"flex px-3 py-2 justify-end cursor-pointer italic rounded-sm text-blue text-sm hover:text-grey-darker",on:{"click":_vm.fetchMoreConsults}},[_vm._v("\n        Load more . . .\n      ")])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uMY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showTab: 'results',
      uploadedBy: this.data.reports[0].uploaded_by,
      uploadedOn: this.data.reports[0].updated_at
    };
  },

  methods: {
    openReport: function openReport(url) {
      window.open(url, '_blank');
    }
  }
});

/***/ }),

/***/ "uOOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border border-solid border-grey-lightest bg-white rounded mt-6"},[_c('table',{staticClass:"m-3 min-w-full max-w-full"},[_c('tr',{staticClass:"flex justify-between mr-6 pb-3 border-b border-solid border-grey-lightest content-center"},[_c('th',{staticClass:"text-grey-dark font-semibold text-base pt-1 w-2/3 break-words"},[_vm._v(_vm._s(_vm.medication.name))]),_vm._v(" "),_c('th',{staticClass:"flex justify-end"},[_c('button',{staticClass:"border border-solid border-grey-lightest rounded focus:outline-none text-center pt-1 px-2",on:{"click":function($event){return _vm.remove()}}},[_c('img',{attrs:{"src":__webpack_require__("1R19"),"alt":"delete saved medication"}})]),_vm._v(" "),_c('button',{staticClass:"border border-solid border-grey-lightest rounded focus:outline-none ml-2 pt-1 px-2",on:{"click":function($event){return _vm.edit()}}},[_c('img',{attrs:{"src":__webpack_require__("3X5m"),"alt":"edit saved medication"}})]),_vm._v(" "),_c('button',{staticClass:"border border-solid border-grey-lightest rounded focus:outline-none font-semibold text-blue px-4 py-1 ml-2",on:{"click":function($event){return _vm.add()}}},[_vm._v("Add")])])]),_vm._v(" "),_c('tr',{staticClass:"flex justify-between mr-6 mt-2 font-semibold text-grey-dark"},[_c('th',{staticClass:"text-left"},[_c('div',{staticClass:"text-grey-light text-sm"},[_vm._v("Dosage")]),_vm._v(" "),_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.medication.dose_quantity)+" "+_vm._s(_vm.medication.dose_unit))])]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_c('div',{staticClass:"text-grey-light text-sm"},[_vm._v("Frequency")]),_vm._v(" "),_c('div',{staticClass:"mt-1 text-left"},[_vm._v(_vm._s(_vm.medication.frequency))])]),_vm._v(" "),_c('th',{staticClass:"border-r border-grey-lightest pr-5 text-left"},[_c('div',{staticClass:"text-grey-light text-sm"},[_vm._v("Duration")]),_vm._v(" "),_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(((_vm.medication.duration) + " " + (_vm.medication.duration_unit))))])]),_vm._v(" "),_c('th',{staticClass:"flex text-grey-light text-sm items-center justify-between pr-3 justify-items-start"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.medication.is_current),expression:"medication.is_current"}],staticClass:"check form-checkbox h-5 w-5",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.medication.is_current)?_vm._i(_vm.medication.is_current,null)>-1:(_vm.medication.is_current)},on:{"change":[function($event){var $$a=_vm.medication.is_current,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.medication, "is_current", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.medication, "is_current", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.medication, "is_current", $$c)}},_vm.toggleCheckbox]}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left leading-6 pr-4"},[_vm._v("Current"),_c('br'),_vm._v("Medication")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uPNi":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MDAgNTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzY2NjY2Njt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTEzNi41LDM4LjdjLTQuOSw0LjktNy4zLDExLjMtNy4zLDE3LjdjMCw2LjQsMi40LDEyLjgsNy4zLDE3LjdMMzEyLDI1MC4yTDEzNiw0MjUuNwoJCWMtNC45LDQuOS03LjQsMTEuMy03LjQsMTcuN2MwLDYuNCwyLjQsMTIuOCw3LjMsMTcuN2M5LjgsOS44LDI1LjYsOS44LDM1LjQsMC4xTDM2NSwyNjhjOS44LTkuNyw5LjgtMjUuNiwwLjEtMzUuNEwxNzEuOSwzOC43CgkJQzE2Mi4xLDI5LDE0Ni4zLDI4LjksMTM2LjUsMzguN3oiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "udZn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-pattern2.176f12c.svg";

/***/ }),

/***/ "ugZY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMTUgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cCAxMTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJEb2N1bWVudHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJEaWdpdGl6YXRpb25yZXBvcnRzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzEyNC4wMDAwMDAsIC00MjQuMDAwMDAwKSIgc3Ryb2tlPSIjODg5NUFGIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzYzLjAwMDAwMCwgMTk2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNjEuMDAwMDAwLCAyMjguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iI0U1RThGMCIgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOS44MDc2OTIzMSwxLjE1Mzg0NjE1IEw5LjgwNzY5MjMxLDEzLjg0NjE1MzgiIGlkPSJMaW5lLTEzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "umV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"relative flex flex-col bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest"},[_c('div',{staticClass:"flex relative flex-col pt-1 flex-no-shrink flex-no-grow w-1/2 z-10"},[_c('div',{staticClass:"flex flex-row h-12 text-xs items-center"},[(_vm.role !== 'specialistDoctor')?_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'requested' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],staticStyle:{"padding":"10px 0px 10px 0px"},on:{"click":function($event){return _vm.selectTab('requested')}}},[_vm._v("\n            Requested\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'scheduled' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],staticStyle:{"padding":"10px 0px 10px 0px"},on:{"click":function($event){return _vm.selectTab('scheduled')}}},[_vm._v("\n            Scheduled\n          ")]),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'completed' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],staticStyle:{"padding":"10px 0px 10px 0px"},on:{"click":function($event){return _vm.selectTab('completed')}}},[_vm._v("\n            Completed\n          ")]),_vm._v(" "),(!['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'no_response' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],staticStyle:{"padding":"10px 0px 10px 0px"},on:{"click":function($event){return _vm.selectTab('no_response')}}},[_vm._v("\n            1 Failed Attempt\n          ")]):_vm._e(),_vm._v(" "),(['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'received' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],staticStyle:{"padding":"10px 0px 10px 0px"},on:{"click":function($event){return _vm.selectTab('received')}}},[_vm._v("\n            Received\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'incomplete' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],staticStyle:{"padding":"10px 0px 10px 0px"},on:{"click":function($event){return _vm.selectTab('incomplete')}}},[_vm._v("\n            Incomplete\n          ")]),_vm._v(" "),(!['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"w-1/3 text-center cursor-pointer",class:[_vm.activeTab === 'rejected' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.selectTab('rejected')}}},[_vm._v("\n            Rejected\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest"},[(_vm.role !== 'specialistDoctor')?_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'requested' ? 'bg-blue' : '']}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'scheduled' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'completed' ? 'bg-blue' : '']}),_vm._v(" "),(!['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'no_response' ? 'bg-blue' : '']}):_vm._e(),_vm._v(" "),(['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'received' ? 'bg-blue' : '']}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'incomplete' ? 'bg-blue' : '']}),_vm._v(" "),(!['specialistDoctor', 'externalAdmin'].includes(_vm.role))?_c('div',{staticClass:"w-1/3",class:[_vm.activeTab === 'rejected' ? 'bg-blue' : '']}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"absolute h-12 mt-2 border-solid border-b-4 border-grey-lightest w-full z-0"}),_vm._v(" "),(_vm.role !== 'externalAdmin' && _vm.activeTab === 'requested')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('requested-appointment-table')],1):_vm._e(),_vm._v(" "),(_vm.role === 'externalAdmin' && _vm.activeTab === 'requested')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":6,"data":_vm.data,"canReschedule":true},on:{"updateAptRequest":_vm.updateAptRequest,"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark,"startConsultation":_vm.startConsultation}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'scheduled')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":0,"data":_vm.data,"canReschedule":true},on:{"updateAptRequest":_vm.updateAptRequest,"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark,"startConsultation":_vm.startConsultation}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'completed')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":1,"data":_vm.data},on:{"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark,"uploadDocuments":_vm.uploadDocuments}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'no_response')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":2,"data":_vm.data},on:{"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark,"startConsultation":_vm.startConsultation}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'incomplete')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":3,"data":_vm.data},on:{"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'rejected')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":4,"data":_vm.data},on:{"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'received')?_c('div',{staticClass:"flex flex-col overflow-y-scroll",staticStyle:{"height":"calc(100vh - 6rem)"}},[_c('appointment-table',{attrs:{"tab":5,"data":_vm.data},on:{"updateStatus":_vm.updateStatus,"updateRemark":_vm.updateRemark}})],1):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"100","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-lg",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"80px","height":"420px","z-index":"110"}},[_c('div',{staticClass:"text-grey-darker px-5 py-4 text-lg font-semibold"},[_vm._v("Assign doctor")]),_vm._v(" "),_c('img',{staticClass:"mr-4 mt-2 cursor-pointer absolute",staticStyle:{"right":"10px","top":"10px","height":"20px","width":"20px"},attrs:{"src":__webpack_require__("uDPR")},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),(true)?_c('div',{staticClass:"flex flex-col bg-white px-5 py-2 mt-2"},[_c('div',{staticClass:"flex justify-end relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDoctor),expression:"selectedDoctor"}],staticClass:"w-full p-3 cursor-pointer capitalize relative bg-grey-extralight rounded-m border border-solid border-grey-lightest \n          text-base text-grey-dark font-semibold placeholder-icon",attrs:{"type":"search","placeholder":"   Search for Doctors"},domProps:{"value":(_vm.selectedDoctor)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.selectedDoctor=$event.target.value},_vm.searchDoctors],"click":_vm.toggleDropdown}}),_vm._v(" "),(_vm.showOptions)?_c('img',{staticClass:"flex absolute cursor-pointer self-center pr-2",attrs:{"src":__webpack_require__("nZiJ")},on:{"click":function($event){return _vm.toggleDropdown()}}}):_c('img',{staticClass:"flex absolute cursor-pointer self-center pr-2",attrs:{"src":__webpack_require__("lYso")},on:{"click":function($event){return _vm.toggleDropdown()}}})]),_vm._v(" "),(_vm.showOptions)?_c('div',{staticClass:"mt-1 rounded-lg border-grey-lightest border py-1"},[(_vm.doctorsList.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-2 text-red-light"},[_vm._v("Search result not found")])]):_c('div',{staticClass:"flex flex-col"},[_c('span',{staticClass:"text-xs text-grey-lighter tracking-wide font-semibold flex justify-center my-2 ml-3 self-start "},[_vm._v("AVAILABLE DOCTORS")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col scrollbar-hide overflow-y-auto",staticStyle:{"max-height":"176px"}},_vm._l((_vm.doctorsList),function(doctor,index){return _c('div',{key:index,staticClass:"flex flex-col h-12 pl-3 pr-3 justify-center pt-3 flex-no-shrink flex-no-grow cursor-pointer hover:bg-grey-extralight",class:{doctorActive : (doctor.name === _vm.selectedDoctor)},on:{"click":function($event){return _vm.selectDoctor(doctor)}}},[_c('div',{staticClass:"flex flex-row align-middle mb-2 items-center"},[(doctor.name === _vm.selectedDoctor)?_c('img',{staticClass:"pr-2",attrs:{"src":__webpack_require__("DtAb"),"alt":"doctor"}}):_c('img',{staticClass:"pr-2",attrs:{"src":__webpack_require__("TA6h"),"alt":"doctor"}}),_vm._v(" "),_c('div',{staticClass:"text-sm text-grey-dark font-semibold self-center capitalize"},[_vm._v(_vm._s(doctor.name))])])])}),0)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showSlots && !_vm.showOptions && _vm.doctorsList.length>0 && _vm.selectedDoctor)?_c('div',{staticClass:"flex flex-col bg-white px-5 py-2"},[_c('span',{staticClass:"text-xs text-grey-lighter tracking-widest font-semibold flex justify-center my-2 self-start "},[_vm._v("AVAILABLE SLOTS")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap scrollbar-hide overflow-y-auto",staticStyle:{"max-height":"176px"}},_vm._l((_vm.slotsList),function(slot,i){return _c('div',{key:i,staticClass:"text-sm cursor-pointer font-semibold rounded-full flex-no-shrink flex-no-grow text-center px-4 py-3 my-2 mr-4 ",class:[slot.slot === _vm.selectedSlot.slot ? 'text-white bg-blue' : slot.available ? 'text-grey border border-solid border-grey-lightest bg-grey-extralight' : 'text-grey-lighter border border-solid border-grey-extralight bg-white cursor-not-allowed'],on:{"click":function($event){slot.available ? _vm.selectSlot(slot) : function (){}}}},[_vm._v("\n            "+_vm._s(slot.slot)+"\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"absolute bg-white flex content-center font-semibold justify-center px-5 py-4 mb-2 w-full pin-b "},[_c('div',{staticClass:"ml-4 px-4 py-3 rounded text-sm hover:shadow-md",class:[this.selectedDoctor && this.selectedSlot ?  'cursor-pointer text-white bg-blue' : 'cursor-not-allowed text-white bg-grey-lightest'],on:{"click":function($event){return _vm.assignDoctorHandler()}}},[_vm._v("Assign Doctor")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uwbl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "v+pk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data'],
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "v3A3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsultationSummary_vue__ = __webpack_require__("v6j2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d187696_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsultationSummary_vue__ = __webpack_require__("JD8d");
function injectStyle (ssrContext) {
  __webpack_require__("FBWV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsultationSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d187696_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsultationSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v6j2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__ = __webpack_require__("qrBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Autocomplete__ = __webpack_require__("8c6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Customer_FollowUp_Scheduled__ = __webpack_require__("Xw7Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Customer_FollowUp_SetUp__ = __webpack_require__("pev1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_modals_SummaryNotSaved__ = __webpack_require__("Lfub");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AutoComplete: __WEBPACK_IMPORTED_MODULE_2__components_common_Autocomplete__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_1__components_common_TextField__["a" /* default */],
    ScheduledFollowUp: __WEBPACK_IMPORTED_MODULE_3__components_Customer_FollowUp_Scheduled__["a" /* default */],
    SetUpFollowUp: __WEBPACK_IMPORTED_MODULE_4__components_Customer_FollowUp_SetUp__["a" /* default */],
    SummaryNotSavedModal: __WEBPACK_IMPORTED_MODULE_6__components_common_modals_SummaryNotSaved__["a" /* default */]
  },
  props: ['currentProps'],
  data: function data() {
    return {
      search: '',
      idc_codes: [],
      showSaveReminder: false,
      error: { hasError: false, message: '' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    },
    editTextFieldId: function editTextFieldId(state) {
      return state.textField.field;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile',
    loader: 'loader/getLoaderData',
    activeSection: 'configuration/getActiveSection'
  }), {
    chiefComplaint: function chiefComplaint() {
      if (this.customer && this.customer.consultation && this.customer.consultation.chiefComplaint) {
        this.error = { hasError: false, message: '' };
        return this.customer.consultation.chiefComplaint;
      } else this.error = { hasError: true, message: 'You must add the chief complaint first' };
    },
    provisionalDiagnosis: function provisionalDiagnosis() {
      if (this.customer && this.customer.consultation && this.customer.consultation.provisionalDiagnosis) {
        return this.customer.consultation.provisionalDiagnosis;
      }
    },
    summaryNotes: function summaryNotes() {
      if (this.customer && this.customer.consultation && this.customer.consultation.summaryNotes) {
        return this.customer.consultation.summaryNotes;
      }
    },
    caseClosed: function caseClosed() {
      if (this.customer && (this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') || this.customer && (this.customer.consultation.consultationId === null || this.customer.consultation.consultationId === undefined)) {
        return true;
      } else {
        return false;
      }
    }
  }),
  methods: {
    scheduledRerender: function scheduledRerender() {
      this.scheduledKey += 1;
      this.followUpKey += 1;
    },
    closeModal: function closeModal() {
      this.showSaveReminder = false;
    },
    getCodes: function getCodes(search) {
      if (search !== '') {
        var vm = this;
        vm.$http.get(window.API_URL + 'doctors/icd_ten_codes?term=' + search).then(function (response) {
          vm.idc_codes = response && response.body && response.body.length > 0 ? response.body : [];
          vm.idc_codes.unshift(search);
        });
      }
    },
    saveChange: function saveChange(data) {
      if (this.$attrs.chatType === 'offline') {
        this.saveOfflineConsult(data);
      } else if (this.$attrs.chatType === 'online') {
        this.saveOnlineConsult(data);
      }
    },
    saveOfflineConsult: function saveOfflineConsult(data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('offlineConsultation/updateConsultation', data);
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastOfflineConsultation/updateConsultation', data);
      }
    },
    saveOnlineConsult: function saveOnlineConsult(data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('consultation/updateConsultation', data);
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastConsultation/updateConsultation', data);
      }
    },

    sendSummary: function sendSummary() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      data.componentKey = 'CS-SendSummary';
      if (this.$attrs.chatType === 'offline') {
        if (this.activeSection === 'consults') {
          if (this.editTextField && this.editTextFieldId === 'summary_notes') {
            this.showSaveReminder = true;
            return;
          }
          this.$store.dispatch('pastOfflineConsultation/sendSummary', data);
        }
      } else if (this.$attrs.chatType === 'online') {
        if (this.activeSection === 'connected') {
          this.$store.dispatch('consultation/sendSummary', data);
        } else if (this.activeSection === 'consults') {
          if (this.editTextField && this.editTextFieldId === 'summary_notes') {
            this.showSaveReminder = true;
            return;
          }
          this.$store.dispatch('pastConsultation/sendSummary', data);
        }
      }
    },
    summaryNotNeeded: function summaryNotNeeded() {
      if (this.$attrs.chatType === 'offline') {
        if (this.activeSection === 'consults') {
          this.$store.dispatch('pastOfflineConsultation/summaryNotNeeded', { summary: 'NA', componentKey: 'CS-SummaryNotNeeded' });
        }
      } else if (this.$attrs.chatType === 'online') {
        if (this.activeSection === 'connected') {
          this.$store.dispatch('consultation/summaryNotNeeded', { summary: 'NA', componentKey: 'CS-SummaryNotNeeded' });
        } else if (this.activeSection === 'consults') {
          this.$store.dispatch('pastConsultation/summaryNotNeeded', { summary: 'NA', componentKey: 'CS-SummaryNotNeeded' });
        }
      }
    }
  }
});

/***/ }),

/***/ "vwW0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-y-auto py-2",staticStyle:{"min-height":"24rem"}},[_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow"},[_c('div',{staticClass:"text-xs p-2 self-center"},[_vm._v(" Hi ! Please tell your problem and let me know how of how exactly are you feeling right now ")]),_vm._v(" "),_c('img',{staticClass:"h-4 w-4 mr-2 self-center opacity-75",attrs:{"src":__webpack_require__("uPNi"),"alt":"copy phrase to chat"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vwaR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUpdateAvailable)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"10","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeOverlay()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto z-20",staticStyle:{"width":"600px","left":"calc((100vw - 600px)/2)","top":"150px"}},[_c('div',{staticClass:"flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest"},[_c('div',{staticClass:"flex flex-row mb-2 justify-between items-center"},[_c('div',{staticClass:"align-center text-lg text-left font-semibold py-2"},[_vm._v(" A new version is available!")]),_vm._v(" "),_c('img',{staticClass:"w-6 h-6 cursor-pointer",attrs:{"src":__webpack_require__("JA1j")},on:{"click":function($event){return _vm.closeOverlay()}}})]),_vm._v(" "),_c('label',{staticClass:"text-grey-darker font-light text-xs"},[_vm._v("Please reload for better experience.")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt-3 mb-2 justify-start"},[_c('div',{staticClass:"flex flex-col bg-blue font-semibold px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":_vm.reload}},[_vm._v("\n                Reload\n              ")])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w2nt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__ = __webpack_require__("kkfI");



//  state
var state = {
  initiated: false,
  scheduledPreEmpAppointments: [],
  approvedPreEmpAppointments: [],
  rejectedPreEmpAppointments: [],
  furtherTestingPreEmpAppointments: [],
  scheduledTotalPages: 1,
  approvedTotalPages: 1,
  rejectedTotalPages: 1,
  furtherTestingTotalPages: 1,
  doctorComments: null

  // getters
};var getters = {
  getScheduledPreEmpAppointments: function getScheduledPreEmpAppointments() {
    return state.scheduledPreEmpAppointments;
  },
  getApprovedPreEmpAppointments: function getApprovedPreEmpAppointments() {
    return state.approvedPreEmpAppointments;
  },
  getRejectedPreEmpAppointments: function getRejectedPreEmpAppointments() {
    return state.rejectedPreEmpAppointments;
  },
  getFurtherTestingPreEmpAppointments: function getFurtherTestingPreEmpAppointments() {
    return state.furtherTestingPreEmpAppointments;
  },
  getScheduledTotalPages: function getScheduledTotalPages() {
    return state.scheduledTotalPages;
  },
  getApprovedTotalPages: function getApprovedTotalPages() {
    return state.approvedTotalPages;
  },
  getRejectedTotalPages: function getRejectedTotalPages() {
    return state.rejectedTotalPages;
  },
  getFurtherTestingTotalPages: function getFurtherTestingTotalPages() {
    return state.furtherTestingTotalPages;
  },
  getDoctorComments: function getDoctorComments() {
    return state.doctorComments;
  }
};

//  actions
var actions = {
  setPreEmpAppointments: function setPreEmpAppointments(_ref, _ref2) {
    var commit = _ref.commit;
    var status = _ref2.status,
        page = _ref2.page;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__["a" /* default */].fetch(status, page).then(function (response) {
        var preEmployeeAppointments = response.body.pre_employee_appointments;
        var totalRecords = response.body.total_records;
        var perPage = response.body.per_page;
        var totalPages = Math.ceil(totalRecords / perPage);
        switch (status) {
          case 'scheduled':
            commit('setScheduledPreEmpAppointments', preEmployeeAppointments);
            commit('setScheduledTotalPages', totalPages);
            resolve(response);
            break;
          case 'approved':
            commit('setApprovedPreEmpAppointments', preEmployeeAppointments);
            commit('setApprovedTotalPages', totalPages);
            resolve(response);
            break;
          case 'rejected':
            commit('setRejectedPreEmpAppointments', preEmployeeAppointments);
            commit('setRejectedTotalPages', totalPages);
            resolve(response);
            break;
          case 'further_testing':
            commit('setFurtherTestingPreEmpAppointments', preEmployeeAppointments);
            commit('setFurtherTestingTotalPages', totalPages);
            resolve(resolve);
            break;
          default:
            console.log(status, page);
            console.log('default pre emp appointments');
            resolve({ body: {} });
        }
      }).catch(function (error) {
        console.log(error, 'pre emp appointments');
        reject(error);
      });
    });
  },
  approve: function approve(_ref3, _ref4) {
    var dispatch = _ref3.dispatch;
    var id = _ref4.id,
        doctorId = _ref4.doctorId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__["a" /* default */].approve(id, doctorId).then(function (response) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        resolve(response);
      }).catch(function (error) {
        console.log(error, 'approve');
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        reject(error);
      });
    });
  },
  reject: function reject(_ref5, _ref6) {
    var dispatch = _ref5.dispatch;
    var id = _ref6.id,
        doctorId = _ref6.doctorId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__["a" /* default */].reject(id, doctorId).then(function (response) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        resolve(response);
      }).catch(function (error) {
        console.log(error, 'reject');
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        reject(error);
      });
    });
  },
  furtherTesting: function furtherTesting(_ref7, _ref8) {
    var dispatch = _ref7.dispatch;
    var id = _ref8.id,
        doctorId = _ref8.doctorId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__["a" /* default */].furtherTesting(id, doctorId).then(function (response) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        resolve(response);
      }).catch(function (error) {
        console.log(error, 'further testing');
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        reject(error);
      });
    });
  },
  saveComment: function saveComment(_ref9, _ref10) {
    var dispatch = _ref9.dispatch;
    var id = _ref10.id,
        comment = _ref10.comment,
        doctorId = _ref10.doctorId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__["a" /* default */].saveComment(id, comment, doctorId).then(function (response) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true });
        resolve(response);
      }).catch(function (error) {
        console.log(error, 'save comment');
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
        reject(error);
      });
    });
  },
  search: function search(_ref11, _ref12) {
    var dispatch = _ref11.dispatch;
    var query = _ref12.query;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_appointment_request__["a" /* default */].search(query).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

//  mutations
var mutations = {
  setScheduledPreEmpAppointments: function setScheduledPreEmpAppointments(state, scheduledPreEmpAppointments) {
    if (!state.initiated) state.initiated = true;
    state.scheduledPreEmpAppointments = scheduledPreEmpAppointments;
  },
  setApprovedPreEmpAppointments: function setApprovedPreEmpAppointments(state, approvedPreEmpAppointments) {
    state.approvedPreEmpAppointments = approvedPreEmpAppointments;
  },
  setRejectedPreEmpAppointments: function setRejectedPreEmpAppointments(state, rejectedPreEmpAppointments) {
    state.rejectedPreEmpAppointments = rejectedPreEmpAppointments;
  },
  setFurtherTestingPreEmpAppointments: function setFurtherTestingPreEmpAppointments(state, furtherTestingPreEmpAppointments) {
    state.furtherTestingPreEmpAppointments = furtherTestingPreEmpAppointments;
  },
  setDoctorComment: function setDoctorComment(state, comment) {
    state.doctorComments = comment;
  },
  setScheduledTotalPages: function setScheduledTotalPages(state, totalPages) {
    state.scheduledTotalPages = totalPages;
  },
  setApprovedTotalPages: function setApprovedTotalPages(state, totalPages) {
    state.approvedTotalPages = totalPages;
  },
  setRejectedTotalPages: function setRejectedTotalPages(state, totalPages) {
    state.rejectedTotalPages = totalPages;
  },
  setFurtherTestingTotalPages: function setFurtherTestingTotalPages(state, totalPages) {
    state.furtherTestingTotalPages = totalPages;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "w6Kz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMain_vue__ = __webpack_require__("d6or");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486f9858_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMain_vue__ = __webpack_require__("u1n2");
function injectStyle (ssrContext) {
  __webpack_require__("INHn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486f9858_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w9q5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wEHN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__ = __webpack_require__("k0Td");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedTab'],
  components: {
    UnsavedChangesModal: __WEBPACK_IMPORTED_MODULE_2__components_common_modals_UnsavedChanges__["a" /* default */]
  },
  data: function data() {
    return {
      showSaveReminder: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    editTextField: function editTextField(state) {
      return state.textField.inEdit;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    customer: 'configuration/getActivePatientProfile'
  }), {
    notViewedNotifications: function notViewedNotifications() {
      if (this.customer) {
        if (this.customer.details && this.customer.details.notifications) {
          var noti = this.customer.details.notifications.filter(function (ele) {
            return !ele.is_viewed;
          });
          return noti.length > 0 ? noti.length : 0;
        }
      }
      return 0;
    }
  }),
  watch: {
    customer: function customer(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal && !newVal.isFamilyDoctor && this.selectedTab === 'notification') {
          this.tabClicked('patient-history');
        }
      }
    }
  },
  methods: {
    tabClicked: function tabClicked(tab) {
      if (this.editTextField) {
        this.showSaveReminder = true;
        return;
      }
      this.$emit('tabChange', tab);
      if (tab === 'notification') {
        this.$store.dispatch('configuration/updateViewedNotification');
      }
    },
    closeModal: function closeModal() {
      this.showSaveReminder = false;
    }
  }
});

/***/ }),

/***/ "wHOX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wSut":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUzr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_TextField__ = __webpack_require__("qrBO");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_0__components_common_TextField__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "wYs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminNavbar_vue__ = __webpack_require__("kgdI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffffd152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminNavbar_vue__ = __webpack_require__("FWNi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffffd152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wawq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("HealthProfile")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wbZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabTestCard_vue__ = __webpack_require__("efRj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b31c03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabTestCard_vue__ = __webpack_require__("YRl6");
function injectStyle (ssrContext) {
  __webpack_require__("FpCC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabTestCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b31c03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabTestCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wz3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDoctorRoster_vue__ = __webpack_require__("9kA3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd1644aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDoctorRoster_vue__ = __webpack_require__("hm3c");
function injectStyle (ssrContext) {
  __webpack_require__("Zjzk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd1644aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDoctorRoster_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd1644aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDoctorRoster_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+Yt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiniMenu_vue__ = __webpack_require__("PElW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ede821d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MiniMenu_vue__ = __webpack_require__("QSbr");
function injectStyle (ssrContext) {
  __webpack_require__("YCf1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiniMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ede821d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MiniMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x8qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_appointments__ = __webpack_require__("5tu9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      interval_id: '',
      current_doctor_id: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.configuration.id,
      requestedAppointments: {}
    };
  },

  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_0_vue_datetime__["Datetime"]
  },
  mounted: function mounted() {
    var _this = this;

    this.getAppointments(false);
    this.interval_id = setInterval(function () {
      _this.getAppointments();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval_id);
  },

  methods: {
    statusChanged: function statusChanged(status, id) {
      this.$emit('updateStatus', { status: status, id: id });
    },
    getSelfAssignedCount: function getSelfAssignedCount(appointments) {
      var _this2 = this;

      return appointments.reduce(function (count, appt) {
        if (appt.status === 'scheduled' && appt.doctor.id === _this2.current_doctor_id) count.selfAssigned = count.selfAssigned + 1;
        if (appt.status === 'requested') count.unAssigned = count.unAssigned + 1;
        return count;
      }, { selfAssigned: 0, unAssigned: 0 });
    },
    getAppointments: function getAppointments() {
      var _this3 = this;

      var showLoader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      __WEBPACK_IMPORTED_MODULE_1__api_appointments__["a" /* default */].fetch('requested', true).then(function (response) {
        if (response.status === 200) {
          _this3.requestedAppointments = response.body.appointment_requests;
        } else {}
      }, function (response) {
        _this3.$toast.open({ message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false });
      });
    },
    remarkChanged: function remarkChanged(id) {
      var _this4 = this;

      var remarkInput = document.getElementById('remark_input_' + id);
      __WEBPACK_IMPORTED_MODULE_1__api_appointments__["a" /* default */].updateRemark({ id: id, doctor_comments: remarkInput.value }).then(function (response) {
        if (response.status === 200) {
          _this4.hideRemarkEdit(id);
          _this4.getAppointments(false);
        }
      });
    },
    selfAssign: function selfAssign(id, apptTime, doctorId, status) {
      var _this5 = this;

      var apptTimeDifference = new Date(apptTime.replace('|', '')).getTime() - new Date().getTime();
      var isUnassign = doctorId === this.current_doctor_id && status === 'scheduled';
      var type = isUnassign ? 'unassign' : 'assign';
      if (apptTimeDifference < 5 * 60 * 1000 && type !== 'assign') {
        this.$toast.open({ message: 'You cannot deassign this appointment now.', type: 'error' });
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__api_appointments__["a" /* default */].selfAssign({ id: id, type: type }).then(function (response) {
        if (response.status === 200) {
          _this5.getAppointments(false);
          _this5.$toast.open({ message: isUnassign ? 'Unassigned' : 'Assigned' + ' successfully', type: 'success', position: 'bottom-right', queue: false });
        } else _this5.$toast.open({ message:  true ? 'Unassign' : 'assign' + ' appointment request', type: 'error', position: 'bottom-right', queue: false });
      }).catch(function () {
        _this5.$toast.open({ message: 'Something went wrong', type: 'error', position: 'bottom-right', queue: false });
      });
    },
    showRemarkEdit: function showRemarkEdit(id) {
      document.getElementById('remark_edit' + id).style.display = 'block';
    },
    hideRemarkEdit: function hideRemarkEdit(id) {
      document.getElementById('remark_edit' + id).style.display = 'none';
      event.stopPropagation();
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_font_css__ = __webpack_require__("Yodc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_styles_font_css__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a8f50a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("XemJ");
function injectStyle (ssrContext) {
  __webpack_require__("qazf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9a8f50a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a8f50a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xO57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-col flex-no-shrink flex-no-grow text-grey-darkest border-light-grey border-b border-solid text-xs",class:_vm.isView ? 'border-none' : ''},[_c('div',{staticClass:"grid_container text-sm"},[_c('div',[(_vm.doc.spc_consultation_name)?_c('div',{staticClass:"item truncate capitalize",attrs:{"title":_vm.doc.name}},[_vm._v(_vm._s(("Attachments of " + (_vm.doc.spc_consultation_name) + " consultation")))]):_c('div',{staticClass:"item truncate capitalize",attrs:{"title":_vm.doc.name}},[_vm._v(_vm._s(_vm.doc.uploaded_by || 'Unknown'))]),_vm._v(" "),_c('div',{staticClass:"item text-grey",staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(_vm.doc.date)))])]),_vm._v(" "),_c('div',{staticClass:"item capitalize"},[_vm._v(_vm._s(_vm.doc.category))]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{class:[((_vm.isView === true)) ? 'btn fas fa-chevron-down text-grey bg-grey-lightest rounded-full' : 'btn fas fa-chevron-right text-grey bg-grey-lightest rounded-full'],on:{"click":function($event){return _vm.showResultsModal(_vm.doc)}}})]),_vm._v(" "),(_vm.isView)?_c('div',{staticClass:"flex flex-row h-8 bg-grey-extralight border-solid border-b border-grey-lightest justify-between mx-3",staticStyle:{"border-radius":"3px 3px 0 0","font-size":".875rem"}},[_c('div',{staticClass:"flex flex-row justify-between"},[_c('div',{staticClass:"text-grey text-sm cursor-pointer ml-2 mt-2 mr-4",class:[_vm.activeResults === 'results' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveResults('results')}}},[_vm._v("Results")]),_vm._v(" "),_c('div',{staticClass:"text-grey text-sm cursor-pointer mt-2 mr-4",class:[_vm.activeResults === 'notes' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveResults('notes')}}},[_vm._v("Notes")]),_vm._v(" "),_c('div',{staticClass:"text-grey text-sm cursor-pointer mt-2 ",class:[_vm.activeResults === 'reports' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue'],on:{"click":function($event){return _vm.setActiveResults('reports')}}},[_vm._v("Reports")])]),_vm._v(" "),_c('div',{staticClass:"text-grey text-sm cursor-pointer hover:text-blue align-right mt-1 mr-2 flex flex-row",on:{"click":function($event){return _vm.showFullViewModal(_vm.doc)}}},[_c('img',{staticClass:"mr-2",attrs:{"src":__webpack_require__("ugZY")}}),_c('span',{staticClass:"self-center"},[_vm._v("Full View")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.isView === true)),expression:"(isView === true)"}],staticClass:"pb-0 pl-3 mr-3 flex flex-col overflow-y-auto",staticStyle:{"min-width":"26rem","max-width":"62rem","max-height":"11.5rem","font-size":".875rem"}},[((_vm.doc.category === 'Prescription'))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"bg-grey-extralight overflow-y-auto p-2",staticStyle:{"border-radius":"0 0 3px 3px"}},[_vm._v("No Results")]):((_vm.doc.health_assessment_status === null))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"bg-grey-extralight overflow-y-auto p-2",staticStyle:{"border-radius":"0 0 3px 3px"}},[_vm._v("No Results")]):((_vm.doc.health_assessment_status !== 'done') && (_vm.doc.health_assessment_status !== undefined))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"bg-grey-extralight overflow-y-auto p-2",staticStyle:{"border-radius":"0 0 3px 3px"}},[_vm._v("Lab results digitization under "+_vm._s(_vm.doc.health_assessment_status))]):(_vm.doc.lab_results && _vm.doc.lab_results.length<1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],staticClass:"bg-grey-extralight overflow-y-auto p-2",staticStyle:{"border-radius":"0 0 3px 3px"}},[_vm._v("No Results")]):((_vm.doc.health_assessment_status === 'done'))?_vm._l((_vm.doc.lab_results),function(lab_result,labIndex){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'results'),expression:"activeResults === 'results'"}],key:labIndex,staticClass:"bg-grey-extralight flex flex-col border-solid border-grey-lightest",staticStyle:{"border-radius":"0 0 3px 3px","color":"#324467"}},[(lab_result.name === null)?_c('div',{staticClass:"font-semibold py-3 px-2"},[_vm._v("No Results")]):(lab_result.name === '')?_c('div',{staticClass:"font-semibold py-3 px-2"},[_vm._v("No Results")]):(lab_result.name)?_c('div',{staticClass:"font-semibold py-3 px-2"},[_vm._v(_vm._s(lab_result.name))]):_vm._e(),_vm._v(" "),_c('div'),_vm._v(" "),_vm._l((lab_result.results),function(result,index){return _c('div',{key:index,staticClass:"text-grey flex flex-row justify-between overflow-y-auto",staticStyle:{"color":"#324467"}},[_c('div',{staticClass:"pb-3 px-2"},[_vm._v(_vm._s(result.test_component_name))]),_vm._v(" "),_c('div',{staticClass:"pb-3 px-2",class:result.color},[_vm._v(_vm._s(result.result))])])})],2)}):_vm._e(),_vm._v(" "),((_vm.doc.category === 'Prescription'))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'notes'),expression:"activeResults === 'notes'"}],staticClass:"bg-grey-extralight overflow-y-auto p-2",staticStyle:{"border-radius":"0 0 3px 3px","color":"#324467"}},[_vm._v("No Notes")]):(_vm.doc.notes && _vm.doc.notes.length<1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'notes'),expression:"activeResults === 'notes'"}],staticClass:"bg-grey-extralight overflow-y-auto p-2",staticStyle:{"border-radius":"0 0 3px 3px","color":"#324467"}},[_vm._v("No Notes")]):_vm._l((_vm.doc.notes),function(note,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'notes'),expression:"activeResults === 'notes'"}],key:index,staticClass:"bg-grey-extralight flex flex-col border-radius-3 border-solid border-grey-lightest",staticStyle:{"color":"#324467"}},[(_vm.hasHTML(note.title))?_c('div',{staticClass:"font-semibold py-3 px-2",domProps:{"innerHTML":_vm._s(note.title)}}):_c('div',{staticClass:"font-semibold py-3 px-2"},[_vm._v(_vm._s(note.title))]),_vm._v(" "),(_vm.hasHTML(note.description))?_c('div',{staticClass:"pb-3 px-2 text-grey",domProps:{"innerHTML":_vm._s(note.description)}}):_c('div',{staticClass:"pb-3 px-2 text-grey"},[_vm._v(_vm._s(note.description))])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeResults === 'reports'),expression:"activeResults === 'reports'"}],staticClass:"bg-grey-extralight border-solid border-grey-lightest overflow-y-auto",staticStyle:{"max-height":"155px","border-radius":"0 0 3px 3px","color":"#324467"}},[((_vm.doc.reports === undefined) && (_vm.doc.category === 'Prescription'))?_c('div',{staticClass:"m-2",attrs:{"data-toggle":"modal","data-target":"#myModal"},on:{"click":function($event){return _vm.getDocument(_vm.doc.category, _vm.doc.id)}}},[_c('span',{staticClass:"text-blue font-semibold cursor-pointer"},[_vm._v(_vm._s(_vm.doc.name))])]):(_vm.doc.reports && _vm.doc.reports.length<1)?_c('div',{staticClass:"m-2 text-sm"},[_vm._v("No Reports")]):_vm._l((_vm.doc.reports),function(report,index){return _c('div',{key:index,staticClass:"justify-between m-2 text-blue font-semibold cursor-pointer",attrs:{"data-toggle":"modal","data-target":"#myModal"},on:{"click":function($event){return _vm.getDocument(report.category, report.id)}}},[_vm._v(_vm._s(report.name))])})],2)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xf//":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiNGRkQwRDAiLz4KICAgICAgICA8ZyB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDguNSAxMSkiPgogICAgICAgICAgICA8cGF0aCBzdHJva2U9IiNDODAwMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyLjUiIGQ9Ik0xLjUgNnY3Ii8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjQzgwMDEwIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "xfme":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return use; });
/* unused harmony export registerComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerComponentProgrammatic; });
var use = function use(plugin) {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
  }
};

var registerComponent = function registerComponent(Vue, component) {
  Vue.component(component.name, component);
};

var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
  Vue.prototype[property] = component;
};

/***/ }),

/***/ "xhXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientMedicalHistory_vue__ = __webpack_require__("GPk2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612bf280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientMedicalHistory_vue__ = __webpack_require__("eZGB");
function injectStyle (ssrContext) {
  __webpack_require__("p0pl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientMedicalHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612bf280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientMedicalHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xvXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__ = __webpack_require__("Ph2H");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import moment from 'moment'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['rosterType', 'selectedMonth', 'selectedYear'],
  data: function data() {
    // let today = moment(new Date())
    return {
      checkedMohanDr: false,
      checkedMaheshDr: false,
      checkedVarunDr: false,
      checkedArmanDr: false,
      showModal: false,
      openReplaceDr: false,
      selectedDoctor: {},
      isLoading: false,
      addDoctors: false,
      addSelectedDoctor: {},
      externalTimeSlots: ['07:00-07:30', '07:30-08:00', '08:00-08:30', '08:30-09:00', '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00', '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00', '15:00-15:30', '15:30-16:00', '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00', '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00', '20:00-20:30', '20:30-21:00', '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00'],
      internalTimeSlots: ['07:00-07:20', '07:20-07:40', '07:40-08:00', '08:00-08:20', '08:20-08:40', '08:40-09:00', '09:00-09:20', '09:20-09:40', '09:40-10:00', '10:00-10:20', '10:20-10:40', '10:40-11:00', '11:00-11:20', '11:20-11:40', '11:40-12:00', '12:00-12:20', '12:20-12:40', '12:40-13:00', '13:00-13:20', '13:20-13:40', '13:40-14:00', '14:00-14:20', '14:20-14:40', '14:40-15:00', '15:00-15:20', '15:20-15:40', '15:40-16:00', '16:00-16:20', '16:20-16:40', '16:40-17:00', '17:00-17:20', '17:20-17:40', '17:40-18:00', '18:00-18:20', '18:20-18:40', '18:40-19:00', '19:00-19:20', '19:20-19:40', '19:40-20:00', '20:00-20:20', '20:20-20:40', '20:40-21:00', '21:00-21:20', '21:20-21:40', '21:40-22:00', '22:00-22:20', '22:20-22:40', '22:40-23:00'],
      doctors: [],
      years: [2022, 2023, 2024],
      months: [{ text: 'January', value: '01' }, { text: 'Feburary', value: '02' }, { text: 'March', value: '03' }, { text: 'April', value: '04' }, { text: 'May', value: '05' }, { text: 'June', value: '06' }, { text: 'July', value: '07' }, { text: 'August', value: '08' }, { text: 'September', value: '09' }, { text: 'October', value: 10 }, { text: 'November', value: 11 }, { text: 'December', value: 12 }],
      response: [],
      slotDoctors: [],
      familyDocList: [],
      externalDocList: []
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$watch('rosterType', function (rosterType) {
      _this.getDoctorsList(rosterType);
      _this.getDoctorsSlots(rosterType, _this.selectedMonth, _this.selectedYear);
    }, { immediate: true });
    this.$watch('selectedMonth', function (selectedMonth) {
      _this.getDoctorsSlots(_this.rosterType, selectedMonth, _this.selectedYear);
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    role: 'configuration/getRole'
  }), {
    dates: function dates() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response);
    },
    autoSelectAllDoc: function autoSelectAllDoc() {
      var noDocSelected = true;
      this.doctors.map(function (doc) {
        if (doc.selected) {
          noDocSelected = false;
        }
        return;
      });
      return noDocSelected;
    },
    dropdownDoctorList: function dropdownDoctorList() {
      var _this2 = this;

      var doctorList = {};
      doctorList = this.doctors.filter(function (doctor) {
        return !_this2.slotDoctors.find(function (doc) {
          return doctor.id === doc.id;
        });
      });
      return doctorList;
    }
  }),
  methods: {
    getDocInitials: function getDocInitials(name) {
      name = name.toLocaleLowerCase();
      if (name.includes('dr.')) {
        var nameArr = name.split('dr.');
        return nameArr[1].trim().charAt(0).toUpperCase();
      } else if (name.includes('dr')) {
        var _nameArr = name.split('dr');
        return _nameArr[1].trim().charAt(0).toUpperCase();
      } else {
        return name.charAt(0).toUpperCase();
      }
    },
    onMonthYearChange: function onMonthYearChange() {
      this.getDoctorsSlots(this.rosterType, this.selectedMonth, this.selectedYear);
    },
    getDoctorsSlots: function getDoctorsSlots(rosterType, selectedMonth, selectedYear) {
      var _this3 = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__["a" /* default */].getDoctorsSlots(rosterType, selectedMonth, selectedYear).then(function (response) {
        if (response.status === 200) {
          if (!response.body.slots) {
            _this3.$toast.open({
              message: 'Slots not available',
              type: 'warning',
              position: 'top',
              queue: false
            });
            var date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(that.response)[0];
            if (date) {
              // that.selectedMonth = {value: parseInt((moment(date, 'DD/MM/YYYY')).format('MM'))}
              // that.selectedYear = parseInt((moment(date, 'DD/MM/YYYY')).format('YYYY'))
            }
            return;
          }
          _this3.response = response.body.slots;
        }
      }).catch(function (error) {
        console.log('error is ', error);
      });
    },
    getDoctorsList: function getDoctorsList(rosterType) {
      var that = this;
      var docList = [];
      __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__["a" /* default */].getDoctorsList().then(function (response) {
        if (response.status === 200) {
          docList = response.body.doctors.map(function (doc) {
            doc.selected = false;
            return doc;
          });
          that.doctors = rosterType === 'family_doctor' ? docList.filter(function (doc) {
            return doc.is_family_doctor;
          }) : docList.filter(function (doc) {
            return !doc.is_family_doctor;
          });
          that.familyDocList = docList.filter(function (doc) {
            return doc.is_family_doctor;
          });
          that.externalDocList = docList.filter(function (doc) {
            return !doc.is_family_doctor;
          });
        }
      }).catch(function (error) {
        console.log('error is ', error);
      });
    },
    openModal: function openModal(showModal, slot, date) {
      if (this.role !== 'admin') {
        return;
      }
      this.showModal = !this.showModal;
      this.selectedSlot = slot;
      this.selectedDate = date;
      this.slotDoctors = this.getDocsForASlot(slot, date);
    },
    closeModal: function closeModal() {
      this.slotDoctors = [];
      this.selectedDate = '';
      this.selectedSlot = '';
      this.selectedDoctor = {};
      this.showModal = false;
      this.addDoctors = false;
      this.openReplaceDr = false;
      this.getDoctorsSlots();
    },
    deleteDoctor: function deleteDoctor(i) {
      this.slotDoctors.splice(i, 1);
    },
    replaceDoctor: function replaceDoctor(i, doctor) {
      this.addDoctors = false;
      this.openReplaceDr = !this.openReplaceDr;
      this.selectedDoctor = doctor;
    },
    replaceHandler: function replaceHandler(i) {
      var replaceDoctorId = parseInt(event.target.value);
      var dropdownSelectedDoctor = {};
      var removeDuplicateDoctor = {};
      dropdownSelectedDoctor = this.dropdownDoctorList.find(function (doctor) {
        if (replaceDoctorId === doctor.id) {
          return doctor;
        }
      });
      removeDuplicateDoctor = this.slotDoctors.find(function (duplicateDoc) {
        if (replaceDoctorId === duplicateDoc.id) {
          return duplicateDoc;
        }
      });
      if (dropdownSelectedDoctor === removeDuplicateDoctor) {
        this.$toast.open({
          message: 'Doctor is already present in the slot',
          type: 'warning',
          position: 'top',
          queue: false
        });
      } else {
        this.slotDoctors.splice(i, 1, dropdownSelectedDoctor);
      }
    },
    undoReplace: function undoReplace(i) {
      this.openReplaceDr = false;
    },
    addDoctor: function addDoctor(addDoctors) {
      this.openReplaceDr = false;
      this.addDoctors = !this.addDoctors;
    },
    addHandler: function addHandler() {
      var addDoctorId = parseInt(event.target.value);
      var addSelectedDoctor = this.dropdownDoctorList.find(function (doctor) {
        if (addDoctorId === doctor.id) {
          return doctor;
        }
      });
      var removeDuplicateSelectedDoc = this.slotDoctors.find(function (duplicateSelectDoc) {
        if (addDoctorId === duplicateSelectDoc.id) {
          return duplicateSelectDoc;
        }
      });
      if (addSelectedDoctor === removeDuplicateSelectedDoc) {
        this.$toast.open({
          message: 'Doctor is already present in the slot',
          type: 'warning',
          position: 'top',
          queue: false
        });
      } else {
        this.slotDoctors.push(addSelectedDoctor);
      }
      this.addDoctors = false;
    },
    dateObject: function dateObject(date) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response[date]).length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.response[date]);
      }
      return [];
    },
    getDocsForASlot: function getDocsForASlot(slot, date) {
      if (this.response[date][slot].length > 0) {
        if (this.autoSelectAllDoc) {
          return this.response[date][slot];
        } else {
          var resp = [];
          var that = this;
          this.response[date][slot].map(function (doc) {
            that.doctors.filter(function (doc) {
              return doc.selected;
            }).map(function (selectedDoc) {
              if (doc.id === selectedDoc.id) {
                resp.push(doc);
              }
            });
          });
          return resp;
        }
      }
      return [];
    },

    selectDoctors: function selectDoctors(i, doc) {
      this.doctors[i].selected = !this.doctors[i].selected;
    },
    showAllDoctors: function showAllDoctors() {
      this.doctors.map(function (doctor) {
        doctor.selected = false;
      });
    },
    updateSlot: function updateSlot() {
      var _this4 = this;

      if (this.role !== 'admin') {
        this.$toast.open({
          message: 'Not Authorised',
          type: 'warning',
          position: 'top',
          queue: false
        });
        return;
      }
      var doctorIds = this.slotDoctors.map(function (a) {
        return a.id;
      });
      var res = this.selectedSlot.split('-');
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api_doctor_roster__["a" /* default */].updateSlot({
        doctor_ids: doctorIds,
        date: this.selectedDate,
        roster_type: this.rosterType,
        start_time: res[0],
        end_time: res[1]
      }).then(function (response) {
        if (response.status === 200) {
          _this4.showModal = false;
          _this4.$toast.open({
            message: 'Roster updated successfully',
            type: 'success',
            position: 'top',
            queue: false
          });
          that.getDoctorsSlots(_this4.rosterType, _this4.selectedMonth, _this4.selectedYear);
        }
      }).catch(function (error) {
        console.log('error is ', error);
        _this4.$toast.open({
          message: 'Roster updated failed',
          type: 'error',
          position: 'top',
          queue: false
        });
      });
    }
  }
});

/***/ }),

/***/ "xyZ0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y1lv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  storeRecommendedTests: function storeRecommendedTests(tests) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(window.API_URL + 'doctors/lab_test/create', tests, {
      progress: function progress(e) {}
    });
  },
  getPackages: function getPackages(customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(window.API_URL + ('doctors/packages/search/' + customerId));
  }
});

/***/ }),

/***/ "y2q6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-col overflow-y-auto pb-4",staticStyle:{"height":"calc(100vh - 5rem)"}},[(_vm.notifications.length < 1)?_c('div',{staticClass:"flex flex-col m-4 text-grey-darkest text-sm"},[_vm._v("Patient does not have any notification")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(n,i){return _c('div',{key:i,staticClass:"flex justify-center flex-row flex-no-shrink flex-no-grow px-4 py-6 border-b border-solid border-grey-lightest hover:bg-blue-lightest cursor-pointer",class:[n.is_read ? 'bg-white' : 'bg-grey-extralight'],on:{"click":function($event){return _vm.onNotificationClick(n)}}},[_c('div',{staticClass:"flex flex-col text-m text-grey-darkest mr-auto"},[_vm._v("\n        "+_vm._s(n.description)+"\n        "),_c('div',{staticClass:"text-xs text-grey mt-2"},[_vm._v("\n          "+_vm._s(n.time)+"\n        ")])]),_vm._v(" "),(n.required_action)?_c('div',{staticClass:"flex text-blue font-semibold text-xs justify-end",staticStyle:{"text-transform":"uppercase","width":"160px"},on:{"click":function($event){return _vm.requiredAction(n)}}},[_vm._v("\n        "+_vm._s(n.required_action)+"\n      ")]):_vm._e()])})],2),_vm._v(" "),(_vm.enquireNow)?_c('enquire-now-card',{attrs:{"notification":_vm.activeNotification},on:{"closePopup":_vm.closePopup}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("Patient Notifications")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y4/U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y5on":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnquireNowCard_vue__ = __webpack_require__("qOaB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac68088_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnquireNowCard_vue__ = __webpack_require__("lCzs");
function injectStyle (ssrContext) {
  __webpack_require__("VCj4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnquireNowCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac68088_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnquireNowCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y7hv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y9Oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yNYv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col overflow-hidden bg-white"},[_c('div',{staticClass:"flex flex-wrap bg-white px-8"},[_c('div',{staticClass:"text-grey text-center cursor-pointer text-sm flex-no-shrink flex-no-grow px-4 py-2 m-2 rounded-full ",class:[_vm.autoSelectAllDoc ? 'bg-blue' : 'border border-solid border-grey-lightest'],on:{"click":function($event){return _vm.showAllDoctors()}}},[_c('label',{staticClass:"text-xs cursor-pointer",class:[_vm.autoSelectAllDoc ? 'text-white' : 'text-black'],attrs:{"for":"Show All Doctor's"}},[_vm._v("Show All Doctor's")])]),_vm._v(" "),_vm._l(((_vm.rosterType === 'family_doctor' ? _vm.familyDocList : _vm.externalDocList)),function(doctor,i){return _c('div',{key:i,staticClass:"cursor-pointer text-red text-sm rounded-full flex-no-shrink flex-no-grow text-center bg-gray-400 px-4 py-2 m-2",class:[doctor.selected ? '' : 'border border-solid border-grey-lightest'],style:([doctor.selected ? {'background': doctor.color} : {'background':'white'}]),on:{"click":function($event){return _vm.selectDoctors(i, doctor)}}},[_c('label',{staticClass:"text-xs cursor-pointer",class:[doctor.selected ? 'text-white' : 'text-black']},[_vm._v(_vm._s(doctor.name))])])})],2),_vm._v(" "),_c('div'),_vm._v(" "),_c('table',{staticClass:"mx-1 mt-2 w-full",class:[_vm.rosterType == 'family_doctor' ? '' : 'external-doctor-table'],staticStyle:{"overflow":"scroll","height":"calc(100vh - 12rem)"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"h-full w-full sticky top-0 left-0 bg-white border-none p-0 m-0 shadow-none z-50",staticStyle:{"top":"0","left":"0"}}),_vm._v(" "),_vm._l(((_vm.rosterType === 'family_doctor' ? _vm.internalTimeSlots : _vm.externalTimeSlots)),function(time,i){return _c('th',{key:i,staticClass:"z-40 flex flex-col w-full h-full sticky left-0 items-start p-0 bg-white cursor-default",staticStyle:{"left":"0"}},[_c('div',{staticClass:"flex font-semibold justify-end items-center w-full h-8 pr-4 mt-px bg-grey-lightest text-sm",staticStyle:{"box-shadow":"0px 0px 0px 1px #d7dbde","margin-left":"1px"}},[_vm._v("\n            "+_vm._s(time)+"  \n          ")])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dates),function(date,i){return _c('tr',{key:i},[_c('td',{staticClass:"flex sticky top-0 text-xs cursor-default p-1 font-semibold text-left justify-center items-center h-12 bg-grey-lightest z-40",staticStyle:{"box-shadow":"inset 0px 0px 0px 1px #d7dbde","top":"0"}},[_vm._v(_vm._s(_vm._f("formatDateMonth")(date)))]),_vm._v(" "),_vm._l((_vm.dateObject(date)),function(slot,index){return _c('td',{key:index,staticClass:"flex flex-wrap p-2 bg-white hover:bg-blue-100 ",class:_vm.role === 'admin' ? 'cursor-pointer' : '',on:{"click":function($event){return _vm.openModal(_vm.showModal, slot, date)}}},_vm._l((_vm.getDocsForASlot(slot, date)),function(doc,i){return _c('div',{key:i,staticClass:"flex w-5 h-5 m-1 rounded-full text-white text-sm justify-center items-center leading-none flex-shrink-0",style:({background:doc.color}),attrs:{"title":doc.name}},[_vm._v(_vm._s(_vm.getDocInitials(doc.name)))])}),0)})],2)}),0)]),_vm._v(" "),(_vm.showModal)?_c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0,0,0,0.5)","z-index":"100","cursor":"pointer"},attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('div',{staticClass:"absolute flex flex-col bg-white shadow rounded-sm h-auto",staticStyle:{"width":"550px","left":"calc((100vw - 600px)/2)","top":"80px","height":"auto","z-index":"110"}},[_c('div',{staticClass:"w-full bg-grey flex flex-col px-5 py-4"},[_c('div',{staticClass:"text-lg",staticStyle:{"color":"#207ae6"}},[_vm._v("Manage Doctors")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between mt-2"},[_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.selectedDate))]),_vm._v(" "),_c('div',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.selectedSlot))])])]),_vm._v(" "),_c('div',{staticClass:"bg-white px-5 py-5"},_vm._l((_vm.slotDoctors),function(doctor,i){return _c('div',{key:i,staticClass:"border border-solid border-gray-300 my-1 rounded-sm"},[_c('div',{staticClass:"flex flex-row p-2 justify-between items-center border-solid border-gray-300"},[_c('div',{staticClass:"flex flex-row items-center m-1 mr-auto"},[_c('div',{staticClass:"rounded-full w-2 h-2 mr-2",style:([{'background-color':doctor.color}])}),_vm._v(" "),_c('div',{staticClass:"flex text-sm text-grey-darkest"},[_vm._v(_vm._s(doctor.name))])]),_vm._v(" "),(_vm.selectedDoctor.id === doctor.id && _vm.openReplaceDr)?_c('div',{staticClass:"flex flex-col text-sm items-center ml-auto"},[_c('div',{staticClass:"flex text-grey-dark cursor-pointer ml-auto mb-1",on:{"click":function($event){return _vm.undoReplace(i)}}},[_vm._v("Undo")]),_vm._v(" "),_c('div',{staticClass:"flex w-64"},[_c('select',{staticClass:"flex cursor-pointer appearance-none w-auto h-8 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",staticStyle:{"width":"400px"},on:{"change":function($event){return _vm.replaceHandler(i)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Select a doctor")]),_vm._v(" "),_vm._l((_vm.dropdownDoctorList),function(doc,index){return _c('option',{key:index,domProps:{"value":doc.id}},[_c('div',[_vm._v(_vm._s(doc.name))])])})],2)])]):_c('div',{staticClass:"flex flex-row text-sm items-center"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"ml-2 text-grey cursor-pointer",on:{"click":function($event){return _vm.replaceDoctor(i, doctor)}}},[_vm._v("Replace")]),_vm._v(" "),_c('div',{staticClass:"ml-2 cursor-pointer",on:{"click":function($event){return _vm.deleteDoctor(i, doctor)}}},[_c('img',{attrs:{"src":__webpack_require__("TpOy")}})])])])])}),0),_vm._v(" "),(_vm.addDoctors)?_c('div',{staticClass:"flex bg-white px-5"},[_c('select',{staticClass:"flex appearance-none cursor-pointer w-full h-8 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue",attrs:{"name":"Replace doctor from selection","id":""},on:{"change":function($event){return _vm.addHandler()}}},[_c('option',{staticClass:"invisible",attrs:{"value":"0"}},[_vm._v("Add doctor from Selection")]),_vm._v(" "),_vm._l((_vm.dropdownDoctorList),function(doc,index){return _c('option',{key:index,domProps:{"value":doc.id}},[_c('div',[_vm._v(_vm._s(doc.name))])])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bg-white px-5 py-4 flex flex-row justify-start items-center cursor-pointer",on:{"click":function($event){return _vm.addDoctor()}}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-gray-600 text-sm ml-2 h-5"},[_vm._v("Add Doctor")])]),_vm._v(" "),_c('div',{staticClass:"bg-white flex flex-row justify-end px-5 py-4 mb-2"},[_c('div',{staticClass:"border  ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm  text-sm hover:shadow-md",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col bg-blue ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md",on:{"click":function($event){return _vm.updateSlot()}}},[_vm._v("Save Update")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer"},[_c('img',{attrs:{"src":__webpack_require__("Dm+L")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-6 w-6 self-center"},[_c('img',{attrs:{"src":__webpack_require__("1bhZ")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yYfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentMedication_vue__ = __webpack_require__("pfDr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b958cfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentMedication_vue__ = __webpack_require__("uJpJ");
function injectStyle (ssrContext) {
  __webpack_require__("y7hv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentMedication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b958cfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentMedication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yiqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("Q8/M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaff516_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("N+7L");
function injectStyle (ssrContext) {
  __webpack_require__("XnN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5aaff516"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaff516_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ykgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forms_vue__ = __webpack_require__("wUzr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203f4b22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forms_vue__ = __webpack_require__("TPlb");
function injectStyle (ssrContext) {
  __webpack_require__("Q5GJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203f4b22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yp8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftPaneOffline_vue__ = __webpack_require__("3fn2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10154d4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftPaneOffline_vue__ = __webpack_require__("5OtV");
function injectStyle (ssrContext) {
  __webpack_require__("LR/b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10154d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftPaneOffline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10154d4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftPaneOffline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ywm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchModal_vue__ = __webpack_require__("DK5D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bae65756_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchModal_vue__ = __webpack_require__("8Ala");
function injectStyle (ssrContext) {
  __webpack_require__("wSut")
  __webpack_require__("ce7E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bae65756_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yxwu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5iz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7QW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientHra_vue__ = __webpack_require__("zC8V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e0e1ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientHra_vue__ = __webpack_require__("S+5v");
function injectStyle (ssrContext) {
  __webpack_require__("1id9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientHra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e0e1ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientHra_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z9hz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_doctor__ = __webpack_require__("4mdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



// State
var state = {
  notifications: []

  // Getters
};var getters = {
  getNotifications: function getNotifications() {
    return state.notifications;
  },
  getNotViewedCount: function getNotViewedCount() {
    var notifications = state.notifications.filter(function (ele) {
      return ele.is_viewed === false;
    });
    return notifications.length > 0 ? notifications.length : 0;
  },
  getLatestNotification: function getLatestNotification() {
    return state.notifications[0];
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__api_doctor__["a" /* default */].getNotificatons().then(function (response) {
      if (response.status === 200) {
        commit('setUpNotifications', response.body.notifications);
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  addNotification: function addNotification(_ref2, _ref3) {
    var commit = _ref2.commit;
    var notification = _ref3.notification;

    commit('addNotification', notification);
  },
  updateViewed: function updateViewed(_ref4, id) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__api_doctor__["a" /* default */].updateViewed(id).then(function (response) {
      if (response.status === 200) {
        commit('setUpNotifications', response.body.notifications);
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  UpdateRead: function UpdateRead(_ref5, id) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__api_doctor__["a" /* default */].updateRead(id).then(function (response) {
      if (response.status === 200) {
        commit('updateRead', id);
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  },
  sendEnquiryToPatient: function sendEnquiryToPatient(_ref6, _ref7) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
    var id = _ref7.id,
        message = _ref7.message;

    __WEBPACK_IMPORTED_MODULE_0__api_doctor__["a" /* default */].sendEnquiry({ id: id, message: message }).then(function (response) {
      if (response.status === 200) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$toast.open({
          message: 'Enquiry sent successfully',
          type: 'success',
          position: 'top',
          queue: false
        });
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true });
      }
    });
  }
};

// Mutations
var mutations = {
  setUpNotifications: function setUpNotifications(state, notifications) {
    state.notifications = notifications;
  },
  addNotification: function addNotification(state, notification) {
    state.notifications.unshift(notification);
  },
  updateViewedNotifications: function updateViewedNotifications(state) {},
  updateRead: function updateRead(state, id) {
    var n = state.notifications.find(function (c) {
      if (c.id === id) return c;
    });
    if (n) {
      var i = state.notifications.indexOf(n);
      state.notifications[i].is_read = true;
    }
  },
  reset: function reset(state) {
    state = {};
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "zBGg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zC8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    healthParameter: Object,
    hraDate: String
  }
});

/***/ }),

/***/ "zRvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-64 bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest"},[_c('div',{staticClass:"flex relative flex-col pt-1 flex-no-shrink flex-no-grow border-solid border-t border-grey-lightest"},[_c('div',{staticClass:"flex flex-row h-12 text-xs items-center"},[_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'request' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('request')}}},[_vm._v("Request")]),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'completed' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('completed')}}},[_vm._v("Completed")]),_vm._v(" "),_c('div',{staticClass:"w-1/3 text-grey-darkest text-center cursor-pointer",class:[_vm.activeSection === 'covid-new' ? 'font-semibold' : 'hover:text-blue hover:font-semibold'],on:{"click":function($event){return _vm.setActiveSection('covid-new')}}},[_vm._v("COVID New")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row h-1 bg-grey-lightest"},[_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'request' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'completed' ? 'bg-blue' : '']}),_vm._v(" "),_c('div',{staticClass:"w-1/3",class:[_vm.activeSection === 'covid-new' ? 'bg-blue' : '']})])]),_vm._v(" "),(_vm.activeSection === 'request')?_c('div',{staticClass:"overflow-auto"},[(_vm.data.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No request Patients")])]):_c('div',_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"flex flex-col px-3 px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight",class:(item.id === _vm.selectedPatient.id) ? 'bg-grey-extralight' : '',on:{"click":function($event){return _vm.selectFromList(item)}}},[_c('div',{staticClass:"flex flex-row justify-between mb-2 h-4"},[_c('div',{staticClass:"text-sm font-semibold text-grey-darkest capitalize"},[_vm._v(_vm._s(item.mobile_number ? item.mobile_number : item.id))])])])}),0)]):_vm._e(),_vm._v(" "),(_vm.activeSection === 'completed')?_c('div',{staticClass:"overflow-auto"},[(_vm.data.length === 0)?_c('div',[_c('span',{staticClass:"text-sm flex justify-center my-4"},[_vm._v("No Completed Consultations")])]):_c('div',_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"flex flex-col px-3 px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight",class:(item.id === _vm.selectedPatient.id) ? 'bg-grey-extralight' : '',on:{"click":function($event){return _vm.selectFromList(item)}}},[_c('div',{staticClass:"flex flex-row justify-between mb-2 h-4"},[_c('div',{staticClass:"text-sm font-semibold text-grey-darkest capitalize"},[_vm._v(_vm._s(item.mobile_number ? item.mobile_number : item.id))])])])}),0)]):_vm._e(),_vm._v(" "),(_vm.activeSection === 'covid-new')?_c('div',{staticClass:"overflow-auto"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zhcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),(_vm.isAdding)?_c('add-drug',{key:'addDrug',staticClass:"p-4 pb-8",attrs:{"saved":false,"drugs":_vm.isAdding ? [] : _vm.drugs,"customerId":_vm.customer.customerId,"consultType":_vm.$attrs.chatType},on:{"updateDrugs":_vm.updateDrugs}}):_vm._e(),_vm._v(" "),(_vm.isAddingSaved)?_c('add-drug',{key:'addSavedDrug',staticClass:"p-4 pb-8",attrs:{"med":_vm.currentSavedDrug,"saved":true,"customerId":_vm.customer.customerId,"consultType":_vm.$attrs.chatType},on:{"editSavedDrug":_vm.editSavedDrug,"updateSavedDrugs":_vm.updateSavedDrugs}}):_vm._e(),_vm._v(" "),(!_vm.isAdding && !_vm.isEditing)?_c('div',{staticClass:"flex flex-col mb-6 overflow-y-scroll h-screen"},[_c('table',{staticClass:"flex flex-col min-w-full max-w-full h-screeen px-4 pb-4 pt-3 bg-white border-b border-solid border-grey-lightest"},[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdding),expression:"!isAdding"}],staticClass:"flex flex-row h-10 rounded-tl rounded-tr items-center justify-center"},[_c('th',{staticClass:"text-sm font-semibold text-grey-dark mr-auto"},[_vm._v("MEDICATIONS")]),_vm._v(" "),_c('th',{staticClass:"justify-center cursor-pointer text-blue text-sm font-semibold ml-auto mr-1",on:{"click":function($event){return _vm.addDrug()}}},[_vm._v("+ Add Medication")])]),_vm._v(" "),(_vm.medications.length > 0)?_c('tr',{staticClass:"flex flex-row h-10 p-2 items-center border-solid border-b border-grey-lightest bg-grey-extralight text-sm text-grey-dark text-left"},[_c('th',{staticClass:"text-grey-darker font-semibold w-3/5"},[_vm._v("Drug")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-2/5"},[_vm._v("Dosage")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-2/5"},[_vm._v("Frequency")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-2/5 pl-4"},[_vm._v("Duration")]),_vm._v(" "),_c('th',{staticClass:"text-grey-darker font-semibold w-1/5"},[_vm._v("Action")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.medications),function(med,index){return _c('tr',{key:index,staticClass:"flex flex-row p-2 bg-grey-extralight text-sm text-grey-darker text-left"},[_c('td',{staticClass:"text-grey-darker w-3/5 truncate"},[_vm._v(_vm._s(med.name))]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-2/5"},[_vm._v(_vm._s(med.dose_quantity)+" "+_vm._s(med.dose_unit))]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-2/5"},[_vm._v(_vm._s(med.frequency))]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-2/5 pl-4"},[_vm._v(_vm._s(((med.duration) + " " + (med.duration_unit))))]),_vm._v(" "),_c('td',{staticClass:"text-grey-darker w-1/5 self-center",on:{"click":function($event){return _vm.deleteDrug(med, index)}}},[_c('img',{staticClass:"w-4",attrs:{"src":__webpack_require__("KuaY")}})])])})],2),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdding),expression:"!isAdding"}],staticClass:"relative flex flex-col min-w-full max-w-full px-4 pb-32 mt-6"},[_c('tr',{staticClass:"flex flex-row h-10 rounded-tl rounded-tr items-center justify-center"},[_c('th',{staticClass:"text-lg font-semibold text-grey-dark mr-auto"},[_vm._v("Saved Medications")]),_vm._v(" "),_c('th',{staticClass:"justify-center cursor-pointer font-semibold border border-solid border-grey-lightest rounded-lg bg-white py-2 px-4 text-blue text-lg ml-auto mr-1 hover:shadow-md",on:{"click":function($event){return _vm.addSavedDrug()}}},[_vm._v("+ Save New Medication")])]),_vm._v(" "),_c('tr',{staticClass:"pb-2",staticStyle:{"height":"fit-content"}},[_c('div',{staticClass:"pb-1",staticStyle:{"overflow-x":"hidden"}},_vm._l((_vm.savedMedications),function(med,index){return _c('saved-drug',{key:index,attrs:{"medication":med},on:{"removeSaved":_vm.removeSavedDrug,"editSaved":_vm.editSaved,"addToMedications":_vm.addToMedications}})}),1)])])]):_vm._e(),_vm._v(" "),(!_vm.isEditing && !_vm.isAdding)?_c('div',{staticClass:"fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow",style:(_vm.$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);')},[_c('div',{staticClass:"flex flex-row mx-auto"},[_c('div',{staticClass:"cursor-pointer font-semibold self-center bg-blue p-2 rounded text-white font-light text-sm px-4",on:{"click":function($event){return _vm.preview()}}},[_vm._v("Preview")]),_vm._v(" "),_c('div',{staticClass:"cursor-pointer font-semibold self-center bg-blue p-2 rounded text-white font-light ml-2 text-sm px-4",on:{"click":function($event){return _vm.sendToPatient()}}},[_vm._v("Send to Patient")])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-10 flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest"},[_c('div',{staticClass:"self-center ml-4 text-sm font-semibold text-grey-darkest"},[_vm._v("Prescribe Drugs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zjGQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.db109a6405b0e967ac97.js